(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["OktaSignIn"] = factory();
	else
		root["OktaSignIn"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 374);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault2 = __webpack_require__(1);

var _lastIndexOf = _interopRequireDefault2(__webpack_require__(283));

var _reverse = _interopRequireDefault2(__webpack_require__(584));

var _flat = _interopRequireDefault2(__webpack_require__(589));

var _flags = _interopRequireDefault2(__webpack_require__(284));

var _forEach = _interopRequireDefault2(__webpack_require__(28));

var _isArray = _interopRequireDefault2(__webpack_require__(40));

var _every = _interopRequireDefault2(__webpack_require__(609));

var _some = _interopRequireDefault2(__webpack_require__(295));

var _findIndex = _interopRequireDefault2(__webpack_require__(137));

var _concat = _interopRequireDefault2(__webpack_require__(16));

var _filter = _interopRequireDefault2(__webpack_require__(37));

var _indexOf = _interopRequireDefault2(__webpack_require__(45));

var _splice = _interopRequireDefault2(__webpack_require__(109));

var _reduce = _interopRequireDefault2(__webpack_require__(90));

var _values = _interopRequireDefault2(__webpack_require__(634));

var _map = _interopRequireDefault2(__webpack_require__(41));

var _setInterval2 = _interopRequireDefault2(__webpack_require__(169));

var _setTimeout2 = _interopRequireDefault2(__webpack_require__(82));

var _find = _interopRequireDefault2(__webpack_require__(18));

var _trim = _interopRequireDefault2(__webpack_require__(138));

var _parseInt3 = _interopRequireDefault2(__webpack_require__(171));

var _parseFloat3 = _interopRequireDefault2(__webpack_require__(298));

var _keys = _interopRequireDefault2(__webpack_require__(172));

var _stringify = _interopRequireDefault2(__webpack_require__(83));

var _slice = _interopRequireDefault2(__webpack_require__(229));

var _bind = _interopRequireDefault2(__webpack_require__(7));

var _iterator = _interopRequireDefault2(__webpack_require__(300));

var _symbol = _interopRequireDefault2(__webpack_require__(303));

var _defineProperty = _interopRequireDefault2(__webpack_require__(3));

/*! THIS FILE IS GENERATED FROM PACKAGE @okta/courage@4.6.0-alpha.3586.gd86894f */
module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      (0, _defineProperty.default)(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 33);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _underscore = _interopRequireDefault(__webpack_require__(35));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta/enforce-requirejs-names: 0, @okta/okta/no-specific-methods: 0, @okta/okta/no-specific-modules: 0 */


  var _ = _underscore.default.noConflict();

  _.mixin({
    resultCtx: function resultCtx(object, property, context, defaultValue) {
      var value = _.isObject(object) ? object[property] : void 0;

      if (_.isFunction(value)) {
        value = value.call(context || object);
      }

      if (value) {
        return value;
      } else {
        return !_.isUndefined(defaultValue) ? defaultValue : value;
      }
    },
    isInteger: function isInteger(x) {
      return _.isNumber(x) && x % 1 === 0;
    },
    // TODO: This will be deprecated at some point. Views should use precompiled templates
    // eslint-disable-next-line @okta/okta-ui/no-bare-templates
    template: function template(source, data) {
      var template = _handlebars.default.compile(source);

      return data ? template(data) : function (data) {
        return template(data);
      };
    }
  });

  var _default = _;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _View = _interopRequireDefault(__webpack_require__(16));

  var _TemplateUtil = _interopRequireDefault(__webpack_require__(42));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var eventBus = _underscoreWrapper.default.clone(_backbone.default.Events); // add `broadcast` and `listen` functionality to all views
  // We use one event emitter per all views
  // This means we need to be very careful with event names


  var proto = {
    constructor: function constructor() {
      _View.default.apply(this, arguments);

      this.module && this.$el.attr('data-view', this.module.id);
    },

    /**
     * @deprecated Use {@link #removeChildren}
     */
    empty: function empty() {
      return this.removeChildren();
    },
    compileTemplate: _TemplateUtil.default.tpl,

    /**
     *
     * Broadcasts a global event that all views and controllers can subscribe to
     * for framework use only - prefer using a shared model
     *
     * @param {String} eventName A unique identifier for the event
     * @param {...String} param Parameter to pass with the event (can pass more than one parameter)
     * @deprecated For internal use only
     * @private
     */
    broadcast: function broadcast() {
      eventBus.trigger.apply(eventBus, arguments);
      return this;
    },

    /**
     * Subscribe to broadcast events
     * for framework use only - prefer using a shared model
     *
     * @param {String} eventName The event identifier to subscribe
     * @param {Function} fn The callback function to invoke
     * @deprecated For internal use only
     * @private
     */
    listen: function listen(name, fn) {
      eventBus.off(name, fn);
      this.listenTo(eventBus, name, fn);
      return this;
    },

    /**
     * Shows a notification box
     * @param {String} level success / warning / error
     * @param {String} message The message to display
     * @param {Object} [options]
     * @param {Number} [options.width] Set a custom width
     * @param {String} [options.title] Set a custom title
     * @param {Boolean} [options.hide=true] Do we want to auto-hide this notification?
     * @param {Boolean} [options.dismissable] Show a dismiss button
     * @example
     * view.notify('success', 'Group created successfully');
     */
    notify: function notify(level, message, options) {
      this.broadcast('notification', _underscoreWrapper.default.defaults({
        message: message,
        level: level
      }, options));
      return this;
    },

    /**
     * Shows a confirmation dialog
     *
     * The main difference between this and the native javascript `confirm` method
     * Is this method is non blocking (note the callback pattern).
     *
     * The callback function will run in the context (`this`) of the invoking view.
     *
     * @param {String} [title] The title of the confirmation dialog
     * @param {String} [message] The message of the confirmation dialog
     * @param {Function} [okfn] The callback to run when the user hits "OK" (runs in the context of the invoking view)
     * @param {Function} [cancelfn] The callback to run when the user hits "Cancel"
     *        (runs in the context of the invoking view)
     * @example
     * view.confirm('Delete Group', 'Are you sure you want to delete the selected group?', function () {
     *   model.destroy();
     * });
     *
     * // title will be auto-set to "Okta"
     * view.confirm('Are you sure you want to delete the selected group?', function () {
     *   model.destroy();
     * });
     *
     * view.confirm({
     *   title: 'Delete Group', //=> Modal title
     *   subtitle: 'Are you sure you want to delete the selected group?', //=> Modal subtitle
     *   content: '<h3 color="red">THIS WILL DELETE THE GROUP!</h3>', //=> A template or a view to add to the modal
     *   save: 'Delete Group', //=> Button label
     *   ok: _.bind(model.save, model) // Callback function on hitting "ok" button
     *   cancel: 'Cancel', //=> Button label
     *   cancelFn: _.bind(model.destroy, model) // Callback function on hitting "cancel" button
     * });
     */
    confirm: function confirm(title, message, okfn, cancelfn) {
      var options;
      /* eslint max-statements: [2, 12] */

      if (_typeof(title) === 'object') {
        options = title;
      } else {
        if (arguments.length === 2 && _underscoreWrapper.default.isFunction(message)) {
          options = {
            title: 'Okta',
            subtitle: title,
            ok: message
          };
        } else {
          options = {
            title: title,
            subtitle: message,
            ok: okfn,
            cancelFn: cancelfn
          };
        }
      }

      if (_underscoreWrapper.default.isFunction(options.ok)) {
        var _context;

        options.ok = (0, _bind.default)(_context = _underscoreWrapper.default).call(_context, options.ok, this);
      }

      if (_underscoreWrapper.default.isFunction(options.cancelFn)) {
        var _context2;

        options.cancelFn = (0, _bind.default)(_context2 = _underscoreWrapper.default).call(_context2, options.cancelFn, this);
      }

      this.broadcast('confirmation', options);
      return this;
    },

    /**
     * Shows an alert box
     *
     * The main difference between this and the native javascript `alert` method
     * Is this method is non blocking.
     *
     * @param {String} message The message
     * @example
     * view.alert('Mission complete');
     */
    alert: function alert(params) {
      if (_underscoreWrapper.default.isString(params)) {
        params = {
          subtitle: params
        };
      }

      this.confirm(_underscoreWrapper.default.extend({}, params, {
        noCancelButton: true
      }));
      return this;
    }
  };
  /**
   * See {@link src/framework/View} for more detail and examples from the base class.
   * @class module:Okta.View
   * @extends src/framework/View
   */

  /** @lends module:Okta.View.prototype */

  var _default = _View.default.extend(proto,
  /** @lends View.prototype */
  {
    /** @method */
    decorate: function decorate(TargetView) {
      var BaseViewView = TargetView.extend({});

      _underscoreWrapper.default.defaults(BaseViewView.prototype, proto);

      return BaseViewView;
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(4);
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _jquery = _interopRequireDefault(__webpack_require__(12));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint-disable @okta/okta/enforce-requirejs-names, @okta/okta/no-specific-modules */


  _jquery.default.ajaxSetup({
    beforeSend: function beforeSend(xhr) {
      xhr.setRequestHeader('X-Okta-XsrfToken', (0, _jquery.default)('#_xsrfToken').text());
    },
    converters: {
      'text secureJSON': function textSecureJSON(str) {
        if (str.substring(0, 11) === 'while(1){};') {
          str = str.substring(11);
        }

        return JSON.parse(str);
      }
    }
  }); // Selenium Hook
  // Widget such as autocomplete and autosuggest needs to be triggered from the running version of jQuery.
  // We have 2 versions of jQuery running in parallel and they don't share the same events bus


  window.jQueryCourage = _jquery.default;
  var _default = _jquery.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _oktaI18nBundles = _interopRequireDefault(__webpack_require__(39));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var entityMap = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': '\'',
    '&#039;': '\'',
    '&#x2F;': '/'
  };
  var emailValidator = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?!-)((\[?[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\]?)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  /* eslint max-len: 0*/

  var StringUtil =
  /** @lends module:Okta.internal.util.StringUtil */
  {
    /** @static */
    sprintf: function sprintf() {
      var args = (0, _slice.default)(Array.prototype).apply(arguments);
      var value = args.shift();
      var oldValue = value;
      /* eslint max-statements: [2, 13] */

      function triggerError() {
        throw new Error('Mismatch number of variables: ' + arguments[0] + ', ' + (0, _stringify.default)(args));
      }

      for (var i = 0, l = args.length; i < l; i++) {
        var entity = args[i];
        value = value.replace('{' + i + '}', entity);

        if (entity === undefined || entity === null || value === oldValue) {
          triggerError();
        }

        oldValue = value;
      }

      if (/\{[\d+]\}/.test(value)) {
        triggerError();
      }

      return value;
    },

    /**
     * Converts a URI encoded query string into a hash map
     * @param  {String} query The query string
     * @return {Object} The map
     * @static
     * @example
     * StringUtil.parseQuery('foo=bar&baz=qux') // {foo: 'bar', baz: 'qux'}
     */
    parseQuery: function parseQuery(query) {
      var params = {};
      var pairs = decodeURIComponent(query.replace(/\+/g, ' ')).split('&');

      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        var data = pair.split('=');
        params[data.shift()] = data.join('=');
      }

      return params;
    },

    /** @static */
    encodeJSObject: function encodeJSObject(jsObj) {
      return encodeURIComponent((0, _stringify.default)(jsObj));
    },

    /** @static */
    decodeJSObject: function decodeJSObject(jsObj) {
      try {
        return JSON.parse(decodeURIComponent(jsObj));
      } catch (e) {
        return null;
      }
    },

    /** @static */
    unescapeHtml: function unescapeHtml(string) {
      return String(string).replace(/&[\w#\d]{2,};/g, function (s) {
        return entityMap[s] || s;
      });
    },

    /**
     * Get the original i18n template directly without string format with parameters
     * @param {String} key The key
     * @param {String} bundle="messages"] The name of the i18n bundle. Defaults to the first bundle in the list.
     */
    getTemplate: function getTemplate(key, bundleName) {
      var _context3;

      var bundle = bundleName ? _oktaI18nBundles.default[bundleName] : _oktaI18nBundles.default[(0, _keys.default)(_context3 = _underscoreWrapper.default).call(_context3, _oktaI18nBundles.default)[0]];

      if (!bundle) {
        return 'L10N_ERROR[' + bundleName + ']';
      }

      return bundle[key] || 'L10N_ERROR[' + key + ']';
    },

    /**
     * Translate a key to the localized value
     * @static
     * @param  {String} key The key
     * @param  {String} [bundle="messages"] The name of the i18n bundle. Defaults to the first bundle in the list.
     * @param  {Array} [params] A list of parameters to apply as tokens to the i18n value
     * @return {String} The localized value
     */
    localize: function localize(key, bundleName, params) {
      var _context4;

      var bundle = bundleName ? _oktaI18nBundles.default[bundleName] : _oktaI18nBundles.default[(0, _keys.default)(_context4 = _underscoreWrapper.default).call(_context4, _oktaI18nBundles.default)[0]];
      /* eslint complexity: [2, 7] */

      if (!bundle) {
        return 'L10N_ERROR[' + bundleName + ']';
      }

      var value = bundle[key];

      try {
        params = params && (0, _slice.default)(params) ? (0, _slice.default)(params).call(params, 0) : [];
        params.unshift(value);
        value = StringUtil.sprintf.apply(null, params);
      } catch (e) {
        value = null;
      }

      return value || 'L10N_ERROR[' + key + ']';
    },

    /**
     * Convert a string to a float if valid, otherwise return the string.
     * Valid numbers may contain a negative sign and a decimal point.
     * @static
     * @param {String} string The string to convert to a number
     * @return {String|Number} Returns a number if the string can be casted, otherwise returns the original string
     */
    parseFloat: function (_parseFloat) {
      function parseFloat(_x) {
        return _parseFloat.apply(this, arguments);
      }

      parseFloat.toString = function () {
        return _parseFloat.toString();
      };

      return parseFloat;
    }(function (string) {
      var number = +string;
      return typeof string === 'string' && number === (0, _parseFloat3.default)(string) ? number : string;
    }),

    /**
     * Convert a string to an integer if valid, otherwise return the string
     * @static
     * @param {String} string The string to convert to an integer
     * @return {String|integer} Returns an integer if the string can be casted, otherwise, returns the original string
     */
    parseInt: function (_parseInt) {
      function parseInt(_x2) {
        return _parseInt.apply(this, arguments);
      }

      parseInt.toString = function () {
        return _parseInt.toString();
      };

      return parseInt;
    }(function (string) {
      var int = +string;
      return _underscoreWrapper.default.isString(string) && int === (0, _parseInt3.default)(string, 10) ? int : string;
    }),

    /**
     * Convert a string to an object if valid, otherwise return the string
     * @static
     * @param {String} string The string to convert to an object
     * @return {String|object} Returns an object if the string can be casted, otherwise, returns the original string
     */
    parseObject: function parseObject(string) {
      if (!_underscoreWrapper.default.isString(string)) {
        return string;
      }

      try {
        var object = JSON.parse(string);
        return _jqueryWrapper.default.isPlainObject(object) ? object : string;
      } catch (e) {
        return string;
      }
    },

    /**
     * Returns a random string from [a-z][A-Z][0-9] of a given length
     * @static
     * @param {Number} length The length of the random string.
     * @return {String} Returns a random string from [a-z][A-Z][0-9] of a given length
     */
    randomString: function randomString(length) {
      var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';

      if (length === undefined) {
        length = _underscoreWrapper.default.random(characters.length);
      } else if (length === 0) {
        return '';
      }

      var stringArray = [];

      while (length--) {
        stringArray.push(characters[_underscoreWrapper.default.random(characters.length - 1)]);
      }

      return stringArray.join('');
    },

    /**
     * Returns if a str ends with another string
     * @static
     * @param {String} str The string to search
     * @param {String} ends The string it should end with
     *
     * @return {Boolean} Returns if the str ends with ends
     */
    endsWith: function endsWith(str, ends) {
      str += '';
      ends += '';
      return str.length >= ends.length && str.substring(str.length - ends.length) === ends;
    },

    /** @static */
    isEmail: function isEmail(str) {
      var _context5;

      var target = (0, _trim.default)(_context5 = _jqueryWrapper.default).call(_context5, str);
      return !_underscoreWrapper.default.isEmpty(target) && emailValidator.test(target);
    }
  };
  /**
   * Handy utility functions to handle strings.
   *
   * @class module:Okta.internal.util.StringUtil
   * @hideconstructor
   */

  var _default = StringUtil;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 5 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(4);
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(706);
  /***/
},
/* 7 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  function _log(level, args) {
    if (window.console && window.okta && window.okta.debug) {
      window.console[level].apply(window.console, args);
    }
  }
  /**
   * Utility library of logging functions.
   * @class module:Okta.Logger
   */


  var _default =
  /** @lends module:Okta.Logger */
  {
    /**
     * See [console.trace](https://developer.mozilla.org/en-US/docs/Web/API/Console.trace)
     * @static
     */
    trace: function trace() {
      return _log('trace', arguments);
    },

    /**
     * See [console.dir](https://developer.mozilla.org/en-US/docs/Web/API/Console.dir)
     * @static
     */
    dir: function dir() {
      return _log('dir', arguments);
    },

    /**
     * See [console.time](https://developer.mozilla.org/en-US/docs/Web/API/Console.time)
     * @static
     */
    time: function time() {
      return _log('time', arguments);
    },

    /**
     * See [console.timeEnd](https://developer.mozilla.org/en-US/docs/Web/API/Console.timeEnd)
     * @static
     */
    timeEnd: function timeEnd() {
      return _log('timeEnd', arguments);
    },

    /**
     * See [console.group](https://developer.mozilla.org/en-US/docs/Web/API/Console.group)
     * @static
     */
    group: function group() {
      return _log('group', arguments);
    },

    /**
     * See [console.groupEnd](https://developer.mozilla.org/en-US/docs/Web/API/Console.groupEnd)
     * @static
     */
    groupEnd: function groupEnd() {
      return _log('groupEnd', arguments);
    },

    /**
     * See [console.assert](https://developer.mozilla.org/en-US/docs/Web/API/Console.assert)
     * @static
     */
    assert: function assert() {
      return _log('assert', arguments);
    },

    /**
     * See [console.log](https://developer.mozilla.org/en-US/docs/Web/API/Console.log)
     * @static
     */
    log: function log() {
      return _log('log', arguments);
    },

    /**
     * See [console.info](https://developer.mozilla.org/en-US/docs/Web/API/Console.info)
     * @static
     */
    info: function info() {
      return _log('info', arguments);
    },

    /**
     * See [console.warn](https://developer.mozilla.org/en-US/docs/Web/API/Console.warn)
     * @static
     */
    warn: function warn() {
      return _log('warn', arguments);
    },

    /**
     * See [console.error](https://developer.mozilla.org/en-US/docs/Web/API/Console.error)
     * @static
     */
    error: function error() {
      return _log('error', arguments);
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _default = {
    UP: 38,
    DOWN: 40,
    DEL: 46,
    TAB: 9,
    RETURN: 13,
    ENTER: 13,
    ESC: 27,
    COMMA: 188,
    PAGEUP: 33,
    PAGEDOWN: 34,
    SPACE: 32,
    BACKSPACE: 8,
    __isKey: function __isKey(e, key) {
      return (e.which || e.keyCode) === this[key];
    },
    isEnter: function isEnter(e) {
      return this.__isKey(e, 'ENTER');
    },
    isEsc: function isEsc(e) {
      return this.__isKey(e, 'ESC');
    },
    isSpaceBar: function isSpaceBar(e) {
      return this.__isKey(e, 'SPACE');
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _ButtonFactory = _interopRequireDefault(__webpack_require__(17));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _Callout = _interopRequireDefault(__webpack_require__(29));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * @class BaseInput
   * @private
   * An abstract object that defines an input for {@link Okta.Form}
   *
   * BaseInputs are typically not created directly, but being passed to {@link Okta.Form#addInput}
   * @extends Okta.View
   */


  var _default = _BaseView.default.extend({
    tagName: 'span',
    attributes: function attributes() {
      return {
        'data-se': 'o-form-input-' + this.getNameString()
      };
    },

    /**
     * default placeholder text when options.placeholder is not defined
     */
    defaultPlaceholder: '',
    constructor: function constructor(options) {
      /* eslint complexity: [2, 7] */
      options = _underscoreWrapper.default.defaults(options || {}, {
        inputId: options.id || _underscoreWrapper.default.uniqueId('input'),
        placeholder: this.defaultPlaceholder,
        inlineValidation: true,
        validateOnlyIfDirty: false
      });
      delete options.id; // decorate the `enable` and `disable` and toggle the `o-form-disabled` class.
      // so we wont need to worry about this when overriding the methods

      var self = this;

      _underscoreWrapper.default.each({
        enable: 'removeClass',
        disable: 'addClass'
      }, function (method, action) {
        self[action] = _underscoreWrapper.default.wrap(self[action], function (fn) {
          fn.apply(self, arguments);
          self.$el[method]('o-form-disabled');
        });
      });

      _BaseView.default.call(this, options);

      if (_underscoreWrapper.default.result(options, 'readOnly') !== true && _underscoreWrapper.default.result(options, 'read') === true) {
        this.listenTo(this.model, 'change:__edit__', this.render);
      }

      if (_underscoreWrapper.default.isFunction(this.focus)) {
        var _context6;

        this.focus = _underscoreWrapper.default.debounce((0, _bind.default)(_context6 = _underscoreWrapper.default).call(_context6, this.focus, this), 50);
      } // Enable inline validation if this is not the first field in the form.


      if (!_underscoreWrapper.default.result(options, 'validateOnlyIfDirty')) {
        this.addInlineValidation();
      }

      this.addModelListeners();
      this.$el.addClass('o-form-input-name-' + this.getNameString());
    },
    addAriaLabel: function addAriaLabel() {
      var ariaLabel = this.options.ariaLabel;

      if (ariaLabel) {
        this.$(':input').attr('aria-label', ariaLabel);
      }
    },
    addInlineValidation: function addInlineValidation() {
      if (_underscoreWrapper.default.result(this.options, 'inlineValidation')) {
        var _context7;

        this.$el.on('focusout', ':input', (0, _bind.default)(_context7 = _underscoreWrapper.default).call(_context7, this.validate, this));
      }
    },
    toModelValue: function toModelValue() {
      var value = this.val();

      if (_underscoreWrapper.default.isFunction(this.to)) {
        value = this.to.call(this, value);
      }

      if (_underscoreWrapper.default.isFunction(this.options.to)) {
        value = this.options.to.call(this, value);
      }

      return value;
    },
    __getDependencyCalloutBtn: function __getDependencyCalloutBtn(btnConfig) {
      var self = this;

      var btnOptions = _underscoreWrapper.default.clone(btnConfig);

      var originalClick = btnOptions.click || function () {}; // add onfocus listener to re-evaluate depedency when callout button is clicked


      btnOptions.click = function () {
        (0, _jqueryWrapper.default)(window).one('focus.dependency', function () {
          self.__showInputDependencies();
        });
        originalClick.call(self);
      };

      var BaseInputCalloutBtn = _BaseView.default.extend({
        children: [_ButtonFactory.default.create(btnOptions)]
      });

      return new BaseInputCalloutBtn();
    },
    getCalloutParent: function getCalloutParent() {
      return this.$('input[value="' + this.getModelValue() + '"]').parent();
    },
    __getCalloutMsgContainer: function __getCalloutMsgContainer(calloutMsg) {
      return _BaseView.default.extend({
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var helper,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<span class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "msg") || (depth0 != null ? lookupProperty(depth0, "msg") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "msg",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 29
                },
                "end": {
                  "line": 1,
                  "column": 36
                }
              }
            }) : helper)) + "</span>";
          },
          "useData": true
        }),
        getTemplateData: function getTemplateData() {
          return {
            msg: calloutMsg
          };
        }
      });
    },
    showCallout: function showCallout(calloutConfig, dependencyResolved) {
      var callout = _underscoreWrapper.default.clone(calloutConfig);

      callout.className = 'dependency-callout';

      if (callout.btn) {
        callout.content = this.__getDependencyCalloutBtn(callout.btn);
        delete callout.btn;
      }

      var dependencyCallout = _Callout.default.create(callout);

      if (!dependencyResolved) {
        dependencyCallout.add(this.__getCalloutMsgContainer(_StringUtil.default.localize('dependency.callout.msg', 'courage')));
      }

      var calloutParent = this.getCalloutParent();
      calloutParent.append(dependencyCallout.render().el);

      if (callout.type === 'success') {
        _underscoreWrapper.default.delay(function () {
          // fade out success callout
          dependencyCallout.$el.fadeOut(800);
        }, 1000);
      }
    },
    removeCallout: function removeCallout() {
      var _context8;

      (0, _find.default)(_context8 = this.$el).call(_context8, '.dependency-callout').remove();
    },
    __evaluateCalloutObject: function __evaluateCalloutObject(dependencyResolved, calloutTitle) {
      var defaultCallout;

      if (dependencyResolved) {
        defaultCallout = {
          title: _StringUtil.default.localize('dependency.action.completed', 'courage'),
          size: 'large',
          type: 'success'
        };
      } else {
        defaultCallout = {
          title: _StringUtil.default.localize('dependency.action.required', 'courage', [calloutTitle]),
          size: 'large',
          type: 'warning'
        };
      }

      return defaultCallout;
    },
    __handleDependency: function __handleDependency(result, callout) {
      var self = this;
      var calloutConfig = _underscoreWrapper.default.isFunction(callout) ? callout(result) : _underscoreWrapper.default.extend({}, callout, self.__evaluateCalloutObject(result.resolved, callout.title)); // remove existing callouts if any

      self.removeCallout();
      self.showCallout(calloutConfig, result.resolved);
    },
    __showInputDependencies: function __showInputDependencies() {
      var self = this;
      var fieldDependency = self.options.deps[self.getModelValue()];

      if (fieldDependency && _underscoreWrapper.default.isFunction(fieldDependency.func)) {
        fieldDependency.func().done(function (data) {
          self.__handleDependency({
            resolved: true,
            data: data
          }, fieldDependency.callout);
        }).fail(function (data) {
          self.__handleDependency({
            resolved: false,
            data: data
          }, fieldDependency.callout);
        });
      } else {
        self.removeCallout();
      }
    },
    _isEdited: false,

    /**
     * updates the model with the input's value
     */
    update: function update() {
      if (!this._isEdited && _underscoreWrapper.default.result(this.options, 'validateOnlyIfDirty')) {
        this._isEdited = true;
        this.addInlineValidation();
      }

      this.model.set(this.options.name, this.toModelValue());

      if (this.options.deps) {
        // check for dependencies
        this.__showInputDependencies();
      }
    },

    /**
     * Is the input in edit mode
     * @return {Boolean}
     */
    isEditMode: function isEditMode() {
      var ret = !_underscoreWrapper.default.result(this.options, 'readOnly') && (_underscoreWrapper.default.result(this.options, 'read') !== true || this.model.get('__edit__') === true);
      return ret;
    },

    /**
     * Renders the input
     * @readonly
     */
    render: function render() {
      this.preRender();
      var params = this.options.params;
      this.options.params = _underscoreWrapper.default.resultCtx(this.options, 'params', this);

      if (this.isEditMode()) {
        this.editMode();

        if (_underscoreWrapper.default.resultCtx(this.options, 'disabled', this)) {
          this.disable();
        } else {
          this.enable();
        }
      } else {
        this.readMode();
      }

      this.options.params = params;
      this.addAriaLabel();
      this.postRender();
      return this;
    },

    /**
     * checks if the current value in the model is valid for this field
     */
    validate: function validate() {
      if (!this.model.get('__pending__') && this.isEditMode() && _underscoreWrapper.default.isFunction(this.model.validateField)) {
        var validationError = this.model.validateField(this.options.name);

        if (validationError) {
          var _context9;

          _underscoreWrapper.default.delay((0, _bind.default)(_context9 = function _context9() {
            this.model.trigger('form:clear-error:' + this.options.name);
            this.model.trigger('invalid', this.model, validationError, false);
          }).call(_context9, this), 100);
        }
      }
    },

    /**
     * Add model event listeners
     */
    addModelListeners: function addModelListeners() {
      this.listenTo(this.model, 'form:field-error', function (name) {
        if (this.options.name === name) {
          this.__markError();
        }
      });
      this.listenTo(this.model, 'form:clear-errors change:' + this.options.name, this.__clearError);
      this.listenTo(this.model, 'form:clear-error:' + this.options.name, this.__clearError);
    },

    /**
     * The value of the input
     * @return {Mixed}
     */
    val: function val() {
      throw new Error('val() is an abstract method');
    },

    /**
     * Set focus on the input
     */
    focus: function focus() {
      throw new Error('focus() is an abstract method');
    },

    /**
     * Default value in read mode
     * When model has no value for the field
     */
    defaultValue: function defaultValue() {
      return '';
    },

    /**
     * Renders the input in edit mode
     */
    editMode: function editMode() {
      var options = _underscoreWrapper.default.extend({}, this.options, {
        value: this.getModelValue()
      });

      this.$el.html(this.template(options));
      this.options.multi && this.$el.removeClass('margin-r');
      return this;
    },

    /**
     * Renders the readable value of the input in read mode
     */
    readMode: function readMode() {
      this.$el.text(this.getReadModeString());
      this.$el.removeClass('error-field');
      this.options.multi && this.$el.addClass('margin-r');
      return this;
    },
    getReadModeString: function getReadModeString() {
      var readModeStr = _underscoreWrapper.default.resultCtx(this.options, 'readModeString', this);

      if (readModeStr) {
        return readModeStr;
      }

      return this.toStringValue();
    },

    /**
     * The model value off the field associated with the input
     * @return {Mixed}
     */
    getModelValue: function getModelValue() {
      var value = this.model.get(this.options.name);

      if (_underscoreWrapper.default.isFunction(this.from)) {
        value = this.from.call(this, value);
      }

      if (_underscoreWrapper.default.isFunction(this.options.from)) {
        value = this.options.from.call(this, value);
      }

      return value;
    },

    /*
    * convenience method to get the textual value from the model
    * will return the textual label rather than value in case of select/radio
    * @return {String}
    */
    toStringValue: function toStringValue() {
      var value = this.getModelValue();

      if (this.options.options) {
        // dropdown or radio
        value = this.options.options[value];
      }

      return value || this.defaultValue();
    },

    /**
     * Triggers a form:resize event in order to tell dialogs content size has changed
     */
    resize: function resize() {
      this.model.trigger('form:resize');
    },

    /**
     * Disable the input
     */
    disable: function disable() {
      this.$(':input').prop('disabled', true);
    },

    /**
     * Enable the input
     */
    enable: function enable() {
      this.$(':input').prop('disabled', false);
    },

    /**
     * Change the type of the input field. (e.g., text <--> password)
     * @param type
     */
    changeType: function changeType(type) {
      this.$(':input').prop('type', type); // Update the options so that it keeps the uptodate state

      this.options.type = type;
    },
    getNameString: function getNameString() {
      if (_underscoreWrapper.default.isArray(this.options.name)) {
        return this.options.name.join('-');
      }

      return this.options.name;
    },

    /**
     * Get parameters, computing _.result
     * @param  {[type]} options alternative options
     * @return {Object} the params
     */
    getParams: function getParams(options) {
      var opts = options || this.options || {};
      return _underscoreWrapper.default.clone(_underscoreWrapper.default.resultCtx(opts, 'params', this) || {});
    },

    /**
     * get a parameter from options.params, compute _.result when needed.
     * @param  {String} key
     * @param  {Object} defaultValue
     * @return {Object} the params
     */
    getParam: function getParam(key, defaultValue) {
      var result = _underscoreWrapper.default.resultCtx(this.getParams(), key, this);

      return !_underscoreWrapper.default.isUndefined(result) ? result : defaultValue;
    },

    /**
     * Get a parameter from options.params or if empty, object attribute.
     *
     * @param  {String} key
     * @return {Object} the param or attribute
     */
    getParamOrAttribute: function getParamOrAttribute(key) {
      return this.getParam(key) || _underscoreWrapper.default.result(this, key);
    },
    __markError: function __markError() {
      this.$el.addClass('o-form-has-errors');
    },
    __clearError: function __clearError() {
      this.$el.removeClass('o-form-has-errors');
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _ViewUtil = _interopRequireDefault(__webpack_require__(24));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-params: [2, 6] */


  var LABEL_OPTIONS = ['model', 'id', 'inputId', 'type', 'label', 'sublabel', 'tooltip', 'name'];
  var CONTAINER_OPTIONS = ['wide', 'multi', 'input', 'label-top', 'explain', 'explain-top', 'customExplain', 'model', 'name', 'type', 'autoRender'];
  var WRAPPER_OPTIONS = ['model', 'name', 'label-top', 'readOnly', 'events', 'initialize', 'showWhen', 'bindings', 'render', 'className', 'data-se', 'toggleWhen'];
  var INPUT_OPTIONS = ['model', 'name', 'inputId', 'type', // base options
  'input', // custom input
  'placeholder', 'label', // labels
  'readOnly', 'read', 'disabled', 'readModeString', // modes
  'options', // select/radio
  'deps', // used to specify inputs that have dependencies and show a callout to user on select
  'from', 'to', // model transformers,
  'autoRender', // model attributes change event to trigger rerendering of the input
  'inlineValidation', // control inline validating against the model on focus lost
  'validateOnlyIfDirty', // check if field has been interacted with and then validate
  'ariaLabel', // 508 compliance for inputs that do not have label associated with them
  'params'];
  var // widgets params - for input specific widgets
  OTHER_OPTIONS = ['errorField'];

  var ALL_OPTIONS = _underscoreWrapper.default.uniq(_underscoreWrapper.default.union(LABEL_OPTIONS, CONTAINER_OPTIONS, WRAPPER_OPTIONS, INPUT_OPTIONS, OTHER_OPTIONS));

  var SAVE_BUTTON_PHASES = ['•         ', '•  •      ', '•  •  •   ', '•  •  •  •', '   •  •  •', '      •  •', '         •', '          ', '          ', '          '];

  function decorateDoWhen(doWhen) {
    if (doWhen && !doWhen['__edit__']) {
      return _underscoreWrapper.default.extend({
        __edit__: _underscoreWrapper.default.constant(true)
      }, doWhen);
    }
  }

  function _createButton(options) {
    options = _underscoreWrapper.default.pick(options || {}, 'action', 'id', 'className', 'text', 'type');
    var timeoutId;
    var intervalId;
    var phaseCount;
    return _BaseView.default.extend({
      tagName: 'input',
      className: 'button',
      events: {
        click: function click() {
          if (options.action && !this.disabled()) {
            options.action.call(this);
          }
        },
        keyup: function keyup(e) {
          if (_Keys.default.isEnter(e) && options.action && !this.disabled()) {
            options.action.call(this);
          }
        }
      },
      disabled: function disabled() {
        return this.$el.prop('disabled') === true;
      },
      disable: function disable() {
        this.$el.prop('disabled', true);
        this.$el.addClass('btn-disabled');
      },
      enable: function enable() {
        this.$el.prop('disabled', false);
        this.$el.removeClass('btn-disabled');
      },
      initialize: function initialize() {
        var self = this;
        this.$el.attr('type', options.type === 'save' ? 'submit' : 'button');
        this.$el.val(options.text);

        if (options.id) {
          this.$el.attr('id', options.id);
        }

        if (options.className) {
          this.$el.addClass(options.className);
        }

        if (options.type) {
          this.$el.attr('data-type', options.type);
        }

        this.$el.mousedown(function () {
          self.model.set('__pending__', true);
        });
        this.$el.mouseup(function () {
          self.model.set('__pending__', false);
        });
        this.listenTo(this.model, 'form:set-saving-state', function () {
          this.disable();

          if (options.type === 'save') {
            var _context10;

            timeoutId = (0, _setTimeout2.default)((0, _bind.default)(_context10 = _underscoreWrapper.default).call(_context10, this.__changeSaveText, this), 1000);
          }
        });
        this.listenTo(this.model, 'form:clear-saving-state', function () {
          this.enable();

          if (options.type === 'save') {
            clearTimeout(timeoutId);
            clearInterval(intervalId);
            this.$el.val(options.text);
          }
        });
      },
      __changeSaveText: function __changeSaveText() {
        var _context11;

        phaseCount = 0;
        intervalId = (0, _setInterval2.default)((0, _bind.default)(_context11 = _underscoreWrapper.default).call(_context11, this.__showLoadingText, this), 200);
      },
      __showLoadingText: function __showLoadingText() {
        this.$el.val(SAVE_BUTTON_PHASES[phaseCount++ % SAVE_BUTTON_PHASES.length]);
      }
    });
  }

  function validateInput(options, model) {
    var _context12;

    /* eslint max-statements: 0, complexity: 0 */
    options || (options = {});

    if (options.type === 'label') {
      if (!options.label) {
        _Logger.default.warn('A label input must have a "label" parameter', options);
      }

      return;
    }

    if (options.type === 'button') {
      if (!options.title && !options.icon) {
        _Logger.default.warn('A button input must have a "title" and/or an "icon" parameter', options);
      }

      if (!options.click && !options.href) {
        _Logger.default.warn('A button input must have a "click" and/or an "href" parameter', options);
      }

      return;
    }

    if (!options.name && !options.input) {
      _Logger.default.warn('Missing "name" or "input" parameters', options);
    }

    if (_underscoreWrapper.default.isArray(options.name) && _underscoreWrapper.default.isArray(options.input)) {
      throw new Error('Not allowed to have both "name" and "input" defined as array.');
    }

    if (options.type !== 'list' && options.name && model && model.allows) {
      var names = [];

      if (_underscoreWrapper.default.isArray(options.name)) {
        names = options.name;
      } else {
        names.push(options.name);
      }

      _underscoreWrapper.default.each(names, function (name) {
        if (!model.allows(name)) {
          throw new Error('field not allowed: ' + options.name);
        }
      });
    }

    if (_underscoreWrapper.default.isArray(options.input) && options.type !== 'list') {
      _underscoreWrapper.default.each(options.input, function (input) {
        validateInput(input, model);
      });
    }

    var keys = (0, _keys.default)(_context12 = _underscoreWrapper.default).call(_context12, options);

    var intersection = _underscoreWrapper.default.intersection(keys, ALL_OPTIONS);

    if (_underscoreWrapper.default.size(intersection) !== _underscoreWrapper.default.size(options)) {
      var fields = _underscoreWrapper.default.clone(ALL_OPTIONS);

      fields.unshift(keys);

      _Logger.default.warn('Invalid input parameters', _underscoreWrapper.default.without.apply(null, fields), options);
    }
  }

  function generateInputOptions(options, form, createFn) {
    var _context14;

    options = _underscoreWrapper.default.clone(options);

    if (_underscoreWrapper.default.contains(['list', 'group'], options.type)) {
      var _context13;

      options.params = _underscoreWrapper.default.defaults({
        create: createFn,
        inputs: (0, _map.default)(_context13 = _underscoreWrapper.default).call(_context13, _underscoreWrapper.default.isArray(options.input) ? options.input : [options.input], function (input) {
          return _underscoreWrapper.default.first(generateInputOptions(input, form, createFn));
        })
      }, options.params || {});
      delete options.input;
    }

    var inputs = _underscoreWrapper.default.isArray(options.input) ? _underscoreWrapper.default.clone(options.input) : [options];
    return (0, _map.default)(_context14 = _underscoreWrapper.default).call(_context14, inputs, function (input) {
      var target = _underscoreWrapper.default.defaults({
        model: form.model
      }, input, _underscoreWrapper.default.omit(options, 'input', 'inputs'), form.options, {
        id: _underscoreWrapper.default.uniqueId('input'),
        readOnly: form.isReadOnly(),
        read: form.hasReadMode()
      });

      if (form.isReadOnly()) {
        target.read = target.readOnly = true;
      }

      return target;
    });
  }

  var _default = {
    LABEL_OPTIONS: LABEL_OPTIONS,
    CONTAINER_OPTIONS: CONTAINER_OPTIONS,
    WRAPPER_OPTIONS: WRAPPER_OPTIONS,
    INPUT_OPTIONS: INPUT_OPTIONS,
    generateInputOptions: generateInputOptions,
    changeEventString: function changeEventString(fieldNames) {
      return 'change:' + fieldNames.join(' change:');
    },
    createReadFormButton: function createReadFormButton(options) {
      var action;
      var text;
      var ariaLabel;

      if (options.type === 'cancel') {
        text = ariaLabel = _StringUtil.default.localize('oform.cancel', 'courage');

        action = function action() {
          this.model.trigger('form:cancel');
        };
      } else {
        text = _StringUtil.default.localize('oform.edit', 'courage');
        ariaLabel = text + ' ' + options.formTitle;

        action = function action() {
          this.model.set('__edit__', true);
        };
      }

      return _BaseView.default.extend({
        tagName: 'a',
        attributes: {
          href: '#',
          'aria-label': ariaLabel
        },
        // TODO: refactor to enforce precompiled templates OKTA-309852
        // eslint-disable-next-line @okta/okta-ui/no-bare-templates
        template: function template() {
          return _underscoreWrapper.default.escape(text);
        },
        events: {
          click: function click(e) {
            e.preventDefault();
            action.call(this);
          }
        }
      });
    },
    createButton: function createButton(options) {
      options = _underscoreWrapper.default.clone(options);

      switch (options.type) {
        case 'save':
          _underscoreWrapper.default.defaults(options, {
            className: 'button-primary'
          });

          break;

        case 'cancel':
          _underscoreWrapper.default.defaults(options, {
            text: _StringUtil.default.localize('oform.cancel', 'courage'),
            action: function action() {
              this.model.trigger('form:cancel');
            }
          });

          break;

        case 'previous':
          _underscoreWrapper.default.defaults(options, {
            text: _StringUtil.default.localize('oform.previous', 'courage'),
            action: function action() {
              this.model.trigger('form:previous');
            }
          });

          break;
      }

      return _createButton(options);
    },
    validateInput: validateInput,

    /**
     * Applies a show-when logic on a view instance.
     * The show-when is a map of a model field name -> a boolean or a function that returns a boolean.
     * The view will toggle based on the field value.
     *
     * @param  {Okta.View} view a view instance that has a this.model attached to it
     * @param  {Object} showWhen
     */
    applyShowWhen: function applyShowWhen(view, showWhen) {
      var toggleAndResize = function toggleAndResize(bool) {
        return function () {
          // The `toggle` is here since an event may be triggered before the el is in the DOM
          // and in that case slide events may not function as expected.
          view.$el.toggle(bool);
          view.model.trigger('form:resize');
        };
      };

      _ViewUtil.default.applyDoWhen(view, decorateDoWhen(showWhen), function (bool, options) {
        if (!options.animate) {
          view.$el.toggle(bool);
        } else {
          view.$el['slide' + (bool ? 'Down' : 'Up')](200, toggleAndResize(bool));
        }
      });
    },
    applyToggleWhen: function applyToggleWhen(view, toggleWhen) {
      _ViewUtil.default.applyDoWhen(view, decorateDoWhen(toggleWhen), function (bool, options) {
        view.$el.toggle(bool);
        view.model.trigger('form:resize');

        if (options.animate) {
          view.render();
        }
      });
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Model = _interopRequireDefault(__webpack_require__(37));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * Wrapper around the more generic {@link src/framework/Model} that
   * contains Okta-specific logic.
   * @class module:Okta.Model
   * @extends src/framework/Model
   */


  var _default = _Model.default.extend(
  /** @lends module:Okta.Model.prototype */
  {
    /**
     * Is the end point using the legacy "secureJSON" format
     * @type {Function|Boolean}
     */
    secureJSON: false,
    _builtInLocalProps: {
      __edit__: 'boolean',
      __pending__: 'boolean'
    },
    constructor: function constructor() {
      this.local = _underscoreWrapper.default.defaults({}, _underscoreWrapper.default.result(this, 'local'), this._builtInLocalProps);

      if (_underscoreWrapper.default.result(this, 'secureJSON')) {
        this.sync = _underscoreWrapper.default.wrap(this.sync, function (sync, method, model, options) {
          return sync.call(this, method, model, _underscoreWrapper.default.extend({
            dataType: 'secureJSON'
          }, options));
        });
      }

      _Model.default.apply(this, arguments);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 12 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(175);
  /***/
},
/* 13 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var loc = _StringUtil.default.localize;
  var SchemaUtils = {
    STRING: 'string',
    NUMBER: 'number',
    INTEGER: 'integer',
    BOOLEAN: 'boolean',
    OBJECT: 'object',
    FORMATDISPLAYTYPE: {
      'date-time': 'date',
      uri: 'uri',
      email: 'email',
      // TODO: settle on using EITHER underscores OR hyphens --- not both (OKTA-202818)
      'country-code': 'country-code',
      'language-code': 'language-code',
      'country_code': 'country_code',
      'language_code': 'language_code',
      locale: 'locale',
      timezone: 'timezone',
      'ref-id': 'reference'
    },
    ARRAYDISPLAYTYPE: {
      arrayofobject: 'arrayofobject',
      arrayofstring: 'arrayofstring',
      arrayofnumber: 'arrayofnumber',
      arrayofinteger: 'arrayofinteger',
      'arrayofref-id': 'arrayofref-id'
    },
    DISPLAYTYPES: {
      date: {
        type: 'string',
        format: 'date-time'
      },
      uri: {
        type: 'string',
        format: 'uri'
      },
      email: {
        type: 'string',
        format: 'email'
      },
      // TODO: Resolve inconsistencies in hyphens vs. underscores for these properties (OKTA-202818)
      'country-code': {
        type: 'string',
        format: 'country-code'
      },
      'language-code': {
        type: 'string',
        format: 'language-code'
      },
      'country_code': {
        type: 'string'
      },
      'language_code': {
        type: 'string'
      },
      locale: {
        type: 'string',
        format: 'locale'
      },
      timezone: {
        type: 'string',
        format: 'timezone'
      },
      string: {
        type: 'string'
      },
      number: {
        type: 'number'
      },
      boolean: {
        type: 'boolean'
      },
      integer: {
        type: 'integer'
      },
      reference: {
        type: 'string',
        format: 'ref-id'
      },
      arrayofobject: {
        type: 'array',
        items: {
          type: 'object'
        }
      },
      arrayofstring: {
        type: 'array',
        items: {
          type: 'string'
        }
      },
      arrayofnumber: {
        type: 'array',
        items: {
          type: 'number'
        }
      },
      arrayofinteger: {
        type: 'array',
        items: {
          type: 'integer'
        }
      },
      'arrayofref-id': {
        type: 'array',
        items: {
          type: 'string',
          format: 'ref-id'
        }
      },
      image: {
        type: 'image'
      },
      password: {
        type: 'string'
      }
    },
    SUPPORTSMINMAX: ['string', 'number', 'integer', 'password'],
    SUPPORTENUM: ['string', 'number', 'integer', 'object', 'arrayofstring', 'arrayofnumber', 'arrayofinteger', 'arrayofobject'],
    DATATYPE: {
      string: 'string',
      number: 'number',
      boolean: 'boolean',
      integer: 'integer',
      date: 'datetime',
      object: 'object',
      arrayofobject: 'object array',
      arrayofstring: 'string array',
      arrayofnumber: 'number array',
      arrayofinteger: 'integer array',
      'arrayofref-id': 'reference array',
      // TODO: settle on using EITHER underscores OR hyphens --- not both (OKTA-202818)
      'country-code': 'country code',
      'language-code': 'language code',
      'country_code': 'country code',
      'language_code': 'language code',
      reference: 'reference',
      timezone: 'timezone',
      image: 'image'
    },
    MUTABILITY: {
      READONLY: 'READ_ONLY',
      WRITEONLY: 'WRITE_ONLY',
      READWRITE: 'READ_WRITE',
      IMMUTABLE: 'IMMUTABLE'
    },
    SCOPE: {
      NONE: 'NONE',
      SELF: 'SELF',
      SYSTEM: 'SYSTEM'
    },
    DISPLAYSCOPE: {
      SELF: 'User personal',
      SYSTEM: 'System',
      NA: 'None'
    },
    UNION: {
      DISABLE: 'DISABLE',
      ENABLE: 'ENABLE'
    },
    UNION_OPTIONS: {
      DISABLE: loc('universal-directory.profiles.attribute.form.union.enable.display', 'courage'),
      ENABLE: loc('universal-directory.profiles.attribute.form.union.disable.display', 'courage')
    },
    PERMISSION: {
      HIDE: 'HIDE',
      READ_ONLY: 'READ_ONLY',
      WRITE_ONLY: 'WRITE_ONLY',
      READ_WRITE: 'READ_WRITE'
    },
    ENDUSER_ATTRIBUTE_PERMISSION_OPTIONS: {
      HIDE: loc('universal-directory.profiles.attribute.enduser.permission.hide', 'courage'),
      READ_ONLY: loc('universal-directory.profiles.attribute.enduser.permission.readonly', 'courage'),
      READ_WRITE: loc('universal-directory.profiles.attribute.enduser.permission.readwrite', 'courage')
    },
    ATTRIBUTE_LEVEL_MASTERING_OPTIONS: {
      INHERIT: loc('universal-directory.profiles.attribute.master.inherit', 'courage'),
      OKTA_MASTERED: loc('universal-directory.profiles.attribute.master.oktamastered', 'courage'),
      OVERRIDE: loc('universal-directory.profiles.attribute.master.override', 'courage')
    },
    USERNAMETYPE: {
      NONE: 'non-username',
      OKTA_TO_APP: 'okta-to-app-username',
      OKTA_TO_AD: 'okta-to-ad-username',
      APP_TO_OKTA: 'app-to-okta-username',
      IDP_TO_OKTA: 'idp-to-okta-username'
    },
    LOGINPATTERNFORMAT: {
      EMAIL: 'EMAIL',
      CUSTOM: 'CUSTOM',
      NONE: 'NONE'
    },
    UNIQUENESS: {
      NOT_UNIQUE: 'NOT_UNIQUE',
      PENDING_UNIQUENESS: 'PENDING_UNIQUENESS',
      UNIQUE_VALIDATED: 'UNIQUE_VALIDATED'
    },

    /*
     * Get a display string for a schema attribute type.
     * @param {String} type Type of an attribute
     * @param {String} format Format of an attribute
     * @param {String} itemType Item type of an attribute if an array
     * @param {String} defaultValue The default value if an attribute type is undefined
     * @return {String} the display value
     */
    getDisplayType: function getDisplayType(type, format, itemType, defaultValue) {
      var displayType; // type is undefined for
      // - an un-mapped source attribute from mapping
      // - an source attribute which is mapped to username target attribute

      if (type) {
        // format is only defined for complicated types (ex. reference, date time, array)
        // not for simple types (ex. string, integer, boolean)
        if (format) {
          displayType = this.FORMATDISPLAYTYPE[format];
        } else {
          // itemType is only defined for array type
          // to specify an array element type (ex. string, integer, number)
          displayType = itemType ? this.ARRAYDISPLAYTYPE[type + 'of' + itemType] : type;
        }
      }

      if (!displayType) {
        displayType = typeof defaultValue === 'undefined' ? '' : defaultValue;
      }

      return displayType;
    },

    /*
     * Get attribute mapping source attribute username type
     * @param {String} mappingDirection
     * @param {String} targetName The mapping target attribute name
     * @param {String} appName The app name that's mapped to/from Okta
     * @return {String} the source attribute username type value
     */
    getSourceUsernameType: function getSourceUsernameType(mappingDirection, targetName, appName) {
      var sourceUsernameType = this.USERNAMETYPE.NONE;
      /* eslint complexity: [2, 7] */

      if (mappingDirection === 'oktaToApp') {
        if (targetName === 'userName') {
          sourceUsernameType = this.USERNAMETYPE.OKTA_TO_APP;
        } else if (targetName === 'cn') {
          sourceUsernameType = this.USERNAMETYPE.OKTA_TO_AD;
        }
      } else if (mappingDirection === 'appToOkta' && targetName === 'login') {
        if (appName === 'saml_idp') {
          sourceUsernameType = this.USERNAMETYPE.IDP_TO_OKTA;
        } else {
          sourceUsernameType = this.USERNAMETYPE.APP_TO_OKTA;
        }
      }

      return sourceUsernameType;
    },
    isArrayDataType: function isArrayDataType(type) {
      var _context15;

      return _underscoreWrapper.default.contains((0, _values.default)(_context15 = _underscoreWrapper.default).call(_context15, this.ARRAYDISPLAYTYPE), type);
    },
    isObjectDataType: function isObjectDataType(type) {
      return this.DATATYPE.object === type;
    }
  };
  var _default = SchemaUtils;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 14 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Collection = _interopRequireDefault(__webpack_require__(36));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * Wrapper around the more generic {@link src/framework/Collection} that
   * contains Okta-specific logic.
   * @class module:Okta.Collection
   * @extends src/framework/Collection
   */


  var _default = _Collection.default.extend(
  /** @lends module:Okta.Collection.prototype */
  {
    /**
     * Is the end point using the legacy "secureJSON" format
     * @type {Function|Boolean}
     */
    secureJSON: false,
    constructor: function constructor() {
      if (_underscoreWrapper.default.result(this, 'secureJSON')) {
        this.sync = _underscoreWrapper.default.wrap(this.sync, function (sync, method, collection, options) {
          return sync.call(this, method, collection, _underscoreWrapper.default.extend({
            dataType: 'secureJSON'
          }, options));
        });
      }

      _Collection.default.apply(this, arguments);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 15 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Model = _interopRequireDefault(__webpack_require__(11));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var hasProps = function hasProps(model) {
    var _context16;

    var local = _underscoreWrapper.default.omit(model.local, (0, _keys.default)(_context16 = _underscoreWrapper.default).call(_context16, model._builtInLocalProps));

    return _underscoreWrapper.default.size(model.props) + _underscoreWrapper.default.size(local) > 0;
  };
  /**
   * @class module:Okta.BaseModel
   * @extends module:Okta.Model
   * @deprecated Use {@link module:Okta.Model|Okta.Model} instead
   * @example
   * var Model = BaseModel.extend({
   *   defaults: {
   *     name: BaseModel.ComputedProperty(['fname', 'lname'], function (fname, lname) {
   *       return fname + ' ' + lname;
   *     })
   *   }
   * });
   * var model = new Model({fname: 'Joe', lname: 'Doe'});
   * model.get('name'); //=> "Joe Doe"
   * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
   *
   * model.set('__private__', 'private property');
   * model.get('__private__'); //=> "private property"
   * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
   */


  var BaseModelBaseModel = _Model.default.extend(
  /** @lends module:Okta.BaseModel.prototype */
  {
    /**
     * @type {Boolean}
     */
    flat: false,
    constructor: function constructor() {
      _Model.default.apply(this, arguments);

      this.on('sync', this._setSynced);
    },
    allows: function allows() {
      if (hasProps(this)) {
        return _Model.default.prototype.allows.apply(this, arguments);
      } else {
        return true;
      }
    },
    // bw compatibility support for old computed properties
    set: function set(key, val) {
      var attrs;

      if (_typeof(key) === 'object') {
        attrs = key;
      } else {
        (attrs = {})[key] = val;
      } // computed properties


      (0, _underscoreWrapper.default)(attrs).each(function (fn, attr) {
        if (!fn || !_underscoreWrapper.default.isArray(fn.__attributes)) {
          return;
        }

        this.on('change:' + fn.__attributes.join(' change:'), function () {
          var val = this.get(attr);

          if (val !== this['__schema__'].computedProperties[attr]) {
            this['__schema__'].computedProperties[attr] = val;
            this.trigger('change:' + attr, val);
          }
        }, this);
      }, this);
      return _Model.default.prototype.set.apply(this, arguments);
    },

    /**
     * Get the current value of an attribute from the model. For example: `note.get("title")`
     *
     * See [Model.get](http://backbonejs.org/#Model-get)
     * @param {String} attribute
     * @return {Mixed} The value of the model attribute
     */
    get: function get() {
      var value = _Model.default.prototype.get.apply(this, arguments);

      if (_underscoreWrapper.default.isFunction(value)) {
        var _context17;

        return value.apply(this, (0, _map.default)(_context17 = _underscoreWrapper.default).call(_context17, value.__attributes || [], this.get, this));
      }

      return value;
    },

    /**
     * Return a shallow copy of the model's attributes for JSON stringification.
     * This can be used for persistence, serialization, or for augmentation before being sent to the server.
     * The name of this method is a bit confusing, as it doesn't actually return a JSON string —
     *  but I'm afraid that it's the way that the JavaScript API for JSON.stringify works.
     *
     * ```javascript
     * var artist = new Model({
     *   firstName: "Wassily",
     *   lastName: "Kandinsky"
     * });
     *
     * artist.set({birthday: "December 16, 1866"});
     * alert(JSON.stringify(artist)); // {"firstName":"Wassily","lastName":"Kandinsky","birthday":"December 16, 1866"}
     * ```
     * See [Model.toJSON](http://backbonejs.org/#Model-toJSON)
     * @param  {Object} options
     * @return {Object}
     */
    toJSON: function toJSON(options) {
      options || (options = {});

      var res = _Model.default.prototype.toJSON.apply(this, arguments); // cleanup computed properties


      (0, _underscoreWrapper.default)(res).each(function (value, key) {
        if (typeof value === 'function') {
          if (options.verbose) {
            res[key] = this.get(key);
          } else {
            delete res[key];
          }
        }
      }, this); // cleanup private properties

      if (!options.verbose) {
        (0, _underscoreWrapper.default)(res).each(function (value, key) {
          if (/^__\w+__$/.test(key)) {
            delete res[key];
          }
        });
      }

      return res;
    },
    sanitizeAttributes: function sanitizeAttributes(attributes) {
      var attrs = {};

      _underscoreWrapper.default.each(attributes, function (value, key) {
        if (!_underscoreWrapper.default.isFunction(value)) {
          attrs[key] = value;
        }
      });

      return attrs;
    },
    reset: function reset(options) {
      this.clear(options);
      this.set(this.sanitizeAttributes(this.defaults), options);
    },
    clear: function clear(options) {
      var attrs = {};

      _underscoreWrapper.default.each(this.sanitizeAttributes(this.attributes), function (value, key) {
        attrs[key] = void 0;
      });

      return this.set(attrs, _underscoreWrapper.default.extend({}, options, {
        unset: true
      }));
    },

    /**
     * @private
     */
    _setSynced: function _setSynced(newModel) {
      this._syncedData = newModel && _underscoreWrapper.default.isFunction(newModel.toJSON) ? newModel.toJSON() : {};
    },

    /**
     * @private
     */
    _getSynced: function _getSynced() {
      return this._syncedData;
    },
    isSynced: function isSynced() {
      return _underscoreWrapper.default.isEqual(this._getSynced(), this.toJSON());
    }
  },
  /** @lends module:Okta.BaseModel.prototype */
  {
    /**
     * @static
     *
     * Example:
     *
     * ```javascript
     * var Model = BaseModel.extend({
     *   defaults: {
     *     name: BaseModel.ComputedProperty(['fname', 'lname'], function (fname, lname) {
     *       return fname + ' ' + lname;
     *     })
     *   }
     * });
     * var model = new Model({fname: 'Joe', lname: 'Doe'});
     * model.get('name'); // Joe Doe
     * model.toJSON(); // {fname: 'Joe', lname: 'Doe'}
     * ```
     *
     * @param {Array} attributes - an array of the attribute names this method depends on
     * @param {Function} callback the function that computes the value of the property
     *
     * @deprecated Use {@link #derived} instead
     */
    ComputedProperty: function ComputedProperty() {
      var args = _underscoreWrapper.default.toArray(arguments);

      var fn = args.pop();
      fn.__attributes = args.pop();
      return fn;
    }
  });

  var _default = BaseModelBaseModel;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 16 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CHILDREN = '__children__',
      RENDERED = '__rendered__',
      PARENT = '__parent__',
      CHILD_DEFINITIONS = '__children_definitions__',
      ADD_TO_CONTAINER = '__add_to_container__';

  function getIndex(container, view) {
    for (var i = 0; i < container[CHILDREN].length; i++) {
      if (view.cid === container[CHILDREN][i].cid) {
        return i;
      }
    }
  }

  function noop() {}

  function doRender(view) {
    view[RENDERED] = true;
    var html = view.renderTemplate(view.template);

    if (html) {
      view.$el.html(html);
    } else if (view.length) {
      view.$el.empty();
    }

    view.each(function (view) {
      view[ADD_TO_CONTAINER]();
    });
  }

  function subscribeEvents(view) {
    var isEventPropertyRe = /^(?!(?:delegate|undelegate|_))([a-zA-Z0-9]+)(?:Events)$/;

    _underscoreWrapper.default.each(_underscoreWrapper.default.allKeys(view), function (key) {
      var matchKeys = key.match(isEventPropertyRe);

      if (!matchKeys) {
        return;
      }

      var bindings = _underscoreWrapper.default.result(view, key),
          entity = view.options[matchKeys[1]] || view[matchKeys[1]];

      if (!entity || !_underscoreWrapper.default.isObject(bindings) || !_underscoreWrapper.default.isFunction(entity.trigger)) {
        return;
      }

      _underscoreWrapper.default.each(bindings, function (callback, event) {
        var _context18;

        var callbacks = _underscoreWrapper.default.isFunction(callback) ? [callback] : (0, _reduce.default)(_context18 = _underscoreWrapper.default).call(_context18, callback.split(/\s+/), function (arr, name) {
          if (_underscoreWrapper.default.isFunction(view[name])) {
            arr.push(view[name]);
          }

          return arr;
        }, []);

        _underscoreWrapper.default.each(callbacks, function (cb) {
          view.listenTo(entity, event, cb);
        });
      });
    });
  }
  /**
     * A View operates on a string template, an token based template, or a model based template, with a few added hooks.
     * It provides a collection of child views, when a child view could be a View or another View.
     * Conceptually, if we were in a file system, the View is a folder, when the concrete child views are files,
     * and the child Views are sub folders.
     *
     * *Technically, when using a View as a container, it could have its own concrete logic,
     * but conceptually we like to keep it separated so a view is either a concrete view or a collection of child views.*
     *
     * In addition to the standard backbone options, we added `settings` and `state` as first class options.
     * it will automatically assign `options` to `this.options` as an instance member.
     *
     * See [Backbone.View](http://backbonejs.org/#View).
     *
     * @class src/framework/View
     * @extends external:Backbone.View
     * @param {Object} [options] options hash
     * @example
     * var DocumentView = Archer.View.extend({
     *   template: [
     *     '<header></header>',
     *     '<article></article>',
     *     '<footer></footer>'
     *   ].join(''),
     *   children: [[HeaderView, 'header'], [ContentView, 'article'], [FooterView, 'footer']]
     * });
     */


  var View = _backbone.default.View.extend(
  /** @lends src/framework/View.prototype */
  {
    /**
       * An object listing events and callback bind to this.{entity}
       * @name *Events
       * @memberof src/framework/View
       * @type {(Object|Function)}
       * @instance
       * @example
       * var FooView = View.extend({
       *   modelEvents: {
       *     'change:name': 'render'
       *   }
       * })
       * //equivalent to ==>
       * var FooView = View.extend({
       *   initialize: function() {
       *     this.listenTo(this.model, 'change:name', this.render);
       *   }
       * });
       *
       *
       * //Multiple callbacks:
       * var FooView = View.extend({
       *   modelEvents: {
       *     'change:name': 'render foo'
       *   },
       *   foo: function() {}
       * });
       *
       * //Callbacks As Function:
       * var FooView = View.extend({
       *   stateEvents: {
       *     'change': function() {
       *   }
       * });
       *
       * //Event Configuration As Function
       * var FooView = View.extend({
       *   collectionEvents: function() {
       *     var events = { 'change:name deleteItem': 'render' };
       *     events['changeItem'] = 'spin';
       *     events['addItem'] = function() {};
       *     return events;
       *   }
       * });
       */
    constructor: function constructor(options) {
      /* eslint max-statements: [2, 17] */
      this.options = options || {};

      _underscoreWrapper.default.extend(this, _underscoreWrapper.default.pick(this.options, 'state', 'settings')); // init per-instance children collection


      this[CHILDREN] = [];
      this[RENDERED] = false;
      this[PARENT] = null;
      this[CHILD_DEFINITIONS] = this.children; // we want to make sure initialize is triggered *after* we append the views from the `this.views` array

      var initialize = this.initialize;
      this.initialize = noop;

      _backbone.default.View.apply(this, arguments);

      _underscoreWrapper.default.each(_underscoreWrapper.default.result(this, CHILD_DEFINITIONS), function (childDefinition) {
        this.add.apply(this, _underscoreWrapper.default.isArray(childDefinition) ? childDefinition : [childDefinition]);
      }, this);

      delete this[CHILD_DEFINITIONS];

      if (this.autoRender && this.model) {
        var _context19;

        var event = _underscoreWrapper.default.isArray(this.autoRender) ? (0, _map.default)(_context19 = _underscoreWrapper.default).call(_context19, this.autoRender, function (field) {
          return 'change:' + field;
        }).join(' ') : 'change';
        this.listenTo(this.model, event, function () {
          this.render();
        });
      }

      this.initialize = initialize;
      this.initialize.apply(this, arguments);
      subscribeEvents(this);
    },

    /**
       * Unregister view from container
       * Note: this will not remove the view from the dom
       * and will not call the `remove` method on the view
       *
       * @param {src/framework/View} view the view to unregister
       * @private
       */
    unregister: function unregister(view) {
      this.stopListening(view);
      var viewIndex = getIndex(this, view); // viewIndex is undefined when the view is not found (may have been removed)
      // check if it is undefined to prevent unexpected thing to happen
      // array.splice(undefined, x) removes the first x element(s) from the array
      // this protects us against issues when calling `remove` on a child view multiple times

      if (_underscoreWrapper.default.isNumber(viewIndex)) {
        var _context20;

        (0, _splice.default)(_context20 = this[CHILDREN]).call(_context20, viewIndex, 1);
      }
    },

    /**
       * Should we auto render the view upon model change. Boolean or array of field names to listen to.
       * @type {Boolean|Array}
       * @deprecated Instead, please use modelEvents
       * @example
       * modelEvents: {
       *   change:name: 'render'
       * }
       */
    autoRender: false,

    /**
       *
       * When the template is an underscore template, the render method will pass the options has to the template
       * And the associated model, if exists, when it will prefer the model over the options in case of a conflict.
       * {@link #render View.render}
       * @type {(String|Function)}
       * @example
       * var View = View.extend({
       *   template: '<p class="name">{{name}}</p>'
       * };
       */
    template: null,

    /**
       * A list of child view definitions to be passed to {@link #add this.add()}.
       * Note: these definitions will be added **before** the {@link #constructor initiliaze} method invokes.
       * @type {(Array|Function)}
       * @example
       * var Container = View.extend({
       *    template: '<p class="content"></p>',
       *    children: [
       *      [ContentView, '.content'],
       *      [OtherContentView, '.content'],
       *      OtherView
       *    ]
       *  })
       *
       * var Container = View.extend({
       *    template: '<dov class="form-wrap"></div>',
       *    children: function () {
       *      return [
       *        [FormView, '.form-wrap', {options: {model: this.optiosn.otherModel}}]
       *      ]
       *    }
       *  })
       */
    children: [],

    /**
       * Add a child view to the container.
       * If the container is already rendered, will also render the view  and append it to the DOM.
       * Otherwise will render and append once the container is rendered.
       *
       * *We believe that for the sake of encapsulation, a view should control its own chilren, so we treat this method as
       * protected and even though technically you can call `view.add` externally we strongly discourage it.*
       *
       * @param {(src/framework/View|String)} view A class (or an instance which is discouraged) of a View - or an HTML
       * string/template
       * @param {String} [selector] selector in the view's template on which the view will be added to
       * @param {Object} [options]
       * @param {Boolean} [options.bubble=false] Bubble (proxy) events from this view up the chain
       * @param {Boolean} [options.prepend=false] Prepend the view instend of appending
       * @param {String} [options.selector] Selector in the view's template on which the view will be added to
       * @param {Object} [options.options] Extra options to pass to the child constructor
       * @protected
       * @returns {src/framework/View} - The instance of itself for the sake of chaining
       * @example
       * var Container = View.extend({
       *
       *   template: [
       *     '<h1></h1>',
       *     '<section></section>',
       *   ].join(''),
       *
       *   initalize: function () {
       *
       *     this.add(TitleView, 'h1'); // will be added to <h1>
       *
       *     this.add(ContentView1, 'section'); // will be added to <section>
       *
       *     this.add(ContentView2, 'section', {prepend: true}); // will be add into <section> **before** ContentView1
       *
       *     this.add(OtherView, {
       *       options: {
       *         model: new Model()
       *       }
       *     }); // will be added **after** the <section> element
       *
       *     this.add('<p class="name">some html</p>'); //=> "<p class="name">some html</p>"
       *     this.add('<p class="name">{{name}}</p>'); //=> "<p class="name">John Doe</p>"
       *     this.add('{{name}}') //=> "<div>John Doe</div>"
       *     this.add('<span>{{name}}</span> w00t') //=> "<div><span>John Doe</span> w00t</div>"
       *   }
       *
       * });
       *
       * var container - new View({name: 'John Doe'});
       */
    add: function add(view, selector, bubble, prepend, extraOptions) {
      /* eslint max-statements: [2, 29], complexity: [2, 12] */
      var options = {},
          args = _underscoreWrapper.default.toArray(arguments); // This will throw if a compiled template function is passed accidentally


      if (_underscoreWrapper.default.isFunction(view) && (!view.prototype || !view.prototype.render)) {
        throw new Error('Type passed to add() is not a View');
      }

      if (_underscoreWrapper.default.isObject(selector)) {
        options = selector;
        selector = options.selector;
        bubble = options.bubble;
        prepend = options.prepend;
        extraOptions = options.options;
      } else if (_underscoreWrapper.default.isObject(bubble)) {
        options = bubble;
        bubble = options.bubble;
        prepend = options.prepend;
        extraOptions = options.options;
      } // TODO: This will be deprecated at some point. Views should use precompiled templates


      if (_underscoreWrapper.default.isString(view)) {
        view = function (template) {
          return View.extend({
            constructor: function constructor() {
              try {
                var $el = _backbone.default.$(template);

                if ($el.length != 1) {
                  throw 'invalid Element';
                }

                var unescapingRexExp = /&(\w+|#x\d+);/g;
                var elementUnescapedOuterHTMLLength = $el.prop('outerHTML').replace(unescapingRexExp, ' ').length;
                var templateUnescapedLength = template.replace(unescapingRexExp, ' ').length;

                if (elementUnescapedOuterHTMLLength !== templateUnescapedLength) {
                  throw 'invalid Element';
                }

                this.template = $el.html(); // Template string will be compiled by handlebars

                this.el = $el.empty()[0];
              } catch (e) {
                // not a valid html tag.
                this.template = template;
              }

              View.apply(this, arguments);
            }
          });
        }(view);
      }

      if (view.prototype && view.prototype instanceof View) {
        /* eslint new-cap: 0 */
        var viewOptions = _underscoreWrapper.default.omit(_underscoreWrapper.default.extend({}, this.options, extraOptions), 'el');

        args[0] = new view(viewOptions);
        return this.add.apply(this, args);
      } // prevent dups


      if (_underscoreWrapper.default.isNumber(getIndex(this, view))) {
        throw new Error('Duplicate child');
      }

      view[PARENT] = this; // make the view responsible for adding itself to the parent:
      // * register the selector in the closure
      // * register a reference the parent in the closure

      view[ADD_TO_CONTAINER] = function (selector) {
        return function () {
          if (selector && view[PARENT].$(selector).length != 1) {
            throw new Error('Invalid selector: ' + selector);
          }

          var $el = selector ? this[PARENT].$(selector) : this[PARENT].$el;
          this.render(); // we need to delegate events in case
          // the view was added and removed before

          this.delegateEvents(); // this[PARENT].at(index).$el.before(this.el);

          prepend ? $el.prepend(this.el) : $el.append(this.el);
        };
      }.call(view, selector); // if flag to bubble events is set
      // proxy all child view events


      if (bubble) {
        this.listenTo(view, 'all', function () {
          this.trigger.apply(this, arguments);
        });
      } // add to the dom if `render` has been called


      if (this.rendered()) {
        view[ADD_TO_CONTAINER]();
      } // add view to child views collection


      this[CHILDREN].push(view);
      return this;
    },

    /**
       * Remove all children from container
       */
    removeChildren: function removeChildren() {
      this.each(function (view) {
        view.remove();
      });
      return this;
    },

    /**
       *  Removes a view from the DOM, and calls stopListening to remove any bound events that the view has listenTo'd.
       *  Also removes all childern of the view if any, and removes itself from its parent view(s)
       */
    remove: function remove() {
      this.removeChildren();

      if (this[PARENT]) {
        this[PARENT].unregister(this);
      }

      return _backbone.default.View.prototype.remove.apply(this, arguments);
    },

    /**
       * Compile the template to function you can apply tokens on on render time.
       * Uses the underscore tempalting engine by default
       * @protected
       * @param  {String} template
       * @return {Function} a compiled template
       */
    // TODO: This will be deprecated at some point. Views should use precompiled templates
    compileTemplate: function compileTemplate(template) {
      /* eslint  @okta/okta/no-specific-methods: 0*/
      return _underscoreWrapper.default.template(template);
    },

    /**
       * Render a template with `this.model` and `this.options` as parameters
       * preferring the model over the options.
       *
       * @param  {(String|Function)} template The template to build
       * @return {String} An HTML string
       * @protected
       */
    renderTemplate: function renderTemplate(template) {
      if (_underscoreWrapper.default.isString(template)) {
        // TODO: This will be deprecated at some point. Views should use precompiled templates
        template = this.compileTemplate(template);
      }

      if (_underscoreWrapper.default.isFunction(template)) {
        return template(this.getTemplateData());
      }
    },

    /**
       * The data hash passed to the compiled template
       * @return {Object}
       * @protected
       */
    getTemplateData: function getTemplateData() {
      var modelData = this.model && this.model.toJSON({
        verbose: true
      }) || {};

      var options = _underscoreWrapper.default.omit(this.options, ['state', 'settings', 'model', 'collection']);

      return _underscoreWrapper.default.defaults({}, modelData, options);
    },

    /**
       * Renders the template to `$el` and append all children in order
       * {@link #template View.template}
       */
    render: function render() {
      this.preRender();
      doRender(this);
      this.postRender();
      return this;
    },

    /**
       * Pre render routine. Will be called right *before* the logic in {@link #render} is executed
       * @method
       */
    preRender: noop,

    /**
       * Post render routine. Will be called right *after* the logic in {@link #render} is executed
       * @method
       */
    postRender: noop,

    /**
       * Was this instance rendered
       */
    rendered: function rendered() {
      return this[RENDERED];
    },

    /**
       * Get all direct child views.
       * @returns {src/framework/View[]}
       * @example
       * var container = View.extend({
       *   children: [View1, View2]
       * }).render();
       * container.getChildren() //=> [view1, view2];
       */
    getChildren: function getChildren() {
      return this.toArray();
    },

    /**
       * Get a child by index
       * @param {number} index
       * @returns {src/framework/View} The child view
       */
    at: function at(index) {
      return this.getChildren()[index];
    },

    /**
       * Invokes a method on all children down the tree
       *
       * @param {String} method The method to invoke
       */
    invoke: function invoke(methodName) {
      var args = _underscoreWrapper.default.toArray(arguments);

      this.each(function (child) {
        // if child has children, bubble down the tree
        if (child.size()) {
          child.invoke.apply(child, args);
        } // run the function on the child


        if (_underscoreWrapper.default.isFunction(child[methodName])) {
          child[methodName].apply(child, (0, _slice.default)(args).call(args, 1));
        }
      });
      return this;
    }
  }); // Code borrowed from Backbone.js source
  // Underscore methods that we want to implement on the Container.


  var methods = ['each', 'map', 'reduce', 'reduceRight', 'find', 'filter', 'reject', 'every', 'some', 'contains', 'toArray', 'size', 'first', 'initial', 'rest', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf', 'isEmpty', 'chain', 'where', 'findWhere'];

  _underscoreWrapper.default.each(methods, function (method) {
    View.prototype[method] = function () {
      var args = _underscoreWrapper.default.toArray(arguments);

      args.unshift(_underscoreWrapper.default.toArray(this[CHILDREN]));
      return _underscoreWrapper.default[method].apply(_underscoreWrapper.default, args);
    };
  }, void 0);
  /**
     * See [_.each](http://underscorejs.org/#each)
     * @name each
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} iterator
     * @param {Object} [context]
     */

  /**
     * See [_.map](http://underscorejs.org/#map)
     * @name map
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} iterator
     * @param {Object} [context]
     */

  /**
     * See [_.reduce](http://underscorejs.org/#reduce)
     * @name reduce
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} iterator
     * @param {Mixed} memo
     * @param {Object} [context]
     */

  /**
     * See [_.reduceRight](http://underscorejs.org/#reduceRight)
     * @name reduceRight
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} iterator
     * @param {Mixed} memo
     * @param {Object} [context]
     */

  /**
     * See [_.find](http://underscorejs.org/#find)
     * @name find
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} predicate
     * @param {Object} [context]
     */

  /**
     * See [_.filter](http://underscorejs.org/#filter)
     * @name filter
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} predicate
     * @param {Object} [context]
     */

  /**
     * See [_.reject](http://underscorejs.org/#reject)
     * @name reject
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} predicate
     * @param {Object} [context]
     */

  /**
     * See [_.every](http://underscorejs.org/#every)
     * @name every
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} [predicate]
     * @param {Object} [context]
     */

  /**
     * See [_.some](http://underscorejs.org/#some)
     * @name some
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} [predicate]
     * @param {Object} [context]
     */

  /**
     * See [_.contains](http://underscorejs.org/#contains)
     * @name contains
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Mixed} value
     */

  /**
     * See [_.toArray](http://underscorejs.org/#toArray)
     * @name toArray
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.size](http://underscorejs.org/#size)
     * @name size
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.first](http://underscorejs.org/#first)
     * @name first
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Number} [n]
     */

  /**
     * See [_.initial](http://underscorejs.org/#initial)
     * @name initial
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Number} [n]
     */

  /**
     * See [_.last](http://underscorejs.org/#last)
     * @name last
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Number} [n]
     */

  /**
     * See [_.rest](http://underscorejs.org/#rest)
     * @name rest
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Number} [index]
     */

  /**
     * See [_.without](http://underscorejs.org/#without)
     * @name without
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.indexOf](http://underscorejs.org/#indexOf)
     * @name indexOf
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Mixed} value
     * @param {Boolean} [isSorted]
     */

  /**
     * See [_.shuffle](http://underscorejs.org/#shuffle)
     * @name shuffle
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.shuffle](http://underscorejs.org/#lastIndexOf)
     * @name lastIndexOf
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Mixed} value
     * @param {Number} [fromIndex]
     */

  /**
     * See [_.isEmpty](http://underscorejs.org/#isEmpty)
     * @name isEmpty
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.chain](http://underscorejs.org/#chain)
     * @name chain
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.where](http://underscorejs.org/#where)
     * @name where
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Object} properties
     */

  /**
     * See [_.findWhere](http://underscorejs.org/#findWhere)
     * @name findWhere
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Object} properties
     */


  var _default = View;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 17 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseButtonLink = _interopRequireDefault(__webpack_require__(44));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint '@okta/okta-ui/no-deprecated-methods': [0, [{ name: 'BaseButtonLink.extend', use: 'Okta.createButton'}, ]] */

  /**
   * A factory method wrapper for {@link BaseButtonLink} creation
   * @class module:Okta.internal.util.ButtonFactory
   */


  function normalizeEvents(options) {
    var events = _underscoreWrapper.default.extend(options.click ? {
      click: options.click
    } : {}, options.events || {});

    var target = {};

    _underscoreWrapper.default.each(events, function (fn, eventName) {
      target[eventName] = function (e) {
        if (!options.href) {
          e.preventDefault();
          e.stopPropagation();
        }

        fn.apply(this, arguments);
      };
    });

    return target;
  }

  var _default =
  /** @lends module:Okta.internal.util.ButtonFactory */
  {
    /**
     * Creates a {@link module:Okta.internal.views.components.BaseButtonLink|BaseButtonLink}.
     * @param  {Object} options Options hash
     * @param  {String} [options.title] The button text
     * @param  {String} [options.icon]
     * CSS class for the icon to display. See [Style guide](http://rain.okta1.com:1802/su/dev/style-guide#icons)
     * @param {String} [options.href] The button link
     * @param {Function} [options.click] On click callback
     * @param {Object} [options.events] a [Backbone events](http://backbonejs.org/#View-delegateEvents) hash
     * @returns {module:Okta.internal.views.components.BaseButtonLink} BaseButtonLink prototype ("class")
     */
    create: function create(options) {
      options = _underscoreWrapper.default.clone(options);
      options.attrs = options.attributes;
      delete options.attributes;
      return _BaseButtonLink.default.extend(_underscoreWrapper.default.extend(options, {
        events: normalizeEvents(options)
      }));
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 18 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _default = {
    redirect: function redirect(url) {
      window.location = url;
    },
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    constantError: function constantError(errorMessage) {
      return function () {
        throw new Error(errorMessage);
      };
    },

    /**
     * Simply convert an URL query key value pair object into an URL query string.
     * Remember NOT to escape the query string when using this util.
     * example:
     * input: {userId: 123, instanceId: undefined, expand: 'schema,app'}
     * output: '?userId=123&expand=schema,app'
     */
    getUrlQueryString: function getUrlQueryString(queries) {
      var _context21;

      _underscoreWrapper.default.isObject(queries) || (queries = {});

      var queriesString = _underscoreWrapper.default.without((0, _map.default)(_context21 = _underscoreWrapper.default).call(_context21, queries, function (value, key) {
        if (value !== undefined && value !== null) {
          return key + '=' + encodeURIComponent(value);
        }
      }), undefined).join('&');

      return _underscoreWrapper.default.isEmpty(queriesString) ? '' : '?' + queriesString;
    },
    isABaseView: function isABaseView(obj) {
      return obj instanceof _BaseView.default || obj.prototype instanceof _BaseView.default || obj === _BaseView.default;
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 19 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseCollection = _interopRequireDefault(__webpack_require__(14));

  var _BaseModel = _interopRequireDefault(__webpack_require__(15));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _SchemaUtil = _interopRequireDefault(__webpack_require__(13));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _EnumTypeHelper = _interopRequireDefault(__webpack_require__(20));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-statements: [2, 16], complexity: [2, 8], max-params: [2, 8] */


  var loc = _StringUtil.default.localize;
  var STRING = _SchemaUtil.default.STRING;
  var NUMBER = _SchemaUtil.default.NUMBER;
  var INTEGER = _SchemaUtil.default.INTEGER;
  var OBJECT = _SchemaUtil.default.OBJECT;

  var getArrayTypeName = function getArrayTypeName(type, elementType) {
    return type + 'of' + elementType;
  };

  var SchemaPropertySubSchema = _BaseModel.default.extend({
    defaults: {
      description: undefined,
      minLength: undefined,
      maxLength: undefined,
      format: undefined
    },
    parse: function parse(resp) {
      if (_underscoreWrapper.default.isString(resp.format)) {
        var matcher = /^\/(.+)\/$/.exec(resp.format);

        if (matcher) {
          resp.format = matcher[1];
        }
      }

      return resp;
    }
  });

  var SchemaPropertySubSchemaCollection = _BaseCollection.default.extend({
    model: SchemaPropertySubSchema
  });

  var SchemaPropertySubSchemaAllOfCollection = SchemaPropertySubSchemaCollection.extend({
    _type: 'allOf'
  });
  var SchemaPropertySubSchemaOneOfCollection = SchemaPropertySubSchemaCollection.extend({
    _type: 'oneOf'
  });
  var SchemaPropertySubSchemaNoneOfCollection = SchemaPropertySubSchemaCollection.extend({
    _type: 'noneOf'
  });
  var constraintTypeErrorMessages = {
    string: loc('schema.validation.field.value.must.string', 'courage'),
    number: loc('schema.validation.field.value.must.number', 'courage'),
    integer: loc('schema.validation.field.value.must.integer', 'courage'),
    object: loc('schema.validation.field.value.must.object', 'courage')
  };
  var loginFormatNonePattern = '.+';
  var escapedLoginCharsRe = /[^a-zA-Z0-9-]/;

  var SchemaPropertySchemaProperty = _BaseModel.default.extend({
    constraintHandlers: {
      between: '_checkBetweenConstraints',
      greaterThan: '_checkGreaterThanConstraint',
      lessThan: '_checkLessThanConstraint',
      equals: '_checkEqualsConstraint'
    },
    idAttribute: 'name',
    local: {
      __oneOf__: {
        type: 'array',
        minItems: 1
      }
    },
    defaults: {
      // OKTA-28445, set empty string by default as the key for each property when syncing with server
      // so that server can respond with error when a name is not provided
      name: '',
      title: undefined,
      type: undefined,
      description: undefined,
      required: false,
      format: undefined,
      // choose disable option be default.
      union: undefined,
      subSchemas: undefined,
      settings: {
        permissions: {
          SELF: _SchemaUtil.default.PERMISSION.READ_ONLY
        }
      },
      unique: undefined,
      __metadata__: undefined,
      __isSensitive__: _BaseModel.default.ComputedProperty(['settings'], function (settings) {
        return !!(settings && settings.sensitive);
      }),
      __unique__: false,
      __isUniqueValidated__: _BaseModel.default.ComputedProperty(['unique'], function (unique) {
        return unique === _SchemaUtil.default.UNIQUENESS.UNIQUE_VALIDATED;
      }),
      __isPendingUniqueness__: _BaseModel.default.ComputedProperty(['unique'], function (unique) {
        return unique === _SchemaUtil.default.UNIQUENESS.PENDING_UNIQUENESS;
      }),
      __isUniqueness__: _BaseModel.default.ComputedProperty(['__isUniqueValidated__', '__isPendingUniqueness__'], function (isValidated, isPending) {
        return isValidated || isPending;
      }),
      __canBeSensitive__: _BaseModel.default.ComputedProperty(['__metadata__'], function (metadata) {
        return !!(metadata && metadata.sensitivizable);
      }),
      __userPermission__: _SchemaUtil.default.PERMISSION.READ_ONLY,
      __displayType__: undefined,
      __displayTypeLabel__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _SchemaUtil.default.DATATYPE[displayType] || displayType;
      }),
      __supportsMinMax__: false,
      // use the private naming convention for these computed properties,
      // to deal with the complexity in cloning schema with properties (toJSON({verbose: true})),
      // to make sure these attributes are being excluded from api request
      __isReadOnly__: _BaseModel.default.ComputedProperty(['mutability'], function (mutability) {
        return mutability === _SchemaUtil.default.MUTABILITY.READONLY;
      }),
      __isWriteOnly__: _BaseModel.default.ComputedProperty(['mutability'], function (mutability) {
        return mutability === _SchemaUtil.default.MUTABILITY.WRITEONLY;
      }),
      __displayScope__: undefined,
      __isScopeSelf__: _BaseModel.default.ComputedProperty(['scope'], function (scope) {
        return scope === _SchemaUtil.default.SCOPE.SELF;
      }),
      __isNoneScopeArrayType__: _BaseModel.default.ComputedProperty(['__isScopeSelf__', '__displayType__'], function (isScopeSelf, displayType) {
        return !isScopeSelf && _SchemaUtil.default.isArrayDataType(displayType);
      }),
      __isImported__: _BaseModel.default.ComputedProperty(['externalName'], function (externalName) {
        return !!externalName;
      }),
      __isFromBaseSchema__: _BaseModel.default.ComputedProperty(['__schemaMeta__'], function (schemaMeta) {
        return schemaMeta && schemaMeta.name === 'base';
      }),
      // Only UI can turn on __enumDefined__ and reprocess the enum/oneOf value; otherwise,
      // it should leave existing value untouch
      __enumDefined__: false,
      __supportEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _underscoreWrapper.default.contains(_SchemaUtil.default.SUPPORTENUM, displayType);
      }),
      __isNumberTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _underscoreWrapper.default.contains([_SchemaUtil.default.NUMBER, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofnumber], displayType);
      }),
      __isIntegerTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _underscoreWrapper.default.contains([_SchemaUtil.default.INTEGER, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofinteger], displayType);
      }),
      __isObjectTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _underscoreWrapper.default.contains([_SchemaUtil.default.OBJECT, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofobject], displayType);
      }),
      __isStringTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _underscoreWrapper.default.contains([_SchemaUtil.default.STRING, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofstring], displayType);
      }),
      __enumConstraintType__: _BaseModel.default.ComputedProperty(['__isStringTypeEnum__', '__isNumberTypeEnum__', '__isIntegerTypeEnum__', '__isObjectTypeEnum__'], function (isStringType, isNumberType, isIntegerType, isObjectType) {
        if (isStringType) {
          return STRING;
        }

        if (isNumberType) {
          return NUMBER;
        }

        if (isIntegerType) {
          return INTEGER;
        }

        if (isObjectType) {
          return OBJECT;
        }
      }),
      __isEnumDefinedAndSupported__: _BaseModel.default.ComputedProperty(['__enumDefined__', '__supportEnum__'], function (enumDefined, supportEnum) {
        return enumDefined && supportEnum;
      }),
      __isLoginOfBaseSchema__: _BaseModel.default.ComputedProperty(['__isFromBaseSchema__', 'name'], function (isFromBaseSchema, name) {
        return isFromBaseSchema && name === 'login';
      }),
      __isLoginFormatRestrictionToEmail__: _BaseModel.default.ComputedProperty(['__loginFormatRestriction__'], function (loginFormatRestriction) {
        return loginFormatRestriction === _SchemaUtil.default.LOGINPATTERNFORMAT.EMAIL;
      })
    },
    initialize: function initialize() {
      _BaseModel.default.prototype.initialize.apply(this, arguments);

      this.listenTo(this, 'change:__displayType__', this._updateTypeFormatConstraints);
      this.listenTo(this, 'change:type change:format change:items', this._updateDisplayType);
      this.listenTo(this, 'change:__minVal__ change:__maxVal__', this._updateMinMax);
      this.listenTo(this, 'change:__equals__', this._convertEqualsToMinMax);
      this.listenTo(this, 'change:__constraint__', this._setConstraintText);

      this._setConstraintText();

      this._setLoginPattern();
    },
    parse: function parse(resp) {
      var _context22;

      /* eslint complexity: [2, 9] */
      resp = _underscoreWrapper.default.clone(resp);

      if (resp.type === 'object' && resp.extendedType === 'image') {
        resp.type = 'image';
      }

      resp['__displayType__'] = _SchemaUtil.default.getDisplayType(resp.type, resp.format, resp.items ? resp.items.format ? resp.items.format : resp.items.type : undefined);

      this._setRangeConstraints(resp);

      resp['__supportsMinMax__'] = (0, _indexOf.default)(_context22 = _SchemaUtil.default.SUPPORTSMINMAX).call(_context22, resp['__displayType__']) !== -1;
      resp['__displayScope__'] = _SchemaUtil.default.DISPLAYSCOPE[resp.scope] || _SchemaUtil.default.DISPLAYSCOPE.NA;

      if (resp.settings && resp.settings.permissions && resp.settings.permissions.SELF) {
        resp['__userPermission__'] = resp.settings.permissions.SELF;
      }

      this._setMasterOverride(resp);

      this._setSubSchemas(resp);

      this._setUniqueness(resp);

      return resp;
    },
    validate: function validate() {
      var enumValidationError = this._validateEnumOneOf();

      if (enumValidationError) {
        return enumValidationError;
      }

      if (!this.get('__supportsMinMax__') || !this.get('__constraint__')) {
        return undefined;
      }

      var constraitType = this.get('__constraint__');
      var constraitHandler = this[this.constraintHandlers[constraitType]];

      if (_underscoreWrapper.default.isFunction(constraitHandler)) {
        return constraitHandler.call(this);
      } else {
        _Logger.default.warn('No constraint handler found for: ' + constraitType);

        return undefined;
      }
    },
    _checkBetweenConstraints: function _checkBetweenConstraints() {
      var minVal = this.get('__minVal__');
      var maxVal = this.get('__maxVal__');

      if (!minVal && !maxVal) {
        return;
      }

      if (!minVal) {
        return {
          __minVal__: 'Min value is required'
        };
      }

      if (!maxVal) {
        return {
          __maxVal__: 'Max value is required'
        };
      }

      var val = this._checkIntegerConstraints('__minVal__', 'Min value');

      if (val) {
        return val;
      }

      val = this._checkIntegerConstraints('__maxVal__', 'Max value');

      if (val) {
        return val;
      }

      if (+minVal >= +maxVal) {
        return {
          __maxVal__: 'Max val must be greater than min val'
        };
      }
    },
    _checkGreaterThanConstraint: function _checkGreaterThanConstraint() {
      var minVal = this.get('__minVal__');

      if (!minVal) {
        return;
      }

      var val = this._checkIntegerConstraints('__minVal__', 'Min value');

      if (val) {
        return val;
      }
    },
    _checkLessThanConstraint: function _checkLessThanConstraint() {
      var maxVal = this.get('__maxVal__');

      if (!maxVal) {
        return;
      }

      var val = this._checkIntegerConstraints('__maxVal__', 'Max value');

      if (val) {
        return val;
      }
    },
    _checkEqualsConstraint: function _checkEqualsConstraint() {
      var equals = this.get('__equals__');

      if (!equals) {
        return;
      }

      var val = this._checkIntegerConstraints('__equals__', 'Constraint');

      if (val) {
        return val;
      }
    },
    _checkIntegerConstraints: function _checkIntegerConstraints(field, name) {
      var val = this.get(field);
      var error = {};

      if (isNaN(val)) {
        error[field] = name + ' must be a number';
        return error;
      }

      if (+val < 0) {
        error[field] = name + ' must be greater than 0';
        return error;
      }
    },
    _setMasterOverride: function _setMasterOverride(resp) {
      if (resp.settings && resp.settings.masterOverride && resp.settings.masterOverride) {
        var masterOverrideValue = resp.settings.masterOverride.value;

        if (_underscoreWrapper.default.isArray(masterOverrideValue) && !_underscoreWrapper.default.isEmpty(masterOverrideValue)) {
          resp['__masterOverrideType__'] = 'OVERRIDE';
          resp['__masterOverrideValue__'] = masterOverrideValue || [];
        } else {
          resp['__masterOverrideType__'] = resp.settings.masterOverride.type;
        }
      } else {
        resp['__masterOverrideType__'] = 'INHERIT';
      }
    },
    _setRangeConstraints: function _setRangeConstraints(resp) {
      /* eslint complexity: [2, 11] */
      if (resp['__displayType__'] === STRING) {
        resp['__minVal__'] = resp.minLength;
        resp['__maxVal__'] = resp.maxLength;
      } else if (resp['__displayType__'] === INTEGER || resp['__displayType__'] === NUMBER) {
        resp['__minVal__'] = resp.minimum;
        resp['__maxVal__'] = resp.maximum;
      }

      if (resp['__minVal__'] && resp['__maxVal__']) {
        if (resp['__minVal__'] === resp['__maxVal__']) {
          resp['__constraint__'] = 'equals';
          resp['__equals__'] = resp['__minVal__'];
        } else {
          resp['__constraint__'] = 'between';
        }
      } else if (!resp['__minVal__'] && resp['__maxVal__']) {
        resp['__constraint__'] = 'lessThan';
      } else if (!resp['__maxVal__'] && resp['__minVal__']) {
        resp['__constraint__'] = 'greaterThan';
      }
    },
    _setSubSchemas: function _setSubSchemas(resp) {
      if (resp.allOf) {
        resp['subSchemas'] = new SchemaPropertySubSchemaAllOfCollection(resp.allOf, {
          parse: true
        });
      } else if (resp.oneOf) {
        resp['subSchemas'] = new SchemaPropertySubSchemaOneOfCollection(resp.oneOf, {
          parse: true
        });
      } else if (resp.noneOf) {
        resp['subSchemas'] = new SchemaPropertySubSchemaNoneOfCollection(resp.noneOf, {
          parse: true
        });
      }
    },
    _setUniqueness: function _setUniqueness(resp) {
      var unique = resp && resp.unique;
      resp['__unique__'] = !!(unique && (unique === _SchemaUtil.default.UNIQUENESS.UNIQUE_VALIDATED || unique === _SchemaUtil.default.UNIQUENESS.PENDING_UNIQUENESS));
    },
    _setLoginPattern: function _setLoginPattern() {
      if (!this.get('__isLoginOfBaseSchema__')) {
        return;
      }

      var pattern = this.get('pattern');

      if (pattern === loginFormatNonePattern) {
        this.set('__loginFormatRestriction__', _SchemaUtil.default.LOGINPATTERNFORMAT.NONE);
      } else if (pattern) {
        this.set('__loginFormatRestriction__', _SchemaUtil.default.LOGINPATTERNFORMAT.CUSTOM);
        this.set('__loginFormatRestrictionCustom__', this._extractLoginPattern(pattern));
      } else {
        this.set('__loginFormatRestriction__', _SchemaUtil.default.LOGINPATTERNFORMAT.EMAIL);
      }
    },
    _updateDisplayType: function _updateDisplayType() {
      var type = this.get('type');

      if (type === STRING && this.get('format')) {
        this.set('__displayType__', _SchemaUtil.default.FORMATDISPLAYTYPE[this.get('format')]);
      } else {
        var items = this.get('items');
        var arraytype = items && (items.format ? items.format : items.type);

        if (type && arraytype) {
          this.set('__displayType__', _SchemaUtil.default.ARRAYDISPLAYTYPE[getArrayTypeName(type, arraytype)]);
        } else {
          this.set('__displayType__', type);
        }
      }
    },
    _validateEnumOneOf: function _validateEnumOneOf() {
      if (!this.get('__isEnumDefinedAndSupported__')) {
        return;
      }

      var enumOneOf = this.get('__oneOf__') || [];

      if (_underscoreWrapper.default.isEmpty(enumOneOf)) {
        return {
          __oneOf__: loc('model.validation.field.blank', 'courage')
        };
      }

      if (!this._isValidateOneOfConstraint(enumOneOf)) {
        var constraintType = this.get('__enumConstraintType__');
        var errorTypeMsg = constraintTypeErrorMessages[constraintType];
        return {
          __oneOf__: errorTypeMsg
        };
      }
    },
    _isValidateOneOfConstraint: function _isValidateOneOfConstraint(values) {
      var constraintType = this.get('__enumConstraintType__');
      return _underscoreWrapper.default.all(values, function (value) {
        return _EnumTypeHelper.default.isConstraintValueMatchType(value.const, constraintType);
      });
    },
    toJSON: function toJSON() {
      var json = _BaseModel.default.prototype.toJSON.apply(this, arguments);

      json.settings = {
        permissions: {}
      };
      json.settings.permissions['SELF'] = this.get('__userPermission__'); // omit "sensitive" filed will have default it value to false.

      if (this.get('__isSensitive__')) {
        json.settings.sensitive = this.get('__isSensitive__');
      }

      if (this.get('type') === 'image') {
        json.type = 'object';
        json.extendedType = 'image';
      }

      json = this._enumAssignment(json);
      json = this._attributeOverrideToJson(json);
      json = this._normalizeUnionValue(json);
      json = this._patternAssignment(json);
      json = this._uniquenessAssignment(json);
      return json;
    },
    _attributeOverrideToJson: function _attributeOverrideToJson(json) {
      var masterOverrideType = this.get('__masterOverrideType__');
      var masterOverrideValue = this.get('__masterOverrideValue__');

      if (masterOverrideType === 'OKTA_MASTERED') {
        json.settings.masterOverride = {
          type: 'OKTA_MASTERED'
        };
      } else if (masterOverrideType === 'OVERRIDE') {
        json.settings.masterOverride = {
          type: 'ORDERED_LIST',
          value: []
        };

        if (masterOverrideValue instanceof _BaseCollection.default) {
          _underscoreWrapper.default.each(masterOverrideValue.toJSON(), function (overrideProfile) {
            json.settings.masterOverride.value.push(overrideProfile.id);
          });
        } else if (masterOverrideValue instanceof Array) {
          json.settings.masterOverride.value = masterOverrideValue;
        }

        if (_underscoreWrapper.default.isEmpty(json.settings.masterOverride.value)) {
          delete json.settings.masterOverride;
        }
      }

      if (masterOverrideType === 'INHERIT') {
        delete json.settings.masterOverride;
      }

      return json;
    },

    /**
     * Only allow set "union" value when isScopeSelf is NONE and displayType is
     * array of (string/number/integer), otherwise reset to default.
     *
     * @see /universal-directory/shared/views/components/UnionGroupValuesRadio.js
     */
    _normalizeUnionValue: function _normalizeUnionValue(json) {
      if (!this.get('__isNoneScopeArrayType__')) {
        json['union'] = undefined;
      }

      return json;
    },
    _enumAssignment: function _enumAssignment(json) {
      if (!this.get('__isEnumDefinedAndSupported__')) {
        return json;
      } // backfill empty title by constraint


      var enumOneOf = this._getEnumOneOfWithTitleCheck();

      if (this.get('type') === 'array') {
        delete json.items.enum;
        json.items.oneOf = enumOneOf;
      } else {
        delete json.enum;
        json.oneOf = enumOneOf;
      }

      return json;
    },
    _patternAssignment: function _patternAssignment(json) {
      if (!this.get('__isLoginOfBaseSchema__') || !this.get('__loginFormatRestriction__')) {
        return json;
      }

      switch (this.get('__loginFormatRestriction__')) {
        case _SchemaUtil.default.LOGINPATTERNFORMAT.EMAIL:
          delete json.pattern;
          break;

        case _SchemaUtil.default.LOGINPATTERNFORMAT.CUSTOM:
          json.pattern = this._buildLoginPattern(this.get('__loginFormatRestrictionCustom__'));
          break;

        case _SchemaUtil.default.LOGINPATTERNFORMAT.NONE:
          json.pattern = loginFormatNonePattern;
          break;
      }

      return json;
    },
    _uniquenessAssignment: function _uniquenessAssignment(json) {
      if (!this.get('__unique__')) {
        delete json.unique;
      } else if (!this.get('__isUniqueness__')) {
        json.unique = _SchemaUtil.default.UNIQUENESS.UNIQUE_VALIDATED;
      }

      return json;
    },

    /**
     * Character should be escaped except letters, digits and hyphen
     */
    _escapedRegexChar: function _escapedRegexChar(pattern, index) {
      var char = pattern.charAt(index);

      if (escapedLoginCharsRe.test(char)) {
        return '\\' + char;
      }

      return char;
    },
    _buildLoginPattern: function _buildLoginPattern(pattern) {
      var result = '';

      for (var i = 0; i < pattern.length; i++) {
        result = result + this._escapedRegexChar(pattern, i);
      }

      return '[' + result + ']+';
    },
    _extractLoginPattern: function _extractLoginPattern(pattern) {
      var re = /^\[(.*)\]\+/;
      var matches = pattern.match(re);
      return matches ? matches[1].replace(/\\(.)/g, '$1') : pattern;
    },
    _getEnumOneOfWithTitleCheck: function _getEnumOneOfWithTitleCheck() {
      var _context23;

      var enumOneOf = this.get('__oneOf__');
      return (0, _map.default)(_context23 = _underscoreWrapper.default).call(_context23, enumOneOf, function (value) {
        var _context24;

        if ((0, _trim.default)(_context24 = _jqueryWrapper.default).call(_context24, value.title) !== '') {
          return value;
        }

        value.title = !_underscoreWrapper.default.isString(value.const) ? (0, _stringify.default)(value.const) : value.const;
        return value;
      });
    },
    _updateTypeFormatConstraints: function _updateTypeFormatConstraints() {
      var _context25;

      var displayType = this.get('__displayType__'); // OKTA-31952 reset format according to its displayType

      this.unset('format', {
        silent: true
      });
      this.unset('items', {
        silent: true
      });
      this.set(_SchemaUtil.default.DISPLAYTYPES[displayType]);

      if (displayType !== NUMBER && displayType !== INTEGER) {
        this.unset('minimum');
        this.unset('maximum');
      }

      if (displayType !== STRING) {
        this.unset('minLength');
        this.unset('maxLength');
      }

      this.unset('__minVal__');
      this.unset('__maxVal__');
      this.unset('__equals__');
      this.set('__supportsMinMax__', (0, _indexOf.default)(_context25 = _SchemaUtil.default.SUPPORTSMINMAX).call(_context25, this.get('__displayType__')) !== -1);
    },
    _updateMinMax: function _updateMinMax() {
      var min;
      var max;
      var displayType = this.get('__displayType__');

      if (displayType === STRING) {
        min = 'minLength';
        max = 'maxLength';
      } else if (displayType === INTEGER || displayType === NUMBER) {
        min = 'minimum';
        max = 'maximum';
      }

      if (this.get('__minVal__')) {
        this.set(min, (0, _parseInt3.default)(this.get('__minVal__'), 10));
      } else {
        this.unset(min);
      }

      if (this.get('__maxVal__')) {
        this.set(max, (0, _parseInt3.default)(this.get('__maxVal__'), 10));
      } else {
        this.unset(max);
      }
    },
    _convertEqualsToMinMax: function _convertEqualsToMinMax() {
      var equals = this.get('__equals__');

      if (equals) {
        this.set('__minVal__', equals);
        this.set('__maxVal__', equals);
      }
    },

    /*
     Normally we would use a derived property here but derived properties do not work with the model Clone function
     so we use this workaround instead.
     */
    _setConstraintText: function _setConstraintText() {
      var constraint = this.get('__constraint__');
      var min = this.get('__minVal__');
      var max = this.get('__maxVal__');
      var equals = this.get('__equals__');

      switch (constraint) {
        case 'between':
          this.set('__constraintText__', 'Between ' + min + ' and ' + max);
          break;

        case 'greaterThan':
          this.set('__constraintText__', 'Greater than ' + min);
          break;

        case 'lessThan':
          this.set('__constraintText__', 'Less than ' + max);
          break;

        case 'equals':
          this.set('__constraintText__', 'Equals ' + equals);
          break;

        default:
          this.set('__constraintText__', '');
          break;
      }
    },
    cleanup: function cleanup() {
      if (this.get('__constraint__') === 'lessThan') {
        this.unset('__minVal__');
      } else if (this.get('__constraint__') === 'greaterThan') {
        this.unset('__maxVal__');
      }

      if (this.get('scope') !== _SchemaUtil.default.SCOPE.SYSTEM) {
        if (this.get('__isScopeSelf__') === true) {
          this.set({
            scope: _SchemaUtil.default.SCOPE.SELF
          }, {
            silent: true
          });
        } else {
          this.unset('scope');
        }
      }

      if (!this.get('__unique__')) {
        this.unset('unique');
      }
    },

    /**
     * Since there is not an dedicated attribute to flag enum type,
     * use enum values to determine whether the property is enum type or not.
     */
    isEnumType: function isEnumType() {
      return !!this.getEnumValues();
    },
    getEnumValues: function getEnumValues() {
      return this.get('oneOf') || this.get('enum') || this.get('items') && this.get('items')['oneOf'] || this.get('items') && this.get('items')['enum'];
    },
    detectHasEnumDefined: function detectHasEnumDefined() {
      var enumValues = this.getEnumValues();

      if (!enumValues) {
        return;
      }

      this.set('__oneOf__', _EnumTypeHelper.default.convertToOneOf(enumValues));
      this.set('__enumDefined__', true);
    }
  });

  var SchemaPropertySchemaProperties = _BaseCollection.default.extend({
    model: SchemaPropertySchemaProperty,
    clone: function clone() {
      return new this.constructor(this.toJSON({
        verbose: true
      }), {
        parse: true
      });
    },
    areAllReadOnly: function areAllReadOnly() {
      return _underscoreWrapper.default.all(this.pluck('__isReadOnly__'));
    },
    createModelProperties: function createModelProperties() {
      var _context26;

      return (0, _reduce.default)(_context26 = this).call(_context26, function (p, schemaProperty) {
        var _context27;

        var type = schemaProperty.get('type');
        p[schemaProperty.id] = _underscoreWrapper.default.clone(_SchemaUtil.default.DISPLAYTYPES[type]);

        if ((0, _indexOf.default)(_context27 = _SchemaUtil.default.SUPPORTSMINMAX).call(_context27, type) !== -1) {
          p[schemaProperty.id].minLength = schemaProperty.get('minLength');
          p[schemaProperty.id].maxLength = schemaProperty.get('maxLength');
        }

        if (type === 'string') {
          p[schemaProperty.id].format = schemaProperty.get('format');
        }

        return p;
      }, {});
    }
  });

  var _default = {
    Model: SchemaPropertySchemaProperty,
    Collection: SchemaPropertySchemaProperties
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _SchemaUtil = _interopRequireDefault(__webpack_require__(13));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-statements: 0 */


  var NAME = 'name';
  var ENUM_KEY_PREFIX = '_enum_';
  /**
   * Generate Input Options in order to create an input in an Form for Enum type attribute.
   * @param {Object} config informations for creating input options
   *   config.name        schema property name
   *   config.title       schema property title
   *   config.readOnly    create an read only input?
   *   config.explain     sub-title to the input
   *   config.enumValues  list of enum values for creating input options (Dropdown/SimpleCheckBoxSet)
   *   config.displayType display type of schema property
   *
   * @return {Object} inputOptions options for create an Input view. (Dropdown/SimpleCheckBoxSet)
   *
   */

  function getEnumInputOptions(config) {
    var enumOneOf = convertToOneOf(config.enumValues);
    var inputOptions = {
      name: config.name,
      label: config.title,
      readOnly: config.readOnly,
      customExplain: config.explain,
      params: {
        enumOneOf: enumOneOf
      },
      options: getDropdownOptionsFromOneOf(enumOneOf)
    }; // input type

    if (_SchemaUtil.default.isArrayDataType(config.displayType)) {
      inputOptions.type = 'checkboxset';
      inputOptions.to = valuesToEnumObjects;
      inputOptions.from = enumObjectsToValues;
    } else {
      inputOptions.type = 'select';
      inputOptions.to = valueToEnumObject;
      inputOptions.from = enumObjectToValue;
    }

    inputOptions.input = null;
    return inputOptions;
  }

  function getDropdownOptions(values) {
    return _underscoreWrapper.default.isArray(values) ? getDropdownOptionsFromOneOf(convertToOneOf(values)) : {};
  }

  function getDropdownOptionsFromOneOf(values) {
    var _context28;

    if (!isOneOfEnumObject(values)) {
      return {};
    }

    return (0, _reduce.default)(_context28 = _underscoreWrapper.default).call(_context28, values, function (options, value, index) {
      options[convertIndexToEnumIndex(index)] = value.title;
      return options;
    }, {});
  }

  function convertToOneOf(values) {
    // assume this is a legacy enum array and convert to oneOf object
    if (!_underscoreWrapper.default.all(values, _jqueryWrapper.default.isPlainObject)) {
      return convertEnumToOneOf(values); // we assume object without const and title is an enum object which need special conversion
    } else if (!isOneOfEnumObject(values)) {
      return convertEnumObjectToOneOf(values);
    }

    return values;
  }

  function isOneOfEnumObject(values) {
    return _underscoreWrapper.default.isArray(values) && _underscoreWrapper.default.all(values, function (value) {
      return _underscoreWrapper.default.has(value, 'const') && _underscoreWrapper.default.has(value, 'title');
    });
  }

  function convertEnumToOneOf(values) {
    var _context29;

    return (0, _map.default)(_context29 = _underscoreWrapper.default).call(_context29, values, function (value) {
      return {
        const: value,
        title: valueToTitle(value)
      };
    });
  }

  function valueToTitle(value) {
    if (_underscoreWrapper.default.isObject(value)) {
      return (0, _stringify.default)(value);
    }

    if (_underscoreWrapper.default.isNumber(value)) {
      return value + '';
    }

    return value;
  }

  function convertEnumObjectToOneOf(values) {
    var findKey = _underscoreWrapper.default.partial(_underscoreWrapper.default.has, _underscoreWrapper.default, NAME); // If all object found the key NAME, use the NAME's value as display name


    if (_underscoreWrapper.default.all(values, findKey)) {
      var _context30, _context31;

      return (0, _map.default)(_context30 = (0, _filter.default)(_context31 = _underscoreWrapper.default.chain(values)).call(_context31, function (value) {
        return _jqueryWrapper.default.isPlainObject(value) && _underscoreWrapper.default.has(value, NAME);
      })).call(_context30, function (value) {
        return {
          const: value,
          title: value[NAME]
        };
      }).value();
    } // Assume a legacy object array does not need special handling and just convert to const/title enum


    return convertEnumToOneOf(values);
  }

  function convertIndexToEnumIndex(index) {
    var _context32;

    return (0, _concat.default)(_context32 = "".concat(ENUM_KEY_PREFIX)).call(_context32, index);
  }

  function enumObjectToValue(obj) {
    var _context33;

    var index = (0, _findIndex.default)(_context33 = _underscoreWrapper.default).call(_context33, this.options.params.enumOneOf, function (oneOfObj) {
      return _underscoreWrapper.default.isObject(obj) ? _underscoreWrapper.default.isEqual(oneOfObj.const, obj) : oneOfObj.const === obj;
    }); // Cannot rely on comparator in findIndex when compare objects so need special handling

    return index > -1 ? convertIndexToEnumIndex(index) : obj;
  }

  function valueToEnumObject(val) {
    if (!_underscoreWrapper.default.isString(val) || (0, _indexOf.default)(val).call(val, ENUM_KEY_PREFIX) !== 0) {
      return val;
    }

    var index = val.replace(ENUM_KEY_PREFIX, '');
    var enumValue = this.options.params && _underscoreWrapper.default.isArray(this.options.params.enumOneOf) ? this.options.params.enumOneOf[index] : null; // @see `getEnumInputOptions` how enumValues has been set.

    return _underscoreWrapper.default.has(enumValue, 'const') ? enumValue.const : enumValue;
  }

  function valuesToEnumObjects(values) {
    var _context34;

    return (0, _map.default)(_context34 = _underscoreWrapper.default).call(_context34, values, (0, _bind.default)(valueToEnumObject).call(valueToEnumObject, this));
  }

  function enumObjectsToValues(values) {
    var _context35;

    return (0, _map.default)(_context35 = _underscoreWrapper.default).call(_context35, values, (0, _bind.default)(enumObjectToValue).call(enumObjectToValue, this));
  }

  function isStringConstraint(value) {
    var _context36;

    return _underscoreWrapper.default.isString(value) && (0, _trim.default)(_context36 = _jqueryWrapper.default).call(_context36, value) !== '';
  }

  function isNumberConstraint(value) {
    var _context37;

    return _underscoreWrapper.default.isNumber(value) || _underscoreWrapper.default.isNumber(_StringUtil.default.parseFloat((0, _trim.default)(_context37 = _jqueryWrapper.default).call(_context37, value)));
  }

  function isIntegerConstraint(value) {
    var _context38;

    var integer = _underscoreWrapper.default.isNumber(value) ? value : _StringUtil.default.parseInt((0, _trim.default)(_context38 = _jqueryWrapper.default).call(_context38, value));
    return typeof integer === 'number' && isFinite(integer) && Math.floor(integer) === integer;
  }

  function isObjectConstraint(value) {
    var _context39;

    if (_underscoreWrapper.default.isObject(value) && !_underscoreWrapper.default.isArray(value)) {
      return true;
    }

    var object = _StringUtil.default.parseObject((0, _trim.default)(_context39 = _jqueryWrapper.default).call(_context39, value));

    return _underscoreWrapper.default.isObject(object) && !_underscoreWrapper.default.isArray(object);
  }

  function isConstraintValueMatchType(value, type) {
    switch (type) {
      case _SchemaUtil.default.STRING:
        return isStringConstraint(value);

      case _SchemaUtil.default.NUMBER:
        return isNumberConstraint(value);

      case _SchemaUtil.default.INTEGER:
        return isIntegerConstraint(value);

      case _SchemaUtil.default.OBJECT:
        return isObjectConstraint(value);
    }
  }

  var _default = {
    getEnumInputOptions: getEnumInputOptions,
    getDropdownOptions: getDropdownOptions,
    convertToOneOf: convertToOneOf,
    isConstraintValueMatchType: isConstraintValueMatchType
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 21 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _SettingsModel = _interopRequireDefault(__webpack_require__(22));

  var _ConfirmationDialog = _interopRequireDefault(__webpack_require__(23));

  var _Notification = _interopRequireDefault(__webpack_require__(41));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-len: [2, 150], max-params: [2, 7] */


  function getRoute(router, route) {
    var root = _underscoreWrapper.default.result(router, 'root') || '';

    if (root && _underscoreWrapper.default.isString(route)) {
      return [root, route].join('/').replace(/\/{2,}/g, '/');
    }

    return route;
  }
  /**
   * BaseRouter is a standard [Backbone.Router](http://backbonejs.org/#Router)
   * with a few additions:
   * - Explicit mapping between routes and controllers
   * - Support for rendering notification and confirmation dialogs
   *
   * Checkout the [Hello World Tutorial](https://github.com/okta/courage/wiki/Hello-World)
   * for a step-by-step guide to using this.
   *
   * @class module:Okta.Router
   * @extends external:Backbone.Router
   * @param {Object} options options hash
   * @param {String} options.el a jQuery selector string stating where to attach the controller in the DOM
   */


  var _default = _backbone.default.Router.extend(
  /** @lends module:Okta.Router.prototype */
  {
    /**
     * The root URL for the router. When setting {@link http://backbonejs.org/#Router-routes|routes},
     * it will be prepended to each route.
     * @type {String|Function}
     */
    root: '',
    listen: _Notification.default.prototype.listen,
    constructor: function constructor(options) {
      options || (options = {});
      this.el = options.el;
      this.settings = new _SettingsModel.default(_underscoreWrapper.default.omit(options, 'el'));

      if (options.root) {
        this.root = options.root;
      }

      _backbone.default.Router.apply(this, arguments);

      this.listen('notification', this._notify);
      this.listen('confirmation', this._confirm);
    },

    /**
     * Fires up a confirmation dialog
     *
     * @param  {Object} options Options Hash
     * @param  {String} options.title The title
     * @param  {String} options.subtitle The explain text
     * @param  {String} options.save The text for the save button
     * @param  {Function} options.ok The callback function to run when hitting "OK"
     * @param  {String} options.cancel The text for the cancel button
     * @param  {Function} options.cancelFn The callback function to run when hitting "Cancel"
     * @param  {Boolean} options.noCancelButton Don't render the cancel button (useful for alert dialogs)
     * @param  {Boolean} options.noSubmitButton Don't render the primary button (useful for alert dialogs)
     * @private
     *
     * @return {Okta.View} the dialog view
     */
    _confirm: function _confirm(options) {
      options || (options = {});

      var Dialog = _ConfirmationDialog.default.extend(_underscoreWrapper.default.pick(options, 'title', 'subtitle', 'save', 'ok', 'cancel', 'cancelFn', 'noCancelButton', 'noSubmitButton', 'content', 'danger', 'type', 'closeOnOverlayClick'));

      var dialog = new Dialog({
        model: this.settings
      }); // The model is here because itsa part of the BaseForm paradigm.
      // It will be ignored in the context of a confirmation dialog.

      dialog.render();
      return dialog; // test hook
    },

    /**
     * Fires up a notification banner
     *
     * @param  {Object} options Options Hash
     * @return {Okta.View} the notification view
     * @private
     */
    _notify: function _notify(options) {
      var notification = new _Notification.default(options);
      (0, _jqueryWrapper.default)('#content').prepend(notification.render().el);
      return notification; // test hook
    },

    /**
     * Renders a Controller
     * This will initialize new instance of a controller and call render on it
     *
     * @param  {Okta.Controller} Controller The controller Class we which to render
     * @param  {Object} [options] Extra options to the controller constructor
     */
    render: function render(Controller, options) {
      this.unload();
      options = _underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this, 'settings', 'el'), options || {});
      this.controller = new Controller(options);
      this.controller.render();
    },

    /**
     * Starts the backbone history object
     *
     * Waits for the dom to be ready before calling `Backbone.history.start()` (IE issue).
     *
     * See [Backbone History](http://backbonejs.org/#History) for more information.
     */
    start: function start() {
      var args = arguments;
      (0, _jqueryWrapper.default)(function () {
        if (_backbone.default.History.started) {
          _Logger.default.error('History has already been started');

          return;
        }

        _backbone.default.history.start.apply(_backbone.default.history, args);
      });
    },

    /**
     * Removes active controller and frees up event listeners
     */
    unload: function unload() {
      if (this.controller) {
        this.stopListening(this.controller);
        this.stopListening(this.controller.state);
        this.controller.remove();
      }
    },
    route: function route(_route, name, callback) {
      return _backbone.default.Router.prototype.route.call(this, getRoute(this, _route), name, callback);
    },
    navigate: function navigate(fragment, options) {
      return _backbone.default.Router.prototype.navigate.call(this, getRoute(this, fragment), options);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 22 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Model = _interopRequireDefault(__webpack_require__(11));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * @class SettingsModel
   * @extends {Okta.Model}
   * @private
   */


  var _default = _Model.default.extend({
    local: function local() {
      var settings = window.okta && window.okta.settings || {};
      return {
        orgId: ['string', false, settings.orgId],
        orgName: ['string', false, settings.orgName],
        serverStatus: ['string', false, settings.serverStatus],
        persona: ['string', false, settings.persona],
        isDeveloperConsole: ['boolean', false, settings.isDeveloperConsole],
        isPreview: ['boolean', false, settings.isPreview],
        permissions: ['array', true, settings.permissions || []]
      };
    },
    extraProperties: true,
    constructor: function constructor() {
      this.features = window._features || [];

      _Model.default.apply(this, arguments);
    },

    /**
     * Checks if the user have a feature flag enabled (Based of the org level feature flag)
     * @param  {String}  feature Feature name
     * @return {Boolean}
     */
    hasFeature: function hasFeature(feature) {
      if (window._possibleFeatures && !_underscoreWrapper.default.contains(window._possibleFeatures, feature) && window.okta && window.okta.logHasFeatureError) {
        window.okta.logHasFeatureError(feature);
      }

      return _underscoreWrapper.default.contains(this.features, feature);
    },

    /**
     * Checks if any of the given feature flags are enabled (Based of the org level feature flags)
     * @param  {Array}  featureArray Features names
     * @return {Boolean} true if any of the give features are enabled. False otherwise
     */
    hasAnyFeature: function hasAnyFeature(featureArray) {
      var _context40;

      return (0, _some.default)(_context40 = _underscoreWrapper.default).call(_context40, featureArray, this.hasFeature, this);
    },

    /**
     * Checks if the user have a specific permission (based on data passed from JSP)
     * @param  {String}  permission Permission name
     * @return {Boolean}
     */
    hasPermission: function hasPermission(permission) {
      return _underscoreWrapper.default.contains(this.get('permissions'), permission);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 23 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __WEBPACK_AMD_DEFINE_RESULT__; // TODO: maybe replaced by
  // https://github.com/Calvein/empty-module
  // https://github.com/crimx/empty-module-loader


  !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  /***/
},
/* 24 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function changeEventString(doWhen) {
    var _context41;

    return 'change:' + (0, _keys.default)(_context41 = _underscoreWrapper.default).call(_context41, doWhen).join(' change:');
  }

  function calcDoWhen(value, key) {
    var modelValue = this.model.get(key);

    if (_underscoreWrapper.default.isFunction(value)) {
      return value.call(this, modelValue);
    } else {
      return value === modelValue;
    }
  }

  function _doWhen(view, doWhen, fn) {
    var _context42;

    var toggle = (0, _bind.default)(_context42 = _underscoreWrapper.default).call(_context42, fn, view, view, doWhen);
    view.render = _underscoreWrapper.default.wrap(view.render, function (render) {
      var val = render.call(view);
      toggle({
        animate: false
      });
      return val;
    });
    view.listenTo(view.model, changeEventString(doWhen), function () {
      toggle({
        animate: true
      });
    });
  }

  var _default = {
    applyDoWhen: function applyDoWhen(view, doWhen, fn) {
      if (!(view.model && _underscoreWrapper.default.isObject(doWhen) && _underscoreWrapper.default.size(doWhen) && _underscoreWrapper.default.isFunction(fn))) {
        return;
      }

      _doWhen(view, doWhen, function (view, doWhen, options) {
        var _context43, _context44;

        var result = (0, _every.default)(_context43 = _underscoreWrapper.default).call(_context43, (0, _map.default)(_context44 = _underscoreWrapper.default).call(_context44, doWhen, calcDoWhen, view));
        fn.call(view, result, options);
      });
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 25 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _FormUtil = _interopRequireDefault(__webpack_require__(10));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _default = _BaseView.default.extend({
    className: 'o-form-button-bar',
    initialize: function initialize(options) {
      if (!options.noSubmitButton) {
        this.addButton({
          type: 'save',
          text: _underscoreWrapper.default.resultCtx(options, 'save', this),
          id: _underscoreWrapper.default.resultCtx(options, 'saveId', this),
          className: _underscoreWrapper.default.resultCtx(options, 'saveClassName', this)
        });
      }

      if (!options.noCancelButton) {
        this.addButton({
          type: 'cancel',
          text: _underscoreWrapper.default.resultCtx(options, 'cancel', this)
        });
      }

      if (options.hasPrevStep) {
        this.addButton({
          type: 'previous'
        }, {
          prepend: true
        });
      }
    },

    /**
     * Adds a buttomn to the toolbar
     * @param {Object} params button parameters
     * @param {Object} options {@link Okta.View#add} options
     */
    addButton: function addButton(params, options) {
      return this.add(_FormUtil.default.createButton(params), options);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 26 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var registry = {};

  function isBaseInput(input) {
    if (_underscoreWrapper.default.isFunction(input)) {
      return _underscoreWrapper.default.isFunction(input.prototype.editMode) && _underscoreWrapper.default.isFunction(input.prototype.readMode);
    } else {
      return _underscoreWrapper.default.isObject(input) && _underscoreWrapper.default.isFunction(input.editMode) && _underscoreWrapper.default.isFunction(input.readMode);
    }
  }
  /**
   * @class module:Okta.internal.views.forms.helpers.InputRegistry
   */


  var _default =
  /** @lends module:Okta.internal.views.forms.helpers.InputRegistry */
  {
    isBaseInput: isBaseInput,

    /**
     * Register a form input
     * @param {String} type string identifier for the input
     * @param {BaseInput} input the input to register
     */
    register: function register(type, input) {
      registry[type] = input;
    },

    /**
     * Get a form input by type
     * @param {Object} options input definition
     * @param {String} options.type string identifier for the input
     * @return {BaseInput} a matching input
     */
    get: function get(options) {
      var input = registry[options.type];
      return input && (isBaseInput(input) ? input : input(options));
    },

    /**
     * Unregister an input type
     * @param {String} type
     */
    unregister: function unregister(type) {
      delete registry[type];
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 27 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(176);
  /***/
},
/* 28 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  __webpack_require__(69);

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var template = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<select id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 12
          },
          "end": {
            "line": 1,
            "column": 23
          }
        }
      }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 31
          },
          "end": {
            "line": 1,
            "column": 39
          }
        }
      }) : helper)) + "\"></select>";
    },
    "useData": true
  });

  var option = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<option value=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "key",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 15
          },
          "end": {
            "line": 1,
            "column": 22
          }
        }
      }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "value",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 24
          },
          "end": {
            "line": 1,
            "column": 33
          }
        }
      }) : helper)) + "</option>";
    },
    "useData": true
  });

  var CHOSEN_WINDOW_MARGIN = 20; // Chosen has known problems when it's at the bottom of a container that has
  // overflow:hidden set. Because it attaches to the parent container, its
  // dropdown will be cut off in the UI. Any modal with a chosen select element
  // at the bottom will manifest this behavior.
  //
  // The fix (aside from replacing Chosen) is to change Chosen's behavior -
  // use the existing styles, but attach it to 'body' and position it correctly
  // so that it is not affected by a parent overflow.
  //
  // More details can be found in OKTA-46489, OKTA-83570

  var CHOSEN_MAX_HEIGHT = 240;
  var CHOSEN_Z_INDEX = 50000;

  function defer(fn) {
    if (this.params.autoWidth) {
      return fn.call(this);
    } else {
      var _context45;

      return _underscoreWrapper.default.defer((0, _bind.default)(_context45 = _underscoreWrapper.default).call(_context45, fn, this));
    }
  }

  function findSelectWidth(self) {
    self.$select.hide();
    var select = (0, _jqueryWrapper.default)(self.$select[0]).hide();
    (0, _jqueryWrapper.default)('body').append(select);
    var width = self.params.width = select.width() * 1.2 + 'px';
    self.$el.append(select.show());
    return width;
  }

  function recalculateChosen($chosen, $results, $clone) {
    var offset = $clone.offset();
    $chosen.css({
      left: offset.left,
      top: offset.top
    }); // Update the max-height to fit within the constraints of the window. This
    // is especially important for modals because page scrolling is disabled.

    var $win = (0, _jqueryWrapper.default)(window);
    var rHeight = $results.outerHeight();
    var rBottom = rHeight + $results.offset().top - $win.scrollTop();
    var wHeight = $win.height() - CHOSEN_WINDOW_MARGIN;
    var maxHeight = Math.min(rHeight + wHeight - rBottom, CHOSEN_MAX_HEIGHT);
    $results.css('max-height', maxHeight);
  }

  function fixChosenModal($select) {
    var $chosen = $select.next('.chzn-container');
    var $clone = $chosen.clone();
    var $results = (0, _find.default)($chosen).call($chosen, '.chzn-results'); // Use a hidden clone to maintain layout and calculate offset. This is
    // necessary for more complex layouts (like adding a group rule) where
    // the chosen element is floated.

    $clone.css('visibility', 'hidden');
    $clone.removeAttr('id');
    (0, _find.default)($clone).call($clone, 'li').removeAttr('id'); // Save the original styles - we'll revert to them when the select closes

    var baseStyles = {
      left: $chosen.css('left'),
      top: $chosen.css('top'),
      position: $chosen.css('position'),
      float: $chosen.css('float'),
      'z-index': $chosen.css('z-index')
    };
    $results.hide(); // Handler for any resize events that happen when the results list is open

    var resizeHandler = _underscoreWrapper.default.debounce(function () {
      recalculateChosen($chosen, $results, $clone);
    }, 10); // When the dropdown opens, attach it to body, with the correct absolute
    // position coordinates


    $select.off('.fixChosen'); // Remove events we could have added before

    $select.on('liszt:showing_dropdown.fixChosen', function () {
      $chosen.width($chosen.width());
      $select.after($clone); // .chzn-container can trigger the vertical scrollbar if it causes scrollHeight > window height after append to
      // the body. Force top -999999 to avoid the scrollbar so $chosen can find the right offset for relocation.

      $chosen.css({
        position: 'absolute',
        float: 'none',
        'z-index': CHOSEN_Z_INDEX,
        top: -999999
      });
      (0, _jqueryWrapper.default)('body').append($chosen);
      $results.show();
      recalculateChosen($chosen, $results, $clone); // Capture scroll events:
      // - for forms that use fixed positioning (like editing attributes in
      //   Profile Editor) - window scroll
      // - for forms that are too long for the modal - o-form-content scroll

      $select.parents().scroll(resizeHandler);
      (0, _jqueryWrapper.default)(window).on('resize scroll', resizeHandler);
    }); // When the dropdown closes or the element is removed, revert to the
    // original styles and reattach it to its original placement in the dom.

    $select.on('liszt:hiding_dropdown.fixChosen remove.fixChosen', function () {
      $select.parents().off('scroll', resizeHandler);
      (0, _jqueryWrapper.default)(window).off('resize scroll', resizeHandler);
      $chosen.css(baseStyles);
      $results.hide();
      $results.css('max-height', CHOSEN_MAX_HEIGHT);
      $clone.remove();
      $select.after($chosen);
    });
  }

  var _default = _BaseInput.default.extend({
    className: 'o-form-select',

    /**
     * @Override
     */
    events: {
      'change select': 'update',
      'keyup .chzn-search > :text': function keyupChznSearchText(e) {
        if (_Keys.default.isEsc(e)) {
          this.$('.chzn-search > :text').val('');
          e.stopPropagation();
        }
      }
    },
    constructor: function constructor() {
      this.template = template;
      this.option = option;

      _BaseInput.default.apply(this, arguments);

      this.params = this.options.params || {};
    },

    /**
     * @Override
     */
    editMode: function editMode() {
      /* eslint max-statements: [2, 13] */
      this.$el.html(template(this.options));
      this.$select = this.$('select');
      var options = this.getOptions();

      _underscoreWrapper.default.each(options, function (value, key) {
        this.$select.append(option({
          key: key,
          value: value
        }));
      }, this); // Fix a regression in jQuery 1.x on Firefox
      // jQuery.val(value) prepends an empty option to the dropdown
      // if value doesnt exist in the dropdown.
      // http://bugs.jquery.com/ticket/13514


      var value = this.getModelValue();

      if (value) {
        this.$select.val(value);
      } else {
        this.$('option:first-child').prop('selected', true);
      }

      this.$el.addClass('o-form-control');

      if (this.params.chosen !== false) {
        this.__applyChosen();
      }

      return this;
    },
    __applyChosen: function __applyChosen(update) {
      var width = this.options.wide ? '100%' : this.params.width || '62%';

      if (this.params.autoWidth) {
        width = findSelectWidth(this);
      }

      defer.call(this, function () {
        var searchThreshold = this.getParam('searchThreshold', 10);

        if (!_underscoreWrapper.default.result(this.options, 'autoRender') && update !== false) {
          this.update();
        }

        this.$select.chosen({
          width: width,
          disable_search_threshold: searchThreshold,
          //eslint-disable-line camelcase
          placeholder_text: this.options['placeholder'],
          //eslint-disable-line camelcase
          search_contains: true //eslint-disable-line camelcase

        });
        fixChosenModal(this.$select);

        if (this.params.autoWidth) {
          // fix a chosen css bug
          this.$el.width(0);
        }

        this.model.trigger('form:resize');
      });
    },

    /**
     * @Override
     */
    val: function val() {
      return this.$select && this.$select.val();
    },

    /**
     * @Override
     */
    focus: function focus() {
      if (this.$select) {
        return this.$select.focus();
      }
    },

    /**
     * @Override
     */
    toStringValue: function toStringValue() {
      var selectedOption = this.getModelValue();
      var displayString = selectedOption;
      var options = this.getOptions();

      if (!_underscoreWrapper.default.isEmpty(options)) {
        displayString = options[selectedOption];
      }

      if (_underscoreWrapper.default.isUndefined(displayString)) {
        displayString = this.defaultValue();
      }

      return displayString || '';
    },

    /**
     * Convert options to an object
     * support input options that is a
     * 1. a static object such as {key1: val1, key2: val2...}
     * 2. a function to be called to return a static object
     * will return an object with key-value pairs or with empty content
     * @return {Object} The value
     */
    getOptions: function getOptions() {
      var options = this.options.options;

      if (_underscoreWrapper.default.isFunction(options)) {
        options = options.call(this);
      }

      return _underscoreWrapper.default.isObject(options) ? options : {};
    },
    remove: function remove() {
      if (this.$select) {
        this.$select.trigger('remove');
      }

      return _BaseInput.default.prototype.remove.apply(this, arguments);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 29 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Time = _interopRequireDefault(__webpack_require__(30));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function getOption(callout, option) {
    return _underscoreWrapper.default.resultCtx(callout.options, option, callout) || _underscoreWrapper.default.result(callout, option);
  }

  function getTopClass(callout) {
    var klass = 'infobox clearfix infobox-' + getOption(callout, 'type');

    switch (getOption(callout, 'size')) {
      case 'standard':
        klass += '';
        break;

      case 'slim':
        klass += ' infobox-slim';
        break;

      case 'compact':
        klass += ' infobox-compact';
        break;

      case 'large':
        klass += ' infobox-md';
        break;
    }

    if (getOption(callout, 'dismissible')) {
      klass += ' infobox-dismiss';
    }

    return klass;
  }

  var events = {
    'click .infobox-dismiss-link': function clickInfoboxDismissLink(e) {
      var _this = this;

      e.preventDefault();
      this.$el.fadeOut(_Time.default.UNLOADING_FADE, function () {
        _this.trigger('dismissed');

        _this.remove();
      });
    }
  };

  var template = _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      return "<a data-se=\"dismiss-link\" class=\"infobox-dismiss-link\" title=\"Dismiss\" href=\"#\"><span data-se=\"icon\" class=\"dismiss-icon\"></span></a>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h3 data-se=\"header\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 243
          },
          "end": {
            "line": 1,
            "column": 252
          }
        }
      }) : helper)) + "</h3>";
    },
    "5": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p data-se=\"sub-header\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "subtitle",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 304
          },
          "end": {
            "line": 1,
            "column": 316
          }
        }
      }) : helper)) + "</p>";
    },
    "7": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<ul data-se=\"list\" class=\"bullets\">" + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "bullets") : depth0, {
        "name": "each",
        "hash": {},
        "fn": container.program(8, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 377
          },
          "end": {
            "line": 1,
            "column": 440
          }
        }
      })) != null ? stack1 : "") + "</ul>";
    },
    "8": function _(container, depth0, helpers, partials, data) {
      return "<li data-se=\"list-item\">" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "dismissible") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 159
          }
        }
      })) != null ? stack1 : "") + "<span data-se=\"icon\" class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "icon",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 192
          },
          "end": {
            "line": 1,
            "column": 200
          }
        }
      }) : helper)) + "\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 209
          },
          "end": {
            "line": 1,
            "column": 264
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 264
          },
          "end": {
            "line": 1,
            "column": 327
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "bullets") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 327
          },
          "end": {
            "line": 1,
            "column": 452
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  });

  var CalloutCallout = _BaseView.default.extend(
  /** @lends src/views/components/Callout.prototype */
  {
    attributes: {
      'data-se': 'callout'
    },

    /**
     * Custom HTML or view to inject to the callout
     * @type {String|Okta.View}
     */
    content: null,

    /**
     * Size of icon. options are standard, large, compact
     * @type {String}
     */
    size: 'standard',

    /**
     * Type of the callout. Valid values are: info, success, warning, error, tip
     * @type {String}
     */
    type: 'info',

    /**
     * Can the callout be dismissed
     * @type {Boolean}
     */
    dismissible: false,

    /**
     * Callout title
     * @type {String}
     */
    title: null,

    /**
     * Callout subtitle
     * @type {String}
     */
    subtitle: null,

    /**
     * Array of strings to render as bullet points
     * @type {Array}
     */
    bullets: null,

    /**
     * Fired after the callout is dismised - applies when
     * {@link module:Okta.internal.views.components.Callout|dismissible} is set to true
     * @event src/views/components/Callout#dismissed
     */
    constructor: function constructor() {
      this.events = _underscoreWrapper.default.defaults(this.events || {}, events);

      _BaseView.default.apply(this, arguments);

      this.$el.addClass(getTopClass(this));
      this.template = template;
      var content = getOption(this, 'content');

      if (content) {
        this.add(content);
      }
    },
    getTemplateData: function getTemplateData() {
      var icon = getOption(this, 'type');
      var size = getOption(this, 'size');

      if (icon === 'tip') {
        // css is inconsistent
        icon = 'light-bulb';
      }

      switch (size) {
        case 'slim':
          icon = '';
          break;

        case 'large':
          icon = [icon, '-', '24'].join('');
          break;

        default:
          icon = [icon, '-', '16'].join('');
      }

      return {
        icon: icon,
        title: getOption(this, 'title'),
        subtitle: getOption(this, 'subtitle'),
        bullets: getOption(this, 'bullets'),
        dismissible: getOption(this, 'dismissible')
      };
    }
  });
  /**
   * @class src/views/components/Callout
   * @extends module:Okta.View
   */

  /**
   * @class module:Okta.internal.views.components.Callout
   */


  var _default =
  /** @lends module:Okta.internal.views.components.Callout */
  {
    /**
     * Creates a {@link src/views/components/Callout|Callout}.
     * @static
     * @param {Object} options
     * @param {String|Function} [options.size] Size of icon. options are standard, large, compact, slim
     * @param {String|Okta.View} [options.content] Custom HTML or view to inject to the callout
     * @param {String|Function} [options.title] Callout title
     * @param {String|Function} [options.subtitle] Callout subtitle
     * @param {Array|Function} [options.bullets] Array of strings to render as bullet points
     * @param {Boolean|Function} [options.dismissible] Can the callout be dismissed
     * @param {String|Function} [options.type] Callout type. Valid values are: info, success, warning, error, tip
     *
     * @return {src/views/components/Callout}
     */
    create: function create(options) {
      return new CalloutCallout(options);
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 30 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _default = {
    DEBOUNCE_DELAY: 200,
    LOADING_FADE: 400,
    UNLOADING_FADE: 400,
    ROW_EXPANDER_TRANSITION: 150,
    HIDE_ADD_MAPPING_FORM: 300
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 31 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
  /**
   * There are following local modifications:
   * - Author: Uzi Kilon ukilon@okta.com
   *   Bug: OKTA-20830 - solves the conflict when there are multiple labels
   */

  /**
   * --------------------------------------------------------------------
   * jQuery customInput plugin
   * Author: Maggie Costello Wachs maggie@filamentgroup.com, Scott Jehl, scott@filamentgroup.com
   * Copyright (c) 2009 Filament Group
   * licensed under MIT (filamentgroup.com/examples/mit-license.txt)
   * --------------------------------------------------------------------
  */


  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (jQuery) {
    var $ = jQuery;

    jQuery.fn.customInput = function () {
      return $(this).each(function () {
        if ($(this).is('[type=checkbox],[type=radio]')) {
          var input = $(this); // get the associated label using the input's id

          var label = input.siblings('label[for="' + input.attr('id') + '"]:first');

          if (!label.length) {
            label = input.closest('label[for="' + input.attr('id') + '"]:first');
          } // wrap the input + label in a div


          input.add(label).wrapAll('<div class="custom-' + input.attr('type') + '"></div>'); // necessary for browsers that don't support the :hover pseudo class on labels

          label.hover(function () {
            $(this).addClass('hover');
          }, function () {
            $(this).removeClass('hover');
          }); //bind custom event, trigger it, bind click,focus,blur events

          (0, _bind.default)(input).call(input, 'updateState', function () {
            input.is(':checked') ? label.addClass('checked') : label.removeClass('checked checkedHover checkedFocus');
          }).trigger('updateState').click(function () {
            $('input[name="' + $(this).attr('name') + '"]').trigger('updateState');
          }).focus(function () {
            label.addClass('focus');

            if (input.is(':checked')) {
              $(this).addClass('checkedFocus');
            }
          }).blur(function () {
            label.removeClass('focus checkedFocus');
          });
        }
      });
    };
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  /***/
},
/* 32 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  __webpack_require__(27);

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  __webpack_require__(74);

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var className = 'okta-form-input-field input-fix';

  function hasTitleAndText(options) {
    var title = options.title;
    var text = options.text;
    return title && text && title !== text;
  } // options may be a string or an object.


  function createQtipContent(options) {
    if (hasTitleAndText(options)) {
      return options;
    }

    return {
      text: options.text || options
    };
  }

  var _default = _BaseInput.default.extend({
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        return "<span class=\"input-tooltip icon form-help-16\"></span>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"icon input-icon " + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "icon") : stack1, depth0)) + "\"></span>";
      },
      "5": function _(container, depth0, helpers, partials, data) {
        return "<span class=\"input-icon-divider\"></span>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "innerTooltip") : stack1, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 87
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "icon") : stack1, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 87
            },
            "end": {
              "line": 1,
              "column": 166
            }
          }
        })) != null ? stack1 : "") + "<input type=\"" + alias4((helper = (helper = lookupProperty(helpers, "type") || (depth0 != null ? lookupProperty(depth0, "type") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "type",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 179
            },
            "end": {
              "line": 1,
              "column": 187
            }
          }
        }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "placeholder",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 202
            },
            "end": {
              "line": 1,
              "column": 217
            }
          }
        }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "name",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 225
            },
            "end": {
              "line": 1,
              "column": 233
            }
          }
        }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 239
            },
            "end": {
              "line": 1,
              "column": 250
            }
          }
        }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "value",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 259
            },
            "end": {
              "line": 1,
              "column": 268
            }
          }
        }) : helper)) + "\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "placeholder",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 282
            },
            "end": {
              "line": 1,
              "column": 297
            }
          }
        }) : helper)) + "\" autocomplete=\"off\"/>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "iconDivider") : stack1, {
          "name": "if",
          "hash": {},
          "fn": container.program(5, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 319
            },
            "end": {
              "line": 1,
              "column": 392
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),

    /**
     * @Override
     */
    events: {
      'input input': 'update',
      'change input': 'update',
      'keydown input': 'update',
      'keyup input': function keyupInput(e) {
        if (_Keys.default.isEnter(e)) {
          this.model.trigger('form:save');
        } else if (_Keys.default.isEsc(e)) {
          this.model.trigger('form:cancel');
        }
      }
    },
    constructor: function constructor() {
      _BaseInput.default.apply(this, arguments);

      this.$el.addClass('o-form-control');
    },

    /**
     * @Override
     */
    editMode: function editMode() {
      this.$el.addClass(className);

      _BaseInput.default.prototype.editMode.apply(this, arguments);

      this.$('input').placeholder();
    },

    /**
     * @Override
     */
    readMode: function readMode() {
      _BaseInput.default.prototype.readMode.apply(this, arguments);

      if (this.options.type === 'password') {
        this.$el.text('********');
      }

      this.$el.removeClass(className);
    },

    /**
     * @Override
     */
    val: function val() {
      var inputValue = this.$('input[type="' + this.options.type + '"]').val(); //IE will only read clear text pw if type="password" is explicitly in selector

      if (this.options.type !== 'password') {
        var _context46;

        inputValue = (0, _trim.default)(_context46 = _jqueryWrapper.default).call(_context46, inputValue);
      }

      return inputValue;
    },

    /**
     * @Override
     */
    focus: function focus() {
      return this.$('input').focus();
    },
    postRender: function postRender() {
      var params = this.options.params;
      var content;

      if (params && params.innerTooltip) {
        content = createQtipContent(params.innerTooltip);
        this.$('.input-tooltip').qtip({
          content: content,
          style: {
            classes: 'okta-tooltip qtip-custom qtip-shadow'
          },
          position: {
            my: 'bottom left',
            // Note: qTip2 has a known issue calculating the tooltip offset when:
            // 1. A container element has both:
            //    a) position: relative/absolute
            //    b) overlay: value other than 'visible'
            // 2. The page is scrolled
            //
            // We set position:relative and overlay:auto on the body element,
            // where both are required for:
            // - Positioning the footer correctly
            // - Displaying long pages in embedded browsers
            //
            // The original design called for a fixed position relative to the
            // tooltip icon - this has been switched to "relative to mouse, and
            // update position when mouse moves" because of this constraint.
            target: 'mouse',
            adjust: {
              method: 'flip',
              mouse: true,
              y: -5,
              x: 5
            },
            viewport: (0, _jqueryWrapper.default)('body')
          }
        });
      }
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 33 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(34);
  /***/
},
/* 34 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _BaseCollection = _interopRequireDefault(__webpack_require__(14));

  var _BaseModel = _interopRequireDefault(__webpack_require__(15));

  var _BaseSchema = _interopRequireDefault(__webpack_require__(38));

  var _Model = _interopRequireDefault(__webpack_require__(11));

  var _SchemaProperty = _interopRequireDefault(__webpack_require__(19));

  var _BaseController = _interopRequireDefault(__webpack_require__(40));

  var _BaseRouter = _interopRequireDefault(__webpack_require__(21));

  var _ButtonFactory = _interopRequireDefault(__webpack_require__(17));

  var _Class = _interopRequireDefault(__webpack_require__(45));

  var _Cookie = _interopRequireDefault(__webpack_require__(46));

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _Util = _interopRequireDefault(__webpack_require__(18));

  var _handlebarsWrapper = _interopRequireDefault(__webpack_require__(48));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Backbone = _interopRequireDefault(__webpack_require__(56));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _BaseDropDown = _interopRequireDefault(__webpack_require__(58));

  var _BaseForm = _interopRequireDefault(__webpack_require__(59));

  var _Toolbar = _interopRequireDefault(__webpack_require__(25));

  var _FormUtil = _interopRequireDefault(__webpack_require__(10));

  var _InputRegistry = _interopRequireDefault(__webpack_require__(26));

  var _SchemaFormFactory = _interopRequireDefault(__webpack_require__(67));

  var _CheckBox = _interopRequireDefault(__webpack_require__(72));

  var _PasswordBox = _interopRequireDefault(__webpack_require__(73));

  var _Radio = _interopRequireDefault(__webpack_require__(75));

  var _Select = _interopRequireDefault(__webpack_require__(28));

  var _InputGroup = _interopRequireDefault(__webpack_require__(76));

  var _TextBox = _interopRequireDefault(__webpack_require__(32));

  var _Callout = _interopRequireDefault(__webpack_require__(29));

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  var _View = _interopRequireDefault(__webpack_require__(16));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  } // The string will be returned unchanged. All templates should be precompiled.


  _View.default.prototype.compileTemplate = function (str) {
    return function fakeTemplate() {
      return str;
    };
  };

  var Okta = {
    Backbone: _backbone.default,
    $: _jqueryWrapper.default,
    _: _underscoreWrapper.default,
    Handlebars: _handlebarsWrapper.default,
    loc: _StringUtil.default.localize,
    createButton: _ButtonFactory.default.create,
    createCallout: _Callout.default.create,
    registerInput: _InputRegistry.default.register,
    Model: _Model.default,
    BaseModel: _BaseModel.default,
    Collection: _BaseCollection.default,
    FrameworkView: _View.default,
    View: _BaseView.default,
    ListView: _Backbone.default,
    Router: _BaseRouter.default,
    Controller: _BaseController.default,
    Form: _BaseForm.default,
    internal: {
      util: {
        Util: _Util.default,
        Cookie: _Cookie.default,
        Logger: _Logger.default,
        Class: _Class.default,
        Keys: _Keys.default
      },
      views: {
        components: {
          BaseDropDown: _BaseDropDown.default
        },
        forms: {
          helpers: {
            FormUtil: _FormUtil.default,
            SchemaFormFactory: _SchemaFormFactory.default
          },
          components: {
            Toolbar: _Toolbar.default
          },
          inputs: {
            TextBox: _TextBox.default,
            PasswordBox: _PasswordBox.default,
            CheckBox: _CheckBox.default,
            Radio: _Radio.default,
            Select: _Select.default,
            InputGroup: _InputGroup.default
          }
        }
      },
      models: {
        BaseSchema: _BaseSchema.default,
        SchemaProperty: _SchemaProperty.default
      }
    }
  };
  Okta.registerInput('text', _TextBox.default);
  Okta.registerInput('password', _PasswordBox.default);
  Okta.registerInput('checkbox', _CheckBox.default);
  Okta.registerInput('radio', _Radio.default);
  Okta.registerInput('select', _Select.default);
  Okta.registerInput('group', _InputGroup.default);
  var _default = Okta;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 35 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(215);
  /***/
},
/* 36 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var STATE = '__STATE__',
      FETCH_DATA = 'FETCH_DATA',
      PAGINATION_DATA = 'PAGINATION_DATA',
      DEFAULT_PARAMS = 'DEFAULT_PARAMS',
      LINK_BY_HEADER = 'LINK_BY_HEADER',
      XHR = 'XHR';
  /*
   * Sets the next page URL on the collection from link headers
   * See: http://www.rfc-editor.org/rfc/rfc5988.txt
   *
   * This method is looking for a link header with `rel="next"`
   * An set's it as the next page's URL.
   *
   * If it doesn't find a next page, and current page is set by a link header
   * it assumes we are at the last page and deletes the current `next`
   */

  function setLinkHeadersPagination(collection, xhr) {
    try {
      var links = parseLinkHeader(xhr.getResponseHeader('link'));
      collection[STATE].set(LINK_BY_HEADER, true);
      collection.setPagination(links['next'].href);
    } catch (e) {
      if (collection[STATE].get(LINK_BY_HEADER)) {
        collection.setPagination(null);
      }
    }
  }

  function parseQuery(url) {
    var params = {},
        rawQueryStr = url && url.split('?')[1],
        queryString = rawQueryStr && decodeURIComponent(rawQueryStr.split('#')[0]).replace(/\+/g, ' '),
        props = queryString ? queryString.split('&') : [];

    for (var i = 0; i < props.length; i++) {
      var parts = props[i].split('=');
      params[parts.shift()] = parts.join('=');
    }

    return params;
  } // ################################################
  // # Source: https://gist.github.com/deiu/9335803
  // ################################################
  // unquote string (utility)


  function unquote(value) {
    if (value.charAt(0) == '"' && value.charAt(value.length - 1) == '"') {
      return value.substring(1, value.length - 1);
    }

    return value;
  }
  /*
  parse a Link header
  Link:<https://example.org/.meta>; rel=meta
  var r = parseLinkHeader(xhr.getResponseHeader('Link');
  r['meta']['href'] outputs https://example.org/.meta
  */


  function parseLinkHeader(header) {
    /* eslint max-statements: 0 */
    var linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*")))*(,|$)/g,
        paramexp = /[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*"))/g;
    var matches = header.match(linkexp);
    var rels = {};

    for (var i = 0; i < matches.length; i++) {
      var split = matches[i].split('>');
      var href = split[0].substring(1);
      var link = {};
      link.href = href;
      var s = split[1].match(paramexp);

      for (var j = 0; j < s.length; j++) {
        var paramsplit = s[j].split('=');
        var name = paramsplit[0];
        link[name] = unquote(paramsplit[1]);
      }

      if (link.rel !== undefined) {
        rels[link.rel] = link;
      }
    }

    return rels;
  } // ################################################
  // # /Source
  // ################################################
  //

  /**
   *
   * Archer.Collection is a standard [Backbone.Collection](http://backbonejs.org/#Collection) with pre-set `data`
   * parameters and built in pagination - works with [http link headers](https://tools.ietf.org/html/rfc5988)
   * out of the box:
   *
   * @class src/framework/Collection
   * @extends external:Backbone.Collection
   * @example
   * var Users = Archer.Collection.extend({
   *   url: '/api/v1/users'
   *   params: {expand: true}
   * });
   * var users = new Users(null, {params: {type: 'new'}}),
   *     $button = this.$('a.fetch-more');
   *
   * $button.click(function () {
   *   users.fetchMore();
   * });
   *
   * this.listenTo(users, 'sync', function () {
   *   $button.toggle(users.hasMore());
   * });
   *
   * collection.fetch(); //=> '/api/v1/users?expand=true&type=new'
   */


  var _default = _backbone.default.Collection.extend(
  /** @lends src/framework/Collection.prototype */
  {
    /**
     * Default fetch parameters
     * @type {Object}
     */
    params: {},
    constructor: function constructor(models, options) {
      var state = this[STATE] = new _backbone.default.Model();
      state.set(DEFAULT_PARAMS, _underscoreWrapper.default.defaults(options && options.params || {}, this.params || {}));

      _backbone.default.Collection.apply(this, arguments);
    },

    /**
     * See [Backbone Collection.sync](http://backbonejs.org/#Collection-sync).
     */
    sync: function sync(method, collection, options) {
      var self = this,
          success = options.success;

      options.success = function (resp, status, xhr) {
        // its important to set the pagination data *before* we call the success callback
        // because we want the pagination data to be ready when the collection triggers the `sync` event
        setLinkHeadersPagination(self, xhr);
        success.apply(null, arguments);
      };

      return _backbone.default.Collection.prototype.sync.call(this, method, collection, options);
    },

    /**
     * See [Backbone Collection.fetch](http://backbonejs.org/#Collection-fetch).
     */
    fetch: function fetch(options) {
      options || (options = {});
      var state = this[STATE],
          xhr = state.get(XHR);
      options.data = _underscoreWrapper.default.extend({}, state.get(DEFAULT_PARAMS), options.data || {});
      options.fromFetch = true;
      state.set(FETCH_DATA, options.data);

      if (xhr && xhr.abort && options.abort !== false) {
        xhr.abort();
      }

      xhr = _backbone.default.Collection.prototype.fetch.call(this, options);
      state.set(XHR, xhr);
      return xhr;
    },

    /**
     * Set pagination data to get to the next page
     * @param {Mixed} params
     * @param {Object} [options]
     * @param {Boolean} [options.fromFetch] should we include data from the previous fetch call in this object
     * @example
     * collection.setPagination({q: 'foo', page: '2'}); //=> {q: 'foo', page: '2'}
     *
     * collection.setPagination('/path/to/resource?q=baz&page=4'); //=> {q: 'baz', page: '4'}
     *
     * collection.setPagination('/path/to/resource'); //=> {}
     *
     * collection.fetch({data: {q: 'foo'}});
     * collection.setPagination({page: 2}, {fromFetch: true}); //=> {q: 'foo', page: 2}
     *
     * any "falsy" value resets pagination
     * collection.setPagination(); //=> {}
     * collection.setPagination(null); //=> {}
     * collection.setPagination(false); //=> {}
     * collection.setPagination(''); //=> {}
     * collection.setPagination(0); //=> {}
     * @protected
     */
    setPagination: function setPagination(params, options) {
      /* eslint complexity: [2, 8] */
      if (_underscoreWrapper.default.isString(params) && params) {
        params = parseQuery(params);
      }

      if (!_underscoreWrapper.default.isObject(params) || _underscoreWrapper.default.isArray(params) || !_underscoreWrapper.default.size(params)) {
        params = null;
      } else if (options && options.fromFetch) {
        params = _underscoreWrapper.default.extend({}, this.getFetchData(), params);
      }

      this[STATE].set(PAGINATION_DATA, params);
    },

    /**
     * Returns the `data` parameters applied in th most recent `fetch` call
     * It will include parameters set by {@link #params} and optios.params passed to the constructor
     * @return {Object}
     * @protected
     */
    getFetchData: function getFetchData() {
      return this[STATE].get(FETCH_DATA) || {};
    },

    /**
     * Data object for constructing a request to fetch the next page
     * @return {Object}
     * @protected
     */
    getPaginationData: function getPaginationData() {
      return this[STATE].get(PAGINATION_DATA) || {};
    },

    /**
     * Does this collection have more data on the server (e.g is there a next "page")
     * @return {Boolean}
     */
    hasMore: function hasMore() {
      return _underscoreWrapper.default.size(this.getPaginationData()) > 0;
    },

    /**
     * Get the next page from the server
     * @return {Object} xhr returned by {@link #fetch}
     */
    fetchMore: function fetchMore() {
      if (!this.hasMore()) {
        throw new Error('Invalid Request');
      }

      return this.fetch({
        data: this.getPaginationData(),
        add: true,
        remove: false,
        update: true
      });
    },

    /**
     * See [Backbone Collection.reset](http://backbonejs.org/#Collection-reset).
     */
    reset: function reset(models, options) {
      options || (options = {}); // only reset the pagination when reset is being called explicitly.
      // this is to avoid link headers pagination being overriden and reset when
      // fetching the collection using `collection.fetch({reset: true})`

      if (!options.fromFetch) {
        this.setPagination(null);
      }

      return _backbone.default.Collection.prototype.reset.apply(this, arguments);
    },
    // we want "where" to be able to search through derived properties as well
    where: function where(attrs, first) {
      if (_underscoreWrapper.default.isEmpty(attrs)) {
        return first ? void 0 : [];
      }

      return this[first ? 'find' : 'filter'](function (model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) {
            return false;
          }
        }

        return true;
      });
    },

    /**
     * See [Backbone Collection.create](http://backbonejs.org/#Collection-create).
     */
    create: function create(model, options) {
      options || (options = {});

      if (!_underscoreWrapper.default.result(model, 'urlRoot')) {
        options.url = _underscoreWrapper.default.result(this, 'url');
      }

      return _backbone.default.Collection.prototype.create.call(this, model, options);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 37 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }
  /**
     * Archer.Model is a standard [Backbone.Model](http://backbonejs.org/#Model) with a few additions:
     *
     * - {@link src/framework/Model#derived Derived properties}
     * - {@link src/framework/Model#props Built in schema validation}
     * - {@link src/framework/Model#local Private properties (with schema validation)}
     * - {@link src/framework/Model#flat Flattening of nested objects}
     *
     * Both derived and private properties are filtered out when sending the data to the server.
     *
     * See [Backbone.Model](http://backbonejs.org/#Model-constructor).
     *
     * @class src/framework/Model
     * @extends external:Backbone.Model
     * @param {Object} [attributes] - Initial model attributes (data)
     * @param {Object} [options] - Options hash
     * @example
     * var Person = Archer.Model.extend({
     *   props: {
     *     'fname': 'string',
     *     'lname': 'string'
     *   },
     *   local: {
     *     isLoggedIn: 'boolean'
     *   },
     *   derived: {
     *     name: {
     *       deps: ['fname', 'lname'],
     *       fn: function (fname, lname) {
     *         return fname + ' ' + lname;
     *       }
     *     }
     *   }
     * });
     * var model = new Person({fname: 'Joe', lname: 'Doe'});
     * model.get('name'); //=> "Joe Doe"
     * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
     *
     * model.set('isLoggedIn', true);
     * model.get('isLoggedIn'); //=> true
     * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
     */


  var Model;

  function flatten(value, objectTypeFields, key, target) {
    var filter = _underscoreWrapper.default.contains(objectTypeFields, key);

    target || (target = {});

    if (!filter && _underscoreWrapper.default.isObject(value) && !_underscoreWrapper.default.isArray(value) && !_underscoreWrapper.default.isFunction(value)) {
      _underscoreWrapper.default.each(value, function (val, i) {
        flatten(val, objectTypeFields, key ? key + '.' + i : i, target);
      });
    } // Case where target is an empty object. Guard against returning {undefined: undefined}.
    else if (key !== undefined) {
        target[key] = value;
      }

    return target;
  }

  function unflatten(data) {
    _underscoreWrapper.default.each(data, function (value, key, data) {
      if ((0, _indexOf.default)(key).call(key, '.') == -1) {
        return;
      }

      var part,
          ref = data,
          parts = key.split('.');

      while ((part = parts.shift()) !== undefined) {
        if (!ref[part]) {
          ref[part] = parts.length ? {} : value;
        }

        ref = ref[part];
      }

      delete data[key];
    });

    return data;
  }

  function createMessage(field, msg) {
    var obj = {};
    obj[field.name] = msg;
    return obj;
  }

  function normalizeSchemaDef(field, name) {
    var target;

    if (_underscoreWrapper.default.isString(field)) {
      target = {
        type: field
      };
    } else if (_underscoreWrapper.default.isArray(field)) {
      target = {
        type: field[0],
        required: field[1],
        value: field[2]
      };
    } else {
      target = _underscoreWrapper.default.clone(field);
    }

    _underscoreWrapper.default.defaults(target, {
      required: false,
      name: name
    });

    return target;
  }

  function capitalize(string) {
    return string.toLowerCase().replace(/\b[a-z]/g, function (letter) {
      return letter.toUpperCase();
    });
  }

  function _validateRegex(value, pattern, error) {
    if (!pattern.test(value)) {
      return error;
    }
  }

  var StringFormatValidators = {
    /*eslint max-len: 0 */
    email: function email(value) {
      // Taken from  http://emailregex.com/ on 2017-03-06.
      var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_EMAIL);
    },
    uri: function uri(value) {
      // source: https://mathiasbynens.be/demo/url-regex
      var pattern = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
      return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_URI);
    },
    ipv4: function ipv4(value) {
      // source: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
      var pattern = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_IPV4);
    },
    hostname: function hostname(value) {
      // source: http://www.regextester.com/23
      var pattern = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/;
      return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_HOSTNAME);
    }
  };

  function validateStringFormat(field, value) {
    var validator = StringFormatValidators[field.format];

    if (field.format && !validator) {
      throw new TypeError(field.format + ' is not a supported string format');
    }

    return validator && validator(value);
  }

  function validateString(field, value) {
    var createMessageWith = _underscoreWrapper.default.partial(createMessage, field),
        invalidFormat = validateStringFormat(field, value);

    if (invalidFormat) {
      return createMessageWith(invalidFormat);
    }

    if (value && field.minLength && value.length < field.minLength) {
      return createMessageWith(Model.ERROR_STRING_STRING_MIN_LENGTH, value.length);
    }

    if (value && field.maxLength && value.length > field.maxLength) {
      return createMessageWith(Model.ERROR_STRING_STRING_MAX_LENGTH, value.length);
    }
  }

  function _validateField(field, value) {
    /* eslint complexity: [2, 25], max-statements: [2, 27] */
    var createMessageWith = _underscoreWrapper.default.partial(createMessage, field),
        isDefined = !_underscoreWrapper.default.isUndefined(value) && !_underscoreWrapper.default.isNull(value),
        checkType,
        errorMessage; // If using an array validator, perform the validation


    if ((0, _isArray.default)(field.validate)) {
      var _context47;

      var output = [];
      var foundError = false;

      var _result;

      (0, _forEach.default)(_context47 = field.validate).call(_context47, function (item) {
        if (!value) {
          _result = false;
        } else {
          switch (item.type.toLowerCase()) {
            case 'regex':
              _result = new RegExp(item.value.pattern, (0, _flags.default)(item.value) || '').test(value);
              break;

            default:
              _result = false;
          }
        } // Append the result.


        foundError = foundError || !_result;
        output.push({
          message: item.hasOwnProperty('message') ? item.message : '',
          passed: _result
        });
      });

      if (foundError) {
        return createMessageWith(output);
      }

      return;
    } // check required fields


    if (field.required && (!isDefined || _underscoreWrapper.default.isNull(value) || value === '')) {
      return createMessageWith(Model.ERROR_BLANK);
    } // check type


    checkType = _underscoreWrapper.default['is' + capitalize(field.type)];

    if (isDefined && field.type != 'any' && (!_underscoreWrapper.default.isFunction(checkType) || !checkType(value))) {
      return createMessageWith(Model.ERROR_WRONG_TYPE);
    } // validate string format


    if (value && field.type == 'string') {
      var error = validateString(field, value);

      if (error) {
        return error;
      }
    } // check pre set values (enum)


    if (isDefined && (0, _values.default)(field) && !_underscoreWrapper.default.contains((0, _values.default)(field), value)) {
      return createMessageWith(Model.ERROR_NOT_ALLOWED);
    } // check validate method


    if (_underscoreWrapper.default.isFunction(field.validate)) {
      var result = field.validate(value);

      if (_underscoreWrapper.default.isString(result) && result) {
        return createMessageWith(result);
      } else if (result === false) {
        return createMessageWith(Model.ERROR_INVALID);
      }
    } // check array items


    if (isDefined && field.type == 'array' && (errorMessage = validateArrayField(field, value))) {
      return createMessageWith(errorMessage);
    }
  }

  function validateArrayField(field, arr) {
    if (field.minItems && arr.length < field.minItems) {
      return 'model.validation.field.array.minItems';
    } else if (field.maxItems && arr.length > field.maxItems) {
      return 'model.validation.field.array.maxItems';
    } else if (field.uniqueItems && arr.length > _underscoreWrapper.default.uniq(arr).length) {
      return Model.ERROR_IARRAY_UNIQUE;
    } else if (field.items) {
      /* eslint max-depth: [2, 3] */
      var arrayField = normalizeSchemaDef(field.items, 'placeholder');

      for (var i = 0; i < arr.length; i++) {
        var value = arr[i];

        var error = _validateField(arrayField, value);

        if (error) {
          return error['placeholder'];
        }
      }
    }
  }

  Model = _backbone.default.Model.extend(
  /** @lends src/framework/Model.prototype */
  {
    /**
       * Pass props as an object to extend, describing the observable properties of your model. The props
       * properties should not be set on an instance, as this won't define new properties, they should only be passed to
       * extend.
       * Properties can be defined in three different ways:
       *
       * - As a string with the expected dataType. One of string, number, boolean, array, object, date, or any.
       * Eg: `name: 'string'`.
       * - An array of `[dataType, required, default]`
       * - An object `{type: 'string', format: '', required: true, value: '', values: [], validate: function() {}`
       *   - `value` will be the value that the property will be set to if it is undefined, either by not being set during
       *   initialization, or by being explicitly set to undefined.
       *   - `format` is a json-schame derived string format. Supported formats are: `email`, `uri`, `hostname` and `ipv4`.
       *   - If `required` is true, one of two things will happen. If a default is set for the property, the property will
       *   start with that value. If a default is not set for the property, validation will fail
       *   - If `values` array is passed, then you'll be able to change a property to one of those values only.
       *   - If `validate` is defined, it should return false or a custom message string when the validation fails.
       *   - If the type is defined as `array`, the array elements could be defined by `minItems` (Number),
       *   `uniqueItems` (Boolean) and `items` (a field definition such as this one that will validate each array member)
       *   To the `validate` method
       *   - Trying to set a property to an invalid type will raise an exception.
       *
       * @type {Mixed}
       * @example
       * var Person = Model.extend({
       *   props: {
       *     name: 'string',
       *     age: 'number',
       *     paying: ['boolean', true, false], //required attribute, defaulted to false
       *     type: {
       *       type: 'string',
       *       values: ['regular-hero', 'super-hero', 'mega-hero']
       *     },
       *     likes: {
       *       type: 'string',
       *       validate: function (value) {
       *         return /^[\w]+ing$/.test(value)
       *       }
       *     }
       *   }
       * });
       */
    props: {},

    /**
       * Derived properties (also known as computed properties) are properties of the model that depend on the
       * other (props, local or even derived properties to determine their value. Best demonstrated with an example:
       *
       * Each derived property, is defined as an object with the current properties:
       *
       * - `deps` {Array} - An array of property names which the derived property depends on.
       * - `fn` {Function} - A function which returns the value of the computed property. It is called in the context of
       * the current object, so that this is set correctly.
       * - `cache` {Boolean} -  - Whether to cache the property. Uncached properties are computed every time they are
       * accessed. Useful if it depends on the current time for example. Defaults to `true`.
       *
       * Derived properties are retrieved and fire change events just like any other property. They cannot be set
       * directly.
       * @type {Object}
       * @example
       * var Person = Model.extend({
       *   props: {
       *     firstName: 'string',
       *     lastName: 'string'
       *   },
       *   derived: {
       *     fullName: {
       *       deps: ['firstName', 'lastName'],
       *       fn: function (firstName, lastName) {
       *         return firstName + ' ' + lastName;
       *       }
       *     }
       *   }
       * });
       *
       * var person = new Person({ firstName: 'Phil', lastName: 'Roberts' })
       * console.log(person.get('fullName')) //=> "Phil Roberts"
       *
       * person.set('firstName', 'Bob');
       * console.log(person.get('fullName')) //=> "Bob Roberts"
       */
    derived: {},

    /**
       * local properties are defined and work in exactly the same way as {@link src/framework/Model#props|props}, but generally only exist for
       * the lifetime of the page.
       * They would not typically be persisted to the server, and are not returned by calls to {@link src/framework/Model#toJSON|toJSON}.
       *
       * @type {Object}
       * @example
       * var Person = Model.extend({
       *   props: {
       *     name: 'string',
       *   },
       *   local: {
       *     isLoggedIn: 'boolean'
       *   }
       * );
       */
    local: {},

    /**
       * Flatten the payload into dot notation string keys:
       *
       * @type {Boolean}
       * @example
       * var Person = Model.extend({
       *   props: {
       *     'profile.fname': 'string',
       *     'profile.lname': 'string',
       *     'profile.languages': 'object'
       *   },
       *   flat: true
       * });
       * var person = new Person({'profile': {
       *                            'fname': 'John',
       *                            'lname': 'Doe',
       *                            'languages': {name: "English", value: "EN"}
       *                         }}, {parse: true});
       * person.get('profile'); //=> undefined
       * person.get('profile.fname'); //=> 'John'
       * person.get('profile.lname'); //=> 'Doe'
       * person.get('profile.languages'); //=> {name: "English", value: "EN"}
       * person.get('profile.languages.name'); //=> undefined
       * person.toJSON(); //=> {'profile': {'fname': 'John'} }
       */
    flat: true,

    /**
       * @deprecated
       * @alias Backbone.Model#defaults
       */
    defaults: {},
    constructor: function constructor(options) {
      this.options = options || {};
      var schema = this['__schema__'] = {},
          objectTypeFields = [];
      schema.computedProperties = {};
      schema.props = _underscoreWrapper.default.clone(_underscoreWrapper.default.result(this, 'props') || {});
      schema.derived = _underscoreWrapper.default.clone(_underscoreWrapper.default.result(this, 'derived') || {});
      schema.local = _underscoreWrapper.default.clone(_underscoreWrapper.default.result(this, 'local') || {});
      var defaults = {};

      _underscoreWrapper.default.each(_underscoreWrapper.default.extend({}, schema.props, schema.local), function (options, name) {
        var schemaDef = normalizeSchemaDef(options, name);

        if (!_underscoreWrapper.default.isUndefined(schemaDef.value)) {
          defaults[name] = schemaDef.value;
        }

        if (schemaDef.type === 'object') {
          objectTypeFields.push(name);
        }
      }, this);

      if (_underscoreWrapper.default.size(defaults)) {
        var localDefaults = _underscoreWrapper.default.result(this, 'defaults');

        this.defaults = function () {
          return _underscoreWrapper.default.defaults({}, defaults, localDefaults);
        };
      } // override `validate`


      this.validate = _underscoreWrapper.default.wrap(this.validate, function (validate) {
        var args = _underscoreWrapper.default.rest(arguments),
            res = _underscoreWrapper.default.extend(this._validateSchema.apply(this, args), validate.apply(this, args));

        return _underscoreWrapper.default.size(res) && res || undefined;
      }); // override `parse`

      this.parse = _underscoreWrapper.default.wrap(this.parse, function (parse) {
        var target = parse.apply(this, _underscoreWrapper.default.rest(arguments));

        if ((0, _flat.default)(this)) {
          target = flatten(target, objectTypeFields);
        }

        return target;
      });

      _backbone.default.Model.apply(this, arguments);

      _underscoreWrapper.default.each(schema.derived, function (options, name) {
        schema.computedProperties[name] = this.__getDerivedValue(name); // set initial value;

        var deps = options.deps || [];

        if (deps.length) {
          this.on('cache:clear change:' + deps.join(' change:'), function () {
            var value = this.__getDerivedValue(name);

            if (value !== schema.computedProperties[name]) {
              schema.computedProperties[name] = value;
              this.trigger('change:' + name, this, value);
            }
          }, this);
        }
      }, this);

      this.on('sync', function () {
        this.__syncedData = this.toJSON();
      }, this);
    },
    validate: function validate() {},

    /**
       * Check if the schema settings allow this field to exist in the model
       * @param  {String} key
       * @return {Boolean}
       */
    allows: function allows(key) {
      var schema = this['__schema__'],
          all = _underscoreWrapper.default.extend({}, schema.props, schema.local);

      if (!_underscoreWrapper.default.has(all, key)) {
        _Logger.default.warn('Field not defined in schema', key);
      }

      return true;
    },

    /**
       * Returns the schema for the specific property
       *
       * @param propName - The name of the property
       * @returns {*} | null
       */
    getPropertySchema: function getPropertySchema(propName) {
      var _context48;

      var schema = this['__schema__'];
      return (0, _reduce.default)(_context48 = _underscoreWrapper.default).call(_context48, [schema.props, schema.local], function (result, options) {
        return result || normalizeSchemaDef(options[propName], propName);
      }, null);
    },
    set: function set(key, val) {
      var attrs;

      if (_typeof(key) === 'object') {
        attrs = key;
      } else {
        (attrs = {})[key] = val;
      } // Don't override a computed properties


      _underscoreWrapper.default.each(attrs, function (value, key) {
        if (_underscoreWrapper.default.has(this['__schema__'].derived, key)) {
          throw 'overriding derived properties is not supported: ' + key;
        }
      }, this); // Schema validation


      var errorFields = [];

      _underscoreWrapper.default.each(attrs, function (value, key) {
        this.allows(key) || errorFields.push(key);
      }, this);

      if (errorFields.length) {
        throw 'field not allowed: ' + errorFields.join(', ');
      }

      return _backbone.default.Model.prototype.set.apply(this, arguments);
    },
    get: function get(attr) {
      var schema = this['__schema__'];

      if (_underscoreWrapper.default.has(schema.derived, attr)) {
        if (schema.derived[attr].cache !== false) {
          return schema.computedProperties[attr];
        } else {
          return this.__getDerivedValue(attr);
        }
      }

      return _backbone.default.Model.prototype.get.apply(this, arguments);
    },

    /**
       * Return a shallow copy of the model's attributes for JSON stringification.
       * This can be used for persistence, serialization, or for augmentation before being sent to the server.
       * The name of this method is a bit confusing, as it doesn't actually return a JSON string —
       * but I'm afraid that it's the way that the JavaScript API for JSON.stringify works.
       *
       * See [Backbone.Model.toJSON](http://backbonejs.org/#Model-toJSON)
       *
       * @param  {Object} options
       * @return {Object}
       * @example
       * var artist = new Model({
       *   firstName: 'Wassily',
       *   lastName: 'Kandinsky'
       * });
       *
       * artist.set({birthday: 'December 16, 1866'});
       * JSON.stringify(artist); //=> {'firstName':'Wassily','lastName':'Kandinsky','birthday':'December 16, 1866'}
       */
    toJSON: function toJSON(options) {
      options || (options = {});

      var res = _underscoreWrapper.default.clone(_backbone.default.Model.prototype.toJSON.apply(this, arguments)),
          schema = this['__schema__']; // cleanup local properties


      if (!options.verbose) {
        var _context49;

        res = _underscoreWrapper.default.omit(res, (0, _keys.default)(_context49 = _underscoreWrapper.default).call(_context49, schema.local));
      } else {
        // add derived properties
        _underscoreWrapper.default.each(schema.derived, function (options, name) {
          res[name] = this.get(name);
        }, this);
      }

      if ((0, _flat.default)(this)) {
        res = unflatten(res);
      }

      return res;
    },

    /**
       * Removes all attributes from the model, including the id attribute.
       * Fires a `"change"` event unless `silent` is passed as an option.
       * Sets the default values to the model
       * @param {Object} [options]
       */
    reset: function reset(options) {
      this.clear(options);
      this.set(_underscoreWrapper.default.result(this, 'defaults'), options);
    },

    /**
       * Is the data on the model has local modifications since the last sync event?
       * @return {Boolean} is the model in sync with the server
       */
    isSynced: function isSynced() {
      return _underscoreWrapper.default.isEqual(this.__syncedData, this.toJSON());
    },

    /**
       * validate a specific field in the model.
       * @param  {String} key
       * @return {Object} returns `{fieldName: errorMessage}` if invalid, otherwise undefined.
       * @readonly
       */
    validateField: function validateField(key) {
      var schema = key && this.getPropertySchema(key);
      return schema && _validateField(schema, this.get(key));
    },

    /**
       * Runs local schema validation. Invoked internally by {@link src/framework/Model#validate|validate}.
       * @return {Object}
       * @protected
       */
    _validateSchema: function _validateSchema() {
      var _context50;

      var schema = this['__schema__'];
      return (0, _reduce.default)(_context50 = _underscoreWrapper.default).call(_context50, _underscoreWrapper.default.extend({}, schema.props, schema.local), function (memo, options, name) {
        return _underscoreWrapper.default.extend(memo, this.validateField(name) || {});
      }, {}, this);
    },
    __getDerivedValue: function __getDerivedValue(name) {
      var _context51;

      var options = this['__schema__'].derived[name];

      if (_underscoreWrapper.default.isString(options)) {
        var key = options;
        options = {
          deps: [key],
          fn: function fn() {
            return this.get(key);
          }
        };
      }

      var deps = options.deps || [];
      return options.fn.apply(this, (0, _map.default)(_context51 = _underscoreWrapper.default).call(_context51, deps, this.get, this));
    }
  }, {
    ERROR_BLANK: 'model.validation.field.blank',
    ERROR_WRONG_TYPE: 'model.validation.field.wrong.type',
    ERROR_NOT_ALLOWED: 'model.validation.field.value.not.allowed',
    ERROR_INVALID: 'model.validation.field.invalid',
    ERROR_IARRAY_UNIQUE: 'model.validation.field.array.unique',
    ERROR_INVALID_FORMAT_EMAIL: 'model.validation.field.invalid.format.email',
    ERROR_INVALID_FORMAT_URI: 'model.validation.field.invalid.format.uri',
    ERROR_INVALID_FORMAT_IPV4: 'model.validation.field.invalid.format.ipv4',
    ERROR_INVALID_FORMAT_HOSTNAME: 'model.validation.field.invalid.format.hostname',
    ERROR_STRING_STRING_MIN_LENGTH: 'model.validation.field.string.minLength',
    ERROR_STRING_STRING_MAX_LENGTH: 'model.validation.field.string.maxLength'
  });
  var _default = Model;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 38 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseCollection = _interopRequireDefault(__webpack_require__(14));

  var _BaseModel = _interopRequireDefault(__webpack_require__(15));

  var _SchemaProperty = _interopRequireDefault(__webpack_require__(19));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var parseProperties = function parseProperties(resp) {
    var _context52;

    var schemaMeta = _underscoreWrapper.default.pick(resp, 'id', 'name', 'displayName');

    var properties = (0, _map.default)(_context52 = _underscoreWrapper.default).call(_context52, resp.schema.properties, function (property, name) {
      return _underscoreWrapper.default.extend({
        name: name
      }, property);
    });

    _underscoreWrapper.default.each(properties, function (property) {
      property['__schemaMeta__'] = schemaMeta;

      if (property.__metadata) {
        property['__metadata__'] = property.__metadata;
        delete property.__metadata;
      }
    });

    return properties;
  };

  var BaseSchemaSchema = _BaseModel.default.extend({
    defaults: {
      id: undefined,
      displayName: undefined,
      name: undefined
    },
    constructor: function constructor() {
      this.properties = new _SchemaProperty.default.Collection();

      _BaseModel.default.apply(this, arguments);
    },
    getProperties: function getProperties() {
      return this.properties;
    },
    clone: function clone() {
      var model = _BaseModel.default.prototype.clone.apply(this, arguments);

      model.getProperties().set(this.getProperties().toJSON({
        verbose: true
      }));
      return model;
    },
    parse: function parse(resp) {
      var properties = parseProperties(resp);
      this.properties.set(properties, {
        parse: true
      });
      return _underscoreWrapper.default.omit(resp, 'schema');
    },
    trimProperty: function trimProperty(property) {
      return _underscoreWrapper.default.omit(property, 'name');
    },
    toJSON: function toJSON() {
      var json = _BaseModel.default.prototype.toJSON.apply(this, arguments);

      json.schema = {
        properties: {}
      };
      this.getProperties().each(function (model) {
        var property = model.toJSON();
        json.schema.properties[property.name] = this.trimProperty(property);
      }, this);
      return json;
    },
    save: function save() {
      this.getProperties().each(function (model) {
        model.cleanup();
      });
      return _BaseModel.default.prototype.save.apply(this, arguments);
    }
  });

  var BaseSchemaSchemas = _BaseCollection.default.extend({
    model: BaseSchemaSchema
  });

  var _default = {
    parseProperties: parseProperties,
    Model: BaseSchemaSchema,
    Collection: BaseSchemaSchemas
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 39 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(125);
  /***/
},
/* 40 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseRouter = _interopRequireDefault(__webpack_require__(21));

  var _SettingsModel = _interopRequireDefault(__webpack_require__(22));

  var _StateMachine = _interopRequireDefault(__webpack_require__(43));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-len: [2, 150] */


  function clean(obj) {
    var res = {};

    _underscoreWrapper.default.each(obj, function (value, key) {
      if (!_underscoreWrapper.default.isNull(value)) {
        res[key] = value;
      }
    });

    return res;
  }
  /**
   * A Controller is our application control flow component.
   *
   * Typically it will:
   * - Initialize the models, controller and main views
   * - Listen to events
   * - Create, read, update and delete models
   * - Create modal dialogs, confirmation dialogs and alert dialogs
   * - Control the application flow
   *
   * The constructor is responsible for:
   * - Create the application state object
   * - Assign or creates the application settings object
   * - Create an instance of the main view with the relevant parameters
   *
   * See:
   * [Hello World Tutorial](https://github.com/okta/courage/wiki/Hello-World),
   * [Jasmine Spec](https://github.com/okta/okta-core/blob/master/WebContent/js/test/unit/spec/shared/util/BaseController_spec.js)
   *
   * @class module:Okta.Controller
   * @param {Object} options Options Hash
   * @param {SettingsModel} [options.settings] Application Settings Model
   * @param {String} options.el a jQuery selector string stating where to attach the controller in the DOM
   */


  var _default = _BaseView.default.extend(
  /** @lends module:Okta.Controller.prototype */
  {
    constructor: function constructor(options) {
      /* eslint max-statements: [2, 15], complexity: [2, 9]*/
      options || (options = {}); // If 'state' is passed down as options, use it, else create a 'new StateMachine()'

      if (options.state instanceof _StateMachine.default || this.state instanceof _StateMachine.default) {
        this.state = options.state || this.state;
      } else {
        var stateData = _underscoreWrapper.default.defaults(clean(options.state), this.state || {});

        this.state = new _StateMachine.default(stateData);
        delete options.state;
      }

      if (options.settings) {
        this.settings = options.settings;
      } else {
        // allow the controller to live without a router
        this.settings = options.settings = new _SettingsModel.default(_underscoreWrapper.default.omit(options || {}, 'el'));
        this.listen('notification', _BaseRouter.default.prototype._notify);
        this.listen('confirmation', _BaseRouter.default.prototype._confirm);
      }

      _BaseView.default.call(this, options);

      this.listenTo(this.state, '__invoke__', function () {
        var args = _underscoreWrapper.default.toArray(arguments);

        var method = args.shift();

        if (_underscoreWrapper.default.isFunction(this[method])) {
          this[method].apply(this, args);
        }
      });

      if (this.View) {
        this.add(new this.View(this.toJSON()));
      }
    },

    /**
     * The default values of our application state
     * @type {Object}
     * @default {}
     */
    state: {},

    /**
     * The main view this controller operate on
     * @type {module:Okta.View}
     * @default null
     */
    View: null,

    /**
     * Renders the {@link module:Okta.Controller#View|main view} after the DOM is ready
     * in case the controller is the root component of the page (e.g there's no router)
     */
    render: function render() {
      var args = arguments;
      var self = this;
      (0, _jqueryWrapper.default)(function () {
        _BaseView.default.prototype.render.apply(self, args);
      });
      return this;
    },

    /**
     * Creates the view constructor options
     * @param {Object} [options] Extra options
     * @return {Object} The view constructor options
     */
    toJSON: function toJSON(options) {
      return _underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this, 'state', 'settings', 'collection', 'model'), options || {});
    },

    /**
     * Removes the child views, empty the DOM element and stop listening to events
     */
    remove: function remove() {
      this.removeChildren();
      this.stopListening();
      this.$el.empty();
      return this;
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 41 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var defaults = {
    level: 'success',
    message: 'Great Success!',
    hide: true,
    fade: 400,
    delay: 3000,
    width: 0,
    dismissable: false
  };

  var _default = _BaseView.default.extend({
    className: 'infobox infobox-confirm infobox-confirm-fixed',
    events: {
      'click .infobox-dismiss-link': function clickInfoboxDismissLink(e) {
        e.preventDefault();
        this.fadeOut();
      }
    },
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        return "<a class=\"infobox-dismiss-link\" title=\"Dismiss\" href=\"#\"><span class=\"dismiss-icon\"></span></a>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<h3>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "title",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 177
            },
            "end": {
              "line": 1,
              "column": 186
            }
          }
        }) : helper)) + "</h3>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "dismissable") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 121
            }
          }
        })) != null ? stack1 : "") + "<span class=\"icon " + alias4((helper = (helper = lookupProperty(helpers, "level") || (depth0 != null ? lookupProperty(depth0, "level") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "level",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 139
            },
            "end": {
              "line": 1,
              "column": 148
            }
          }
        }) : helper)) + "-16\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 160
            },
            "end": {
              "line": 1,
              "column": 198
            }
          }
        })) != null ? stack1 : "") + "<p>" + alias4((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "message",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 201
            },
            "end": {
              "line": 1,
              "column": 212
            }
          }
        }) : helper)) + "</p>";
      },
      "useData": true
    }),
    initialize: function initialize() {
      this.options = _underscoreWrapper.default.defaults({}, this.options, defaults);
      this.$el.addClass('infobox-' + this.options.level);

      if (this.options.width) {
        this.$el.width(this.options.width).css({
          'margin-left': '0px',
          left: Math.round(((0, _jqueryWrapper.default)(window).width() - this.options.width) / 2)
        });
      }
    },
    getTemplateData: function getTemplateData() {
      return _underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this.options, 'level', 'message', 'title'), {
        dismissable: this.options.hide === false || this.options.dismissable === true
      });
    },
    postRender: function postRender() {
      if (this.options.hide) {
        var _context53;

        _underscoreWrapper.default.delay((0, _bind.default)(_context53 = _underscoreWrapper.default).call(_context53, this.fadeOut, this), this.options.delay);
      }
    },
    fadeOut: function fadeOut() {
      var _context54;

      this.$el.fadeOut(this.options.fade, (0, _bind.default)(_context54 = _underscoreWrapper.default).call(_context54, this.remove, this));
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 42 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta/no-specific-methods: 0 */

  /**
   * @class module:Okta.internal.util.TemplateUtil
   * @hideconstructor
   */


  var _default =
  /** @lends module:Okta.internal.util.TemplateUtil */
  {
    /**
     * Compiles a Handlebars template
     * @static
     * @method
     */
    // TODO: This will be deprecated at some point. Views should use precompiled templates
    tpl: _underscoreWrapper.default.memoize(function (tpl) {
      /* eslint okta/no-specific-methods: 0 */
      // Handlebars 4.6.x introduced a breaking change with prototype/own values. If a kill-switch
      // is enabled - fallback to prior implementation logic. OKTA-297682
      var runtimeOptions = {};

      if (window && window.__OKTA_HANDLEBARS_FALLBACK__) {
        runtimeOptions.allowProtoPropertiesByDefault = true;
      }

      return function (context) {
        return _handlebars.default.compile(tpl)(context, runtimeOptions);
      };
    })
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 43 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Model = _interopRequireDefault(__webpack_require__(11));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * @class StateMachine
   * @extends Okta.Model
   * @private
   *
   * A state object that holds the applciation state
   */


  var _default = _Model.default.extend({
    extraProperties: true,

    /**
     * Invokes a method on the applicable {@link Okta.Controller}
     *
     * ```javascript
     * state.invoke('methodName', 'param1', 'param2')
     * // Will call
     * contoller.methodName('param1', 'param2')
     * ```
     * @param {String} methodName the name of the controller method to invoke on the controller
     */
    invoke: function invoke() {
      var args = _underscoreWrapper.default.toArray(arguments);

      args.unshift('__invoke__');
      this.trigger.apply(this, args);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 44 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _ViewUtil = _interopRequireDefault(__webpack_require__(24));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var disabledEvents = {
    click: function click(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  /**
   * A configurable button
   * @class module:Okta.internal.views.components.BaseButtonLink
   * @extends module:Okta.View
   * @example
   * var View = BaseButtonLink.extend({
   *   title: 'Click Me',
   *   icon: 'help-text'
   * })
   */

  var _default = _BaseView.default.extend(
  /** @lends module:Okta.internal.views.components.BaseButtonLink.prototype */
  {
    attributes: function attributes() {
      var defaultAttrs = {
        'data-se': 'button'
      };

      var additionalAttr = this.__getAttribute('attrs');

      return _underscoreWrapper.default.extend(defaultAttrs, additionalAttr);
    },

    /**
     * The main text for the button
     * @name title
     * @memberof module:Okta.internal.views.components.BaseButtonLink
     * @type {(String|Function)}
     * @instance
     */

    /**
     * The link for the button
     * @name href
     * @memberof module:Okta.internal.views.components.BaseButtonLink
     * @type {(String|Function)}
     * @instance
     */

    /**
     * CSS class for the icon to display. See [Style guide](http://rain.okta1.com:1802/su/dev/style-guide#icons)
     * @name icon
     * @memberof module:Okta.internal.views.components.BaseButtonLink
     * @type {(String|Function)}
     * @instance
     */

    /**
     * A [Backbone events](http://backbonejs.org/#View-delegateEvents) hash
     * @name events
     * @memberof module:Okta.internal.views.components.BaseButtonLink
     * @type {Object}
     * @instance
     */
    tagName: 'a',
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "icon",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 30
            },
            "end": {
              "line": 1,
              "column": 38
            }
          }
        }) : helper)) + "\"></span>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "title",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 67
            },
            "end": {
              "line": 1,
              "column": 76
            }
          }
        }) : helper));
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 54
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 54
            },
            "end": {
              "line": 1,
              "column": 83
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),

    /**
     * Make this button visible, default to true.
     * @type {(Boolean|Function)}
     * @default true
     */
    visible: true,

    /**
     * Make this button enabled, default to true.
     * @type {(Boolean|Function)}
     * @default true
     */
    enabled: true,

    /**
     * The setting to determine when the button is enabled, default to {} and
     * enabled takes a higher priority.
     * @type {(Object|Function)}
     * @default {}
     */
    enableWhen: {},

    /**
     * The setting to determine when the button is visible, default to {} and
     * visible takes a higher priority.
     * @type {(Object|Function)}
     * @default {}
     */
    showWhen: {},
    constructor: function constructor(options) {
      this.options = options || {};
      var data = this.getTemplateData();
      this.disabled = false;

      _BaseView.default.apply(this, arguments);

      this.$el.addClass('link-button');

      if (data.icon) {
        this.$el.addClass('link-button-icon');

        if (!data.title) {
          this.$el.addClass('icon-only');
        }
      }
    },
    getTemplateData: function getTemplateData() {
      return {
        href: this.__getAttribute('href'),
        title: this.__getAttribute('title'),
        icon: this.__getAttribute('icon')
      };
    },
    initialize: function initialize() {
      _ViewUtil.default.applyDoWhen(this, _underscoreWrapper.default.resultCtx(this, 'enableWhen', this), this.toggle);

      _ViewUtil.default.applyDoWhen(this, _underscoreWrapper.default.resultCtx(this, 'showWhen', this), this.toggleVisible);
    },
    render: function render() {
      _BaseView.default.prototype.render.apply(this, arguments);

      if (!_underscoreWrapper.default.result(this, 'enabled')) {
        this.toggle(false);
      }

      if (!_underscoreWrapper.default.result(this, 'visible')) {
        this.toggleVisible(false);
      }

      var data = this.getTemplateData();
      this.$el.attr('href', data.href || '#');
      return this;
    },
    __getAttribute: function __getAttribute(name, defaultValue) {
      var value = _underscoreWrapper.default.resultCtx(this.options, name, this);

      if (_underscoreWrapper.default.isUndefined(value)) {
        value = _underscoreWrapper.default.result(this, name);
      }

      return !_underscoreWrapper.default.isUndefined(value) ? value : defaultValue;
    },
    enable: function enable() {
      this.toggle(true);
    },
    disable: function disable() {
      this.toggle(false);
    },
    show: function show() {
      this.toggleVisible(true);
    },
    hide: function hide() {
      this.toggleVisible(false);
    },
    toggle: function toggle(enable) {
      var bool = !!enable && _underscoreWrapper.default.result(this, 'enabled'); //this is to toggle the enability


      this.disabled = !bool;
      this.$el.toggleClass('link-button-disabled btn-disabled disabled', this.disabled);
      this.delegateEvents(this.disabled ? disabledEvents : null);
    },
    toggleVisible: function toggleVisible(visible) {
      var hidden = !visible || !_underscoreWrapper.default.result(this, 'visible');
      this.$el.toggleClass('hide', hidden);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 45 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function Class(options) {
    this.options = _underscoreWrapper.default.clone(options || {});
    this.cid = _underscoreWrapper.default.uniqueId('class');
    this.initialize.apply(this, arguments);
  }

  _underscoreWrapper.default.extend(Class.prototype, _backbone.default.Events, {
    initialize: function initialize() {}
  });

  Class.extend = _backbone.default.Model.extend;
  var _default = Class;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 46 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _js = _interopRequireDefault(__webpack_require__(47));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SECURED_COOKIE = /^https/.test(window.location.href);
  var _default = {
    setCookie: function setCookie(name, value, options) {
      _js.default.set(name, value, _underscoreWrapper.default.defaults(options || {}, {
        secure: SECURED_COOKIE,
        path: '/'
      }));
    },
    getCookie: function getCookie() {
      return _js.default.get.apply(_js.default, arguments);
    },
    removeCookie: function removeCookie() {
      return _js.default.remove.apply(_js.default, arguments);
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 47 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }
  /*!
   * JavaScript Cookie v2.1.0
   * https://github.com/js-cookie/js-cookie
   *
   * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
   * Released under the MIT license
   */


  (function (factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
      module.exports = factory();
    } else {
      var _OldCookies = window.Cookies;
      var api = window.Cookies = factory();

      api.noConflict = function () {
        window.Cookies = _OldCookies;
        return api;
      };
    }
  })(function () {
    function extend() {
      var i = 0;
      var result = {};

      for (; i < arguments.length; i++) {
        var attributes = arguments[i];

        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }

      return result;
    }

    function init(converter) {
      function api(key, value, attributes) {
        var result; // Write

        if (arguments.length > 1) {
          attributes = extend({
            path: '/'
          }, api.defaults, attributes);

          if (typeof attributes.expires === 'number') {
            var expires = new Date();
            expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
            attributes.expires = expires;
          }

          try {
            result = (0, _stringify.default)(value);

            if (/^[\{\[]/.test(result)) {
              value = result;
            }
          } catch (e) {}

          if (!converter.write) {
            value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
          } else {
            value = converter.write(value, key);
          }

          key = encodeURIComponent(String(key));
          key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
          key = key.replace(/[\(\)]/g, escape);
          return document.cookie = [key, '=', value, attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
          attributes.path && '; path=' + attributes.path, attributes.domain && '; domain=' + attributes.domain, attributes.secure ? '; secure' : ''].join('');
        } // Read


        if (!key) {
          result = {};
        } // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all. Also prevents odd result when
        // calling "get()"


        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var rdecode = /(%[0-9A-Z]{2})+/g;
        var i = 0;

        for (; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var name = parts[0].replace(rdecode, decodeURIComponent);
          var cookie = (0, _slice.default)(parts).call(parts, 1).join('=');

          if (cookie.charAt(0) === '"') {
            cookie = (0, _slice.default)(cookie).call(cookie, 1, -1);
          }

          try {
            cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);

            if (this.json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
            }

            if (key === name) {
              result = cookie;
              break;
            }

            if (!key) {
              result[name] = cookie;
            }
          } catch (e) {}
        }

        return result;
      }

      api.get = api.set = api;

      api.getJSON = function () {
        return api.apply({
          json: true
        }, (0, _slice.default)([]).call(arguments));
      };

      api.defaults = {};

      api.remove = function (key, attributes) {
        api(key, '', extend(attributes, {
          expires: -1
        }));
      };

      api.withConverter = init;
      return api;
    }

    return init(function () {});
  });
  /***/

},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  __webpack_require__(49);

  __webpack_require__(50);

  __webpack_require__(51);

  __webpack_require__(52);

  __webpack_require__(53);

  __webpack_require__(55);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  } // Handlebars "wrapper" is used by frontend code. It contains all helpers.
  // This runs in a browser / webpacked environment
  // TODO: Once all templates are precompiled, this file should use handlebars/runtime

  /* eslint @okta/okta/no-specific-modules: 0 */
  // from vendor/lib


  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 49 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var clonedEscapeExpression = _handlebars.default.Utils.escapeExpression;

  _handlebars.default.Utils.escapeExpression = function (string) {
    return clonedEscapeExpression(string).replace(/&#x3D;/g, '=');
  };

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 50 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _moment = _interopRequireDefault(__webpack_require__(23));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta/enforce-requirejs-names: 0, @okta/okta/no-specific-modules: 0, max-params: 0, max-statements: 0 */


  function formatDate(format, dateInISOString) {
    return _moment.default.utc(dateInISOString).utcOffset('-07:00').format(format);
  }

  _handlebars.default.registerHelper('shortDate', _underscoreWrapper.default.partial(formatDate, 'MMM Do'));

  _handlebars.default.registerHelper('mediumDate', _underscoreWrapper.default.partial(formatDate, 'MMMM DD, YYYY'));

  _handlebars.default.registerHelper('longDate', _underscoreWrapper.default.partial(formatDate, 'MMMM DD, YYYY, h:mma'));

  _handlebars.default.registerHelper('formatDate', formatDate);

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 51 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta/no-specific-modules: 0 */


  function trim(str) {
    return str && str.replace(/^\s+|\s+$/g, '');
  }

  _handlebars.default.registerHelper('i18n', function (options) {
    var params;
    var key = trim(options.hash.code);
    var bundle = trim(options.hash.bundle);
    var args = trim(options.hash['arguments']);

    if (args) {
      var _context55;

      params = (0, _map.default)(_context55 = _underscoreWrapper.default).call(_context55, trim(args).split(';'), function (param) {
        param = trim(param);
        var val;
        var data = this;
        /*
        * the context(data) may be a deep object, ex {user: {name: 'John', gender: 'M'}}
        * arguments may be 'user.name'
        * return data['user']['name']
        */

        _underscoreWrapper.default.each(param.split('.'), function (p) {
          val = val ? val[p] : data[p];
        });

        return val;
      }, this);
    }

    return _StringUtil.default.localize(key, bundle, params);
  });

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 52 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta/no-specific-modules: 0 */


  var CACHE_BUST_URL_PREFIX = '/assets';

  function prependCachebustPrefix(path) {
    if ((0, _indexOf.default)(path).call(path, CACHE_BUST_URL_PREFIX) === 0) {
      return path;
    }

    return CACHE_BUST_URL_PREFIX + path;
  }

  _handlebars.default.registerHelper('img', function (options) {
    var _context56;

    var cdn = typeof okta !== 'undefined' && okta.cdnUrlHostname || '';
    /*global okta */

    var hash = _underscoreWrapper.default.pick(options.hash, ['src', 'alt', 'width', 'height', 'class', 'title']);

    hash.src = '' + cdn + prependCachebustPrefix(hash.src);
    var attrs = (0, _map.default)(_context56 = _underscoreWrapper.default).call(_context56, hash, function (value, attr) {
      return attr + '="' + (attr === 'src' ? encodeURI(value) : _handlebars.default.Utils.escapeExpression(value)) + '"';
    });
    return new _handlebars.default.SafeString('<img ' + attrs.join(' ') + '/>');
  });

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 53 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _markdownToHtml = _interopRequireDefault(__webpack_require__(54));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta/no-specific-modules: 0 */


  _handlebars.default.registerHelper('markdown', function (mdText) {
    return (0, _markdownToHtml.default)(_handlebars.default, mdText);
  });

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 54 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = mdToHtml;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  } // Simple "markdown parser" - just handles markdown formatted links. If we
  // find that we need more extensive markdown support, we should include
  // a fully formulated markdown library like:
  // https://github.com/evilstreak/markdown-js


  var RE_LINK = /\[[^\]]*\]\([^)]*\)/gi;
  var RE_LINK_HREF = /\]\(([^)]*)\)/i;
  var RE_LINK_TEXT = /\[([^\]]*)\]/i;
  var RE_LINK_JS = /javascript:/gi; // Converts links
  // FROM:
  // [some link text](http://the/link/url)
  // TO:
  // <a href="http://the/link/url">some link text</a>

  function mdToHtml(Handlebars, markdownText) {
    // TODO: use precompiled templates OKTA-309852
    // eslint-disable-next-line @okta/okta-ui/no-bare-templates
    var linkTemplate = Handlebars.compile('<a href="{{href}}">{{text}}</a>');
    /* eslint  @okta/okta/no-specific-methods: 0*/

    var res;

    if (!_underscoreWrapper.default.isString(markdownText)) {
      res = '';
    } else {
      res = Handlebars.Utils.escapeExpression(markdownText).replace(RE_LINK_JS, '').replace(RE_LINK, function (mdLink) {
        return linkTemplate({
          href: mdLink.match(RE_LINK_HREF)[1],
          text: mdLink.match(RE_LINK_TEXT)[1]
        });
      });
    }

    return new Handlebars.SafeString(res);
  }

  module.exports = exports.default;
  /***/
},
/* 55 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta/no-specific-modules: 0 */


  _handlebars.default.registerHelper('xsrfTokenInput', function () {
    return new _handlebars.default.SafeString('<input type="hidden" class="hide" name="_xsrfToken" ' + 'value="' + (0, _jqueryWrapper.default)('#_xsrfToken').text() + '">');
  });

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 56 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _ListView = _interopRequireDefault(__webpack_require__(57));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * See {@link src/framework/ListView} for more detail and examples from the base class.
   * @class module:Okta.ListView
   * @extends src/framework/ListView
   * @mixes module:Okta.View
   */


  var _default = _BaseView.default.decorate(_ListView.default);

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 57 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _View = _interopRequireDefault(__webpack_require__(16));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint-disable max-statements */

  /**
     * Archer.ListView is a {@link src/framework/View} that operates on a
     * collection and builds a list of "things" of the same type.
     *
     * Automagically adds, removes and sorts upon standard collection events.
     *
     * Listen to collection events so the ListView will do the right thing when
     * a model is added or the collection is reset or sorted.
     *
     * @class src/framework/ListView
     * @extends src/framework/View
     * @param {Object} options options hash
     * @param {Object} options.collection The collection which this view operates on
     * @example
     * var UserList = Archer.ListView.extend({
     *   tagName: 'ul',
     *   item: '<li>{{fname}} {{lname}}</li>'
     * });
     *
     * var users = new Archer.Collection([
     *   {fname: 'John', lname: 'Doe'},
     *   {fname: 'Jane', lname: 'Doe'}
     * ]);
     *
     * var userList = new UserList({collection: users}).render();
     * userList.el; //=> "<ul><li>John Doe</li><li>Jane Doe</li></ul>"
     *
     * users.push({fname: 'Jim', lname: 'Doe'});
     * userList.el; //=> "<ul><li>John Doe</li><li>Jane Doe</li><li>Jim Doe</li></ul>"
     *
     * users.first().destroy();
     * userList.el; //=> "<ul><li>Jane Doe</li><li>Jim Doe</li></ul>"
     */


  var _default = _View.default.extend(
  /** @lends src/framework/ListView.prototype */
  {
    constructor: function constructor() {
      _View.default.apply(this, arguments);

      if (!this.collection) {
        throw new Error('Missing collection');
      }

      this.listenTo(this.collection, 'reset sort', this.reset);
      this.listenTo(this.collection, 'add', this.addItem);

      if (this.fetchCollection) {
        this.collection.fetch();
      } else {
        this.collection.each(this.addItem, this);
      }
    },

    /**
       * The view/template we will use to render each model in the collection.
       * @type {String|module:Okta.View}
       */
    item: null,

    /**
       * A selector in the local template where to append each item
       * @type {String}
       */
    itemSelector: null,

    /**
       * Empty the list and re-add everything from the collection.
       * Usefull for handling `collection.reset()` or for handling the initial load
       * @protected
       */
    reset: function reset() {
      var _this = this;

      this.removeChildren();
      this.collection.each(function (model, index) {
        _this.addItem(model, index);
      });
      return this;
    },

    /**
       * Add an item view to the list that will represent one model from the collection
       *
       * Listen to the model so when it is destoyed or removed from the collection
       * this item will remove itself from the list
       *
       * @param {Backbone.Model} model The model this row operates on
       * @protected
       */
    addItem: function addItem(model) {
      var view = this.add(this.item, this.itemSelector, {
        options: {
          model: model
        }
      }).last();

      if (this.state && this.state.get('trackItemAdded')) {
        this.state.trigger('itemAdded', view);
      }

      view.listenTo(model, 'destroy remove', view.remove);
      return this;
    },
    addShowMore: _underscoreWrapper.default.noop
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 58 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var optionsTemplate = _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "icon",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 96
          },
          "end": {
            "line": 1,
            "column": 104
          }
        }
      }) : helper)) + "\"></span>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 133
          },
          "end": {
            "line": 1,
            "column": 142
          }
        }
      }) : helper));
    },
    "5": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"option-subtitle\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "subtitle",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 192
          },
          "end": {
            "line": 1,
            "column": 204
          }
        }
      }) : helper)) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"\" class=\"icon-16 " + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 26
          },
          "end": {
            "line": 1,
            "column": 39
          }
        }
      }) : helper)) + "\" data-se=\"" + alias4((helper = (helper = lookupProperty(helpers, "seleniumId") || (depth0 != null ? lookupProperty(depth0, "seleniumId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "seleniumId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 50
          },
          "end": {
            "line": 1,
            "column": 64
          }
        }
      }) : helper)) + "\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 66
          },
          "end": {
            "line": 1,
            "column": 120
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 120
          },
          "end": {
            "line": 1,
            "column": 149
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 149
          },
          "end": {
            "line": 1,
            "column": 215
          }
        }
      })) != null ? stack1 : "") + "</a>";
    },
    "useData": true
  });

  var BaseDropDownDropDownOption = _BaseView.default.extend({
    tagName: 'li',
    events: {
      click: function click(e) {
        e.preventDefault();
        this.action && this.action.call(this);
      }
    },
    constructor: function constructor() {
      _BaseView.default.apply(this, arguments);

      this.$el.addClass('okta-dropdown-option option');
    },
    render: function render() {
      this.$el.html(optionsTemplate({
        icon: _underscoreWrapper.default.result(this, 'icon'),
        className: _underscoreWrapper.default.result(this, 'className') || '',
        title: _underscoreWrapper.default.result(this, 'title'),
        subtitle: _underscoreWrapper.default.result(this, 'subtitle'),
        seleniumId: _underscoreWrapper.default.result(this, 'seleniumId')
      }));

      if (_underscoreWrapper.default.result(this, 'disabled')) {
        this.disable();
      }

      return this;
    },
    disable: function disable() {
      var _context57;

      this.$el.addClass('option-disabled');
      (0, _find.default)(_context57 = this.$el).call(_context57, 'a').attr('tabindex', '-1');
    }
  });

  var _default = _BaseView.default.extend({
    events: {
      'click a.option-selected': function clickAOptionSelected(e) {
        e.preventDefault();

        if (_underscoreWrapper.default.result(this, 'disabled')) {
          e.stopPropagation();
        }
      },
      'click .dropdown-disabled': function clickDropdownDisabled(e) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    items: [],
    constructor: function constructor() {
      var className = this.className; // In this very specific case we want to NOT append className to $el
      // but to the <a> tag in the template
      // so we want to disable backbone default functionality.

      this.className = null;

      _BaseView.default.apply(this, arguments);

      this.className = className;
      this.$el.addClass('dropdown more-actions float-l');

      _underscoreWrapper.default.each(_underscoreWrapper.default.result(this, 'items'), function (option) {
        this.addOption(option, this.options);
      }, this);
    },
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "icon",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 176
            },
            "end": {
              "line": 1,
              "column": 184
            }
          }
        }) : helper)) + "\"></span>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"off-screen\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "screenReaderText") || (depth0 != null ? lookupProperty(depth0, "screenReaderText") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "screenReaderText",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 249
            },
            "end": {
              "line": 1,
              "column": 269
            }
          }
        }) : helper)) + "</span>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link-button " + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "className",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 31
            },
            "end": {
              "line": 1,
              "column": 44
            }
          }
        }) : helper)) + " link-button-icon option-selected center\" aria-expanded=\"false\" aria-controls=\"okta-dropdown-options\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 146
            },
            "end": {
              "line": 1,
              "column": 200
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "screenReaderText") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 200
            },
            "end": {
              "line": 1,
              "column": 283
            }
          }
        })) != null ? stack1 : "") + "<span class=\"option-selected-text\">" + alias4((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "title",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 318
            },
            "end": {
              "line": 1,
              "column": 327
            }
          }
        }) : helper)) + "</span><span class=\"icon-dm\"></span></a><div id=\"okta-dropdown-options\" class=\"options clearfix\" style=\"display: none;\"><ul class=\"okta-dropdown-list options-wrap clearfix\"></ul></div>";
      },
      "useData": true
    }),
    getTemplateData: function getTemplateData() {
      var _context58;

      var className = [_underscoreWrapper.default.result(this, 'className') || '', _underscoreWrapper.default.result(this, 'disabled') ? 'dropdown-disabled' : ''];
      return {
        icon: _underscoreWrapper.default.result(this, 'icon'),
        className: (0, _trim.default)(_context58 = _jqueryWrapper.default).call(_context58, className.join(' ')),
        title: _underscoreWrapper.default.result(this, 'title'),
        screenReaderText: _underscoreWrapper.default.result(this, 'screenReaderText')
      };
    },
    addOption: function addOption(proto, options) {
      this.add(BaseDropDownDropDownOption.extend(proto), 'ul.options-wrap', {
        options: options || {}
      });
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 59 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _ReadModeBar = _interopRequireDefault(__webpack_require__(60));

  var _Toolbar = _interopRequireDefault(__webpack_require__(25));

  var _ErrorBanner = _interopRequireDefault(__webpack_require__(61));

  var _ErrorParser = _interopRequireDefault(__webpack_require__(62));

  var _FormUtil = _interopRequireDefault(__webpack_require__(10));

  var _InputContainer = _interopRequireDefault(__webpack_require__(63));

  var _InputFactory = _interopRequireDefault(__webpack_require__(64));

  var _InputLabel = _interopRequireDefault(__webpack_require__(65));

  var _InputWrapper = _interopRequireDefault(__webpack_require__(66));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-statements: [2, 11] */


  var template = _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h2 class=\"o-form-title-bar\" data-se=\"o-form-title-bar\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 75
          },
          "end": {
            "line": 1,
            "column": 84
          }
        }
      }) : helper)) + "</h2>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(4, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 192
          },
          "end": {
            "line": 1,
            "column": 288
          }
        }
      })) != null ? stack1 : "";
    },
    "4": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h2 data-se=\"o-form-head\" class=\"okta-form-title o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 267
          },
          "end": {
            "line": 1,
            "column": 276
          }
        }
      }) : helper)) + "</h2>";
    },
    "6": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"okta-form-subtitle o-form-explain\" data-se=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "subtitle",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 385
          },
          "end": {
            "line": 1,
            "column": 397
          }
        }
      }) : helper)) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "hasReadMode") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 96
          }
        }
      })) != null ? stack1 : "") + "<div data-se=\"o-form-content\" class=\"o-form-content " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "layout") || (depth0 != null ? lookupProperty(depth0, "layout") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "layout",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 148
          },
          "end": {
            "line": 1,
            "column": 158
          }
        }
      }) : helper)) + " clearfix\">" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "hasReadMode") : depth0, {
        "name": "unless",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 169
          },
          "end": {
            "line": 1,
            "column": 299
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(6, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 299
          },
          "end": {
            "line": 1,
            "column": 408
          }
        }
      })) != null ? stack1 : "") + "<div class=\"o-form-error-container\" data-se=\"o-form-error-container\"></div><div class=\"o-form-fieldset-container\" data-se=\"o-form-fieldset-container\"></div></div>";
    },
    "useData": true
  });

  var sectionTitleTemplate = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h2 class=\"o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 24
          },
          "end": {
            "line": 1,
            "column": 33
          }
        }
      }) : helper)) + "</h2>";
    },
    "useData": true
  });

  var pointerEventsSupported = (0, _jqueryWrapper.default)('<div>').css({
    'pointer-events': 'auto'
  })[0].style.pointerEvents === 'auto'; // polyfill for `pointer-events: none;` in IE < 11
  // Logic borrowed from https://github.com/kmewhort/pointer_events_polyfill (BSD)

  function pointerEventsPolyfill(e) {
    if (!pointerEventsSupported && this.$el.hasClass('o-form-saving')) {
      var $el = (0, _jqueryWrapper.default)(e.currentTarget);
      $el.css('display', 'none');
      var underneathElem = document.elementFromPoint(e.clientX, e.clientY);
      $el.css('display', 'block');
      e.target = underneathElem;
      (0, _jqueryWrapper.default)(underneathElem).trigger(e);
      return false;
    }
  }

  var events = {
    submit: function submit(e) {
      e.preventDefault();

      this.__save();
    }
  };

  _underscoreWrapper.default.each(['click', 'dblclick', 'mousedown', 'mouseup'], function (event) {
    events[event + ' .o-form-input'] = pointerEventsPolyfill;
  });

  var attributes = function attributes(model) {
    model || (model = {});
    var collection = model && model.collection || {};
    return {
      method: 'POST',
      action: _underscoreWrapper.default.result(model, 'urlRoot') || _underscoreWrapper.default.result(collection, 'url') || window.location.pathname,
      'data-se': 'o-form',
      slot: 'content'
    };
  };

  var convertSavingState = function convertSavingState(rawSavingStateEvent, defaultEvent) {
    rawSavingStateEvent || (rawSavingStateEvent = '');
    var savingStateEvent = [];

    if (_underscoreWrapper.default.isString(rawSavingStateEvent)) {
      savingStateEvent = rawSavingStateEvent.split(' ');
    }

    savingStateEvent = _underscoreWrapper.default.union(savingStateEvent, defaultEvent);
    return savingStateEvent.join(' ');
  };

  var getErrorSummary = function getErrorSummary() {
    var responseJSON = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if ((0, _isArray.default)(responseJSON.errorCauses) && responseJSON.errorCauses.length > 0) {
      //set errorSummary from first errorCause which is not field specific error
      return responseJSON.errorCauses[0].errorSummary;
    } else {
      //set errorSummary from top level errorSummary
      return responseJSON.errorSummary;
    }
  };
  /**
   * A Form utility framework
   *
   * Okta.Form is a form that operates on one flat model
   * It exposes one main factory method, {@link module:Okta.Form#addInput|addInput}, which add inputs to the form,
   * and each input operates on one field in the model, identified by the `name` field.
   *
   * See:
   * [Basic O-Form Tutorial](https://github.com/okta/courage/wiki/Basic-O-Form)
   *
   * @class module:Okta.Form
   * @extends module:Okta.View
   * @param {Object} options options hash (See {@link module:Okta.View|View})
   * @param {Object} options.model the model this form operates on
   * @param {Boolean} [options.label-top=false] position label on top of inputs
   * @param {Boolean} [options.wide=false] Use a wide input layout for all input
   */

  /**
   * Fired when the "Save" button is clicked
   * @event module:Okta.Form#save
   * @param {module:Okta.Model} model Model used in the form
   */

  /**
   * Fired after the model is successfully saved - applies when {@link module:Okta.Form#autoSave|autoSave}
   * is set to true
   * @event module:Okta.Form#saved
   * @param {module:Okta.Model} model Model used in the form
   */

  /**
   * Fired when the model fires an invalid event or an error event;
   * @event module:Okta.Form#error
   * @param {module:Okta.Model} model Model used in the form
   */

  /**
   * Fired when the form layout is likely to be resized
   * @event module:Okta.Form#resize
   * @param {module:Okta.Model} model Model used in the form
   */

  /**
   * Fired when the "Cancel" button is clicked
   * @event module:Okta.Form#cancel
   */


  var _default = _BaseView.default.extend(
  /** @lends module:Okta.Form.prototype */
  {
    /**
     * Specifies how to validate form:
     * - In case "local" string provided as a value of the property,
     * the form will validate only fields added as inputs to the form;
     * - In case array is provided, the validation will be performed only for fields specified in array;
     * - In case function is provided, provided function will be used as a validation function,
     * it must return an error object with the format {fieldName: 'error text'} with as many fields as you need.
     * @name validate
     * @memberof module:Okta.Form
     * @type {String|Array|Function}
     * @instance
     */
    constructor: function constructor(options) {
      /* eslint max-statements: 0, complexity: 0 */
      options || (options = {});
      this.options = options;
      this.id = _underscoreWrapper.default.uniqueId('form');
      this.tagName = 'form';

      _underscoreWrapper.default.defaults(this.events, events);

      _underscoreWrapper.default.defaults(this.attributes, attributes(options.model));

      this.__buttons = [];
      this.__errorFields = {};

      this.__saveModelState(options.model);

      if (this.step) {
        if (!this.save) {
          this.save = !this.totalSteps || this.step === this.totalSteps ? 'Finish' : 'Next';
        }

        this.className += ' wizard';
      }

      this.className += ' o-form';
      this.__toolbar = this.__createToolbar(options);

      _BaseView.default.call(this, options);

      _underscoreWrapper.default.each(_underscoreWrapper.default.result(this, 'inputs') || [], function (input) {
        // to ingore extra argumests from `each` iteratee function
        // http://underscorejs.org/#each
        this.__addLayoutItem(input);
      }, this);

      this.add(this.__toolbar, '');
      this.listenTo(this.model, 'change:__edit__', this.__applyMode);
      this.listenTo(this.model, 'invalid error', _underscoreWrapper.default.throttle(function (model, resp, showBanner) {
        this.__showErrors(model, resp, showBanner !== false);
      }, 100, {
        trailing: false
      }));
      this.listenTo(this.model, 'form:resize', function () {
        this.trigger('resize');
      });
      this.listenTo(this.model, 'form:cancel', _underscoreWrapper.default.throttle(this.__cancel, 100, {
        trailing: false
      }));
      this.listenTo(this.model, 'form:previous', _underscoreWrapper.default.throttle(this.__previous, 100, {
        trailing: false
      }));
      this.__save = _underscoreWrapper.default.throttle(this.__save, 200, {
        trailing: false
      });
      this.listenTo(this.model, 'form:save', function () {
        this.$el.submit();
      });
      this.listenTo(this.model, 'sync', function () {
        if (this.model.get('__edit__')) {
          this.model.set('__edit__', false, {
            silent: true
          });
        }

        this.__saveModelState(this.model);

        this.render();
      });
      var hasSavingState = this.getAttribute('hasSavingState');

      if (this.getAttribute('autoSave')) {
        this.listenTo(this, 'save', function (model) {
          var _this = this;

          var xhr = model.save();

          if (xhr && xhr.done) {
            xhr.done(function () {
              _this.trigger('saved', model);
            });
          }
        });

        if (_underscoreWrapper.default.isUndefined(hasSavingState)) {
          hasSavingState = true;
        }
      }
      /*
      * Attach model event listeners
      * by default, model's request event starts the form saving state,
      * error and sync event stops it
      * you can define customized saving start and stop state, like
      * customSavingState: {start: 'requestingAdditionalInfo', stop: 'retrievedAdditionalInfo'}
      * doing this does not override the default events
      */


      if (hasSavingState) {
        var customSavingState = this.getAttribute('customSavingState', {});
        this.listenTo(this.model, convertSavingState(customSavingState.start || '', ['request']), this.__setSavingState);
        this.listenTo(this.model, convertSavingState(customSavingState.stop || '', ['error', 'sync']), this.__clearSavingState);
      }
    },

    /**
     * Create the bottom button bar
     * @param  {Object} options options h
     * @return {Okta.View} The toolbar
     * @private
     */
    __createToolbar: function __createToolbar(options) {
      var danger = this.getAttribute('danger');
      var saveBtnClassName = danger === true ? 'button-error' : 'button-primary';
      var toolbar = new _Toolbar.default(_underscoreWrapper.default.extend({
        save: this.save || _StringUtil.default.localize('oform.save', 'courage'),
        saveId: this.saveId,
        saveClassName: saveBtnClassName,
        cancel: this.cancel || _StringUtil.default.localize('oform.cancel', 'courage'),
        noCancelButton: this.noCancelButton || false,
        noSubmitButton: this.noSubmitButton || false,
        hasPrevStep: this.step && this.step > 1
      }, options || this.options));

      _underscoreWrapper.default.each(this.__buttons, function (args) {
        toolbar.addButton.apply(toolbar, args);
      });

      return toolbar;
    },
    className: '',
    attributes: {},
    events: {},

    /**
     * An array of input configurations to render in the form
     * @type {Array}
     */
    inputs: [],
    template: null,

    /**
     * Does the form support read/edit toggle.
     * @type {Boolean|Function}
     * @default false
     */
    read: false,

    /**
     * Is the form in readOnly mode.
     * @type {Boolean|Function}
     * @default false
     */
    readOnly: false,

    /**
     * Should we not render the button bar
     * @type {Boolean|Function}
     * @default false
     */
    noButtonBar: false,

    /**
     * Should we not render a cancel button
     * @type {Boolean|Function}
     * @default false
     */
    noCancelButton: false,

    /**
     * Should we not render a save button
     * @type {Boolean}
     * @default false
     */
    noSubmitButton: false,

    /**
     * The text on the save button
     * @type {String}
     * @default "Save"
     */
    save: null,

    /**
     * The text on the cancel button
     * @type {String}
     * @default "Cancel"
     */
    cancel: null,

    /**
     * To use button-error to style the submit button instead of button-primary.
     * @type {Boolean|Function}
     * @default false
     */
    danger: false,

    /**
     * A layout CSS class to add to the form
     * @type {String|Function}
     * @default ""
     */
    layout: '',

    /**
     * The step this form is in the context of a wizard
     * @type {Number}
     */
    step: undefined,

    /**
     * The total numbers of steps the wizard this form is a part of has
     * @type {Number}
     */
    totalSteps: undefined,

    /**
     * The form's title
     * @type {String|Function}
     */
    title: null,

    /**
     * The form's subtitle
     * @type {String|Function}
     */
    subtitle: null,

    /**
     * Auto-save the model when hitting save. Triggers a `saved` event when done
     * @type {Boolean}
     * @default false
     */
    autoSave: false,

    /**
     * Scroll to the top of the form on error
     * @type {Boolean|Function}
     * @default true
     */
    scrollOnError: true,

    /**
     * Show the error banner upon error
     * @type {Boolean|Function}
     * @default true
     */
    showErrors: true,

    /**
     * The form's scrollable area
     * @type {String}
     * @default ".o-form-content"
     */
    resizeSelector: '.o-form-content',

    /**
     * Sets whether or not the form shows the saving state when
     * the model is saved.  Has no effect on setSavingState and clearSavingState as those are manual calls
     * to trigger/clear the saving state.
     * @name hasSavingState
     * @memberof module:Okta.Form
     * @type {Boolean}
     * @default false
     * @instance
     */

    /**
     * Get an attribute value from options or instance.
     * Prefer options value over instance value
     * @param  {String} name Name of the attribute
     * @param  {Object} defaultValue the default value to return if the attribute is not found
     * @return {Object} The value
     */
    getAttribute: function getAttribute(name, defaultValue) {
      var value = _underscoreWrapper.default.resultCtx(this.options, name, this);

      if (_underscoreWrapper.default.isUndefined(value)) {
        value = _underscoreWrapper.default.result(this, name);
      }

      return !_underscoreWrapper.default.isUndefined(value) ? value : defaultValue;
    },

    /**
     * Does this form have a "read" mode
     * @return {Boolean}
     */
    hasReadMode: function hasReadMode() {
      return !!this.getAttribute('read');
    },

    /**
     * Is this form in "read only" mode
     * @return {Boolean}
     */
    isReadOnly: function isReadOnly() {
      return !!this.getAttribute('readOnly');
    },

    /**
     * Does this form have a button bar
     * @return {Boolean}
     */
    hasButtonBar: function hasButtonBar() {
      return !(this.getAttribute('noButtonBar') || this.isReadOnly());
    },
    render: function render() {
      this.__readModeBar && this.__readModeBar.remove();

      if (this.hasReadMode() && !this.isReadOnly()) {
        var readModeBar = _ReadModeBar.default.extend({
          formTitle: this.getAttribute('title', '')
        });

        this.__readModeBar = this.add(readModeBar, '.o-form-title-bar').last();
      }

      var html = template({
        layout: this.getAttribute('layout', ''),
        title: this.getAttribute('title', '', true),
        subtitle: this.getAttribute('subtitle', '', true),
        hasReadMode: this.hasReadMode()
      });
      this.$el.html(html);
      delete this.template;

      _BaseView.default.prototype.render.apply(this, arguments);

      this.__applyMode();

      return this;
    },

    /**
     * Changes form UI to indicate saving.  Disables all inputs and buttons.  Use this function if you have set
     * hasSavingState to false on the the form
     * @private
     */
    __setSavingState: function __setSavingState() {
      this.model.trigger('form:set-saving-state');
      this.$el.addClass('o-form-saving');
    },

    /**
     * Changes form UI back to normal from the saving state.  Use this function if you are have set hasSavingState
     * to false on the form
     * @private
     */
    __clearSavingState: function __clearSavingState() {
      this.model.trigger('form:clear-saving-state');
      this.$el.removeClass('o-form-saving');
    },

    /**
     * Toggles the visibility of the bottom button bar
     * @private
     */
    __toggleToolbar: function __toggleToolbar() {
      this.__toolbar && this.__toolbar.remove();

      if (this.hasButtonBar() && this._editMode()) {
        this.__toolbar = this.__createToolbar();
        this.add(this.__toolbar, '');
      }

      this.trigger('resize');
    },

    /**
     * Cancels this form
     * - Reset the model to the previous state
     * - Clears all errors
     * - Triggers a `cancel` event
     * - Sets the model to read mode (if applicable)
     * @private
     * @fires cancel
     */
    __cancel: function __cancel() {
      var edit = this.model.get('__edit__');
      /* eslint max-statements: [2, 12] */

      this.model.clear({
        silent: true
      });
      var data;

      if (this.model.sanitizeAttributes) {
        data = this.model.sanitizeAttributes(this.__originalModel);
      } else {
        data = _underscoreWrapper.default.clone(this.__originalModel);
      }

      this.model.set(data, {
        silent: true
      });
      this.trigger('cancel', this.model);
      this.model.trigger('cache:clear');

      if (edit) {
        this.model.set('__edit__', false, {
          silent: true
        });
        this.model.trigger('change:__edit__', this.model, false);
      }

      this.clearErrors();
    },

    /**
     * Runs {@link module:Okta.Form#validate|validate} to check the model state.
     * Triggers an "invalid" event on the model if validation fails
     * @returns {Boolean}
     */
    isValid: function isValid() {
      var res;
      var self = this;

      function validateArray(arr) {
        var _context59;

        return (0, _reduce.default)(_context59 = _underscoreWrapper.default).call(_context59, arr, function (memo, fieldName) {
          return _underscoreWrapper.default.extend(memo, self.model.validateField(fieldName));
        }, {});
      }

      if (_underscoreWrapper.default.isUndefined(this.validate)) {
        return this.model.isValid();
      } else if (_underscoreWrapper.default.isFunction(this.validate)) {
        res = this.validate();
      } else if (_underscoreWrapper.default.isArray(this.validate)) {
        res = validateArray(this.validate);
      } else if (this.validate === 'local') {
        var _context60;

        res = validateArray((0, _map.default)(_context60 = this.getInputs()).call(_context60, function (input) {
          return input.options.name;
        }));
      }

      if (!_underscoreWrapper.default.isEmpty(res)) {
        this.model.trigger('invalid', this.model, res);
        return false;
      } else {
        return true;
      }
    },

    /**
     * A throttled function that saves the form not more than once every 100 ms
     * Basically all this method does is trigger a `save` event
     * @fires save
     * @private
     */
    __save: function __save() {
      this.clearErrors();

      if (this.isValid()) {
        this.trigger('save', this.model);
      }
    },

    /**
     * In the context of a wizard, go to previous state
     * Technically all this method does is trigger a `previous` event
     * @param  {Event} e
     * @private
     */
    __previous: function __previous() {
      this.trigger('previous', this.model);
    },

    /**
     * Renders the form in the correct mode based on the model.
     * @private
     */
    __applyMode: function __applyMode() {
      this.clearErrors();

      this.__toggleToolbar();

      if (this._editMode()) {
        this.$el.addClass('o-form-edit-mode');
        this.$el.removeClass('o-form-read-mode');
        this.$('.o-form-content').removeClass('rounded-btm-4');
        this.focus();
      } else {
        this.$el.removeClass('o-form-edit-mode');
        this.$el.addClass('o-form-read-mode');
        this.$('.o-form-content').addClass('rounded-btm-4');
      }
    },

    /**
     * Is the form in edit mode
     * @return {Boolean}
     * @private
     */
    _editMode: function _editMode() {
      return this.model.get('__edit__') || !this.hasReadMode();
    },

    /**
     * Function can be overridden to alter top level error summary.
     * @param {Object} responseJSON
     *
     * @example
     * // responseJSON object
     * {
     *  errorCauses: [{errorSummary: "At least one of Proxy Status, Location, or ASN should be configured."}]
     *  errorSummary: "At least one of Proxy Status, Location, or ASN should be configured."
     *  errorCode: "E0000001"
     *  errorId: "oaepsrTCHrhT-eIi8XTm6KWWg"
     *  errorLink: "E0000001"
     *  errorSummary: "Api validation failed: networkZone"
     * }
     *
     * @method
     * @default _.identity
     */
    parseErrorMessage: _underscoreWrapper.default.identity,

    /**
     * Show an error message based on an XHR error
     * @param  {Okta.BaseModel} model the model
     * @param  {jqXHR} xhr The jQuery XmlHttpRequest Object
     * @private
     */
    __showErrors: function __showErrors(model, resp, showBanner) {
      this.trigger('error', model);
      /* eslint max-statements: 0 */

      if (this.getAttribute('showErrors')) {
        var errorSummary;

        var responseJSON = _ErrorParser.default.getResponseJSON(resp);

        var validationErrors = _ErrorParser.default.parseFieldErrors(resp); // trigger events for field validation errors


        if (_underscoreWrapper.default.size(validationErrors)) {
          _underscoreWrapper.default.each(validationErrors, function (errors, field) {
            var _context61;

            this.model.trigger('form:field-error', this.__errorFields[field] || field, (0, _map.default)(_context61 = _underscoreWrapper.default).call(_context61, errors, function (error) {
              return /^model\.validation/.test(error) ? _StringUtil.default.localize(error, 'courage') : error;
            }));
          }, this);
        } else {
          responseJSON = this.parseErrorMessage(responseJSON);
          errorSummary = getErrorSummary(responseJSON);
        } // show the error message


        if (showBanner) {
          this.$('.o-form-error-container').addClass('o-form-has-errors');
          this.add(_ErrorBanner.default, '.o-form-error-container', {
            options: {
              errorSummary: errorSummary
            }
          });
        } // slide to and focus on the error message


        if (this.getAttribute('scrollOnError')) {
          var $el = (0, _jqueryWrapper.default)('#' + this.id + ' .o-form-error-container');
          $el.length && (0, _jqueryWrapper.default)('html, body').animate({
            scrollTop: $el.offset().top
          }, 400);
        }

        this.model.trigger('form:resize');
      }
    },

    /**
     * Clears the error banner
     * @private
     */
    clearErrors: function clearErrors() {
      this.$('.o-form-error-container').removeClass('o-form-has-errors');
      this.model.trigger('form:clear-errors');
      this.model.trigger('form:resize');
    },

    /**
     * Toggles between edit and read mode
     */
    toggle: function toggle() {
      this.model.set('__edit__', !this.hasReadMode() || !this.model.get('__edit__'));
      return this;
    },
    __addLayoutItem: function __addLayoutItem(input) {
      if (_InputFactory.default.supports(input)) {
        this.addInput(input);
      } else {
        this.__addNonInputLayoutItem(input);
      }
    },
    __addNonInputLayoutItem: function __addNonInputLayoutItem(item) {
      var itemOptions = _underscoreWrapper.default.omit(item, 'type');

      switch (item.type) {
        case 'sectionTitle':
          this.addSectionTitle(item.title, _underscoreWrapper.default.omit(itemOptions, 'title'));
          break;

        case 'divider':
          this.addDivider(itemOptions);
          break;

        default:
          throw new Error('unknown input: ' + item.type);
      }
    },

    /**
     * Adds a view to the buttons tool bar
     * @param {Object} params parameterized button options
     * @param {Object} options options to send to {@link module:Okta.View#add|View.add}
     */
    addButton: function addButton(params, options) {
      this.__toolbar && this.__toolbar.addButton(params, options);

      this.__buttons.push([params, options]);
    },

    /**
     * Adds a divider
     */
    addDivider: function addDivider(options) {
      this.add('<div class="okta-form-divider form-divider"></div>');

      _FormUtil.default.applyShowWhen(this.last(), options && options.showWhen);

      _FormUtil.default.applyToggleWhen(this.last(), options && options.toggleWhen);

      return this;
    },

    /**
     * Adds section header
     * @param {String} title
     */
    addSectionTitle: function addSectionTitle(title, options) {
      this.add(sectionTitleTemplate({
        title: title
      }));

      _FormUtil.default.applyShowWhen(this.last(), options && options.showWhen);

      _FormUtil.default.applyToggleWhen(this.last(), options && options.toggleWhen);

      return this;
    },

    /**
     * Add a form input
     * @param {Object} options Options to describe the input
     * @param {String} options.type The input type.
     * The options are: `text`, `textarea`, `select`, `checkbox`, `radio`, `switch`,
     * `password`, `number`, `textselect`, `date`, `grouppicker`, `admingrouppicker`, `su-orgspicker`
     * `file/image`, `file/cert`, `checkboxset`, `list`, `group`, `zonepicker`
     * @param {String} options.name The name of the model field this input mutates
     * @param {String|Function} [options.label]
     * The input label text.
     * When passed as a function, will invoke the function (in the context of the {@link InputLabel})
     * on render time, and use the returned value.
     * @param {String} [options.sublabel] The input sub label text
     * @param {String} [options.tooltip] A popover tooltip to be displayed next to the label
     * @param {String} [options.placeholder] Placeholder text.
     * @param {String} [options.explain] Explanation text to render below the input
     * @param {Okta.View} [options.customExplain] A custom view to render below the input (deprecated)
     * @param {Boolean} [options.disabled=false] Make this input disabled
     * @param {Boolean} [options.wide=false] Use a wide input layout
     * @param {Boolean} [options.label-top=false] position label on top of an input
     * @param {Boolean} [options.explain-top=false] position explain on top of an input (requires label-top=true)
     * @param {Number} [options.multi] have multiple in-line inputs. useful when `input` is passed as an array of inputs
     * @param {String} [options.errorField] The API error field here that maps to this input
     * @param {Boolean} [options.inlineValidation=true] Validate input on focusout
     * @param {String} [options.ariaLabel] Used to add aria-label attribute to the input when label is not present.
     * @param {Object} [options.options]
     * In the context of `radio` and `select`, a key/value set of options
     *
     * @param {Object} [options.params]
     * Widget specific parameters. Varies per input.
     *
     * @param {BaseInput|Object[]} [options.input]
     * - A custom input "class" or instance - preferably a **class**, so we can automagically assign the right
     * parameters when initializing it
     * - An array of input definition object literals (such as this one)
     *
     * @param {Object} [options.showWhen]
     * Setting to define when to show (or hide) the input. The input is visible by default.
     *
     * @param {Object} [options.bindings]
     * Bind a certain model attribute to a callback function, so the function is being called on render,
     * and any time this model field changes.
     * This is similar to `showWhen` but is not limited to toggling.
     *
     * @param {Function} [options.render]
     * A post-render hook that will run upon render on InputWrapper
     *
     * @param {String|Function} className   A className to apply on the {@link InputWrapper}
     *
     * @param {Function} [options.initialize]
     * An `initialize` function to run when initializing the {@link InputWrapper}
     * Useful for state mutation on start time, and complex state logic
     *
     * @example
     * // showhen: the field will be visible when `advanced` is set to `true`
     * // and `mode` is set to `"ON"`.
     * showWhen: {
     *   'advanced': true,
     *   'mode': function (value) {
     *     return value == 'ON'; // this is identical to this.model.get('mode') == 'ON'
     *   }
     * }
     *
     * @example
     * // bindings
     * bindings: {
     *   'status mode': function (status, mode) {
     *      var labelView = this.getLabel();
     *      if (status == 1) {
     *        labelView.options.label = 'Something';
     *      }
     *      else {
     *        labelView.options.label = mode;
     *      }
     *      labelView.render();
     *   }
     * }
     */
    addInput: function addInput(_options) {
      var _context62, _context63, _context64;

      _options = _underscoreWrapper.default.clone(_options);

      _FormUtil.default.validateInput(_options, this.model);

      var inputsOptions = (0, _reverse.default)(_context62 = _FormUtil.default.generateInputOptions(_options, this, this.__createInput)).call(_context62); // We need a local variable here to keep track
      // as addInput can be called either directy or through the inputs array.

      if (_underscoreWrapper.default.isEmpty(this.getInputs().toArray())) {
        _underscoreWrapper.default.extend(inputsOptions[0], {
          validateOnlyIfDirty: true
        });
      }

      var inputs = (0, _map.default)(_context63 = _underscoreWrapper.default).call(_context63, inputsOptions, this.__createInput, this);

      _underscoreWrapper.default.each(inputsOptions, function (input) {
        if (input.errorField) {
          this.__errorFields[input.errorField] = input.name;
        }
      }, this);

      var options = {
        inputId: _underscoreWrapper.default.last(inputs).options.inputId,
        input: inputs,
        multi: inputsOptions.length > 1 ? inputsOptions.length : undefined
      };

      _underscoreWrapper.default.extend(options, _underscoreWrapper.default.omit(this.options, 'input'), _underscoreWrapper.default.omit(_options, 'input'));

      var inputWrapper = this.__createWrapper(options);

      if (options.label !== false) {
        inputWrapper.add(this.__createLabel(options));
      }

      inputWrapper.add(this._createContainer(options));
      inputWrapper.type = options.type || options.input.type || 'custom';
      var args = (0, _concat.default)(_context64 = [inputWrapper]).call(_context64, _underscoreWrapper.default.rest(arguments));
      return this.add.apply(this, args);
    },

    /**
     * @private
     */
    __createInput: function __createInput(options) {
      options = _underscoreWrapper.default.pick(options, _FormUtil.default.INPUT_OPTIONS);
      return _InputFactory.default.create(options);
    },

    /**
     * @private
     */
    __createWrapper: function __createWrapper(options) {
      options = _underscoreWrapper.default.pick(options, _FormUtil.default.WRAPPER_OPTIONS);
      return new _InputWrapper.default(options);
    },

    /**
     * @private
     */
    __createLabel: function __createLabel(options) {
      options = _underscoreWrapper.default.pick(options, _FormUtil.default.LABEL_OPTIONS);
      return new _InputLabel.default(options);
    },

    /**
     * @private
     */
    _createContainer: function _createContainer(options) {
      options = _underscoreWrapper.default.pick(options, _FormUtil.default.CONTAINER_OPTIONS);
      return new _InputContainer.default(options);
    },

    /**
     * Stores the current attributes of the model to a private property
     * @param  {Okta.BaseModel} model The model
     * @private
     */
    __saveModelState: function __saveModelState(model) {
      this.__originalModel = _jqueryWrapper.default.extend(true, {}, model.attributes);
    },

    /**
     * @override
     * @ignore
     */
    add: function add() {
      var args = _underscoreWrapper.default.toArray(arguments);

      typeof args[1] === 'undefined' && (args[1] = '> div.o-form-content > .o-form-fieldset-container');
      return _BaseView.default.prototype.add.apply(this, args);
    },

    /**
     * Set the focus on the first input in the form
     */
    focus: function focus() {
      var first = this.getInputs().first();

      if (first && first.focus) {
        first.focus();
      }

      return this;
    },

    /**
     * Disable all inputs in the form
     * @deprecated not currently in use
     */
    disable: function disable() {
      this.invoke('disable');
      return this;
    },

    /**
     * Enable all inputs in the form
     * @deprecated not currently in use
     */
    enable: function enable() {
      this.invoke('enable');
    },

    /**
     * Set the max-height for o-form-content class container within the form if a height is provided,
     * otherwise, get its computed inner height
     * @param {Number} the height in pixel to set for class o-form-content
     * @return {Number}
     */
    contentHeight: function contentHeight(height) {
      var content = this.$('.o-form-content');

      if (_underscoreWrapper.default.isNumber(height)) {
        content.css('max-height', height);
      } else {
        return content.height();
      }
    },

    /**
     * Get only the input children
     * @return {InputWrapper[]} An underscore wrapped array of {@link InputWrapper} instances
     */
    getInputs: function getInputs() {
      var _context65;

      return (0, _underscoreWrapper.default)((0, _filter.default)(_context65 = this).call(_context65, function (view) {
        return view instanceof _InputWrapper.default;
      }));
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 60 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _FormUtil = _interopRequireDefault(__webpack_require__(10));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _default = _BaseView.default.extend({
    el: '<span class="o-form-toggle" data-type="header-btn"></span>',
    formTitle: '',
    modelEvents: {
      'change:__edit__': 'toggle'
    },
    initialize: function initialize() {
      this.addButton();
    },
    addButton: function addButton() {
      if (this.model.get('__edit__')) {
        this.add(_FormUtil.default.createReadFormButton({
          type: 'cancel'
        }));
      } else {
        this.add(_FormUtil.default.createReadFormButton({
          type: 'edit',
          formTitle: this.formTitle
        }));
      }
    },
    toggle: function toggle() {
      this.removeChildren();
      this.addButton();
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 61 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _default = _BaseView.default.extend({
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "errorSummary") || (depth0 != null ? lookupProperty(depth0, "errorSummary") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "errorSummary",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 130
            },
            "end": {
              "line": 1,
              "column": 146
            }
          }
        }) : helper)) + "</p>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "courage",
            "code": "oform.errorbanner.title"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 161
            },
            "end": {
              "line": 1,
              "column": 217
            }
          }
        })) + "</p>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "errorSummary") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.program(3, data, 0),
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 107
            },
            "end": {
              "line": 1,
              "column": 228
            }
          }
        })) != null ? stack1 : "") + "</div>";
      },
      "useData": true
    }),
    modelEvents: {
      'form:clear-errors': 'remove'
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 62 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var FIELD_REGEX = /^([\S]+): (.+)$/;
  var _default = {
    /**
     * Helper function that returns the json output of an xhr objext
     * @param  {jqXhr} xhr
     * @return {Object}
     */
    getResponseJSON: function getResponseJSON(xhr) {
      try {
        return xhr.responseJSON || JSON.parse(xhr.responseText);
      } catch (e) {
        return;
      }
    },

    /**
     * Parses an error summary to extract a field name and an error message
     * @param  {String} errorSummary The raw error summary
     * @return {String[]} An array with two members: [field name, error message]
     */
    parseErrorSummary: function parseErrorSummary(errorSummary) {
      var matches = errorSummary.match(FIELD_REGEX); // error format is: `fieldName: The field cannot be left blank`

      if (matches) {
        return [matches[1], matches[2]];
      }
    },

    /**
     * Parses an error cause object to extract a field name from property attribute
     * and an error message form errorSummary attribute. It looks to see if there is
     * a custom override/translation for the erorrCause.reason before using the errorSummary
     * @param  {Object} errorCause object
     * @return {String[]} An array with two members: [field name, error message]
     */
    parseErrorCauseObject: function parseErrorCauseObject(errorCause) {
      if (errorCause.property && errorCause.errorSummary) {
        var localizedMsg = _StringUtil.default.localize(errorCause.reason);

        var apiMsg = errorCause.errorSummary;
        var field = errorCause.property;
        var errorMessage = (0, _indexOf.default)(localizedMsg).call(localizedMsg, 'L10N_ERROR[') === -1 ? localizedMsg : apiMsg;
        return [field, errorMessage];
      }
    },
    parseErrors: function parseErrors(resp) {
      var _context66;

      var responseJSON = this.getResponseJSON(resp);
      return (0, _map.default)(_context66 = _underscoreWrapper.default).call(_context66, responseJSON && responseJSON.errorCauses || [], function (errorCause) {
        return ('' + errorCause.errorSummary).replace(FIELD_REGEX, '$2');
      });
    },

    /**
     * Parses the response for errors
     * Returns a map of field names > array or error messages
     * Example:
     * ```javascript
     * {
     *   url: ['The field cannot be left blank', 'The field has to be a valid URI'],
     *   name: ['The field cannot be left blank']
     * }
     * ```
     * @param  {Object} resp
     * @return {Object}
     */
    parseFieldErrors: function parseFieldErrors(resp) {
      var responseJSON = this.getResponseJSON(resp);
      var errors = {}; // xhr error object

      if (responseJSON) {
        /* eslint complexity: [2, 7] */
        _underscoreWrapper.default.each(responseJSON.errorCauses || [], function (cause) {
          var res = [];

          if (cause.property && cause.errorSummary) {
            res = this.parseErrorCauseObject(cause);
          } else {
            res = this.parseErrorSummary(cause && cause.errorSummary || '');
          }

          if (res) {
            var fieldName = res[0];
            var message = res[1];
            errors[fieldName] || (errors[fieldName] = []);
            errors[fieldName].push(message);
          }
        }, this);
      } // validation key/value object
      else if (_underscoreWrapper.default.isObject(resp) && _underscoreWrapper.default.size(resp)) {
          _underscoreWrapper.default.each(resp, function (msg, field) {
            errors[field] = [msg];
          });
        }

      return _underscoreWrapper.default.size(errors) ? errors : undefined;
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 63 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _Util = _interopRequireDefault(__webpack_require__(18));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var isABaseView = _Util.default.isABaseView;
  /**
   * @class InputContainer
   * @private
   *
   * TODO: OKTA-80796
   * Attention: Please change with caution since this is used in other places
   */

  var _default = _BaseView.default.extend({
    attributes: function attributes() {
      return {
        'data-se': 'o-form-input-container'
      };
    },
    className: function className() {
      var className = 'o-form-input';

      if (this.options.wide) {
        className += ' o-form-wide';
      }

      if (_underscoreWrapper.default.contains([1, 2, 3, 4], this.options.multi)) {
        className += ' o-form-multi-input-' + this.options.multi;

        if (_underscoreWrapper.default.isArray(this.options.input)) {
          var _context67;

          var inputGroup = (0, _find.default)(_context67 = _underscoreWrapper.default).call(_context67, this.options.input, function (input) {
            return _underscoreWrapper.default.contains(['text+select', 'select+text'], input.options.type);
          });
          inputGroup && (className += ' o-form-multi-input-group-' + this.options.multi);
        }
      }

      return className;
    },
    _getNames: function _getNames() {
      var names = _underscoreWrapper.default.isArray(this.options.name) ? this.options.name : [this.options.name];
      /*eslint complexity: 0 */

      if (this.options.type === 'group') {
        names.push.apply(names, _underscoreWrapper.default.pluck(this.options.input[0].options.params.inputs, 'name'));
      } else if (_underscoreWrapper.default.isArray(this.options.name)) {
        if (this.options.input && this.options.input.options && this.options.input.options.name) {
          names.push(this.options.input.options.name);
        }
      } else if (this.options.input) {
        if (_underscoreWrapper.default.isArray(this.options.input)) {
          _underscoreWrapper.default.each(this.options.input, function (inputItem) {
            names.push(inputItem.options.name);
          });
        } else {
          names.push(this.options.input.options.name);
        }
      }

      return _underscoreWrapper.default.uniq(_underscoreWrapper.default.compact(names));
    },
    constructor: function constructor() {
      /* eslint max-statements: [2, 18] */
      _BaseView.default.apply(this, arguments);

      var explainTop = this.options['explain-top'] && this.options['label-top'];

      if (this.options.input) {
        if (_underscoreWrapper.default.isArray(this.options.input)) {
          _underscoreWrapper.default.each(this.options.input, function (inputItem) {
            this.add(inputItem, {
              prepend: !explainTop
            });
          }, this);
        } else {
          this.add(this.options.input, {
            prepend: !explainTop
          });
        }
      }

      this.__setExplain(this.options);

      var names = this._getNames();

      this.listenTo(this.model, 'form:field-error', function (name, errors) {
        if (_underscoreWrapper.default.contains(names, name)) {
          this.__setError(errors, explainTop);
        }
      });
      this.listenTo(this.model, 'form:clear-errors change:' + names.join(' change:'), this.__clearError);
      this.listenTo(this.model, 'form:clear-error:' + names.join(' form:clear-error:'), this.__clearError);

      if (_underscoreWrapper.default.resultCtx(this.options, 'autoRender', this)) {
        this.listenTo(this.model, 'change:' + this.options.name, this.render);
      }

      this.__errorState = false;
    },

    /**
     * Populates the explain on the input container (if it exists). There are
     * two ways to use this:
     * 1. Raw text - wraps in the correct html template
     * 2. Custom html
     *    - pass in a View class (preferred)
     *    - pass in an instance of a View
     * Some additional notes:
     * - You can pass a function that returns any of the above
     * - This maintains support for the deprecated "customExplain" property
     *   that was used before. This pattern is superseded by explain, so use
     *   that instead.
     * @private
     */
    __setExplain: function __setExplain(options) {
      var explain; // Deprecated - if you need custom html, use explain instead

      if (options.customExplain) {
        _Logger.default.warn('Deprecated - use explain instead of customExplain');

        this.add(this.options.customExplain);
        return;
      }

      explain = options.explain;

      if (_underscoreWrapper.default.isFunction(explain) && !isABaseView(explain)) {
        explain = _underscoreWrapper.default.resultCtx(this.options, 'explain', this);
      }

      if (!explain) {
        return;
      }

      if (isABaseView(explain)) {
        this.template = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            return "<p class=\"o-form-explain\"></p>";
          },
          "useData": true
        });
        this.add(explain, '.o-form-explain');
      } else {
        this.template = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var helper,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<p class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "explain") || (depth0 != null ? lookupProperty(depth0, "explain") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "explain",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 26
                },
                "end": {
                  "line": 1,
                  "column": 37
                }
              }
            }) : helper)) + "</p>";
          },
          "useData": true
        });
      }
    },

    /**
     * Highlight the input as invalid (validation failed)
     * Adds an explaination message of the error
     * @private
     */
    __setError: function __setError(errors, explainTop) {
      this.__errorState = true;
      this.$el.addClass('o-form-has-errors');

      var errorId = _underscoreWrapper.default.uniqueId('input-container-error');

      var tmpl = _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var helper,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              alias2 = container.hooks.helperMissing,
              alias3 = "function",
              alias4 = container.escapeExpression,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return "<p id=\"" + alias4((helper = (helper = lookupProperty(helpers, "errorId") || (depth0 != null ? lookupProperty(depth0, "errorId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
            "name": "errorId",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 7
              },
              "end": {
                "line": 1,
                "column": 18
              }
            }
          }) : helper)) + "\" class=\"okta-form-input-error o-form-input-error o-form-explain\" role=\"alert\"><span class=\"icon icon-16 error-16-small\" role=\"img\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "iconLabel") || (depth0 != null ? lookupProperty(depth0, "iconLabel") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
            "name": "iconLabel",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 162
              },
              "end": {
                "line": 1,
                "column": 175
              }
            }
          }) : helper)) + "\"></span>" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
            "name": "text",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 184
              },
              "end": {
                "line": 1,
                "column": 192
              }
            }
          }) : helper)) + "</p>";
        },
        "useData": true
      });

      var iconLabel = _StringUtil.default.localize('oform.error.icon.ariaLabel', 'courage'); // 'Error'


      var html = tmpl({
        errorId: errorId,
        iconLabel: iconLabel,
        text: errors.join(', ')
      });
      var $elExplain = this.$('.o-form-explain').not('.o-form-input-error').first();

      if ($elExplain.length && !explainTop) {
        $elExplain.before(html);
      } else {
        this.$el.append(html);
      }

      this.$el.attr('aria-describedby', errorId);
    },

    /**
     * Un-highlight the input and remove explaination text
     * @private
     */
    __clearError: function __clearError() {
      var _this = this;

      if (this.__errorState) {
        this.$('.o-form-input-error').remove();
        this.$el.attr('aria-describedby', null);
        this.$el.removeClass('o-form-has-errors');
        this.__errorState = false;

        _underscoreWrapper.default.defer(function () {
          _this.model.trigger('form:resize');
        });
      }
    },
    focus: function focus() {
      this.each(function (view) {
        if (view.focus) {
          return view.focus();
        }
      });
      return this;
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 64 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _InputRegistry = _interopRequireDefault(__webpack_require__(26));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint complexity: 0, max-statements: 0 */


  function createInput(Input, options) {
    if (_InputRegistry.default.isBaseInput(Input)) {
      return Input.prototype ? new Input(_underscoreWrapper.default.omit(options, 'input')) : Input;
    } else {
      return Input;
    }
  }

  function create(options) {
    options = _underscoreWrapper.default.clone(options);

    if (options.input) {
      return createInput(options.input, options);
    }

    var Input = _InputRegistry.default.get(options);

    if (!Input) {
      throw new Error('unknown input: ' + options.type);
    }

    return createInput(Input, options);
  }

  function supports(options) {
    return !!options.input || !!_InputRegistry.default.get(options);
  }

  var _default = {
    create: create,
    supports: supports
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 65 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  __webpack_require__(27);

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }
  /**
   * @class InputLabel
   * @extends {Okta.View}
   * @private
   * The input's label.
   */


  var _default = _BaseView.default.extend({
    className: 'okta-form-label o-form-label',
    attributes: {
      'data-se': 'o-form-label'
    },

    /**
     * @constructor
     * @param  {Object} options options hash
     * @param  {String} [options.type] Input type
     * @param  {String|Function} [options.label] Label text
     * @param  {String|Function} [options.sublabel] Sub label text
     * @param  {String|Function} [options.tooltip] Tooltip text
     * @param  {String|Function} [options.inputId] Id of the inputs
     * @param  {String|Function} [options.id] Id of the inputs
     */
    constructor: function constructor(options) {
      /* eslint max-statements: [2, 16] complexity: [2, 7]*/
      _underscoreWrapper.default.defaults(options, {
        inputId: options.id
      });

      delete options.id;

      _BaseView.default.apply(this, arguments);
    },
    // standardLabel: space added in the end of the label to avoid selecting label text with double click in read mode
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<label for=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 33
            },
            "end": {
              "line": 1,
              "column": 44
            }
          }
        }) : helper)) + "\"></label>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "label",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 88
            },
            "end": {
              "line": 1,
              "column": 97
            }
          }
        }) : helper));
      },
      "5": function _(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 139
            },
            "end": {
              "line": 1,
              "column": 150
            }
          }
        }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "label",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 152
            },
            "end": {
              "line": 1,
              "column": 161
            }
          }
        }) : helper)) + "&nbsp;</label>";
      },
      "7": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "sublabel") || (depth0 != null ? lookupProperty(depth0, "sublabel") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "sublabel",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 228
            },
            "end": {
              "line": 1,
              "column": 240
            }
          }
        }) : helper)) + "</span>";
      },
      "9": function _(container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"o-form-tooltip icon-16 icon-only form-help-16\" title=\"" + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "tooltip") : depth0) != null ? lookupProperty(stack1, "text") : stack1, depth0)) + "\"></span>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_isLabelView") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 61
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_isRadioOrCheckbox") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 61
            },
            "end": {
              "line": 1,
              "column": 104
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_standardLabel") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(5, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 104
            },
            "end": {
              "line": 1,
              "column": 182
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sublabel") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(7, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 182
            },
            "end": {
              "line": 1,
              "column": 254
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "tooltip") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(9, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 254
            },
            "end": {
              "line": 1,
              "column": 369
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),
    getTemplateData: function getTemplateData() {
      var options = {
        label: ''
      };

      _underscoreWrapper.default.each(['inputId', 'label', 'sublabel', 'tooltip'], function (option) {
        options[option] = _underscoreWrapper.default.resultCtx(this.options, option, this);
      }, this);

      if (this._isLabelView(options.label)) {
        options._isLabelView = true;
      } else if (_underscoreWrapper.default.contains(['radio', 'checkbox'], this.options.type) || !options.label) {
        options._isRadioOrCheckbox = true;
      } else {
        options._standardLabel = true;
      }

      if (options.tooltip) {
        if (_underscoreWrapper.default.isString(options.tooltip)) {
          options.tooltip = {
            text: options.tooltip
          };
        }
      }

      return options;
    },
    _isLabelView: function _isLabelView(label) {
      return !_underscoreWrapper.default.isUndefined(label) && label instanceof _BaseView.default;
    },
    postRender: function postRender() {
      var options = this.getTemplateData();

      if (this._isLabelView(options.label)) {
        this.removeChildren();
        this.add(options.label, 'label');
      }

      if (options.tooltip) {
        this.$('.o-form-tooltip').qtip(_underscoreWrapper.default.extend({
          style: {
            classes: 'qtip-custom qtip-shadow'
          },
          position: {
            my: 'bottom left',
            at: 'top center'
          },
          hide: {
            fixed: true
          },
          show: {
            delay: 0
          }
        }, options.tooltip.options));
      }
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 66 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _FormUtil = _interopRequireDefault(__webpack_require__(10));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function runCallback(callback, field) {
    var _context68;

    callback.apply(this, (0, _map.default)(_context68 = _underscoreWrapper.default).call(_context68, field.split(/\s+/), function (field) {
      return this.model.get(field);
    }, this));
  }

  function runIf(fn, ctx) {
    if (_underscoreWrapper.default.isFunction(fn)) {
      fn.call(ctx);
    }
  }
  /**
   * @class InputWrapper
   * @extends Okta.View
   * @private
   * The outer wrapper that warps the label and the input container
   */


  var _default = _BaseView.default.extend({
    className: function className() {
      var className = 'o-form-fieldset';

      if (this.options['label-top']) {
        className += ' o-form-label-top';
      }

      if (this.options.readOnly) {
        className += ' o-form-read-mode';
      }

      return className;
    },
    attributes: function attributes() {
      return {
        'data-se': this.options['data-se'] || 'o-form-fieldset'
      };
    },

    /**
     * @constructor
     * @param  {Object} options options hash
     * @param  {Object} [options.events]
     * @param  {Object} [options.bindings]
     * @param  {Object} [options.showWhen]
     * @param  {Function} [options.initialize] post initialize callback
     * @param  {Function} [options.render] post render callback
     */
    constructor: function constructor(options) {
      if (options.className) {
        this.inputWrapperClassName = this.className;
        this.optionsClassName = options.className;

        options.className = function () {
          return _underscoreWrapper.default.result(this, 'inputWrapperClassName', '') + ' ' + _underscoreWrapper.default.result(this, 'optionsClassName');
        };
      }

      _BaseView.default.apply(this, arguments);

      _underscoreWrapper.default.each(options.events || {}, function (callback, event) {
        this.listenTo(this.model, event, callback);
      }, this);

      _underscoreWrapper.default.each(options.bindings || {}, function (callback, field) {
        var _context69;

        this.listenTo(this.model, _FormUtil.default.changeEventString(field.split(/\s+/)), (0, _bind.default)(_context69 = _underscoreWrapper.default).call(_context69, runCallback, this, callback, field));
      }, this);

      _FormUtil.default.applyShowWhen(this, options.showWhen);

      _FormUtil.default.applyToggleWhen(this, options.toggleWhen);

      runIf(options.initialize, this);
    },
    postRender: function postRender() {
      _underscoreWrapper.default.each(this.options.bindings || {}, runCallback, this);

      runIf(this.options.render, this);
    },

    /**
     * @return {InputLabel}
     */
    getLabel: function getLabel() {
      return this.size() > 1 ? this.at(0) : null;
    },

    /**
     * @deprecated ambiguous naming, use {@link #getInputContainer}
     */
    getInput: function getInput() {
      return this.getInputContainer();
    },

    /**
     * @return {InputContainer}
     */
    getInputContainer: function getInputContainer() {
      return this.at(this.size() > 1 ? 1 : 0);
    },

    /**
     * @return {BaseInput[]}
     */
    getInputs: function getInputs() {
      return this.getInputContainer().toArray();
    },
    focus: function focus() {
      return this.getInput().focus();
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 67 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _BooleanSelect = _interopRequireDefault(__webpack_require__(68));

  var _TextBoxSet = _interopRequireDefault(__webpack_require__(70));

  var _EnumTypeHelper = _interopRequireDefault(__webpack_require__(20));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-statements: 0, max-params: 0 */
  // Maps each __displayType__ to a basic set of inputOptions.


  function defaultOptions(property) {
    var type = property.get('__displayType__');
    var values = property.get('__possibleValues__');
    var name = property.get('name');
    var title = property.get('title');
    /* eslint complexity: [2, 24] */

    var inputOptions = {
      type: 'text',
      name: name,
      label: title || name
    }; // @see customOptions for enum complex "object" type,
    // a.k.a "object" or "arrayofobject" type has enum values defined.
    // Other cases (e.g., nested object type) are not support yet.

    switch (type) {
      case 'arrayofstring':
        inputOptions.input = _TextBoxSet.default;
        inputOptions.params = {
          itemType: 'string'
        };
        break;

      case 'arrayofnumber':
        inputOptions.input = _TextBoxSet.default;
        inputOptions.params = {
          itemType: 'number'
        };
        break;

      case 'arrayofinteger':
        inputOptions.input = _TextBoxSet.default;
        inputOptions.params = {
          itemType: 'integer'
        };
        break;

      case 'arrayofobject':
        inputOptions.input = _TextBoxSet.default;
        inputOptions.params = {
          itemType: property.get('items').type
        };
        break;

      case 'arrayofref-id':
        inputOptions.input = _TextBoxSet.default;
        inputOptions.params = {
          itemType: property.get('items').format
        };
        break;

      case 'boolean':
        inputOptions.input = _BooleanSelect.default;
        break;

      case 'integer':
      case 'number':
        inputOptions.to = convertStringToNumber;
        break;

      case 'reference':
        inputOptions.type = 'select';
        inputOptions.options = getChoices(values);
        break;

      case 'image':
        inputOptions.readOnly = true;

        inputOptions.from = function (value) {
          return _underscoreWrapper.default.isEmpty(value) ? '' : _StringUtil.default.localize('user.profile.image.image_set', 'courage'); //TODO
        };

        break;

      case 'password':
        inputOptions.type = 'password';
        break;

      case 'date':
        inputOptions.type = 'date';
        break;

      case 'uri':
      case 'country-code':
      case 'country_code':
      case 'language-code':
      case 'language_code':
      case 'email':
      case 'locale':
      case 'timezone':
      case 'string':
      case 'object':
        //default input options
        break;

      default:
        throw new Error('unknown type: ' + type);
    }

    return inputOptions;
  } // Sets nonbasic inputOptions, such as an array with possible values


  function customOptions(property) {
    var inputOptions = {};
    var name = property.get('name');
    var type = property.get('__displayType__');
    var values = property.get('__possibleValues__');
    var prefix = property.get('__fieldNamePrefix__');

    if (prefix) {
      inputOptions.name = prefix + name;
      inputOptions.errorField = name;
    }

    if (property.isEnumType()) {
      var configs = {
        displayType: type,
        title: property.get('title'),
        enumValues: property.getEnumValues()
      };
      inputOptions = _underscoreWrapper.default.extend({}, _EnumTypeHelper.default.getEnumInputOptions(configs), inputOptions);
    } else if (isArray(type) && values) {
      inputOptions.type = 'checkboxset';
      inputOptions.input = null;
      inputOptions.options = getChoices(values);
    }

    return inputOptions;
  }

  function convertStringToNumber(string) {
    var number = _StringUtil.default.parseFloat(string);

    return string === '' ? null : number;
  }

  function isArray(type) {
    return type && (0, _indexOf.default)(type).call(type, 'array') >= 0;
  } // converts possibleValues to choices
  // [a, b, c] => {a: a, b: b, c: c}


  function getChoices(values) {
    return _underscoreWrapper.default.object(values, values);
  } // A schema property may have an objectName either
  // at the root level or nested in the items object


  function getObjectName(schemaProp) {
    var items = schemaProp.get('items');

    if (items) {
      return items.objectName;
    } else {
      return schemaProp.get('objectName');
    }
  }

  function augmentSchemaProp(schemaProp, possibleValues, profile) {
    var name = schemaProp.get('name');
    var prefix = profile['__nestedProperty__'];
    var defaultValues = possibleValues[name];
    var userValues = profile.get(name);
    var //TODO: Not implemented
    fixedValues;
    var values; // If API responds with a field name that differs from the form-field name
    // example: Model's 'profile.username' vs. server's 'username'

    if (prefix) {
      schemaProp.set('__fieldNamePrefix__', prefix);
    } // case 1: objectName - fixed list of values are set for the input


    fixedValues = possibleValues[getObjectName(schemaProp)]; // case 2: name only - default list of values are provided, user can add more
    // TODO: this case does not yet exist, so it is not tested

    if (defaultValues && userValues) {
      defaultValues = _underscoreWrapper.default.union(defaultValues, userValues);
    } // If both fixed and default values exist,
    // take the fixed values unless they are empty


    if (fixedValues && fixedValues.length) {
      values = fixedValues;
    } else if (defaultValues && defaultValues.length) {
      values = defaultValues;
    }

    schemaProp.set('__possibleValues__', values);
  }

  function augmentSchemaProps(schemaProps, possibleValues, profile) {
    schemaProps.each(function (schemaProp) {
      augmentSchemaProp(schemaProp, possibleValues, profile);
    });
    return schemaProps;
  }
  /**
   * Remove invalid schema properties from a collection
   *
   * @param {SchemaProperties Collection} [properties] A collection of schema properties
   * @param {Object} [values] An object of the form { key: [value1, value2]}
   * @return {Array} An array of valid schema models, this can be used to reset
   * a schema properties collection for example.
   * @private
   */


  function cleanSchema(properties, values) {
    return (0, _filter.default)(properties).call(properties, function (schema) {
      return isValidSchemaProp(schema, values);
    });
  }
  /**
   * Checks the validity of a schema property.
   *
   * @param {SchemaProperty} [schemaProp] A schema property backbone model
   * @param {Object} [values] An object of the form { key: [value1, value2]}
   * @return {Boolean} true/false
   * @private
   */


  function isValidSchemaProp(schemaProp, values) {
    var objectName = getObjectName(schemaProp);
    var results = values[objectName]; // a schema property that references an empty list of values
    // Im looking at you, google apps.

    if (objectName && (0, _underscoreWrapper.default)(results).isEmpty()) {
      return false;
    }

    return true;
  }

  var _default = {
    /**
     * Creates the options hash for BaseForm.addInput from a prepared schema
     * property.
     *
     * @param {Okta.Model} [preparedSchemaProp] A schema property backbone model
     * that has been standardized by the prepareSchema method.
     * @return {Object} An object containing all of the options needed by
     * BaseForm's addInput()
     */
    createInputOptions: function createInputOptions(preparedSchemaProp) {
      var custom = customOptions(preparedSchemaProp);
      var standard = defaultOptions(preparedSchemaProp); // underscore did not support nested extend
      // https://github.com/jashkenas/underscore/issues/162

      if (custom.params && standard.params) {
        custom.params = _underscoreWrapper.default.defaults(custom.params, standard.params);
      }

      return _underscoreWrapper.default.defaults(custom, standard);
    },
    hasValidSchemaProps: function hasValidSchemaProps(schemaProps, possibleValues) {
      if (_underscoreWrapper.default.isEmpty(schemaProps)) {
        return false;
      } else {
        var validSchema = cleanSchema(schemaProps, possibleValues);
        return !!validSchema.length;
      }
    },

    /**
     * This method is responsible for preparing a collection for the form
     * factory to use by putting all of the information to create an input
     * into the schema property and removing invalid properties.
     * The typical UD form takes 3 models:
     * The data model has the input values.
     * The schema model describes which input to use, such as a textbox or a checkbox.
     * The possible values model provide a list of default options to display, for example in a drop down menu.
     *
     * @param {SchemaProperty Collection} [schemaProps] A schema property backbone model.
     * @param {Object} [possibleValues] An object of the form { key: [value1, value2]}
     * @param {Okta.Model} [profile] A backbone model containing the property described by the schema property.
     * @return {SchemaProperty Collection} A schema property collection with standardized models.
     * The standard schema model adds a couple of additional private properties to
     * allow the form factory to reference lookup values or name prefixes without going to a second model.
     */
    prepareSchema: function prepareSchema(schemaProps, possibleValues, profile) {
      schemaProps.reset(cleanSchema(schemaProps, possibleValues));
      return augmentSchemaProps(schemaProps, possibleValues, profile);
    },

    /**
     * `prepareSchema` will reset the property list which may not be necessary at some case.
     * like when setting default value for schema properties.
     * (more detail about such case @see wiki UX, App+Entitlements+for+Provisioning)
     *
     * @param { }
     * @return {String}
     */
    augmentSchemaProps: augmentSchemaProps,
    augmentSchemaProp: augmentSchemaProp
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 68 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _Select = _interopRequireDefault(__webpack_require__(28));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var options = {
    undefined: 'undefined',
    true: 'true',
    false: 'false'
  };

  var from = function from(val) {
    if (val) {
      return 'true';
    }

    if (val === false) {
      return 'false';
    }

    return 'undefined';
  };

  var to = function to(val) {
    switch (val) {
      case 'undefined':
        return null;

      case 'true':
        return true;

      case 'false':
        return false;

      default:
        return null;
    }
  };

  var _default = _Select.default.extend({
    initialize: function initialize() {
      this.options.options = options;
      this.options.from = from;
      this.options.to = to;
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 69 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Chosen, a Select Box Enhancer for jQuery and Prototype
  // by Patrick Filler for Harvest, http://getharvest.com
  //
  // Version 0.11.1
  // Full source at https://github.com/harvesthq/chosen
  // Copyright (c) 2011 Harvest http://getharvest.com
  // MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
  // This file is generated by `grunt build`, do not edit it by hand.


  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (jQuery) {
    (function () {
      var SelectParser;

      SelectParser = function () {
        function SelectParser() {
          this.options_index = 0;
          this.parsed = [];
        }

        SelectParser.prototype.add_node = function (child) {
          if (child.nodeName.toUpperCase() === "OPTGROUP") {
            return this.add_group(child);
          } else {
            return this.add_option(child);
          }
        };

        SelectParser.prototype.add_group = function (group) {
          var group_position, option, _i, _len, _ref, _results;

          group_position = this.parsed.length;
          this.parsed.push({
            array_index: group_position,
            group: true,
            label: group.label,
            children: 0,
            disabled: group.disabled
          });
          _ref = group.childNodes;
          _results = [];

          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            option = _ref[_i];

            _results.push(this.add_option(option, group_position, group.disabled));
          }

          return _results;
        };

        SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
          if (option.nodeName.toUpperCase() === "OPTION") {
            if (option.text !== "") {
              if (group_position != null) {
                this.parsed[group_position].children += 1;
              }

              this.parsed.push({
                array_index: this.parsed.length,
                options_index: this.options_index,
                value: option.value,
                text: option.text,
                html: option.innerHTML,
                selected: option.selected,
                disabled: group_disabled === true ? group_disabled : option.disabled,
                group_array_index: group_position,
                classes: option.className,
                style: option.style.cssText
              });
            } else {
              this.parsed.push({
                array_index: this.parsed.length,
                options_index: this.options_index,
                empty: true
              });
            }

            return this.options_index += 1;
          }
        };

        return SelectParser;
      }();

      SelectParser.select_to_array = function (select) {
        var child, parser, _i, _len, _ref;

        parser = new SelectParser();
        _ref = select.childNodes;

        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          parser.add_node(child);
        }

        return parser.parsed;
      };

      this.SelectParser = SelectParser;
    }).call(this);
    (function () {
      var AbstractChosen, root;
      root = this;

      AbstractChosen = function () {
        function AbstractChosen(form_field, options) {
          this.form_field = form_field;
          this.options = options != null ? options : {};

          if (!AbstractChosen.browser_is_supported()) {
            return;
          }

          this.is_multiple = this.form_field.multiple;
          this.set_default_text();
          this.set_default_values();
          this.setup();
          this.set_up_html();
          this.register_observers();
          this.finish_setup();
        }

        AbstractChosen.prototype.set_default_values = function () {
          var _this = this;

          this.click_test_action = function (evt) {
            return _this.test_active_click(evt);
          };

          this.activate_action = function (evt) {
            return _this.activate_field(evt);
          };

          this.active_field = false;
          this.mouse_on_container = false;
          this.results_showing = false;
          this.result_highlighted = null;
          this.result_single_selected = null;
          this.allow_single_deselect = this.options.allow_single_deselect != null && this.form_field.options[0] != null && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
          this.disable_search_threshold = this.options.disable_search_threshold || 0;
          this.disable_search = this.options.disable_search || false;
          this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
          this.search_contains = this.options.search_contains || false;
          this.single_backstroke_delete = this.options.single_backstroke_delete || false;
          this.max_selected_options = this.options.max_selected_options || Infinity;
          return this.inherit_select_classes = this.options.inherit_select_classes || false;
        };

        AbstractChosen.prototype.set_default_text = function () {
          if (this.form_field.getAttribute("data-placeholder")) {
            this.default_text = this.form_field.getAttribute("data-placeholder");
          } else if (this.is_multiple) {
            this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
          } else {
            this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
          }

          return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
        };

        AbstractChosen.prototype.mouse_enter = function () {
          return this.mouse_on_container = true;
        };

        AbstractChosen.prototype.mouse_leave = function () {
          return this.mouse_on_container = false;
        };

        AbstractChosen.prototype.input_focus = function (evt) {
          var _this = this;

          if (this.is_multiple) {
            if (!this.active_field) {
              return (0, _setTimeout2.default)(function () {
                return _this.container_mousedown();
              }, 50);
            }
          } else {
            if (!this.active_field) {
              return this.activate_field();
            }
          }
        };

        AbstractChosen.prototype.input_blur = function (evt) {
          var _this = this;

          if (!this.mouse_on_container) {
            this.active_field = false;
            return (0, _setTimeout2.default)(function () {
              return _this.blur_test();
            }, 100);
          }
        };

        AbstractChosen.prototype.result_add_option = function (option) {
          var classes, style;
          option.dom_id = this.container_id + "_o_" + option.array_index;
          classes = [];

          if (!option.disabled && !(option.selected && this.is_multiple)) {
            classes.push("active-result");
          }

          if (option.disabled && !(option.selected && this.is_multiple)) {
            classes.push("disabled-result");
          }

          if (option.selected) {
            classes.push("result-selected");
          }

          if (option.group_array_index != null) {
            classes.push("group-option");
          }

          if (option.classes !== "") {
            classes.push(option.classes);
          }

          style = option.style.cssText !== "" ? " style=\"" + option.style + "\"" : "";
          return '<li id="' + option.dom_id + '" class="' + classes.join(' ') + '"' + style + '>' + option.html + '</li>';
        };

        AbstractChosen.prototype.results_update_field = function () {
          this.set_default_text();

          if (!this.is_multiple) {
            this.results_reset_cleanup();
          }

          this.result_clear_highlight();
          this.result_single_selected = null;
          return this.results_build();
        };

        AbstractChosen.prototype.results_toggle = function () {
          if (this.results_showing) {
            return this.results_hide();
          } else {
            return this.results_show();
          }
        };

        AbstractChosen.prototype.results_search = function (evt) {
          if (this.results_showing) {
            return this.winnow_results();
          } else {
            return this.results_show();
          }
        };

        AbstractChosen.prototype.choices_count = function () {
          var option, _i, _len, _ref;

          if (this.selected_option_count != null) {
            return this.selected_option_count;
          }

          this.selected_option_count = 0;
          _ref = this.form_field.options;

          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            option = _ref[_i];

            if (option.selected) {
              this.selected_option_count += 1;
            }
          }

          return this.selected_option_count;
        };

        AbstractChosen.prototype.choices_click = function (evt) {
          evt.preventDefault();

          if (!(this.results_showing || this.is_disabled)) {
            return this.results_show();
          }
        };

        AbstractChosen.prototype.keyup_checker = function (evt) {
          var stroke, _ref;

          stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
          this.search_field_scale();

          switch (stroke) {
            case 8:
              if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
                return this.keydown_backstroke();
              } else if (!this.pending_backstroke) {
                this.result_clear_highlight();
                return this.results_search();
              }

              break;

            case 13:
              evt.preventDefault();

              if (this.results_showing) {
                return this.result_select(evt);
              }

              break;

            case 27:
              if (this.results_showing) {
                this.results_hide();
              }

              return true;

            case 9:
            case 38:
            case 40:
            case 16:
            case 91:
            case 17:
              break;

            default:
              return this.results_search();
          }
        };

        AbstractChosen.prototype.generate_field_id = function () {
          var new_id;
          new_id = this.generate_random_id();
          this.form_field.id = new_id;
          return new_id;
        };

        AbstractChosen.prototype.generate_random_char = function () {
          var chars, newchar, rand;
          chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          rand = Math.floor(Math.random() * chars.length);
          return newchar = chars.substring(rand, rand + 1);
        };

        AbstractChosen.prototype.container_width = function () {
          if (this.options.width != null) {
            return this.options.width;
          } else {
            return "" + this.form_field.offsetWidth + "px";
          }
        };

        AbstractChosen.browser_is_supported = function () {
          var _ref;

          if (window.navigator.appName === "Microsoft Internet Explorer") {
            return null !== (_ref = document.documentMode) && _ref >= 8;
          }

          return true;
        };

        AbstractChosen.default_multiple_text = "Select Some Options";
        AbstractChosen.default_single_text = "Select an Option";
        AbstractChosen.default_no_result_text = "No results match";
        return AbstractChosen;
      }();

      root.AbstractChosen = AbstractChosen;
    }).call(this);
    (function () {
      var $,
          Chosen,
          root,
          _ref,
          __hasProp = {}.hasOwnProperty,
          __extends = function __extends(child, parent) {
        for (var key in parent) {
          if (__hasProp.call(parent, key)) child[key] = parent[key];
        }

        function ctor() {
          this.constructor = child;
        }

        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
      };

      root = this; // OKTA-93521 - plugin assumes root is global scope

      var AbstractChosen = root.AbstractChosen;
      $ = jQuery;
      $.fn.extend({
        chosen: function chosen(options) {
          if (!AbstractChosen.browser_is_supported()) {
            return this;
          }

          return this.each(function (input_field) {
            var $this;
            $this = $(this);

            if (!$this.hasClass("chzn-done")) {
              return $this.data('chosen', new Chosen(this, options));
            }
          });
        }
      });

      Chosen = function (_super) {
        __extends(Chosen, _super);

        function Chosen() {
          _ref = Chosen.__super__.constructor.apply(this, arguments);
          return _ref;
        }

        Chosen.prototype.setup = function () {
          this.form_field_jq = $(this.form_field);
          this.current_selectedIndex = this.form_field.selectedIndex;
          return this.is_rtl = this.form_field_jq.hasClass("chzn-rtl");
        };

        Chosen.prototype.finish_setup = function () {
          return this.form_field_jq.addClass("chzn-done");
        };

        Chosen.prototype.set_up_html = function () {
          var _context70, _context71, _context72, _context73;

          var container_classes, container_props;
          this.container_id = this.form_field.id.length ? this.form_field.id.replace(/[^\w]/g, '_') : this.generate_field_id();
          this.container_id += "_chzn";
          container_classes = ["chzn-container"];
          container_classes.push("chzn-container-" + (this.is_multiple ? "multi" : "single"));

          if (this.inherit_select_classes && this.form_field.className) {
            container_classes.push(this.form_field.className);
          }

          if (this.is_rtl) {
            container_classes.push("chzn-rtl");
          }

          container_props = {
            'id': this.container_id,
            'class': container_classes.join(' '),
            'style': "width: " + this.container_width() + ";",
            'title': this.form_field.title
          };
          this.container = $("<div></div>", container_props);

          if (this.is_multiple) {
            this.container.html('<ul class="chzn-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chzn-drop"><ul class="chzn-results"></ul></div>');
          } else {
            this.container.html('<a href="javascript:void(0)" class="chzn-single chzn-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chzn-drop"><div class="chzn-search"><input type="text" autocomplete="off" /></div><ul class="chzn-results"></ul></div>');
          }

          this.form_field_jq.hide().after(this.container);
          this.dropdown = (0, _find.default)(_context70 = this.container).call(_context70, 'div.chzn-drop').first();
          this.search_field = (0, _find.default)(_context71 = this.container).call(_context71, 'input').first();
          this.search_results = (0, _find.default)(_context72 = this.container).call(_context72, 'ul.chzn-results').first();
          this.search_field_scale();
          this.search_no_results = (0, _find.default)(_context73 = this.container).call(_context73, 'li.no-results').first();

          if (this.is_multiple) {
            var _context74, _context75;

            this.search_choices = (0, _find.default)(_context74 = this.container).call(_context74, 'ul.chzn-choices').first();
            this.search_container = (0, _find.default)(_context75 = this.container).call(_context75, 'li.search-field').first();
          } else {
            var _context76, _context77;

            this.search_container = (0, _find.default)(_context76 = this.container).call(_context76, 'div.chzn-search').first();
            this.selected_item = (0, _find.default)(_context77 = this.container).call(_context77, '.chzn-single').first();
          }

          this.results_build();
          this.set_tab_index();
          this.set_label_behavior();
          return this.form_field_jq.trigger("liszt:ready", {
            chosen: this
          });
        };

        Chosen.prototype.register_observers = function () {
          var _context78, _context79, _context80, _context81;

          var _this = this;

          this.container.mousedown(function (evt) {
            _this.container_mousedown(evt);
          });
          this.container.mouseup(function (evt) {
            _this.container_mouseup(evt);
          });
          this.container.mouseenter(function (evt) {
            _this.mouse_enter(evt);
          });
          this.container.mouseleave(function (evt) {
            _this.mouse_leave(evt);
          });
          this.search_results.mouseup(function (evt) {
            _this.search_results_mouseup(evt);
          });
          this.search_results.mouseover(function (evt) {
            _this.search_results_mouseover(evt);
          });
          this.search_results.mouseout(function (evt) {
            _this.search_results_mouseout(evt);
          });
          (0, _bind.default)(_context78 = this.search_results).call(_context78, 'mousewheel DOMMouseScroll', function (evt) {
            _this.search_results_mousewheel(evt);
          });
          (0, _bind.default)(_context79 = this.form_field_jq).call(_context79, "liszt:updated", function (evt) {
            _this.results_update_field(evt);
          });
          (0, _bind.default)(_context80 = this.form_field_jq).call(_context80, "liszt:activate", function (evt) {
            _this.activate_field(evt);
          });
          (0, _bind.default)(_context81 = this.form_field_jq).call(_context81, "liszt:open", function (evt) {
            _this.container_mousedown(evt);
          });
          this.search_field.blur(function (evt) {
            _this.input_blur(evt);
          });
          this.search_field.keyup(function (evt) {
            _this.keyup_checker(evt);
          });
          this.search_field.keydown(function (evt) {
            _this.keydown_checker(evt);
          });
          this.search_field.focus(function (evt) {
            _this.input_focus(evt);
          });

          if (this.is_multiple) {
            return this.search_choices.click(function (evt) {
              _this.choices_click(evt);
            });
          } else {
            return this.container.click(function (evt) {
              evt.preventDefault();
            });
          }
        };

        Chosen.prototype.search_field_disabled = function () {
          this.is_disabled = this.form_field_jq[0].disabled;

          if (this.is_disabled) {
            this.container.addClass('chzn-disabled');
            this.search_field[0].disabled = true;

            if (!this.is_multiple) {
              this.selected_item.unbind("focus", this.activate_action);
            }

            return this.close_field();
          } else {
            this.container.removeClass('chzn-disabled');
            this.search_field[0].disabled = false;

            if (!this.is_multiple) {
              var _context82;

              return (0, _bind.default)(_context82 = this.selected_item).call(_context82, "focus", this.activate_action);
            }
          }
        };

        Chosen.prototype.container_mousedown = function (evt) {
          if (!this.is_disabled) {
            if (evt && evt.type === "mousedown" && !this.results_showing) {
              evt.preventDefault();
            }

            if (!(evt != null && $(evt.target).hasClass("search-choice-close"))) {
              if (!this.active_field) {
                if (this.is_multiple) {
                  this.search_field.val("");
                }

                $(document).click(this.click_test_action);
                this.results_show();
              } else if (!this.is_multiple && evt && ($(evt.target)[0] === this.selected_item[0] || $(evt.target).parents("a.chzn-single").length)) {
                evt.preventDefault();
                this.results_toggle();
              }

              return this.activate_field();
            }
          }
        };

        Chosen.prototype.container_mouseup = function (evt) {
          if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
            return this.results_reset(evt);
          }
        };

        Chosen.prototype.search_results_mousewheel = function (evt) {
          var delta, _ref1, _ref2;

          delta = -((_ref1 = evt.originalEvent) != null ? _ref1.wheelDelta : void 0) || ((_ref2 = evt.originialEvent) != null ? _ref2.detail : void 0);

          if (delta != null) {
            evt.preventDefault();

            if (evt.type === 'DOMMouseScroll') {
              delta = delta * 40;
            }

            return this.search_results.scrollTop(delta + this.search_results.scrollTop());
          }
        };

        Chosen.prototype.blur_test = function (evt) {
          if (!this.active_field && this.container.hasClass("chzn-container-active")) {
            return this.close_field();
          }
        };

        Chosen.prototype.close_field = function () {
          $(document).unbind("click", this.click_test_action);
          this.active_field = false;
          this.results_hide();
          this.container.removeClass("chzn-container-active");
          this.clear_backstroke();
          this.show_search_field_default();
          return this.search_field_scale();
        };

        Chosen.prototype.activate_field = function () {
          this.container.addClass("chzn-container-active");
          this.active_field = true;
          this.search_field.val(this.search_field.val());
          return this.search_field.focus();
        };

        Chosen.prototype.test_active_click = function (evt) {
          if ($(evt.target).parents('#' + this.container_id).length) {
            return this.active_field = true;
          } else {
            return this.close_field();
          }
        };

        Chosen.prototype.results_build = function () {
          var content, data, _i, _len, _ref1;

          this.parsing = true;
          this.selected_option_count = null;
          this.results_data = root.SelectParser.select_to_array(this.form_field);

          if (this.is_multiple) {
            var _context83;

            (0, _find.default)(_context83 = this.search_choices).call(_context83, "li.search-choice").remove();
          } else if (!this.is_multiple) {
            var _context84;

            (0, _find.default)(_context84 = this.selected_item.addClass("chzn-default")).call(_context84, "span").text(this.default_text);

            if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
              this.search_field[0].readOnly = true;
              this.container.addClass("chzn-container-single-nosearch");
            } else {
              this.search_field[0].readOnly = false;
              this.container.removeClass("chzn-container-single-nosearch");
            }
          }

          content = '';
          _ref1 = this.results_data;

          for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
            data = _ref1[_i];

            if (data.group) {
              content += this.result_add_group(data);
            } else if (!data.empty) {
              content += this.result_add_option(data);

              if (data.selected && this.is_multiple) {
                this.choice_build(data);
              } else if (data.selected && !this.is_multiple) {
                var _context85;

                (0, _find.default)(_context85 = this.selected_item.removeClass("chzn-default")).call(_context85, "span").text(data.text);

                if (this.allow_single_deselect) {
                  this.single_deselect_control_build();
                }
              }
            }
          }

          this.search_field_disabled();
          this.show_search_field_default();
          this.search_field_scale();
          this.search_results.html(content);
          return this.parsing = false;
        };

        Chosen.prototype.result_add_group = function (group) {
          group.dom_id = this.container_id + "_g_" + group.array_index;
          return '<li id="' + group.dom_id + '" class="group-result">' + $("<div></div>").text(group.label).html() + '</li>';
        };

        Chosen.prototype.result_do_highlight = function (el) {
          var high_bottom, high_top, maxHeight, visible_bottom, visible_top;

          if (el.length) {
            this.result_clear_highlight();
            this.result_highlight = el;
            this.result_highlight.addClass("highlighted");
            maxHeight = (0, _parseInt3.default)(this.search_results.css("maxHeight"), 10);
            visible_top = this.search_results.scrollTop();
            visible_bottom = maxHeight + visible_top;
            high_top = this.result_highlight.position().top + this.search_results.scrollTop();
            high_bottom = high_top + this.result_highlight.outerHeight();

            if (high_bottom >= visible_bottom) {
              return this.search_results.scrollTop(high_bottom - maxHeight > 0 ? high_bottom - maxHeight : 0);
            } else if (high_top < visible_top) {
              return this.search_results.scrollTop(high_top);
            }
          }
        };

        Chosen.prototype.result_clear_highlight = function () {
          if (this.result_highlight) {
            this.result_highlight.removeClass("highlighted");
          }

          return this.result_highlight = null;
        };

        Chosen.prototype.results_show = function () {
          if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
            this.form_field_jq.trigger("liszt:maxselected", {
              chosen: this
            });
            return false;
          }

          this.container.addClass("chzn-with-drop");
          this.form_field_jq.trigger("liszt:showing_dropdown", {
            chosen: this
          });
          this.results_showing = true;
          this.search_field.focus();
          this.search_field.val(this.search_field.val());
          return this.winnow_results();
        };

        Chosen.prototype.results_hide = function () {
          if (this.results_showing) {
            this.result_clear_highlight();
            this.container.removeClass("chzn-with-drop");
            this.form_field_jq.trigger("liszt:hiding_dropdown", {
              chosen: this
            });
          }

          return this.results_showing = false;
        };

        Chosen.prototype.set_tab_index = function (el) {
          var ti;

          if (this.form_field_jq.attr("tabindex")) {
            ti = this.form_field_jq.attr("tabindex");
            this.form_field_jq.attr("tabindex", -1);
            return this.search_field.attr("tabindex", ti);
          }
        };

        Chosen.prototype.set_label_behavior = function () {
          var _this = this;

          this.form_field_label = this.form_field_jq.parents("label");

          if (!this.form_field_label.length && this.form_field.id.length) {
            this.form_field_label = $("label[for='" + this.form_field.id + "']");
          }

          if (this.form_field_label.length > 0) {
            return this.form_field_label.click(function (evt) {
              if (_this.is_multiple) {
                return _this.container_mousedown(evt);
              } else {
                return _this.activate_field();
              }
            });
          }
        };

        Chosen.prototype.show_search_field_default = function () {
          if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
            this.search_field.val(this.default_text);
            return this.search_field.addClass("default");
          } else {
            this.search_field.val("");
            return this.search_field.removeClass("default");
          }
        };

        Chosen.prototype.search_results_mouseup = function (evt) {
          var target;
          target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();

          if (target.length) {
            this.result_highlight = target;
            this.result_select(evt);
            return this.search_field.focus();
          }
        };

        Chosen.prototype.search_results_mouseover = function (evt) {
          var target;
          target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();

          if (target) {
            return this.result_do_highlight(target);
          }
        };

        Chosen.prototype.search_results_mouseout = function (evt) {
          if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
            return this.result_clear_highlight();
          }
        };

        Chosen.prototype.choice_build = function (item) {
          var choice,
              close_link,
              _this = this;

          choice = $('<li></li>', {
            "class": "search-choice"
          }).html("<span>" + item.html + "</span>");

          if (item.disabled) {
            choice.addClass('search-choice-disabled');
          } else {
            close_link = $('<a></a>', {
              href: '#',
              "class": 'search-choice-close',
              rel: item.array_index
            });
            close_link.click(function (evt) {
              return _this.choice_destroy_link_click(evt);
            });
            choice.append(close_link);
          }

          return this.search_container.before(choice);
        };

        Chosen.prototype.choice_destroy_link_click = function (evt) {
          evt.preventDefault();
          evt.stopPropagation();

          if (!this.is_disabled) {
            return this.choice_destroy($(evt.target));
          }
        };

        Chosen.prototype.choice_destroy = function (link) {
          if (this.result_deselect(link.attr("rel"))) {
            this.show_search_field_default();

            if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
              this.results_hide();
            }

            link.parents('li').first().remove();
            return this.search_field_scale();
          }
        };

        Chosen.prototype.results_reset = function () {
          var _context86;

          this.form_field.options[0].selected = true;
          this.selected_option_count = null;
          (0, _find.default)(_context86 = this.selected_item).call(_context86, "span").text(this.default_text);

          if (!this.is_multiple) {
            this.selected_item.addClass("chzn-default");
          }

          this.show_search_field_default();
          this.results_reset_cleanup();
          this.form_field_jq.trigger("change");

          if (this.active_field) {
            return this.results_hide();
          }
        };

        Chosen.prototype.results_reset_cleanup = function () {
          var _context87;

          this.current_selectedIndex = this.form_field.selectedIndex;
          return (0, _find.default)(_context87 = this.selected_item).call(_context87, "abbr").remove();
        };

        Chosen.prototype.result_select = function (evt) {
          var high, high_id, item, position;

          if (this.result_highlight) {
            high = this.result_highlight;
            high_id = high.attr("id");
            this.result_clear_highlight();

            if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
              this.form_field_jq.trigger("liszt:maxselected", {
                chosen: this
              });
              return false;
            }

            if (this.is_multiple) {
              high.removeClass("active-result");
            } else {
              var _context88;

              (0, _find.default)(_context88 = this.search_results).call(_context88, ".result-selected").removeClass("result-selected");
              this.result_single_selected = high;
              this.selected_item.removeClass("chzn-default");
            }

            high.addClass("result-selected");
            position = high_id.substr((0, _lastIndexOf.default)(high_id).call(high_id, "_") + 1);
            item = this.results_data[position];
            item.selected = true;
            this.form_field.options[item.options_index].selected = true;
            this.selected_option_count = null;

            if (this.is_multiple) {
              this.choice_build(item);
            } else {
              var _context89;

              (0, _find.default)(_context89 = this.selected_item).call(_context89, "span").first().text(item.text);

              if (this.allow_single_deselect) {
                this.single_deselect_control_build();
              }
            }

            if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
              this.results_hide();
            }

            this.search_field.val("");

            if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
              this.form_field_jq.trigger("change", {
                'selected': this.form_field.options[item.options_index].value
              });
            }

            this.current_selectedIndex = this.form_field.selectedIndex;
            return this.search_field_scale();
          }
        };

        Chosen.prototype.result_activate = function (el, option) {
          if (option.disabled) {
            return el.addClass("disabled-result");
          } else if (this.is_multiple && option.selected) {
            return el.addClass("result-selected");
          } else {
            return el.addClass("active-result");
          }
        };

        Chosen.prototype.result_deactivate = function (el) {
          return el.removeClass("active-result result-selected disabled-result");
        };

        Chosen.prototype.result_deselect = function (pos) {
          var result, result_data;
          result_data = this.results_data[pos];

          if (!this.form_field.options[result_data.options_index].disabled) {
            result_data.selected = false;
            this.form_field.options[result_data.options_index].selected = false;
            this.selected_option_count = null;
            result = $("#" + this.container_id + "_o_" + pos);
            result.removeClass("result-selected").addClass("active-result").show();
            this.result_clear_highlight();
            this.winnow_results();
            this.form_field_jq.trigger("change", {
              deselected: this.form_field.options[result_data.options_index].value
            });
            this.search_field_scale();
            return true;
          } else {
            return false;
          }
        };

        Chosen.prototype.single_deselect_control_build = function () {
          var _context90;

          if (!this.allow_single_deselect) {
            return;
          }

          if (!(0, _find.default)(_context90 = this.selected_item).call(_context90, "abbr").length) {
            var _context91;

            (0, _find.default)(_context91 = this.selected_item).call(_context91, "span").first().after("<abbr class=\"search-choice-close\"></abbr>");
          }

          return this.selected_item.addClass("chzn-single-with-deselect");
        };

        Chosen.prototype.winnow_results = function () {
          var found, option, part, parts, regex, regexAnchor, result, result_id, results, searchText, startpos, text, zregex, _i, _j, _len, _len1, _ref1;

          this.no_results_clear();
          results = 0;
          searchText = this.search_field.val() === this.default_text ? "" : $('<div></div>').text((0, _trim.default)($).call($, this.search_field.val())).html();
          regexAnchor = this.search_contains ? "" : "^";
          regex = new RegExp(regexAnchor + searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
          zregex = new RegExp(searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
          _ref1 = this.results_data;

          for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
            option = _ref1[_i];

            if (!option.empty) {
              if (option.group) {
                $('#' + option.dom_id).css('display', 'none');
              } else {
                var _context92, _context93;

                found = false;
                result_id = option.dom_id;
                result = $("#" + result_id);

                if (regex.test(option.html)) {
                  found = true;
                  results += 1;
                } else if (this.enable_split_word_search && ((0, _indexOf.default)(_context92 = option.html).call(_context92, " ") >= 0 || (0, _indexOf.default)(_context93 = option.html).call(_context93, "[") === 0)) {
                  parts = option.html.replace(/\[|\]/g, "").split(" ");

                  if (parts.length) {
                    for (_j = 0, _len1 = parts.length; _j < _len1; _j++) {
                      part = parts[_j];

                      if (regex.test(part)) {
                        found = true;
                        results += 1;
                      }
                    }
                  }
                }

                if (found) {
                  if (searchText.length) {
                    startpos = option.html.search(zregex);
                    text = option.html.substr(0, startpos + searchText.length) + '</em>' + option.html.substr(startpos + searchText.length);
                    text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
                  } else {
                    text = option.html;
                  }

                  result.html(text);
                  this.result_activate(result, option);

                  if (option.group_array_index != null) {
                    $("#" + this.results_data[option.group_array_index].dom_id).css('display', 'list-item');
                  }
                } else {
                  if (this.result_highlight && result_id === this.result_highlight.attr('id')) {
                    this.result_clear_highlight();
                  }

                  this.result_deactivate(result);
                }
              }
            }
          }

          if (results < 1 && searchText.length) {
            return this.no_results(searchText);
          } else {
            return this.winnow_results_set_highlight();
          }
        };

        Chosen.prototype.winnow_results_set_highlight = function () {
          var do_high, selected_results;

          if (!this.result_highlight) {
            var _context94, _context95;

            selected_results = !this.is_multiple ? (0, _find.default)(_context94 = this.search_results).call(_context94, ".result-selected.active-result") : [];
            do_high = selected_results.length ? selected_results.first() : (0, _find.default)(_context95 = this.search_results).call(_context95, ".active-result").first();

            if (do_high != null) {
              return this.result_do_highlight(do_high);
            }
          }
        };

        Chosen.prototype.no_results = function (terms) {
          var no_results_html;
          no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
          (0, _find.default)(no_results_html).call(no_results_html, "span").first().html(terms);
          return this.search_results.append(no_results_html);
        };

        Chosen.prototype.no_results_clear = function () {
          var _context96;

          return (0, _find.default)(_context96 = this.search_results).call(_context96, ".no-results").remove();
        };

        Chosen.prototype.keydown_arrow = function () {
          var next_sib;

          if (this.results_showing && this.result_highlight) {
            next_sib = this.result_highlight.nextAll("li.active-result").first();

            if (next_sib) {
              return this.result_do_highlight(next_sib);
            }
          } else {
            return this.results_show();
          }
        };

        Chosen.prototype.keyup_arrow = function () {
          var prev_sibs;

          if (!this.results_showing && !this.is_multiple) {
            return this.results_show();
          } else if (this.result_highlight) {
            prev_sibs = this.result_highlight.prevAll("li.active-result");

            if (prev_sibs.length) {
              return this.result_do_highlight(prev_sibs.first());
            } else {
              if (this.choices_count() > 0) {
                this.results_hide();
              }

              return this.result_clear_highlight();
            }
          }
        };

        Chosen.prototype.keydown_backstroke = function () {
          var next_available_destroy;

          if (this.pending_backstroke) {
            var _context97;

            this.choice_destroy((0, _find.default)(_context97 = this.pending_backstroke).call(_context97, "a").first());
            return this.clear_backstroke();
          } else {
            next_available_destroy = this.search_container.siblings("li.search-choice").last();

            if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
              this.pending_backstroke = next_available_destroy;

              if (this.single_backstroke_delete) {
                return this.keydown_backstroke();
              } else {
                return this.pending_backstroke.addClass("search-choice-focus");
              }
            }
          }
        };

        Chosen.prototype.clear_backstroke = function () {
          if (this.pending_backstroke) {
            this.pending_backstroke.removeClass("search-choice-focus");
          }

          return this.pending_backstroke = null;
        };

        Chosen.prototype.keydown_checker = function (evt) {
          var stroke, _ref1;

          stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
          this.search_field_scale();

          if (stroke !== 8 && this.pending_backstroke) {
            this.clear_backstroke();
          }

          switch (stroke) {
            case 8:
              this.backstroke_length = this.search_field.val().length;
              break;

            case 9:
              if (this.results_showing && !this.is_multiple) {
                this.result_select(evt);
              }

              this.mouse_on_container = false;
              break;

            case 13:
              evt.preventDefault();
              break;

            case 38:
              evt.preventDefault();
              this.keyup_arrow();
              break;

            case 40:
              evt.preventDefault();
              this.keydown_arrow();
              break;
          }
        };

        Chosen.prototype.search_field_scale = function () {
          var div, h, style, style_block, styles, w, _i, _len;

          if (this.is_multiple) {
            h = 0;
            w = 0;
            style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
            styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];

            for (_i = 0, _len = styles.length; _i < _len; _i++) {
              style = styles[_i];
              style_block += style + ":" + this.search_field.css(style) + ";";
            }

            div = $('<div></div>', {
              'style': style_block
            });
            div.text(this.search_field.val());
            $('body').append(div);
            w = div.width() + 25;
            div.remove();

            if (!this.f_width) {
              this.f_width = this.container.outerWidth();
            }

            if (w > this.f_width - 10) {
              w = this.f_width - 10;
            }

            return this.search_field.css({
              'width': w + 'px'
            });
          }
        };

        Chosen.prototype.generate_random_id = function () {
          var string;
          string = "sel" + this.generate_random_char() + this.generate_random_char() + this.generate_random_char();

          while ($("#" + string).length > 0) {
            string += this.generate_random_char();
          }

          return string;
        };

        return Chosen;
      }(AbstractChosen);

      root.Chosen = Chosen;
    }).call(this);
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  /***/
},
/* 70 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _SchemaUtil = _interopRequireDefault(__webpack_require__(13));

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  var _DeletableBox = _interopRequireDefault(__webpack_require__(71));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _default = _BaseInput.default.extend({
    className: 'array-input',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        return "<a href=\"#\" class=\"array-inputs-button link-button\">Add Another</a>";
      },
      "useData": true
    }),
    params: {
      itemType: 'string'
    },
    events: {
      'click .array-inputs-button': function clickArrayInputsButton(e) {
        e.preventDefault();

        if (this.isEditMode()) {
          this.addNewElement();
        }
      }
    },
    initialize: function initialize(options) {
      options || (options = {});
      this.params = _underscoreWrapper.default.defaults(options.params || {}, this.params);
      this.uniqueIdPrefix = 'array';
    },
    // api returns null for an array that does not have value
    // convert it to an empty array
    from: function from(val) {
      if (!_underscoreWrapper.default.isArray(val)) {
        return [];
      }

      return val;
    },
    // @Override
    editMode: function editMode() {
      var _context98;

      this._setArrayObject();

      this.$el.html(this.template);

      _underscoreWrapper.default.each(this.arrayObject, (0, _bind.default)(_context98 = _underscoreWrapper.default).call(_context98, this._addDeletableBox, this));

      return this;
    },
    // @Override
    readMode: function readMode() {
      this.editMode();
      this.$('.array-inputs-button').addClass('link-button-disabled');
    },
    // @Override
    // converts arrayObject to a plain array
    // for string type array, returns all values
    // for number/integer type array, returns values in number type
    val: function val() {
      var _context99;

      var values = (0, _values.default)(_context99 = _underscoreWrapper.default).call(_context99, this.arrayObject);

      if (_underscoreWrapper.default.contains([_SchemaUtil.default.DATATYPE.number, _SchemaUtil.default.DATATYPE.integer], this.params.itemType)) {
        var _context100;

        values = (0, _filter.default)(_context100 = _underscoreWrapper.default).call(_context100, values, _underscoreWrapper.default.isNumber);
      }

      return values;
    },
    focus: function focus() {},
    addNewElement: function addNewElement() {
      var value = '';

      var key = _underscoreWrapper.default.uniqueId(this.uniqueIdPrefix);

      this.arrayObject[key] = value;

      this._addDeletableBox(value, key); // update is called to make sure an empty string value is added for string type array


      this.update();
    },
    _addDeletableBox: function _addDeletableBox(value, key) {
      var deletableBox = new _DeletableBox.default(_underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this.options, 'read', 'readOnly', 'model'), {
        key: key,
        value: value,
        itemType: this.params.itemType
      }));
      this.listenTo(deletableBox, 'updateArray', function (updatedValue) {
        if (_underscoreWrapper.default.isNull(updatedValue)) {
          delete this.arrayObject[key];
          this.stopListening(deletableBox);
        } else {
          this.arrayObject[key] = updatedValue;
        }

        this.update();
      });
      deletableBox.render().$el.hide();
      this.$('.array-inputs-button').before(deletableBox.el);
      deletableBox.$el.slideDown();
      return deletableBox;
    },
    _setArrayObject: function _setArrayObject() {
      var array = this.model.get(this.options.name);
      this.arrayObject = {};

      if (_underscoreWrapper.default.isArray(array) && !_underscoreWrapper.default.isEmpty(array)) {
        var keys = [];
        var self = this;
        (0, _underscoreWrapper.default)(array.length).times(function () {
          keys.push(_underscoreWrapper.default.uniqueId(self.uniqueIdPrefix));
        });
        this.arrayObject = _underscoreWrapper.default.object(keys, array);
      }
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 71 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _SchemaUtil = _interopRequireDefault(__webpack_require__(13));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _Time = _interopRequireDefault(__webpack_require__(30));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var isVowel = function isVowel(string) {
    return /^[aeiou]/.test(string);
  };

  var getArticle = function getArticle(string) {
    return isVowel(string) ? 'an' : 'a';
  };

  var template = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"o-form-input-group-controls\"><span class=\"input-fix o-form-control\"><input type=\"text\" class=\"o-form-text\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "key",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 125
          },
          "end": {
            "line": 1,
            "column": 132
          }
        }
      }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "key",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 138
          },
          "end": {
            "line": 1,
            "column": 145
          }
        }
      }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "value",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 154
          },
          "end": {
            "line": 1,
            "column": 163
          }
        }
      }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "placeholder",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 178
          },
          "end": {
            "line": 1,
            "column": 193
          }
        }
      }) : helper)) + "\"/></span><a href=\"#\" class=\"link-button link-button-icon icon-only\"><span class=\"icon clear-input-16 \"></span></a></div><p class=\"o-form-input-error o-form-explain\"><span class=\"icon icon-16 error-16-small\"></span>" + alias4((helper = (helper = lookupProperty(helpers, "errorExplain") || (depth0 != null ? lookupProperty(depth0, "errorExplain") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "errorExplain",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 408
          },
          "end": {
            "line": 1,
            "column": 424
          }
        }
      }) : helper)) + "</p>";
    },
    "useData": true
  });

  var errorClass = 'o-form-has-errors';
  var updateArrayEvent = 'updateArray';

  var _default = _BaseView.default.extend({
    tagName: 'div',
    className: 'o-form-input-group',
    events: {
      'click a': function clickA(e) {
        e.preventDefault();
        this.remove();
      },
      'keyup input': function keyupInput() {
        this.update();
      }
    },
    isEditMode: function isEditMode() {
      return !this.options.readOnly && (this.options.read !== true || this.model.get('__edit__') === true);
    },
    initialize: function initialize() {
      this.template = template(_underscoreWrapper.default.extend(this.options, {
        placeholder: this.getPlaceholderText(),
        errorExplain: this.getErrorExplainText()
      }));
      this.update = _underscoreWrapper.default.debounce(this.update, this.options.debounceDelay || _Time.default.DEBOUNCE_DELAY);
    },
    render: function render() {
      if (this.isEditMode()) {
        this.$el.html(this.template);
      } else {
        this.$el.text(this.options.value);
        this.$('a').hide();
      }

      return this;
    },
    remove: function remove() {
      var _arguments = arguments,
          _this = this;

      this.trigger(updateArrayEvent, null);
      this.$el.slideUp(function () {
        _BaseView.default.prototype.remove.call(_this, _arguments);
      });
    },
    update: function update() {
      var updatedValue = this.$('input').val();

      var parseFunc = _underscoreWrapper.default.object([_SchemaUtil.default.DATATYPE.number, _SchemaUtil.default.DATATYPE.integer], [_StringUtil.default.parseFloat, this.parseInt]);

      if (_underscoreWrapper.default.has(parseFunc, this.options.itemType)) {
        updatedValue = parseFunc[this.options.itemType](updatedValue);
        !_underscoreWrapper.default.isNumber(updatedValue) ? this.markInvalid() : this.clearInvalid();
      }

      this.trigger(updateArrayEvent, updatedValue);
    },
    markInvalid: function markInvalid() {
      this.$el.addClass(errorClass);
    },
    clearInvalid: function clearInvalid() {
      this.$el.removeClass(errorClass);
    },
    getPlaceholderText: function getPlaceholderText() {
      var text = ['Enter'];
      text.push(getArticle(this.options.itemType));
      text.push(this.options.itemType.toLowerCase());
      return text.join(' ');
    },
    getErrorExplainText: function getErrorExplainText() {
      var text = ['Value must be'];
      text.push(getArticle(this.options.itemType));
      text.push(this.options.itemType.toLowerCase());
      return text.join(' ');
    },
    parseInt: function (_parseInt) {
      function parseInt(_x) {
        return _parseInt.apply(this, arguments);
      }

      parseInt.toString = function () {
        return _parseInt.toString();
      };

      return parseInt;
    }(function (string) {
      // native javascript parseInt is aggressive
      // there're cases we don't want a string to be parsed even though it is convertable
      // so that we don't convert a string silently before warning a user the potential error
      // this is to make sure the string is in an integer format before we parse it
      if (/^-?\d+$/.test(string)) {
        var num = (0, _parseInt3.default)(string, 10);
        return !_underscoreWrapper.default.isNaN(num) ? num : string;
      }

      return string;
    })
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 72 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  __webpack_require__(31);

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var _default = _BaseInput.default.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<input type=\"checkbox\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "name",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 29
            },
            "end": {
              "line": 1,
              "column": 37
            }
          }
        }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 43
            },
            "end": {
              "line": 1,
              "column": 54
            }
          }
        }) : helper)) + "\"/><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 69
            },
            "end": {
              "line": 1,
              "column": 80
            }
          }
        }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "name",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 100
            },
            "end": {
              "line": 1,
              "column": 108
            }
          }
        }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "placeholder",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 110
            },
            "end": {
              "line": 1,
              "column": 125
            }
          }
        }) : helper)) + "</label>";
      },
      "useData": true
    }),

    /**
     * @Override
     */
    events: {
      'change :checkbox': 'update',
      keyup: function keyup(e) {
        if (_Keys.default.isSpaceBar(e)) {
          this.$(':checkbox').click();
        } else if (_Keys.default.isEnter(e)) {
          this.model.trigger('form:save');
        }
      }
    },

    /**
     * @Override
     */
    editMode: function editMode() {
      var placeholder = _underscoreWrapper.default.resultCtx(this.options, 'placeholder', this);

      if (placeholder === '') {
        placeholder = _underscoreWrapper.default.resultCtx(this.options, 'label', this);
      } else if (placeholder === false) {
        placeholder = '';
      }

      this.$el.html(this.template(_underscoreWrapper.default.extend(_underscoreWrapper.default.omit(this.options, 'placeholder'), {
        placeholder: placeholder
      })));
      var $input = this.$(':checkbox');
      $input.prop('checked', this.getModelValue() || false);
      this.$('input').customInput();
      this.model.trigger('form:resize');
      return this;
    },

    /**
     * @Override
     */
    readMode: function readMode() {
      this.editMode();
      this.$(':checkbox').prop('disabled', true);
      return this;
    },

    /**
     * @Override
     */
    val: function val() {
      return this.$(':checkbox').prop('checked');
    },

    /**
     * @Override
     */
    focus: function focus() {
      return this.$(':checkbox').focus();
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 73 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _TextBox = _interopRequireDefault(__webpack_require__(32));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /*!
   * Copyright (c) 2015-2018, Okta, Inc. and/or its affiliates. All rights reserved.
   * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
   *
   * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
   * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   *
   * See the License for the specific language governing permissions and limitations under the License.
   */


  var toggleTemplate = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<span class=\"password-toggle\"><span class=\"eyeicon visibility-16 button-show\"></span><span class=\"eyeicon visibility-off-16 button-hide\"></span></span>";
    },
    "useData": true
  });

  var toggleTimeout = 30000;

  var _default = _TextBox.default.extend({
    initialize: function initialize() {
      if (this.__showPasswordToggle()) {
        this.events['click .password-toggle .button-show'] = '__showPassword';
        this.events['click .password-toggle .button-hide'] = '__hidePassword';
      }

      this.delegateEvents();
    },
    postRender: function postRender() {
      if (this.isEditMode() && this.__showPasswordToggle()) {
        var _context101;

        this.$el.append(toggleTemplate);
        (0, _find.default)(_context101 = this.$el).call(_context101, 'input[type="password"]').addClass('password-with-toggle');
      }

      _TextBox.default.prototype.postRender.apply(this, arguments);
    },
    __showPasswordToggle: function __showPasswordToggle() {
      return this.options.params && this.options.params.showPasswordToggle;
    },
    __showPassword: function __showPassword() {
      var _this = this;

      _TextBox.default.prototype.changeType.apply(this, ['text']);

      this.$('.password-toggle .button-show').hide();
      this.$('.password-toggle .button-hide').show();
      this.passwordToggleTimer = _underscoreWrapper.default.delay(function () {
        _this.__hidePassword();
      }, toggleTimeout);
    },
    __hidePassword: function __hidePassword() {
      _TextBox.default.prototype.changeType.apply(this, ['password']);

      this.$('.password-toggle .button-show').show();
      this.$('.password-toggle .button-hide').hide(); // clear timeout

      if (this.passwordToggleTimer) {
        clearTimeout(this.passwordToggleTimer);
      }
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 74 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
  /*! http://mths.be/placeholder v2.0.7 by @mathias */


  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
    var isInputSupported = ('placeholder' in document.createElement('input')),
        isTextareaSupported = ('placeholder' in document.createElement('textarea')),
        prototype = $.fn,
        valHooks = $.valHooks,
        hooks,
        placeholder;

    if (isInputSupported && isTextareaSupported) {
      placeholder = prototype.placeholder = function () {
        return this;
      };

      placeholder.input = placeholder.textarea = true;
    } else {
      var _context103;

      placeholder = prototype.placeholder = function () {
        var _context102;

        var $this = this;
        (0, _bind.default)(_context102 = (0, _filter.default)($this).call($this, (isInputSupported ? 'textarea' : ':input') + '[placeholder]').not('.placeholder')).call(_context102, {
          'focus.placeholder': clearPlaceholder,
          'blur.placeholder': setPlaceholder
        }).data('placeholder-enabled', true).trigger('blur.placeholder');
        return $this;
      };

      placeholder.input = isInputSupported;
      placeholder.textarea = isTextareaSupported;
      hooks = {
        'get': function get(element) {
          var $element = $(element);
          return $element.data('placeholder-enabled') && $element.hasClass('placeholder') ? '' : element.value;
        },
        'set': function set(element, value) {
          var $element = $(element);

          if (!$element.data('placeholder-enabled')) {
            return element.value = value;
          }

          if (value == '') {
            element.value = value; // Issue #56: Setting the placeholder causes problems if the element continues to have focus.

            if (element != document.activeElement) {
              // We can't use `triggerHandler` here because of dummy text/password inputs :(
              setPlaceholder.call(element);
            }
          } else if ($element.hasClass('placeholder')) {
            clearPlaceholder.call(element, true, value) || (element.value = value);
          } else {
            element.value = value;
          } // `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363


          return $element;
        }
      };
      isInputSupported || (valHooks.input = hooks);
      isTextareaSupported || (valHooks.textarea = hooks);
      $(function () {
        // Look for forms
        $(document).delegate('form', 'submit.placeholder', function () {
          // Clear the placeholder values so they don't get submitted
          var $inputs = $('.placeholder', this).each(clearPlaceholder);
          (0, _setTimeout2.default)(function () {
            $inputs.each(setPlaceholder);
          }, 10);
        });
      }); // Clear placeholder values upon page reload

      (0, _bind.default)(_context103 = $(window)).call(_context103, 'beforeunload.placeholder', function () {
        $('.placeholder').each(function () {
          this.value = '';
        });
      });
    }

    function args(elem) {
      // Return an object of element attributes
      var newAttrs = {},
          rinlinejQuery = /^jQuery\d+$/;
      $.each(elem.attributes, function (i, attr) {
        if (attr.specified && !rinlinejQuery.test(attr.name)) {
          newAttrs[attr.name] = attr.value;
        }
      });
      return newAttrs;
    }

    function clearPlaceholder(event, value) {
      var input = this,
          $input = $(input);

      if (input.value == $input.attr('placeholder') && $input.hasClass('placeholder')) {
        if ($input.data('placeholder-password')) {
          $input = $input.hide().next().show().attr('id', $input.removeAttr('id').data('placeholder-id')); // If `clearPlaceholder` was called from `$.valHooks.input.set`

          if (event === true) {
            return $input[0].value = value;
          }

          $input.focus();
        } else {
          input.value = '';
          $input.removeClass('placeholder');
          input == document.activeElement && input.select();
        }
      }
    }

    function setPlaceholder() {
      var $replacement,
          input = this,
          $input = $(input),
          $origInput = $input,
          id = this.id;

      if (input.value == '') {
        if (input.type == 'password') {
          if (!$input.data('placeholder-textinput')) {
            var _context104;

            try {
              $replacement = $input.clone().attr({
                'type': 'text'
              });
            } catch (e) {
              $replacement = $('<input>').attr($.extend(args(this), {
                'type': 'text'
              }));
            }

            (0, _bind.default)(_context104 = $replacement.removeAttr('name').data({
              'placeholder-password': true,
              'placeholder-id': id
            })).call(_context104, 'focus.placeholder', clearPlaceholder);
            $input.data({
              'placeholder-textinput': $replacement,
              'placeholder-id': id
            }).before($replacement);
          }

          $input = $input.removeAttr('id').hide().prev().attr('id', id).show(); // Note: `$input[0] != input` now!
        }

        $input.addClass('placeholder');
        $input[0].value = $input.attr('placeholder');
      } else {
        $input.removeClass('placeholder');
      }
    }
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  /***/
},
/* 75 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  var _Util = _interopRequireDefault(__webpack_require__(18));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  __webpack_require__(31);

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var isABaseView = _Util.default.isABaseView;

  var myTmp = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<input type=\"radio\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 26
          },
          "end": {
            "line": 1,
            "column": 34
          }
        }
      }) : helper)) + "\" data-se-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "realName") || (depth0 != null ? lookupProperty(depth0, "realName") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "realName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 50
          },
          "end": {
            "line": 1,
            "column": 62
          }
        }
      }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "value",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 71
          },
          "end": {
            "line": 1,
            "column": 80
          }
        }
      }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "optionId") || (depth0 != null ? lookupProperty(depth0, "optionId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "optionId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 86
          },
          "end": {
            "line": 1,
            "column": 98
          }
        }
      }) : helper)) + "\"><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "optionId") || (depth0 != null ? lookupProperty(depth0, "optionId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "optionId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 112
          },
          "end": {
            "line": 1,
            "column": 124
          }
        }
      }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "realName") || (depth0 != null ? lookupProperty(depth0, "realName") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "realName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 144
          },
          "end": {
            "line": 1,
            "column": 156
          }
        }
      }) : helper)) + "\" class=\"radio-label\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 178
          },
          "end": {
            "line": 1,
            "column": 187
          }
        }
      }) : helper)) + "</label>";
    },
    "useData": true
  });

  var RadioRadioOption = _BaseView.default.extend({
    template: myTmp,
    initialize: function initialize(options) {
      var explain;
      explain = options.explain;

      if (_underscoreWrapper.default.isFunction(explain) && !isABaseView(explain)) {
        explain = _underscoreWrapper.default.resultCtx(this.options, 'explain', this);
      }

      if (!explain) {
        return;
      }

      if (isABaseView(explain)) {
        this.add('<p class="o-form-explain"></p>', '.radio-label');
        this.add(explain, '.o-form-explain');
      } else {
        this.add(_BaseView.default.extend({
          className: 'o-form-explain',
          tagName: 'p',
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var helper,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return container.escapeExpression((helper = (helper = lookupProperty(helpers, "explain") || (depth0 != null ? lookupProperty(depth0, "explain") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "explain",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 11
                  }
                }
              }) : helper));
            },
            "useData": true
          })
        }), '.radio-label');
      }
    }
  });

  var _default = _BaseInput.default.extend({
    /**
     * @Override
     */
    events: {
      'change :radio': 'update',
      keyup: function keyup(e) {
        if (_Keys.default.isSpaceBar(e)) {
          (0, _jqueryWrapper.default)(e.target).click();
        } else if (_Keys.default.isEnter(e)) {
          this.model.trigger('form:save');
        }
      }
    },

    /**
     * @Override
     */
    editMode: function editMode() {
      var templates = [];
      this.$el.empty();

      _underscoreWrapper.default.each(this.options.options, function (value, key) {
        var options = {
          optionId: _underscoreWrapper.default.uniqueId('option'),
          name: this.options.inputId,
          realName: this.options.name,
          value: key
        };

        if (!_underscoreWrapper.default.isObject(value)) {
          value = {
            label: value
          };
        }

        _underscoreWrapper.default.extend(options, value);

        templates.push(new RadioRadioOption(options).render().el);
      }, this);

      this.$el.append(templates);
      var value = this.getModelValue();

      if (value) {
        this.$(':radio[value=' + value + ']').prop('checked', true);
      }

      this.$('input').customInput();
      this.model.trigger('form:resize');

      if (this.getParam('inline') === true) {
        this.$('div.custom-radio').addClass('inline');
      }

      return this;
    },

    /**
     * @Override
     */
    readMode: function readMode() {
      this.editMode();
      this.$(':radio').prop('disabled', true);
      return this;
    },

    /**
     * @Override
     */
    val: function val() {
      return this.$(':radio:checked').val();
    },

    /**
     * @Override
     */
    focus: function focus() {
      return this.$('label:eq(0)').focus();
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 76 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _ButtonFactory = _interopRequireDefault(__webpack_require__(17));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function countInputs(inputs) {
    var _context105;

    return (0, _filter.default)(_context105 = _underscoreWrapper.default).call(_context105, inputs || [], function (input) {
      return !_underscoreWrapper.default.contains(['label', 'button', 'select'], input.type);
    }).length;
  }

  var InputGroupLabelInput = _BaseInput.default.extend({
    tagName: 'span',
    initialize: function initialize() {
      this.$el.text(this.getModelValue());
    },
    editMode: function editMode() {
      this.toggle(true);
    },
    readMode: function readMode() {
      this.toggle(false);
    },
    getModelValue: function getModelValue() {
      return this.options.label;
    },
    toggle: function toggle(isEditMode) {
      this.$el.toggleClass('o-form-label-inline', isEditMode);
      this.$el.toggleClass('o-form-control', !isEditMode);
    },
    focus: _underscoreWrapper.default.noop
  });

  function createButtonInput(options) {
    return _ButtonFactory.default.create(_underscoreWrapper.default.defaults({
      getReadModeString: _underscoreWrapper.default.constant(' '),
      focus: _underscoreWrapper.default.noop
    }, _underscoreWrapper.default.pick(options, 'click', 'title', 'href', 'icon')));
  }

  var InputGroupInputGroupView = _BaseView.default.extend({
    getParams: _BaseInput.default.prototype.getParams,
    getParam: _BaseInput.default.prototype.getParam,
    className: function className() {
      var className;

      if (this.getParam('display') === 'text') {
        className = 'o-form-input-group-subtle';
      } else {
        className = 'o-form-input-group';
      }

      if (countInputs(this.getParam('inputs')) > 1) {
        className += ' o-form-input-group-2';
      }

      return className;
    },
    initialize: function initialize() {
      _underscoreWrapper.default.each(this.getParam('inputs'), function (input) {
        switch (input.type) {
          case 'label':
            this.add(InputGroupLabelInput, {
              options: input
            });
            break;

          case 'button':
            this.add(createButtonInput(input));
            break;

          default:
            input = _underscoreWrapper.default.defaults({
              model: this.model,
              params: _underscoreWrapper.default.extend({
                autoWidth: true
              }, input.params || {})
            }, input);
            this.add(this.getParams().create(input));
        }
      }, this);
    },
    focus: function focus() {
      this.first().focus();
    }
  });

  var _default = _BaseInput.default.extend({
    constructor: function constructor(options) {
      this.inputGroupView = new InputGroupInputGroupView(options);

      _BaseInput.default.apply(this, arguments);
    },
    editMode: function editMode() {
      this.inputGroupView.remove();
      this.inputGroupView = new InputGroupInputGroupView(this.options);
      this.$el.html(this.inputGroupView.render().el);
    },
    toStringValue: function toStringValue() {
      var _context106, _context107;

      var strings = (0, _map.default)(_context106 = this.inputGroupView).call(_context106, function (input) {
        return input.getReadModeString();
      });
      return strings.length && (0, _every.default)(_context107 = _underscoreWrapper.default).call(_context107, strings) ? strings.join(' ') : ' ';
    },
    focus: function focus() {
      this.inputGroupView.focus();
    }
  }, {
    // test hooks
    LabelInput: InputGroupLabelInput,
    InputGroupView: InputGroupInputGroupView
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
}
/******/
]);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(30);
var hide = __webpack_require__(54);
var redefine = __webpack_require__(49);
var ctx = __webpack_require__(66);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(690);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _handlebarsBase = __webpack_require__(311);

var base = _interopRequireWildcard(_handlebarsBase);

// Each of these augment the Handlebars object. No need to setup here.
// (This is done to easily share code between commonjs and browse envs)

var _handlebarsSafeString = __webpack_require__(702);

var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

var _handlebarsException = __webpack_require__(112);

var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

var _handlebarsUtils = __webpack_require__(74);

var Utils = _interopRequireWildcard(_handlebarsUtils);

var _handlebarsRuntime = __webpack_require__(703);

var runtime = _interopRequireWildcard(_handlebarsRuntime);

var _handlebarsNoConflict = __webpack_require__(705);

var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function create() {
  var hb = new base.HandlebarsEnvironment();

  Utils.extend(hb, base);
  hb.SafeString = _handlebarsSafeString2['default'];
  hb.Exception = _handlebarsException2['default'];
  hb.Utils = Utils;
  hb.escapeExpression = Utils.escapeExpression;

  hb.VM = runtime;
  hb.template = function (spec) {
    return runtime.template(spec, hb);
  };

  return hb;
}

var inst = create();
inst.create = create;

_handlebarsNoConflict2['default'](inst);

inst['default'] = inst;

exports['default'] = inst;
module.exports = exports['default'];


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(22);
var getOwnPropertyDescriptor = __webpack_require__(104).f;
var isForced = __webpack_require__(279);
var path = __webpack_require__(15);
var bind = __webpack_require__(88);
var createNonEnumerableProperty = __webpack_require__(61);
var has = __webpack_require__(46);

var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global : STATIC ? global[TARGET] : (global[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = bind(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    target[key] = resultProperty;

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(8), __webpack_require__(126), __webpack_require__(142)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormType, BaseLoginController, BaseLoginModel) {
  var Toolbar = Okta.internal.views.forms.components.Toolbar;
  var FormUtil = Okta.internal.views.forms.helpers.FormUtil;
  var _ = Okta._;
  var SimpleForm = Okta.Form.extend({
    layout: 'o-form-theme',
    noCancelButton: true,
    constructor: function constructor(options) {
      Okta.Form.call(this, options);

      _.each(_.result(this, 'formChildren') || [], function (child) {
        switch (child.type) {
          case FormType.INPUT:
            this.addInput(_.extend({
              label: false,
              'label-top': true
            }, child.viewOptions));
            break;

          case FormType.BUTTON:
            this.add(Okta.createButton(_.extend({
              model: this.model
            }, child.viewOptions)), child.addOptions);
            FormUtil.applyShowWhen(this.last(), child.viewOptions && child.viewOptions.showWhen);
            break;

          case FormType.DIVIDER:
            this.addDivider(child.viewOptions);
            break;

          case FormType.TOOLBAR:
            this.add(Toolbar, {
              options: child.viewOptions
            });
            FormUtil.applyShowWhen(this.last(), child.viewOptions && child.viewOptions.showWhen);
            break;

          case FormType.VIEW:
            this.add(child.viewOptions.View, child.addOptions);
            FormUtil.applyShowWhen(this.last(), child.viewOptions.showWhen);
            break;

          default:
            throw new Error('Unrecognized child type: ' + child.type);
        }
      }, this);
    }
  });
  return BaseLoginController.extend({
    constructor: function constructor() {
      var initialize = this.initialize;

      this.initialize = function () {};

      BaseLoginController.apply(this, arguments);

      if (this.Model && this.Form) {
        var Model = BaseLoginModel.extend(_.extend({
          parse: function parse(attributes) {
            this.settings = attributes.settings;
            this.appState = attributes.appState;
            return _.omit(attributes, ['settings', 'appState']);
          }
        }, _.result(this, 'Model')));
        this.model = new Model({
          settings: this.settings,
          appState: this.options.appState
        }, {
          parse: true
        });
        var Form = SimpleForm.extend(_.result(this, 'Form', this));
        this.form = new Form(this.toJSON());
        this.add(this.form);
      }

      if (this.Footer) {
        this.addFooter(this.Footer);
      }

      this.addListeners();
      initialize.apply(this, arguments);
    },
    addFooter: function addFooter(Footer, args) {
      this.footer = new Footer(_.extend(this.toJSON(), args || {}));
      this.add(this.footer);
    },
    toJSON: function toJSON() {
      var data = BaseLoginController.prototype.toJSON.apply(this, arguments);
      return _.extend(_.pick(this.options, 'appState'), data);
    },
    back: function back() {
      if (this.footer && this.footer.back) {
        this.footer.back();
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(670);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  // Syntactic sugar to provide some structure to SimpleForm inputs - Just
  // wraps options with { type: type, viewOptions: viewOptions, addOptions: addOptions }
  var INPUT = 'INPUT';
  var BUTTON = 'BUTTON';
  var DIVIDER = 'DIVIDER';
  var TOOLBAR = 'TOOLBAR';
  var VIEW = 'VIEW';

  function wrap(type) {
    return function (viewOptions, addOptions) {
      return {
        type: type,
        viewOptions: viewOptions,
        addOptions: addOptions
      };
    };
  }

  return {
    Input: wrap(INPUT),
    Button: wrap(BUTTON),
    Divider: wrap(DIVIDER),
    Toolbar: wrap(TOOLBAR),
    View: wrap(VIEW),
    INPUT: INPUT,
    BUTTON: BUTTON,
    DIVIDER: DIVIDER,
    TOOLBAR: TOOLBAR,
    VIEW: VIEW
  };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(7));

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _find = _interopRequireDefault(__webpack_require__(18));

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _map = _interopRequireDefault(__webpack_require__(41));

var _okta = __webpack_require__(0);

var _FormInputFactory = _interopRequireDefault(__webpack_require__(364));

var _default = _okta.Form.extend({
  layout: 'o-form-theme',
  className: 'ion-form',
  hasSavingState: true,
  autoSave: false,
  noCancelButton: true,
  title: function title() {
    return (0, _okta.loc)('oform.title.authenticate', 'login');
  },
  save: (0, _okta.loc)('oform.next', 'login'),
  modelEvents: {
    'clearFormError': 'handleClearFormError',
    'error': 'triggerAfterError'
  },
  initialize: function initialize() {
    var _this = this;

    var uiSchemas = this.getUISchema();
    var inputOptions = (0, _map.default)(uiSchemas).call(uiSchemas, _FormInputFactory.default.create); //should be used before adding any other input components

    this.showMessages();
    (0, _forEach.default)(inputOptions).call(inputOptions, function (input) {
      _this.addInputOrView(input);
    });
    this.listenTo(this, 'save', this.saveForm);
  },
  handleClearFormError: function handleClearFormError() {
    if (this.$('.o-form-error-container').hasClass('o-form-has-errors')) {
      this.clearErrors();
    }
  },
  triggerAfterError: function triggerAfterError(model, error) {
    this.options.appState.trigger('afterError', error);
  },
  saveForm: function saveForm(model) {
    var _context;

    //remove any existing warnings or messages before saving form
    (0, _find.default)(_context = this.$el).call(_context, '.o-form-error-container').empty();
    this.options.appState.trigger('saveForm', model);
  },
  getUISchema: function getUISchema() {
    if ((0, _isArray.default)(this.options.currentViewState.uiSchema)) {
      return this.options.currentViewState.uiSchema;
    } else {
      return [];
    }
  },
  addInputOrView: function addInputOrView(input) {
    if (input.visible === false || input.mutable === false) {
      return;
    }

    if (input.View) {
      this.add(input.View, _okta._.omit(input, 'View'));
    } else {
      this.addInput(input);
    }

    if ((0, _isArray.default)(input.optionsUiSchemas)) {
      if (this.options.optionUiSchemaConfig[input.name]) {
        var _context2;

        var optionUiSchemaIndex = Number(this.options.optionUiSchemaConfig[input.name]);
        var optionUiSchemas = input.optionsUiSchemas[optionUiSchemaIndex] || [];
        (0, _forEach.default)(optionUiSchemas).call(optionUiSchemas, (0, _bind.default)(_context2 = this.addInputOrView).call(_context2, this));
      }
    }
  },
  showMessages: function showMessages() {
    // render messages as text
    var messagesObjs = this.options.appState.get('messages');

    if (messagesObjs === null || messagesObjs === void 0 ? void 0 : messagesObjs.value.length) {
      var _context3;

      var content = (0, _map.default)(_context3 = messagesObjs.value).call(_context3, function (messagesObj) {
        return messagesObj.message;
      });
      this.add("<div class=\"ion-messages-container\">".concat(content.join(' '), "</div>"), '.o-form-error-container');
    }
  }
});

exports.default = _default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(module.exports = {
  API_RATE_LIMIT: 30000,
  //milliseconds
  WIDGET_CONTAINER_ID: 'okta-sign-in',
  WIDGET_CONFIG_COLORS_ID: 'okta-sign-in-config-colors',
  DIRECTION_BACK: 'DIRECTION_BACK',
  RECOVERY_TYPE_PASSWORD: 'PASSWORD',
  RECOVERY_TYPE_UNLOCK: 'UNLOCK',
  RECOVERY_FACTOR_TYPE_SMS: 'SMS',
  RECOVERY_FACTOR_TYPE_EMAIL: 'EMAIL',
  RECOVERY_FACTOR_TYPE_CALL: 'CALL',
  // Global success messages
  SUCCESS: 'SUCCESS',
  FORGOT_PASSWORD_EMAIL_SENT: 'FORGOT_PASSWORD_EMAIL_SENT',
  UNLOCK_ACCOUNT_EMAIL_SENT: 'UNLOCK_ACCOUNT_EMAIL_SENT',
  // Global error messages
  CONFIG_ERROR: 'CONFIG_ERROR',
  UNSUPPORTED_BROWSER_ERROR: 'UNSUPPORTED_BROWSER_ERROR',
  OAUTH_ERROR: 'OAUTH_ERROR',
  AUTH_STOP_POLL_INITIATION_ERROR: 'AUTH_STOP_POLL_INITIATION_ERROR',
  U2F_ERROR: 'U2F_ERROR',
  WEB_AUTHN_ERROR: 'WEB_AUTHN_ERROR',
  WEBAUTHN_ABORT_ERROR: 'WEBAUTHN_ABORT_ERROR',
  // Enroll choice page types
  ALL_OPTIONAL_NONE_ENROLLED: 'ALL_OPTIONAL_NONE_ENROLLED',
  ALL_OPTIONAL_SOME_ENROLLED: 'ALL_OPTIONAL_SOME_ENROLLED',
  HAS_REQUIRED_NONE_ENROLLED: 'HAS_REQUIRED_NONE_ENROLLED',
  HAS_REQUIRED_SOME_REQUIRED_ENROLLED: 'HAS_REQUIRED_SOME_REQUIRED_ENROLLED',
  HAS_REQUIRED_ALL_REQUIRED_ENROLLED: 'HAS_REQUIRED_ALL_REQUIRED_ENROLLED',
  // Operations
  PRIMARY_AUTH: 'PRIMARY_AUTH',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  UNLOCK_ACCOUNT: 'UNLOCK_ACCOUNT',
  // Auth Types
  SESSION_SSO: 'SESSION_SSO',
  SESSION_STEP_UP: 'SESSION_STEP_UP',
  //Registration
  ACTIVATION_EMAIL_SENT: 'ACTIVATION_EMAIL_SENT',
  REGISTRATION_COMPLETE: 'REGISTRATION_COMPLETE',
  REGISTRATION_FAILED: 'REGISTRATION_FAILED',
  //IDP Discovery
  IDP_DISCOVERY: 'IDP_DISCOVERY'
});

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(622);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(741);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(644);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(15);

module.exports = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(148)('wks');
var uid = __webpack_require__(95);
var Symbol = __webpack_require__(11).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var shared = __webpack_require__(220);
var has = __webpack_require__(46);
var uid = __webpack_require__(165);
var NATIVE_SYMBOL = __webpack_require__(221);
var USE_SYMBOL_AS_UID = __webpack_require__(281);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _startsWith = _interopRequireDefault(__webpack_require__(316));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(82));

var _map = _interopRequireDefault(__webpack_require__(41));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

var _forEach = _interopRequireDefault(__webpack_require__(28));

/* eslint-disable max-statements */

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 13], max-depth: [2, 3] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(64), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Logger, Enums) {
  var Util = {};
  var _ = Okta._;

  var buildInputForParameter = function buildInputForParameter(name, value) {
    var input = document.createElement('input');
    input.name = name;
    input.value = decodeURIComponent(value);
    input.type = 'hidden';
    return input;
  };

  var buildDynamicForm = function buildDynamicForm() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var method = arguments.length > 1 ? arguments[1] : undefined;
    var splitOnFragment = url.split('#');
    var fragment = splitOnFragment[1];
    var splitOnQuery = (splitOnFragment[0] || '').split('?');
    var query = splitOnQuery[1];
    var targetUrl = splitOnQuery[0];

    if (fragment) {
      targetUrl += '#' + fragment;
    }

    var form = document.createElement('form');
    form.method = method;
    form.setAttribute('style', 'display: none;');
    form.action = targetUrl;

    if (query && query.length) {
      var queryParts = query.split('&');
      (0, _forEach.default)(queryParts).call(queryParts, function (queryPart) {
        var parameterParts = queryPart.split('=');
        var input = buildInputForParameter(parameterParts[0], parameterParts[1]);
        form.appendChild(input);
      });
    }

    return form;
  };

  Util.hasTokensInHash = function (hash) {
    return /((id|access)_token=)/i.test(hash);
  };

  Util.hasCodeInUrl = function (hashOrSearch) {
    return /(code=)/i.test(hashOrSearch);
  };

  Util.transformErrorXHR = function (xhr) {
    // Handle network connection error
    if (xhr.status === 0 && _.isEmpty(xhr.responseJSON)) {
      xhr.responseJSON = {
        errorSummary: Okta.loc('error.network.connection', 'login')
      };
      return xhr;
    }

    if (!xhr.responseJSON) {
      if (!xhr.responseText) {
        xhr.responseJSON = {
          errorSummary: Okta.loc('oform.error.unexpected', 'login')
        };
        return xhr;
      }

      xhr.responseJSON = xhr.responseText;
    } // Temporary solution to display field errors
    // Assuming there is only one field error in a response


    if (xhr.responseJSON && xhr.responseJSON.errorCauses && xhr.responseJSON.errorCauses.length) {
      xhr.responseJSON.errorSummary = xhr.responseJSON.errorCauses[0].errorSummary;
    } // Replace error messages


    if (!_.isEmpty(xhr.responseJSON)) {
      var errorMsg = Okta.loc('errors.' + xhr.responseJSON.errorCode, 'login');

      if ((0, _indexOf.default)(errorMsg).call(errorMsg, 'L10N_ERROR[') === -1) {
        xhr.responseJSON.errorSummary = errorMsg;

        if (xhr.responseJSON && xhr.responseJSON.errorCauses && xhr.responseJSON.errorCauses.length) {
          // BaseForm will consume errorCauses before errorSummary if it is an array,
          // so, we have to make sure to remove it when we have a valid error code
          delete xhr.responseJSON.errorCauses;
        }
      }
    }

    return xhr;
  }; // Simple helper function to lowercase all strings in the given array


  Util.toLower = function (strings) {
    return (0, _map.default)(_).call(_, strings, function (str) {
      return str.toLowerCase();
    });
  }; // A languageCode can be composed of multiple parts, i.e:
  // {{langage}}-{{region}}-{{dialect}}
  //
  // In these cases, it's necessary to generate a list of other possible
  // combinations that we might support (in preferred order).
  //
  // For example:
  // en-US -> [en-US, en]
  // de-DE-bavarian -> [de-DE-bavarian, de-DE, de]


  function expandLanguage(language) {
    var expanded = [language],
        parts = language.split('-');

    while (parts.pop() && parts.length > 0) {
      expanded.push(parts.join('-'));
    }

    return expanded;
  } // Following the rules of expanding one language, this will generate
  // all potential languages in the given order (where higher priority is
  // given to expanded languages over other downstream languages).


  Util.expandLanguages = function (languages) {
    var _context;

    return (0, _map.default)(_context = _.chain(languages)).call(_context, expandLanguage).flatten().uniq().value();
  }; //helper to call setTimeout


  Util.callAfterTimeout = function (callback, time) {
    return (0, _setTimeout2.default)(callback, time);
  }; // Helper function to provide consistent formatting of template literals
  // that are logged when in development mode.


  Util.debugMessage = function (message) {
    Logger.warn("\n".concat(message.replace(/^(\s)+/gm, '')));
  }; // Trigger an afterError event


  Util.triggerAfterError = function (controller) {
    var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!err.statusCode && err.xhr && err.xhr.status) {
      // Bring the statusCode to the top-level of the Error
      err.statusCode = err.xhr.status;
    } // Some controllers return the className as a function - process it here:


    var className = _.isFunction(controller.className) ? controller.className() : controller.className;

    var error = _.pick(err, 'name', 'message', 'statusCode', 'xhr');

    controller.trigger('afterError', {
      controller: className
    }, error); // Logs to console only in dev mode

    Logger.warn('controller: ' + className + ', error: ' + error);
  };

  Util.redirect = function (url) {
    var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    if (!url) {
      Logger.error("Cannot redirect to empty URL: (".concat(url, ")"));
      return;
    }

    win.location.href = url;
  };
  /**
   * Why redirect via Form get rather using `window.location.href`?
   * At the time of writing, Chrome (<72) in Android would block window location change
   * at following case
   * 1. An AJAX is trigger because of user action.
   * 2. 5+ seconds passed without any further user interaction.
   * 3. User takes an action results in window location change.
   *
   * Luckily we discovered that uses Form submit would work around this problem
   * even though it changed window location.
   *
   * Check the commit history for more details.
   */


  Util.redirectWithFormGet = function (url) {
    Util.redirectWithForm(url, 'get');
  };

  Util.redirectWithForm = function (url) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';

    if (!url) {
      Logger.error("Cannot redirect to empty URL: (".concat(url, ")"));
      return;
    }

    var mainContainer = document.getElementById(Enums.WIDGET_CONTAINER_ID);

    if (!mainContainer) {
      Logger.error('Cannot find okta-sign-in container append to which a form');
      return;
    }

    var form = buildDynamicForm(url, method);
    mainContainer.appendChild(form);
    form.submit();
  };
  /**
   * When we want to show an explain text, we need to check if this is different from
   * the label text, to not have an explain that look like a duplicated label.
   * okta-signin-widget gives the possibility to customize every i18n, so we cannot
   * know ahead if these two are equal or different, we need to call this function everytime.
   */


  Util.createInputExplain = function (explainKey, labelKey, bundleName, explainParams, labelParams) {
    var explain = explainParams ? Okta.loc(explainKey, bundleName, explainParams) : Okta.loc(explainKey, bundleName);
    var label = labelParams ? Okta.loc(labelKey, bundleName, labelParams) : Okta.loc(labelKey, bundleName);

    if (explain === label) {
      return false;
    }

    return explain;
  };

  Util.isV1StateToken = function (token) {
    return !!(token && _.isString(token) && (0, _startsWith.default)(token).call(token, '00'));
  };

  return Util;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(68);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
//note: not including Okta here and explicitly including jquery and Handlebars
//because we want to be explicit about which TextBox we are extending here
//and want to avoid the cirucular dependency that occurs if we
//include Okta
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(75), __webpack_require__(176)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, BrowserFeatures) {
  var TextBox = Okta.internal.views.forms.inputs.TextBox;
  return TextBox.extend({
    postRender: function postRender() {
      if (this.options.type === 'number') {
        var input = this.$('input');
        input.attr({
          pattern: '[0-9]*',
          inputmode: 'numeric'
        });
      }

      TextBox.prototype.postRender.apply(this, arguments);
    },
    // Override the focus() to ignore focus in IE. IE (8-11) has a known bug where
    // the placeholder text disappears when the input field is focused.
    focus: function focus() {
      if (BrowserFeatures.isIE()) {
        return;
      }

      return TextBox.prototype.focus.apply(this, arguments);
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseHeader = _interopRequireDefault(__webpack_require__(240));

var _HeaderBeacon = _interopRequireDefault(__webpack_require__(241));

var _AuthenticatorUtil = __webpack_require__(185);

var HeaderBeaconFactor = _HeaderBeacon.default.extend({
  getBeaconClassName: function getBeaconClassName() {
    var authenticatorType = this.options.appState.get('authenticatorType');
    return (0, _AuthenticatorUtil.getIconClassNameForBeacon)(authenticatorType);
  }
});

var _default = _BaseView.default.extend({
  Header: _BaseHeader.default.extend({
    HeaderBeacon: HeaderBeaconFactor
  })
});

exports.default = _default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(601);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol$iterator = __webpack_require__(718);

var _Symbol = __webpack_require__(232);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof _Symbol === "function" && typeof _Symbol$iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof _Symbol === "function" && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _reduce = _interopRequireDefault(__webpack_require__(90));

var _trim = _interopRequireDefault(__webpack_require__(138));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

var _map = _interopRequireDefault(__webpack_require__(41));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 38], max-statements: [2, 38] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(739)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, TimeUtil) {
  var _ = Okta._;
  var fn = {};
  var factorData = {
    'OKTA_VERIFY': {
      label: 'factor.totpSoft.oktaVerify',
      description: 'factor.totpSoft.description',
      iconClassName: 'mfa-okta-verify',
      sortOrder: 1
    },
    'OKTA_VERIFY_PUSH': {
      label: 'factor.oktaVerifyPush',
      description: 'factor.push.description',
      iconClassName: 'mfa-okta-verify',
      sortOrder: 1
    },
    'U2F': {
      label: 'factor.u2f',
      description: function description(brandName) {
        return brandName ? 'factor.u2f.description.specific' : 'factor.u2f.description.generic';
      },
      iconClassName: 'mfa-u2f',
      sortOrder: 2
    },
    'WEBAUTHN': {
      label: 'factor.webauthn.biometric',
      description: 'factor.webauthn.biometric.description',
      iconClassName: 'mfa-webauthn',
      sortOrder: 2
    },
    'WINDOWS_HELLO': {
      label: 'factor.windowsHello',
      description: function description(brandName) {
        return brandName ? 'factor.windowsHello.signin.description.specific' : 'factor.windowsHello.signin.description.generic';
      },
      iconClassName: 'mfa-windows-hello',
      sortOrder: 3
    },
    'YUBIKEY': {
      label: 'factor.totpHard.yubikey',
      description: 'factor.totpHard.yubikey.description',
      iconClassName: 'mfa-yubikey',
      sortOrder: 4
    },
    'GOOGLE_AUTH': {
      label: 'factor.totpSoft.googleAuthenticator',
      description: 'factor.totpSoft.description',
      iconClassName: 'mfa-google-auth',
      sortOrder: 5
    },
    'CUSTOM_HOTP': {
      label: '',
      description: 'factor.hotp.description',
      iconClassName: 'mfa-hotp',
      sortOrder: 6
    },
    'SMS': {
      label: 'factor.sms',
      description: 'factor.sms.description',
      iconClassName: 'mfa-okta-sms',
      sortOrder: 7
    },
    'CALL': {
      label: 'factor.call',
      description: 'factor.call.description',
      iconClassName: 'mfa-okta-call',
      sortOrder: 8
    },
    'EMAIL': {
      label: 'factor.email',
      description: 'factor.email.description',
      iconClassName: 'mfa-okta-email',
      sortOrder: 9
    },
    'QUESTION': {
      label: 'factor.securityQuestion',
      description: 'factor.securityQuestion.description',
      iconClassName: 'mfa-okta-security-question',
      sortOrder: 10
    },
    'DUO': {
      label: 'factor.duo',
      description: 'factor.duo.description',
      iconClassName: 'mfa-duo',
      sortOrder: 11
    },
    'SYMANTEC_VIP': {
      label: 'factor.totpHard.symantecVip',
      description: 'factor.totpHard.description',
      iconClassName: 'mfa-symantec',
      sortOrder: 12
    },
    'RSA_SECURID': {
      label: 'factor.totpHard.rsaSecurId',
      description: 'factor.totpHard.description',
      iconClassName: 'mfa-rsa',
      sortOrder: 13
    },
    'ON_PREM': {
      label: '',
      description: 'factor.totpHard.description',
      iconClassName: 'mfa-onprem',
      sortOrder: 14
    },
    'PASSWORD': {
      label: 'factor.password',
      description: '',
      iconClassName: 'mfa-okta-password',
      sortOrder: 15
    },
    'CUSTOM_CLAIMS': {
      label: '',
      description: 'factor.customFactor.description',
      iconClassName: 'mfa-custom-factor',
      sortOrder: 16
    },
    'GENERIC_SAML': {
      label: '',
      description: function description(brandName) {
        return brandName ? 'factor.customFactor.description.specific' : 'factor.customFactor.description.generic';
      },
      iconClassName: 'mfa-custom-factor',
      sortOrder: 17
    },
    'GENERIC_OIDC': {
      label: '',
      description: function description(brandName) {
        return brandName ? 'factor.customFactor.description.specific' : 'factor.customFactor.description.generic';
      },
      iconClassName: 'mfa-custom-factor',
      sortOrder: 18
    }
  };

  var getPasswordComplexityRequirementsAsArray = function getPasswordComplexityRequirementsAsArray(policy, i18nKeys) {
    var setExcludeAttributes = function setExcludeAttributes(policyComplexity) {
      var excludeAttributes = policyComplexity.excludeAttributes;
      policyComplexity.excludeFirstName = _.contains(excludeAttributes, 'firstName');
      policyComplexity.excludeLastName = _.contains(excludeAttributes, 'lastName');
      return _.omit(policyComplexity, 'excludeAttributes');
    };

    if (policy.complexity) {
      var complexityFields = i18nKeys.complexity;
      var policyComplexity = setExcludeAttributes(policy.complexity);
      var requirements = (0, _map.default)(_).call(_, policyComplexity, function (complexityValue, complexityType) {
        if (complexityValue <= 0) {
          // to skip 0 and -1
          return;
        }

        var params = complexityFields[complexityType];
        return params.args ? Okta.loc(params.i18n, 'login', [complexityValue]) : Okta.loc(params.i18n, 'login');
      });
      return _.compact(requirements);
    }

    return [];
  };

  var getPasswordHistoryRequirementDescription = function getPasswordHistoryRequirementDescription(policy, i18nKeys) {
    if (policy.age && policy.age.historyCount > 0) {
      return Okta.loc(i18nKeys.history.i18n, 'login', [policy.age.historyCount]);
    }

    return null;
  };

  var getPasswordAgeRequirementDescription = function getPasswordAgeRequirementDescription(policy, i18nKeys) {
    var getPasswordAgeRequirement = function getPasswordAgeRequirement(displayableTime) {
      var propertiesString;

      switch (displayableTime.unit) {
        case 'DAY':
          propertiesString = i18nKeys.age.days.i18n;
          break;

        case 'HOUR':
          propertiesString = i18nKeys.age.hours.i18n;
          break;

        case 'MINUTE':
          propertiesString = i18nKeys.age.minutes.i18n;
      }

      return Okta.loc(propertiesString, 'login', [displayableTime.time]);
    };

    if (policy.age && policy.age.minAgeMinutes > 0) {
      var displayableTime = TimeUtil.getTimeInHighestRelevantUnit(policy.age.minAgeMinutes, 'MINUTE');
      return getPasswordAgeRequirement(displayableTime);
    }

    return null;
  };

  var getPasswordRequirements = function getPasswordRequirements(policy, i18nKeys) {
    var passwordRequirements = {
      complexity: [],
      history: [],
      age: []
    };
    passwordRequirements.complexity = getPasswordComplexityRequirementsAsArray(policy, i18nKeys);
    var historyRequirement = getPasswordHistoryRequirementDescription(policy, i18nKeys);

    if (historyRequirement) {
      passwordRequirements.history.push(historyRequirement);
    }

    var ageRequirement = getPasswordAgeRequirementDescription(policy, i18nKeys);

    if (ageRequirement) {
      passwordRequirements.age.push(ageRequirement);
    }

    return passwordRequirements;
  };

  fn.getFactorName = function (provider, factorType) {
    if (provider === 'OKTA' && factorType === 'token:software:totp') {
      return 'OKTA_VERIFY';
    }

    if (provider === 'OKTA' && factorType === 'push') {
      return 'OKTA_VERIFY_PUSH';
    }

    if (provider === 'GOOGLE') {
      return 'GOOGLE_AUTH';
    }

    if (provider === 'SYMANTEC' && factorType === 'token') {
      return 'SYMANTEC_VIP';
    }

    if (provider === 'RSA' && factorType === 'token') {
      return 'RSA_SECURID';
    }

    if (provider === 'DEL_OATH' && factorType === 'token') {
      return 'ON_PREM';
    }

    if (provider === 'DUO' && factorType === 'web') {
      return 'DUO';
    }

    if (provider === 'YUBICO' && factorType === 'token:hardware') {
      return 'YUBIKEY';
    }

    if (provider === 'OKTA' && factorType === 'sms') {
      return 'SMS';
    }

    if (provider === 'OKTA' && factorType === 'call') {
      return 'CALL';
    }

    if (provider === 'OKTA' && factorType === 'question') {
      return 'QUESTION';
    }

    if (provider === 'OKTA' && factorType === 'email') {
      return 'EMAIL';
    }

    if (provider === 'OKTA' && factorType === 'password') {
      return 'PASSWORD';
    }

    if (provider === 'GENERIC_SAML' && factorType === 'assertion:saml2') {
      return 'GENERIC_SAML';
    }

    if (provider === 'GENERIC_OIDC' && factorType === 'assertion:oidc') {
      return 'GENERIC_OIDC';
    }

    return fn.getFactorNameForFactorType.call(this, factorType);
  };

  fn.getFactorNameForFactorType = function (factorType) {
    if (factorType === 'u2f') {
      return 'U2F';
    }

    if (factorType === 'token:software:totp') {
      return 'OKTA_VERIFY';
    }

    if (factorType === 'webauthn') {
      if (this.settings.get('features.webauthn')) {
        return 'WEBAUTHN';
      } else {
        return 'WINDOWS_HELLO';
      }
    }

    if (factorType === 'token:hotp') {
      return 'CUSTOM_HOTP';
    }

    if (factorType === 'claims_provider') {
      return 'CUSTOM_CLAIMS';
    }
  };

  fn.isOktaVerify = function (provider, factorType) {
    return provider === 'OKTA' && (factorType === 'token:software:totp' || factorType === 'push');
  };

  fn.getFactorLabel = function (provider, factorType) {
    var key = factorData[fn.getFactorName.apply(this, [provider, factorType])].label;
    return Okta.loc(key, 'login');
  };

  fn.getFactorDescription = function (provider, factorType) {
    var descriptionKey = factorData[fn.getFactorName.apply(this, [provider, factorType])].description;

    if (_.isFunction(descriptionKey)) {
      var brandName = this.settings.get('brandName');
      var key = descriptionKey(brandName);
      return brandName ? Okta.loc(key, 'login', [brandName]) : Okta.loc(key, 'login');
    } else {
      return Okta.loc(descriptionKey, 'login');
    }
  };

  fn.getFactorIconClassName = function (provider, factorType) {
    return factorData[fn.getFactorName.apply(this, [provider, factorType])].iconClassName;
  };

  fn.getFactorSortOrder = function (provider, factorType) {
    return factorData[fn.getFactorName.apply(this, [provider, factorType])].sortOrder;
  };

  fn.getRememberDeviceValue = function (appState) {
    return appState && appState.get('rememberDeviceByDefault');
  };

  fn.getSecurityQuestionLabel = function (questionObj) {
    var localizedQuestion = Okta.loc('security.' + questionObj.question);
    return (0, _indexOf.default)(localizedQuestion).call(localizedQuestion, 'L10N_ERROR') < 0 ? localizedQuestion : questionObj.questionText;
  };

  fn.removeRequirementsFromError = function (responseJSON, policy) {
    var passwordRequirementsAsString = this.getPasswordComplexityDescription(policy);

    if (responseJSON.errorCauses && responseJSON.errorCauses.length > 0 && _.isString(responseJSON.errorCauses[0].errorSummary)) {
      var _context;

      responseJSON.errorCauses[0].errorSummary = (0, _trim.default)(_context = responseJSON.errorCauses[0].errorSummary.replace(passwordRequirementsAsString, '')).call(_context);
    }

    return responseJSON;
  };

  fn.getPasswordComplexityDescriptionForHtmlList = function (policy) {
    var passwordRequirementHtmlI18nKeys = {
      complexity: {
        minLength: {
          i18n: 'password.complexity.length.description',
          args: true
        },
        minLowerCase: {
          i18n: 'password.complexity.lowercase.description'
        },
        minUpperCase: {
          i18n: 'password.complexity.uppercase.description'
        },
        minNumber: {
          i18n: 'password.complexity.number.description'
        },
        minSymbol: {
          i18n: 'password.complexity.symbol.description'
        },
        excludeUsername: {
          i18n: 'password.complexity.no_username.description'
        },
        excludeFirstName: {
          i18n: 'password.complexity.no_first_name.description'
        },
        excludeLastName: {
          i18n: 'password.complexity.no_last_name.description'
        }
      },
      history: {
        i18n: 'password.complexity.history.description'
      },
      age: {
        minutes: {
          i18n: 'password.complexity.minAgeMinutes.description'
        },
        hours: {
          i18n: 'password.complexity.minAgeHours.description'
        },
        days: {
          i18n: 'password.complexity.minAgeDays.description'
        }
      }
    };
    var passwordRequirements = getPasswordRequirements(policy, passwordRequirementHtmlI18nKeys);
    return _.union(passwordRequirements.complexity, passwordRequirements.history, passwordRequirements.age);
  };

  fn.getPasswordComplexityDescription = function (policy) {
    var passwordRequirementI18nKeys = {
      complexity: {
        minLength: {
          i18n: 'password.complexity.length',
          args: true
        },
        minLowerCase: {
          i18n: 'password.complexity.lowercase'
        },
        minUpperCase: {
          i18n: 'password.complexity.uppercase'
        },
        minNumber: {
          i18n: 'password.complexity.number'
        },
        minSymbol: {
          i18n: 'password.complexity.symbol'
        },
        excludeUsername: {
          i18n: 'password.complexity.no_username'
        },
        excludeFirstName: {
          i18n: 'password.complexity.no_first_name'
        },
        excludeLastName: {
          i18n: 'password.complexity.no_last_name'
        }
      },
      history: {
        i18n: 'password.complexity.history'
      },
      age: {
        minutes: {
          i18n: 'password.complexity.minAgeMinutes'
        },
        hours: {
          i18n: 'password.complexity.minAgeHours'
        },
        days: {
          i18n: 'password.complexity.minAgeDays'
        }
      }
    };
    var result = [];
    var passwordRequirements = getPasswordRequirements(policy, passwordRequirementI18nKeys);
    var requirements = passwordRequirements.complexity; // Generate and add complexity string to result

    if (requirements.length > 0) {
      requirements = (0, _reduce.default)(_).call(_, requirements, function (result, requirement) {
        return result ? result + Okta.loc('password.complexity.list.element', 'login', [requirement]) : requirement;
      });
      result.push(Okta.loc('password.complexity.requirements', 'login', [requirements]));
    } // Only 1 value expected in history and age for now


    result.push(passwordRequirements.history[0]);
    result.push(passwordRequirements.age[0]);
    return _.compact(result).join(' ');
  };

  fn.getCardinalityText = function (enrolled, required, cardinality) {
    if (cardinality) {
      if (enrolled) {
        return cardinality.enrolled === 1 ? '' : Okta.loc('enroll.choices.cardinality.setup', 'login', [cardinality.enrolled]);
      } else if (required && cardinality.maximum > 1) {
        return Okta.loc('enroll.choices.cardinality.setup.remaining', 'login', [cardinality.enrolled, cardinality.minimum]);
      }
    }

    return '';
  };

  fn.findFactorInFactorsArray = function (factors, provider, factorType) {
    var factor = factors.findWhere({
      provider: provider,
      factorType: factorType
    });

    if (factor === undefined) {
      //for factors that support cardinality and only have factorType
      factor = factors.findWhere({
        factorType: factorType
      });
    }

    return factor;
  };

  return fn;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(12)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(244);
var toPrimitive = __webpack_require__(86);
var dP = Object.defineProperty;

exports.f = __webpack_require__(33) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(15);
var has = __webpack_require__(46);
var wrappedWellKnownSymbolModule = __webpack_require__(173);
var defineProperty = __webpack_require__(62).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// vim:ts=4:sts=4:sw=4:
/*!
 *
 * Copyright 2009-2012 Kris Kowal under the terms of the MIT
 * license found at http://github.com/kriskowal/q/raw/master/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

(function (definition) {
    "use strict";

    // This file will function properly as a <script> tag, or a module
    // using CommonJS and NodeJS or RequireJS module formats.  In
    // Common/Node/RequireJS, the module exports the Q API and when
    // executed as a simple <script>, it creates a Q global instead.

    // Montage Require
    if (typeof bootstrap === "function") {
        bootstrap("promise", definition);

    // CommonJS
    } else if (true) {
        module.exports = definition();

    // RequireJS
    } else if (typeof define === "function" && define.amd) {
        define(definition);

    // SES (Secure EcmaScript)
    } else if (typeof ses !== "undefined") {
        if (!ses.ok()) {
            return;
        } else {
            ses.makeQ = definition;
        }

    // <script>
    } else if (typeof window !== "undefined" || typeof self !== "undefined") {
        // Prefer window over self for add-on scripts. Use self for
        // non-windowed contexts.
        var global = typeof window !== "undefined" ? window : self;

        // Get the `window` object, save the previous Q global
        // and initialize Q as a global.
        var previousQ = global.Q;
        global.Q = definition();

        // Add a noConflict function so Q can be removed from the
        // global namespace.
        global.Q.noConflict = function () {
            global.Q = previousQ;
            return this;
        };

    } else {
        throw new Error("This environment was not anticipated by Q. Please file a bug.");
    }

})(function () {
"use strict";

var hasStacks = false;
try {
    throw new Error();
} catch (e) {
    hasStacks = !!e.stack;
}

// All code after this point will be filtered from stack traces reported
// by Q.
var qStartingLine = captureLine();
var qFileName;

// shims

// used for fallback in "allResolved"
var noop = function () {};

// Use the fastest possible means to execute a task in a future turn
// of the event loop.
var nextTick =(function () {
    // linked list of tasks (single, with head node)
    var head = {task: void 0, next: null};
    var tail = head;
    var flushing = false;
    var requestTick = void 0;
    var isNodeJS = false;
    // queue for late tasks, used by unhandled rejection tracking
    var laterQueue = [];

    function flush() {
        /* jshint loopfunc: true */
        var task, domain;

        while (head.next) {
            head = head.next;
            task = head.task;
            head.task = void 0;
            domain = head.domain;

            if (domain) {
                head.domain = void 0;
                domain.enter();
            }
            runSingle(task, domain);

        }
        while (laterQueue.length) {
            task = laterQueue.pop();
            runSingle(task);
        }
        flushing = false;
    }
    // runs a single function in the async queue
    function runSingle(task, domain) {
        try {
            task();

        } catch (e) {
            if (isNodeJS) {
                // In node, uncaught exceptions are considered fatal errors.
                // Re-throw them synchronously to interrupt flushing!

                // Ensure continuation if the uncaught exception is suppressed
                // listening "uncaughtException" events (as domains does).
                // Continue in next event to avoid tick recursion.
                if (domain) {
                    domain.exit();
                }
                setTimeout(flush, 0);
                if (domain) {
                    domain.enter();
                }

                throw e;

            } else {
                // In browsers, uncaught exceptions are not fatal.
                // Re-throw them asynchronously to avoid slow-downs.
                setTimeout(function () {
                    throw e;
                }, 0);
            }
        }

        if (domain) {
            domain.exit();
        }
    }

    nextTick = function (task) {
        tail = tail.next = {
            task: task,
            domain: isNodeJS && process.domain,
            next: null
        };

        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };

    if (typeof process === "object" &&
        process.toString() === "[object process]" && process.nextTick) {
        // Ensure Q is in a real Node environment, with a `process.nextTick`.
        // To see through fake Node environments:
        // * Mocha test runner - exposes a `process` global without a `nextTick`
        // * Browserify - exposes a `process.nexTick` function that uses
        //   `setTimeout`. In this case `setImmediate` is preferred because
        //    it is faster. Browserify's `process.toString()` yields
        //   "[object Object]", while in a real Node environment
        //   `process.nextTick()` yields "[object process]".
        isNodeJS = true;

        requestTick = function () {
            process.nextTick(flush);
        };

    } else if (typeof setImmediate === "function") {
        // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
        if (typeof window !== "undefined") {
            requestTick = setImmediate.bind(window, flush);
        } else {
            requestTick = function () {
                setImmediate(flush);
            };
        }

    } else if (typeof MessageChannel !== "undefined") {
        // modern browsers
        // http://www.nonblocking.io/2011/06/windownexttick.html
        var channel = new MessageChannel();
        // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
        // working message ports the first time a page loads.
        channel.port1.onmessage = function () {
            requestTick = requestPortTick;
            channel.port1.onmessage = flush;
            flush();
        };
        var requestPortTick = function () {
            // Opera requires us to provide a message payload, regardless of
            // whether we use it.
            channel.port2.postMessage(0);
        };
        requestTick = function () {
            setTimeout(flush, 0);
            requestPortTick();
        };

    } else {
        // old browsers
        requestTick = function () {
            setTimeout(flush, 0);
        };
    }
    // runs a task after all other tasks have been run
    // this is useful for unhandled rejection tracking that needs to happen
    // after all `then`d tasks have been run.
    nextTick.runAfter = function (task) {
        laterQueue.push(task);
        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };
    return nextTick;
})();

// Attempt to make generics safe in the face of downstream
// modifications.
// There is no situation where this is necessary.
// If you need a security guarantee, these primordials need to be
// deeply frozen anyway, and if you don’t need a security guarantee,
// this is just plain paranoid.
// However, this **might** have the nice side-effect of reducing the size of
// the minified code by reducing x.call() to merely x()
// See Mark Miller’s explanation of what this does.
// http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
var call = Function.call;
function uncurryThis(f) {
    return function () {
        return call.apply(f, arguments);
    };
}
// This is equivalent, but slower:
// uncurryThis = Function_bind.bind(Function_bind.call);
// http://jsperf.com/uncurrythis

var array_slice = uncurryThis(Array.prototype.slice);

var array_reduce = uncurryThis(
    Array.prototype.reduce || function (callback, basis) {
        var index = 0,
            length = this.length;
        // concerning the initial value, if one is not provided
        if (arguments.length === 1) {
            // seek to the first value in the array, accounting
            // for the possibility that is is a sparse array
            do {
                if (index in this) {
                    basis = this[index++];
                    break;
                }
                if (++index >= length) {
                    throw new TypeError();
                }
            } while (1);
        }
        // reduce
        for (; index < length; index++) {
            // account for the possibility that the array is sparse
            if (index in this) {
                basis = callback(basis, this[index], index);
            }
        }
        return basis;
    }
);

var array_indexOf = uncurryThis(
    Array.prototype.indexOf || function (value) {
        // not a very good shim, but good enough for our one use of it
        for (var i = 0; i < this.length; i++) {
            if (this[i] === value) {
                return i;
            }
        }
        return -1;
    }
);

var array_map = uncurryThis(
    Array.prototype.map || function (callback, thisp) {
        var self = this;
        var collect = [];
        array_reduce(self, function (undefined, value, index) {
            collect.push(callback.call(thisp, value, index, self));
        }, void 0);
        return collect;
    }
);

var object_create = Object.create || function (prototype) {
    function Type() { }
    Type.prototype = prototype;
    return new Type();
};

var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);

var object_keys = Object.keys || function (object) {
    var keys = [];
    for (var key in object) {
        if (object_hasOwnProperty(object, key)) {
            keys.push(key);
        }
    }
    return keys;
};

var object_toString = uncurryThis(Object.prototype.toString);

function isObject(value) {
    return value === Object(value);
}

// generator related shims

// FIXME: Remove this function once ES6 generators are in SpiderMonkey.
function isStopIteration(exception) {
    return (
        object_toString(exception) === "[object StopIteration]" ||
        exception instanceof QReturnValue
    );
}

// FIXME: Remove this helper and Q.return once ES6 generators are in
// SpiderMonkey.
var QReturnValue;
if (typeof ReturnValue !== "undefined") {
    QReturnValue = ReturnValue;
} else {
    QReturnValue = function (value) {
        this.value = value;
    };
}

// long stack traces

var STACK_JUMP_SEPARATOR = "From previous event:";

function makeStackTraceLong(error, promise) {
    // If possible, transform the error stack trace by removing Node and Q
    // cruft, then concatenating with the stack trace of `promise`. See #57.
    if (hasStacks &&
        promise.stack &&
        typeof error === "object" &&
        error !== null &&
        error.stack &&
        error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1
    ) {
        var stacks = [];
        for (var p = promise; !!p; p = p.source) {
            if (p.stack) {
                stacks.unshift(p.stack);
            }
        }
        stacks.unshift(error.stack);

        var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
        error.stack = filterStackString(concatedStacks);
    }
}

function filterStackString(stackString) {
    var lines = stackString.split("\n");
    var desiredLines = [];
    for (var i = 0; i < lines.length; ++i) {
        var line = lines[i];

        if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
            desiredLines.push(line);
        }
    }
    return desiredLines.join("\n");
}

function isNodeFrame(stackLine) {
    return stackLine.indexOf("(module.js:") !== -1 ||
           stackLine.indexOf("(node.js:") !== -1;
}

function getFileNameAndLineNumber(stackLine) {
    // Named functions: "at functionName (filename:lineNumber:columnNumber)"
    // In IE10 function name can have spaces ("Anonymous function") O_o
    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
    if (attempt1) {
        return [attempt1[1], Number(attempt1[2])];
    }

    // Anonymous functions: "at filename:lineNumber:columnNumber"
    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
    if (attempt2) {
        return [attempt2[1], Number(attempt2[2])];
    }

    // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
    if (attempt3) {
        return [attempt3[1], Number(attempt3[2])];
    }
}

function isInternalFrame(stackLine) {
    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);

    if (!fileNameAndLineNumber) {
        return false;
    }

    var fileName = fileNameAndLineNumber[0];
    var lineNumber = fileNameAndLineNumber[1];

    return fileName === qFileName &&
        lineNumber >= qStartingLine &&
        lineNumber <= qEndingLine;
}

// discover own file name and line number range for filtering stack
// traces
function captureLine() {
    if (!hasStacks) {
        return;
    }

    try {
        throw new Error();
    } catch (e) {
        var lines = e.stack.split("\n");
        var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
        var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
        if (!fileNameAndLineNumber) {
            return;
        }

        qFileName = fileNameAndLineNumber[0];
        return fileNameAndLineNumber[1];
    }
}

function deprecate(callback, name, alternative) {
    return function () {
        if (typeof console !== "undefined" &&
            typeof console.warn === "function") {
            console.warn(name + " is deprecated, use " + alternative +
                         " instead.", new Error("").stack);
        }
        return callback.apply(callback, arguments);
    };
}

// end of shims
// beginning of real work

/**
 * Constructs a promise for an immediate reference, passes promises through, or
 * coerces promises from different systems.
 * @param value immediate reference or promise
 */
function Q(value) {
    // If the object is already a Promise, return it directly.  This enables
    // the resolve function to both be used to created references from objects,
    // but to tolerably coerce non-promises to promises.
    if (value instanceof Promise) {
        return value;
    }

    // assimilate thenables
    if (isPromiseAlike(value)) {
        return coerce(value);
    } else {
        return fulfill(value);
    }
}
Q.resolve = Q;

/**
 * Performs a task in a future turn of the event loop.
 * @param {Function} task
 */
Q.nextTick = nextTick;

/**
 * Controls whether or not long stack traces will be on
 */
Q.longStackSupport = false;

// enable long stacks if Q_DEBUG is set
if (typeof process === "object" && process && process.env && process.env.Q_DEBUG) {
    Q.longStackSupport = true;
}

/**
 * Constructs a {promise, resolve, reject} object.
 *
 * `resolve` is a callback to invoke with a more resolved value for the
 * promise. To fulfill the promise, invoke `resolve` with any value that is
 * not a thenable. To reject the promise, invoke `resolve` with a rejected
 * thenable, or invoke `reject` with the reason directly. To resolve the
 * promise to another thenable, thus putting it in the same state, invoke
 * `resolve` with that other thenable.
 */
Q.defer = defer;
function defer() {
    // if "messages" is an "Array", that indicates that the promise has not yet
    // been resolved.  If it is "undefined", it has been resolved.  Each
    // element of the messages array is itself an array of complete arguments to
    // forward to the resolved promise.  We coerce the resolution value to a
    // promise using the `resolve` function because it handles both fully
    // non-thenable values and other thenables gracefully.
    var messages = [], progressListeners = [], resolvedPromise;

    var deferred = object_create(defer.prototype);
    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, operands) {
        var args = array_slice(arguments);
        if (messages) {
            messages.push(args);
            if (op === "when" && operands[1]) { // progress operand
                progressListeners.push(operands[1]);
            }
        } else {
            Q.nextTick(function () {
                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
            });
        }
    };

    // XXX deprecated
    promise.valueOf = function () {
        if (messages) {
            return promise;
        }
        var nearerValue = nearer(resolvedPromise);
        if (isPromise(nearerValue)) {
            resolvedPromise = nearerValue; // shorten chain
        }
        return nearerValue;
    };

    promise.inspect = function () {
        if (!resolvedPromise) {
            return { state: "pending" };
        }
        return resolvedPromise.inspect();
    };

    if (Q.longStackSupport && hasStacks) {
        try {
            throw new Error();
        } catch (e) {
            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
            // accessor around; that causes memory leaks as per GH-111. Just
            // reify the stack trace as a string ASAP.
            //
            // At the same time, cut off the first line; it's always just
            // "[object Promise]\n", as per the `toString`.
            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
        }
    }

    // NOTE: we do the checks for `resolvedPromise` in each method, instead of
    // consolidating them into `become`, since otherwise we'd create new
    // promises with the lines `become(whatever(value))`. See e.g. GH-252.

    function become(newPromise) {
        resolvedPromise = newPromise;
        promise.source = newPromise;

        array_reduce(messages, function (undefined, message) {
            Q.nextTick(function () {
                newPromise.promiseDispatch.apply(newPromise, message);
            });
        }, void 0);

        messages = void 0;
        progressListeners = void 0;
    }

    deferred.promise = promise;
    deferred.resolve = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(Q(value));
    };

    deferred.fulfill = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(fulfill(value));
    };
    deferred.reject = function (reason) {
        if (resolvedPromise) {
            return;
        }

        become(reject(reason));
    };
    deferred.notify = function (progress) {
        if (resolvedPromise) {
            return;
        }

        array_reduce(progressListeners, function (undefined, progressListener) {
            Q.nextTick(function () {
                progressListener(progress);
            });
        }, void 0);
    };

    return deferred;
}

/**
 * Creates a Node-style callback that will resolve or reject the deferred
 * promise.
 * @returns a nodeback
 */
defer.prototype.makeNodeResolver = function () {
    var self = this;
    return function (error, value) {
        if (error) {
            self.reject(error);
        } else if (arguments.length > 2) {
            self.resolve(array_slice(arguments, 1));
        } else {
            self.resolve(value);
        }
    };
};

/**
 * @param resolver {Function} a function that returns nothing and accepts
 * the resolve, reject, and notify functions for a deferred.
 * @returns a promise that may be resolved with the given resolve and reject
 * functions, or rejected by a thrown exception in resolver
 */
Q.Promise = promise; // ES6
Q.promise = promise;
function promise(resolver) {
    if (typeof resolver !== "function") {
        throw new TypeError("resolver must be a function.");
    }
    var deferred = defer();
    try {
        resolver(deferred.resolve, deferred.reject, deferred.notify);
    } catch (reason) {
        deferred.reject(reason);
    }
    return deferred.promise;
}

promise.race = race; // ES6
promise.all = all; // ES6
promise.reject = reject; // ES6
promise.resolve = Q; // ES6

// XXX experimental.  This method is a way to denote that a local value is
// serializable and should be immediately dispatched to a remote upon request,
// instead of passing a reference.
Q.passByCopy = function (object) {
    //freeze(object);
    //passByCopies.set(object, true);
    return object;
};

Promise.prototype.passByCopy = function () {
    //freeze(object);
    //passByCopies.set(object, true);
    return this;
};

/**
 * If two promises eventually fulfill to the same value, promises that value,
 * but otherwise rejects.
 * @param x {Any*}
 * @param y {Any*}
 * @returns {Any*} a promise for x and y if they are the same, but a rejection
 * otherwise.
 *
 */
Q.join = function (x, y) {
    return Q(x).join(y);
};

Promise.prototype.join = function (that) {
    return Q([this, that]).spread(function (x, y) {
        if (x === y) {
            // TODO: "===" should be Object.is or equiv
            return x;
        } else {
            throw new Error("Can't join: not the same: " + x + " " + y);
        }
    });
};

/**
 * Returns a promise for the first of an array of promises to become settled.
 * @param answers {Array[Any*]} promises to race
 * @returns {Any*} the first promise to be settled
 */
Q.race = race;
function race(answerPs) {
    return promise(function (resolve, reject) {
        // Switch to this once we can assume at least ES5
        // answerPs.forEach(function (answerP) {
        //     Q(answerP).then(resolve, reject);
        // });
        // Use this in the meantime
        for (var i = 0, len = answerPs.length; i < len; i++) {
            Q(answerPs[i]).then(resolve, reject);
        }
    });
}

Promise.prototype.race = function () {
    return this.then(Q.race);
};

/**
 * Constructs a Promise with a promise descriptor object and optional fallback
 * function.  The descriptor contains methods like when(rejected), get(name),
 * set(name, value), post(name, args), and delete(name), which all
 * return either a value, a promise for a value, or a rejection.  The fallback
 * accepts the operation name, a resolver, and any further arguments that would
 * have been forwarded to the appropriate method above had a method been
 * provided with the proper name.  The API makes no guarantees about the nature
 * of the returned object, apart from that it is usable whereever promises are
 * bought and sold.
 */
Q.makePromise = Promise;
function Promise(descriptor, fallback, inspect) {
    if (fallback === void 0) {
        fallback = function (op) {
            return reject(new Error(
                "Promise does not support operation: " + op
            ));
        };
    }
    if (inspect === void 0) {
        inspect = function () {
            return {state: "unknown"};
        };
    }

    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, args) {
        var result;
        try {
            if (descriptor[op]) {
                result = descriptor[op].apply(promise, args);
            } else {
                result = fallback.call(promise, op, args);
            }
        } catch (exception) {
            result = reject(exception);
        }
        if (resolve) {
            resolve(result);
        }
    };

    promise.inspect = inspect;

    // XXX deprecated `valueOf` and `exception` support
    if (inspect) {
        var inspected = inspect();
        if (inspected.state === "rejected") {
            promise.exception = inspected.reason;
        }

        promise.valueOf = function () {
            var inspected = inspect();
            if (inspected.state === "pending" ||
                inspected.state === "rejected") {
                return promise;
            }
            return inspected.value;
        };
    }

    return promise;
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.then = function (fulfilled, rejected, progressed) {
    var self = this;
    var deferred = defer();
    var done = false;   // ensure the untrusted promise makes at most a
                        // single call to one of the callbacks

    function _fulfilled(value) {
        try {
            return typeof fulfilled === "function" ? fulfilled(value) : value;
        } catch (exception) {
            return reject(exception);
        }
    }

    function _rejected(exception) {
        if (typeof rejected === "function") {
            makeStackTraceLong(exception, self);
            try {
                return rejected(exception);
            } catch (newException) {
                return reject(newException);
            }
        }
        return reject(exception);
    }

    function _progressed(value) {
        return typeof progressed === "function" ? progressed(value) : value;
    }

    Q.nextTick(function () {
        self.promiseDispatch(function (value) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_fulfilled(value));
        }, "when", [function (exception) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_rejected(exception));
        }]);
    });

    // Progress propagator need to be attached in the current tick.
    self.promiseDispatch(void 0, "when", [void 0, function (value) {
        var newValue;
        var threw = false;
        try {
            newValue = _progressed(value);
        } catch (e) {
            threw = true;
            if (Q.onerror) {
                Q.onerror(e);
            } else {
                throw e;
            }
        }

        if (!threw) {
            deferred.notify(newValue);
        }
    }]);

    return deferred.promise;
};

Q.tap = function (promise, callback) {
    return Q(promise).tap(callback);
};

/**
 * Works almost like "finally", but not called for rejections.
 * Original resolution value is passed through callback unaffected.
 * Callback may return a promise that will be awaited for.
 * @param {Function} callback
 * @returns {Q.Promise}
 * @example
 * doSomething()
 *   .then(...)
 *   .tap(console.log)
 *   .then(...);
 */
Promise.prototype.tap = function (callback) {
    callback = Q(callback);

    return this.then(function (value) {
        return callback.fcall(value).thenResolve(value);
    });
};

/**
 * Registers an observer on a promise.
 *
 * Guarantees:
 *
 * 1. that fulfilled and rejected will be called only once.
 * 2. that either the fulfilled callback or the rejected callback will be
 *    called, but not both.
 * 3. that fulfilled and rejected will not be called in this turn.
 *
 * @param value      promise or immediate reference to observe
 * @param fulfilled  function to be called with the fulfilled value
 * @param rejected   function to be called with the rejection exception
 * @param progressed function to be called on any progress notifications
 * @return promise for the return value from the invoked callback
 */
Q.when = when;
function when(value, fulfilled, rejected, progressed) {
    return Q(value).then(fulfilled, rejected, progressed);
}

Promise.prototype.thenResolve = function (value) {
    return this.then(function () { return value; });
};

Q.thenResolve = function (promise, value) {
    return Q(promise).thenResolve(value);
};

Promise.prototype.thenReject = function (reason) {
    return this.then(function () { throw reason; });
};

Q.thenReject = function (promise, reason) {
    return Q(promise).thenReject(reason);
};

/**
 * If an object is not a promise, it is as "near" as possible.
 * If a promise is rejected, it is as "near" as possible too.
 * If it’s a fulfilled promise, the fulfillment value is nearer.
 * If it’s a deferred promise and the deferred has been resolved, the
 * resolution is "nearer".
 * @param object
 * @returns most resolved (nearest) form of the object
 */

// XXX should we re-do this?
Q.nearer = nearer;
function nearer(value) {
    if (isPromise(value)) {
        var inspected = value.inspect();
        if (inspected.state === "fulfilled") {
            return inspected.value;
        }
    }
    return value;
}

/**
 * @returns whether the given object is a promise.
 * Otherwise it is a fulfilled value.
 */
Q.isPromise = isPromise;
function isPromise(object) {
    return object instanceof Promise;
}

Q.isPromiseAlike = isPromiseAlike;
function isPromiseAlike(object) {
    return isObject(object) && typeof object.then === "function";
}

/**
 * @returns whether the given object is a pending promise, meaning not
 * fulfilled or rejected.
 */
Q.isPending = isPending;
function isPending(object) {
    return isPromise(object) && object.inspect().state === "pending";
}

Promise.prototype.isPending = function () {
    return this.inspect().state === "pending";
};

/**
 * @returns whether the given object is a value or fulfilled
 * promise.
 */
Q.isFulfilled = isFulfilled;
function isFulfilled(object) {
    return !isPromise(object) || object.inspect().state === "fulfilled";
}

Promise.prototype.isFulfilled = function () {
    return this.inspect().state === "fulfilled";
};

/**
 * @returns whether the given object is a rejected promise.
 */
Q.isRejected = isRejected;
function isRejected(object) {
    return isPromise(object) && object.inspect().state === "rejected";
}

Promise.prototype.isRejected = function () {
    return this.inspect().state === "rejected";
};

//// BEGIN UNHANDLED REJECTION TRACKING

// This promise library consumes exceptions thrown in handlers so they can be
// handled by a subsequent promise.  The exceptions get added to this array when
// they are created, and removed when they are handled.  Note that in ES6 or
// shimmed environments, this would naturally be a `Set`.
var unhandledReasons = [];
var unhandledRejections = [];
var reportedUnhandledRejections = [];
var trackUnhandledRejections = true;

function resetUnhandledRejections() {
    unhandledReasons.length = 0;
    unhandledRejections.length = 0;

    if (!trackUnhandledRejections) {
        trackUnhandledRejections = true;
    }
}

function trackRejection(promise, reason) {
    if (!trackUnhandledRejections) {
        return;
    }
    if (typeof process === "object" && typeof process.emit === "function") {
        Q.nextTick.runAfter(function () {
            if (array_indexOf(unhandledRejections, promise) !== -1) {
                process.emit("unhandledRejection", reason, promise);
                reportedUnhandledRejections.push(promise);
            }
        });
    }

    unhandledRejections.push(promise);
    if (reason && typeof reason.stack !== "undefined") {
        unhandledReasons.push(reason.stack);
    } else {
        unhandledReasons.push("(no stack) " + reason);
    }
}

function untrackRejection(promise) {
    if (!trackUnhandledRejections) {
        return;
    }

    var at = array_indexOf(unhandledRejections, promise);
    if (at !== -1) {
        if (typeof process === "object" && typeof process.emit === "function") {
            Q.nextTick.runAfter(function () {
                var atReport = array_indexOf(reportedUnhandledRejections, promise);
                if (atReport !== -1) {
                    process.emit("rejectionHandled", unhandledReasons[at], promise);
                    reportedUnhandledRejections.splice(atReport, 1);
                }
            });
        }
        unhandledRejections.splice(at, 1);
        unhandledReasons.splice(at, 1);
    }
}

Q.resetUnhandledRejections = resetUnhandledRejections;

Q.getUnhandledReasons = function () {
    // Make a copy so that consumers can't interfere with our internal state.
    return unhandledReasons.slice();
};

Q.stopUnhandledRejectionTracking = function () {
    resetUnhandledRejections();
    trackUnhandledRejections = false;
};

resetUnhandledRejections();

//// END UNHANDLED REJECTION TRACKING

/**
 * Constructs a rejected promise.
 * @param reason value describing the failure
 */
Q.reject = reject;
function reject(reason) {
    var rejection = Promise({
        "when": function (rejected) {
            // note that the error has been handled
            if (rejected) {
                untrackRejection(this);
            }
            return rejected ? rejected(reason) : this;
        }
    }, function fallback() {
        return this;
    }, function inspect() {
        return { state: "rejected", reason: reason };
    });

    // Note that the reason has not been handled.
    trackRejection(rejection, reason);

    return rejection;
}

/**
 * Constructs a fulfilled promise for an immediate reference.
 * @param value immediate reference
 */
Q.fulfill = fulfill;
function fulfill(value) {
    return Promise({
        "when": function () {
            return value;
        },
        "get": function (name) {
            return value[name];
        },
        "set": function (name, rhs) {
            value[name] = rhs;
        },
        "delete": function (name) {
            delete value[name];
        },
        "post": function (name, args) {
            // Mark Miller proposes that post with no name should apply a
            // promised function.
            if (name === null || name === void 0) {
                return value.apply(void 0, args);
            } else {
                return value[name].apply(value, args);
            }
        },
        "apply": function (thisp, args) {
            return value.apply(thisp, args);
        },
        "keys": function () {
            return object_keys(value);
        }
    }, void 0, function inspect() {
        return { state: "fulfilled", value: value };
    });
}

/**
 * Converts thenables to Q promises.
 * @param promise thenable promise
 * @returns a Q promise
 */
function coerce(promise) {
    var deferred = defer();
    Q.nextTick(function () {
        try {
            promise.then(deferred.resolve, deferred.reject, deferred.notify);
        } catch (exception) {
            deferred.reject(exception);
        }
    });
    return deferred.promise;
}

/**
 * Annotates an object such that it will never be
 * transferred away from this process over any promise
 * communication channel.
 * @param object
 * @returns promise a wrapping of that object that
 * additionally responds to the "isDef" message
 * without a rejection.
 */
Q.master = master;
function master(object) {
    return Promise({
        "isDef": function () {}
    }, function fallback(op, args) {
        return dispatch(object, op, args);
    }, function () {
        return Q(object).inspect();
    });
}

/**
 * Spreads the values of a promised array of arguments into the
 * fulfillment callback.
 * @param fulfilled callback that receives variadic arguments from the
 * promised array
 * @param rejected callback that receives the exception if the promise
 * is rejected.
 * @returns a promise for the return value or thrown exception of
 * either callback.
 */
Q.spread = spread;
function spread(value, fulfilled, rejected) {
    return Q(value).spread(fulfilled, rejected);
}

Promise.prototype.spread = function (fulfilled, rejected) {
    return this.all().then(function (array) {
        return fulfilled.apply(void 0, array);
    }, rejected);
};

/**
 * The async function is a decorator for generator functions, turning
 * them into asynchronous generators.  Although generators are only part
 * of the newest ECMAScript 6 drafts, this code does not cause syntax
 * errors in older engines.  This code should continue to work and will
 * in fact improve over time as the language improves.
 *
 * ES6 generators are currently part of V8 version 3.19 with the
 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
 * for longer, but under an older Python-inspired form.  This function
 * works on both kinds of generators.
 *
 * Decorates a generator function such that:
 *  - it may yield promises
 *  - execution will continue when that promise is fulfilled
 *  - the value of the yield expression will be the fulfilled value
 *  - it returns a promise for the return value (when the generator
 *    stops iterating)
 *  - the decorated function returns a promise for the return value
 *    of the generator or the first rejected promise among those
 *    yielded.
 *  - if an error is thrown in the generator, it propagates through
 *    every following yield until it is caught, or until it escapes
 *    the generator function altogether, and is translated into a
 *    rejection for the promise returned by the decorated generator.
 */
Q.async = async;
function async(makeGenerator) {
    return function () {
        // when verb is "send", arg is a value
        // when verb is "throw", arg is an exception
        function continuer(verb, arg) {
            var result;

            // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
            // engine that has a deployed base of browsers that support generators.
            // However, SM's generators use the Python-inspired semantics of
            // outdated ES6 drafts.  We would like to support ES6, but we'd also
            // like to make it possible to use generators in deployed browsers, so
            // we also support Python-style generators.  At some point we can remove
            // this block.

            if (typeof StopIteration === "undefined") {
                // ES6 Generators
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    return reject(exception);
                }
                if (result.done) {
                    return Q(result.value);
                } else {
                    return when(result.value, callback, errback);
                }
            } else {
                // SpiderMonkey Generators
                // FIXME: Remove this case when SM does ES6 generators.
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    if (isStopIteration(exception)) {
                        return Q(exception.value);
                    } else {
                        return reject(exception);
                    }
                }
                return when(result, callback, errback);
            }
        }
        var generator = makeGenerator.apply(this, arguments);
        var callback = continuer.bind(continuer, "next");
        var errback = continuer.bind(continuer, "throw");
        return callback();
    };
}

/**
 * The spawn function is a small wrapper around async that immediately
 * calls the generator and also ends the promise chain, so that any
 * unhandled errors are thrown instead of forwarded to the error
 * handler. This is useful because it's extremely common to run
 * generators at the top-level to work with libraries.
 */
Q.spawn = spawn;
function spawn(makeGenerator) {
    Q.done(Q.async(makeGenerator)());
}

// FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
/**
 * Throws a ReturnValue exception to stop an asynchronous generator.
 *
 * This interface is a stop-gap measure to support generator return
 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
 * generators like Chromium 29, just use "return" in your generator
 * functions.
 *
 * @param value the return value for the surrounding generator
 * @throws ReturnValue exception with the value.
 * @example
 * // ES6 style
 * Q.async(function* () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      return foo + bar;
 * })
 * // Older SpiderMonkey style
 * Q.async(function () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      Q.return(foo + bar);
 * })
 */
Q["return"] = _return;
function _return(value) {
    throw new QReturnValue(value);
}

/**
 * The promised function decorator ensures that any promise arguments
 * are settled and passed as values (`this` is also settled and passed
 * as a value).  It will also ensure that the result of a function is
 * always a promise.
 *
 * @example
 * var add = Q.promised(function (a, b) {
 *     return a + b;
 * });
 * add(Q(a), Q(B));
 *
 * @param {function} callback The function to decorate
 * @returns {function} a function that has been decorated.
 */
Q.promised = promised;
function promised(callback) {
    return function () {
        return spread([this, all(arguments)], function (self, args) {
            return callback.apply(self, args);
        });
    };
}

/**
 * sends a message to a value in a future turn
 * @param object* the recipient
 * @param op the name of the message operation, e.g., "when",
 * @param args further arguments to be forwarded to the operation
 * @returns result {Promise} a promise for the result of the operation
 */
Q.dispatch = dispatch;
function dispatch(object, op, args) {
    return Q(object).dispatch(op, args);
}

Promise.prototype.dispatch = function (op, args) {
    var self = this;
    var deferred = defer();
    Q.nextTick(function () {
        self.promiseDispatch(deferred.resolve, op, args);
    });
    return deferred.promise;
};

/**
 * Gets the value of a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to get
 * @return promise for the property value
 */
Q.get = function (object, key) {
    return Q(object).dispatch("get", [key]);
};

Promise.prototype.get = function (key) {
    return this.dispatch("get", [key]);
};

/**
 * Sets the value of a property in a future turn.
 * @param object    promise or immediate reference for object object
 * @param name      name of property to set
 * @param value     new value of property
 * @return promise for the return value
 */
Q.set = function (object, key, value) {
    return Q(object).dispatch("set", [key, value]);
};

Promise.prototype.set = function (key, value) {
    return this.dispatch("set", [key, value]);
};

/**
 * Deletes a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to delete
 * @return promise for the return value
 */
Q.del = // XXX legacy
Q["delete"] = function (object, key) {
    return Q(object).dispatch("delete", [key]);
};

Promise.prototype.del = // XXX legacy
Promise.prototype["delete"] = function (key) {
    return this.dispatch("delete", [key]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param value     a value to post, typically an array of
 *                  invocation arguments for promises that
 *                  are ultimately backed with `resolve` values,
 *                  as opposed to those backed with URLs
 *                  wherein the posted value can be any
 *                  JSON serializable object.
 * @return promise for the return value
 */
// bound locally because it is used by other methods
Q.mapply = // XXX As proposed by "Redsandro"
Q.post = function (object, name, args) {
    return Q(object).dispatch("post", [name, args]);
};

Promise.prototype.mapply = // XXX As proposed by "Redsandro"
Promise.prototype.post = function (name, args) {
    return this.dispatch("post", [name, args]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param ...args   array of invocation arguments
 * @return promise for the return value
 */
Q.send = // XXX Mark Miller's proposed parlance
Q.mcall = // XXX As proposed by "Redsandro"
Q.invoke = function (object, name /*...args*/) {
    return Q(object).dispatch("post", [name, array_slice(arguments, 2)]);
};

Promise.prototype.send = // XXX Mark Miller's proposed parlance
Promise.prototype.mcall = // XXX As proposed by "Redsandro"
Promise.prototype.invoke = function (name /*...args*/) {
    return this.dispatch("post", [name, array_slice(arguments, 1)]);
};

/**
 * Applies the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param args      array of application arguments
 */
Q.fapply = function (object, args) {
    return Q(object).dispatch("apply", [void 0, args]);
};

Promise.prototype.fapply = function (args) {
    return this.dispatch("apply", [void 0, args]);
};

/**
 * Calls the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q["try"] =
Q.fcall = function (object /* ...args*/) {
    return Q(object).dispatch("apply", [void 0, array_slice(arguments, 1)]);
};

Promise.prototype.fcall = function (/*...args*/) {
    return this.dispatch("apply", [void 0, array_slice(arguments)]);
};

/**
 * Binds the promised function, transforming return values into a fulfilled
 * promise and thrown errors into a rejected one.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q.fbind = function (object /*...args*/) {
    var promise = Q(object);
    var args = array_slice(arguments, 1);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};
Promise.prototype.fbind = function (/*...args*/) {
    var promise = this;
    var args = array_slice(arguments);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};

/**
 * Requests the names of the owned properties of a promised
 * object in a future turn.
 * @param object    promise or immediate reference for target object
 * @return promise for the keys of the eventually settled object
 */
Q.keys = function (object) {
    return Q(object).dispatch("keys", []);
};

Promise.prototype.keys = function () {
    return this.dispatch("keys", []);
};

/**
 * Turns an array of promises into a promise for an array.  If any of
 * the promises gets rejected, the whole array is rejected immediately.
 * @param {Array*} an array (or promise for an array) of values (or
 * promises for values)
 * @returns a promise for an array of the corresponding values
 */
// By Mark Miller
// http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
Q.all = all;
function all(promises) {
    return when(promises, function (promises) {
        var pendingCount = 0;
        var deferred = defer();
        array_reduce(promises, function (undefined, promise, index) {
            var snapshot;
            if (
                isPromise(promise) &&
                (snapshot = promise.inspect()).state === "fulfilled"
            ) {
                promises[index] = snapshot.value;
            } else {
                ++pendingCount;
                when(
                    promise,
                    function (value) {
                        promises[index] = value;
                        if (--pendingCount === 0) {
                            deferred.resolve(promises);
                        }
                    },
                    deferred.reject,
                    function (progress) {
                        deferred.notify({ index: index, value: progress });
                    }
                );
            }
        }, void 0);
        if (pendingCount === 0) {
            deferred.resolve(promises);
        }
        return deferred.promise;
    });
}

Promise.prototype.all = function () {
    return all(this);
};

/**
 * Returns the first resolved promise of an array. Prior rejected promises are
 * ignored.  Rejects only if all promises are rejected.
 * @param {Array*} an array containing values or promises for values
 * @returns a promise fulfilled with the value of the first resolved promise,
 * or a rejected promise if all promises are rejected.
 */
Q.any = any;

function any(promises) {
    if (promises.length === 0) {
        return Q.resolve();
    }

    var deferred = Q.defer();
    var pendingCount = 0;
    array_reduce(promises, function (prev, current, index) {
        var promise = promises[index];

        pendingCount++;

        when(promise, onFulfilled, onRejected, onProgress);
        function onFulfilled(result) {
            deferred.resolve(result);
        }
        function onRejected() {
            pendingCount--;
            if (pendingCount === 0) {
                deferred.reject(new Error(
                    "Can't get fulfillment value from any promise, all " +
                    "promises were rejected."
                ));
            }
        }
        function onProgress(progress) {
            deferred.notify({
                index: index,
                value: progress
            });
        }
    }, undefined);

    return deferred.promise;
}

Promise.prototype.any = function () {
    return any(this);
};

/**
 * Waits for all promises to be settled, either fulfilled or
 * rejected.  This is distinct from `all` since that would stop
 * waiting at the first rejection.  The promise returned by
 * `allResolved` will never be rejected.
 * @param promises a promise for an array (or an array) of promises
 * (or values)
 * @return a promise for an array of promises
 */
Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
function allResolved(promises) {
    return when(promises, function (promises) {
        promises = array_map(promises, Q);
        return when(all(array_map(promises, function (promise) {
            return when(promise, noop, noop);
        })), function () {
            return promises;
        });
    });
}

Promise.prototype.allResolved = function () {
    return allResolved(this);
};

/**
 * @see Promise#allSettled
 */
Q.allSettled = allSettled;
function allSettled(promises) {
    return Q(promises).allSettled();
}

/**
 * Turns an array of promises into a promise for an array of their states (as
 * returned by `inspect`) when they have all settled.
 * @param {Array[Any*]} values an array (or promise for an array) of values (or
 * promises for values)
 * @returns {Array[State]} an array of states for the respective values.
 */
Promise.prototype.allSettled = function () {
    return this.then(function (promises) {
        return all(array_map(promises, function (promise) {
            promise = Q(promise);
            function regardless() {
                return promise.inspect();
            }
            return promise.then(regardless, regardless);
        }));
    });
};

/**
 * Captures the failure of a promise, giving an oportunity to recover
 * with a callback.  If the given promise is fulfilled, the returned
 * promise is fulfilled.
 * @param {Any*} promise for something
 * @param {Function} callback to fulfill the returned promise if the
 * given promise is rejected
 * @returns a promise for the return value of the callback
 */
Q.fail = // XXX legacy
Q["catch"] = function (object, rejected) {
    return Q(object).then(void 0, rejected);
};

Promise.prototype.fail = // XXX legacy
Promise.prototype["catch"] = function (rejected) {
    return this.then(void 0, rejected);
};

/**
 * Attaches a listener that can respond to progress notifications from a
 * promise's originating deferred. This listener receives the exact arguments
 * passed to ``deferred.notify``.
 * @param {Any*} promise for something
 * @param {Function} callback to receive any progress notifications
 * @returns the given promise, unchanged
 */
Q.progress = progress;
function progress(object, progressed) {
    return Q(object).then(void 0, void 0, progressed);
}

Promise.prototype.progress = function (progressed) {
    return this.then(void 0, void 0, progressed);
};

/**
 * Provides an opportunity to observe the settling of a promise,
 * regardless of whether the promise is fulfilled or rejected.  Forwards
 * the resolution to the returned promise when the callback is done.
 * The callback can return a promise to defer completion.
 * @param {Any*} promise
 * @param {Function} callback to observe the resolution of the given
 * promise, takes no arguments.
 * @returns a promise for the resolution of the given promise when
 * ``fin`` is done.
 */
Q.fin = // XXX legacy
Q["finally"] = function (object, callback) {
    return Q(object)["finally"](callback);
};

Promise.prototype.fin = // XXX legacy
Promise.prototype["finally"] = function (callback) {
    callback = Q(callback);
    return this.then(function (value) {
        return callback.fcall().then(function () {
            return value;
        });
    }, function (reason) {
        // TODO attempt to recycle the rejection with "this".
        return callback.fcall().then(function () {
            throw reason;
        });
    });
};

/**
 * Terminates a chain of promises, forcing rejections to be
 * thrown as exceptions.
 * @param {Any*} promise at the end of a chain of promises
 * @returns nothing
 */
Q.done = function (object, fulfilled, rejected, progress) {
    return Q(object).done(fulfilled, rejected, progress);
};

Promise.prototype.done = function (fulfilled, rejected, progress) {
    var onUnhandledError = function (error) {
        // forward to a future turn so that ``when``
        // does not catch it and turn it into a rejection.
        Q.nextTick(function () {
            makeStackTraceLong(error, promise);
            if (Q.onerror) {
                Q.onerror(error);
            } else {
                throw error;
            }
        });
    };

    // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
    var promise = fulfilled || rejected || progress ?
        this.then(fulfilled, rejected, progress) :
        this;

    if (typeof process === "object" && process && process.domain) {
        onUnhandledError = process.domain.bind(onUnhandledError);
    }

    promise.then(void 0, onUnhandledError);
};

/**
 * Causes a promise to be rejected if it does not get fulfilled before
 * some milliseconds time out.
 * @param {Any*} promise
 * @param {Number} milliseconds timeout
 * @param {Any*} custom error message or Error object (optional)
 * @returns a promise for the resolution of the given promise if it is
 * fulfilled before the timeout, otherwise rejected.
 */
Q.timeout = function (object, ms, error) {
    return Q(object).timeout(ms, error);
};

Promise.prototype.timeout = function (ms, error) {
    var deferred = defer();
    var timeoutId = setTimeout(function () {
        if (!error || "string" === typeof error) {
            error = new Error(error || "Timed out after " + ms + " ms");
            error.code = "ETIMEDOUT";
        }
        deferred.reject(error);
    }, ms);

    this.then(function (value) {
        clearTimeout(timeoutId);
        deferred.resolve(value);
    }, function (exception) {
        clearTimeout(timeoutId);
        deferred.reject(exception);
    }, deferred.notify);

    return deferred.promise;
};

/**
 * Returns a promise for the given value (or promised value), some
 * milliseconds after it resolved. Passes rejections immediately.
 * @param {Any*} promise
 * @param {Number} milliseconds
 * @returns a promise for the resolution of the given promise after milliseconds
 * time has elapsed since the resolution of the given promise.
 * If the given promise rejects, that is passed immediately.
 */
Q.delay = function (object, timeout) {
    if (timeout === void 0) {
        timeout = object;
        object = void 0;
    }
    return Q(object).delay(timeout);
};

Promise.prototype.delay = function (timeout) {
    return this.then(function (value) {
        var deferred = defer();
        setTimeout(function () {
            deferred.resolve(value);
        }, timeout);
        return deferred.promise;
    });
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided as an array, and returns a promise.
 *
 *      Q.nfapply(FS.readFile, [__filename])
 *      .then(function (content) {
 *      })
 *
 */
Q.nfapply = function (callback, args) {
    return Q(callback).nfapply(args);
};

Promise.prototype.nfapply = function (args) {
    var deferred = defer();
    var nodeArgs = array_slice(args);
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided individually, and returns a promise.
 * @example
 * Q.nfcall(FS.readFile, __filename)
 * .then(function (content) {
 * })
 *
 */
Q.nfcall = function (callback /*...args*/) {
    var args = array_slice(arguments, 1);
    return Q(callback).nfapply(args);
};

Promise.prototype.nfcall = function (/*...args*/) {
    var nodeArgs = array_slice(arguments);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Wraps a NodeJS continuation passing function and returns an equivalent
 * version that returns a promise.
 * @example
 * Q.nfbind(FS.readFile, __filename)("utf-8")
 * .then(console.log)
 * .done()
 */
Q.nfbind =
Q.denodeify = function (callback /*...args*/) {
    var baseArgs = array_slice(arguments, 1);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        Q(callback).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nfbind =
Promise.prototype.denodeify = function (/*...args*/) {
    var args = array_slice(arguments);
    args.unshift(this);
    return Q.denodeify.apply(void 0, args);
};

Q.nbind = function (callback, thisp /*...args*/) {
    var baseArgs = array_slice(arguments, 2);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        function bound() {
            return callback.apply(thisp, arguments);
        }
        Q(bound).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nbind = function (/*thisp, ...args*/) {
    var args = array_slice(arguments, 0);
    args.unshift(this);
    return Q.nbind.apply(void 0, args);
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback with a given array of arguments, plus a provided callback.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param {Array} args arguments to pass to the method; the callback
 * will be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nmapply = // XXX As proposed by "Redsandro"
Q.npost = function (object, name, args) {
    return Q(object).npost(name, args);
};

Promise.prototype.nmapply = // XXX As proposed by "Redsandro"
Promise.prototype.npost = function (name, args) {
    var nodeArgs = array_slice(args || []);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback, forwarding the given variadic arguments, plus a provided
 * callback argument.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param ...args arguments to pass to the method; the callback will
 * be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nsend = // XXX Based on Mark Miller's proposed "send"
Q.nmcall = // XXX Based on "Redsandro's" proposal
Q.ninvoke = function (object, name /*...args*/) {
    var nodeArgs = array_slice(arguments, 2);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    Q(object).dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

Promise.prototype.nsend = // XXX Based on Mark Miller's proposed "send"
Promise.prototype.nmcall = // XXX Based on "Redsandro's" proposal
Promise.prototype.ninvoke = function (name /*...args*/) {
    var nodeArgs = array_slice(arguments, 1);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * If a function would like to support both Node continuation-passing-style and
 * promise-returning-style, it can end its internal promise chain with
 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
 * elects to use a nodeback, the result will be sent there.  If they do not
 * pass a nodeback, they will receive the result promise.
 * @param object a result (or a promise for a result)
 * @param {Function} nodeback a Node.js-style callback
 * @returns either the promise or nothing
 */
Q.nodeify = nodeify;
function nodeify(object, nodeback) {
    return Q(object).nodeify(nodeback);
}

Promise.prototype.nodeify = function (nodeback) {
    if (nodeback) {
        this.then(function (value) {
            Q.nextTick(function () {
                nodeback(null, value);
            });
        }, function (error) {
            Q.nextTick(function () {
                nodeback(error);
            });
        });
    } else {
        return this;
    }
};

Q.noConflict = function() {
    throw new Error("Q.noConflict only works when Q is used as a global");
};

// All code before this point will be filtered from stack traces.
var qEndingLine = captureLine();

return Q;

});


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(625);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums) {
  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "mfa.backToFactors"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 58
            },
            "end": {
              "line": 1,
              "column": 106
            }
          }
        })) + "</a>";
      },
      "useData": true
    }),
    className: 'auth-footer',
    events: {
      'click .js-back': function clickJsBack(e) {
        e.preventDefault();
        this.options.appState.trigger('backToFactors');
        this.back();
      }
    },
    back: function back() {
      this.state.set('navigateDir', Enums.DIRECTION_BACK);

      if (this.options.appState.get('prevLink')) {
        // Once we are in the MFA_ENROLL_ACTIVATE, we need to reset to the
        // correct state. Fortunately, this means that the router will
        // handle navigation once the request is finished.
        this.model.doTransaction(function (transaction) {
          return transaction.prev();
        });
      } else {
        this.options.appState.trigger('navigate', 'signin/enroll');
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(20);

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(577);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(638);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseModel = _interopRequireDefault(__webpack_require__(874));

var _BaseHeader = _interopRequireDefault(__webpack_require__(240));

var _BaseFooter = _interopRequireDefault(__webpack_require__(92));

var _ViewClassNamesFactory = __webpack_require__(366);

var _default = _okta.View.extend({
  Header: _BaseHeader.default,
  Body: _BaseForm.default,
  Footer: _BaseFooter.default,
  className: function className() {
    var _context;

    var appState = this.options.appState;
    var formName = appState.get('currentFormName');
    var authenticatorType = appState.get('authenticatorType');
    var methodType = appState.get('authenticatorMethodType');
    var isPasswordRecoveryFlow = appState.get('isPasswordRecoveryFlow');
    var additionalClassNames = (0, _ViewClassNamesFactory.getClassNameMapping)(formName, authenticatorType, methodType, isPasswordRecoveryFlow);
    var classNames = (0, _concat.default)(_context = ['siw-main-view']).call(_context, additionalClassNames);
    return classNames.join(' ');
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<div class=\"siw-main-header\"></div><div class=\"siw-main-body\"></div><div class=\"siw-main-footer\"></div>";
    },
    "useData": true
  }),
  preRender: function preRender() {
    _okta.View.prototype.preRender.apply(this, arguments); // Add Views


    this.add(this.Header, {
      selector: '.siw-main-header',
      options: this.options
    });
    this.renderForm();
    this.add(this.Footer, {
      selector: '.siw-main-footer',
      options: this.options
    });
  },
  renderForm: function renderForm() {
    var _this = this;

    var optionUiSchemaConfig;

    if (this.form) {
      this.form.remove();
      optionUiSchemaConfig = this.form.model.toJSON({
        verbose: true
      });
    } // Create Model


    var IonModel = this.createModelClass(this.options.currentViewState, optionUiSchemaConfig);
    var model = new IonModel({
      formName: this.options.currentViewState.name
    });

    if (!optionUiSchemaConfig) {
      optionUiSchemaConfig = model.toJSON({
        verbose: true
      });
    }

    this.model = model;
    this.form = this.add(this.Body, {
      selector: '.siw-main-body',
      options: (0, _assign.default)({}, this.options, {
        model: model,
        optionUiSchemaConfig: optionUiSchemaConfig
      })
    }).last();

    _okta._.each(model.attributes, function (value, key) {
      if (key.match(/sub_schema_local_[^ ]+/)) {
        // in order to render different sub-schema
        _this.listenTo(model, "change:".concat(key), function () {
          _this.renderForm();
        });
      }
    });
  },
  createModelClass: function createModelClass(currentViewState) {
    var optionUiSchemaConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _BaseModel.default.create(currentViewState, optionUiSchemaConfig);
  }
});

exports.default = _default;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(77);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(561);

/***/ }),
/* 46 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(120);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(217), __webpack_require__(24), __webpack_require__(10), __webpack_require__(75), __webpack_require__(56), __webpack_require__(766)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, OAuth2Util, Util, Enums, BrowserFeatures, Errors, ErrorCodes) {
  var fn = {};

  var verifyUrlTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "signin/verify/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "provider",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 14
          },
          "end": {
            "line": 1,
            "column": 26
          }
        }
      }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "factorType",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 27
          },
          "end": {
            "line": 1,
            "column": 41
          }
        }
      }) : helper));
    },
    "useData": true
  });

  var verifyUrlMultipleTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "signin/verify/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "provider",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 14
          },
          "end": {
            "line": 1,
            "column": 26
          }
        }
      }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "factorType",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 27
          },
          "end": {
            "line": 1,
            "column": 41
          }
        }
      }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorIndex") || (depth0 != null ? lookupProperty(depth0, "factorIndex") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "factorIndex",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 42
          },
          "end": {
            "line": 1,
            "column": 57
          }
        }
      }) : helper));
    },
    "useData": true
  });

  var verifyUrlNoProviderTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "signin/verify/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "factorType",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 14
          },
          "end": {
            "line": 1,
            "column": 28
          }
        }
      }) : helper));
    },
    "useData": true
  });

  var enrollFactorUrlTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "signin/enroll/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "provider",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 14
          },
          "end": {
            "line": 1,
            "column": 26
          }
        }
      }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "factorType",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 27
          },
          "end": {
            "line": 1,
            "column": 41
          }
        }
      }) : helper));
    },
    "useData": true
  });

  var activateFactorUrlTpl = _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "step") || (depth0 != null ? lookupProperty(depth0, "step") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "step",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 63
          },
          "end": {
            "line": 1,
            "column": 71
          }
        }
      }) : helper));
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "signin/enroll-activate/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "provider",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 23
          },
          "end": {
            "line": 1,
            "column": 35
          }
        }
      }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "factorType",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 36
          },
          "end": {
            "line": 1,
            "column": 50
          }
        }
      }) : helper)) + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "step") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 50
          },
          "end": {
            "line": 1,
            "column": 78
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  });

  var recoveryUrlTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "signin/recovery/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "recoveryToken") || (depth0 != null ? lookupProperty(depth0, "recoveryToken") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "recoveryToken",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 16
          },
          "end": {
            "line": 1,
            "column": 33
          }
        }
      }) : helper));
    },
    "useData": true
  });

  var refreshUrlTpl = _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "token") || (depth0 != null ? lookupProperty(depth0, "token") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "token",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 39
          },
          "end": {
            "line": 1,
            "column": 48
          }
        }
      }) : helper));
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "signin/refresh-auth-state" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "token") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 25
          },
          "end": {
            "line": 1,
            "column": 55
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  });

  var sessionCookieRedirectTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "baseUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 11
          }
        }
      }) : helper)) + "/login/sessionCookieRedirect?checkAccountSetupComplete=true&token=" + ((stack1 = (helper = (helper = lookupProperty(helpers, "token") || (depth0 != null ? lookupProperty(depth0, "token") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "token",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 77
          },
          "end": {
            "line": 1,
            "column": 88
          }
        }
      }) : helper)) != null ? stack1 : "") + "&redirectUrl=" + ((stack1 = (helper = (helper = lookupProperty(helpers, "redirectUrl") || (depth0 != null ? lookupProperty(depth0, "redirectUrl") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "redirectUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 101
          },
          "end": {
            "line": 1,
            "column": 118
          }
        }
      }) : helper)) != null ? stack1 : "");
    },
    "useData": true
  });

  fn.isHostBackgroundChromeTab = function () {
    // Checks if the SIW is loaded in a chrome webview and
    // it is in an app that is in background.
    if (navigator.userAgent.match(/Android/) && navigator.userAgent.match(/Chrome/) && document.hidden) {
      return true;
    } else {
      return false;
    }
  };

  fn.isDocumentVisible = function () {
    return document.visibilityState === 'visible';
  };

  fn.createVerifyUrl = function (provider, factorType, factorIndex) {
    if (provider && factorIndex) {
      return verifyUrlMultipleTpl({
        provider: encodeURIComponent(provider.toLowerCase()),
        factorType: encodeURIComponent(factorType),
        factorIndex: encodeURIComponent(factorIndex)
      });
    } else if (provider) {
      return verifyUrlTpl({
        provider: encodeURIComponent(provider.toLowerCase()),
        factorType: encodeURIComponent(factorType)
      });
    } else {
      return verifyUrlNoProviderTpl({
        factorType: encodeURIComponent(factorType)
      });
    }
  };

  fn.createEnrollFactorUrl = function (provider, factorType) {
    return enrollFactorUrlTpl({
      provider: encodeURIComponent(provider.toLowerCase()),
      factorType: encodeURIComponent(factorType)
    });
  };

  fn.createActivateFactorUrl = function (provider, factorType, step) {
    return activateFactorUrlTpl({
      provider: encodeURIComponent(provider.toLowerCase()),
      factorType: encodeURIComponent(factorType),
      step: step ? encodeURIComponent(step) : false
    });
  };

  fn.createRecoveryUrl = function (recoveryToken) {
    return recoveryUrlTpl({
      recoveryToken: encodeURIComponent(recoveryToken)
    });
  };

  fn.createRefreshUrl = function (stateToken) {
    var token = stateToken ? encodeURIComponent(stateToken) : null;
    return refreshUrlTpl({
      token: token
    });
  };

  fn.routeAfterAuthStatusChangeError = function (router, err) {
    if (!err) {
      return;
    } // Global error handling for CORS enabled errors


    if (err.xhr && BrowserFeatures.corsIsNotEnabled(err.xhr)) {
      router.settings.callGlobalError(new Errors.UnsupportedBrowserError(Okta.loc('error.enabled.cors')));
      return;
    } // Token has expired - no longer valid. Navigate back to primary auth.


    if (err.errorCode === ErrorCodes.INVALID_TOKEN_EXCEPTION) {
      router.appState.set('flashError', err);
      router.controller.state.set('navigateDir', Enums.DIRECTION_BACK);
      router.navigate('', {
        trigger: true
      });
      return;
    }

    Util.triggerAfterError(router.controller, err);
  };

  fn.routeAfterAuthStatusChange = function (router, res) {
    // Other errors are handled by the function making the authClient request
    if (!res || !res.status) {
      router.appState.clearLastAuthResponse();
      return;
    }

    router.appState.setAuthResponse(res);

    if (router.controller && router.controller.trapAuthResponse(res)) {
      return;
    }

    fn.handleResponseStatus(router, res);
  };

  fn.handleResponseStatus = function (router, res) {
    switch (res.status) {
      case 'SUCCESS':
        if (res.recoveryType === Enums.RECOVERY_TYPE_UNLOCK) {
          router.navigate('signin/account-unlocked', {
            trigger: true
          });
          return;
        } // If the desired end result object needs to have idToken (and not sessionToken),
        // get the id token from session token before calling the global success function.


        if (router.settings.get('oauth2Enabled')) {
          OAuth2Util.getTokens(router.settings, {
            sessionToken: res.sessionToken
          }, router.controller);
          return;
        }

        var successData = {
          user: res._embedded.user,
          type: res.type || Enums.SESSION_SSO
        };

        if (res.relayState) {
          successData.relayState = res.relayState;
        }

        var redirectFn = router.settings.get('redirectUtilFn');
        var nextUrl = res._links && (res._links.original && res._links.original.href || res._links.next && res._links.next.href);

        if (res.type === Enums.SESSION_STEP_UP) {
          var targetUrl = res._links && res._links.next && res._links.next.href;
          successData.stepUp = {
            url: targetUrl,
            finish: function finish() {
              redirectFn(targetUrl);
            }
          };
        } else if (nextUrl) {
          successData.next = function () {
            redirectFn(nextUrl);
          };
        } else {
          // Add the type for now until the API returns it.
          successData.type = Enums.SESSION_SSO;
          successData.session = {
            token: res.sessionToken,
            setCookieAndRedirect: function setCookieAndRedirect(redirectUrl) {
              redirectFn(sessionCookieRedirectTpl({
                baseUrl: router.settings.get('baseUrl'),
                token: encodeURIComponent(res.sessionToken),
                redirectUrl: encodeURIComponent(redirectUrl)
              }));
            }
          };
        } // Check if we need to wait for redirect based on host.


        if (fn.isHostBackgroundChromeTab()) {
          document.addEventListener('visibilitychange', function checkVisibilityAndCallSuccess() {
            if (fn.isDocumentVisible()) {
              document.removeEventListener('visibilitychange', checkVisibilityAndCallSuccess);
              router.settings.callGlobalSuccess(Enums.SUCCESS, successData);
            }
          });
        } else {
          router.settings.callGlobalSuccess(Enums.SUCCESS, successData);
        }

        return;

      case 'ADMIN_CONSENT_REQUIRED':
        router.navigate('signin/admin-consent', {
          trigger: true
        });
        return;

      case 'CONSENT_REQUIRED':
        if (router.settings.get('features.consent')) {
          router.navigate('signin/consent', {
            trigger: true
          });
        }

        return;
      // We want the same view for FACTOR_REQUIRED & FACTOR_CHALLENGE
      // In the new idx pipeline FACTOR_CHALLENGE API response does not contain a prev link

      case 'FACTOR_REQUIRED':
      case 'FACTOR_CHALLENGE':
      case 'MFA_REQUIRED':
        // When the widget is bootstrapped with an error in MFA_CHALLENGE state, we pass the
        // lastFailedChallengeFactorData to MFA_REQUIRED, in order to show the error message
        // on the correct factor view
        var lastFailedChallengeFactorData = router.appState.get('lastFailedChallengeFactorData');

        if (lastFailedChallengeFactorData && lastFailedChallengeFactorData.factor) {
          router.appState.get('factors').lastUsedFactor = lastFailedChallengeFactorData.factor;
        }

        var factor = router.appState.get('factors').getDefaultFactor();
        var url = fn.createVerifyUrl(factor.get('provider'), factor.get('factorType'));
        router.navigate(url, {
          trigger: true
        });
        router.appState.clearLastFailedChallengeFactorData();
        return;

      case 'POLL':
        var pollUrl = 'signin/poll';
        router.navigate(pollUrl, {
          trigger: true
        });
        return;

      case 'MFA_CHALLENGE':
        // Since we normally trap MFA_CHALLENGE, this will only get called on a
        // page refresh or when an error is returned on verification with an IdP.
        // We need to return to MFA_REQUIRED to initialize the
        // page correctly (i.e. factors dropdown, etc)
        if (router.appState.get('isFactorResultFailed')) {
          router.appState.setLastFailedChallengeFactorData();
        }

        router.appState.get('transaction').prev().then(function (trans) {
          router.appState.set('transaction', trans);
        }); // TODO: catch/handle error here?

        return;

      case 'MFA_ENROLL':
      case 'FACTOR_ENROLL':
        router.navigate('signin/enroll', {
          trigger: true
        });
        return;

      case 'MFA_ENROLL_ACTIVATE':
      case 'FACTOR_ENROLL_ACTIVATE':
        var activateUrl = fn.createActivateFactorUrl(router.appState.get('activatedFactorProvider'), router.appState.get('activatedFactorType'));
        router.navigate(activateUrl, {
          trigger: true
        });
        return;

      case 'PASSWORD_WARN':
      case 'PASSWORD_EXPIRED':
        if (router.settings.get('features.customExpiredPassword') && !router.appState.get('isPwdManagedByOkta')) {
          router.navigate('signin/custom-password-expired', {
            trigger: true
          });
        } else {
          router.navigate('signin/password-expired', {
            trigger: true
          });
        }

        return;

      case 'RECOVERY_CHALLENGE':
        // Will use this workaround (lowercasing response) until OKTA-69083 is resolved
        var fromEmail = res.factorType.toLowerCase() === Enums.RECOVERY_FACTOR_TYPE_EMAIL.toLowerCase(),
            isForgotPassword = res.recoveryType === Enums.RECOVERY_TYPE_PASSWORD,
            isUnlock = res.recoveryType === Enums.RECOVERY_TYPE_UNLOCK;

        if (isForgotPassword && fromEmail) {
          router.navigate('signin/recovery-emailed', {
            trigger: true
          });
        } else if (isUnlock && fromEmail) {
          router.navigate('signin/unlock-emailed', {
            trigger: true
          });
        } else {
          router.navigate('signin/recovery-challenge', {
            trigger: true
          });
        }

        return;

      case 'RECOVERY':
        router.navigate('signin/recovery-question', {
          trigger: true
        });
        return;

      case 'PASSWORD_RESET':
        router.navigate('signin/password-reset', {
          trigger: true
        });
        return;

      case 'LOCKED_OUT':
        if (router.settings.get('features.selfServiceUnlock')) {
          router.navigate('signin/unlock', {
            trigger: true
          });
        } else {
          router.controller.model.trigger('error', router.controller.model, {
            responseJSON: {
              errorCauses: [],
              errorSummary: Okta.loc('error.auth.lockedOut', 'login')
            }
          });
        }

        return;

      case 'PROFILE_REQUIRED':
        router.navigate('signin/enroll-user', {
          trigger: true
        });
        return;

      case 'UNAUTHENTICATED':
        // Either we have factors and we are in passwordlessAuth mode
        if (router.appState.get('promptForFactorInUnauthenticated')) {
          var defaultFactor = router.appState.get('factors').getDefaultFactor();
          var factorURL = fn.createVerifyUrl(defaultFactor.get('provider'), defaultFactor.get('factorType'));
          router.navigate(factorURL, {
            trigger: true
          });
          return;
        } // Or we don't have anything and we need to show the login page


        router.navigate('', {
          trigger: true
        });
        return;

      default:
        throw new Error('Unknown status: ' + res.status);
    }
  };

  return fn;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var hide = __webpack_require__(54);
var has = __webpack_require__(53);
var SRC = __webpack_require__(95)('src');
var $toString = __webpack_require__(379);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(30).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var fails = __webpack_require__(12);
var defined = __webpack_require__(77);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(39);
var fails = __webpack_require__(20);
var has = __webpack_require__(46);

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(107);

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34);
var createDesc = __webpack_require__(94);
module.exports = __webpack_require__(33) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(128);
var defined = __webpack_require__(77);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums) {
  function ConfigError(message) {
    this.name = Enums.CONFIG_ERROR;
    this.message = message || Okta.loc('error.config');
  }

  ConfigError.prototype = new Error();

  function UnsupportedBrowserError(message) {
    this.name = Enums.UNSUPPORTED_BROWSER_ERROR;
    this.message = message || Okta.loc('error.unsupported.browser');
  }

  UnsupportedBrowserError.prototype = new Error();

  function OAuthError(message) {
    this.name = Enums.OAUTH_ERROR;
    this.message = message;
  }

  OAuthError.prototype = new Error();

  function RegistrationError(message) {
    this.name = Enums.REGISTRATION_FAILED;
    this.message = message;
  }

  RegistrationError.prototype = new Error(); // Thrown when initiation of poll was cancelled.

  function AuthStopPollInitiationError() {
    this.name = Enums.AUTH_STOP_POLL_INITIATION_ERROR;
  }

  AuthStopPollInitiationError.prototype = new Error();

  function U2FError(err) {
    this.name = Enums.U2F_ERROR;
    this.message = err.xhr.responseJSON.errorSummary;
    this.xhr = err.xhr;
  }

  U2FError.prototype = new Error();

  function WebAuthnError(err) {
    this.name = Enums.WEB_AUTHN_ERROR;
    this.message = err.xhr.responseJSON.errorSummary;
    this.xhr = err.xhr;
  }

  WebAuthnError.prototype = new Error(); // This is triggered only when code aborts webauthn browser prompt.

  function WebauthnAbortError() {
    this.name = Enums.WEBAUTHN_ABORT_ERROR;
  }

  WebauthnAbortError.prototype = new Error();
  return {
    ConfigError: ConfigError,
    UnsupportedBrowserError: UnsupportedBrowserError,
    OAuthError: OAuthError,
    RegistrationError: RegistrationError,
    AuthStopPollInitiationError: AuthStopPollInitiationError,
    U2FError: U2FError,
    WebAuthnError: WebAuthnError,
    WebauthnAbortError: WebauthnAbortError
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.FORMS_FOR_VERIFICATION = exports.FORMS_WITH_STATIC_BACK_LINK = exports.FORMS_WITHOUT_SIGNOUT = exports.FORMS = void 0;

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var FORMS = {
  IDENTIFY: 'identify',
  SELECT_IDENTIFY: 'select-identify',
  SELECT_ENROLL_PROFILE: 'select-enroll-profile',
  ENROLL_PROFILE: 'enroll-profile',
  SELECT_AUTHENTICATOR_AUTHENTICATE: 'select-authenticator-authenticate',
  AUTHENTICATOR_VERIFICATION_DATA: 'authenticator-verification-data',
  CHALLENGE_AUTHENTICATOR: 'challenge-authenticator',
  CHALLENGE_POLL: 'challenge-poll',
  RESEND: 'resend',
  SELECT_AUTHENTICATOR_ENROLL: 'select-authenticator-enroll',
  SELECT_AUTHENTICATOR_ENROLL_DATA: 'select-authenticator-enroll-data',
  AUTHENTICATOR_ENROLLMENT_DATA: 'authenticator-enrollment-data',
  ENROLL_AUTHENTICATOR: 'enroll-authenticator',
  SELECT_ENROLLMENT_CHANNEL: 'select-enrollment-channel',
  ENROLLMENT_CHANNEL_DATA: 'enrollment-channel-data',
  ENROLL_POLL: 'enroll-poll',
  REENROLL_AUTHENTICATOR: 'reenroll-authenticator',
  REENROLL_AUTHENTICATOR_WARNING: 'reenroll-authenticator-warning',
  RESET_AUTHENTICATOR: 'reset-authenticator',
  SKIP: 'skip',
  SUCCESS_REDIRECT: 'success-redirect',
  REDIRECT_IDP: 'redirect-idp',
  DEVICE_CHALLENGE_POLL: 'device-challenge-poll',
  DEVICE_APPLE_SSO_EXTENSION: 'device-apple-sso-extension',
  CANCEL_TRANSACTION: 'cancel-transaction',
  LAUNCH_AUTHENTICATOR: 'launch-authenticator',
  // 'terminal` is not ION Form name but only coined in widget
  // for rendering a page that user has nothing to remediate.
  TERMINAL: 'terminal'
};
exports.FORMS = FORMS;
var FORMS_WITHOUT_SIGNOUT = [FORMS.IDENTIFY, FORMS.SUCCESS_REDIRECT, FORMS.ENROLL_PROFILE, FORMS.SELECT_AUTHENTICATOR_ENROLL, FORMS.AUTHENTICATOR_ENROLLMENT_DATA, FORMS.ENROLL_AUTHENTICATOR, FORMS.REDIRECT_IDP, FORMS.RESET_AUTHENTICATOR, // TODO: remove following when deprecating `factor`
'select-factor-enroll', 'enroll-factor'];
exports.FORMS_WITHOUT_SIGNOUT = FORMS_WITHOUT_SIGNOUT;
var FORMS_WITH_STATIC_BACK_LINK = [FORMS.SELECT_AUTHENTICATOR_ENROLL, FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE];
exports.FORMS_WITH_STATIC_BACK_LINK = FORMS_WITH_STATIC_BACK_LINK;
var FORMS_FOR_VERIFICATION = [FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, FORMS.CHALLENGE_AUTHENTICATOR, FORMS.CHALLENGE_POLL, FORMS.RESEND];
exports.FORMS_FOR_VERIFICATION = FORMS_FOR_VERIFICATION;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(12);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(161);
var requireObjectCoercible = __webpack_require__(107);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(39);
var definePropertyModule = __webpack_require__(62);
var createPropertyDescriptor = __webpack_require__(105);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(39);
var IE8_DOM_DEFINE = __webpack_require__(278);
var anObject = __webpack_require__(43);
var toPrimitive = __webpack_require__(162);

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  function _log(level, args) {
    // Only log statements in development mode or if
    // throwing an error through console.error
    if (false || level === 'error') {
      window.console[level].apply(window.console, args);
    }
  }
  /**
   * Utility library of logging functions.
   */


  return {
    trace: function trace() {
      return _log('trace', arguments);
    },
    dir: function dir() {
      return _log('dir', arguments);
    },
    time: function time() {
      return _log('time', arguments);
    },
    timeEnd: function timeEnd() {
      return _log('timeEnd', arguments);
    },
    group: function group() {
      return _log('group', arguments);
    },
    groupEnd: function groupEnd() {
      return _log('groupEnd', arguments);
    },
    assert: function assert() {
      return _log('assert', arguments);
    },
    log: function log() {
      return _log('log', arguments);
    },
    info: function info() {
      return _log('info', arguments);
    },
    warn: function warn() {
      return _log('warn', arguments);
    },
    error: function error() {
      return _log('error', arguments);
    },
    deprecate: function deprecate(msg) {
      return _log('warn', ['[okta-signin-widget] DEPRECATED:', msg]);
    }
  };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _BaseFooter = _interopRequireDefault(__webpack_require__(92));

var _LinksUtil = __webpack_require__(146);

var _default = _BaseFooter.default.extend({
  links: function links() {
    return (0, _LinksUtil.getSwitchAuthenticatorLink)(this.options.appState);
  }
});

exports.default = _default;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(67);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(129);
var createDesc = __webpack_require__(94);
var toIObject = __webpack_require__(55);
var toPrimitive = __webpack_require__(86);
var has = __webpack_require__(53);
var IE8_DOM_DEFINE = __webpack_require__(244);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(33) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2);
var core = __webpack_require__(30);
var fails = __webpack_require__(12);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(66);
var IObject = __webpack_require__(128);
var toObject = __webpack_require__(44);
var toLength = __webpack_require__(25);
var asc = __webpack_require__(260);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(15);
var global = __webpack_require__(22);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(88);
var IndexedObject = __webpack_require__(161);
var toObject = __webpack_require__(52);
var toLength = __webpack_require__(47);
var arraySpeciesCreate = __webpack_require__(164);

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extend = extend;
exports.indexOf = indexOf;
exports.escapeExpression = escapeExpression;
exports.isEmpty = isEmpty;
exports.createFrame = createFrame;
exports.blockParams = blockParams;
exports.appendContextPath = appendContextPath;
var escape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

var badChars = /[&<>"'`=]/g,
    possible = /[&<>"'`=]/;

function escapeChar(chr) {
  return escape[chr];
}

function extend(obj /* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;
}

var toString = Object.prototype.toString;

exports.toString = toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */
if (isFunction(/x/)) {
  exports.isFunction = isFunction = function (value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
exports.isFunction = isFunction;

/* eslint-enable func-style */

/* istanbul ignore next */
var isArray = Array.isArray || function (value) {
  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};

exports.isArray = isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.

function indexOf(array, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
}

function escapeExpression(string) {
  if (typeof string !== 'string') {
    // don't escape SafeStrings, since they're already safe
    if (string && string.toHTML) {
      return string.toHTML();
    } else if (string == null) {
      return '';
    } else if (!string) {
      return string + '';
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = '' + string;
  }

  if (!possible.test(string)) {
    return string;
  }
  return string.replace(badChars, escapeChar);
}

function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}

function createFrame(object) {
  var frame = extend({}, object);
  frame._parent = object;
  return frame;
}

function blockParams(params, ids) {
  params.path = ids;
  return params;
}

function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  var fn = {},
      hasFullCorsSupport = ('withCredentials' in new window.XMLHttpRequest()),
      hasXDomainRequest = typeof XDomainRequest !== 'undefined';

  fn.corsIsNotSupported = function () {
    return !(hasFullCorsSupport || hasXDomainRequest);
  };

  fn.corsIsNotEnabled = function (jqXhr) {
    // Not a definitive check, but it's the best we've got.
    // Note: This will change when OktaAuth is updated
    return jqXhr.status === 0;
  }; // This is currently not being used, but we'll keep it around for when we
  // want a fallback mechanism - i.e. use localStorage if it exists, else fall
  // back to cookies.


  fn.localStorageIsNotSupported = function () {
    var test = 'test';

    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return false;
    } catch (e) {
      return true;
    }
  };

  fn.supportsPushState = function (win) {
    win = win || window;
    return !!(win.history && win.history.pushState);
  };

  fn.isIE = function () {
    return /(msie|trident)/i.test(navigator.userAgent);
  };

  fn.isFirefox = function () {
    var _context;

    return (0, _indexOf.default)(_context = navigator.userAgent.toLowerCase()).call(_context, 'firefox') > -1;
  };

  fn.isEdge = function () {
    var _context2;

    // This is to just check for windows edge. Mac edge - chromium based's UA is 'edg'.
    return (0, _indexOf.default)(_context2 = navigator.userAgent.toLowerCase()).call(_context2, 'edge') > -1;
  };

  fn.isSafari = function () {
    var _context3, _context4;

    // Chrome has safari in its useragent string so adding this extra check.
    return (0, _indexOf.default)(_context3 = navigator.userAgent.toLowerCase()).call(_context3, 'safari') > -1 && (0, _indexOf.default)(_context4 = navigator.userAgent.toLowerCase()).call(_context4, 'chrome') === -1;
  };

  fn.isMac = function () {
    var _context5;

    return (0, _indexOf.default)(_context5 = navigator.platform.toUpperCase()).call(_context5, 'MAC') >= 0;
  };

  fn.isAndroid = function () {
    // Windows Phone also contains "Android"
    return /android/i.test(navigator.userAgent) && !/windows phone/i.test(navigator.userAgent);
  };

  fn.isIOS = function () {
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }; // Returns a list of languages the user has configured for their browser, in
  // order of preference.


  fn.getUserLanguages = function () {
    var languages, properties; // Chrome, Firefox

    if (navigator.languages) {
      return navigator.languages;
    }

    languages = [];
    properties = ['language', // Safari, IE11
    'userLanguage', // IE
    'browserLanguage', // IE
    'systemLanguage' // IE
    ];
    (0, _forEach.default)(properties).call(properties, function (property) {
      if (navigator[property]) {
        languages.push(navigator[property]);
      }
    });
    return languages;
  };

  return fn;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 76 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(33)) {
  var LIBRARY = __webpack_require__(96);
  var global = __webpack_require__(11);
  var fails = __webpack_require__(12);
  var $export = __webpack_require__(2);
  var $typed = __webpack_require__(159);
  var $buffer = __webpack_require__(211);
  var ctx = __webpack_require__(66);
  var anInstance = __webpack_require__(118);
  var propertyDesc = __webpack_require__(94);
  var hide = __webpack_require__(54);
  var redefineAll = __webpack_require__(119);
  var toInteger = __webpack_require__(68);
  var toLength = __webpack_require__(25);
  var toIndex = __webpack_require__(271);
  var toAbsoluteIndex = __webpack_require__(98);
  var toPrimitive = __webpack_require__(86);
  var has = __webpack_require__(53);
  var classof = __webpack_require__(130);
  var isObject = __webpack_require__(14);
  var toObject = __webpack_require__(44);
  var isArrayIter = __webpack_require__(203);
  var create = __webpack_require__(99);
  var getPrototypeOf = __webpack_require__(101);
  var gOPN = __webpack_require__(100).f;
  var getIterFn = __webpack_require__(205);
  var uid = __webpack_require__(95);
  var wks = __webpack_require__(21);
  var createArrayMethod = __webpack_require__(71);
  var createArrayIncludes = __webpack_require__(149);
  var speciesConstructor = __webpack_require__(131);
  var ArrayIterators = __webpack_require__(207);
  var Iterators = __webpack_require__(116);
  var $iterDetect = __webpack_require__(152);
  var setSpecies = __webpack_require__(117);
  var arrayFill = __webpack_require__(206);
  var arrayCopyWithin = __webpack_require__(262);
  var $DP = __webpack_require__(34);
  var $GOPD = __webpack_require__(69);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
var DOMIterables = __webpack_require__(604);
var global = __webpack_require__(22);
var classof = __webpack_require__(81);
var createNonEnumerableProperty = __webpack_require__(61);
var Iterators = __webpack_require__(111);
var wellKnownSymbol = __webpack_require__(23);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
  }
  Iterators[COLLECTION_NAME] = Iterators.Array;
}


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(285);
var global = __webpack_require__(22);
var isObject = __webpack_require__(31);
var createNonEnumerableProperty = __webpack_require__(61);
var objectHas = __webpack_require__(46);
var sharedKey = __webpack_require__(167);
var hiddenKeys = __webpack_require__(134);

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(227);
var classofRaw = __webpack_require__(106);
var wellKnownSymbol = __webpack_require__(23);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(643);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(664);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums) {
  var Util = Okta.internal.util.Util;
  var _ = Okta._;
  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link " + alias4((helper = (helper = lookupProperty(helpers, "linkClassName") || (depth0 != null ? lookupProperty(depth0, "linkClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "linkClassName",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 24
            },
            "end": {
              "line": 1,
              "column": 41
            }
          }
        }) : helper)) + "\" data-se=\"signout-link\">" + alias4((helper = (helper = lookupProperty(helpers, "linkText") || (depth0 != null ? lookupProperty(depth0, "linkText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "linkText",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 66
            },
            "end": {
              "line": 1,
              "column": 78
            }
          }
        }) : helper)) + "</a>";
      },
      "useData": true
    }),
    className: 'auth-footer clearfix',
    events: {
      'click a': function clickA(e) {
        e.preventDefault();
        this.options.appState.trigger('signOut');
        var self = this;
        this.model.doTransaction(function (transaction) {
          return transaction.cancel();
        }).then(function () {
          if (self.settings.get('signOutLink')) {
            Util.redirect(self.settings.get('signOutLink'));
          } else {
            self.state.set('navigateDir', Enums.DIRECTION_BACK);
            self.options.appState.trigger('navigate', '');
          }
        });
      }
    },
    getTemplateData: function getTemplateData() {
      return {
        linkClassName: _.isUndefined(this.options.linkClassName) ? 'goto' : this.options.linkClassName,
        linkText: this.options.linkText || Okta.loc('signout', 'login')
      };
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  // Have to be unescaped for the html in enroll.windowsHello.error.notConfiguredHtml
  var template = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"icon error-24\"></span><h4><strong>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "message",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 47
          },
          "end": {
            "line": 1,
            "column": 60
          }
        }
      }) : helper)) != null ? stack1 : "") + "</strong></h4>";
    },
    "useData": true
  });

  return Okta.View.extend({
    template: template,
    className: 'okta-infobox-error infobox infobox-error infobox-md margin-btm-25',
    attributes: {
      'data-se': 'o-form-error-html'
    },
    message: '',
    initialize: function initialize(options) {
      if (options && options.message) {
        this.message = options.message;
      }
    },
    getTemplateData: function getTemplateData() {
      return {
        message: this.message
      };
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(95)('meta');
var isObject = __webpack_require__(14);
var has = __webpack_require__(53);
var setDesc = __webpack_require__(34).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(12)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(60);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(227);
var defineProperty = __webpack_require__(62).f;
var createNonEnumerableProperty = __webpack_require__(61);
var has = __webpack_require__(46);
var toString = __webpack_require__(602);
var wellKnownSymbol = __webpack_require__(23);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has(target, TO_STRING_TAG)) {
      defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT) {
      createNonEnumerableProperty(target, 'toString', toString);
    }
  }
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(629);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(43);
var isArrayIteratorMethod = __webpack_require__(324);
var toLength = __webpack_require__(47);
var bind = __webpack_require__(88);
var getIteratorMethod = __webpack_require__(180);
var callWithSafeIterationClosing = __webpack_require__(325);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _okta = __webpack_require__(0);

var _Link = _interopRequireDefault(__webpack_require__(875));

var _LinksUtil = __webpack_require__(146);

/**
 * When `href` is present, the Link behaviors as normal link (anchor element).
 * When `actionPath` is present, the Link behaviors as link button
 *   on which user clicks, will trigger the action `actionPath`.
 * When `formName` is present, the link behaviors as link button
 *   on which user clicks, will submit a remediation form.
 *
 * @typedef {Object} Link
 * @property {string} label
 * @property {string} name
 * @property {string=} href
 * @property {string=} actionPath
 * @property {string=} formName
 */
var _default = _okta.View.extend({
  className: 'auth-footer',

  /**
   * {Link[]} links
   */
  links: [],
  initialize: function initialize() {
    var _this = this;

    var links = _okta._.resultCtx(this, 'links', this); // safe check
    // 1. avoid none array from override
    // 2. ignore any none plain object arguments


    if (!(0, _isArray.default)(links)) {
      links = [];
    } else {
      links = (0, _filter.default)(links).call(links, function (l) {
        return _okta.$.isPlainObject(l);
      });
    } // add cancel/signout link if the form qualifies for it


    if (this.options.appState.shouldShowSignOutLinkInCurrentForm(this.options.settings.get('features.hideSignOutLinkInMFA'))) {
      links = (0, _concat.default)(links).call(links, (0, _LinksUtil.getSignOutLink)(this.options.settings));
    }

    (0, _forEach.default)(links).call(links, function (link) {
      _this.add(_Link.default, {
        options: link
      });
    });
  }
});

exports.default = _default;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _BaseFooter = _interopRequireDefault(__webpack_require__(92));

var _LinksUtil = __webpack_require__(146);

var _default = _BaseFooter.default.extend({
  links: function links() {
    return (0, _LinksUtil.getSwitchAuthenticatorLink)(this.options.appState);
  }
});

exports.default = _default;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(246);
var enumBugKeys = __webpack_require__(190);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(68);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(13);
var dPs = __webpack_require__(247);
var enumBugKeys = __webpack_require__(190);
var IE_PROTO = __webpack_require__(189)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(187)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(191).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(246);
var hiddenKeys = __webpack_require__(190).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(53);
var toObject = __webpack_require__(44);
var IE_PROTO = __webpack_require__(189)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(21)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(54)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(39);
var propertyIsEnumerableModule = __webpack_require__(160);
var createPropertyDescriptor = __webpack_require__(105);
var toIndexedObject = __webpack_require__(59);
var toPrimitive = __webpack_require__(162);
var has = __webpack_require__(46);
var IE8_DOM_DEFINE = __webpack_require__(278);

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(20);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(565);

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(106);

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var errorProps = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];

function Exception(message, node) {
  var loc = node && node.loc,
      line = undefined,
      endLineNumber = undefined,
      column = undefined,
      endColumn = undefined;

  if (loc) {
    line = loc.start.line;
    endLineNumber = loc.end.line;
    column = loc.start.column;
    endColumn = loc.end.column;

    message += ' - ' + line + ':' + column;
  }

  var tmp = Error.prototype.constructor.call(this, message);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }

  /* istanbul ignore else */
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, Exception);
  }

  try {
    if (loc) {
      this.lineNumber = line;
      this.endLineNumber = endLineNumber;

      // Work around issue under safari where we can't directly set the column value
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(this, 'column', {
          value: column,
          enumerable: true
        });
        Object.defineProperty(this, 'endColumn', {
          value: endColumn,
          enumerable: true
        });
      } else {
        this.column = column;
        this.endColumn = endColumn;
      }
    }
  } catch (nop) {
    /* Ignore if the browser is very particular */
  }
}

Exception.prototype = new Error();

exports['default'] = Exception;
module.exports = exports['default'];


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _freeze = _interopRequireDefault(__webpack_require__(352));

var _map = _interopRequireDefault(__webpack_require__(41));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* globals JSON */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(36), __webpack_require__(238)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Q, FidoUtil) {
  function adaptToOkta(promise) {
    return new Q(promise);
  }

  function makeCredential(accountInfo, cryptoParams, challenge) {
    cryptoParams = (0, _map.default)(cryptoParams).call(cryptoParams, function (param) {
      return {
        type: 'FIDO_2_0',
        algorithm: param.algorithm
      };
    });
    var promise = window.msCredentials.makeCredential(accountInfo, cryptoParams, challenge).then(function (cred) {
      return (0, _freeze.default)({
        credential: {
          id: cred.id
        },
        publicKey: JSON.parse(cred.publicKey),
        attestation: cred.attestation
      });
    });
    return adaptToOkta(promise);
  }

  function getAssertion(challenge, allowList) {
    var accept = (0, _map.default)(allowList).call(allowList, function (item) {
      return {
        type: 'FIDO_2_0',
        id: item.id
      };
    });
    var filters = {
      accept: accept
    };
    var promise = window.msCredentials.getAssertion(challenge, filters).then(function (attestation) {
      var signature = attestation.signature;
      return (0, _freeze.default)({
        credential: {
          id: attestation.id
        },
        clientData: signature.clientData,
        authenticatorData: signature.authnrData,
        signature: signature.signature
      });
    });
    return adaptToOkta(promise);
  }

  return {
    makeCredential: makeCredential,
    getAssertion: getAssertion,
    isAvailable: function isAvailable() {
      return window.hasOwnProperty('msCredentials');
    },
    isNewApiAvailable: function isNewApiAvailable() {
      return navigator && navigator.credentials && navigator.credentials.create;
    },
    isWebauthnOrU2fAvailable: function isWebauthnOrU2fAvailable() {
      return this.isNewApiAvailable() || FidoUtil.isU2fAvailable();
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(34).f;
var has = __webpack_require__(53);
var TAG = __webpack_require__(21)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var defined = __webpack_require__(77);
var fails = __webpack_require__(12);
var spaces = __webpack_require__(193);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var dP = __webpack_require__(34);
var DESCRIPTORS = __webpack_require__(33);
var SPECIES = __webpack_require__(21)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(49);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(162);
var definePropertyModule = __webpack_require__(62);
var createPropertyDescriptor = __webpack_require__(105);

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(59);
var addToUnscopables = __webpack_require__(122);
var Iterators = __webpack_require__(111);
var InternalStateModule = __webpack_require__(80);
var defineIterator = __webpack_require__(287);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__(61);

module.exports = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _stringify = _interopRequireDefault(__webpack_require__(83));

var _keys = _interopRequireDefault(__webpack_require__(172));

var _crossFetch = _interopRequireDefault(__webpack_require__(708));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(175), __webpack_require__(215), __webpack_require__(36), __webpack_require__(709), __webpack_require__(710), __webpack_require__(64), __webpack_require__(216), __webpack_require__(75)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, _, Q, login, country, Logger, config, BrowserFeatures) {
  var STORAGE_KEY = 'osw.languages';
  /**
   * Converts options to our internal format, which distinguishes between
   * login and country bundles.
   *
   * Example options.i18n passed in by the developer:
   * {
   *   'en': {
   *     'needhelp': 'need help override',
   *     'primaryauth.title': 'new sign in text',
   *     'country.JP' = 'Japan, Japan'
   *   }
   * }
   *
   * Parsed:
   * {
   *  'en': {
   *    'login': {
   *      'needhelp': 'need help override',
   *      'primaryauth.title': 'new sign in text',
   *    },
   *    'country': {
   *      'JP': 'Japan, Japan'
   *    }
   *  }
   * }
   */

  function parseOverrides(i18n) {
    if (!i18n) {
      return {};
    }

    var i18nWithLowerCaseKeys = {};

    _.each((0, _keys.default)(_).call(_, i18n), function (key) {
      i18nWithLowerCaseKeys[key.toLowerCase()] = i18n[key];
    });

    return _.mapObject(i18nWithLowerCaseKeys, function (props) {
      var mapped = {
        login: {},
        country: {}
      };

      if (!_.isObject(props)) {
        throw new Error('Invalid format for "i18n"');
      }

      _.each(props, function (val, key) {
        var split = key.split(/^country\./);

        if (split.length > 1) {
          mapped.country[split[1]] = val;
        } else {
          mapped.login[split[0]] = val;
        }
      });

      return mapped;
    });
  } // Caching: We only bundle English by default in the Sign-In Widget. Other
  // languages are loaded on demand and cached in localStorage. These languages
  // are tied to the version of the widget - when it bumps, we reset the cache.


  function getCachedLanguages() {
    var storage = JSON.parse(localStorage.getItem(STORAGE_KEY));

    if (!storage || storage.version !== config.version) {
      storage = {
        version: config.version
      };
    }

    return storage;
  }

  function addLanguageToCache(language, loginJson, countryJson) {
    var current = getCachedLanguages();
    current[language] = {
      login: loginJson,
      country: countryJson
    };
    localStorage.setItem(STORAGE_KEY, (0, _stringify.default)(current));
  } // By default, the assets.bundleUrl is tied to the Okta CDN.
  //
  // There are two overrides available for modifying where we load the asset
  // bundles from:
  //
  // 1. assets.baseUrl
  //
  //    This is the base path the OSW pulls assets from, which in this case is
  //    the Okta CDN. Override this config option if you want to host the
  //    files on your own domain, or if you're using a new version of the
  //    widget whose language files haven't been published to the CDN yet.
  //
  // 2. assets.rewrite
  //
  //    This is a function that can be used to modify the path + fileName of
  //    the bundle we're loading, relative to the baseUrl. When called, it
  //    will pass the current path, and expect the new path to be returned.
  //    This is useful, for example, if your build process has an extra
  //    cachebusting step, i.e:
  //
  //    function rewrite(file) {
  //      // file: /labels/json/login_ja.json
  //      return file.replace('.json', '.' + md5file(file) + '.json');
  //    }
  //
  // Note: Most developers will not need to use these overrides - the default
  // is to use the Okta CDN and to use the same path + file structure the
  // widget module publishes by default.


  function fetchJson(bundle, language, assets) {
    var _context;

    var languageCode, path; // Our bundles use _ to separate country and region, i.e:
    // zh-CN -> zh_CN

    languageCode = language.replace('-', '_');
    path = assets.rewrite(encodeURI((0, _concat.default)(_context = "/labels/json/".concat(bundle, "_")).call(_context, languageCode, ".json")));
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'text/plain'
    };
    var mode = 'no-cors';
    return (0, _crossFetch.default)(assets.baseUrl + path, {
      method: 'GET',
      headers: headers,
      mode: mode
    }).then(function (res) {
      return res.text();
    }).then(function (txt) {
      return JSON.parse(txt);
    });
  }

  function getBundles(language, assets) {
    // Two special cases:
    // 1. English is already bundled with the widget
    // 2. If the language is not in our config file, it means that they've
    //    probably defined it on their own.
    if (language === 'en' || !_.contains(config.supportedLanguages, language)) {
      return Q({});
    } //local storage does not work correctly with android web views (embeded browers)
    //so skip the caching and just make the request to get the local info


    var localStorageIsSupported = !BrowserFeatures.localStorageIsNotSupported();

    if (localStorageIsSupported) {
      var cached = getCachedLanguages();

      if (cached[language]) {
        return Q(cached[language]);
      }
    }

    return Q.all([fetchJson('login', language, assets), fetchJson('country', language, assets)]).spread(function (loginJson, countryJson) {
      if (localStorageIsSupported) {
        addLanguageToCache(language, loginJson, countryJson);
      }

      return {
        login: loginJson,
        country: countryJson
      };
    }).catch(function () {
      // If there is an error, this will default to the bundled language and
      // we will no longer try to load the language this session.
      Logger.warn('Unable to load language: ' + language);
      return {};
    });
  }

  return {
    login: login,
    country: country,
    // Courage components within the sign in widget point to courage bundle to look
    // up i18nkeys. Since we dont have courage.properties inside the sign in widget
    // we are pointing courage bundle to login.
    courage: login,
    currentLanguage: null,
    isLoaded: function isLoaded(language) {
      return this.currentLanguage === language;
    },
    remove: function remove() {
      this.currentLanguage = null;
    },
    loadLanguage: function loadLanguage(language, overrides, assets) {
      var parsedOverrides = parseOverrides(overrides);
      var lowerCaseLanguage = language.toLowerCase();
      return getBundles(language, assets).then((0, _bind.default)(_).call(_, function (bundles) {
        // Always extend from the built in defaults in the event that some
        // properties are not translated
        this.login = _.extend({}, login, bundles.login);
        this.country = _.extend({}, country, bundles.country);
        this.courage = _.extend({}, login, bundles.login);

        if (parsedOverrides[lowerCaseLanguage]) {
          _.extend(this.login, parsedOverrides[lowerCaseLanguage]['login']);

          _.extend(this.country, parsedOverrides[lowerCaseLanguage]['country']);

          _.extend(this.courage, parsedOverrides[lowerCaseLanguage]['login']);
        }

        this.currentLanguage = language;
      }, this));
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _find = _interopRequireDefault(__webpack_require__(18));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Q) {
  var _ = Okta._;

  function getForm(controller) {
    return (0, _find.default)(_).call(_, controller.getChildren(), function (item) {
      return item instanceof Okta.Form;
    });
  }

  return Okta.Controller.extend({
    // Ideally we should be attaching the listeners in the constructor, but because of the way
    // we construct the FormController (this.model is generated after the BaseLoginController's
    // constructor is called), this.model is undefined in when try to attach the events and
    // therefore we don't listen to events for such forms. And changing the order in which we call
    // the constructor doesn't help either (JS errors etc.). This at least guarantees that we
    // are listening to the model events.
    // Note - Figure out a way to call the constructor in the right order.
    addListeners: function addListeners() {
      // Events to enable/disable the primary button on the forms
      this.listenTo(this.model, 'save', function () {
        //disable the submit button on forms while making the request
        //to prevent users from hitting rate limiting exceptions of
        //1 per second on the auth api
        var form = getForm(this);
        var disableSubmitButton = form.disableSubmitButton;

        if (disableSubmitButton && !form.disableSubmitButton()) {
          return;
        }

        this.toggleButtonState(true);
      });
      this.listenTo(this.model, 'error', function () {
        this.toggleButtonState(false);
      });
      this.addModelListeners(this.model);
    },
    addModelListeners: function addModelListeners(model) {
      var setTransactionHandler = (0, _bind.default)(_).call(_, function (transaction) {
        this.options.appState.set('transaction', transaction);
      }, this);
      var transactionErrorHandler = (0, _bind.default)(_).call(_, function (err) {
        this.options.appState.set('transactionError', err);
      }, this); // Events to set the transaction attributes on the app state.

      this.listenTo(model, 'setTransaction', setTransactionHandler);
      this.listenTo(model, 'setTransactionError', transactionErrorHandler); // For TOTP factor model
      // TOTP model is special, its model will not be attached to a controller, but will
      // tag along with the push factor model. We need to listen to the transaction
      // changes on this as well (in case of the push+totp form).

      var totpModel = model.get('backupFactor');

      if (totpModel) {
        this.listenTo(totpModel, 'setTransaction', setTransactionHandler);
        this.listenTo(totpModel, 'setTransactionError', transactionErrorHandler);
      }
    },
    // Override this method to delay switching to this screen until return
    // promise is resolved. This is useful for cases like enrolling a security
    // question, which requires an additional request to fetch the question
    // list.
    fetchInitialData: function fetchInitialData() {
      return Q();
    },
    // Override this method to prevent route navigation. This is useful for
    // intermediate status changes that do not trigger a full refresh of the
    // page, like MFA_ENROLL_ACTIVATE and MFA_CHALLENGE.
    trapAuthResponse: function trapAuthResponse() {
      return false;
    },
    toJSON: function toJSON() {
      var data = Okta.Controller.prototype.toJSON.apply(this, arguments);
      return _.extend(_.pick(this.options, 'appState'), data);
    },
    toggleButtonState: function toggleButtonState(state) {
      var _context;

      var button = (0, _find.default)(_context = this.$el).call(_context, '.button');
      button.toggleClass('link-button-disabled', state).prop('disabled', state);
    },
    postRenderAnimation: function postRenderAnimation() {
      // Event triggered after a page is rendered along with the classname to identify the page
      // TODO: Deprecate this event in the next major version in favor of 'afterRender'
      this.trigger('pageRendered', {
        page: this.className
      });
      this.trigger('afterRender', {
        controller: this.className
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setInterval2 = _interopRequireDefault(__webpack_require__(169));

var _some = _interopRequireDefault(__webpack_require__(295));

var _okta = __webpack_require__(0);

var _default = {
  startPolling: function startPolling() {
    // Poll is present in remediation form
    if (this.options.currentViewState.refresh) {
      this._startRemediationPolling();
    } else {
      // Poll is present in authenticator/ authenticator Enrollment obj.
      // Factor and Authenticator won't co-exists hence it's safe to trigger both.
      this._startAuthenticatorPolling();
    }
  },
  _startAuthenticatorPolling: function _startAuthenticatorPolling() {
    var _context,
        _this = this;

    // Factor and Authenticator won't co-exists hence it's safe to trigger both.
    (0, _some.default)(_context = ['currentAuthenticator', 'currentAuthenticatorEnrollment', 'factor']).call(_context, function (responseKey) {
      if (_this.options.appState.has(responseKey)) {
        var _authenticator$poll;

        var authenticator = _this.options.appState.get(responseKey);

        var authenticatorPollAction = "".concat(responseKey, "-poll");
        var pollInterval = authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$poll = authenticator.poll) === null || _authenticator$poll === void 0 ? void 0 : _authenticator$poll.refresh;

        if (_okta._.isNumber(pollInterval)) {
          _this.polling = (0, _setInterval2.default)(function () {
            _this.options.appState.trigger('invokeAction', authenticatorPollAction);
          }, pollInterval);
        }

        return true;
      } else {
        return false;
      }
    });
  },
  _startRemediationPolling: function _startRemediationPolling() {
    var _this2 = this;

    var pollingInterval = this.options.currentViewState.refresh;

    if (_okta._.isNumber(pollingInterval)) {
      this.polling = (0, _setInterval2.default)(function () {
        _this2.options.appState.trigger('saveForm', _this2.model);
      }, pollingInterval);
    }
  },
  stopPolling: function stopPolling() {
    if (this.polling) {
      clearInterval(this.polling);
    }
  }
};
exports.default = _default;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(76);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(76);
var TAG = __webpack_require__(21)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(13);
var aFunction = __webpack_require__(67);
var SPECIES = __webpack_require__(21)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(20);
var wellKnownSymbol = __webpack_require__(23);
var V8_VERSION = __webpack_require__(222);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(43);
var defineProperties = __webpack_require__(291);
var enumBugKeys = __webpack_require__(226);
var hiddenKeys = __webpack_require__(134);
var html = __webpack_require__(293);
var documentCreateElement = __webpack_require__(218);
var sharedKey = __webpack_require__(167);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(292);
var enumBugKeys = __webpack_require__(226);

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(618);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(648);

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(676).charAt;
var InternalStateModule = __webpack_require__(80);
var defineIterator = __webpack_require__(287);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(60);

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$defineProperty = __webpack_require__(333);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(36), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Q, Enums) {
  var _ = Okta._;
  var KNOWN_ERRORS = ['OAuthError', 'AuthSdkError', 'AuthPollStopError', 'AuthApiError'];
  return Okta.Model.extend({
    // May return either a "standard" promise or a Q promise
    doTransaction: function doTransaction(fn, rethrow) {
      var self = this;
      return fn.call(this, this.appState.get('transaction')).then(function (trans) {
        self.trigger('setTransaction', trans);
        return trans;
      }).catch(function (err) {
        // Q may still consider AuthPollStopError to be unhandled
        if (err.name === 'AuthPollStopError' || err.name === Enums.AUTH_STOP_POLL_INITIATION_ERROR || err.name === Enums.WEBAUTHN_ABORT_ERROR) {
          return;
        }

        self.trigger('error', self, err.xhr);
        self.trigger('setTransactionError', err);

        if (rethrow || (0, _indexOf.default)(_).call(_, KNOWN_ERRORS, err.name) === -1) {
          throw err;
        }
      });
    },
    manageTransaction: function manageTransaction(fn) {
      var self = this,
          res = fn.call(this, this.appState.get('transaction'), (0, _bind.default)(_).call(_, this.setTransaction, this)); // If it's a promise, listen for failures

      if (Q.isPromiseAlike(res)) {
        return res.catch(function (err) {
          if (err.name === 'AuthPollStopError' || err.name === Enums.AUTH_STOP_POLL_INITIATION_ERROR || err.name === Enums.WEBAUTHN_ABORT_ERROR) {
            return;
          }

          self.trigger('error', self, err.xhr);
          self.trigger('setTransactionError', err);
        });
      }

      return Q.resolve(res);
    },
    startTransaction: function startTransaction(fn) {
      var self = this,
          res = fn.call(this, this.settings.getAuthClient()); // If it's a promise, then chain to it

      if (Q.isPromiseAlike(res)) {
        return res.then(function (trans) {
          self.trigger('setTransaction', trans);
          return trans;
        }).catch(function (err) {
          self.trigger('error', self, err.xhr);
          self.trigger('setTransactionError', err);
          throw err;
        });
      }

      return Q.resolve(res);
    },
    setTransaction: function setTransaction(trans) {
      this.appState.set('transaction', trans);
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _reduce = _interopRequireDefault(__webpack_require__(90));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* global Uint8Array */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  var fn = {};
  /**
   * Light weight hashing algorithm that hashes string into an integer between 0 and 4294967295
   * Not recommended for data set of size greater than 10000
   * https://www.npmjs.com/package/string-hash
   *
   * @param str the string to be hashed
   * @returns string hash of integer type
   */

  fn.getStringHash = function (str) {
    var hash = 5381,
        i = str.length;

    while (i) {
      hash = hash * 33 ^ str.charCodeAt(--i);
    }

    return hash >>> 0;
  };
  /**
   * Converts any url safe characters in a base64 string to regular base64 characters
   * @param str base64 string that might contain url safe characters
   * @returns base64 formatted string
   */


  fn.base64UrlSafeToBase64 = function (str) {
    return str.replace(new RegExp('_', 'g'), '/').replace(new RegExp('-', 'g'), '+');
  };
  /**
   * Converts an ArrayBuffer object that contains binary data to base64 encoded string
   * @param bin ArrayBuffer object
   * @returns base64 encoded string
   */


  fn.binToStr = function (bin) {
    var _context;

    return btoa((0, _reduce.default)(_context = new Uint8Array(bin)).call(_context, function (s, byte) {
      return s + String.fromCharCode(byte);
    }, ''));
  };
  /**
   * Converts base64 string to binary data view
   * @param str in base64 or base64UrlSafe format
   * @returns converted Uint8Array view of binary data
   */


  fn.strToBin = function (str) {
    return Uint8Array.from(atob(this.base64UrlSafeToBase64(str)), function (c) {
      return c.charCodeAt(0);
    });
  };

  return fn;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  var fn = {}; // Validate the 'username' field on the model.

  fn.validateUsername = function (model) {
    var username = model.get('username');

    if (username && username.length > 256) {
      return {
        username: Okta.loc('model.validation.field.username', 'login')
      };
    }
  }; // Validate that the field1 and field2 fields on the model are a match.


  fn.validateFieldsMatch = function (model, field1, field2, message) {
    if (model.get(field1) !== model.get(field2)) {
      var ret = {};
      ret[field2] = message;
      return ret;
    }
  }; // Validate that the 'newPassword' and 'confirmPassword' fields on the model are a match.


  fn.validatePasswordMatch = function (model) {
    return fn.validateFieldsMatch(model, 'newPassword', 'confirmPassword', Okta.loc('password.error.match', 'login'));
  };

  return fn;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _map = _interopRequireDefault(__webpack_require__(41));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(125), __webpack_require__(815)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, bundles, countryCallingCodes) {
  var _ = Okta._;
  var fn = {}; // () => [{ countryCode: countryName }], sorted by countryName

  fn.getCountries = function () {
    // HM, BV, and TF do not have phone prefixes, so don't give the
    // user the option to choose these countries. FYI it appears that these
    // countries do not have calling codes because they are ~~uninhabited~~
    var countries = _.omit(bundles.country, 'HM', 'BV', 'TF'); // Sort it; figure out if there is a better way to do this (best would
    // be to sort it in the properties file!!)


    var collection = (0, _map.default)(_).call(_, countries, function (name, code) {
      return {
        name: name,
        code: code
      };
    });
    collection = _.sortBy(collection, 'name');
    var sorted = {};

    _.each(collection, function (country) {
      sorted[country.code] = country.name;
    });

    return sorted;
  };

  fn.getCallingCodeForCountry = function (countryCode) {
    return countryCallingCodes[countryCode];
  };

  return fn;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getSignOutLink = exports.goBackLink = exports.getForgotPasswordLink = exports.getSwitchAuthenticatorLink = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(0);

var _RemediationConstants = __webpack_require__(57);

var ENROLLED_PASSWORD_RECOVERY_LINK = 'currentAuthenticatorEnrollment-recover';
var ORG_PASSWORD_RECOVERY_LINK = 'currentAuthenticator-recover';

var getSwitchAuthenticatorLink = function getSwitchAuthenticatorLink(appState) {
  if (appState.hasRemediationObject('select-factor-authenticate')) {
    return [{
      'type': 'link',
      'label': (0, _okta.loc)('mfa.switch', 'login'),
      'name': 'switchFactor',
      'formName': 'select-factor-authenticate'
    }];
  }

  if (appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE)) {
    return [{
      'type': 'link',
      'label': (0, _okta.loc)('oie.verification.switch.authenticator', 'login'),
      'name': 'switchAuthenticator',
      'formName': _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE
    }];
  }

  if (appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL)) {
    return [{
      'type': 'link',
      'label': (0, _okta.loc)('oie.enroll.switch.authenticator', 'login'),
      'name': 'switchAuthenticator',
      'formName': _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL
    }];
  }

  return [];
};

exports.getSwitchAuthenticatorLink = getSwitchAuthenticatorLink;

var getForgotPasswordLink = function getForgotPasswordLink(appState, settings) {
  var forgotPasswordLink = {
    'type': 'link',
    'label': (0, _okta.loc)('forgotpassword', 'login'),
    'name': 'forgot-password'
  };
  var customForgotPasswordHref = settings.get('helpLinks.forgotPassword');

  if (customForgotPasswordHref) {
    return [(0, _assign.default)({}, {
      'href': customForgotPasswordHref,
      'label': (0, _okta.loc)('forgotpassword', 'login'),
      'name': 'forgot-password'
    })];
  } // at identify page when only Org Authenticator Password may be available
  else if (appState.getActionByPath(ORG_PASSWORD_RECOVERY_LINK)) {
      return [(0, _assign.default)({}, forgotPasswordLink, {
        actionPath: ORG_PASSWORD_RECOVERY_LINK
      })];
    } // at password verify page
    else if (appState.getActionByPath(ENROLLED_PASSWORD_RECOVERY_LINK)) {
        return [(0, _assign.default)({}, forgotPasswordLink, {
          actionPath: ENROLLED_PASSWORD_RECOVERY_LINK
        })];
      }

  return [];
};

exports.getForgotPasswordLink = getForgotPasswordLink;

var goBackLink = function goBackLink(appState) {
  if (appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL)) {
    return [{
      'type': 'link',
      'label': (0, _okta.loc)('oie.go.back', 'login'),
      'name': 'go-back',
      'formName': _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL
    }];
  }

  return [];
};

exports.goBackLink = goBackLink;

var getSignOutLink = function getSignOutLink(settings) {
  if (settings === null || settings === void 0 ? void 0 : settings.get('signOutLink')) {
    return [{
      'label': (0, _okta.loc)('signout', 'login'),
      'name': 'cancel',
      'href': settings.get('signOutLink')
    }];
  } else {
    return [{
      'actionPath': 'cancel',
      'label': (0, _okta.loc)('signout', 'login'),
      'name': 'cancel',
      'type': 'link'
    }];
  }
};

exports.getSignOutLink = getSignOutLink;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.WARNING_TIMEOUT = exports.SHOW_RESEND_TIMEOUT = void 0;
var SHOW_RESEND_TIMEOUT = 30000;
exports.SHOW_RESEND_TIMEOUT = SHOW_RESEND_TIMEOUT;
var WARNING_TIMEOUT = 30000;
exports.WARNING_TIMEOUT = WARNING_TIMEOUT;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(30);
var global = __webpack_require__(11);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(96) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(55);
var toLength = __webpack_require__(25);
var toAbsoluteIndex = __webpack_require__(98);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(76);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(21)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(13);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(130);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(264);
var redefine = __webpack_require__(49);
var hide = __webpack_require__(54);
var fails = __webpack_require__(12);
var defined = __webpack_require__(77);
var wks = __webpack_require__(21);
var regexpExec = __webpack_require__(208);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(66);
var call = __webpack_require__(259);
var isArrayIter = __webpack_require__(203);
var anObject = __webpack_require__(13);
var toLength = __webpack_require__(25);
var getIterFn = __webpack_require__(205);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(49);
var redefineAll = __webpack_require__(119);
var meta = __webpack_require__(87);
var forOf = __webpack_require__(156);
var anInstance = __webpack_require__(118);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(12);
var $iterDetect = __webpack_require__(152);
var setToStringTag = __webpack_require__(114);
var inheritIfRequired = __webpack_require__(194);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var hide = __webpack_require__(54);
var uid = __webpack_require__(95);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(20);
var classof = __webpack_require__(106);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(120);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);
var isArray = __webpack_require__(110);
var wellKnownSymbol = __webpack_require__(23);

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(570);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(220);
var uid = __webpack_require__(165);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(46);
var toObject = __webpack_require__(52);
var sharedKey = __webpack_require__(167);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(290);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(642);

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(653);

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(661);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(23);

exports.f = wellKnownSymbol;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v1.12.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2017-10-25T15:48Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var deletedIds = [];

var document = window.document;

var slice = deletedIds.slice;

var concat = deletedIds.concat;

var push = deletedIds.push;

var indexOf = deletedIds.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "1.12.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1, IE<9
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: deletedIds.sort,
	splice: deletedIds.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var src, copyIsArray, copy, name, options, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				// Prevent Object.prototype pollution to avoid CVE-2019-11358 vulnerability
				// https://oktainc.atlassian.net/browse/OKTA-277796
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	// See test/unit/core.js for details concerning isFunction.
	// Since version 1.3, DOM methods and functions like alert
	// aren't supported. They return false on IE (#2968).
	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray || function( obj ) {
		return jQuery.type( obj ) === "array";
	},

	isWindow: function( obj ) {
		/* jshint eqeqeq: false */
		return obj != null && obj == obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	isPlainObject: function( obj ) {
		var key;

		// Must be an Object.
		// Because of IE, we also have to check the presence of the constructor property.
		// Make sure that DOM nodes and window objects don't pass through, as well
		if ( !obj || jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		try {

			// Not own constructor property must be Object
			if ( obj.constructor &&
				!hasOwn.call( obj, "constructor" ) &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
				return false;
			}
		} catch ( e ) {

			// IE8,9 Will throw exceptions on certain host objects #9897
			return false;
		}

		// Support: IE<9
		// Handle iteration over inherited properties before own properties.
		if ( !support.ownFirst ) {
			for ( key in obj ) {
				return hasOwn.call( obj, key );
			}
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Workarounds based on findings by Jim Driscoll
	// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
	globalEval: function( data ) {
		if ( data && jQuery.trim( data ) ) {

			// We use execScript on Internet Explorer
			// We use an anonymous function so that context is window
			// rather than jQuery in Firefox
			( window.execScript || function( data ) {
				window[ "eval" ].call( window, data ); // jscs:ignore requireDotNotation
			} )( data );
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1, IE<9
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		var len;

		if ( arr ) {
			if ( indexOf ) {
				return indexOf.call( arr, elem, i );
			}

			len = arr.length;
			i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;

			for ( ; i < len; i++ ) {

				// Skip accessing in sparse arrays
				if ( i in arr && arr[ i ] === elem ) {
					return i;
				}
			}
		}

		return -1;
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		while ( j < len ) {
			first[ i++ ] = second[ j++ ];
		}

		// Support: IE<9
		// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
		if ( len !== len ) {
			while ( second[ j ] !== undefined ) {
				first[ i++ ] = second[ j++ ];
			}
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var args, proxy, tmp;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: function() {
		return +( new Date() );
	},

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = deletedIds[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( jQuery.inArray( elem, qualifier ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			ret = [],
			self = this,
			len = self.length;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// init accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector.charAt( 0 ) === "<" &&
				selector.charAt( selector.length - 1 ) === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					if ( elem && elem.parentNode ) {

						// Handle the case where IE and Opera return items
						// by name instead of ID
						if ( elem.id !== match[ 2 ] ) {
							return rootjQuery.find( selector );
						}

						// Otherwise, we inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof root.ready !== "undefined" ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var i,
			targets = jQuery( target, this ),
			len = targets.length;

		return this.filter( function() {
			for ( i = 0; i < len; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within
	// the matched set of elements
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// index in selector
		if ( typeof elem === "string" ) {
			return jQuery.inArray( this[ 0 ], jQuery( elem ) );
		}

		// Locate the position of the desired element
		return jQuery.inArray(

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem, this );
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	do {
		cur = cur[ dir ];
	} while ( cur && cur.nodeType !== 1 );

	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return jQuery.nodeName( elem, "iframe" ) ?
			elem.contentDocument || elem.contentWindow.document :
			jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var ret = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			ret = jQuery.filter( selector, ret );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				ret = jQuery.uniqueSort( ret );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				ret = ret.reverse();
			}
		}

		return this.pushStack( ret );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = true;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );

					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// if we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * Clean-up method for dom ready events
 */
function detach() {
	if ( document.addEventListener ) {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );

	} else {
		document.detachEvent( "onreadystatechange", completed );
		window.detachEvent( "onload", completed );
	}
}

/**
 * The ready event handler and self cleanup method
 */
function completed() {

	// readyState === "complete" is good enough for us to call the dom ready in oldIE
	if ( document.addEventListener ||
		window.event.type === "load" ||
		document.readyState === "complete" ) {

		detach();
		jQuery.ready();
	}
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE6-10
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		// Standards-based browsers support DOMContentLoaded
		} else if ( document.addEventListener ) {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );

		// If IE event model is used
		} else {

			// Ensure firing before onload, maybe late but safe also for iframes
			document.attachEvent( "onreadystatechange", completed );

			// A fallback to window.onload, that will always work
			window.attachEvent( "onload", completed );

			// If IE and not a frame
			// continually check to see if the document is ready
			var top = false;

			try {
				top = window.frameElement == null && document.documentElement;
			} catch ( e ) {}

			if ( top && top.doScroll ) {
				( function doScrollCheck() {
					if ( !jQuery.isReady ) {

						try {

							// Use the trick by Diego Perini
							// http://javascript.nwbox.com/IEContentLoaded/
							top.doScroll( "left" );
						} catch ( e ) {
							return window.setTimeout( doScrollCheck, 50 );
						}

						// detach all dom ready events
						detach();

						// and execute any waiting functions
						jQuery.ready();
					}
				} )();
			}
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Support: IE<9
// Iteration over object's inherited properties before its own
var i;
for ( i in jQuery( support ) ) {
	break;
}
support.ownFirst = i === "0";

// Note: most support tests are defined in their respective modules.
// false until the test is run
support.inlineBlockNeedsLayout = false;

// Execute ASAP in case we need to set body.style.zoom
jQuery( function() {

	// Minified: var a,b,c,d
	var val, div, body, container;

	body = document.getElementsByTagName( "body" )[ 0 ];
	if ( !body || !body.style ) {

		// Return for frameset docs that don't have a body
		return;
	}

	// Setup
	div = document.createElement( "div" );
	container = document.createElement( "div" );
	container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
	body.appendChild( container ).appendChild( div );

	if ( typeof div.style.zoom !== "undefined" ) {

		// Support: IE<8
		// Check if natively block-level elements act like inline-block
		// elements when setting their display to 'inline' and giving
		// them layout
		div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";

		support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
		if ( val ) {

			// Prevent IE 6 from affecting layout for positioned elements #11048
			// Prevent IE from shrinking the body in IE 7 mode #12869
			// Support: IE<8
			body.style.zoom = 1;
		}
	}

	body.removeChild( container );
} );


( function() {
	var div = document.createElement( "div" );

	// Support: IE<9
	support.deleteExpando = true;
	try {
		delete div.test;
	} catch ( e ) {
		support.deleteExpando = false;
	}

	// Null elements to avoid leaks in IE.
	div = null;
} )();
var acceptData = function( elem ) {
	var noData = jQuery.noData[ ( elem.nodeName + " " ).toLowerCase() ],
		nodeType = +elem.nodeType || 1;

	// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
	return nodeType !== 1 && nodeType !== 9 ?
		false :

		// Nodes accept data unless otherwise specified; rejection can be conditional
		!noData || noData !== true && elem.getAttribute( "classid" ) === noData;
};




var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {

		var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();

		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			jQuery.data( elem, key, data );

		} else {
			data = undefined;
		}
	}

	return data;
}

// checks a cache object for emptiness
function isEmptyDataObject( obj ) {
	var name;
	for ( name in obj ) {

		// if the public data object is empty, the private is still empty
		if ( name === "data" && jQuery.isEmptyObject( obj[ name ] ) ) {
			continue;
		}
		if ( name !== "toJSON" ) {
			return false;
		}
	}

	return true;
}

function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
	if ( !acceptData( elem ) ) {
		return;
	}

	var ret, thisCache,
		internalKey = jQuery.expando,

		// We have to handle DOM nodes and JS objects differently because IE6-7
		// can't GC object references properly across the DOM-JS boundary
		isNode = elem.nodeType,

		// Only DOM nodes need the global jQuery cache; JS object data is
		// attached directly to the object so GC can occur automatically
		cache = isNode ? jQuery.cache : elem,

		// Only defining an ID for JS objects if its cache already exists allows
		// the code to shortcut on the same path as a DOM node with no cache
		id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;

	// Avoid doing any more work than we need to when trying to get data on an
	// object that has no data at all
	if ( ( !id || !cache[ id ] || ( !pvt && !cache[ id ].data ) ) &&
		data === undefined && typeof name === "string" ) {
		return;
	}

	if ( !id ) {

		// Only DOM nodes need a new unique ID for each element since their data
		// ends up in the global cache
		if ( isNode ) {
			id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
		} else {
			id = internalKey;
		}
	}

	if ( !cache[ id ] ) {

		// Avoid exposing jQuery metadata on plain JS objects when the object
		// is serialized using JSON.stringify
		cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
	}

	// An object can be passed to jQuery.data instead of a key/value pair; this gets
	// shallow copied over onto the existing cache
	if ( typeof name === "object" || typeof name === "function" ) {
		if ( pvt ) {
			cache[ id ] = jQuery.extend( cache[ id ], name );
		} else {
			cache[ id ].data = jQuery.extend( cache[ id ].data, name );
		}
	}

	thisCache = cache[ id ];

	// jQuery data() is stored in a separate object inside the object's internal data
	// cache in order to avoid key collisions between internal data and user-defined
	// data.
	if ( !pvt ) {
		if ( !thisCache.data ) {
			thisCache.data = {};
		}

		thisCache = thisCache.data;
	}

	if ( data !== undefined ) {
		thisCache[ jQuery.camelCase( name ) ] = data;
	}

	// Check for both converted-to-camel and non-converted data property names
	// If a data property was specified
	if ( typeof name === "string" ) {

		// First Try to find as-is property data
		ret = thisCache[ name ];

		// Test for null|undefined property data
		if ( ret == null ) {

			// Try to find the camelCased property
			ret = thisCache[ jQuery.camelCase( name ) ];
		}
	} else {
		ret = thisCache;
	}

	return ret;
}

function internalRemoveData( elem, name, pvt ) {
	if ( !acceptData( elem ) ) {
		return;
	}

	var thisCache, i,
		isNode = elem.nodeType,

		// See jQuery.data for more information
		cache = isNode ? jQuery.cache : elem,
		id = isNode ? elem[ jQuery.expando ] : jQuery.expando;

	// If there is already no cache entry for this object, there is no
	// purpose in continuing
	if ( !cache[ id ] ) {
		return;
	}

	if ( name ) {

		thisCache = pvt ? cache[ id ] : cache[ id ].data;

		if ( thisCache ) {

			// Support array or space separated string names for data keys
			if ( !jQuery.isArray( name ) ) {

				// try the string as a key before any manipulation
				if ( name in thisCache ) {
					name = [ name ];
				} else {

					// split the camel cased version by spaces unless a key with the spaces exists
					name = jQuery.camelCase( name );
					if ( name in thisCache ) {
						name = [ name ];
					} else {
						name = name.split( " " );
					}
				}
			} else {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = name.concat( jQuery.map( name, jQuery.camelCase ) );
			}

			i = name.length;
			while ( i-- ) {
				delete thisCache[ name[ i ] ];
			}

			// If there is no data left in the cache, we want to continue
			// and let the cache object itself get destroyed
			if ( pvt ? !isEmptyDataObject( thisCache ) : !jQuery.isEmptyObject( thisCache ) ) {
				return;
			}
		}
	}

	// See jQuery.data for more information
	if ( !pvt ) {
		delete cache[ id ].data;

		// Don't destroy the parent cache unless the internal data object
		// had been the only thing left in it
		if ( !isEmptyDataObject( cache[ id ] ) ) {
			return;
		}
	}

	// Destroy the cache
	if ( isNode ) {
		jQuery.cleanData( [ elem ], true );

	// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
	/* jshint eqeqeq: false */
	} else if ( support.deleteExpando || cache != cache.window ) {
		/* jshint eqeqeq: true */
		delete cache[ id ];

	// When all else fails, undefined
	} else {
		cache[ id ] = undefined;
	}
}

jQuery.extend( {
	cache: {},

	// The following elements (space-suffixed to avoid Object.prototype collisions)
	// throw uncatchable exceptions if you attempt to set expando properties
	noData: {
		"applet ": true,
		"embed ": true,

		// ...but Flash objects (which have this classid) *can* handle expandos
		"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
	},

	hasData: function( elem ) {
		elem = elem.nodeType ? jQuery.cache[ elem[ jQuery.expando ] ] : elem[ jQuery.expando ];
		return !!elem && !isEmptyDataObject( elem );
	},

	data: function( elem, name, data ) {
		return internalData( elem, name, data );
	},

	removeData: function( elem, name ) {
		return internalRemoveData( elem, name );
	},

	// For internal use only.
	_data: function( elem, name, data ) {
		return internalData( elem, name, data, true );
	},

	_removeData: function( elem, name ) {
		return internalRemoveData( elem, name, true );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Special expections of .data basically thwart jQuery.access,
		// so implement the relevant behavior ourselves

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = jQuery.data( elem );

				if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					jQuery._data( elem, "parsedAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				jQuery.data( this, key );
			} );
		}

		return arguments.length > 1 ?

			// Sets one value
			this.each( function() {
				jQuery.data( this, key, value );
			} ) :

			// Gets one value
			// Try to fetch any internally stored data first
			elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
	},

	removeData: function( key ) {
		return this.each( function() {
			jQuery.removeData( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = jQuery._data( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = jQuery._data( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// not intended for public consumption - generates a queueHooks object,
	// or returns the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return jQuery._data( elem, key ) || jQuery._data( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				jQuery._removeData( elem, type + "queue" );
				jQuery._removeData( elem, key );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = jQuery._data( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );


( function() {
	var shrinkWrapBlocksVal;

	support.shrinkWrapBlocks = function() {
		if ( shrinkWrapBlocksVal != null ) {
			return shrinkWrapBlocksVal;
		}

		// Will be changed later if needed.
		shrinkWrapBlocksVal = false;

		// Minified: var b,c,d
		var div, body, container;

		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {

			// Test fired too early or in an unsupported environment, exit.
			return;
		}

		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );

		// Support: IE6
		// Check if elements with layout shrink-wrap their children
		if ( typeof div.style.zoom !== "undefined" ) {

			// Reset CSS: box-sizing; display; margin; border
			div.style.cssText =

				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;" +
				"padding:1px;width:1px;zoom:1";
			div.appendChild( document.createElement( "div" ) ).style.width = "5px";
			shrinkWrapBlocksVal = div.offsetWidth !== 3;
		}

		body.removeChild( container );

		return shrinkWrapBlocksVal;
	};

} )();
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		length = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < length; i++ ) {
				fn(
					elems[ i ],
					key,
					raw ? value : value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			length ? fn( elems[ 0 ], key ) : emptyGet;
};
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );

var rleadingWhitespace = ( /^\s+/ );

var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|" +
		"details|dialog|figcaption|figure|footer|header|hgroup|main|" +
		"mark|meter|nav|output|picture|progress|section|summary|template|time|video";



function createSafeFragment( document ) {
	var list = nodeNames.split( "|" ),
		safeFrag = document.createDocumentFragment();

	if ( safeFrag.createElement ) {
		while ( list.length ) {
			safeFrag.createElement(
				list.pop()
			);
		}
	}
	return safeFrag;
}


( function() {
	var div = document.createElement( "div" ),
		fragment = document.createDocumentFragment(),
		input = document.createElement( "input" );

	// Setup
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";

	// IE strips leading whitespace when .innerHTML is used
	support.leadingWhitespace = div.firstChild.nodeType === 3;

	// Make sure that tbody elements aren't automatically inserted
	// IE will insert them into empty tables
	support.tbody = !div.getElementsByTagName( "tbody" ).length;

	// Make sure that link elements get serialized correctly by innerHTML
	// This requires a wrapper element in IE
	support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;

	// Makes sure cloning an html5 element does not cause problems
	// Where outerHTML is undefined, this still works
	support.html5Clone =
		document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";

	// Check if a disconnected checkbox will retain its checked
	// value of true after appended to the DOM (IE6/7)
	input.type = "checkbox";
	input.checked = true;
	fragment.appendChild( input );
	support.appendChecked = input.checked;

	// Make sure textarea (and checkbox) defaultValue is properly cloned
	// Support: IE6-IE11+
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// #11217 - WebKit loses check when the name is after the checked attribute
	fragment.appendChild( div );

	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input = document.createElement( "input" );
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
	// old WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<9
	// Cloned elements keep attachEvent handlers, we use addEventListener on IE9+
	support.noCloneEvent = !!div.addEventListener;

	// Support: IE<9
	// Since attributes and properties are the same in IE,
	// cleanData must set properties to undefined rather than use removeAttribute
	div[ jQuery.expando ] = 1;
	support.attributes = !div.getAttribute( jQuery.expando );
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {
	option: [ 1, "<select multiple='multiple'>", "</select>" ],
	legend: [ 1, "<fieldset>", "</fieldset>" ],
	area: [ 1, "<map>", "</map>" ],

	// Support: IE8
	param: [ 1, "<object>", "</object>" ],
	thead: [ 1, "<table>", "</table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
	// unless wrapped in a div with non-breaking characters in front of it.
	_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>" ]
};

// Support: IE8-IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {
	var elems, elem,
		i = 0,
		found = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
				undefined;

	if ( !found ) {
		for ( found = [], elems = context.childNodes || context;
			( elem = elems[ i ] ) != null;
			i++
		) {
			if ( !tag || jQuery.nodeName( elem, tag ) ) {
				found.push( elem );
			} else {
				jQuery.merge( found, getAll( elem, tag ) );
			}
		}
	}

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], found ) :
		found;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var elem,
		i = 0;
	for ( ; ( elem = elems[ i ] ) != null; i++ ) {
		jQuery._data(
			elem,
			"globalEval",
			!refElements || jQuery._data( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/,
	rtbody = /<tbody/i;

function fixDefaultChecked( elem ) {
	if ( rcheckableType.test( elem.type ) ) {
		elem.defaultChecked = elem.checked;
	}
}

function buildFragment( elems, context, scripts, selection, ignored ) {
	var j, elem, contains,
		tmp, tag, tbody, wrap,
		l = elems.length,

		// Ensure a safe fragment
		safe = createSafeFragment( context ),

		nodes = [],
		i = 0;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || safe.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;

				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Manually add leading whitespace removed by IE
				if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
					nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[ 0 ] ) );
				}

				// Remove IE's autoinserted <tbody> from table fragments
				if ( !support.tbody ) {

					// String was a <table>, *may* have spurious <tbody>
					elem = tag === "table" && !rtbody.test( elem ) ?
						tmp.firstChild :

						// String was a bare <thead> or <tfoot>
						wrap[ 1 ] === "<table>" && !rtbody.test( elem ) ?
							tmp :
							0;

					j = elem && elem.childNodes.length;
					while ( j-- ) {
						if ( jQuery.nodeName( ( tbody = elem.childNodes[ j ] ), "tbody" ) &&
							!tbody.childNodes.length ) {

							elem.removeChild( tbody );
						}
					}
				}

				jQuery.merge( nodes, tmp.childNodes );

				// Fix #12392 for WebKit and IE > 9
				tmp.textContent = "";

				// Fix #12392 for oldIE
				while ( tmp.firstChild ) {
					tmp.removeChild( tmp.firstChild );
				}

				// Remember the top-level container for proper cleanup
				tmp = safe.lastChild;
			}
		}
	}

	// Fix #11356: Clear elements from fragment
	if ( tmp ) {
		safe.removeChild( tmp );
	}

	// Reset defaultChecked for any radios and checkboxes
	// about to be appended to the DOM in IE 6/7 (#8060)
	if ( !support.appendChecked ) {
		jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
	}

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}

			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( safe.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	tmp = null;

	return safe;
}


( function() {
	var i, eventName,
		div = document.createElement( "div" );

	// Support: IE<9 (lack submit/change bubble), Firefox (lack focus(in | out) events)
	for ( i in { submit: true, change: true, focusin: true } ) {
		eventName = "on" + i;

		if ( !( support[ i ] = eventName in window ) ) {

			// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
			div.setAttribute( eventName, "t" );
			support[ i ] = div.attributes[ eventName ].expando === false;
		}
	}

	// Null elements to avoid leaks in IE.
	div = null;
} )();


var rformElems = /^(?:input|select|textarea)$/i,
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {
		var tmp, events, t, handleObjIn,
			special, eventHandle, handleObj,
			handlers, type, namespaces, origType,
			elemData = jQuery._data( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" &&
					( !e || jQuery.event.triggered !== e.type ) ?
					jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
					undefined;
			};

			// Add elem as a property of the handle fn to prevent a memory leak
			// with IE non-native events
			eventHandle.elem = elem;
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener/attachEvent if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					// Bind the global event handler to the element
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );

					} else if ( elem.attachEvent ) {
						elem.attachEvent( "on" + type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

		// Nullify elem to prevent memory leaks in IE
		elem = null;
	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {
		var j, handleObj, tmp,
			origCount, t, events,
			special, handlers, type,
			namespaces, origType,
			elemData = jQuery.hasData( elem ) && jQuery._data( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;

			// removeData also checks for emptiness and clears the expando if empty
			// so use it instead of delete
			jQuery._removeData( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {
		var handle, ontype, cur,
			bubbleType, special, tmp, i,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] &&
				jQuery._data( cur, "handle" );

			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if (
				( !special._default ||
				 special._default.apply( eventPath.pop(), data ) === false
				) && acceptData( elem )
			) {

				// Call a native DOM method on the target with the same name name as the event.
				// Can't use an .isFunction() check here because IE6/7 fails that test.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					try {
						elem[ type ]();
					} catch ( e ) {

						// IE<9 dies on focus/blur to hidden element (#1486,#12518)
						// only reproducible on winXP IE8 native, not IE9 in IE8 mode
					}
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			/* jshint eqeqeq: false */
			for ( ; cur != this; cur = cur.parentNode || this ) {
				/* jshint eqeqeq: true */

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: IE<9
		// Fix target property (#1925)
		if ( !event.target ) {
			event.target = originalEvent.srcElement || document;
		}

		// Support: Safari 6-8+
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		// Support: IE<9
		// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
		event.metaKey = !!event.metaKey;

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY fromElement offsetX offsetY " +
			"pageX pageY screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var body, eventDoc, doc,
				button = original.button,
				fromElement = original.fromElement;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add relatedTarget, if necessary
			if ( !event.relatedTarget && fromElement ) {
				event.relatedTarget = fromElement === event.target ?
					original.toElement :
					fromElement;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					try {
						this.focus();
						return false;
					} catch ( e ) {

						// Support: IE<9
						// If we error on focus to hidden element (#1486, #12518),
						// let .trigger() run the handlers
					}
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	// Piggyback on a donor event to simulate a different one
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true

				// Previously, `originalEvent: {}` was set here, so stopPropagation call
				// would not be triggered on donor event, since in our own
				// jQuery.event.stopPropagation function we had a check for existence of
				// originalEvent.stopPropagation method, so, consequently it would be a noop.
				//
				// Guard for simulated events was moved to jQuery.event.stopPropagation function
				// since `originalEvent` should point to the original event for the
				// constancy with other events and for more focused logic
			}
		);

		jQuery.event.trigger( e, null, elem );

		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = document.removeEventListener ?
	function( elem, type, handle ) {

		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	} :
	function( elem, type, handle ) {
		var name = "on" + type;

		if ( elem.detachEvent ) {

			// #8545, #7054, preventing memory leaks for custom events in IE6-8
			// detachEvent needed property on element, by name of that event,
			// to properly expose it to GC
			if ( typeof elem[ name ] === "undefined" ) {
				elem[ name ] = null;
			}

			elem.detachEvent( name, handle );
		}
	};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: IE < 9, Android < 4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;
		if ( !e ) {
			return;
		}

		// If preventDefault exists, run it on the original event
		if ( e.preventDefault ) {
			e.preventDefault();

		// Support: IE
		// Otherwise set the returnValue property of the original event to false
		} else {
			e.returnValue = false;
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( !e || this.isSimulated ) {
			return;
		}

		// If stopPropagation exists, run it on the original event
		if ( e.stopPropagation ) {
			e.stopPropagation();
		}

		// Support: IE
		// Set the cancelBubble property of the original event to true
		e.cancelBubble = true;
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

// IE submit delegation
if ( !support.submit ) {

	jQuery.event.special.submit = {
		setup: function() {

			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Lazy-add a submit handler when a descendant form may potentially be submitted
			jQuery.event.add( this, "click._submit keypress._submit", function( e ) {

				// Node name check avoids a VML-related crash in IE (#9807)
				var elem = e.target,
					form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ?

						// Support: IE <=8
						// We use jQuery.prop instead of elem.form
						// to allow fixing the IE8 delegated submit issue (gh-2332)
						// by 3rd party polyfills/workarounds.
						jQuery.prop( elem, "form" ) :
						undefined;

				if ( form && !jQuery._data( form, "submit" ) ) {
					jQuery.event.add( form, "submit._submit", function( event ) {
						event._submitBubble = true;
					} );
					jQuery._data( form, "submit", true );
				}
			} );

			// return undefined since we don't need an event listener
		},

		postDispatch: function( event ) {

			// If form was submitted by the user, bubble the event up the tree
			if ( event._submitBubble ) {
				delete event._submitBubble;
				if ( this.parentNode && !event.isTrigger ) {
					jQuery.event.simulate( "submit", this.parentNode, event );
				}
			}
		},

		teardown: function() {

			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
			jQuery.event.remove( this, "._submit" );
		}
	};
}

// IE change delegation and checkbox/radio fix
if ( !support.change ) {

	jQuery.event.special.change = {

		setup: function() {

			if ( rformElems.test( this.nodeName ) ) {

				// IE doesn't fire change on a check/radio until blur; trigger it on click
				// after a propertychange. Eat the blur-change in special.change.handle.
				// This still fires onchange a second time for check/radio after blur.
				if ( this.type === "checkbox" || this.type === "radio" ) {
					jQuery.event.add( this, "propertychange._change", function( event ) {
						if ( event.originalEvent.propertyName === "checked" ) {
							this._justChanged = true;
						}
					} );
					jQuery.event.add( this, "click._change", function( event ) {
						if ( this._justChanged && !event.isTrigger ) {
							this._justChanged = false;
						}

						// Allow triggered, simulated change events (#11500)
						jQuery.event.simulate( "change", this, event );
					} );
				}
				return false;
			}

			// Delegated event; lazy-add a change handler on descendant inputs
			jQuery.event.add( this, "beforeactivate._change", function( e ) {
				var elem = e.target;

				if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "change" ) ) {
					jQuery.event.add( elem, "change._change", function( event ) {
						if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
							jQuery.event.simulate( "change", this.parentNode, event );
						}
					} );
					jQuery._data( elem, "change", true );
				}
			} );
		},

		handle: function( event ) {
			var elem = event.target;

			// Swallow native change events from checkbox/radio, we already triggered them above
			if ( this !== elem || event.isSimulated || event.isTrigger ||
				( elem.type !== "radio" && elem.type !== "checkbox" ) ) {

				return event.handleObj.handler.apply( this, arguments );
			}
		},

		teardown: function() {
			jQuery.event.remove( this, "._change" );

			return !rformElems.test( this.nodeName );
		}
	};
}

// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					jQuery._removeData( doc, fix );
				} else {
					jQuery._data( doc, fix, attaches );
				}
			}
		};
	} );
}

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	},

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
	rnoshimcache = new RegExp( "<(?:" + nodeNames + ")[\\s/>]", "i" ),
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	safeFragment = createSafeFragment( document ),
	fragmentDiv = safeFragment.appendChild( document.createElement( "div" ) );

// Support: IE<8
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName( "tbody" )[ 0 ] ||
			elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( jQuery.find.attr( elem, "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );
	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}
	return elem;
}

function cloneCopyEvent( src, dest ) {
	if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
		return;
	}

	var type, i, l,
		oldData = jQuery._data( src ),
		curData = jQuery._data( dest, oldData ),
		events = oldData.events;

	if ( events ) {
		delete curData.handle;
		curData.events = {};

		for ( type in events ) {
			for ( i = 0, l = events[ type ].length; i < l; i++ ) {
				jQuery.event.add( dest, type, events[ type ][ i ] );
			}
		}
	}

	// make the cloned public data object a copy from the original
	if ( curData.data ) {
		curData.data = jQuery.extend( {}, curData.data );
	}
}

function fixCloneNodeIssues( src, dest ) {
	var nodeName, e, data;

	// We do not need to do anything for non-Elements
	if ( dest.nodeType !== 1 ) {
		return;
	}

	nodeName = dest.nodeName.toLowerCase();

	// IE6-8 copies events bound via attachEvent when using cloneNode.
	if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
		data = jQuery._data( dest );

		for ( e in data.events ) {
			jQuery.removeEvent( dest, e, data.handle );
		}

		// Event data gets referenced instead of copied if the expando gets copied too
		dest.removeAttribute( jQuery.expando );
	}

	// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
	if ( nodeName === "script" && dest.text !== src.text ) {
		disableScript( dest ).text = src.text;
		restoreScript( dest );

	// IE6-10 improperly clones children of object elements using classid.
	// IE10 throws NoModificationAllowedError if parent is null, #12132.
	} else if ( nodeName === "object" ) {
		if ( dest.parentNode ) {
			dest.outerHTML = src.outerHTML;
		}

		// This path appears unavoidable for IE9. When cloning an object
		// element in IE9, the outerHTML strategy above is not sufficient.
		// If the src has innerHTML and the destination does not,
		// copy the src.innerHTML into the dest.innerHTML. #10324
		if ( support.html5Clone && ( src.innerHTML && !jQuery.trim( dest.innerHTML ) ) ) {
			dest.innerHTML = src.innerHTML;
		}

	} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {

		// IE6-8 fails to persist the checked state of a cloned checkbox
		// or radio button. Worse, IE6-7 fail to give the cloned element
		// a checked appearance if the defaultChecked value isn't also set

		dest.defaultChecked = dest.checked = src.checked;

		// IE6-7 get confused and end up setting the value of a cloned
		// checkbox/radio button to an empty string instead of "on"
		if ( dest.value !== src.value ) {
			dest.value = src.value;
		}

	// IE6-8 fails to return the selected option to the default selected
	// state when cloning options
	} else if ( nodeName === "option" ) {
		dest.defaultSelected = dest.selected = src.defaultSelected;

	// IE6-8 fails to set the defaultValue to the correct value when
	// cloning other types of input fields
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var first, node, hasScripts,
		scripts, doc, fragment,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!jQuery._data( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval(
								( node.text || node.textContent || node.innerHTML || "" )
									.replace( rcleanScript, "" )
							);
						}
					}
				}
			}

			// Fix #11809: Avoid leaking memory
			fragment = first = null;
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		elems = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = elems[ i ] ) != null; i++ ) {

		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function (html) {
		try {
			if (window.top && window.top.__OKTA_JQUERY_LEGACY_HTML_PREFILTER__) {
				return html.replace(rxhtmlTag, "<$1></$2>");
			}
		} catch (e) {
			return html.replace(rxhtmlTag, "<$1></$2>");
		}
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var destElements, node, clone, i, srcElements,
			inPage = jQuery.contains( elem.ownerDocument, elem );

		if ( support.html5Clone || jQuery.isXMLDoc( elem ) ||
			!rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {

			clone = elem.cloneNode( true );

		// IE<=8 does not properly clone detached, unknown element nodes
		} else {
			fragmentDiv.innerHTML = elem.outerHTML;
			fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
		}

		if ( ( !support.noCloneEvent || !support.noCloneChecked ) &&
				( elem.nodeType === 1 || elem.nodeType === 11 ) && !jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			// Fix all IE cloning issues
			for ( i = 0; ( node = srcElements[ i ] ) != null; ++i ) {

				// Ensure that the destination node is not null; Fixes #9587
				if ( destElements[ i ] ) {
					fixCloneNodeIssues( node, destElements[ i ] );
				}
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0; ( node = srcElements[ i ] ) != null; i++ ) {
					cloneCopyEvent( node, destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		destElements = srcElements = node = null;

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems, /* internal */ forceAcceptData ) {
		var elem, type, id, data,
			i = 0,
			internalKey = jQuery.expando,
			cache = jQuery.cache,
			attributes = support.attributes,
			special = jQuery.event.special;

		for ( ; ( elem = elems[ i ] ) != null; i++ ) {
			if ( forceAcceptData || acceptData( elem ) ) {

				id = elem[ internalKey ];
				data = id && cache[ id ];

				if ( data ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Remove cache only if it was not already removed by jQuery.event.remove
					if ( cache[ id ] ) {

						delete cache[ id ];

						// Support: IE<9
						// IE does not allow us to delete expando properties from nodes
						// IE creates expando attributes along with the property
						// IE does not have a removeAttribute function on Document nodes
						if ( !attributes && typeof elem.removeAttribute !== "undefined" ) {
							elem.removeAttribute( internalKey );

						// Webkit & Blink performance suffers when deleting properties
						// from DOM nodes, so set to undefined instead
						// https://code.google.com/p/chromium/issues/detail?id=378607
						} else {
							elem[ internalKey ] = undefined;
						}

						deletedIds.push( id );
					}
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().append(
					( this[ 0 ] && this[ 0 ].ownerDocument || document ).createTextNode( value )
				);
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {

			// Remove element nodes and prevent memory leaks
			if ( elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem, false ) );
			}

			// Remove any remaining nodes
			while ( elem.firstChild ) {
				elem.removeChild( elem.firstChild );
			}

			// If this is a select, ensure that it displays empty (#12336)
			// Support: IE<9
			if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
				elem.options.length = 0;
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined ) {
				return elem.nodeType === 1 ?
					elem.innerHTML.replace( rinlinejQuery, "" ) :
					undefined;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
				( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {

						// Remove element nodes and prevent memory leaks
						elem = this[ i ] || {};
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			i = 0,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'></iframe>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, pixelMarginRightVal, boxSizingReliableVal,
		reliableHiddenOffsetsVal, reliableMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	div.style.cssText = "float:left;opacity:.5";

	// Support: IE<9
	// Make sure that element opacity exists (as opposed to filter)
	support.opacity = div.style.opacity === "0.5";

	// Verify style float existence
	// (IE uses styleFloat instead of cssFloat)
	support.cssFloat = !!div.style.cssFloat;

	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container = document.createElement( "div" );
	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	div.innerHTML = "";
	container.appendChild( div );

	// Support: Firefox<29, Android 2.3
	// Vendor-prefix box-sizing
	support.boxSizing = div.style.boxSizing === "" || div.style.MozBoxSizing === "" ||
		div.style.WebkitBoxSizing === "";

	jQuery.extend( support, {
		reliableHiddenOffsets: function() {
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableHiddenOffsetsVal;
		},

		boxSizingReliable: function() {

			// We're checking for pixelPositionVal here instead of boxSizingReliableVal
			// since that compresses better and they're computed together anyway.
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},

		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},

		pixelPosition: function() {
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return pixelPositionVal;
		},

		reliableMarginRight: function() {

			// Support: Android 2.3
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableMarginRightVal;
		},

		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		}
	} );

	function computeStyleTests() {
		var contents, divStyle,
			documentElement = document.documentElement;

		// Setup
		documentElement.appendChild( container );

		div.style.cssText =

			// Support: Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";

		// Support: IE<9
		// Assume reasonable values in the absence of getComputedStyle
		pixelPositionVal = boxSizingReliableVal = reliableMarginLeftVal = false;
		pixelMarginRightVal = reliableMarginRightVal = true;

		// Check for getComputedStyle so that this code is not run in IE<9.
		if ( window.getComputedStyle ) {
			divStyle = window.getComputedStyle( div );
			pixelPositionVal = ( divStyle || {} ).top !== "1%";
			reliableMarginLeftVal = ( divStyle || {} ).marginLeft === "2px";
			boxSizingReliableVal = ( divStyle || { width: "4px" } ).width === "4px";

			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = ( divStyle || { marginRight: "4px" } ).marginRight === "4px";

			// Support: Android 2.3 only
			// Div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			contents = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			contents.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
			contents.style.marginRight = contents.style.width = "0";
			div.style.width = "1px";

			reliableMarginRightVal =
				!parseFloat( ( window.getComputedStyle( contents ) || {} ).marginRight );

			div.removeChild( contents );
		}

		// Support: IE6-8
		// First check that getClientRects works as expected
		// Check if table cells still have offsetWidth/Height when they are set
		// to display:none and there are still other visible table cells in a
		// table row; if so, offsetWidth/Height are not reliable for use when
		// determining if an element has been hidden directly using
		// display:none (it is still safe to use offsets if a parent element is
		// hidden; don safety goggles and see bug #4512 for more information).
		div.style.display = "none";
		reliableHiddenOffsetsVal = div.getClientRects().length === 0;
		if ( reliableHiddenOffsetsVal ) {
			div.style.display = "";
			div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
			div.childNodes[ 0 ].style.borderCollapse = "separate";
			contents = div.getElementsByTagName( "td" );
			contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
			reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			if ( reliableHiddenOffsetsVal ) {
				contents[ 0 ].style.display = "";
				contents[ 1 ].style.display = "none";
				reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			}
		}

		// Teardown
		documentElement.removeChild( container );
	}

} )();


var getStyles, curCSS,
	rposition = /^(top|right|bottom|left)$/;

if ( window.getComputedStyle ) {
	getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

	curCSS = function( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;

		computed = computed || getStyles( elem );

		// getPropertyValue is only needed for .css('filter') in IE9, see #12537
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		if ( computed ) {

			// A tribute to the "awesome hack by Dean Edwards"
			// Chrome < 17 and Safari 5.0 uses "computed value"
			// instead of "used value" for margin-right
			// Safari 5.1.7 (at least) returns percentage for a larger set of values,
			// but width seems to be reliably pixels
			// this is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "";
	};
} else if ( documentElement.currentStyle ) {
	getStyles = function( elem ) {
		return elem.currentStyle;
	};

	curCSS = function( elem, name, computed ) {
		var left, rs, rsLeft, ret,
			style = elem.style;

		computed = computed || getStyles( elem );
		ret = computed ? computed[ name ] : undefined;

		// Avoid setting ret to empty string here
		// so we don't default to auto
		if ( ret == null && style && style[ name ] ) {
			ret = style[ name ];
		}

		// From the awesome hack by Dean Edwards
		// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291

		// If we're not dealing with a regular pixel number
		// but a number that has a weird ending, we need to convert it to pixels
		// but not position css attributes, as those are
		// proportional to the parent element instead
		// and we can't measure the parent instead because it
		// might trigger a "stacking dolls" problem
		if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {

			// Remember the original values
			left = style.left;
			rs = elem.runtimeStyle;
			rsLeft = rs && rs.left;

			// Put in the new values to get a computed value out
			if ( rsLeft ) {
				rs.left = elem.currentStyle.left;
			}
			style.left = name === "fontSize" ? "1em" : ret;
			ret = style.pixelLeft + "px";

			// Revert the changed values
			style.left = left;
			if ( rsLeft ) {
				rs.left = rsLeft;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "" || "auto";
	};
}




function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

		ralpha = /alpha\([^)]*\)/i,
	ropacity = /opacity\s*=\s*([^)]*)/i,

	// swappable if display is none or starts with table except
	// "table", "table-cell", or "table-caption"
	// see here for display values:
	// https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;


// return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// check for vendor prefixed names
	var capName = name.charAt( 0 ).toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = jQuery._data( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] =
					jQuery._data( elem, "olddisplay", defaultDisplay( elem.nodeName ) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display && display !== "none" || !hidden ) {
				jQuery._data(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// at this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// at this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// at this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = support.boxSizing &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// we need the check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {

		// normalize float css property
		"float": support.cssFloat ? "cssFloat" : "styleFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set. See: #7116
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
			// but it would mean to define eight
			// (for every problematic property) identical functions
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				// Support: IE
				// Swallow errors from 'invalid' CSS values (#5509)
				try {
					style[ name ] = value;
				} catch ( e ) {}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var num, val, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		//convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Return, converting to number if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// certain elements can have dimension info if we invisibly show them
				// however, it must have a current display style that would benefit from this
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					support.boxSizing &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
} );

if ( !support.opacity ) {
	jQuery.cssHooks.opacity = {
		get: function( elem, computed ) {

			// IE uses filters for opacity
			return ropacity.test( ( computed && elem.currentStyle ?
				elem.currentStyle.filter :
				elem.style.filter ) || "" ) ?
					( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
					computed ? "1" : "";
		},

		set: function( elem, value ) {
			var style = elem.style,
				currentStyle = elem.currentStyle,
				opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
				filter = currentStyle && currentStyle.filter || style.filter || "";

			// IE has trouble with opacity if it does not have layout
			// Force it by setting the zoom level
			style.zoom = 1;

			// if setting opacity to 1, and no other filters exist -
			// attempt to remove filter attribute #6652
			// if value === "", then remove inline opacity #12685
			if ( ( value >= 1 || value === "" ) &&
					jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
					style.removeAttribute ) {

				// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
				// if "filter:" is present at all, clearType is disabled, we want to avoid this
				// style.removeAttribute is IE Only, but so apparently is this code path...
				style.removeAttribute( "filter" );

				// if there is no filter style applied in a css rule
				// or unset inline opacity, we are done
				if ( value === "" || currentStyle && !currentStyle.filter ) {
					return;
				}
			}

			// otherwise, set new filter values
			style.filter = ralpha.test( filter ) ?
				filter.replace( ralpha, opacity ) :
				filter + " " + opacity;
		}
	};
}

jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return (
				parseFloat( curCSS( elem, "marginLeft" ) ) ||

				// Support: IE<=11+
				// Running getBoundingClientRect on a disconnected node in IE throws an error
				// Support: IE8 only
				// getClientRects() errors on disconnected elems
				( jQuery.contains( elem.ownerDocument, elem ) ?
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} ) :
					0
				)
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails
			// so, simple values such as "10px" are parsed to Float.
			// complex values such as "rotate(1rad)" are returned as is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// use step hook for back compat - use cssHook if its there - use .style if its
			// available and use plain properties where available
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9
// Panic based approach to setting things on disconnected nodes

Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		attrs = { height: type },
		i = 0;

	// if we include width, step value is 1 to do all cssExpand values,
	// if we don't include width, step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// we're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = jQuery._data( elem, "fxshow" );

	// handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// doing this makes sure that the complete handler will be called
			// before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE does not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {

			// inline-level elements accept inline-block;
			// block-level elements need to be inline with layout
			if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
				style.display = "inline-block";
			} else {
				style.zoom = 1;
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		if ( !support.shrinkWrapBlocks() ) {
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = jQuery._data( elem, "fxshow", {} );
		}

		// store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;
			jQuery._removeData( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// not quite $.extend, this wont overwrite keys already present.
			// also - reusing 'index' from above because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// if we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// resolve when we played the last frame
				// otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || jQuery._data( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = jQuery._data( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// start the next in the queue if the last step wasn't forced
			// timers currently will call their complete callbacks, which will dequeue
			// but only if they were gotoEnd
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = jQuery._data( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// enable finishing flag on private data
			data.finish = true;

			// empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		timers = jQuery.timers,
		i = 0;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var a,
		input = document.createElement( "input" ),
		div = document.createElement( "div" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	// Setup
	div = document.createElement( "div" );
	div.setAttribute( "className", "t" );
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	a = div.getElementsByTagName( "a" )[ 0 ];

	// Support: Windows Web Apps (WWA)
	// `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "checkbox" );
	div.appendChild( input );

	a = div.getElementsByTagName( "a" )[ 0 ];

	// First batch of tests.
	a.style.cssText = "top:1px";

	// Test setAttribute on camelCase class.
	// If it works, we need attrFixes when doing get/setAttribute (ie6/7)
	support.getSetAttribute = div.className !== "t";

	// Get the style information from getAttribute
	// (IE uses .cssText instead)
	support.style = /top/.test( a.getAttribute( "style" ) );

	// Make sure that URLs aren't manipulated
	// (IE normalizes it by default)
	support.hrefNormalized = a.getAttribute( "href" ) === "/a";

	// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
	support.checkOn = !!input.value;

	// Make sure that a selected-by-default option has a working selected property.
	// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
	support.optSelected = opt.selected;

	// Tests for enctype support on a form (#6743)
	support.enctype = !!document.createElement( "form" ).enctype;

	// Make sure that the options inside disabled selects aren't marked as disabled
	// (WebKit marks them as disabled)
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE8 only
	// Check if we can trust getAttribute("value")
	input = document.createElement( "input" );
	input.setAttribute( "value", "" );
	support.input = input.getAttribute( "value" ) === "";

	// Check if an input maintains its value after becoming a radio
	input.value = "t";
	input.setAttribute( "type", "radio" );
	support.radioValue = input.value === "t";
} )();


var rreturn = /\r/g,
	rspaces = /[\x20\t\r\n\f]+/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if (
					hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// handle most common string cases
					ret.replace( rreturn, "" ) :

					// handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";
			} else if ( typeof val === "number" ) {
				val += "";
			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// oldIE doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled :
								option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1 ) {

						// Support: IE6
						// When new option element is added to select box we need to
						// force reflow of newly added node in order to workaround delay
						// of initialization properties
						try {
							option.selected = optionSet = true;

						} catch ( _ ) {

							// Will be executed only in IE6
							option.scrollHeight;
						}

					} else {
						option.selected = false;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}

				return options;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle,
	ruseDefault = /^(?:checked|selected)$/i,
	getSetAttribute = support.getSetAttribute,
	getSetInput = support.input;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {

					// Setting the type on a radio button after the value resets the value in IE8-9
					// Reset value to default in case type is set after value during creation
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
						elem[ propName ] = false;

					// Support: IE<9
					// Also clear defaultChecked/defaultSelected (if appropriate)
					} else {
						elem[ jQuery.camelCase( "default-" + name ) ] =
							elem[ propName ] = false;
					}

				// See #9699 for explanation of this approach (setting first, then removal)
				} else {
					jQuery.attr( elem, name, "" );
				}

				elem.removeAttribute( getSetAttribute ? name : propName );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {

			// IE<8 needs the *property* name
			elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );

		} else {

			// Support: IE<9
			// Use defaultChecked and defaultSelected for oldIE
			elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} else {
		attrHandle[ name ] = function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem[ jQuery.camelCase( "default-" + name ) ] ?
					name.toLowerCase() :
					null;
			}
		};
	}
} );

// fix oldIE attroperties
if ( !getSetInput || !getSetAttribute ) {
	jQuery.attrHooks.value = {
		set: function( elem, value, name ) {
			if ( jQuery.nodeName( elem, "input" ) ) {

				// Does not return so that setAttribute is also used
				elem.defaultValue = value;
			} else {

				// Use nodeHook if defined (#1954); otherwise setAttribute is fine
				return nodeHook && nodeHook.set( elem, value, name );
			}
		}
	};
}

// IE6/7 do not support getting/setting some attributes with get/setAttribute
if ( !getSetAttribute ) {

	// Use this for any attribute in IE6/7
	// This fixes almost every IE6/7 issue
	nodeHook = {
		set: function( elem, value, name ) {

			// Set the existing or create a new attribute node
			var ret = elem.getAttributeNode( name );
			if ( !ret ) {
				elem.setAttributeNode(
					( ret = elem.ownerDocument.createAttribute( name ) )
				);
			}

			ret.value = value += "";

			// Break association with cloned elements by also using setAttribute (#9646)
			if ( name === "value" || value === elem.getAttribute( name ) ) {
				return value;
			}
		}
	};

	// Some attributes are constructed with empty-string values when not defined
	attrHandle.id = attrHandle.name = attrHandle.coords =
		function( elem, name, isXML ) {
			var ret;
			if ( !isXML ) {
				return ( ret = elem.getAttributeNode( name ) ) && ret.value !== "" ?
					ret.value :
					null;
			}
		};

	// Fixing value retrieval on a button requires this module
	jQuery.valHooks.button = {
		get: function( elem, name ) {
			var ret = elem.getAttributeNode( name );
			if ( ret && ret.specified ) {
				return ret.value;
			}
		},
		set: nodeHook.set
	};

	// Set contenteditable to false on removals(#10429)
	// Setting to empty string throws an error as an invalid value
	jQuery.attrHooks.contenteditable = {
		set: function( elem, value, name ) {
			nodeHook.set( elem, value === "" ? false : value, name );
		}
	};

	// Set width and height to auto instead of 0 on empty string( Bug #8150 )
	// This is for removals
	jQuery.each( [ "width", "height" ], function( i, name ) {
		jQuery.attrHooks[ name ] = {
			set: function( elem, value ) {
				if ( value === "" ) {
					elem.setAttribute( name, "auto" );
					return value;
				}
			}
		};
	} );
}

if ( !support.style ) {
	jQuery.attrHooks.style = {
		get: function( elem ) {

			// Return undefined in the case of empty string
			// Note: IE uppercases css property names, but if we were to .toLowerCase()
			// .cssText, that would destroy case sensitivity in URL's, like in "background"
			return elem.style.cssText || undefined;
		},
		set: function( elem, value ) {
			return ( elem.style.cssText = value + "" );
		}
	};
}




var rfocusable = /^(?:input|select|textarea|button|object)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		name = jQuery.propFix[ name ] || name;
		return this.each( function() {

			// try/catch handles cases where IE balks (such as removing a property on window)
			try {
				this[ name ] = undefined;
				delete this[ name ];
			} catch ( e ) {}
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Some attributes require a special call on IE
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !support.hrefNormalized ) {

	// href/src property should get the full normalized URL (#10299/#12915)
	jQuery.each( [ "href", "src" ], function( i, name ) {
		jQuery.propHooks[ name ] = {
			get: function( elem ) {
				return elem.getAttribute( name, 4 );
			}
		};
	} );
}

// Support: Safari, IE9+
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;

			if ( parent ) {
				parent.selectedIndex;

				// Make sure that it also works with optgroups, see #5701
				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
			return null;
		},
		set: function( elem ) {
			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );

// IE6/7 call enctype encoding
if ( !support.enctype ) {
	jQuery.propFix.enctype = "encoding";
}




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return jQuery.attr( elem, "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						jQuery.attr( elem, "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						jQuery.attr( elem, "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// store className if set
					jQuery._data( this, "__className__", className );
				}

				// If the element has a class name or if we're passed "false",
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				jQuery.attr( this, "class",
					className || value === false ?
					"" :
					jQuery._data( this, "__className__" ) || ""
				);
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




// Return jQuery for attributes-only inclusion


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );


var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;

jQuery.parseJSON = function( data ) {

	// Attempt to parse using the native JSON parser first
	if ( window.JSON && window.JSON.parse ) {

		// Support: Android 2.3
		// Workaround failure to string-cast null input
		return window.JSON.parse( data + "" );
	}

	var requireNonComma,
		depth = null,
		str = jQuery.trim( data + "" );

	// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
	// after removing valid tokens
	return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {

		// Force termination if we see a misplaced comma
		if ( requireNonComma && comma ) {
			depth = 0;
		}

		// Perform no more replacements after returning to outermost depth
		if ( depth === 0 ) {
			return token;
		}

		// Commas must not follow "[", "{", or ","
		requireNonComma = open || comma;

		// Determine new depth
		// array/object open ("[" or "{"): depth += true - false (increment)
		// array/object close ("]" or "}"): depth += false - true (decrement)
		// other cases ("," or primitive): depth += true - true (numeric cast)
		depth += !close - !open;

		// Remove this token
		return "";
	} ) ) ?
		( Function( "return " + str ) )() :
		jQuery.error( "Invalid JSON: " + data );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	try {
		if ( window.DOMParser ) { // Standard
			tmp = new window.DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} else { // IE
			xml = new window.ActiveXObject( "Microsoft.XMLDOM" );
			xml.async = "false";
			xml.loadXML( data );
		}
	} catch ( e ) {
		xml = undefined;
	}
	if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,

	// IE leaves an \r character at EOL
	rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType.charAt( 0 ) === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var deep, key,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {
	var firstDataType, ct, finalDataType, type,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) { // jscs:ignore requireDotNotation
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var

			// Cross-domain detection vars
			parts,

			// Loop variable
			i,

			// URL without anti-cache param
			cacheURL,

			// Response headers as string
			responseHeadersString,

			// timeout handle
			timeoutTimer,

			// To know if global events are to be dispatched
			fireGlobals,

			transport,

			// Response headers
			responseHeaders,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" )
			.replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// We extract error from statusText
				// then normalize statusText and status for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			var wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
					elem = elem.firstChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


function getDisplay( elem ) {
	return elem.style && elem.style.display || jQuery.css( elem, "display" );
}

function filterHidden( elem ) {

	// Disconnected elements are considered hidden
	if ( !jQuery.contains( elem.ownerDocument || document, elem ) ) {
		return true;
	}
	while ( elem && elem.nodeType === 1 ) {
		if ( getDisplay( elem ) === "none" || elem.type === "hidden" ) {
			return true;
		}
		elem = elem.parentNode;
	}
	return false;
}

jQuery.expr.filters.hidden = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return support.reliableHiddenOffsets() ?
		( elem.offsetWidth <= 0 && elem.offsetHeight <= 0 &&
			!elem.getClientRects().length ) :
			filterHidden( elem );
};

jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is(":disabled") so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


// Create the request object
// (This is still attached to ajaxSettings for backward compatibility)
jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?

	// Support: IE6-IE8
	function() {

		// XHR cannot access local files, always use ActiveX for that case
		if ( this.isLocal ) {
			return createActiveXHR();
		}

		// Support: IE 9-11
		// IE seems to error on cross-domain PATCH requests when ActiveX XHR
		// is used. In IE 9+ always use the native XHR.
		// Note: this condition won't catch Edge as it doesn't define
		// document.documentMode but it also doesn't support ActiveX so it won't
		// reach this code.
		if ( document.documentMode > 8 ) {
			return createStandardXHR();
		}

		// Support: IE<9
		// oldIE XHR does not support non-RFC2616 methods (#13240)
		// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
		// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
		// Although this check for six methods instead of eight
		// since IE also does not support "trace" and "connect"
		return /^(get|post|head|put|delete|options)$/i.test( this.type ) &&
			createStandardXHR() || createActiveXHR();
	} :

	// For all other browsers, use the standard XMLHttpRequest object
	createStandardXHR;

var xhrId = 0,
	xhrCallbacks = {},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE<10
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]( undefined, true );
		}
	} );
}

// Determine support properties
support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
xhrSupported = support.ajax = !!xhrSupported;

// Create transport if the browser can provide an xhr
if ( xhrSupported ) {

	jQuery.ajaxTransport( function( options ) {

		// Cross domain only allowed if supported through XMLHttpRequest
		if ( !options.crossDomain || support.cors ) {

			var callback;

			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;

					// Open the socket
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);

					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}

					// Set headers
					for ( i in headers ) {

						// Support: IE<9
						// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
						// request header to a null-value.
						//
						// To keep consistent with other XHR implementations, cast the value
						// to string and ignore `undefined`.
						if ( headers[ i ] !== undefined ) {
							xhr.setRequestHeader( i, headers[ i ] + "" );
						}
					}

					// Do send the request
					// This may raise an exception which is actually
					// handled in jQuery.ajax (so no try/catch here)
					xhr.send( ( options.hasContent && options.data ) || null );

					// Listener
					callback = function( _, isAbort ) {
						var status, statusText, responses;

						// Was never called and is aborted or complete
						if ( callback && ( isAbort || xhr.readyState === 4 ) ) {

							// Clean up
							delete xhrCallbacks[ id ];
							callback = undefined;
							xhr.onreadystatechange = jQuery.noop;

							// Abort manually if needed
							if ( isAbort ) {
								if ( xhr.readyState !== 4 ) {
									xhr.abort();
								}
							} else {
								responses = {};
								status = xhr.status;

								// Support: IE<10
								// Accessing binary-data responseText throws an exception
								// (#11426)
								if ( typeof xhr.responseText === "string" ) {
									responses.text = xhr.responseText;
								}

								// Firefox throws an exception when accessing
								// statusText for faulty cross-domain requests
								try {
									statusText = xhr.statusText;
								} catch ( e ) {

									// We normalize with Webkit giving an empty statusText
									statusText = "";
								}

								// Filter status for non standard behaviors

								// If the request is local and we have data: assume a success
								// (success with no data won't get notified, that's the best we
								// can do given current implementations)
								if ( !status && options.isLocal && !options.crossDomain ) {
									status = responses.text ? 200 : 404;

								// IE - #1450: sometimes returns 1223 when it should be 204
								} else if ( status === 1223 ) {
									status = 204;
								}
							}
						}

						// Call complete if needed
						if ( responses ) {
							complete( status, statusText, responses, xhr.getAllResponseHeaders() );
						}
					};

					// Do send the request
					// `xhr.send` may raise an exception, but it will be
					// handled in jQuery.ajax (so no try/catch here)
					if ( !options.async ) {

						// If we're in sync mode we fire the callback
						callback();
					} else if ( xhr.readyState === 4 ) {

						// (IE6 & IE7) if it's in cache and has been
						// retrieved directly we need to fire the callback
						window.setTimeout( callback );
					} else {

						// Register the callback, but delay it in case `xhr.send` throws
						// Add to the list of active xhr callbacks
						xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
					}
				},

				abort: function() {
					if ( callback ) {
						callback( undefined, true );
					}
				}
			};
		}
	} );
}

// Functions to create xhrs
function createStandardXHR() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
}

function createActiveXHR() {
	try {
		return new window.ActiveXObject( "Microsoft.XMLHTTP" );
	} catch ( e ) {}
}




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
// https://oktainc.atlassian.net/browse/OKTA-131142
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and global
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
		s.global = false;
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {

		var script,
			head = document.head || jQuery( "head" )[ 0 ] || document.documentElement;

		return {

			send: function( _, callback ) {

				script = document.createElement( "script" );

				script.async = true;

				if ( s.scriptCharset ) {
					script.charset = s.scriptCharset;
				}

				script.src = s.url;

				// Attach handlers for all browsers
				script.onload = script.onreadystatechange = function( _, isAbort ) {

					if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {

						// Handle memory leak in IE
						script.onload = script.onreadystatechange = null;

						// Remove the script
						if ( script.parentNode ) {
							script.parentNode.removeChild( script );
						}

						// Dereference the script
						script = null;

						// Callback if not abort
						if ( !isAbort ) {
							callback( 200, "success" );
						}
					}
				};

				// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
				// Use native DOM manipulation to avoid our domManip AJAX trickery
				head.insertBefore( script, head.firstChild );
			},

			abort: function() {
				if ( script ) {
					script.onload( undefined, true );
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// data: string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off, url.length ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};





/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ?
		elem :
		elem.nodeType === 9 ?
			elem.defaultView || elem.parentWindow :
			false;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			jQuery.inArray( "auto", [ curCSSTop, curCSSLeft ] ) > -1;

		// need to be able to calculate position if either top or left
		// is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;
		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );
		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			box = { top: 0, left: 0 },
			elem = this[ 0 ],
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// If we don't have gBCR, just use 0,0 rather than error
		// BlackBerry 5, iOS 3 (original iPhone)
		if ( typeof elem.getBoundingClientRect !== "undefined" ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
			left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			parentOffset = { top: 0, left: 0 },
			elem = this[ 0 ];

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// we assume that getBoundingClientRect is available when computed position is fixed
			offset = elem.getBoundingClientRect();
		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		// note: when an element has margin: auto the offsetLeft and marginLeft
		// are the same in Safari causing offset.left to incorrectly be 0
		return {
			top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}
			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = /Y/.test( prop );

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? ( prop in win ) ? win[ prop ] :
					win.document.documentElement[ method ] :
					elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : jQuery( win ).scrollLeft(),
					top ? val : jQuery( win ).scrollTop()
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// getComputedStyle returns percent when specified for top/left/bottom/right
// rather than make the css module depend on the offset module, we just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// if curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
	function( defaultExtra, funcName ) {

		// margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					// unfortunately, this causes bug #3838 in IE6/8 only,
					// but there is currently no good, small way to fix it.
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in
// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)

//9/10/2018 - OKTA-187649 - Expose jQuery in the global window object to externalize it
//OKTA-Core used to load separate jquery as part of the saasure.min.js file along with the one that is bundled in dll.common
if ( !noGlobal || window.__OKTA_EXPORT_JQUERY__ ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* @okta/qtip2 v3.0.3-5-g | Plugins: tips modal viewport svg imagemap ie6 | Styles: core basic css3 | qtip2.com | Licensed MIT | Wed May 24 2017 01:22:57 */

!function(a,b,c){!function(a){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(175)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):jQuery&&!jQuery.fn.qtip&&a(jQuery)}(function(d){"use strict";function e(a,b,c,e){this.id=c,this.target=a,this.tooltip=F,this.elements={target:a},this._id=S+"-"+c,this.timers={img:{}},this.options=b,this.plugins={},this.cache={event:{},target:d(),disabled:E,attr:e,onTooltip:E,lastClass:""},this.rendered=this.destroyed=this.disabled=this.waiting=this.hiddenDuringWait=this.positioning=this.triggering=E}function f(a){return a===F||"object"!==d.type(a)}function g(a){return!(d.isFunction(a)||a&&a.attr||a.length||"object"===d.type(a)&&(a.jquery||a.then))}function h(a){var b,c,e,h;return f(a)?E:(f(a.metadata)&&(a.metadata={type:a.metadata}),"content"in a&&(b=a.content,f(b)||b.jquery||b.done?(c=g(b)?E:b,b=a.content={text:c}):c=b.text,"ajax"in b&&(e=b.ajax,h=e&&e.once!==E,delete b.ajax,b.text=function(a,b){var f=c||d(this).attr(b.options.content.attr)||"Loading...",g=d.ajax(d.extend({},e,{context:b})).then(e.success,F,e.error).then(function(a){return a&&h&&b.set("content.text",a),a},function(a,c,d){b.destroyed||0===a.status||b.set("content.text",c+": "+d)});return h?f:(b.set("content.text",f),g)}),"title"in b&&(d.isPlainObject(b.title)&&(b.button=b.title.button,b.title=b.title.text),g(b.title||E)&&(b.title=E))),"position"in a&&f(a.position)&&(a.position={my:a.position,at:a.position}),"show"in a&&f(a.show)&&(a.show=a.show.jquery?{target:a.show}:a.show===D?{ready:D}:{event:a.show}),"hide"in a&&f(a.hide)&&(a.hide=a.hide.jquery?{target:a.hide}:{event:a.hide}),"style"in a&&f(a.style)&&(a.style={classes:a.style}),d.each(R,function(){this.sanitize&&this.sanitize(a)}),a)}function i(a,b){for(var c,d=0,e=a,f=b.split(".");e=e[f[d++]];)d<f.length&&(c=e);return[c||a,f.pop()]}function j(a,b){var c,d,e;for(c in this.checks)if(this.checks.hasOwnProperty(c))for(d in this.checks[c])this.checks[c].hasOwnProperty(d)&&(e=new RegExp(d,"i").exec(a))&&(b.push(e),("builtin"===c||this.plugins[c])&&this.checks[c][d].apply(this.plugins[c]||this,b))}function k(a){return V.concat("").join(a?"-"+a+" ":" ")}function l(a,b){return b>0?setTimeout(d.proxy(a,this),b):void a.call(this)}function m(a){this.tooltip.hasClass(aa)||(clearTimeout(this.timers.show),clearTimeout(this.timers.hide),this.timers.show=l.call(this,function(){this.toggle(D,a)},this.options.show.delay))}function n(a){if(!this.tooltip.hasClass(aa)&&!this.destroyed){var b=d(a.relatedTarget),c=b.closest(W)[0]===this.tooltip[0],e=b[0]===this.options.show.target[0];if(clearTimeout(this.timers.show),clearTimeout(this.timers.hide),this!==b[0]&&"mouse"===this.options.position.target&&c||this.options.hide.fixed&&/mouse(out|leave|move)/.test(a.type)&&(c||e))try{a.preventDefault(),a.stopImmediatePropagation()}catch(f){}else this.timers.hide=l.call(this,function(){this.toggle(E,a)},this.options.hide.delay,this)}}function o(a){!this.tooltip.hasClass(aa)&&this.options.hide.inactive&&(clearTimeout(this.timers.inactive),this.timers.inactive=l.call(this,function(){this.hide(a)},this.options.hide.inactive))}function p(a){this.rendered&&this.tooltip[0].offsetWidth>0&&this.reposition(a)}function q(a,c,e){d(b.body).delegate(a,(c.split?c:c.join("."+S+" "))+"."+S,function(){var a=y.api[d.attr(this,U)];a&&!a.disabled&&e.apply(a,arguments)})}function r(a,c,f){var g,i,j,k,l,m=d(b.body),n=a[0]===b?m:a,o=a.metadata?a.metadata(f.metadata):F,p="html5"===f.metadata.type&&o?o[f.metadata.name]:F,q=a.data(f.metadata.name||"qtipopts");try{q="string"==typeof q?d.parseJSON(q):q}catch(r){}if(k=d.extend(D,{},y.defaults,f,"object"==typeof q?h(q):F,h(p||o)),i=k.position,k.id=c,"boolean"==typeof k.content.text){if(j=a.attr(k.content.attr),k.content.attr===E||!j)return E;k.content.text=j}if(i.container.length||(i.container=m),i.target===E&&(i.target=n),k.show.target===E&&(k.show.target=n),k.show.solo===D&&(k.show.solo=i.container.closest("body")),k.hide.target===E&&(k.hide.target=n),k.position.viewport===D&&(k.position.viewport=i.container),i.container=i.container.eq(0),i.at=new A(i.at,D),i.my=new A(i.my),a.data(S))if(k.overwrite)a.qtip("destroy",!0);else if(k.overwrite===E)return E;return a.attr(T,c),k.suppress&&(l=a.attr("title"))&&a.removeAttr("title").attr(ca,l).attr("title",""),g=new e(a,k,c,(!!j)),a.data(S,g),g}function s(a){return a.charAt(0).toUpperCase()+a.slice(1)}function t(a,b){var d,e,f=b.charAt(0).toUpperCase()+b.slice(1),g=(b+" "+va.join(f+" ")+f).split(" "),h=0;if(ua[b])return a.css(ua[b]);for(;d=g[h++];)if((e=a.css(d))!==c)return ua[b]=d,e}function u(a,b){return Math.ceil(parseFloat(t(a,b)))}function v(a,b){this._ns="tip",this.options=b,this.offset=b.offset,this.size=[b.width,b.height],this.qtip=a,this.init(a)}function w(a,b){this.options=b,this._ns="-modal",this.qtip=a,this.init(a)}function x(a){this._ns="ie6",this.qtip=a,this.init(a)}var y,z,A,B,C,D=!0,E=!1,F=null,G="x",H="y",I="width",J="height",K="top",L="left",M="bottom",N="right",O="center",P="flipinvert",Q="shift",R={},S="qtip",T="data-hasqtip",U="data-qtip-id",V=["ui-widget","ui-tooltip"],W="."+S,X="click dblclick mousedown mouseup mousemove mouseleave mouseenter".split(" "),Y=S+"-fixed",Z=S+"-default",$=S+"-focus",_=S+"-hover",aa=S+"-disabled",ba="_replacedByqTip",ca="oldtitle",da={ie:function(){var a,c;for(a=4,c=b.createElement("div");(c.innerHTML="<!--[if gt IE "+a+"]><i></i><![endif]-->")&&c.getElementsByTagName("i")[0];a+=1);return a>4?a:NaN}(),iOS:parseFloat((""+(/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent)||[0,""])[1]).replace("undefined","3_2").replace("_",".").replace("_",""))||E};z=e.prototype,z._when=function(a){return d.when.apply(d,a)},z.render=function(a){if(this.rendered||this.destroyed)return this;var b=this,c=this.options,e=this.cache,f=this.elements,g=c.content.text,h=c.content.title,i=c.content.button,j=c.position,k=[];return d.attr(this.target[0],"aria-describedby",this._id),e.posClass=this._createPosClass((this.position={my:j.my,at:j.at}).my),this.tooltip=f.tooltip=d("<div/>",{id:this._id,"class":[S,Z,c.style.classes,e.posClass].join(" "),width:c.style.width||"",height:c.style.height||"",tracking:"mouse"===j.target&&j.adjust.mouse,role:"alert","aria-live":"polite","aria-atomic":E,"aria-describedby":this._id+"-content","aria-hidden":D}).toggleClass(aa,this.disabled).attr(U,this.id).data(S,this).appendTo(j.container).append(f.content=d("<div />",{"class":S+"-content",id:this._id+"-content","aria-atomic":D})),this.rendered=-1,this.positioning=D,h&&(this._createTitle(),d.isFunction(h)||k.push(this._updateTitle(h,E))),i&&this._createButton(),d.isFunction(g)||k.push(this._updateContent(g,E)),this.rendered=D,this._setWidget(),d.each(R,function(a){var c;"render"===this.initialize&&(c=this(b))&&(b.plugins[a]=c)}),this._unassignEvents(),this._assignEvents(),this._when(k).then(function(){b._trigger("render"),b.positioning=E,b.hiddenDuringWait||!c.show.ready&&!a||b.toggle(D,e.event,E),b.hiddenDuringWait=E}),y.api[this.id]=this,this},z.destroy=function(a){function b(){if(!this.destroyed){this.destroyed=D;var a,b=this.target,c=b.attr(ca);this.rendered&&this.tooltip.stop(1,0).find("*").remove().end().remove(),d.each(this.plugins,function(){this.destroy&&this.destroy()});for(a in this.timers)this.timers.hasOwnProperty(a)&&clearTimeout(this.timers[a]);b.removeData(S).removeAttr(U).removeAttr(T).removeAttr("aria-describedby"),this.options.suppress&&c&&b.attr("title",c).removeAttr(ca),this._unassignEvents(),this.options=this.elements=this.cache=this.timers=this.plugins=this.mouse=F,delete y.api[this.id]}}return this.destroyed?this.target:(a===D&&"hide"!==this.triggering||!this.rendered?b.call(this):(this.tooltip.one("tooltiphidden",d.proxy(b,this)),!this.triggering&&this.hide()),this.target)},B=z.checks={builtin:{"^id$":function(a,b,c,e){var f=c===D?y.nextid:c,g=S+"-"+f;f!==E&&f.length>0&&!d("#"+g).length?(this._id=g,this.rendered&&(this.tooltip[0].id=this._id,this.elements.content[0].id=this._id+"-content",this.elements.title[0].id=this._id+"-title")):a[b]=e},"^prerender":function(a,b,c){c&&!this.rendered&&this.render(this.options.show.ready)},"^content.text$":function(a,b,c){this._updateContent(c)},"^content.attr$":function(a,b,c,d){this.options.content.text===this.target.attr(d)&&this._updateContent(this.target.attr(c))},"^content.title$":function(a,b,c){return c?(c&&!this.elements.title&&this._createTitle(),void this._updateTitle(c)):this._removeTitle()},"^content.button$":function(a,b,c){this._updateButton(c)},"^content.title.(text|button)$":function(a,b,c){this.set("content."+b,c)},"^position.(my|at)$":function(a,b,c){"string"==typeof c&&(this.position[b]=a[b]=new A(c,"at"===b))},"^position.container$":function(a,b,c){this.rendered&&this.tooltip.appendTo(c)},"^show.ready$":function(a,b,c){c&&(!this.rendered&&this.render(D)||this.toggle(D))},"^style.classes$":function(a,b,c,d){this.rendered&&this.tooltip.removeClass(d).addClass(c)},"^style.(width|height)":function(a,b,c){this.rendered&&this.tooltip.css(b,c)},"^style.widget|content.title":function(){this.rendered&&this._setWidget()},"^style.def":function(a,b,c){this.rendered&&this.tooltip.toggleClass(Z,!!c)},"^events.(render|show|move|hide|focus|blur)$":function(a,b,c){this.rendered&&this.tooltip[(d.isFunction(c)?"":"un")+"bind"]("tooltip"+b,c)},"^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)":function(){if(this.rendered){var a=this.options.position;this.tooltip.attr("tracking","mouse"===a.target&&a.adjust.mouse),this._unassignEvents(),this._assignEvents()}}}},z.get=function(a){if(this.destroyed)return this;var b=i(this.options,a.toLowerCase()),c=b[0][b[1]];return c.precedance?c.string():c};var ea=/^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,fa=/^prerender|show\.ready/i;z.set=function(a,b){if(this.destroyed)return this;var c,e=this.rendered,f=E,g=this.options;return"string"==typeof a?(c=a,a={},a[c]=b):a=d.extend({},a),d.each(a,function(b,c){if(e&&fa.test(b))return void delete a[b];var h,j=i(g,b.toLowerCase());h=j[0][j[1]],j[0][j[1]]=c&&c.nodeType?d(c):c,f=ea.test(b)||f,a[b]=[j[0],j[1],c,h]}),h(g),this.positioning=D,d.each(a,d.proxy(j,this)),this.positioning=E,this.rendered&&this.tooltip[0].offsetWidth>0&&f&&this.reposition("mouse"===g.position.target?F:this.cache.event),this},z._update=function(a,b){var c=this,e=this.cache;return this.rendered&&a?(d.isFunction(a)&&(a=a.call(this.elements.target,e.event,this)||""),d.isFunction(a.then)?(e.waiting=D,a.then(function(a){return e.waiting=E,c._update(a,b)},F,function(a){return c._update(a,b)})):a===E||!a&&""!==a?E:(a.jquery&&a.length>0?b.empty().append(a.css({display:"block",visibility:"visible"})):b.html(a),this._waitForContent(b).then(function(a){c.rendered&&c.tooltip[0].offsetWidth>0&&c.reposition(e.event,!a.length)}))):E},z._waitForContent=function(a){var b=this.cache;return b.waiting=D,(d.fn.imagesLoaded?a.imagesLoaded():(new d.Deferred).resolve([])).done(function(){b.waiting=E}).promise()},z._updateContent=function(a,b){this._update(a,this.elements.content,b)},z._updateTitle=function(a,b){this._update(a,this.elements.title,b)===E&&this._removeTitle(E)},z._createTitle=function(){var a=this.elements,b=this._id+"-title";a.titlebar&&this._removeTitle(),a.titlebar=d("<div />",{"class":S+"-titlebar "+(this.options.style.widget?k("header"):"")}).append(a.title=d("<div />",{id:b,"class":S+"-title","aria-atomic":D})).insertBefore(a.content).delegate(".qtip-close","mousedown keydown mouseup keyup mouseout",function(a){d(this).toggleClass("ui-state-active ui-state-focus","down"===a.type.substr(-4))}).delegate(".qtip-close","mouseover mouseout",function(a){d(this).toggleClass("ui-state-hover","mouseover"===a.type)}),this.options.content.button&&this._createButton()},z._removeTitle=function(a){var b=this.elements;b.title&&(b.titlebar.remove(),b.titlebar=b.title=b.button=F,a!==E&&this.reposition())},z._createPosClass=function(a){return S+"-pos-"+(a||this.options.position.my).abbrev()},z.reposition=function(c,e){if(!this.rendered||this.positioning||this.destroyed)return this;this.positioning=D;var f,g,h,i,j=this.cache,k=this.tooltip,l=this.options.position,m=l.target,n=l.my,o=l.at,p=l.viewport,q=l.container,r=l.adjust,s=r.method.split(" "),t=k.outerWidth(E),u=k.outerHeight(E),v=0,w=0,x=k.css("position"),y={left:0,top:0},z=k[0].offsetWidth>0,A=c&&"scroll"===c.type,B=d(a),C=q[0].ownerDocument,F=this.mouse;if(d.isArray(m)&&2===m.length)o={x:L,y:K},y={left:m[0],top:m[1]};else if("mouse"===m)o={x:L,y:K},(!r.mouse||this.options.hide.distance)&&j.origin&&j.origin.pageX?c=j.origin:!c||c&&("resize"===c.type||"scroll"===c.type)?c=j.event:F&&F.pageX&&(c=F),"static"!==x&&(y=q.offset()),C.body.offsetWidth!==(a.innerWidth||C.documentElement.clientWidth)&&(g=d(b.body).offset()),y={left:c.pageX-y.left+(g&&g.left||0),top:c.pageY-y.top+(g&&g.top||0)},r.mouse&&A&&F&&(y.left-=(F.scrollX||0)-B.scrollLeft(),y.top-=(F.scrollY||0)-B.scrollTop());else{if("event"===m?c&&c.target&&"scroll"!==c.type&&"resize"!==c.type?j.target=d(c.target):c.target||(j.target=this.elements.target):"event"!==m&&(j.target=d(m.jquery?m:this.elements.target)),m=j.target,m=d(m).eq(0),0===m.length)return this;m[0]===b||m[0]===a?(v=da.iOS?a.innerWidth:m.width(),w=da.iOS?a.innerHeight:m.height(),m[0]===a&&(y={top:(p||m).scrollTop(),left:(p||m).scrollLeft()})):R.imagemap&&m.is("area")?f=R.imagemap(this,m,o,R.viewport?s:E):R.svg&&m&&m[0].ownerSVGElement?f=R.svg(this,m,o,R.viewport?s:E):(v=m.outerWidth(E),w=m.outerHeight(E),y=m.offset()),f&&(v=f.width,w=f.height,g=f.offset,y=f.position),y=this.reposition.offset(m,y,q),(da.iOS>3.1&&da.iOS<4.1||da.iOS>=4.3&&da.iOS<4.33||!da.iOS&&"fixed"===x)&&(y.left-=B.scrollLeft(),y.top-=B.scrollTop()),(!f||f&&f.adjustable!==E)&&(y.left+=o.x===N?v:o.x===O?v/2:0,y.top+=o.y===M?w:o.y===O?w/2:0)}return y.left+=r.x+(n.x===N?-t:n.x===O?-t/2:0),y.top+=r.y+(n.y===M?-u:n.y===O?-u/2:0),R.viewport?(h=y.adjusted=R.viewport(this,y,l,v,w,t,u),g&&h.left&&(y.left+=g.left),g&&h.top&&(y.top+=g.top),h.my&&(this.position.my=h.my)):y.adjusted={left:0,top:0},j.posClass!==(i=this._createPosClass(this.position.my))&&(j.posClass=i,k.removeClass(j.posClass).addClass(i)),this._trigger("move",[y,p.elem||p],c)?(delete y.adjusted,e===E||!z||isNaN(y.left)||isNaN(y.top)||"mouse"===m||!d.isFunction(l.effect)?k.css(y):d.isFunction(l.effect)&&(l.effect.call(k,this,d.extend({},y)),k.queue(function(a){d(this).css({opacity:"",height:""}),da.ie&&this.style.removeAttribute("filter"),a()})),this.positioning=E,this):this},z.reposition.offset=function(a,c,e){function f(a,b){c.left+=b*a.scrollLeft(),c.top+=b*a.scrollTop()}if(!e[0])return c;var g,h,i,j,k=d(a[0].ownerDocument),l=!!da.ie&&"CSS1Compat"!==b.compatMode,m=e[0];do"static"!==(h=d.css(m,"position"))&&("fixed"===h?(i=m.getBoundingClientRect(),f(k,-1)):(i=d(m).position(),i.left+=parseFloat(d.css(m,"borderLeftWidth"))||0,i.top+=parseFloat(d.css(m,"borderTopWidth"))||0),c.left-=i.left+(parseFloat(d.css(m,"marginLeft"))||0),c.top-=i.top+(parseFloat(d.css(m,"marginTop"))||0),g||"hidden"===(j=d.css(m,"overflow"))||"visible"===j||"BODY"===d.prop(m,"tagName")||(g=d(m)));while(m=m.offsetParent);return g&&(g[0]!==k[0]||l)&&f(g,1),c};var ga=(A=z.reposition.Corner=function(a,b){a=(""+a).replace(/([A-Z])/," $1").replace(/middle/gi,O).toLowerCase(),this.x=(a.match(/left|right/i)||a.match(/center/)||["inherit"])[0].toLowerCase(),this.y=(a.match(/top|bottom|center/i)||["inherit"])[0].toLowerCase(),this.forceY=!!b;var c=a.charAt(0);this.precedance="t"===c||"b"===c?H:G}).prototype;ga.invert=function(a,b){this[a]=this[a]===L?N:this[a]===N?L:b||this[a]},ga.string=function(a){var b=this.x,c=this.y,d=b!==c?"center"===b||"center"!==c&&(this.precedance===H||this.forceY)?[c,b]:[b,c]:[b];return a!==!1?d.join(" "):d},ga.abbrev=function(){var a=this.string(!1);return a[0].charAt(0)+(a[1]&&a[1].charAt(0)||"")},ga.clone=function(){return new A(this.string(),this.forceY)},z.toggle=function(a,c){var e=this.cache,f=this.options,g=this.tooltip;if(c){if(/over|enter/.test(c.type)&&e.event&&/out|leave/.test(e.event.type)&&f.show.target.add(c.target).length===f.show.target.length&&g.has(c.relatedTarget).length)return this;e.event=d.event.fix(c)}if(this.waiting&&!a&&(this.hiddenDuringWait=D),!this.rendered)return a?this.render(1):this;if(this.destroyed||this.disabled)return this;var h,i,j,k=a?"show":"hide",l=this.options[k],m=this.options.position,n=this.options.content,o=this.tooltip.css("width"),p=this.tooltip.is(":visible"),q=a||1===l.target.length,r=!c||l.target.length<2||e.target[0]===c.target;return(typeof a).search("boolean|number")&&(a=!p),h=!g.is(":animated")&&p===a&&r,i=h?F:!!this._trigger(k,[90]),this.destroyed?this:(i!==E&&a&&this.focus(c),!i||h?this:(d.attr(g[0],"aria-hidden",!a),a?(this.mouse&&(e.origin=d.event.fix(this.mouse)),d.isFunction(n.text)&&this._updateContent(n.text,E),d.isFunction(n.title)&&this._updateTitle(n.title,E),!C&&"mouse"===m.target&&m.adjust.mouse&&(d(b).bind("mousemove."+S,this._storeMouse),C=D),o||g.css("width",g.outerWidth(E)),this.reposition(c,arguments[2]),o||g.css("width",""),l.solo&&("string"==typeof l.solo?d(l.solo):d(W,l.solo)).not(g).not(l.target).qtip("hide",new d.Event("tooltipsolo"))):(clearTimeout(this.timers.show),delete e.origin,C&&!d(W+'[tracking="true"]:visible',l.solo).not(g).length&&(d(b).unbind("mousemove."+S),C=E),this.blur(c)),j=d.proxy(function(){a?(da.ie&&g[0].style.removeAttribute("filter"),g.css("overflow",""),"string"==typeof l.autofocus&&d(this.options.show.autofocus,g).focus(),this.options.show.target.trigger("qtip-"+this.id+"-inactive")):g.css({display:"",visibility:"",opacity:"",left:"",top:""}),this._trigger(a?"visible":"hidden")},this),l.effect===E||q===E?(g[k](),j()):d.isFunction(l.effect)?(g.stop(1,1),l.effect.call(g,this),g.queue("fx",function(a){j(),a()})):g.fadeTo(90,a?1:0,j),a&&l.target.trigger("qtip-"+this.id+"-inactive"),this))},z.show=function(a){return this.toggle(D,a)},z.hide=function(a){return this.toggle(E,a)},z.focus=function(a){if(!this.rendered||this.destroyed)return this;var b=d(W),c=this.tooltip,e=parseInt(c[0].style.zIndex,10),f=y.zindex+b.length;return c.hasClass($)||this._trigger("focus",[f],a)&&(e!==f&&(b.each(function(){this.style.zIndex>e&&(this.style.zIndex=this.style.zIndex-1)}),b.filter("."+$).qtip("blur",a)),c.addClass($)[0].style.zIndex=f),this},z.blur=function(a){return!this.rendered||this.destroyed?this:(this.tooltip.removeClass($),this._trigger("blur",[this.tooltip.css("zIndex")],a),this)},z.disable=function(a){return this.destroyed?this:("toggle"===a?a=!(this.rendered?this.tooltip.hasClass(aa):this.disabled):"boolean"!=typeof a&&(a=D),this.rendered&&this.tooltip.toggleClass(aa,a).attr("aria-disabled",a),this.disabled=!!a,this)},z.enable=function(){return this.disable(E)},z._createButton=function(){var a=this,b=this.elements,c=b.tooltip,e=this.options.content.button,f="string"==typeof e,g=f?e:"Close tooltip";b.button&&b.button.remove(),e.jquery?b.button=e:b.button=d("<a />",{"class":"qtip-close "+(this.options.style.widget?"":S+"-icon"),title:g,"aria-label":g}).prepend(d("<span />",{"class":"ui-icon ui-icon-close",html:"&times;"})),b.button.appendTo(b.titlebar||c).attr("role","button").click(function(b){return c.hasClass(aa)||a.hide(b),E})},z._updateButton=function(a){if(!this.rendered)return E;var b=this.elements.button;a?this._createButton():b.remove()},z._setWidget=function(){var a=this.options.style.widget,b=this.elements,c=b.tooltip,d=c.hasClass(aa);c.removeClass(aa),aa=a?"ui-state-disabled":"qtip-disabled",c.toggleClass(aa,d),c.toggleClass("ui-helper-reset "+k(),a).toggleClass(Z,this.options.style.def&&!a),b.content&&b.content.toggleClass(k("content"),a),b.titlebar&&b.titlebar.toggleClass(k("header"),a),b.button&&b.button.toggleClass(S+"-icon",!a)},z._storeMouse=function(a){return(this.mouse=d.event.fix(a)).type="mousemove",this},z._bind=function(a,b,c,e,f){if(a&&c&&b.length){var g="."+this._id+(e?"-"+e:"");return d(a).bind((b.split?b:b.join(g+" "))+g,d.proxy(c,f||this)),this}},z._unbind=function(a,b){return a&&d(a).unbind("."+this._id+(b?"-"+b:"")),this},z._trigger=function(a,b,c){var e=new d.Event("tooltip"+a);return e.originalEvent=c&&d.extend({},c)||this.cache.event||F,this.triggering=a,this.tooltip.trigger(e,[this].concat(b||[])),this.triggering=E,!e.isDefaultPrevented()},z._bindEvents=function(a,b,c,e,f,g){var h=c.filter(e).add(e.filter(c)),i=[];h.length&&(d.each(b,function(b,c){var e=d.inArray(c,a);e>-1&&i.push(a.splice(e,1)[0])}),i.length&&(this._bind(h,i,function(a){var b=!!this.rendered&&this.tooltip[0].offsetWidth>0;(b?g:f).call(this,a)}),c=c.not(h),e=e.not(h))),this._bind(c,a,f),this._bind(e,b,g)},z._assignInitialEvents=function(a){function b(a){return this.disabled||this.destroyed?E:(this.cache.event=a&&d.event.fix(a),this.cache.target=a&&d(a.target),clearTimeout(this.timers.show),void(this.timers.show=l.call(this,function(){this.render("object"==typeof a||c.show.ready)},c.prerender?0:c.show.delay)))}var c=this.options,e=c.show.target,f=c.hide.target,g=c.show.event?d.trim(""+c.show.event).split(" "):[],h=c.hide.event?d.trim(""+c.hide.event).split(" "):[];this._bind(this.elements.target,["remove","removeqtip"],function(){this.destroy(!0)},"destroy"),/mouse(over|enter)/i.test(c.show.event)&&!/mouse(out|leave)/i.test(c.hide.event)&&h.push("mouseleave"),this._bind(e,"mousemove",function(a){this._storeMouse(a),this.cache.onTarget=D}),this._bindEvents(g,h,e,f,b,function(){return this.timers?void clearTimeout(this.timers.show):E}),(c.show.ready||c.prerender)&&b.call(this,a)},z._assignEvents=function(){var c=this,e=this.options,f=e.position,g=this.tooltip,h=e.show.target,i=e.hide.target,j=f.container,k=f.viewport,l=d(b),q=d(a),r=e.show.event?d.trim(""+e.show.event).split(" "):[],s=e.hide.event?d.trim(""+e.hide.event).split(" "):[];d.each(e.events,function(a,b){c._bind(g,"toggle"===a?["tooltipshow","tooltiphide"]:["tooltip"+a],b,null,g)}),/mouse(out|leave)/i.test(e.hide.event)&&"window"===e.hide.leave&&this._bind(l,["mouseout","blur"],function(a){/select|option/.test(a.target.nodeName)||a.relatedTarget||this.hide(a)}),e.hide.fixed?i=i.add(g.addClass(Y)):/mouse(over|enter)/i.test(e.show.event)&&this._bind(i,"mouseleave",function(){clearTimeout(this.timers.show)}),(""+e.hide.event).indexOf("unfocus")>-1&&this._bind(j.closest("html"),["mousedown","touchstart"],function(a){var b=d(a.target),c=this.rendered&&!this.tooltip.hasClass(aa)&&this.tooltip[0].offsetWidth>0,e=b.parents(W).filter(this.tooltip[0]).length>0;b[0]===this.target[0]||b[0]===this.tooltip[0]||e||this.target.has(b[0]).length||!c||this.hide(a)}),"number"==typeof e.hide.inactive&&(this._bind(h,"qtip-"+this.id+"-inactive",o,"inactive"),this._bind(i.add(g),y.inactiveEvents,o)),this._bindEvents(r,s,h,i,m,n),this._bind(h.add(g),"mousemove",function(a){if("number"==typeof e.hide.distance){var b=this.cache.origin||{},c=this.options.hide.distance,d=Math.abs;(d(a.pageX-b.pageX)>=c||d(a.pageY-b.pageY)>=c)&&this.hide(a)}this._storeMouse(a)}),"mouse"===f.target&&f.adjust.mouse&&(e.hide.event&&this._bind(h,["mouseenter","mouseleave"],function(a){return this.cache?void(this.cache.onTarget="mouseenter"===a.type):E}),this._bind(l,"mousemove",function(a){this.rendered&&this.cache.onTarget&&!this.tooltip.hasClass(aa)&&this.tooltip[0].offsetWidth>0&&this.reposition(a)})),(f.adjust.resize||k.length)&&this._bind(d.event.special.resize?k:q,"resize",p),f.adjust.scroll&&this._bind(q.add(f.container),"scroll",p)},z._unassignEvents=function(){var c=this.options,e=c.show.target,f=c.hide.target,g=d.grep([this.elements.target[0],this.rendered&&this.tooltip[0],c.position.container[0],c.position.viewport[0],c.position.container.closest("html")[0],a,b],function(a){return"object"==typeof a});e&&e.toArray&&(g=g.concat(e.toArray())),f&&f.toArray&&(g=g.concat(f.toArray())),this._unbind(g)._unbind(g,"destroy")._unbind(g,"inactive")},d(function(){q(W,["mouseenter","mouseleave"],function(a){var b="mouseenter"===a.type,c=d(a.currentTarget),e=d(a.relatedTarget||a.target),f=this.options;b?(this.focus(a),c.hasClass(Y)&&!c.hasClass(aa)&&clearTimeout(this.timers.hide)):"mouse"===f.position.target&&f.position.adjust.mouse&&f.hide.event&&f.show.target&&!e.closest(f.show.target[0]).length&&this.hide(a),c.toggleClass(_,b)}),q("["+U+"]",X,o)}),y=d.fn.qtip=function(a,b,e){var f=(""+a).toLowerCase(),g=F,i=d.makeArray(arguments).slice(1),j=i[i.length-1],k=this[0]?d.data(this[0],S):F;return!arguments.length&&k||"api"===f?k:"string"==typeof a?(this.each(function(){var a=d.data(this,S);if(!a)return D;if(j&&j.timeStamp&&(a.cache.event=j),!b||"option"!==f&&"options"!==f)a[f]&&a[f].apply(a,i);else{if(e===c&&!d.isPlainObject(b))return g=a.get(b),E;a.set(b,e)}}),g!==F?g:this):"object"!=typeof a&&arguments.length?void 0:(k=h(d.extend(D,{},a)),this.each(function(a){var b,c;return c=d.isArray(k.id)?k.id[a]:k.id,c=!c||c===E||c.length<1||y.api[c]?y.nextid++:c,b=r(d(this),c,k),b===E?D:(y.api[c]=b,d.each(R,function(){"initialize"===this.initialize&&this(b)}),void b._assignInitialEvents(j))}))},d.qtip=e,y.api={},d.each({attr:function(a,b){if(this.length){var c=this[0],e="title",f=d.data(c,"qtip");if(a===e&&f&&f.options&&"object"==typeof f&&"object"==typeof f.options&&f.options.suppress)return arguments.length<2?d.attr(c,ca):(f&&f.options.content.attr===e&&f.cache.attr&&f.set("content.text",b),this.attr(ca,b))}return d.fn["attr"+ba].apply(this,arguments)},clone:function(a){var b=d.fn["clone"+ba].apply(this,arguments);return a||b.filter("["+ca+"]").attr("title",function(){return d.attr(this,ca)}).removeAttr(ca),b}},function(a,b){if(!b||d.fn[a+ba])return D;var c=d.fn[a+ba]=d.fn[a];d.fn[a]=function(){return b.apply(this,arguments)||c.apply(this,arguments)}}),d.ui||(d["cleanData"+ba]=d.cleanData,d.cleanData=function(a){for(var b,c=0;(b=d(a[c])).length;c++)if(b.attr(T))try{b.triggerHandler("removeqtip")}catch(e){}d["cleanData"+ba].apply(this,arguments)}),y.version="3.0.3-5-g",y.nextid=0,y.inactiveEvents=X,y.zindex=15e3,y.defaults={prerender:E,id:E,overwrite:D,suppress:D,content:{text:D,attr:"title",title:E,button:E},position:{my:"top left",at:"bottom right",target:E,container:E,viewport:E,adjust:{x:0,y:0,mouse:D,scroll:D,resize:D,method:"flipinvert flipinvert"},effect:function(a,b){d(this).animate(b,{duration:200,queue:E})}},show:{target:E,event:"mouseenter",effect:D,delay:90,solo:E,ready:E,autofocus:E},hide:{target:E,event:"mouseleave",effect:D,delay:0,fixed:E,inactive:E,leave:"window",distance:E},style:{classes:"",widget:E,width:E,height:E,def:D},events:{render:F,move:F,show:F,hide:F,toggle:F,visible:F,hidden:F,focus:F,blur:F}};var ha,ia,ja,ka,la,ma="margin",na="border",oa="color",pa="background-color",qa="transparent",ra=" !important",sa=!!b.createElement("canvas").getContext,ta=/rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i,ua={},va=["Webkit","O","Moz","ms"];sa?(ka=a.devicePixelRatio||1,la=function(){var a=b.createElement("canvas").getContext("2d");return a.backingStorePixelRatio||a.webkitBackingStorePixelRatio||a.mozBackingStorePixelRatio||a.msBackingStorePixelRatio||a.oBackingStorePixelRatio||1}(),ja=ka/la):ia=function(a,b,c){return"<qtipvml:"+a+' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" '+(b||"")+' style="behavior: url(#default#VML); '+(c||"")+'" />'},d.extend(v.prototype,{init:function(a){var b,c;c=this.element=a.elements.tip=d("<div />",{"class":S+"-tip"}).prependTo(a.tooltip),sa?(b=d("<canvas />").appendTo(this.element)[0].getContext("2d"),b.lineJoin="miter",b.miterLimit=1e5,b.save()):(b=ia("shape",'coordorigin="0,0"',"position:absolute;"),this.element.html(b+b),a._bind(d("*",c).add(c),["click","mousedown"],function(a){a.stopPropagation()},this._ns)),a._bind(a.tooltip,"tooltipmove",this.reposition,this._ns,this),this.create()},_swapDimensions:function(){this.size[0]=this.options.height,this.size[1]=this.options.width},_resetDimensions:function(){this.size[0]=this.options.width,this.size[1]=this.options.height},_useTitle:function(a){var b=this.qtip.elements.titlebar;return b&&(a.y===K||a.y===O&&this.element.position().top+this.size[1]/2+this.options.offset<b.outerHeight(D))},_parseCorner:function(a){var b=this.qtip.options.position.my;return a===E||b===E?a=E:a===D?a=new A(b.string()):a.string||(a=new A(a),a.fixed=D),a},_parseWidth:function(a,b,c){var d=this.qtip.elements,e=na+s(b)+"Width";return(c?u(c,e):u(d.content,e)||u(this._useTitle(a)&&d.titlebar||d.content,e)||u(d.tooltip,e))||0},_parseRadius:function(a){var b=this.qtip.elements,c=na+s(a.y)+s(a.x)+"Radius";return da.ie<9?0:u(this._useTitle(a)&&b.titlebar||b.content,c)||u(b.tooltip,c)||0},_invalidColour:function(a,b,c){var d=a.css(b);return!d||c&&d===a.css(c)||ta.test(d)?E:d},_parseColours:function(a){var b=this.qtip.elements,c=this.element.css("cssText",""),e=na+s(a[a.precedance])+s(oa),f=this._useTitle(a)&&b.titlebar||b.content,g=this._invalidColour,h=[];return h[0]=g(c,pa)||g(f,pa)||g(b.content,pa)||g(b.tooltip,pa)||c.css(pa),h[1]=g(c,e,oa)||g(f,e,oa)||g(b.content,e,oa)||g(b.tooltip,e,oa)||b.tooltip.css(e),d("*",c).add(c).css("cssText",pa+":"+qa+ra+";"+na+":0"+ra+";"),h},_calculateSize:function(a){var b,c,d,e=a.precedance===H,f=this.options.width,g=this.options.height,h="c"===a.abbrev(),i=(e?f:g)*(h?.5:1),j=Math.pow,k=Math.round,l=Math.sqrt(j(i,2)+j(g,2)),m=[this.border/i*l,this.border/g*l];return m[2]=Math.sqrt(j(m[0],2)-j(this.border,2)),m[3]=Math.sqrt(j(m[1],2)-j(this.border,2)),b=l+m[2]+m[3]+(h?0:m[0]),c=b/l,d=[k(c*f),k(c*g)],e?d:d.reverse()},_calculateTip:function(a,b,c){c=c||1,b=b||this.size;var d=b[0]*c,e=b[1]*c,f=Math.ceil(d/2),g=Math.ceil(e/2),h={br:[0,0,d,e,d,0],bl:[0,0,d,0,0,e],tr:[0,e,d,0,d,e],tl:[0,0,0,e,d,e],tc:[0,e,f,0,d,e],bc:[0,0,d,0,f,e],rc:[0,0,d,g,0,e],lc:[d,0,d,e,0,g]};return h.lt=h.br,h.rt=h.bl,h.lb=h.tr,h.rb=h.tl,h[a.abbrev()]},_drawCoords:function(a,b){a.beginPath(),a.moveTo(b[0],b[1]),a.lineTo(b[2],b[3]),a.lineTo(b[4],b[5]),a.closePath()},create:function(){var a=this.corner=(sa||da.ie)&&this._parseCorner(this.options.corner);return this.enabled=!!this.corner&&"c"!==this.corner.abbrev(),this.enabled&&(this.qtip.cache.corner=a.clone(),this.update()),this.element.toggle(this.enabled),this.corner},update:function(b,c){if(!this.enabled)return this;var e,f,g,h,i,j,k,l,m=this.qtip.elements,n=this.element,o=n.children(),p=this.options,q=this.size,r=p.mimic,s=Math.round;b||(b=this.qtip.cache.corner||this.corner),r===E?r=b:(r=new A(r),r.precedance=b.precedance,"inherit"===r.x?r.x=b.x:"inherit"===r.y?r.y=b.y:r.x===r.y&&(r[b.precedance]=b[b.precedance])),f=r.precedance,b.precedance===G?this._swapDimensions():this._resetDimensions(),e=this.color=this._parseColours(b),e[1]!==qa?(l=this.border=this._parseWidth(b,b[b.precedance]),p.border&&l<1&&!ta.test(e[1])&&(e[0]=e[1]),this.border=l=p.border!==D?p.border:l):this.border=l=0,k=this.size=this._calculateSize(b),n.css({width:k[0],height:k[1],lineHeight:k[1]+"px"}),j=b.precedance===H?[s(r.x===L?l:r.x===N?k[0]-q[0]-l:(k[0]-q[0])/2),s(r.y===K?k[1]-q[1]:0)]:[s(r.x===L?k[0]-q[0]:0),s(r.y===K?l:r.y===M?k[1]-q[1]-l:(k[1]-q[1])/2)],sa?(g=o[0].getContext("2d"),g.restore(),g.save(),g.clearRect(0,0,6e3,6e3),h=this._calculateTip(r,q,ja),i=this._calculateTip(r,this.size,ja),o.attr(I,k[0]*ja).attr(J,k[1]*ja),o.css(I,k[0]).css(J,k[1]),this._drawCoords(g,i),g.fillStyle=e[1],g.fill(),g.translate(j[0]*ja,j[1]*ja),this._drawCoords(g,h),g.fillStyle=e[0],g.fill()):(h=this._calculateTip(r),h="m"+h[0]+","+h[1]+" l"+h[2]+","+h[3]+" "+h[4]+","+h[5]+" xe",j[2]=l&&/^(r|b)/i.test(b.string())?8===da.ie?2:1:0,o.css({coordsize:k[0]+l+" "+k[1]+l,antialias:""+(r.string().indexOf(O)>-1),left:j[0]-j[2]*Number(f===G),top:j[1]-j[2]*Number(f===H),width:k[0]+l,height:k[1]+l}).each(function(a){var b=d(this);b[b.prop?"prop":"attr"]({coordsize:k[0]+l+" "+k[1]+l,path:h,fillcolor:e[0],filled:!!a,stroked:!a}).toggle(!(!l&&!a)),!a&&b.html(ia("stroke",'weight="'+2*l+'px" color="'+e[1]+'" miterlimit="1000" joinstyle="miter"'))})),a.opera&&setTimeout(function(){m.tip.css({display:"inline-block",visibility:"visible"})},1),c!==E&&this.calculate(b,k)},calculate:function(a,b){if(!this.enabled)return E;
var c,e,f=this,g=this.qtip.elements,h=this.element,i=this.options.offset,j={};return a=a||this.corner,c=a.precedance,b=b||this._calculateSize(a),e=[a.x,a.y],c===G&&e.reverse(),d.each(e,function(d,e){var h,k,l;e===O?(h=c===H?L:K,j[h]="50%",j[ma+"-"+h]=-Math.round(b[c===H?0:1]/2)+i):(h=f._parseWidth(a,e,g.tooltip),k=f._parseWidth(a,e,g.content),l=f._parseRadius(a),j[e]=Math.max(-f.border,d?k:i+(l>h?l:-h)))}),j[a[c]]-=b[c===G?0:1],h.css({margin:"",top:"",bottom:"",left:"",right:""}).css(j),j},reposition:function(a,b,d){function e(a,b,c,d,e){a===Q&&j.precedance===b&&k[d]&&j[c]!==O?j.precedance=j.precedance===G?H:G:a!==Q&&k[d]&&(j[b]=j[b]===O?k[d]>0?d:e:j[b]===d?e:d)}function f(a,b,e){j[a]===O?p[ma+"-"+b]=o[a]=g[ma+"-"+b]-k[b]:(h=g[e]!==c?[k[b],-g[b]]:[-k[b],g[b]],(o[a]=Math.max(h[0],h[1]))>h[0]&&(d[b]-=k[b],o[b]=E),p[g[e]!==c?e:b]=o[a])}if(this.enabled){var g,h,i=b.cache,j=this.corner.clone(),k=d.adjusted,l=b.options.position.adjust.method.split(" "),m=l[0],n=l[1]||l[0],o={left:E,top:E,x:0,y:0},p={};this.corner.fixed!==D&&(e(m,G,H,L,N),e(n,H,G,K,M),j.string()===i.corner.string()&&i.cornerTop===k.top&&i.cornerLeft===k.left||this.update(j,E)),g=this.calculate(j),g.right!==c&&(g.left=-g.right),g.bottom!==c&&(g.top=-g.bottom),g.user=this.offset,o.left=m===Q&&!!k.left,o.left&&f(G,L,N),o.top=n===Q&&!!k.top,o.top&&f(H,K,M),this.element.css(p).toggle(!(o.x&&o.y||j.x===O&&o.y||j.y===O&&o.x)),d.left-=g.left.charAt?g.user:m!==Q||o.top||!o.left&&!o.top?g.left+this.border:0,d.top-=g.top.charAt?g.user:n!==Q||o.left||!o.left&&!o.top?g.top+this.border:0,i.cornerLeft=k.left,i.cornerTop=k.top,i.corner=j.clone()}},destroy:function(){this.qtip._unbind(this.qtip.tooltip,this._ns),this.qtip.elements.tip&&this.qtip.elements.tip.find("*").remove().end().remove()}}),ha=R.tip=function(a){return new v(a,a.options.style.tip)},ha.initialize="render",ha.sanitize=function(a){if(a.style&&"tip"in a.style){var b=a.style.tip;"object"!=typeof b&&(b=a.style.tip={corner:b}),/string|boolean/i.test(typeof b.corner)||(b.corner=D)}},B.tip={"^position.my|style.tip.(corner|mimic|border)$":function(){this.create(),this.qtip.reposition()},"^style.tip.(height|width)$":function(a){this.size=[a.width,a.height],this.update(),this.qtip.reposition()},"^content.title|style.(classes|widget)$":function(){this.update()}},d.extend(D,y.defaults,{style:{tip:{corner:D,mimic:E,width:6,height:6,border:D,offset:0}}});var wa,xa,ya="qtip-modal",za="."+ya;xa=function(){function a(a){if(d.expr[":"].focusable)return d.expr[":"].focusable;var b,c,e,f=!isNaN(d.attr(a,"tabindex")),g=a.nodeName&&a.nodeName.toLowerCase();return"area"===g?(b=a.parentNode,c=b.name,!(!a.href||!c||"map"!==b.nodeName.toLowerCase())&&(e=d("img[usemap=#"+c+"]")[0],!!e&&e.is(":visible"))):/input|select|textarea|button|object/.test(g)?!a.disabled:"a"===g?a.href||f:f}function c(a){j.length<1&&a.length?a.not("body").blur():j.first().focus()}function e(a){if(h.is(":visible")){var b,e=d(a.target),g=f.tooltip,i=e.closest(W);b=i.length<1?E:parseInt(i[0].style.zIndex,10)>parseInt(g[0].style.zIndex,10),b||e.closest(W)[0]===g[0]||c(e)}}var f,g,h,i=this,j={};d.extend(i,{init:function(){return h=i.elem=d("<div />",{id:"qtip-overlay",html:"<div></div>",mousedown:function(){return E}}).hide(),d(b.body).bind("focusin"+za,e),d(b).bind("keydown"+za,function(a){f&&f.options.show.modal.escape&&27===a.keyCode&&f.hide(a)}),h.bind("click"+za,function(a){f&&f.options.show.modal.blur&&f.hide(a)}),i},update:function(b){f=b,j=b.options.show.modal.stealfocus!==E?b.tooltip.find("*").filter(function(){return a(this)}):[]},toggle:function(a,e,j){var k=a.tooltip,l=a.options.show.modal,m=l.effect,n=e?"show":"hide",o=h.is(":visible"),p=d(za).filter(":visible:not(:animated)").not(k);return i.update(a),e&&l.stealfocus!==E&&c(d(":focus")),h.toggleClass("blurs",l.blur),e&&h.appendTo(b.body),h.is(":animated")&&o===e&&g!==E||!e&&p.length?i:(h.stop(D,E),d.isFunction(m)?m.call(h,e):m===E?h[n]():h.fadeTo(parseInt(j,10)||90,e?1:0,function(){e||h.hide()}),e||h.queue(function(a){h.css({left:"",top:""}),d(za).length||h.detach(),a()}),g=e,f.destroyed&&(f=F),i)}}),i.init()},xa=new xa,d.extend(w.prototype,{init:function(a){var b=a.tooltip;return this.options.on?(a.elements.overlay=xa.elem,b.addClass(ya).css("z-index",y.modal_zindex+d(za).length),a._bind(b,["tooltipshow","tooltiphide"],function(a,c,e){var f=a.originalEvent;if(a.target===b[0])if(f&&"tooltiphide"===a.type&&/mouse(leave|enter)/.test(f.type)&&d(f.relatedTarget).closest(xa.elem[0]).length)try{a.preventDefault()}catch(g){}else(!f||f&&"tooltipsolo"!==f.type)&&this.toggle(a,"tooltipshow"===a.type,e)},this._ns,this),a._bind(b,"tooltipfocus",function(a,c){if(!a.isDefaultPrevented()&&a.target===b[0]){var e=d(za),f=y.modal_zindex+e.length,g=parseInt(b[0].style.zIndex,10);xa.elem[0].style.zIndex=f-1,e.each(function(){this.style.zIndex>g&&(this.style.zIndex-=1)}),e.filter("."+$).qtip("blur",a.originalEvent),b.addClass($)[0].style.zIndex=f,xa.update(c);try{a.preventDefault()}catch(h){}}},this._ns,this),void a._bind(b,"tooltiphide",function(a){a.target===b[0]&&d(za).filter(":visible").not(b).last().qtip("focus",a)},this._ns,this)):this},toggle:function(a,b,c){return a&&a.isDefaultPrevented()?this:void xa.toggle(this.qtip,!!b,c)},destroy:function(){this.qtip.tooltip.removeClass(ya),this.qtip._unbind(this.qtip.tooltip,this._ns),xa.toggle(this.qtip,E),delete this.qtip.elements.overlay}}),wa=R.modal=function(a){return new w(a,a.options.show.modal)},wa.sanitize=function(a){a.show&&("object"!=typeof a.show.modal?a.show.modal={on:!!a.show.modal}:"undefined"==typeof a.show.modal.on&&(a.show.modal.on=D))},y.modal_zindex=y.zindex-200,wa.initialize="render",B.modal={"^show.modal.(on|blur)$":function(){this.destroy(),this.init(),this.qtip.elems.overlay.toggle(this.qtip.tooltip[0].offsetWidth>0)}},d.extend(D,y.defaults,{show:{modal:{on:E,effect:D,blur:D,stealfocus:D,escape:D}}}),R.viewport=function(c,d,e,f,g,h,i){function j(a,b,c,e,f,g,h,i,j){var k=d[f],s=u[a],t=v[a],w=c===Q,x=s===f?j:s===g?-j:-j/2,y=t===f?i:t===g?-i:-i/2,z=q[f]+r[f]-(n?0:m[f]),A=z-k,B=k+j-(h===I?o:p)-z,C=x-(u.precedance===a||s===u[b]?y:0)-(t===O?i/2:0);return w?(C=(s===f?1:-1)*x,d[f]+=A>0?A:B>0?-B:0,d[f]=Math.max(-m[f]+r[f],k-C,Math.min(Math.max(-m[f]+r[f]+(h===I?o:p),k+C),d[f],"center"===s?k-x:1e9))):(e*=c===P?2:0,A>0&&(s!==f||B>0)?(d[f]-=C+e,l.invert(a,f)):B>0&&(s!==g||A>0)&&(d[f]-=(s===O?-C:C)+e,l.invert(a,g)),d[f]<q[f]&&-d[f]>B&&(d[f]=k,l=u.clone())),d[f]-k}var k,l,m,n,o,p,q,r,s=e.target,t=c.elements.tooltip,u=e.my,v=e.at,w=e.adjust,x=w.method.split(" "),y=x[0],z=x[1]||x[0],A=e.viewport,B=e.container,C={left:0,top:0};return A.jquery&&s[0]!==a&&s[0]!==b.body&&"none"!==w.method?(m=B.offset()||C,n="static"===B.css("position"),k="fixed"===t.css("position"),o=A[0]===a?A.width():A.outerWidth(E),p=A[0]===a?A.height():A.outerHeight(E),q={left:k?0:A.scrollLeft(),top:k?0:A.scrollTop()},r=A.offset()||C,"shift"===y&&"shift"===z||(l=u.clone()),C={left:"none"!==y?j(G,H,y,w.x,L,N,I,f,h):0,top:"none"!==z?j(H,G,z,w.y,K,M,J,g,i):0,my:l}):C},R.polys={polygon:function(a,b){var c,d,e,f={width:0,height:0,position:{top:1e10,right:0,bottom:0,left:1e10},adjustable:E},g=0,h=[],i=1,j=1,k=0,l=0;for(g=a.length;g--;)c=[parseInt(a[--g],10),parseInt(a[g+1],10)],c[0]>f.position.right&&(f.position.right=c[0]),c[0]<f.position.left&&(f.position.left=c[0]),c[1]>f.position.bottom&&(f.position.bottom=c[1]),c[1]<f.position.top&&(f.position.top=c[1]),h.push(c);if(d=f.width=Math.abs(f.position.right-f.position.left),e=f.height=Math.abs(f.position.bottom-f.position.top),"c"===b.abbrev())f.position={left:f.position.left+f.width/2,top:f.position.top+f.height/2};else{for(;d>0&&e>0&&i>0&&j>0;)for(d=Math.floor(d/2),e=Math.floor(e/2),b.x===L?i=d:b.x===N?i=f.width-d:i+=Math.floor(d/2),b.y===K?j=e:b.y===M?j=f.height-e:j+=Math.floor(e/2),g=h.length;g--&&!(h.length<2);)k=h[g][0]-f.position.left,l=h[g][1]-f.position.top,(b.x===L&&k>=i||b.x===N&&k<=i||b.x===O&&(k<i||k>f.width-i)||b.y===K&&l>=j||b.y===M&&l<=j||b.y===O&&(l<j||l>f.height-j))&&h.splice(g,1);f.position={left:h[0][0],top:h[0][1]}}return f},rect:function(a,b,c,d){return{width:Math.abs(c-a),height:Math.abs(d-b),position:{left:Math.min(a,c),top:Math.min(b,d)}}},_angles:{tc:1.5,tr:7/4,tl:5/4,bc:.5,br:.25,bl:.75,rc:2,lc:1,c:0},ellipse:function(a,b,c,d,e){var f=R.polys._angles[e.abbrev()],g=0===f?0:c*Math.cos(f*Math.PI),h=d*Math.sin(f*Math.PI);return{width:2*c-Math.abs(g),height:2*d-Math.abs(h),position:{left:a+g,top:b+h},adjustable:E}},circle:function(a,b,c,d){return R.polys.ellipse(a,b,c,c,d)}},R.svg=function(a,c,e){for(var f,g,h,i,j,k,l,m,n,o=c[0],p=d(o.ownerSVGElement),q=o.ownerDocument,r=(parseInt(c.css("stroke-width"),10)||0)/2;!o.getBBox;)o=o.parentNode;if(!o.getBBox||!o.parentNode)return E;switch(o.nodeName){case"ellipse":case"circle":m=R.polys.ellipse(o.cx.baseVal.value,o.cy.baseVal.value,(o.rx||o.r).baseVal.value+r,(o.ry||o.r).baseVal.value+r,e);break;case"line":case"polygon":case"polyline":for(l=o.points||[{x:o.x1.baseVal.value,y:o.y1.baseVal.value},{x:o.x2.baseVal.value,y:o.y2.baseVal.value}],m=[],k=-1,i=l.numberOfItems||l.length;++k<i;)j=l.getItem?l.getItem(k):l[k],m.push.apply(m,[j.x,j.y]);m=R.polys.polygon(m,e);break;default:m=o.getBBox(),m={width:m.width,height:m.height,position:{left:m.x,top:m.y}}}return n=m.position,p=p[0],p.createSVGPoint&&(g=o.getScreenCTM(),l=p.createSVGPoint(),l.x=n.left,l.y=n.top,h=l.matrixTransform(g),n.left=h.x,n.top=h.y),q!==b&&"mouse"!==a.position.target&&(f=d((q.defaultView||q.parentWindow).frameElement).offset(),f&&(n.left+=f.left,n.top+=f.top)),q=d(q),n.left+=q.scrollLeft(),n.top+=q.scrollTop(),m},R.imagemap=function(a,b,c){b.jquery||(b=d(b));var e,f,g,h,i,j=(b.attr("shape")||"rect").toLowerCase().replace("poly","polygon"),k=d('img[usemap="#'+b.parent("map").attr("name")+'"]'),l=d.trim(b.attr("coords")),m=l.replace(/,$/,"").split(",");if(!k.length)return E;if("polygon"===j)h=R.polys.polygon(m,c);else{if(!R.polys[j])return E;for(g=-1,i=m.length,f=[];++g<i;)f.push(parseInt(m[g],10));h=R.polys[j].apply(this,f.concat(c))}return e=k.offset(),e.left+=Math.ceil((k.outerWidth(E)-k.width())/2),e.top+=Math.ceil((k.outerHeight(E)-k.height())/2),h.position.left+=e.left,h.position.top+=e.top,h};var Aa,Ba='<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';"  style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';d.extend(x.prototype,{_scroll:function(){var b=this.qtip.elements.overlay;b&&(b[0].style.top=d(a).scrollTop()+"px")},init:function(c){var e=c.tooltip;d("select, object").length<1&&(this.bgiframe=c.elements.bgiframe=d(Ba).appendTo(e),c._bind(e,"tooltipmove",this.adjustBGIFrame,this._ns,this)),this.redrawContainer=d("<div/>",{id:S+"-rcontainer"}).appendTo(b.body),c.elements.overlay&&c.elements.overlay.addClass("qtipmodal-ie6fix")&&(c._bind(a,["scroll","resize"],this._scroll,this._ns,this),c._bind(e,["tooltipshow"],this._scroll,this._ns,this)),this.redraw()},adjustBGIFrame:function(){var a,b,c=this.qtip.tooltip,d={height:c.outerHeight(E),width:c.outerWidth(E)},e=this.qtip.plugins.tip,f=this.qtip.elements.tip;b=parseInt(c.css("borderLeftWidth"),10)||0,b={left:-b,top:-b},e&&f&&(a="x"===e.corner.precedance?[I,L]:[J,K],b[a[1]]-=f[a[0]]()),this.bgiframe.css(b).css(d)},redraw:function(){if(this.qtip.rendered<1||this.drawing)return this;var a,b,c,d,e=this.qtip.tooltip,f=this.qtip.options.style,g=this.qtip.options.position.container;return this.qtip.drawing=1,f.height&&e.css(J,f.height),f.width?e.css(I,f.width):(e.css(I,"").appendTo(this.redrawContainer),b=e.width(),b%2<1&&(b+=1),c=e.css("maxWidth")||"",d=e.css("minWidth")||"",a=(c+d).indexOf("%")>-1?g.width()/100:0,c=(c.indexOf("%")>-1?a:1*parseInt(c,10))||b,d=(d.indexOf("%")>-1?a:1*parseInt(d,10))||0,b=c+d?Math.min(Math.max(b,d),c):b,e.css(I,Math.round(b)).appendTo(g)),this.drawing=0,this},destroy:function(){this.bgiframe&&this.bgiframe.remove(),this.qtip._unbind([a,this.qtip.tooltip],this._ns)}}),Aa=R.ie6=function(a){return 6===da.ie?new x(a):E},Aa.initialize="render",B.ie6={"^content|style$":function(){this.redraw()}}})}(window,document);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-statements: [2, 15] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(36), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Q, Enums) {
  var SWAP_PAGE_TIME = 200;
  var fn = {};

  function zoom($el, start, finish) {
    var deferred = Q.defer();
    $el.animate({
      'text-indent': 1
    }, {
      duration: 200,
      easing: 'swing',
      step: function step(now, fx) {
        fx.start = start;
        fx.end = finish;
        $el.css('transform', 'scale(' + now + ', ' + now + ')');
      },
      always: function always() {
        deferred.resolve($el);
      }
    });
    return deferred.promise;
  }

  function rotate($el, start, finish) {
    var deferred = Q.defer();
    $el.animate({
      'text-indent': 1
    }, {
      duration: 150,
      easing: 'swing',
      step: function step(now, fx) {
        fx.start = start;
        fx.end = finish;
        $el.css('transform', 'rotate(' + now + 'deg)');
      },
      always: function always() {
        deferred.resolve($el);
      }
    });
    return deferred.promise;
  } // Note: It is necessary to pass in a success callback because we must
  // remove the old dom node (and controller) in the same tick of the event
  // loop. Waiting for "then" results in a glitchy animation.


  fn.swapPages = function (options) {
    var deferred = Q.defer();
    var $parent = options.$parent;
    var $oldRoot = options.$oldRoot;
    var $newRoot = options.$newRoot;
    var success = options.success;
    var ctx = options.ctx;
    var directionClassName = 'transition-from-right';

    if (options.dir && options.dir === Enums.DIRECTION_BACK) {
      directionClassName = 'transition-from-left';
    }

    $newRoot.addClass(directionClassName);
    $parent.append($newRoot);
    $parent.addClass('animation-container-overflow');
    $newRoot.animate({
      left: '0px',
      top: '0px',
      opacity: 1
    }, SWAP_PAGE_TIME, function () {
      $parent.removeClass('animation-container-overflow');
      $newRoot.removeClass(directionClassName);
      $newRoot.removeAttr('style');
      success.call(ctx);
      deferred.resolve();
    });
    $oldRoot.animate({
      height: $newRoot.height(),
      opacity: 0
    }, SWAP_PAGE_TIME * 0.8);
    return deferred.promise;
  };

  fn.swapBeacons = function (options) {
    var $el = options.$el,
        swap = options.swap,
        ctx = options.ctx;
    return this.implode($el).then(function () {
      swap.call(ctx);
      return $el;
    }).then(this.explode);
  };

  fn.explode = function ($el) {
    return zoom($el, 0, 1); //zoom in
  };

  fn.implode = function ($el) {
    return zoom($el, 1, 0); //zoom out
  };

  fn.radialProgressBar = function (options) {
    var radialProgressBar = options.$el,
        swap = options.swap,
        circles = radialProgressBar.children();
    return rotate(circles, 0, 180).then(function () {
      radialProgressBar.css({
        'clip': 'auto'
      });
    }).then(function () {
      var leftHalf = circles.eq(0);
      swap();
      return rotate(leftHalf, 180, 360);
    }).then(function () {
      //reset values to initial state
      radialProgressBar.css({
        'clip': 'rect(0px, 96px, 96px, 48px)'
      });
      circles.css({
        'transform': 'rotate(0deg)',
        'text-indent': '1px'
      });
    });
  };

  return fn;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(124);

module.exports = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];
    else redefine(target, key, src[key], options);
  } return target;
};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(81);
var Iterators = __webpack_require__(111);
var wellKnownSymbol = __webpack_require__(23);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _findIndex = _interopRequireDefault(__webpack_require__(137));

var _reduce = _interopRequireDefault(__webpack_require__(90));

var _filter = _interopRequireDefault(__webpack_require__(37));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 13] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(36), __webpack_require__(32), __webpack_require__(24), __webpack_require__(56), __webpack_require__(142)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Q, factorUtil, Util, Errors, BaseLoginModel) {
  var _ = Okta._; // Avoid setting interval to same value as keep-alive time (5 seconds) because it
  // caused an occasional issue with network connection lost errors in Safari and IE

  var PUSH_INTERVAL = 4000;
  var Factor = BaseLoginModel.extend({
    extraProperties: true,
    flat: false,
    props: {
      id: 'string',
      factorType: {
        type: 'string',
        values: ['sms', 'call', 'email', 'token', 'token:software:totp', 'token:hotp', 'token:hardware', 'question', 'push', 'u2f', 'password', 'assertion:saml2', 'assertion:oidc', 'claims_provider', 'webauthn']
      },
      provider: {
        type: 'string',
        values: ['OKTA', 'RSA', 'DEL_OATH', 'SYMANTEC', 'GOOGLE', 'YUBICO', 'FIDO', 'CUSTOM', 'GENERIC_SAML', 'GENERIC_OIDC']
      },
      enrollment: {
        type: 'string',
        values: ['OPTIONAL', 'REQUIRED']
      },
      status: {
        type: 'string',
        values: ['NOT_SETUP', 'ACTIVE']
      },
      profile: ['object'],
      vendorName: 'string',
      policy: ['object'],
      profiles: ['object']
    },
    local: {
      'answer': 'string',
      'password': 'string',
      'backupFactor': 'object',
      'showAnswer': 'boolean',
      'rememberDevice': 'boolean',
      'autoPush': ['boolean', true, false]
    },
    derived: {
      isOktaFactor: {
        deps: ['provider'],
        fn: function fn(provider) {
          return provider === 'OKTA';
        }
      },
      factorName: {
        deps: ['provider', 'factorType'],
        fn: factorUtil.getFactorName
      },
      factorLabel: {
        deps: ['provider', 'factorType', 'vendorName'],
        fn: function fn(provider, factorType, vendorName) {
          if (_.contains(['DEL_OATH', 'GENERIC_SAML', 'GENERIC_OIDC', 'CUSTOM'], provider)) {
            return vendorName;
          }

          return factorUtil.getFactorLabel.apply(this, [provider, factorType]);
        }
      },
      factorDescription: {
        deps: ['provider', 'factorType'],
        fn: factorUtil.getFactorDescription
      },
      sortOrder: {
        deps: ['provider', 'factorType'],
        fn: factorUtil.getFactorSortOrder
      },
      iconClassName: {
        deps: ['provider', 'factorType'],
        fn: factorUtil.getFactorIconClassName
      },
      securityQuestion: {
        deps: ['profile', 'factorType'],
        fn: function fn(profile, factorType) {
          if (factorType !== 'question') {
            return null;
          }

          return profile && factorUtil.getSecurityQuestionLabel(profile);
        }
      },
      phoneNumber: {
        deps: ['profile', 'factorType'],
        fn: function fn(profile, factorType) {
          if (_.contains(['sms', 'call'], factorType)) {
            return profile && profile.phoneNumber;
          }

          return null;
        }
      },
      email: {
        deps: ['profile', 'factorType'],
        fn: function fn(profile, factorType) {
          if (factorType === 'email') {
            return profile && profile.email;
          }

          return null;
        }
      },
      deviceName: {
        deps: ['profile', 'factorType'],
        fn: function fn(profile, factorType) {
          if (factorType !== 'push') {
            return null;
          }

          return profile && profile.name;
        }
      },
      enrolled: {
        deps: ['status'],
        fn: function fn(status) {
          return status === 'ACTIVE';
        }
      },
      cardinality: {
        deps: ['policy', 'profiles'],
        fn: function fn(policy, profiles) {
          if (profiles && profiles.length > 0) {
            //assume for now we only get one profile (multiple profiles are not supported yet)
            var profile = profiles[0];
            var enrolled = profile._embedded.enrolledFactors.length;

            var adoption = _.findWhere(profile._embedded.features, {
              type: 'adoption'
            });

            if (adoption && adoption.cardinality) {
              return {
                enrolled: enrolled,
                minimum: adoption.cardinality.min,
                maximum: adoption.cardinality.max
              };
            }

            return false;
          } else if (policy && policy.enrollment) {
            return policy.enrollment;
          } else {
            return false;
          }
        }
      },
      additionalEnrollment: {
        deps: ['cardinality'],
        fn: function fn(cardinality) {
          if (cardinality) {
            return cardinality.enrolled !== 0 && cardinality.enrolled < cardinality.maximum;
          } else {
            return false;
          }
        }
      },
      required: {
        deps: ['enrollment'],
        fn: function fn(enrollment) {
          return enrollment === 'REQUIRED';
        }
      },
      canUseResend: {
        deps: ['provider', 'factorType'],
        fn: function fn(provider, factorType) {
          // Only push, sms and call have resend links.
          return provider === 'OKTA' && _.contains(['push', 'sms', 'call', 'email'], factorType);
        }
      },
      isAnswerRequired: {
        deps: ['factorType'],
        fn: function fn(factorType) {
          return _.contains(['sms', 'call', 'email', 'token', 'token:software:totp', 'question'], factorType);
        }
      },
      isFactorTypeVerification: {
        deps: ['provider', 'id'],
        fn: function fn(provider, id) {
          return provider === undefined && id === undefined;
        }
      }
    },
    parse: function parse(attributes) {
      this.settings = attributes.settings;
      this.appState = attributes.appState; // set the initial value for remember device.

      attributes.rememberDevice = factorUtil.getRememberDeviceValue(this.appState); // Add vendorname for custom totp enroll

      this.setCustomHotpVendorName(attributes);
      return _.omit(attributes, ['settings', 'appState']);
    },
    validate: function validate() {
      if (this.get('isAnswerRequired') && !this.get('answer')) {
        return {
          'answer': Okta.loc('model.validation.field.blank')
        };
      } else if (this.get('factorType') === 'password' && !this.get('password')) {
        return {
          'password': Okta.loc('error.password.required')
        };
      }
    },
    needsPasscode: function needsPasscode() {
      // we don't need passcode for email with magic link flow
      return !(this.options.appState.get('isIdxStateToken') && this.get('factorType') === 'email');
    },
    resend: function resend() {
      this.trigger('form:clear-errors');
      return this.manageTransaction(function (transaction) {
        var firstLink = transaction.data._links.resend[0];
        return transaction.resend(firstLink.name);
      });
    },
    save: function save() {
      var rememberDevice = !!this.get('rememberDevice'); // Set/Remove the remember device cookie based on the remember device input.

      var self = this;
      return this.manageTransaction(function (transaction, setTransaction) {
        var data = {
          rememberDevice: rememberDevice
        };

        if (this.get('factorType') === 'question') {
          data.answer = this.get('answer');
        } else if (this.get('factorType') === 'password') {
          data.password = this.get('password');
        } else if (this.needsPasscode()) {
          data.passCode = this.get('answer');
        }

        if (this.pushFactorHasAutoPush()) {
          data.autoPush = this.get('autoPush');
        }

        var promise; // MFA_REQUIRED, FACTOR_REQUIRED or UNAUTHENTICATED with factors (passwordlessAuth)

        if (transaction.status === 'MFA_REQUIRED' || transaction.status === 'FACTOR_REQUIRED' || this.appState.get('promptForFactorInUnauthenticated')) {
          var factor = this._findFactor(transaction);

          promise = factor.verify(data);
        } // MFA_CHALLENGE/ FACTOR_CHALLENGE
        else if (this.get('canUseResend') && !this.get('answer') && transaction.resend) {
            var firstLink = transaction.data._links.resend[0];
            promise = transaction.resend(firstLink.name);
          } else {
            promise = transaction.verify(data);
          } //the 'save' event here is triggered and used in the BaseLoginController
        //to disable the primary button on the factor form


        this.trigger('save');
        return promise.then(function (trans) {
          var options = {
            'delay': PUSH_INTERVAL,
            'transactionCallBack': function transactionCallBack(transaction) {
              self.options.appState.set('lastAuthResponse', transaction);
            }
          };
          setTransaction(trans); // In Okta verify case we initiate poll.

          if (trans.status === 'MFA_CHALLENGE' && trans.poll || trans.status === 'FACTOR_CHALLENGE' && trans.poll) {
            var deferred = Q.defer();
            var initiatePollTimout = Util.callAfterTimeout(deferred.resolve, PUSH_INTERVAL);
            self.listenToOnce(self.options.appState, 'factorSwitched', function () {
              clearTimeout(initiatePollTimout);
              deferred.reject(new Errors.AuthStopPollInitiationError());
            });
            return deferred.promise.then(function () {
              // Stop listening if factor was not switched before poll.
              self.stopListening(self.options.appState, 'factorSwitched');

              if (self.pushFactorHasAutoPush()) {
                options.autoPush = function () {
                  return self.get('autoPush');
                };

                options.rememberDevice = function () {
                  return self.get('rememberDevice');
                };
              }

              return trans.poll(options).then(function (trans) {
                self.options.appState.set('lastAuthResponse', trans.data);
                setTransaction(trans);
              });
            });
          }
        });
      });
    },
    _findFactor: function _findFactor(transaction) {
      var factor;

      if (transaction.factorTypes) {
        factor = _.findWhere(transaction.factorTypes, {
          factorType: this.get('factorType')
        });
      }

      if (!factor) {
        factor = _.findWhere(transaction.factors, {
          id: this.get('id')
        });
      }

      return factor;
    },
    pushFactorHasAutoPush: function pushFactorHasAutoPush() {
      return this.settings.get('features.autoPush') && this.get('factorType') === 'push';
    },
    setCustomHotpVendorName: function setCustomHotpVendorName(attributes) {
      // If factor is token:hotp and not enrolled, we assume the first profile is the default.
      // If factor is enrolled, we only support one profile to be enrolled, so find that one
      // and display as enrolled profile. We do this by populating profile name in vendorName.
      if (attributes.factorType === 'token:hotp' && attributes.profiles) {
        if (attributes.status === 'NOT_SETUP') {
          attributes.vendorName = attributes.profiles[0].name;
        } else if (attributes.status === 'ACTIVE') {
          var _context;

          var enrolledProfiles = (0, _filter.default)(_context = attributes.profiles).call(_context, function (profile) {
            return profile._embedded.enrolledFactors.length > 0;
          });
          attributes.vendorName = enrolledProfiles[0].name;
        }
      }

      return attributes;
    }
  });
  var Factors = Okta.Collection.extend({
    model: Factor,
    comparator: 'sortOrder',
    // One override necessary here - When Okta Verify OTP and Push are in the list,
    // they are presented in the view as one factor - in the beacon menu,
    // there's only one option (Okta Verify), and we show a form with Push
    // with an inline totp option. What we need to do is to add totp
    // as a "backupFactor" for push
    parse: function parse(factors) {
      // Keep a track of the last used factor, since
      // we need it to determine the default factor.
      this.lastUsedFactor = factors[0];

      var oktaPushFactor = _.findWhere(factors, {
        provider: 'OKTA',
        factorType: 'push'
      });

      var totpFactor;

      if (_.where(factors, {
        factorType: 'push'
      }).length > 1) {
        totpFactor = _.findWhere(factors, {
          factorType: 'token:software:totp'
        });
      } else {
        totpFactor = _.findWhere(factors, {
          provider: 'OKTA',
          factorType: 'token:software:totp'
        });
      }

      if (!oktaPushFactor || !totpFactor) {
        return factors;
      }

      var isTotpFirst = totpFactor === factors[0];
      var parsedFactors = (0, _reduce.default)(_).call(_, factors, function (memo, factor) {
        var isOkta = factor.provider === 'OKTA';
        var isOktaTotp = isOkta && factor.factorType === 'token:software:totp';
        var isOktaPush = isOkta && factor.factorType === 'push';
        var notEnrolled = factor.status !== 'ACTIVE';
        var hideOktaTotp = isOktaTotp && (notEnrolled || oktaPushFactor.status === 'ACTIVE');
        var hideOktaPush = isOktaPush && notEnrolled && totpFactor.status === 'ACTIVE';

        if (hideOktaTotp || hideOktaPush) {
          return memo;
        }

        if (isOktaPush) {
          factor.backupFactor = new Factor(totpFactor, {
            parse: true
          });
        }

        memo.push(factor);
        return memo;
      }, []); // Use push factor instead of TOTP, if TOTP is first in the list
      // (since it is stored as backupFactor for push).

      if (isTotpFirst) {
        this.lastUsedFactor = oktaPushFactor;
      }

      return parsedFactors;
    },
    // Will need to update this to use HAL link to get last used factor:
    // https://oktainc.atlassian.net/browse/OKTA-58380
    // However, current code returns last used factor as first factor in list.
    // Also, will need to add priority - i.e. if they do not have a last used
    // factor, should try Okta Verify, then Okta SMS, etc.
    getDefaultFactor: function getDefaultFactor() {
      var factor = _.pick(this.lastUsedFactor, 'factorType', 'provider');

      return this.findWhere(factor);
    },
    getFirstUnenrolledRequiredFactor: function getFirstUnenrolledRequiredFactor() {
      return this.findWhere({
        required: true,
        enrolled: false
      });
    },
    _getFactorsOfType: function _getFactorsOfType(factorType) {
      return this.where({
        factorType: factorType
      });
    },
    getFactorIndex: function getFactorIndex(factorType, factorId) {
      var _context2;

      return (0, _findIndex.default)(_context2 = this._getFactorsOfType(factorType)).call(_context2, function (factor) {
        return factor.get('id') === factorId;
      });
    },
    hasMultipleFactorsOfSameType: function hasMultipleFactorsOfSameType(factorType) {
      return this._getFactorsOfType(factorType).length > 1;
    },
    getFactorByTypeAndIndex: function getFactorByTypeAndIndex(factorType, factorIndex) {
      return this._getFactorsOfType(factorType)[factorIndex];
    }
  });
  return {
    Model: Factor,
    Collection: Factors
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _setTimeout2 = _interopRequireDefault(__webpack_require__(82));

var _stringify = _interopRequireDefault(__webpack_require__(83));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(36), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Q, Okta) {
  var $ = Okta.$;
  return {
    getUserAgent: function getUserAgent() {
      return navigator.userAgent;
    },
    isAndroid: function isAndroid() {
      return /Android/i.test(this.getUserAgent());
    },
    isMessageFromCorrectSource: function isMessageFromCorrectSource($iframe, event) {
      return event.source === $iframe[0].contentWindow;
    },
    generateDeviceFingerprint: function generateDeviceFingerprint(oktaDomainUrl, element) {
      var userAgent = this.getUserAgent();

      if (!userAgent) {
        return Q.reject('user agent is not defined');
      } else if (isWindowsPhone(userAgent)) {
        return Q.reject('device fingerprint is not supported on Windows phones');
      }

      var deferred = Q.defer();
      var self = this;
      var $iframe;
      var iFrameTimeout;

      function isWindowsPhone(userAgent) {
        return userAgent.match(/windows phone|iemobile|wpdesktop/i);
      }

      function removeIframe() {
        $iframe.off();
        $iframe.remove();
        window.removeEventListener('message', onMessageReceivedFromOkta, false);
      }

      function handleError(reason) {
        removeIframe();
        deferred.reject(reason);
      }

      function onMessageReceivedFromOkta(event) {
        if (!self.isMessageFromCorrectSource($iframe, event)) {
          return;
        } // deviceFingerprint service is available, clear timeout


        clearTimeout(iFrameTimeout);

        if (!event || !event.data || event.origin !== oktaDomainUrl) {
          handleError('no data');
          return;
        }

        try {
          var message = JSON.parse(event.data);

          if (message && message.type === 'FingerprintServiceReady') {
            sendMessageToOkta({
              type: 'GetFingerprint'
            });
          } else if (message && message.type === 'FingerprintAvailable') {
            removeIframe();
            deferred.resolve(message.fingerprint);
          } else {
            handleError('no data');
          }
        } catch (error) {//Ignore any errors since we could get other messages too
        }
      }

      function sendMessageToOkta(message) {
        var win = $iframe[0].contentWindow;

        if (win) {
          win.postMessage((0, _stringify.default)(message), oktaDomainUrl);
        }
      } // Attach listener


      window.addEventListener('message', onMessageReceivedFromOkta, false); // Create and Load devicefingerprint page inside the iframe

      $iframe = $('<iframe>', {
        style: 'display: none;',
        src: oktaDomainUrl + '/auth/services/devicefingerprint'
      });
      element.append($iframe);
      iFrameTimeout = (0, _setTimeout2.default)(function () {
        // If the iFrame does not load, throw an error
        handleError('service not available');
      }, 2000);
      return deferred.promise;
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__(134);
var isObject = __webpack_require__(31);
var has = __webpack_require__(46);
var defineProperty = __webpack_require__(62).f;
var uid = __webpack_require__(165);
var FREEZING = __webpack_require__(353);

var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getAuthenticatorDataForEnroll = getAuthenticatorDataForEnroll;
exports.getAuthenticatorDataForVerification = getAuthenticatorDataForVerification;
exports.getIconClassNameForBeacon = getIconClassNameForBeacon;
exports.removeRequirementsFromError = removeRequirementsFromError;

_Object$defineProperty(exports, "getPasswordComplexityDescriptionForHtmlList", {
  enumerable: true,
  get: function get() {
    return _FactorUtil.getPasswordComplexityDescriptionForHtmlList;
  }
});

var _trim = _interopRequireDefault(__webpack_require__(138));

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(0);

var _FactorUtil = __webpack_require__(32);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 19] */
var getAuthenticatorData = function getAuthenticatorData(authenticator, isVerifyAuthenticator) {
  var _authenticator$relate, _authenticator$relate2;

  var authenticatorType = authenticator.authenticatorType || authenticator.factorType;
  var key = _okta._.isString(authenticatorType) ? authenticatorType.toLowerCase() : '';
  var authenticatorData = {};

  switch (key) {
    case 'email':
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.email.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-email'
      });
      break;

    case 'password':
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.password.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-password'
      });
      break;

    case 'phone':
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? (_authenticator$relate = authenticator.relatesTo) === null || _authenticator$relate === void 0 ? void 0 : (_authenticator$relate2 = _authenticator$relate.profile) === null || _authenticator$relate2 === void 0 ? void 0 : _authenticator$relate2.phoneNumber : (0, _okta.loc)('oie.phone.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-phone'
      });
      break;

    case 'security_question':
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.security.question.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-security-question'
      });
      break;
    // Will get rid of this after fully implementing verify. OKTA-301557

    case 'webauthn':
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.webauthn.description', 'login'),
        iconClassName: 'mfa-webauthn'
      });
      break;

    case 'security_key':
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.webauthn.description', 'login'),
        iconClassName: 'mfa-webauthn'
      });
      break;

    case 'app':
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.okta_verify.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-verify'
      });
      break;
  }

  return authenticatorData;
};

function getAuthenticatorDataForEnroll(authenticator) {
  return getAuthenticatorData(authenticator);
}

function getAuthenticatorDataForVerification(authenticator) {
  return getAuthenticatorData(authenticator, true);
}

function getIconClassNameForBeacon(authenticatorType) {
  return getAuthenticatorData({
    authenticatorType: authenticatorType
  }).iconClassName;
}

function removeRequirementsFromError(errorJSON, policy) {
  var _errorJSON$errorCause;

  var passwordRequirementsAsString = (0, _FactorUtil.getPasswordComplexityDescription)(policy);

  if (((_errorJSON$errorCause = errorJSON.errorCauses) === null || _errorJSON$errorCause === void 0 ? void 0 : _errorJSON$errorCause.length) > 0 && (0, _isArray.default)(errorJSON.errorCauses[0].errorSummary) && errorJSON.errorCauses[0].errorSummary.length > 0) {
    var _context;

    // Remove the [ and ] if they are present followed by requirements string if it is present.
    errorJSON.errorCauses[0].errorSummary = (0, _trim.default)(_context = errorJSON.errorCauses[0].errorSummary[0].replace("".concat(passwordRequirementsAsString), '').replace('[]', '')).call(_context);
  }

  return errorJSON;
}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorUtil = __webpack_require__(185);

var _AuthenticatorEnrollFooter = _interopRequireDefault(__webpack_require__(93));

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('oie.password.enroll.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oform.next', 'login');
  },
  initialize: function initialize() {
    _BaseForm.default.prototype.initialize.apply(this, arguments);

    var policy = this.getPasswordPolicySettings();
    this.displayPasswordPolicy(policy);
  },
  displayPasswordPolicy: function displayPasswordPolicy(policy) {
    if (policy) {
      var rulesList = (0, _AuthenticatorUtil.getPasswordComplexityDescriptionForHtmlList)(policy);
      this.add(_okta.View.extend({
        tagName: 'section',
        template: _runtime.default.template({
          "1": function _(container, depth0, helpers, partials, data) {
            return "<li>" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
          },
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var stack1,
                alias1 = depth0 != null ? depth0 : container.nullContext || {},
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<div class=\"password-authenticator--heading\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "password.complexity.requirements.header"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 45
                },
                "end": {
                  "line": 1,
                  "column": 115
                }
              }
            })) + "</div><ul class=\"password-authenticator--list\">" + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "rulesList") : depth0, {
              "name": "each",
              "hash": {},
              "fn": container.program(1, data, 0),
              "inverse": container.noop,
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 162
                },
                "end": {
                  "line": 1,
                  "column": 207
                }
              }
            })) != null ? stack1 : "") + "</ul>";
          },
          "useData": true
        }),
        getTemplateData: function getTemplateData() {
          return {
            rulesList: rulesList
          };
        },
        attributes: {
          'data-se': 'password-authenticator--rules'
        }
      }), {
        prepend: true,
        selector: '.o-form-fieldset-container'
      });
    }
  },
  triggerAfterError: function triggerAfterError(model, error) {
    var policy = this.getPasswordPolicySettings();
    error.responseJSON = (0, _AuthenticatorUtil.removeRequirementsFromError)(error.responseJSON, policy);
    this.options.appState.trigger('afterError', error);
  },
  getPasswordPolicySettings: function getPasswordPolicySettings() {
    var _relatesToObject$valu;

    // This will be overridden by following scenario since the policies could be different for those.
    // - password reset (`ReEnrollAuthenticatorPasswordView.js`)
    //
    var relatesToObject = this.options.currentViewState.relatesTo;
    return relatesToObject === null || relatesToObject === void 0 ? void 0 : (_relatesToObject$valu = relatesToObject.value) === null || _relatesToObject$valu === void 0 ? void 0 : _relatesToObject$valu.settings;
  },
  getUISchema: function getUISchema() {
    var uiSchemas = _BaseForm.default.prototype.getUISchema.apply(this, arguments);

    return (0, _concat.default)(uiSchemas).call(uiSchemas, [{
      name: 'confirmPassword',
      label: (0, _okta.loc)('oie.password.confirmPasswordLabel', 'login'),
      type: 'password',
      'label-top': true,
      params: {
        showPasswordToggle: true
      }
    }]);
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorEnrollFooter.default,
  createModelClass: function createModelClass() {
    var ModelClass = _BaseView.default.prototype.createModelClass.apply(this, arguments);

    var local = (0, _assign.default)({
      confirmPassword: {
        type: 'string',
        required: true
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local: local,
      validate: function validate() {
        if (this.get('credentials.passcode') !== this.get('confirmPassword') && this.get('credential.value') !== this.get('confirmPassword')) {
          var errors = {
            'confirmPassword': (0, _okta.loc)('password.error.match', 'login')
          };
          return errors;
        } else {
          return null;
        }
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var document = __webpack_require__(11).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(21);


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(148)('keys');
var uid = __webpack_require__(95);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 190 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(11).document;
module.exports = document && document.documentElement;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(14);
var anObject = __webpack_require__(13);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(66)(Function.call, __webpack_require__(69).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var setPrototypeOf = __webpack_require__(192).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(68);
var defined = __webpack_require__(77);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 196 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(68);
var defined = __webpack_require__(77);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(96);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(49);
var hide = __webpack_require__(54);
var Iterators = __webpack_require__(116);
var $iterCreate = __webpack_require__(258);
var setToStringTag = __webpack_require__(114);
var getPrototypeOf = __webpack_require__(101);
var ITERATOR = __webpack_require__(21)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(201);
var defined = __webpack_require__(77);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(14);
var cof = __webpack_require__(76);
var MATCH = __webpack_require__(21)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(21)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(116);
var ITERATOR = __webpack_require__(21)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(34);
var createDesc = __webpack_require__(94);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(130);
var ITERATOR = __webpack_require__(21)('iterator');
var Iterators = __webpack_require__(116);
module.exports = __webpack_require__(30).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(44);
var toAbsoluteIndex = __webpack_require__(98);
var toLength = __webpack_require__(25);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(102);
var step = __webpack_require__(263);
var Iterators = __webpack_require__(116);
var toIObject = __webpack_require__(55);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(199)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(153);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(198)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(66);
var invoke = __webpack_require__(252);
var html = __webpack_require__(191);
var cel = __webpack_require__(187);
var global = __webpack_require__(11);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(76)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(33);
var LIBRARY = __webpack_require__(96);
var $typed = __webpack_require__(159);
var hide = __webpack_require__(54);
var redefineAll = __webpack_require__(119);
var fails = __webpack_require__(12);
var anInstance = __webpack_require__(118);
var toInteger = __webpack_require__(68);
var toLength = __webpack_require__(25);
var toIndex = __webpack_require__(271);
var gOPN = __webpack_require__(100).f;
var dP = __webpack_require__(34).f;
var arrayFill = __webpack_require__(206);
var setToStringTag = __webpack_require__(114);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(277)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = {"version":"4.4.4","supportedLanguages":["en","cs","da","de","el","es","fi","fr","hu","id","in","it","ja","ko","ms","nb","nl-NL","pl","pt-BR","ro","ru","sv","th","tr","uk","vi","zh-CN","zh-TW"]}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _indexOf = _interopRequireDefault(__webpack_require__(45));

var _splice = _interopRequireDefault(__webpack_require__(109));

var _includes = _interopRequireDefault(__webpack_require__(166));

var _isArray = _interopRequireDefault(__webpack_require__(40));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10), __webpack_require__(56), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums, Errors, Util) {
  var util = {};
  var _ = Okta._;

  function hasResponseType(params, type) {
    if (_.isArray(params.responseType)) {
      return _.contains(params.responseType, type);
    } else {
      return type === params.responseType;
    }
  }
  /**
   * Get the tokens in the OIDC/OAUTH flows
   *
   * @param settings - settings model object
   * @param params - {idp: 'xxx'} for social auth
   *                 {sessionToken: 'xxx'} for okta idp
   */


  util.getTokens = function (settings, params, controller) {
    function success(result) {
      settings.callGlobalSuccess(Enums.SUCCESS, result);
    }

    function error(error) {
      // OKTA-104330- Handle error case where user is not assigned to OIDC client
      if (error.errorCode === 'access_denied') {
        controller.model.trigger('error', controller.model, {
          'responseJSON': error
        });
        controller.model.appState.trigger('removeLoading');
      }

      Util.triggerAfterError(controller, new Errors.OAuthError(error.message), settings);
    }

    var authClient = settings.getAuthClient(),
        options = settings.toJSON({
      verbose: true
    }),
        getTokenOptions = {};

    _.extend(getTokenOptions, _.pick(options, 'clientId', 'redirectUri'), _.pick(options.authParams, 'pkce', 'responseType', 'responseMode', 'display', 'scopes', 'state', 'nonce'), params); // Extra Options for Social Idp popup window title and id_token response timeout


    getTokenOptions.popupTitle = Okta.loc('socialauth.popup.title', 'login');
    getTokenOptions.timeout = options.oAuthTimeout;

    _.extend(getTokenOptions, _.pick(options.authParams, 'issuer', 'authorizeUrl')); // Redirect flow - this can be used when logging into an external IDP, or
    // converting the Okta sessionToken to an access_token, id_token, and/or
    // authorization code. Note: The authorization code flow will always redirect.


    if (getTokenOptions.display === 'page' || hasResponseType(getTokenOptions, 'code')) {
      authClient.token.getWithRedirect(getTokenOptions).catch(error);
    } // Default flow if logging in with Okta as the IDP - convert sessionToken to
    // tokens in a hidden iframe. Used in Single Page Apps where the app does
    // not want to redirect away from the page to convert the token.
    else if (getTokenOptions.sessionToken) {
        authClient.token.getWithoutPrompt(getTokenOptions).then(success).catch(error);
      } // Default flow if logging in with an external IDP - opens a popup and
      // gets the token from a postMessage response.
      else {
          authClient.token.getWithPopup(getTokenOptions).then(success).catch(error);
        }
  }; // Parse through the OAuth 'authParams' object to ensure the 'openid' scope is
  // included (if required)


  util.addOrRemoveOpenIdScope = function (authParams) {
    var _context;

    if (!authParams.responseType) {
      return;
    } //  Convert scope into an Array


    var scope = (0, _isArray.default)(authParams.scopes) ? authParams.scopes : authParams.scopes.split(' '); // Remove the 'openid' scope, as it is only required if an 'id_token' is requested

    if ((0, _includes.default)(scope).call(scope, 'openid')) {
      (0, _splice.default)(scope).call(scope, (0, _indexOf.default)(scope).call(scope, 'openid'), 1);
    } // Add the 'openid' scope


    if ((0, _includes.default)(_context = authParams.responseType).call(_context, 'id_token')) {
      scope.push('openid');
    }

    return scope;
  }; // Utility handlers for mapping convenience keys to OAuth params


  util.getResponseType = function (options) {
    var responseType = [];

    if (options.getIdToken !== false) {
      responseType.push('id_token');
    }

    if (options.getAccessToken !== false) {
      responseType.push('token');
    }

    return responseType;
  };

  util.transformShowSignInToGetTokensOptions = function (options) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Override specific OAuth/OIDC values
    if (!options.clientId && !config.clientId) {
      throw new Errors.ConfigError('showSignInToGetTokens() requires a "clientId" property.');
    }

    var renderOptions = {
      clientId: options.clientId,
      redirectUri: options.redirectUri,
      authParams: {
        display: 'page',
        responseType: util.getResponseType(options),
        scopes: options.scope || config.authParams && config.authParams.scopes || ['openid', 'email']
      }
    }; // Ensure the 'openid' scope is provided when an 'id_token' is requested.
    // If the 'openid' scope is present and isn't needed, remove it.

    renderOptions.authParams.scopes = util.addOrRemoveOpenIdScope(renderOptions.authParams);
    return renderOptions;
  };

  return util;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var isObject = __webpack_require__(31);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(59);
var toLength = __webpack_require__(47);
var toAbsoluteIndex = __webpack_require__(163);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(63);
var store = __webpack_require__(280);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(20);

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var userAgent = __webpack_require__(223);

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(72);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__(576);

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(23);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(23);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(107);
var whitespaces = __webpack_require__(170);

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(667);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(292);
var enumBugKeys = __webpack_require__(226);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 231 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(720);

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(275);


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(754);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(770);

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(142), __webpack_require__(237), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, BaseLoginModel, CookieUtil, Enums) {
  var _ = Okta._;
  return BaseLoginModel.extend({
    props: function props() {
      var cookieUsername = CookieUtil.getCookieUsername(),
          properties = this.getUsernameAndRemember(cookieUsername);
      var props = {
        username: {
          type: 'string',
          validate: function validate(value) {
            if (_.isEmpty(value)) {
              return Okta.loc('error.username.required', 'login');
            }
          },
          value: properties.username
        },
        lastUsername: ['string', false, cookieUsername],
        context: ['object', false],
        remember: ['boolean', true, properties.remember],
        multiOptionalFactorEnroll: ['boolean', true]
      };

      if (!(this.settings && this.settings.get('features.passwordlessAuth'))) {
        props.password = {
          type: 'string',
          validate: function validate(value) {
            if (_.isEmpty(value)) {
              return Okta.loc('error.password.required', 'login');
            }
          }
        };
      }

      return props;
    },
    getUsernameAndRemember: function getUsernameAndRemember(cookieUsername) {
      var settingsUsername = this.settings && this.settings.get('username'),
          rememberMeEnabled = this.settings && this.settings.get('features.rememberMe'),
          remember = false,
          username;

      if (settingsUsername) {
        username = settingsUsername;
        remember = rememberMeEnabled && username === cookieUsername;
      } else if (rememberMeEnabled && cookieUsername) {
        // Only respect the cookie if the feature is enabled.
        // Allows us to force prompting when necessary, e.g. SAML ForceAuthn
        username = cookieUsername;
        remember = true;
      }

      return {
        username: username,
        remember: remember
      };
    },
    constructor: function constructor(options) {
      this.settings = options && options.settings;
      this.appState = options && options.appState;
      Okta.Model.apply(this, arguments);
      this.listenTo(this, 'change:username', function (model, username) {
        this.set({
          remember: username === this.get('lastUsername')
        });
      });
    },
    parse: function parse(options) {
      return _.omit(options, ['settings', 'appState']);
    },
    save: function save() {
      var username = this.settings.transformUsername(this.get('username'), Enums.PRIMARY_AUTH),
          remember = this.get('remember'),
          lastUsername = this.get('lastUsername');
      this.setUsernameCookie(username, remember, lastUsername); //the 'save' event here is triggered and used in the BaseLoginController
      //to disable the primary button on the primary auth form

      this.trigger('save');
      this.appState.trigger('loading', true);
      var signInArgs = this.getSignInArgs(username);
      var primaryAuthPromise;

      if (this.appState.get('isUnauthenticated')) {
        var authClient = this.appState.settings.authClient; // bootstrapped with stateToken

        if (this.appState.get('isIdxStateToken')) {
          // if its an idx stateToken, we send the parameter as identifier to login API
          primaryAuthPromise = this.doTransaction(function (transaction) {
            return this.doPrimaryAuth(authClient, signInArgs, transaction.login);
          });
        } else {
          primaryAuthPromise = this.doTransaction(function (transaction) {
            return this.doPrimaryAuth(authClient, signInArgs, transaction.authenticate);
          });
        }
      } else {
        //normal username/password flow without stateToken
        primaryAuthPromise = this.startTransaction(function (authClient) {
          return this.doPrimaryAuth(authClient, signInArgs, (0, _bind.default)(_).call(_, authClient.signIn, authClient));
        });
      }

      return primaryAuthPromise.catch((0, _bind.default)(_).call(_, function () {
        // Specific event handled by the Header for the case where the security image is not
        // enabled and we want to show a spinner. (Triggered only here and handled only by Header).
        this.appState.trigger('removeLoading');
        CookieUtil.removeUsernameCookie();
      }, this)).finally((0, _bind.default)(_).call(_, function () {
        this.appState.trigger('loading', false);
      }, this));
    },
    getSignInArgs: function getSignInArgs(username) {
      var multiOptionalFactorEnroll = this.get('multiOptionalFactorEnroll');
      var signInArgs = {};

      if (!this.settings.get('features.passwordlessAuth')) {
        signInArgs.password = this.get('password');
      } // if its an idx stateToken, we send the parameter as identifier to login API


      if (this.appState.get('isIdxStateToken')) {
        signInArgs.identifier = username;
      } else {
        //only post options param for non-idx flows
        signInArgs.username = username;
        signInArgs.options = {
          warnBeforePasswordExpired: true,
          multiOptionalFactorEnroll: multiOptionalFactorEnroll
        };
      }

      return signInArgs;
    },
    setUsernameCookie: function setUsernameCookie(username, remember, lastUsername) {
      // Do not modify the cookie when feature is disabled, relevant for SAML ForceAuthn prompts
      if (this.settings.get('features.rememberMe')) {
        // Only delete the cookie if its owner says so. This allows other
        // users to log in on a one-off basis.
        if (!remember && lastUsername === username) {
          CookieUtil.removeUsernameCookie();
        } else if (remember) {
          CookieUtil.setUsernameCookie(username);
        }
      }
    },
    doPrimaryAuth: function doPrimaryAuth(authClient, signInArgs, func) {
      var deviceFingerprintEnabled = this.settings.get('features.deviceFingerprinting'),
          typingPatternEnabled = this.settings.get('features.trackTypingPattern'); // Add the custom header for fingerprint, typing pattern if needed, and then remove it afterwards
      // Since we only need to send it for primary auth

      if (deviceFingerprintEnabled) {
        authClient.options.headers['X-Device-Fingerprint'] = this.appState.get('deviceFingerprint');
      }

      if (typingPatternEnabled) {
        authClient.options.headers['X-Typing-Pattern'] = this.appState.get('typingPattern');
      }

      var self = this;
      return func(signInArgs).finally(function () {
        if (deviceFingerprintEnabled) {
          delete authClient.options.headers['X-Device-Fingerprint'];
          self.appState.unset('deviceFingerprint'); //Fingerprint can only be used once
        }

        if (typingPatternEnabled) {
          delete authClient.options.headers['X-Typing-Pattern'];
          self.appState.unset('typingPattern');
        }
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  var Cookie = Okta.internal.util.Cookie;
  var LAST_USERNAME_COOKIE_NAME = 'ln';
  var DAYS_SAVE_REMEMBER = 365;
  var fn = {};

  fn.getCookieUsername = function () {
    return Cookie.getCookie(LAST_USERNAME_COOKIE_NAME);
  };

  fn.setUsernameCookie = function (username) {
    Cookie.setCookie(LAST_USERNAME_COOKIE_NAME, username, {
      expires: DAYS_SAVE_REMEMBER,
      path: '/'
    });
  };

  fn.removeUsernameCookie = function () {
    Cookie.removeCookie(LAST_USERNAME_COOKIE_NAME, {
      path: '/'
    });
  };

  return fn;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity:[2, 9] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  var fn = {};

  fn.getU2fEnrollErrorMessageKeyByCode = function (errorCode) {
    switch (errorCode) {
      default:
      case 1:
        return 'u2f.error.other';

      case 2:
      case 3:
        return 'u2f.error.badRequest';

      case 4:
        return 'u2f.error.unsupported';

      case 5:
        return 'u2f.error.timeout';
    }
  };

  fn.getU2fVerifyErrorMessageKeyByCode = function (errorCode, isOneFactor) {
    switch (errorCode) {
      case 1:
        // OTHER_ERROR
        return isOneFactor ? 'u2f.error.other.oneFactor' : 'u2f.error.other';

      case 2: // BAD_REQUEST

      case 3:
        // CONFIGURATION_UNSUPPORTED
        return isOneFactor ? 'u2f.error.badRequest.oneFactor' : 'u2f.error.badRequest';

      case 4:
        // DEVICE_INELIGIBLE
        return isOneFactor ? 'u2f.error.unsupported.oneFactor' : 'u2f.error.unsupported';

      case 5:
        // TIMEOUT
        return 'u2f.error.timeout';
    }
  };

  fn.getU2fEnrollErrorMessageByCode = function (errorCode) {
    return Okta.loc(fn.getU2fEnrollErrorMessageKeyByCode(errorCode), 'login');
  };

  fn.getU2fVerifyErrorMessageByCode = function (errorCode, isOneFactor) {
    return Okta.loc(fn.getU2fVerifyErrorMessageKeyByCode(errorCode, isOneFactor), 'login');
  };

  fn.getU2fVersion = function () {
    return 'U2F_V2';
  };

  fn.isU2fAvailable = function () {
    return window.hasOwnProperty('u2f');
  };

  return fn;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(32), __webpack_require__(48)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FactorUtil, RouterUtil) {
  var _ = Okta._;
  return Okta.View.extend({
    className: 'scan-instructions clearfix',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"scan-instructions-details-wrapper\"><div class=\"scan-instructions-details\"><p>" + alias4((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "instructions",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 89
            },
            "end": {
              "line": 1,
              "column": 105
            }
          }
        }) : helper)) + "</p></div></div><div class=\"scan-instructions-qrcode-wrapper\"><div class=\"qrcode-wrap\"><img data-se=\"qrcode\" class=\"qrcode-image\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "qrcode") || (depth0 != null ? lookupProperty(depth0, "qrcode") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "qrcode",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 240
            },
            "end": {
              "line": 1,
              "column": 250
            }
          }
        }) : helper)) + "\"><div data-se=\"qrcode-success\" class=\"qrcode-success\"></div><div data-se=\"qrcode-error\" class=\"qrcode-error\"></div></div><a href=\"#\" data-type=\"manual-setup\" data-se=\"manual-setup\" class=\"link manual-setup\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "enroll.totp.cannotScan"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 458
            },
            "end": {
              "line": 1,
              "column": 511
            }
          }
        })) + "</a><a href=\"#\" data-type=\"refresh-qrcode\" data-se=\"refresh-qrcode\" class=\"link refresh-qrcode\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "enroll.totp.refreshBarcode"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 607
            },
            "end": {
              "line": 1,
              "column": 664
            }
          }
        })) + "</a></div>";
      },
      "useData": true
    }),
    events: {
      'click [data-type="manual-setup"]': function clickDataTypeManualSetup(e) {
        var _this = this;

        e.preventDefault();
        var url = RouterUtil.createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'manual');

        if (this.model.get('__factorType__') === 'push') {
          // cancel the poll and navigate to manual setup.
          this.model.doTransaction(function (transaction) {
            return transaction.prev().then(function (trans) {
              var factor = _.findWhere(trans.factors, {
                factorType: 'push',
                provider: 'OKTA'
              });

              return factor.enroll();
            });
          }).then(function () {
            _this.options.appState.trigger('navigate', url);
          });
        } else {
          this.options.appState.trigger('navigate', url);
        }
      },
      'click [data-type="refresh-qrcode"]': function clickDataTypeRefreshQrcode(e) {
        e.preventDefault();
        this.model.trigger('errors:clear');
        var self = this;
        this.model.doTransaction(function (transaction) {
          if (this.appState.get('isWaitingForActivation')) {
            return transaction.poll();
          } else {
            return transaction.activate();
          }
        }).then(function (trans) {
          var res = trans.data;

          if ((res.status === 'MFA_ENROLL_ACTIVATE' || res.status === 'FACTOR_ENROLL_ACTIVATE') && res.factorResult === 'WAITING') {
            // defer the render here to have a lastResponse set in AppState
            // so that we get new QRcode rendered
            _.defer((0, _bind.default)(_).call(_, self.render, self));
          }
        });
      }
    },
    initialize: function initialize() {
      this.listenTo(this.options.appState, 'change:lastAuthResponse', function () {
        if (this.options.appState.get('isMfaEnrollActivate')) {
          this.$el.toggleClass('qrcode-expired', !this.options.appState.get('isWaitingForActivation'));
        } else if (this.options.appState.get('isSuccessResponse')) {
          this.$el.addClass('qrcode-success');
        }
      });
      this.listenTo(this.model, 'error', function () {
        if (this.options.appState.get('isMfaEnrollActivate')) {
          this.$el.toggleClass('qrcode-expired', true);
        }
      });
    },
    getTemplateData: function getTemplateData() {
      var factorName = FactorUtil.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
      var instructions;

      if (this.model.get('__provider__') === 'GOOGLE') {
        instructions = Okta.loc('enroll.totp.setupGoogleAuthApp', 'login', [factorName]);
      } else {
        instructions = Okta.loc('enroll.totp.setupApp', 'login', [factorName]);
      }

      return {
        instructions: instructions,
        qrcode: this.options.appState.get('qrcode')
      };
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(0);

var _HeaderBeacon = _interopRequireDefault(__webpack_require__(241));

var _Animations = _interopRequireDefault(__webpack_require__(177));

var _default = _okta.View.extend({
  HeaderBeacon: _HeaderBeacon.default,
  initialize: function initialize() {
    // add beacon
    this.add(this.HeaderBeacon);
  },
  postRender: function postRender() {
    var _context;

    (0, _okta.$)('#okta-sign-in').removeClass('no-beacon'); // animate beacon

    var selector = '[data-type="beacon-container"]',
        container = (0, _find.default)(_context = this.$el).call(_context, selector);

    _Animations.default.explode(container);
  }
});

exports.default = _default;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var BeaconView = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div data-type=\"beacon-container\" class=\"beacon-container\"><div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div><div class=\"bg-helper auth-beacon auth-beacon-factor " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 230
          },
          "end": {
            "line": 1,
            "column": 243
          }
        }
      }) : helper)) + "\" data-se=\"factor-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div></div >";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    return {
      className: this.getBeaconClassName() || ''
    };
  },
  getBeaconClassName: function getBeaconClassName() {
    return 'undefined-user';
  }
});

module.exports = BeaconView;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(883);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(930);

var iterableToArray = __webpack_require__(931);

var unsupportedIterableToArray = __webpack_require__(339);

var nonIterableSpread = __webpack_require__(932);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(33) && !__webpack_require__(12)(function () {
  return Object.defineProperty(__webpack_require__(187)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(30);
var LIBRARY = __webpack_require__(96);
var wksExt = __webpack_require__(188);
var defineProperty = __webpack_require__(34).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(53);
var toIObject = __webpack_require__(55);
var arrayIndexOf = __webpack_require__(149)(false);
var IE_PROTO = __webpack_require__(189)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34);
var anObject = __webpack_require__(13);
var getKeys = __webpack_require__(97);

module.exports = __webpack_require__(33) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(55);
var gOPN = __webpack_require__(100).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(33);
var getKeys = __webpack_require__(97);
var gOPS = __webpack_require__(150);
var pIE = __webpack_require__(129);
var toObject = __webpack_require__(44);
var IObject = __webpack_require__(128);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(12)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(67);
var isObject = __webpack_require__(14);
var invoke = __webpack_require__(252);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 252 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(11).parseInt;
var $trim = __webpack_require__(115).trim;
var ws = __webpack_require__(193);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(11).parseFloat;
var $trim = __webpack_require__(115).trim;

module.exports = 1 / $parseFloat(__webpack_require__(193) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(76);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(14);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 257 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(99);
var descriptor = __webpack_require__(94);
var setToStringTag = __webpack_require__(114);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(54)(IteratorPrototype, __webpack_require__(21)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(13);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(469);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(67);
var toObject = __webpack_require__(44);
var IObject = __webpack_require__(128);
var toLength = __webpack_require__(25);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(44);
var toAbsoluteIndex = __webpack_require__(98);
var toLength = __webpack_require__(25);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(208);
__webpack_require__(2)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(33) && /./g.flags != 'g') __webpack_require__(34).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(153)
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(96);
var global = __webpack_require__(11);
var ctx = __webpack_require__(66);
var classof = __webpack_require__(130);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(14);
var aFunction = __webpack_require__(67);
var anInstance = __webpack_require__(118);
var forOf = __webpack_require__(156);
var speciesConstructor = __webpack_require__(131);
var task = __webpack_require__(210).set;
var microtask = __webpack_require__(489)();
var newPromiseCapabilityModule = __webpack_require__(267);
var perform = __webpack_require__(490);
var userAgent = __webpack_require__(157);
var promiseResolve = __webpack_require__(268);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(21)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(119)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(114)($Promise, PROMISE);
__webpack_require__(117)(PROMISE);
Wrapper = __webpack_require__(30)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(152)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(67);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var isObject = __webpack_require__(14);
var newPromiseCapability = __webpack_require__(267);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(34).f;
var create = __webpack_require__(99);
var redefineAll = __webpack_require__(119);
var ctx = __webpack_require__(66);
var anInstance = __webpack_require__(118);
var forOf = __webpack_require__(156);
var $iterDefine = __webpack_require__(199);
var step = __webpack_require__(263);
var setSpecies = __webpack_require__(117);
var DESCRIPTORS = __webpack_require__(33);
var fastKey = __webpack_require__(87).fastKey;
var validate = __webpack_require__(103);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(119);
var getWeak = __webpack_require__(87).getWeak;
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(14);
var anInstance = __webpack_require__(118);
var forOf = __webpack_require__(156);
var createArrayMethod = __webpack_require__(71);
var $has = __webpack_require__(53);
var validate = __webpack_require__(103);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(68);
var toLength = __webpack_require__(25);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(100);
var gOPS = __webpack_require__(150);
var anObject = __webpack_require__(13);
var Reflect = __webpack_require__(11).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(25);
var repeat = __webpack_require__(195);
var defined = __webpack_require__(77);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(33);
var getKeys = __webpack_require__(97);
var toIObject = __webpack_require__(55);
var isEnum = __webpack_require__(129).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 276 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(39);
var fails = __webpack_require__(20);
var createElement = __webpack_require__(218);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(20);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var setGlobal = __webpack_require__(569);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(221);

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(578);
var path = __webpack_require__(15);

module.exports = path.Array.isArray;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(579);

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(596);

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var inspectSource = __webpack_require__(286);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(280);

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var createIteratorConstructor = __webpack_require__(288);
var getPrototypeOf = __webpack_require__(168);
var setPrototypeOf = __webpack_require__(294);
var setToStringTag = __webpack_require__(89);
var createNonEnumerableProperty = __webpack_require__(61);
var redefine = __webpack_require__(124);
var wellKnownSymbol = __webpack_require__(23);
var IS_PURE = __webpack_require__(63);
var Iterators = __webpack_require__(111);
var IteratorsCore = __webpack_require__(289);

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(289).IteratorPrototype;
var create = __webpack_require__(135);
var createPropertyDescriptor = __webpack_require__(105);
var setToStringTag = __webpack_require__(89);
var Iterators = __webpack_require__(111);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(168);
var createNonEnumerableProperty = __webpack_require__(61);
var has = __webpack_require__(46);
var wellKnownSymbol = __webpack_require__(23);
var IS_PURE = __webpack_require__(63);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(20);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(39);
var definePropertyModule = __webpack_require__(62);
var anObject = __webpack_require__(43);
var objectKeys = __webpack_require__(136);

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(46);
var toIndexedObject = __webpack_require__(59);
var indexOf = __webpack_require__(219).indexOf;
var hiddenKeys = __webpack_require__(134);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(72);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(43);
var aPossiblePrototype = __webpack_require__(603);

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(614);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var fails = __webpack_require__(20);
var isArray = __webpack_require__(110);
var isObject = __webpack_require__(31);
var toObject = __webpack_require__(52);
var toLength = __webpack_require__(47);
var createProperty = __webpack_require__(121);
var arraySpeciesCreate = __webpack_require__(164);
var arrayMethodHasSpeciesSupport = __webpack_require__(133);
var wellKnownSymbol = __webpack_require__(23);
var V8_VERSION = __webpack_require__(222);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var global = __webpack_require__(22);
var userAgent = __webpack_require__(223);

var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
$({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(657);

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var slice = __webpack_require__(668);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.slice;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.slice) ? slice : own;
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(675);

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(302);
__webpack_require__(139);
__webpack_require__(79);
var WrappedWellKnownSymbolModule = __webpack_require__(173);

module.exports = WrappedWellKnownSymbolModule.f('iterator');


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(677);

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(296);
__webpack_require__(174);
__webpack_require__(305);
__webpack_require__(678);
__webpack_require__(679);
__webpack_require__(680);
__webpack_require__(681);
__webpack_require__(302);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(684);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(307);
__webpack_require__(689);
__webpack_require__(308);
__webpack_require__(309);
var path = __webpack_require__(15);

module.exports = path.Symbol;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var global = __webpack_require__(22);
var getBuiltIn = __webpack_require__(72);
var IS_PURE = __webpack_require__(63);
var DESCRIPTORS = __webpack_require__(39);
var NATIVE_SYMBOL = __webpack_require__(221);
var USE_SYMBOL_AS_UID = __webpack_require__(281);
var fails = __webpack_require__(20);
var has = __webpack_require__(46);
var isArray = __webpack_require__(110);
var isObject = __webpack_require__(31);
var anObject = __webpack_require__(43);
var toObject = __webpack_require__(52);
var toIndexedObject = __webpack_require__(59);
var toPrimitive = __webpack_require__(162);
var createPropertyDescriptor = __webpack_require__(105);
var nativeObjectCreate = __webpack_require__(135);
var objectKeys = __webpack_require__(136);
var getOwnPropertyNamesModule = __webpack_require__(230);
var getOwnPropertyNamesExternal = __webpack_require__(306);
var getOwnPropertySymbolsModule = __webpack_require__(231);
var getOwnPropertyDescriptorModule = __webpack_require__(104);
var definePropertyModule = __webpack_require__(62);
var propertyIsEnumerableModule = __webpack_require__(160);
var createNonEnumerableProperty = __webpack_require__(61);
var redefine = __webpack_require__(124);
var shared = __webpack_require__(220);
var sharedKey = __webpack_require__(167);
var hiddenKeys = __webpack_require__(134);
var uid = __webpack_require__(165);
var wellKnownSymbol = __webpack_require__(23);
var wrappedWellKnownSymbolModule = __webpack_require__(173);
var defineWellKnownSymbol = __webpack_require__(35);
var setToStringTag = __webpack_require__(89);
var InternalStateModule = __webpack_require__(80);
var $forEach = __webpack_require__(73).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(59);
var nativeGetOwnPropertyNames = __webpack_require__(230).f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.toStringTag` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var setToStringTag = __webpack_require__(89);

// Math[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var setToStringTag = __webpack_require__(89);

// JSON[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(691);
var path = __webpack_require__(15);

var Object = path.Object;

var defineProperty = module.exports = function defineProperty(it, key, desc) {
  return Object.defineProperty(it, key, desc);
};

if (Object.defineProperty.sham) defineProperty.sham = true;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HandlebarsEnvironment = HandlebarsEnvironment;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(74);

var _exception = __webpack_require__(112);

var _exception2 = _interopRequireDefault(_exception);

var _helpers = __webpack_require__(312);

var _decorators = __webpack_require__(699);

var _logger = __webpack_require__(313);

var _logger2 = _interopRequireDefault(_logger);

var _internalProtoAccess = __webpack_require__(314);

var VERSION = '4.7.6';
exports.VERSION = VERSION;
var COMPILER_REVISION = 8;
exports.COMPILER_REVISION = COMPILER_REVISION;
var LAST_COMPATIBLE_COMPILER_REVISION = 7;

exports.LAST_COMPATIBLE_COMPILER_REVISION = LAST_COMPATIBLE_COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1',
  7: '>= 4.0.0 <4.3.0',
  8: '>= 4.3.0'
};

exports.REVISION_CHANGES = REVISION_CHANGES;
var objectType = '[object Object]';

function HandlebarsEnvironment(helpers, partials, decorators) {
  this.helpers = helpers || {};
  this.partials = partials || {};
  this.decorators = decorators || {};

  _helpers.registerDefaultHelpers(this);
  _decorators.registerDefaultDecorators(this);
}

HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,

  logger: _logger2['default'],
  log: _logger2['default'].log,

  registerHelper: function registerHelper(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple helpers');
      }
      _utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function unregisterHelper(name) {
    delete this.helpers[name];
  },

  registerPartial: function registerPartial(name, partial) {
    if (_utils.toString.call(name) === objectType) {
      _utils.extend(this.partials, name);
    } else {
      if (typeof partial === 'undefined') {
        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
      }
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function unregisterPartial(name) {
    delete this.partials[name];
  },

  registerDecorator: function registerDecorator(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple decorators');
      }
      _utils.extend(this.decorators, name);
    } else {
      this.decorators[name] = fn;
    }
  },
  unregisterDecorator: function unregisterDecorator(name) {
    delete this.decorators[name];
  },
  /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */
  resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
    _internalProtoAccess.resetLoggedProperties();
  }
};

var log = _logger2['default'].log;

exports.log = log;
exports.createFrame = _utils.createFrame;
exports.logger = _logger2['default'];


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultHelpers = registerDefaultHelpers;
exports.moveHelperToHooks = moveHelperToHooks;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _helpersBlockHelperMissing = __webpack_require__(692);

var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

var _helpersEach = __webpack_require__(693);

var _helpersEach2 = _interopRequireDefault(_helpersEach);

var _helpersHelperMissing = __webpack_require__(694);

var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

var _helpersIf = __webpack_require__(695);

var _helpersIf2 = _interopRequireDefault(_helpersIf);

var _helpersLog = __webpack_require__(696);

var _helpersLog2 = _interopRequireDefault(_helpersLog);

var _helpersLookup = __webpack_require__(697);

var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

var _helpersWith = __webpack_require__(698);

var _helpersWith2 = _interopRequireDefault(_helpersWith);

function registerDefaultHelpers(instance) {
  _helpersBlockHelperMissing2['default'](instance);
  _helpersEach2['default'](instance);
  _helpersHelperMissing2['default'](instance);
  _helpersIf2['default'](instance);
  _helpersLog2['default'](instance);
  _helpersLookup2['default'](instance);
  _helpersWith2['default'](instance);
}

function moveHelperToHooks(instance, helperName, keepHelper) {
  if (instance.helpers[helperName]) {
    instance.hooks[helperName] = instance.helpers[helperName];
    if (!keepHelper) {
      delete instance.helpers[helperName];
    }
  }
}


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(74);

var logger = {
  methodMap: ['debug', 'info', 'warn', 'error'],
  level: 'info',

  // Maps a given level value to the `methodMap` indexes above.
  lookupLevel: function lookupLevel(level) {
    if (typeof level === 'string') {
      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
      if (levelMap >= 0) {
        level = levelMap;
      } else {
        level = parseInt(level, 10);
      }
    }

    return level;
  },

  // Can be overridden in the host environment
  log: function log(level) {
    level = logger.lookupLevel(level);

    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
      var method = logger.methodMap[level];
      // eslint-disable-next-line no-console
      if (!console[method]) {
        method = 'log';
      }

      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        message[_key - 1] = arguments[_key];
      }

      console[method].apply(console, message); // eslint-disable-line no-console
    }
  }
};

exports['default'] = logger;
module.exports = exports['default'];


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createProtoAccessControl = createProtoAccessControl;
exports.resultIsAllowed = resultIsAllowed;
exports.resetLoggedProperties = resetLoggedProperties;
// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _createNewLookupObject = __webpack_require__(701);

var _logger = __webpack_require__(313);

var logger = _interopRequireWildcard(_logger);

var loggedProperties = Object.create(null);

function createProtoAccessControl(runtimeOptions) {
  var defaultMethodWhiteList = Object.create(null);
  defaultMethodWhiteList['constructor'] = false;
  defaultMethodWhiteList['__defineGetter__'] = false;
  defaultMethodWhiteList['__defineSetter__'] = false;
  defaultMethodWhiteList['__lookupGetter__'] = false;

  var defaultPropertyWhiteList = Object.create(null);
  // eslint-disable-next-line no-proto
  defaultPropertyWhiteList['__proto__'] = false;

  return {
    properties: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
      defaultValue: runtimeOptions.allowProtoPropertiesByDefault
    },
    methods: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
      defaultValue: runtimeOptions.allowProtoMethodsByDefault
    }
  };
}

function resultIsAllowed(result, protoAccessControl, propertyName) {
  if (typeof result === 'function') {
    return checkWhiteList(protoAccessControl.methods, propertyName);
  } else {
    return checkWhiteList(protoAccessControl.properties, propertyName);
  }
}

function checkWhiteList(protoAccessControlForType, propertyName) {
  if (protoAccessControlForType.whitelist[propertyName] !== undefined) {
    return protoAccessControlForType.whitelist[propertyName] === true;
  }
  if (protoAccessControlForType.defaultValue !== undefined) {
    return protoAccessControlForType.defaultValue;
  }
  logUnexpecedPropertyAccessOnce(propertyName);
  return false;
}

function logUnexpecedPropertyAccessOnce(propertyName) {
  if (loggedProperties[propertyName] !== true) {
    loggedProperties[propertyName] = true;
    logger.log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
  }
}

function resetLoggedProperties() {
  Object.keys(loggedProperties).forEach(function (propertyName) {
    delete loggedProperties[propertyName];
  });
}


/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(711);

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _map = _interopRequireDefault(__webpack_require__(41));

var _lastIndexOf = _interopRequireDefault(__webpack_require__(283));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

var _keys = _interopRequireDefault(__webpack_require__(172));

var _bind = _interopRequireDefault(__webpack_require__(7));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(36), __webpack_require__(56), __webpack_require__(75), __webpack_require__(24), __webpack_require__(64), __webpack_require__(318), __webpack_require__(216)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Q, Errors, BrowserFeatures, Util, Logger, IDP, config) {
  var SharedUtil = Okta.internal.util.Util;
  var _ = Okta._;
  var DEFAULT_LANGUAGE = 'en';
  var supportedResponseTypes = ['token', 'id_token', 'code'];
  var ConfigError = Errors.ConfigError;
  var UnsupportedBrowserError = Errors.UnsupportedBrowserError;

  var assetBaseUrlTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "https://global.oktacdn.com/okta-signin-widget/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "version") || (depth0 != null ? lookupProperty(depth0, "version") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "version",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 46
          },
          "end": {
            "line": 1,
            "column": 57
          }
        }
      }) : helper));
    },
    "useData": true
  });

  return Okta.Model.extend({
    authClient: undefined,
    local: {
      'baseUrl': ['string', true],
      'recoveryToken': ['string', false, undefined],
      'stateToken': ['string', false, undefined],
      'username': ['string', false],
      'signOutLink': ['string', false],
      'relayState': ['string', false],
      // Function to transform the username before passing it to the API
      // for Primary Auth, Forgot Password and Unlock Account.
      'transformUsername': ['function', false],
      // CALLBACKS
      'globalSuccessFn': 'function',
      'globalErrorFn': 'function',
      'processCreds': 'function',
      // IMAGES
      'logo': 'string',
      'logoText': ['string', false],
      'helpSupportNumber': 'string',
      // IDX API VERSION
      'apiVersion': ['string', true, '1.0.0'],
      // FEATURES
      'features.router': ['boolean', true, false],
      'features.securityImage': ['boolean', true, false],
      'features.rememberMe': ['boolean', true, true],
      'features.autoPush': ['boolean', true, false],
      'features.smsRecovery': ['boolean', true, false],
      'features.callRecovery': ['boolean', true, false],
      'features.emailRecovery': ['boolean', false, true],
      'features.webauthn': ['boolean', true, false],
      'features.selfServiceUnlock': ['boolean', true, false],
      'features.multiOptionalFactorEnroll': ['boolean', true, false],
      'features.preventBrowserFromSavingOktaPassword': ['boolean', true, true],
      'features.deviceFingerprinting': ['boolean', false, false],
      'features.hideSignOutLinkInMFA': ['boolean', false, false],
      'features.hideBackToSignInForReset': ['boolean', false, false],
      'features.customExpiredPassword': ['boolean', true, false],
      'features.registration': ['boolean', false, false],
      'features.consent': ['boolean', false, false],
      'features.idpDiscovery': ['boolean', false, false],
      'features.passwordlessAuth': ['boolean', false, false],
      'features.showPasswordToggleOnSignInPage': ['boolean', false, false],
      'features.trackTypingPattern': ['boolean', false, false],
      'features.redirectByFormSubmit': ['boolean', false, false],
      'features.useDeviceFingerprintForSecurityImage': ['boolean', false, true],
      'features.hideDefaultTip': ['boolean', false, true],
      'features.showPasswordRequirementsAsHtmlList': ['boolean', false, false],
      // I18N
      'language': ['any', false],
      // Can be a string or a function
      'i18n': ['object', false],
      // ASSETS
      'assets.baseUrl': ['string', false],
      'assets.rewrite': {
        type: 'function',
        value: _.identity
      },
      // OAUTH2
      'clientId': 'string',
      'redirectUri': 'string',
      'oAuthTimeout': ['number', false],
      'authScheme': ['string', false, 'OAUTH2'],
      'authParams.display': {
        type: 'string',
        values: ['none', 'popup', 'page']
      },
      // Note: It shouldn't be necessary to override/pass in this property -
      // it will be set correctly depending on what the value of display is
      // and whether we are using Okta or a social IDP.
      'authParams.responseMode': {
        type: 'string',
        values: ['query', 'fragment', 'form_post', 'okta_post_message']
      },
      // Can either be a string or an array, i.e.
      // - Single value: 'id_token', 'token', or 'code'
      // - Multiple values: ['id_token', 'token']
      'authParams.responseType': ['any', false, 'id_token'],
      'authParams.scopes': ['array', false],
      'authParams.issuer': ['string', false],
      'authParams.authorizeUrl': ['string', false],
      'authParams.state': ['string', false],
      'authParams.nonce': ['string', false],
      // External IdPs
      'idps': ['array', false, []],
      'idpDisplay': {
        type: 'string',
        values: ['PRIMARY', 'SECONDARY'],
        value: 'SECONDARY'
      },
      // HELP LINKS
      'helpLinks.help': 'string',
      'helpLinks.forgotPassword': 'string',
      'helpLinks.unlock': 'string',
      'helpLinks.custom': 'array',
      //Custom Buttons
      'customButtons': ['array', false, []],
      //Registration
      'policyId': 'string',
      'registration.click': 'function',
      'registration.parseSchema': 'function',
      'registration.preSubmit': 'function',
      'registration.postSubmit': 'function',
      //Consent
      'consent.cancel': 'function',
      //IDP Discovery
      'idpDiscovery.requestContext': 'string',
      //Colors
      'colors.brand': 'string',
      //Descriptions
      'brandName': 'string',
      //PIV
      'piv': ['object', false, {}]
    },
    derived: {
      redirectUtilFn: {
        deps: ['features.redirectByFormSubmit'],
        fn: function fn(redirectByFormSubmit) {
          var _context, _context2;

          return redirectByFormSubmit ? (0, _bind.default)(_context = Util.redirectWithFormGet).call(_context, Util) : (0, _bind.default)(_context2 = SharedUtil.redirect).call(_context2, SharedUtil);
        },
        cache: true
      },
      supportedLanguages: {
        deps: ['i18n'],
        fn: function fn(i18n) {
          // Developers can pass in their own languages
          return _.union(config.supportedLanguages, (0, _keys.default)(_).call(_, i18n));
        },
        cache: true
      },
      languageCode: {
        deps: ['language', 'supportedLanguages'],
        fn: function fn(language, supportedLanguages) {
          var userLanguages = BrowserFeatures.getUserLanguages(),
              preferred = _.clone(userLanguages),
              supportedLowerCase = Util.toLower(supportedLanguages),
              expanded; // Any developer defined "language" takes highest priority:
          // As a string, i.e. 'en', 'ja', 'zh-CN'


          if (_.isString(language)) {
            preferred.unshift(language);
          } // As a callback function, which is passed the list of supported
          // languages and detected user languages. This function must return
          // a languageCode, i.e. 'en', 'ja', 'zh-CN'
          else if (_.isFunction(language)) {
              preferred.unshift(language(supportedLanguages, userLanguages));
            } // Add english as the default, and expand to include any language
          // codes that do not include region, dialect, etc.


          preferred.push(DEFAULT_LANGUAGE);
          expanded = Util.toLower(Util.expandLanguages(preferred)); // Perform a case insensitive search - this is necessary in the case
          // of browsers like Safari

          var i, supportedPos;

          for (i = 0; i < expanded.length; i++) {
            supportedPos = (0, _indexOf.default)(supportedLowerCase).call(supportedLowerCase, expanded[i]);

            if (supportedPos > -1) {
              return supportedLanguages[supportedPos];
            }
          }
        }
      },
      oauth2Enabled: {
        deps: ['clientId', 'authScheme', 'authParams.responseType'],
        fn: function fn(clientId, authScheme, responseType) {
          if (!clientId) {
            return false;
          }

          if (authScheme.toLowerCase() !== 'oauth2') {
            return false;
          }

          var responseTypes = _.isArray(responseType) ? responseType : [responseType];
          return _.intersection(responseTypes, supportedResponseTypes).length > 0;
        },
        cache: true
      },
      // Redirect Uri to provide in the oauth API
      oauthRedirectUri: {
        deps: ['redirectUri'],
        fn: function fn(redirectUri) {
          if (redirectUri) {
            return redirectUri;
          }

          var origin = window.location.origin; // IE8

          if (!origin) {
            var href = window.location.href;
            var path = window.location.pathname;

            if (path !== '') {
              origin = href.substring(0, (0, _lastIndexOf.default)(href).call(href, path));
            }
          }

          return encodeURI(origin);
        }
      },
      // Adjusts the idps passed into the widget based on if they get explicit support
      configuredSocialIdps: {
        deps: ['idps'],
        fn: function fn(idps) {
          return (0, _map.default)(_).call(_, idps, function (idpConfig) {
            var idp = _.clone(idpConfig);

            var type = idp.type && idp.type.toLowerCase();

            if (!(type && _.contains(IDP.SUPPORTED_SOCIAL_IDPS, type))) {
              type = 'general-idp';
              idp.text = idp.text || '{ Please provide a text value }';
            }

            idp.className = ['social-auth-button', 'social-auth-' + type + '-button ', idp.className ? idp.className : ''].join(' ');
            idp.dataAttr = 'social-auth-' + type + '-button';
            idp.i18nKey = 'socialauth.' + type + '.label';
            return idp;
          });
        },
        cache: true
      },
      // Can support piv authentication
      hasPivCard: {
        deps: ['piv'],
        fn: function fn(piv) {
          return piv && piv.certAuthUrl;
        },
        cache: true
      },
      // social auth buttons order - 'above'/'below' the primary auth form (boolean)
      socialAuthPositionTop: {
        deps: ['configuredSocialIdps', 'hasPivCard', 'idpDisplay'],
        fn: function fn(configuredSocialIdps, hasPivCard, idpDisplay) {
          return (!_.isEmpty(configuredSocialIdps) || hasPivCard) && idpDisplay.toUpperCase() === 'PRIMARY';
        },
        cache: true
      },
      hasConfiguredButtons: {
        deps: ['configuredSocialIdps', 'customButtons', 'hasPivCard'],
        fn: function fn(configuredSocialIdps, customButtons, hasPivCard) {
          return !_.isEmpty(configuredSocialIdps) || !_.isEmpty(customButtons) || hasPivCard;
        },
        cache: true
      }
    },
    initialize: function initialize(options) {
      if (!options.baseUrl) {
        this.callGlobalError(new ConfigError(Okta.loc('error.required.baseUrl')));
      } else if (options.colors && _.isString(options.colors.brand) && !options.colors.brand.match(/^#[0-9A-Fa-f]{6}$/)) {
        this.callGlobalError(new ConfigError(Okta.loc('error.invalid.colors.brand')));
      } else if (BrowserFeatures.corsIsNotSupported()) {
        this.callGlobalError(new UnsupportedBrowserError(Okta.loc('error.unsupported.cors')));
      }
    },
    setAcceptLanguageHeader: function setAcceptLanguageHeader(authClient) {
      if (authClient && authClient.options && authClient.options.headers) {
        authClient.options.headers['Accept-Language'] = this.get('languageCode');
      }
    },
    setAuthClient: function setAuthClient(authClient) {
      this.setAcceptLanguageHeader(authClient);
      this.authClient = authClient;
    },
    getAuthClient: function getAuthClient() {
      return this.authClient;
    },
    set: function set() {
      try {
        return Okta.Model.prototype.set.apply(this, arguments);
      } catch (e) {
        var message = e.message ? e.message : e;
        this.callGlobalError(new ConfigError(message));
      }
    },
    // Invokes the global success function. This should only be called on a
    // terminal part of the code (i.e. authStatus SUCCESS or after sending
    // a recovery email)
    callGlobalSuccess: function callGlobalSuccess(status, data) {
      // Defer this to ensure that our functions have rendered completely
      // before invoking their function
      var res = _.extend(data, {
        status: status
      });

      _.defer(_.partial(this.get('globalSuccessFn'), res));
    },
    // Invokes the global error function. This should only be called on non
    // recoverable errors (i.e. configuration errors, browser unsupported
    // errors, etc)
    callGlobalError: function callGlobalError(err) {
      // Note: Must use "this.options.globalErrorFn" when they've passed invalid
      // arguments - globalErrorFn will not have been set yet
      var globalErrorFn = this.get('globalErrorFn') || this.options.globalErrorFn;

      if (globalErrorFn) {
        globalErrorFn(err);
      } else {
        // Only throw the error if they have not registered a globalErrorFn
        throw err;
      }
    },
    // Get the username by applying the transform function if it exists.
    transformUsername: function transformUsername(username, operation) {
      var transformFn = this.get('transformUsername');

      if (transformFn && _.isFunction(transformFn)) {
        return transformFn(username, operation);
      }

      return username;
    },
    processCreds: function processCreds(creds) {
      var processCreds = this.get('processCreds');
      return Q.Promise(function (resolve) {
        if (!_.isFunction(processCreds)) {
          resolve();
        } else if (processCreds.length === 2) {
          processCreds(creds, resolve);
        } else {
          processCreds(creds);
          resolve();
        }
      });
    },
    parseSchema: function parseSchema(schema, onSuccess, onFailure) {
      var parseSchema = this.get('registration.parseSchema'); //check for parseSchema callback

      if (_.isFunction(parseSchema)) {
        parseSchema(schema, function (schema) {
          onSuccess(schema);
        }, function (error) {
          error = error || {
            'errorSummary': Okta.loc('registration.default.callbackhook.error')
          };
          error['callback'] = 'parseSchema';
          onFailure(error);
        });
      } else {
        //no callback
        onSuccess(schema);
      }
    },
    preSubmit: function preSubmit(postData, onSuccess, onFailure) {
      var preSubmit = this.get('registration.preSubmit'); //check for preSubmit callback

      if (_.isFunction(preSubmit)) {
        preSubmit(postData, function (postData) {
          onSuccess(postData);
        }, function (error) {
          error = error || {
            'errorSummary': Okta.loc('registration.default.callbackhook.error')
          };
          error['callback'] = 'preSubmit';
          onFailure(error);
        });
      } else {
        //no callback
        onSuccess(postData);
      }
    },
    postSubmit: function postSubmit(response, onSuccess, onFailure) {
      var postSubmit = this.get('registration.postSubmit'); //check for postSubmit callback

      if (_.isFunction(postSubmit)) {
        postSubmit(response, function (response) {
          onSuccess(response);
        }, function (error) {
          error = error || {
            'errorSummary': Okta.loc('registration.default.callbackhook.error')
          };
          error['callback'] = 'postSubmit';
          onFailure(error);
        });
      } else {
        //no callback
        onSuccess(response);
      }
    },
    // Use the parse function to transform config options to the standard
    // settings we currently support. This is a good place to deprecate old
    // option formats.
    parse: function parse(options) {
      // PKCE flow: automatically set responseType to 'code'
      if (options.authParams && options.authParams.pkce) {
        options.authParams.responseType = 'code';
      }

      if (options.authParams && options.authParams.scope) {
        Logger.deprecate('Use "scopes" instead of "scope"');
        options.authParams.scopes = options.authParams.scope;
        delete options.authParams.scope;
      }

      if (options.labels || options.country) {
        Logger.deprecate('Use "i18n" instead of "labels" and "country"');
        var overrides = options.labels || {};

        _.each(options.country, function (val, key) {
          overrides['country.' + key] = val;
        }); // Old behavior is to treat the override as a global override, so we
        // need to add these overrides to each language


        options.i18n = {};

        _.each(config.supportedLanguages, function (language) {
          options.i18n[language] = overrides;
        });

        delete options.labels;
        delete options.country;
      } // Default the assets.baseUrl to the cdn, or remove any trailing slashes


      if (!options.assets) {
        options.assets = {};
      }

      var abu = options.assets.baseUrl;

      if (!abu) {
        options.assets.baseUrl = assetBaseUrlTpl({
          version: config.version
        });
      } else if (abu[abu.length - 1] === '/') {
        options.assets.baseUrl = abu.substring(0, abu.length - 1);
      }

      return options;
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  var SUPPORTED_SOCIAL_IDPS = ['facebook', 'google', 'linkedin', 'microsoft', 'apple'];
  return {
    SUPPORTED_SOCIAL_IDPS: SUPPORTED_SOCIAL_IDPS
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(177), __webpack_require__(726)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Animations, LoadingBeacon) {
  var NO_BEACON_CLS = 'no-beacon';
  var LOADING_BEACON_CLS = 'beacon-small beacon-loading';

  function isLoadingBeacon(beacon) {
    return beacon && beacon.equals(LoadingBeacon);
  }

  function removeBeacon(view) {
    // There are some timing issues with removing beacons (i.e. the case of
    // transitioning from loadingBeacon -> loadingBeacon)
    if (!view.currentBeacon) {
      return;
    }

    view.currentBeacon.remove();
    view.currentBeacon = null;
  }

  function addBeacon(view, NextBeacon, selector, options) {
    view.add(NextBeacon, {
      selector: selector,
      options: options
    });
    view.currentBeacon = view.first();
  }

  function typeOfTransition(currentBeacon, NextBeacon, options) {
    if (!currentBeacon && !NextBeacon) {
      return 'none';
    } // Show Loading beacon


    if (!currentBeacon && options.loading) {
      return 'load';
    } // Swap/Hide Loading beacon


    if (currentBeacon && isLoadingBeacon(currentBeacon)) {
      return NextBeacon ? 'swap' : 'unload';
    }

    if (currentBeacon && currentBeacon.equals(NextBeacon, options)) {
      return 'same';
    }

    if (!currentBeacon && NextBeacon) {
      return 'add';
    }

    if (currentBeacon && !NextBeacon) {
      return 'remove';
    }

    if (currentBeacon instanceof NextBeacon) {
      return 'fade';
    } // If none of the above
    // then we are changing the type of beacon
    // ex. from SecurityBeacon to FactorBeacon


    return 'swap';
  }

  return Okta.View.extend({
    currentBeacon: null,
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<img src=\"" + alias4((helper = (helper = lookupProperty(helpers, "logo") || (depth0 != null ? lookupProperty(depth0, "logo") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "logo",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 67
            },
            "end": {
              "line": 1,
              "column": 75
            }
          }
        }) : helper)) + "\" class=\"auth-org-logo\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "logoText") || (depth0 != null ? lookupProperty(depth0, "logoText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "logoText",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 104
            },
            "end": {
              "line": 1,
              "column": 116
            }
          }
        }) : helper)) + "\">";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"okta-sign-in-header auth-header\">" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "logo") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 45
            },
            "end": {
              "line": 1,
              "column": 125
            }
          }
        })) != null ? stack1 : "") + "<div data-type=\"beacon-container\" class=\"beacon-container\"></div></div><div class=\"auth-content\"><div class=\"auth-content-inner\"></div></div>";
      },
      "useData": true
    }),
    // Attach a 'no-beacon' class if the security image feature
    // is not passed in to prevent the beacon from jumping.
    initialize: function initialize(options) {
      if (!options.settings.get('features.securityImage')) {
        this.$el.addClass(NO_BEACON_CLS); // To show/hide the spinner when there is no security image,
        // listen to the appState's loading/removeLoading events.

        this.listenTo(options.appState, 'loading', this.setLoadingBeacon);
        this.listenTo(options.appState, 'removeLoading', this.removeLoadingBeacon);
      }
    },

    /* eslint complexity: 0 */
    setBeacon: function setBeacon(NextBeacon, options) {
      var selector = '[data-type="beacon-container"]',
          container = this.$(selector),
          transition = typeOfTransition(this.currentBeacon, NextBeacon, options),
          self = this;

      switch (transition) {
        case 'none':
          this.$el.addClass(NO_BEACON_CLS);
          return;

        case 'same':
          return;

        case 'add':
          this.$el.removeClass(NO_BEACON_CLS);
          addBeacon(this, NextBeacon, selector, options);
          return Animations.explode(container);

        case 'remove':
          this.$el.addClass(NO_BEACON_CLS);
          return Animations.implode(container).then(function () {
            removeBeacon(self);
          }).done();
        // TODO: can this be removed if Animations.implode returns standard ES6 Promise?

        case 'fade':
          // Other transitions are performed on the beacon container,
          // but this transition is on the content inside the beacon.
          // For a SecurityBeacon the username change will update the
          // AppState and trigger an transition to a new Becon
          // Since there is no url change this method is not called.
          // For a FactorBeacon a page refresh has occurred
          // so we execute the beacon's own transition method.
          if (!this.currentBeacon.fadeOut) {
            throw new Error('The current beacon is missing the "fadeOut" method');
          }

          options.animate = true;
          return this.currentBeacon.fadeOut().then(function () {
            removeBeacon(self);
            addBeacon(self, NextBeacon, selector, options);
          }).done();
        // TODO: can this be removed if fadeOut returns standard ES6 Promise?

        case 'swap':
          return Animations.swapBeacons({
            $el: container,
            swap: function swap() {
              var isLoading = isLoadingBeacon(self.currentBeacon); // Order of these calls is important for -
              // loader --> security/factor beacon swap.

              removeBeacon(self);

              if (isLoading) {
                container.removeClass(LOADING_BEACON_CLS);
                self.$el.removeClass(NO_BEACON_CLS);
              }

              addBeacon(self, NextBeacon, selector, options);
            }
          }).done();
        // TODO: can this be removed if Animations.swapBeacons returns standard ES6 Promise?

        case 'load':
          // Show the loading beacon. Add a couple of classes
          // before triggering the add beacon code.
          container.addClass(LOADING_BEACON_CLS);
          addBeacon(self, NextBeacon, selector, options);
          return Animations.explode(container);

        case 'unload':
          // Hide the loading beacon.
          return this.removeLoadingBeacon();

        default:
          throw new Error('the "' + transition + '" is not recognized');
      }
    },
    // Show the loading beacon when the security image feature is not enabled.
    setLoadingBeacon: function setLoadingBeacon(isLoading) {
      if (!isLoading || isLoadingBeacon(this.currentBeacon)) {
        return;
      }

      this.setBeacon(LoadingBeacon, {
        loading: true
      });
    },
    // Hide the beacon on primary auth failure. On primary auth success, setBeacon does this job.
    removeLoadingBeacon: function removeLoadingBeacon() {
      var self = this,
          container = this.$('[data-type="beacon-container"]');
      return Animations.implode(container).then(function () {
        removeBeacon(self);
        container.removeClass(LOADING_BEACON_CLS);
      }).done(); // TODO: can this be removed if Animations.implode returns standard ES6 Promise?
    },
    getTemplateData: function getTemplateData() {
      return this.settings.toJSON({
        verbose: true
      });
    },
    getContentEl: function getContentEl() {
      return this.$('.auth-content-inner');
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _regenerator = _interopRequireDefault(__webpack_require__(233));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(321));

var _find = _interopRequireDefault(__webpack_require__(18));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(177)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Animations) {
  var _ = Okta._,
      $ = Okta.$;

  function setBackgroundImage(el, appState) {
    // NOTE: The imgSrc is returned by the server so that every
    // user has a unique image. However new and undefined user states
    // are hard coded into the css and the value returned by the server
    // is ignored.
    var imgSrc = appState.get('securityImage'),
        imgDescription = appState.get('securityImageDescription'),
        isUndefinedUser = appState.get('isUndefinedUser'),
        isNewUser = appState.get('isNewUser'),
        isSecurityImage = !isUndefinedUser && !isNewUser;
    el.css('background-image', '');
    el.removeClass('new-user undefined-user');

    if (isNewUser) {
      el.addClass('new-user');
      return;
    }

    if (isUndefinedUser) {
      el.addClass('undefined-user');
      return;
    }

    if (isSecurityImage) {
      // TODO: Newer versions of qtip will remove aria-describedby on their own when destroy() is called.
      el.removeAttr('aria-describedby');
      (0, _find.default)(el).call(el, '.accessibility-text').text(imgDescription);
      el.css('background-image', 'url(' + _.escape(imgSrc) + ')');
      return;
    }
  }

  function antiPhishingMessage(image, host) {
    $(window).on('resize.securityBeaconQtip', _.debounce(function () {
      if (image.is(':visible')) {
        image.qtip('show');
      }
    }, 300)); // Show the message that the user has not logged in from this device before.

    image.qtip({
      prerender: true,
      content: {
        text: Okta.loc('primaryauth.newUser.tooltip', 'login', [_.escape(host)]),
        button: Okta.loc('primaryauth.newUser.tooltip.close', 'login')
      },
      style: {
        classes: 'okta-security-image-tooltip security-image-qtip qtip-custom qtip-shadow qtip-rounded',
        tip: {
          height: 12,
          width: 16
        }
      },
      position: {
        my: 'top center',
        at: 'center',
        target: $('.auth-beacon-security'),
        adjust: {
          method: 'flip',
          scroll: false,
          resize: true
        },
        effect: false
      },
      hide: {
        event: false,
        fixed: true
      },
      show: {
        event: false,
        delay: 200
      },
      events: {
        move: function move(event, api) {
          if (!api.elements.target.is(':visible')) {
            // Have to hide it immediately, with no effect
            api.set('hide.effect', false);
            api.hide();
            api.set('hide.effect', true);
          }
        }
      }
    });
    image.qtip('toggle', image.is(':visible'));
  }

  function destroyAntiPhishingMessage(image) {
    image.qtip('destroy');
    $(window).off('resize.securityBeaconQtip');
  }

  function updateSecurityImage(_x, _x2, _x3) {
    return _updateSecurityImage.apply(this, arguments);
  }

  function _updateSecurityImage() {
    _updateSecurityImage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee($el, appState, animate) {
      var image, border, hasBorder, hasAntiPhishing, radialProgressBar, host, duration;
      return _regenerator.default.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              image = (0, _find.default)($el).call($el, '.auth-beacon-security'), border = (0, _find.default)($el).call($el, '.js-auth-beacon-border'), hasBorder = !appState.get('isUndefinedUser'), hasAntiPhishing = appState.get('isNewUser'), radialProgressBar = (0, _find.default)($el).call($el, '.radial-progress-bar'), host = appState.get('baseUrl').match(/https?:\/\/(.[^/]+)/)[1], duration = 200;

              if (animate) {
                _context2.next = 5;
                break;
              }

              // Do not animate the security beacon
              // This occurs when initializing the form
              setBackgroundImage(image, appState);
              border.toggleClass('auth-beacon-border', hasBorder);
              return _context2.abrupt("return");

            case 5:
              destroyAntiPhishingMessage(image); // Animate loading the security beacon

              if (hasBorder) {
                _context2.next = 10;
                break;
              }

              // This occurrs when appState username is blank
              // we do not yet know if the user is recognized
              image.fadeOut(duration, function () {
                setBackgroundImage(image, appState);
                border.removeClass('auth-beacon-border');
                image.fadeIn(duration);
              });
              _context2.next = 15;
              break;

            case 10:
              // Animate loading the security beacon with a loading bar for the border
              // This occurrs when the username has been checked against Okta.
              border.removeClass('auth-beacon-border');
              _context2.next = 13;
              return Animations.radialProgressBar({
                $el: radialProgressBar,
                swap: function swap() {
                  image.fadeOut(duration, function () {
                    setBackgroundImage(image, appState);
                    image.fadeIn(duration);
                  });
                }
              });

            case 13:
              border.addClass('auth-beacon-border');

              if (hasAntiPhishing) {
                antiPhishingMessage(image, host);
              }

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee);
    }));
    return _updateSecurityImage.apply(this, arguments);
  }

  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        return "<div class=\"beacon-blank\"><div class=\"radial-progress-bar\"><div class=\"circle left\"></div><div class=\"circle right\"></div></div></div><div aria-live=\"polite\" role=\"img\" class=\"bg-helper auth-beacon auth-beacon-security\" data-se=\"security-beacon\"><span class=\"accessibility-text\"></span><div class=\"okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border\"></div></div>";
      },
      "useData": true
    }),
    className: 'js-security-beacon',
    initialize: function initialize(options) {
      this.update = _.partial(updateSecurityImage, this.$el, options.appState);
      this.listenTo(options.appState, 'change:securityImage', this.update);
      this.listenTo(options.appState, 'loading', function (isLoading) {
        this.$el.toggleClass('beacon-loading', isLoading);
        this.removeAntiPhishingMessage();
      });
      this.options.appState.set('beaconType', 'security');
      this.listenTo(options.appState, 'navigate', this.removeAntiPhishingMessage);
    },
    postRender: function postRender() {
      this.update(false);
    },
    equals: function equals(Beacon) {
      return Beacon && this instanceof Beacon;
    },
    removeAntiPhishingMessage: function removeAntiPhishingMessage() {
      var _context;

      var image = (0, _find.default)(_context = this.$el).call(_context, '.auth-beacon-security');
      image.qtip('destroy');
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var _Promise = __webpack_require__(727);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    _Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new _Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(174);
__webpack_require__(139);
__webpack_require__(79);
__webpack_require__(729);
__webpack_require__(331);
__webpack_require__(733);
var path = __webpack_require__(15);

module.exports = path.Promise;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);

module.exports = global.Promise;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(23);
var Iterators = __webpack_require__(111);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(43);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(23);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(43);
var aFunction = __webpack_require__(60);
var wellKnownSymbol = __webpack_require__(23);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var fails = __webpack_require__(20);
var classof = __webpack_require__(106);
var bind = __webpack_require__(88);
var html = __webpack_require__(293);
var createElement = __webpack_require__(218);
var IS_IOS = __webpack_require__(329);

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof(process) == 'process') {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    !fails(post) &&
    location.protocol !== 'file:'
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__(223);

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(43);
var isObject = __webpack_require__(31);
var newPromiseCapability = __webpack_require__(140);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var aFunction = __webpack_require__(60);
var newPromiseCapabilityModule = __webpack_require__(140);
var perform = __webpack_require__(181);
var iterate = __webpack_require__(91);

// `Promise.allSettled` method
// https://github.com/tc39/proposal-promise-allSettled
$({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (e) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: e };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums) {
  var CAN_REMOVE_BEACON_CLS = 'can-remove-beacon';
  return Okta.View.extend({
    className: 'auth-container main-container',
    id: Enums.WIDGET_CONTAINER_ID,
    attributes: {
      'data-se': 'auth-container'
    },
    initialize: function initialize(options) {
      this.listenTo(options.appState, 'change:beaconType', function (model, type) {
        this.$el.toggleClass(CAN_REMOVE_BEACON_CLS, type === 'security');
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(740);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(745);

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(750);

var iterableToArrayLimit = __webpack_require__(752);

var unsupportedIterableToArray = __webpack_require__(339);

var nonIterableRest = __webpack_require__(761);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(751);

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(753);

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(43);
var getIteratorMethod = __webpack_require__(180);

module.exports = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$from = __webpack_require__(340);

var _sliceInstanceProperty = __webpack_require__(759);

var arrayLikeToArray = __webpack_require__(342);

function _unsupportedIterableToArray(o, minLen) {
  var _context;

  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);

  var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return _Array$from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(756);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(139);
__webpack_require__(757);
var path = __webpack_require__(15);

module.exports = path.Array.from;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(762);

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _parseInt2 = _interopRequireDefault(__webpack_require__(171));

var _concat = _interopRequireDefault(__webpack_require__(16));

/*!
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Enums) {
  var fn = {};

  var template = function template(colors) {
    var _context, _context2;

    return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "\n#okta-sign-in.auth-container .button-primary,\n#okta-sign-in.auth-container .button-primary:active,\n#okta-sign-in.auth-container .button-primary:focus { background: ".concat(colors.brand, "; }\n#okta-sign-in.auth-container .button-primary:hover { background: ")).call(_context2, fn.lighten(colors.brand, 0.05), "; }\n#okta-sign-in.auth-container .button.button-primary.link-button-disabled {\n  background: ")).call(_context, colors.brand, ";\n  opacity: 0.5;\n}\n    ");
  }; // visible for testing


  fn.lighten = function (hex, lum) {
    lum = lum || 0;
    hex = hex.substr(1);
    var newHex = '#';

    for (var i = 0; i < 3; i++) {
      var c = (0, _parseInt2.default)(hex.substr(i * 2, 2), 16);
      c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
      newHex += ('00' + c).substr(c.length);
    }

    return newHex;
  };

  fn.addStyle = function (colors) {
    var css = template(colors);
    var main = document.getElementById(Enums.WIDGET_CONTAINER_ID);
    var style = document.createElement('style');
    style.id = Enums.WIDGET_CONFIG_COLORS_ID;
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    main.appendChild(style);
  };

  fn.isLoaded = function () {
    return !!document.getElementById(Enums.WIDGET_CONFIG_COLORS_ID);
  };

  return fn;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(346), __webpack_require__(347), __webpack_require__(774), __webpack_require__(236), __webpack_require__(348), __webpack_require__(126), __webpack_require__(64), __webpack_require__(183)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, PrimaryAuthForm, CustomButtons, FooterRegistration, PrimaryAuthModel, Footer, BaseLoginController, Logger, DeviceFingerprint) {
  var $ = Okta.$;
  return BaseLoginController.extend({
    className: 'primary-auth',
    state: {
      enabled: true
    },
    View: PrimaryAuthForm,
    constructor: function constructor(options) {
      options.appState.unset('username');
      this.model = new PrimaryAuthModel({
        multiOptionalFactorEnroll: options.settings.get('features.multiOptionalFactorEnroll'),
        settings: options.settings,
        appState: options.appState
      }, {
        parse: true
      });
      BaseLoginController.apply(this, arguments);
      this.addListeners(); // If social auth is configured, 'socialAuthPositionTop' will determine
      // the order in which the social auth and primary auth are shown on the screen.

      if (options.settings.get('hasConfiguredButtons')) {
        this.add(CustomButtons, {
          prepend: options.settings.get('socialAuthPositionTop'),
          options: {
            // To trigger an afterError event, we require the current controller
            currentController: this
          }
        });
      }

      this.addFooter(options);
      this.setUsername();
    },
    addFooter: function addFooter(options) {
      this.add(new Footer(this.toJSON({
        appState: options.appState
      })));

      if (options.settings.get('features.registration') || options.appState.get('isIdxStateToken')) {
        this.add(new FooterRegistration({
          settings: this.settings,
          appState: options.appState
        }));
      }
    },
    setUsername: function setUsername() {
      var username = this.model.get('username');

      if (username) {
        this.options.appState.set('username', username);
      }
    },
    events: {
      'focusout input[name=username]': function focusoutInputNameUsername() {
        if (this.shouldComputeDeviceFingerprint() && this.model.get('username')) {
          var self = this;
          this.options.appState.trigger('loading', true);
          DeviceFingerprint.generateDeviceFingerprint(this.settings.get('baseUrl'), this.$el).then(function (fingerprint) {
            self.options.appState.set('deviceFingerprint', fingerprint);
            self.options.appState.set('username', self.model.get('username'));
          }).catch(function () {
            // Keep going even if device fingerprint fails
            self.options.appState.set('username', self.model.get('username'));
          }).finally(function () {
            self.options.appState.trigger('loading', false);
          });
        } else {
          this.options.appState.set('username', this.model.get('username'));
        }
      },
      'focusin input': function focusinInput(e) {
        $(e.target.parentElement).addClass('focused-input');
      },
      'focusout input': function focusoutInput(e) {
        $(e.target.parentElement).removeClass('focused-input');
      },

      /**
       * @deprecated
       * This event was originally added for capturing specific usage metrics
       * and is now obsolete.
       */
      'click .button-show': function clickButtonShow() {
        Logger.deprecate('use "passwordRevealed" event is deprecated');
        this.trigger('passwordRevealed');
      }
    },
    // This model and the AppState both have a username property.
    // The controller updates the AppState's username when the user is
    // done editing (on blur) or deletes the username (see below).
    initialize: function initialize() {
      this.options.appState.unset('deviceFingerprint');
      this.listenTo(this.model, 'change:username', function (model, value) {
        if (!value) {
          // reset AppState to an undefined user.
          this.options.appState.set('username', '');
        }
      });
      this.listenTo(this.model, 'save', function () {
        this.state.set('enabled', false);
      });
      this.listenTo(this.model, 'error', function () {
        this.state.set('enabled', true);
      });
      this.listenTo(this.state, 'togglePrimaryAuthButton', function (buttonState) {
        this.toggleButtonState(buttonState);
      });
    },
    shouldComputeDeviceFingerprint: function shouldComputeDeviceFingerprint() {
      return this.settings.get('features.securityImage') && this.settings.get('features.deviceFingerprinting') && this.settings.get('features.useDeviceFingerprintForSecurityImage');
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(26), __webpack_require__(183), __webpack_require__(768), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, TextBox, DeviceFingerprint, TypingUtil, Util) {
  var _ = Okta._;
  return Okta.Form.extend({
    className: 'primary-auth-form',
    noCancelButton: true,
    attributes: {
      'novalidate': 'novalidate'
    },
    save: function save() {
      if (this.settings.get('features.passwordlessAuth')) {
        return Okta.loc('oform.next', 'login');
      }

      return Okta.loc('primaryauth.submit', 'login');
    },
    saveId: 'okta-signin-submit',
    layout: 'o-form-theme',
    // If socialAuth is configured, the title moves from the form to
    // the top of the container (and is rendered in socialAuth).
    title: function title() {
      var formTitle = Okta.loc('primaryauth.title', 'login');

      if (this.settings.get('socialAuthPositionTop')) {
        formTitle = '';
      }

      return formTitle;
    },
    initialize: function initialize() {
      var trackTypingPattern = this.settings.get('features.trackTypingPattern');
      this.listenTo(this, 'save', function () {
        if (trackTypingPattern) {
          var typingPattern = TypingUtil.getTypingPattern();
          this.options.appState.set('typingPattern', typingPattern);
        }

        var self = this;
        var creds = {
          username: this.model.get('username')
        };

        if (!this.settings.get('features.passwordlessAuth')) {
          creds.password = this.model.get('password');
        }

        this.settings.processCreds(creds).then(function () {
          if (!self.settings.get('features.deviceFingerprinting')) {
            return;
          }

          self.options.appState.trigger('loading', true);
          self.state.trigger('togglePrimaryAuthButton', true);
          return DeviceFingerprint.generateDeviceFingerprint(self.settings.get('baseUrl'), self.$el).then(function (fingerprint) {
            self.options.appState.set('deviceFingerprint', fingerprint);
          }).catch(function () {// Keep going even if device fingerprint fails
          }).finally(function () {
            self.options.appState.trigger('loading', false);
            self.state.trigger('togglePrimaryAuthButton', false);
          });
        }).then((0, _bind.default)(_).call(_, this.model.save, this.model));
      });
      this.stateEnableChange();
    },
    stateEnableChange: function stateEnableChange() {
      this.listenTo(this.state, 'change:enabled', function (model, enable) {
        if (enable) {
          this.enable();
        } else {
          this.disable();
        }
      });
    },
    inputs: function inputs() {
      var inputs = [];
      inputs.push(this.getUsernameField());

      if (!this.settings.get('features.passwordlessAuth')) {
        inputs.push(this.getPasswordField());
      }

      if (this.settings.get('features.rememberMe')) {
        inputs.push(this.getRemeberMeCheckbox());
      }

      return inputs;
    },
    getUsernameField: function getUsernameField() {
      var _this = this;

      var userNameFieldObject = {
        className: 'margin-btm-5',
        label: Okta.loc('primaryauth.username.placeholder', 'login'),
        'label-top': true,
        explain: function explain() {
          if (_this.settings.get('features.hideDefaultTip') && !_this.isCustomized('primaryauth.username.tooltip')) {
            return false;
          }

          return Util.createInputExplain('primaryauth.username.tooltip', 'primaryauth.username.placeholder', 'login');
        },
        'explain-top': true,
        name: 'username',
        input: TextBox,
        inputId: 'okta-signin-username',
        type: 'text',
        disabled: this.options.appState.get('disableUsername'),
        // TODO: support a11y attrs in Courage - OKTA-279025
        render: function render() {
          this.$("input[name=".concat(this.options.name, "]")).prop('required', true);
        }
      };
      return userNameFieldObject;
    },
    getPasswordField: function getPasswordField() {
      var _this2 = this;

      var passwordFieldObject = {
        className: 'margin-btm-30',
        label: Okta.loc('primaryauth.password.placeholder', 'login'),
        'label-top': true,
        explain: function explain() {
          if (_this2.settings.get('features.hideDefaultTip') && !_this2.isCustomized('primaryauth.password.tooltip')) {
            return false;
          }

          return Util.createInputExplain('primaryauth.password.tooltip', 'primaryauth.password.placeholder', 'login');
        },
        'explain-top': true,
        name: 'password',
        inputId: 'okta-signin-password',
        validateOnlyIfDirty: true,
        type: 'password',
        // TODO: support a11y attrs in Courage - OKTA-279025
        render: function render() {
          this.$("input[name=".concat(this.options.name, "]")).prop('required', true);
        }
      };

      if (this.settings.get('features.showPasswordToggleOnSignInPage')) {
        passwordFieldObject.params = {};
        passwordFieldObject.params.showPasswordToggle = true;
      }

      return passwordFieldObject;
    },
    isCustomized: function isCustomized(property) {
      var language = this.settings.get('language');
      var i18n = this.settings.get('i18n');
      var customizedProperty = i18n && i18n[language] && i18n[language][property];
      return !!customizedProperty;
    },
    getRemeberMeCheckbox: function getRemeberMeCheckbox() {
      return {
        label: false,
        placeholder: Okta.loc('remember', 'login'),
        name: 'remember',
        type: 'checkbox',
        'label-top': true,
        className: 'margin-btm-0',
        initialize: function initialize() {
          this.listenTo(this.model, 'change:remember', function (model, val) {
            // OKTA-98946: We normally re-render on changes to model values,
            // but in this case we will manually update the checkbox due to
            // iOS Safari and how it handles autofill - it will autofill the
            // form anytime the dom elements are re-rendered, which prevents
            // the user from editing their username.
            this.$(':checkbox').prop('checked', val).trigger('updateState');
          });
        }
      };
    },
    focus: function focus() {
      if (!this.model.get('username')) {
        this.getInputs().first().focus();
      } else if (!this.settings.get('features.passwordlessAuth')) {
        this.getInputs().toArray()[1].focus();
      }

      if (this.settings.get('features.trackTypingPattern')) {
        TypingUtil.track('okta-signin-username');
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _concat = _interopRequireDefault(__webpack_require__(16));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(217)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, OAuth2Util) {
  var _ = Okta._,
      $ = Okta.$,
      SharedUtil = Okta.internal.util.Util;

  var dividerTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"auth-divider\"><span class=\"auth-divider-text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "text",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 66
          }
        }
      }) : helper)) + "</span></div>";
    },
    "useData": true
  });

  var formTitleTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h2 data-se=\"o-form-head\" class=\"okta-form-title o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 62
          },
          "end": {
            "line": 1,
            "column": 71
          }
        }
      }) : helper)) + "</h2>";
    },
    "useData": true
  });

  return Okta.View.extend({
    className: 'primary-auth-container',
    children: function children() {
      var children = [],
          socialIdpButtons = this.settings.get('configuredSocialIdps'),
          pivButton = this.settings.get('piv'),
          customButtons = this.settings.get('customButtons'),
          divider = dividerTpl({
        text: Okta.loc('socialauth.divider.text', 'login')
      });

      if (this.settings.get('hasPivCard')) {
        children.push(this._createPivButton(pivButton));
      }

      _.each(socialIdpButtons, function (button) {
        children.push(this._createSocialIdpButton(button));
      }, this);

      _.each(customButtons, function (button) {
        children.push(this._createCustomButton(button));
      }, this); // If the social auth buttons have to be above the Okta form, the title moves from
      // primary auth form to the social auth (above the buttons) and the divider goes below
      // the buttons (in between social auth and primary auth). If social auth needs to go below
      // Okta form, just add the divider at the top of the social auth container. The title still
      // lives in primary auth form.


      if (this.settings.get('socialAuthPositionTop')) {
        children.unshift(formTitleTpl({
          title: Okta.loc('primaryauth.title', 'login')
        })); // Divider between Primary Auth and the Social Auth

        children.push(divider);
      } else {
        children.unshift(divider);
      }

      return children;
    },
    _createSocialIdpButton: function _createSocialIdpButton(options) {
      return Okta.createButton({
        attributes: {
          'data-se': options.dataAttr
        },
        className: options.className,
        title: function title() {
          return options.text || Okta.loc(options.i18nKey);
        },
        click: function click(e) {
          e.preventDefault();

          if (this.settings.get('oauth2Enabled')) {
            OAuth2Util.getTokens(this.settings, {
              idp: options.id
            }, this.options.currentController);
          } else {
            var _context, _context2;

            var baseUrl = this.settings.get('baseUrl');
            var params = $.param({
              fromURI: this.settings.get('relayState')
            });
            var targetUri = (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(baseUrl, "/sso/idps/")).call(_context2, options.id, "?")).call(_context, params);
            SharedUtil.redirect(targetUri);
          }
        }
      });
    },
    _createPivButton: function _createPivButton(options) {
      var className = options.className || '';
      return Okta.createButton({
        attributes: {
          'data-se': 'piv-card-button'
        },
        className: className + ' piv-button',
        title: options.text || Okta.loc('piv.cac.card', 'login'),
        click: function click(e) {
          e.preventDefault();
          this.options.appState.trigger('navigate', 'signin/verify/piv');
        }
      });
    },
    _createCustomButton: function _createCustomButton(options) {
      return Okta.createButton({
        attributes: {
          'data-se': options.dataAttr
        },
        className: options.className + ' default-custom-button',
        title: options.title,
        click: options.click
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  var Util = Okta.internal.util.Util;
  var _ = Okta._;
  return Okta.View.extend({
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<li><a href=\"#\" data-se=\"unlock\" class=\"link js-unlock\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "unlockaccount"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 440
            },
            "end": {
              "line": 1,
              "column": 484
            }
          }
        })) + "</a></li>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<li><a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "href",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 539
            },
            "end": {
              "line": 1,
              "column": 547
            }
          }
        }) : helper)) + "\" class=\"link js-custom\" rel=\"noopener noreferrer\" " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "target") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(4, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 598
            },
            "end": {
              "line": 1,
              "column": 638
            }
          }
        })) != null ? stack1 : "") + ">" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "text",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 639
            },
            "end": {
              "line": 1,
              "column": 647
            }
          }
        }) : helper)) + "</a></li>";
      },
      "4": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "target=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "target") || (depth0 != null ? lookupProperty(depth0, "target") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "target",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 620
            },
            "end": {
              "line": 1,
              "column": 630
            }
          }
        }) : helper)) + "\"";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" data-se=\"needhelp\" aria-expanded=\"false\" aria-controls=\"help-links-container\" class=\"link help js-help\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "needhelp"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 116
            },
            "end": {
              "line": 1,
              "column": 155
            }
          }
        })) + "</a><ul class=\"help-links js-help-links\" id=\"help-links-container\"><li><a href=\"#\" data-se=\"forgot-password\" class=\"link js-forgot-password\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "forgotpassword"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 296
            },
            "end": {
              "line": 1,
              "column": 341
            }
          }
        })) + "</a></li>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "features") : depth0) != null ? lookupProperty(stack1, "selfServiceUnlock") : stack1, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 350
            },
            "end": {
              "line": 1,
              "column": 500
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "each").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "helpLinks") : depth0) != null ? lookupProperty(stack1, "custom") : stack1, {
          "name": "each",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 500
            },
            "end": {
              "line": 1,
              "column": 665
            }
          }
        })) != null ? stack1 : "") + "<li><a href=\"" + alias3((helper = (helper = lookupProperty(helpers, "helpLinkUrl") || (depth0 != null ? lookupProperty(depth0, "helpLinkUrl") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
          "name": "helpLinkUrl",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 678
            },
            "end": {
              "line": 1,
              "column": 693
            }
          }
        }) : helper)) + "\" data-se=\"help-link\" class=\"link js-help-link\" rel=\"noopener noreferrer\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "help"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 783
            },
            "end": {
              "line": 1,
              "column": 818
            }
          }
        })) + "</a></li></ul>";
      },
      "useData": true
    }),
    className: 'auth-footer',
    initialize: function initialize() {
      this.listenTo(this.state, 'change:enabled', function (model, enable) {
        this.$(':link').toggleClass('o-form-disabled', !enable);
      });
    },
    getTemplateData: function getTemplateData() {
      var helpLinkUrl;
      var customHelpPage = this.settings.get('helpLinks.help');

      if (customHelpPage) {
        helpLinkUrl = customHelpPage;
      } else {
        helpLinkUrl = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var helper,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return container.escapeExpression((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "baseUrl",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 11
                }
              }
            }) : helper)) + "/help/login";
          },
          "useData": true
        })({
          baseUrl: this.settings.get('baseUrl')
        });
      }

      return _.extend(this.settings.toJSON({
        verbose: true
      }), {
        helpLinkUrl: helpLinkUrl
      });
    },
    postRender: function postRender() {
      this.$('.js-help-links').hide();
    },
    toggleLinks: function toggleLinks(e) {
      e.preventDefault();
      this.$('.js-help-links').slideToggle(200, (0, _bind.default)(_).call(_, function () {
        this.$('.js-help').attr('aria-expanded', this.$('.js-help-links').is(':visible'));
      }, this));
    },
    events: {
      'click .js-help': function clickJsHelp(e) {
        e.preventDefault();

        if (!this.state.get('enabled')) {
          return;
        }

        this.toggleLinks(e);
      },
      'click .js-forgot-password': function clickJsForgotPassword(e) {
        e.preventDefault();

        if (!this.state.get('enabled')) {
          return;
        }

        var customResetPasswordPage = this.settings.get('helpLinks.forgotPassword');

        if (customResetPasswordPage) {
          Util.redirect(customResetPasswordPage);
        } else {
          this.options.appState.trigger('navigate', 'signin/forgot-password');
        }
      },
      'click .js-unlock': function clickJsUnlock(e) {
        e.preventDefault();

        if (!this.state.get('enabled')) {
          return;
        }

        var customUnlockPage = this.settings.get('helpLinks.unlock');

        if (customUnlockPage) {
          Util.redirect(customUnlockPage);
        } else {
          this.options.appState.trigger('navigate', 'signin/unlock');
        }
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _endsWith = _interopRequireDefault(__webpack_require__(778));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

/**
 * 
 * This file has been modified to override doPostBack
 * Check out the doPostBack function below for more details.
 * Override the doPostBack function when upgrading.
 * Unable to make a wrapper because it is invoked using an internal name within 
 * this library.
 * 
 * Current Verison = https://github.com/duosecurity/duo_web_sdk/blob/7aec8dd895ea4bd4549069e76076850eccfe07f2/index.js
 * PS: they dont seem to version correctly hence using commit.
 */

/**
 * Duo Web SDK v2
 * Copyright 2019, Duo Security
 */
(function (root, factory) {
  /*eslint-disable */
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    /*eslint-enable */
  } else if ((typeof module === "undefined" ? "undefined" : (0, _typeof2.default)(module)) === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    var Duo = factory(); // If the Javascript was loaded via a script tag, attempt to autoload
    // the frame.

    Duo._onReady(Duo.init); // Attach Duo to the `window` object


    root.Duo = Duo;
  }
})(void 0, function () {
  var DUO_MESSAGE_FORMAT = /^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/;
  var DUO_ERROR_FORMAT = /^ERR\|[\w\s\.\(\)]+$/;
  var DUO_OPEN_WINDOW_FORMAT = /^DUO_OPEN_WINDOW\|/;
  var VALID_OPEN_WINDOW_DOMAINS = ['duo.com', 'duosecurity.com', 'duomobile.s3-us-west-1.amazonaws.com'];
  var postAction, postArgument, host, sigRequest, duoSig, appSig, iframe, submitCallback; // We use this function instead of setting initial values in the var
  // declarations to make sure the initial values and subsequent
  // re-initializations are always the same.

  initializeStatefulVariables();
  /**
   * Set local variables to whatever they should be before you call init().
   */

  function initializeStatefulVariables() {
    postAction = '';
    postArgument = 'sig_response';
    host = undefined;
    sigRequest = undefined;
    duoSig = undefined;
    appSig = undefined;
    iframe = undefined;
    submitCallback = undefined;
  }

  function throwError(message, givenUrl) {
    var url = givenUrl || 'https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe';
    throw new Error('Duo Web SDK error: ' + message + (url ? '\n' + 'See ' + url + ' for more information' : ''));
  }

  function hyphenize(str) {
    return str.replace(/([a-z])([A-Z])/, '$1-$2').toLowerCase();
  } // cross-browser data attributes


  function getDataAttribute(element, name) {
    if ('dataset' in element) {
      return element.dataset[name];
    } else {
      return element.getAttribute('data-' + hyphenize(name));
    }
  } // cross-browser event binding/unbinding


  function on(context, event, fallbackEvent, callback) {
    if ('addEventListener' in window) {
      context.addEventListener(event, callback, false);
    } else {
      context.attachEvent(fallbackEvent, callback);
    }
  }

  function off(context, event, fallbackEvent, callback) {
    if ('removeEventListener' in window) {
      context.removeEventListener(event, callback, false);
    } else {
      context.detachEvent(fallbackEvent, callback);
    }
  }

  function onReady(callback) {
    on(document, 'DOMContentLoaded', 'onreadystatechange', callback);
  }

  function offReady(callback) {
    off(document, 'DOMContentLoaded', 'onreadystatechange', callback);
  }

  function onMessage(callback) {
    on(window, 'message', 'onmessage', callback);
  }

  function offMessage(callback) {
    off(window, 'message', 'onmessage', callback);
  }
  /**
   * Parse the sig_request parameter, throwing errors if the token contains
   * a server error or if the token is invalid.
   *
   * @param {String} sig Request token
   */


  function parseSigRequest(sig) {
    if (!sig) {
      // nothing to do
      return;
    } // see if the token contains an error, throwing it if it does


    if ((0, _indexOf.default)(sig).call(sig, 'ERR|') === 0) {
      throwError(sig.split('|')[1]);
    } // validate the token


    if ((0, _indexOf.default)(sig).call(sig, ':') === -1 || sig.split(':').length !== 2) {
      throwError('Duo was given a bad token.  This might indicate a configuration ' + 'problem with one of Duo\'s client libraries.');
    }

    var sigParts = sig.split(':'); // hang on to the token, and the parsed duo and app sigs

    sigRequest = sig;
    duoSig = sigParts[0];
    appSig = sigParts[1];
    return {
      sigRequest: sig,
      duoSig: sigParts[0],
      appSig: sigParts[1]
    };
  }
  /**
   * Validate that a MessageEvent came from the Duo service, and that it
   * is a properly formatted payload.
   *
   * The Google Chrome sign-in page injects some JS into pages that also
   * make use of postMessage, so we need to do additional validation above
   * and beyond the origin.
   *
   * @param {MessageEvent} event Message received via postMessage
   */


  function isDuoMessage(event) {
    return Boolean(event.origin === 'https://' + host && typeof event.data === 'string' && (event.data.match(DUO_MESSAGE_FORMAT) || event.data.match(DUO_ERROR_FORMAT) || event.data.match(DUO_OPEN_WINDOW_FORMAT)));
  }
  /**
   * Validate the request token and prepare for the iframe to become ready.
   *
   * All options below can be passed into an options hash to `Duo.init`, or
   * specified on the iframe using `data-` attributes.
   *
   * Options specified using the options hash will take precedence over
   * `data-` attributes.
   *
   * Example using options hash:
   * ```javascript
   * Duo.init({
   *     iframe: "some_other_id",
   *     host: "api-main.duo.test",
   *     sig_request: "...",
   *     post_action: "/auth",
   *     post_argument: "resp"
   * });
   * ```
   *
   * Example using `data-` attributes:
   * ```html
   * <iframe id="duo_iframe"
   *         data-host="api-main.duo.test"
   *         data-sig-request="..."
   *         data-post-action="/auth"
   *         data-post-argument="resp"
   *         >
   * </iframe>
   * ```
   *
   * Some browsers (especially embedded browsers) don't like it when the Duo
   * Web SDK changes the `src` attribute on the iframe. To prevent this, there
   * is an alternative way to use the Duo Web SDK:
   *
   * Add a div (or any other container element) instead of an iframe to the
   * DOM with an id of "duo_iframe", or pass that element to the
   * `iframeContainer` parameter of `Duo.init`. An iframe will be created and
   * inserted into that container element, preventing `src` change related
   * bugs. WARNING: All other elements in the container will be deleted.
   *
   * The `iframeAttributes` parameter of `Duo.init` is available to set any
   * attributes on the inserted iframe if the Duo Web SDK is inserting the
   * iframe. For details, see the parameter documentation below.
   *
   * @param {Object} options
   * @param {String} options.host - Hostname for the Duo Prompt.
   * @param {String} options.sig_request - Request token.
   * @param {String|HTMLElement} [options.iframe] - The iframe, or id of an
   *     iframe that will be used for the Duo Prompt. If you don't provide
   *     this or the `iframeContainer` parameter the Duo Web SDK will default
   *     to using whatever element has an id of "duo_iframe".
   * @param {String|HTMLElement} [options.iframeContainer] - The element you
   *     want the Duo Prompt inserted into, or the id of that element.
   *     Anything inside this element will be deleted and replaced with an
   *     iframe hosting the Duo prompt. If you don't provide this or the
   *     `iframe` parameter the Duo Web SDK will default to using whatever
   *     element has an id of "duo_iframe".
   * @param {Object} [options.iframeAttributes] - Object with  names and
   *     values coresponding to attributes you want added to the  Duo Prompt
   *     iframe, like `title`, `width` and `allow`. WARNING: this parameter
   *     only works if you use the `iframeContainer` parameter or add an id
   *     of "duo_iframe" to an element that isn't an iframe. If you have
   *     added an iframe to the DOM yourself, you should set those attributes
   *     directly on the iframe.
   * @param {String} [options.post_action=''] - URL to POST back to after a
   *     successful auth.
   * @param {String} [options.post_argument='sig_response'] - Parameter name
   *     to use for response token.
   * @param {Function} [options.submit_callback] - If provided, the Duo Web
   *     SDK will not submit the form. Instead it will execute this callback
   *     function passing in a reference to the "duo_form" form object.
   *     `submit_callback`` can be used to prevent the webpage from reloading.
   */


  function init(options) {
    // If init() is called more than once we have to reset all the local
    // variables to ensure init() will work the same way every time. This
    // helps people making single page applications. SPAs may periodically
    // remove the iframe and add a new one that has to be initialized.
    initializeStatefulVariables();

    if (options) {
      if (options.host) {
        host = options.host;
      }

      if (options.sig_request) {
        parseSigRequest(options.sig_request);
      }

      if (options.post_action) {
        postAction = options.post_action;
      }

      if (options.post_argument) {
        postArgument = options.post_argument;
      }

      if (typeof options.submit_callback === 'function') {
        submitCallback = options.submit_callback;
      }
    }

    var promptElement = getPromptElement(options);

    if (promptElement) {
      // If we can get the element that will host the prompt, set it.
      ready(promptElement, options.iframeAttributes || {});
    } else {
      // If the element that will host the prompt isn't available yet, set
      // it up after the DOM finishes loading.
      asyncReady(options);
    } // always clean up after yourself!


    offReady(init);
  }
  /**
   * Given the options from init(), get the iframe or iframe container that
   * should be used for the Duo Prompt. Returns `null` if nothing was found.
   */


  function getPromptElement(options) {
    var result;

    if (options.iframe && options.iframeContainer) {
      throwError('Passing both `iframe` and `iframeContainer` arguments at the' + ' same time is not allowed.');
    } else if (options.iframe) {
      // If we are getting an iframe, try to get it and raise if the
      // element we find is NOT an iframe.
      result = getUserDefinedElement(options.iframe);
      validateIframe(result);
    } else if (options.iframeContainer) {
      result = getUserDefinedElement(options.iframeContainer);
      validateIframeContainer(result);
    } else {
      result = document.getElementById('duo_iframe');
    }

    return result;
  }
  /**
   * When given an HTMLElement, return it. When given a string, get an element
   * with that id, else return null.
   */


  function getUserDefinedElement(object) {
    if (object.tagName) {
      return object;
    } else if (typeof object == 'string') {
      return document.getElementById(object);
    }

    return null;
  }
  /**
   * Check if the given thing is an iframe.
   */


  function isIframe(element) {
    return element && element.tagName && element.tagName.toLowerCase() === 'iframe';
  }
  /**
   * Throw an error if we are given an element that is NOT an iframe.
   */


  function validateIframe(element) {
    if (element && !isIframe(element)) {
      throwError('`iframe` only accepts an iframe element or the id of an' + ' iframe. To use a non-iframe element, use the' + ' `iframeContainer` argument.');
    }
  }
  /**
   * Throw an error if we are given an element that IS an iframe instead of an
   * element that we can insert an iframe into.
   */


  function validateIframeContainer(element) {
    if (element && isIframe(element)) {
      throwError('`iframeContainer` only accepts a non-iframe element or the' + ' id of a non-iframe. To use a non-iframe element, use the' + ' `iframeContainer` argument on Duo.init().');
    }
  }
  /**
   * Generate the URL that goes to the Duo Prompt.
   */


  function generateIframeSrc() {
    return ['https://', host, '/frame/web/v1/auth?tx=', duoSig, '&parent=', encodeURIComponent(document.location.href), '&v=2.8'].join('');
  }
  /**
   * This function is called when a message was received from another domain
   * using the `postMessage` API.  Check that the event came from the Duo
   * service domain, and that the message is a properly formatted payload,
   * then perform the post back to the primary service.
   *
   * @param event Event object (contains origin and data)
   */


  function onReceivedMessage(event) {
    if (isDuoMessage(event)) {
      if (event.data.match(DUO_OPEN_WINDOW_FORMAT)) {
        var url = event.data.substring("DUO_OPEN_WINDOW|".length);

        if (isValidUrlToOpen(url)) {
          // Open the URL that comes after the DUO_WINDOW_OPEN token.
          window.open(url, "_self");
        }
      } else {
        // the event came from duo, do the post back
        doPostBack(event.data); // always clean up after yourself!

        offMessage(onReceivedMessage);
      }
    }
  }
  /**
   * Validate that this passed in URL is one that we will actually allow to
   * be opened.
   * @param url String URL that the message poster wants to open
   * @returns {boolean} true if we allow this url to be opened in the window
   */


  function isValidUrlToOpen(url) {
    if (!url) {
      return false;
    }

    var parser = document.createElement('a');
    parser.href = url;

    if (parser.protocol === "duotrustedendpoints:") {
      return true;
    } else if (parser.protocol !== "https:") {
      return false;
    }

    for (var i = 0; i < VALID_OPEN_WINDOW_DOMAINS.length; i++) {
      var _context;

      if ((0, _endsWith.default)(_context = parser.hostname).call(_context, "." + VALID_OPEN_WINDOW_DOMAINS[i]) || parser.hostname === VALID_OPEN_WINDOW_DOMAINS[i]) {
        return true;
      }
    }

    return false;
  }
  /**
   * Register a callback to call ready() after the DOM has loaded.
   */


  function asyncReady(options) {
    var callback = function callback() {
      var promptElement = getPromptElement(options);

      if (!promptElement) {
        throwError('This page does not contain an iframe for Duo to use.' + ' Add an element like' + ' <iframe id="duo_iframe"></iframe> to this page.');
      }

      ready(promptElement, options.iframeAttributes || {}); // Always clean up after yourself.

      offReady(callback);
    };

    onReady(callback);
  }
  /**
   * Point the iframe at Duo, then wait for it to postMessage back to us.
   */


  function ready(promptElement, iframeAttributes) {
    if (!host) {
      host = getDataAttribute(promptElement, 'host');

      if (!host) {
        throwError('No API hostname is given for Duo to use.  Be sure to pass ' + 'a `host` parameter to Duo.init, or through the `data-host` ' + 'attribute on the iframe element.');
      }
    }

    if (!duoSig || !appSig) {
      parseSigRequest(getDataAttribute(promptElement, 'sigRequest'));

      if (!duoSig || !appSig) {
        throwError('No valid signed request is given.  Be sure to give the ' + '`sig_request` parameter to Duo.init, or use the ' + '`data-sig-request` attribute on the iframe element.');
      }
    } // if postAction/Argument are defaults, see if they are specified
    // as data attributes on the iframe


    if (postAction === '') {
      postAction = getDataAttribute(promptElement, 'postAction') || postAction;
    }

    if (postArgument === 'sig_response') {
      postArgument = getDataAttribute(promptElement, 'postArgument') || postArgument;
    }

    if (isIframe(promptElement)) {
      iframe = promptElement;
      iframe.src = generateIframeSrc();
    } else {
      // If given a container to put an iframe in, clean out any children
      // child elements in case `init()` was called more than once.
      while (promptElement.firstChild) {
        // We call `removeChild()` instead of doing `innerHTML = ""`
        // to make sure we unbind any events.
        promptElement.removeChild(promptElement.firstChild);
      }

      iframe = document.createElement('iframe'); // Set the src and all other attributes on the new iframe.

      iframeAttributes['src'] = generateIframeSrc();

      for (var name in iframeAttributes) {
        iframe.setAttribute(name, iframeAttributes[name]);
      }

      promptElement.appendChild(iframe);
    } // listen for the 'message' event


    onMessage(onReceivedMessage);
  }
  /**
   * We received a postMessage from Duo.  POST back to the primary service
   * with the response token, and any additional user-supplied parameters
   * given in form#duo_form.
   */
  // function doPostBack(response) {
  //     // create a hidden input to contain the response token
  //     var input = document.createElement('input');
  //     input.type = 'hidden';
  //     input.name = postArgument;
  //     input.value = response + ':' + appSig;
  //     // user may supply their own form with additional inputs
  //     var form = document.getElementById('duo_form');
  //     // if the form doesn't exist, create one
  //     if (!form) {
  //         form = document.createElement('form');
  //         // insert the new form after the iframe
  //         iframe.parentElement.insertBefore(form, iframe.nextSibling);
  //     }
  //     // make sure we are actually posting to the right place
  //     form.method = 'POST';
  //     form.action = postAction;
  //     // add the response token input to the form
  //     form.appendChild(input);
  //     // away we go!
  //     if (typeof submitCallback === "function") {
  //         submitCallback.call(null, form);
  //     } else {
  //         form.submit();
  //     }
  // }
  // OKTA: Overriding their doPostBack logic because we want to submit this
  // through ajax, not a postBack


  function doPostBack(response) {
    postAction(response + ':' + appSig);
  }

  return {
    init: init,
    _onReady: onReady,
    _parseSigRequest: parseSigRequest,
    _isDuoMessage: isDuoMessage,
    _doPostBack: doPostBack
  };
});

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums) {
  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link help\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "goback"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 50
            },
            "end": {
              "line": 1,
              "column": 87
            }
          }
        })) + "</a>";
      },
      "useData": true
    }),
    className: 'auth-footer',
    events: {
      'click .help': function clickHelp(e) {
        e.preventDefault();
        this.back();
      }
    },
    back: function back() {
      this.state.set('navigateDir', Enums.DIRECTION_BACK);
      this.options.appState.trigger('navigate', '');
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums) {
  var _ = Okta._;
  return Okta.View.extend({
    className: 'hide resend-email-infobox',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"infobox infobox-warning\"><span class=\"icon warning-16\"></span><p><span>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "email.code.not.received"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 83
            },
            "end": {
              "line": 1,
              "column": 137
            }
          }
        })) + "</span><a href=\"#\" class=\"resend-email-btn\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "email.button.resend"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 181
            },
            "end": {
              "line": 1,
              "column": 231
            }
          }
        })) + "</a></p></div>";
      },
      "useData": true
    }),
    events: {
      'click .resend-email-btn': 'resendEmail'
    },
    postRender: function postRender() {
      this.showResendCallout();
    },
    showResendCallout: function showResendCallout() {
      var _this = this;

      _.delay(function () {
        _this.$el.removeClass('hide');
      }, Enums.API_RATE_LIMIT);
    },
    hideResendCallout: function hideResendCallout() {
      this.$el.addClass('hide');
    },
    resendEmail: function resendEmail(e) {
      var _context;

      e.preventDefault();
      this.hideResendCallout();
      this.model.resend().finally((0, _bind.default)(_context = this.showResendCallout).call(_context, this));
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(796);

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(20);

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  return Okta.View.extend({
    className: 'okta-waiting-spinner',
    attributes: {
      'data-se': 'o-form-okta-waiting-spinner'
    },
    modelEvents: {
      'spinner:show': 'show',
      'spinner:hide': 'hide'
    },
    initialize: function initialize(options) {
      if (options && options.visible === false) {
        this.hide();
      }
    },
    show: function show() {
      this.$el.removeClass('hide');
    },
    hide: function hide() {
      this.$el.addClass('hide');
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Copyright 2014-2015 Google Inc. All rights reserved.

//Use of this source code is governed by a BSD-style
//license that can be found in the LICENSE file or at
//https://developers.google.com/open-source/licenses/bsd

/**
 * @fileoverview The U2F api.
 */


(function (){
  var isChrome = 'chrome' in window && window.navigator.userAgent.indexOf('Edge') < 0;
  if ('u2f' in window || !isChrome) {
    return;
  }

  /** Namespace for the U2F api.
   * @type {Object}
   */
  var u2f = window.u2f = {};

  /**
   * FIDO U2F Javascript API Version
   * @number
   */
  var js_api_version;

  /**
   * The U2F extension id
   * @const {string}
   */
  // The Chrome packaged app extension ID.
  // Uncomment this if you want to deploy a server instance that uses
  // the package Chrome app and does not require installing the U2F Chrome extension.
   u2f.EXTENSION_ID = 'kmendfapggjehodndflmmgagdbamhnfd';
  // The U2F Chrome extension ID.
  // Uncomment this if you want to deploy a server instance that uses
  // the U2F Chrome extension to authenticate.
  // u2f.EXTENSION_ID = 'pfboblefjcgdjicmnffhdgionmgcdmne';


  /**
   * Message types for messsages to/from the extension
   * @const
   * @enum {string}
   */
  u2f.MessageTypes = {
      'U2F_REGISTER_REQUEST': 'u2f_register_request',
      'U2F_REGISTER_RESPONSE': 'u2f_register_response',
      'U2F_SIGN_REQUEST': 'u2f_sign_request',
      'U2F_SIGN_RESPONSE': 'u2f_sign_response',
      'U2F_GET_API_VERSION_REQUEST': 'u2f_get_api_version_request',
      'U2F_GET_API_VERSION_RESPONSE': 'u2f_get_api_version_response'
  };


  /**
   * Response status codes
   * @const
   * @enum {number}
   */
  u2f.ErrorCodes = {
      'OK': 0,
      'OTHER_ERROR': 1,
      'BAD_REQUEST': 2,
      'CONFIGURATION_UNSUPPORTED': 3,
      'DEVICE_INELIGIBLE': 4,
      'TIMEOUT': 5
  };


  /**
   * A message for registration requests
   * @typedef {{
   *   type: u2f.MessageTypes,
   *   appId: ?string,
   *   timeoutSeconds: ?number,
   *   requestId: ?number
   * }}
   */
  u2f.U2fRequest;


  /**
   * A message for registration responses
   * @typedef {{
   *   type: u2f.MessageTypes,
   *   responseData: (u2f.Error | u2f.RegisterResponse | u2f.SignResponse),
   *   requestId: ?number
   * }}
   */
  u2f.U2fResponse;


  /**
   * An error object for responses
   * @typedef {{
   *   errorCode: u2f.ErrorCodes,
   *   errorMessage: ?string
   * }}
   */
  u2f.Error;

  /**
   * Data object for a single sign request.
   * @typedef {enum {BLUETOOTH_RADIO, BLUETOOTH_LOW_ENERGY, USB, NFC}}
   */
  u2f.Transport;


  /**
   * Data object for a single sign request.
   * @typedef {Array<u2f.Transport>}
   */
  u2f.Transports;

  /**
   * Data object for a single sign request.
   * @typedef {{
   *   version: string,
   *   challenge: string,
   *   keyHandle: string,
   *   appId: string
   * }}
   */
  u2f.SignRequest;


  /**
   * Data object for a sign response.
   * @typedef {{
   *   keyHandle: string,
   *   signatureData: string,
   *   clientData: string
   * }}
   */
  u2f.SignResponse;


  /**
   * Data object for a registration request.
   * @typedef {{
   *   version: string,
   *   challenge: string
   * }}
   */
  u2f.RegisterRequest;


  /**
   * Data object for a registration response.
   * @typedef {{
   *   version: string,
   *   keyHandle: string,
   *   transports: Transports,
   *   appId: string
   * }}
   */
  u2f.RegisterResponse;


  /**
   * Data object for a registered key.
   * @typedef {{
   *   version: string,
   *   keyHandle: string,
   *   transports: ?Transports,
   *   appId: ?string
   * }}
   */
  u2f.RegisteredKey;


  /**
   * Data object for a get API register response.
   * @typedef {{
   *   js_api_version: number
   * }}
   */
  u2f.GetJsApiVersionResponse;


  //Low level MessagePort API support

  /**
   * Sets up a MessagePort to the U2F extension using the
   * available mechanisms.
   * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
   */
  u2f.getMessagePort = function(callback) {
    if (typeof chrome != 'undefined' && chrome.runtime) {
      // The actual message here does not matter, but we need to get a reply
      // for the callback to run. Thus, send an empty signature request
      // in order to get a failure response.
      var msg = {
          type: u2f.MessageTypes.U2F_SIGN_REQUEST,
          signRequests: []
      };
      chrome.runtime.sendMessage(u2f.EXTENSION_ID, msg, function() {
        if (!chrome.runtime.lastError) {
          // We are on a whitelisted origin and can talk directly
          // with the extension.
          u2f.getChromeRuntimePort_(callback);
        } else {
          // chrome.runtime was available, but we couldn't message
          // the extension directly, use iframe
          u2f.getIframePort_(callback);
        }
      });
    } else if (u2f.isAndroidChrome_()) {
      u2f.getAuthenticatorPort_(callback);
    } else if (u2f.isIosChrome_()) {
      u2f.getIosPort_(callback);
    } else {
      // chrome.runtime was not available at all, which is normal
      // when this origin doesn't have access to any extensions.
      u2f.getIframePort_(callback);
    }
  };

  /**
   * Detect chrome running on android based on the browser's useragent.
   * @private
   */
  u2f.isAndroidChrome_ = function() {
    var userAgent = navigator.userAgent;
    return userAgent.indexOf('Chrome') != -1 &&
    userAgent.indexOf('Android') != -1;
  };

  /**
   * Detect chrome running on iOS based on the browser's platform.
   * @private
   */
  u2f.isIosChrome_ = function() {
    return ["iPhone", "iPad", "iPod"].indexOf(navigator.platform) > -1;
  };

  /**
   * Connects directly to the extension via chrome.runtime.connect.
   * @param {function(u2f.WrappedChromeRuntimePort_)} callback
   * @private
   */
  u2f.getChromeRuntimePort_ = function(callback) {
    var port = chrome.runtime.connect(u2f.EXTENSION_ID,
        {'includeTlsChannelId': true});
    setTimeout(function() {
      callback(new u2f.WrappedChromeRuntimePort_(port));
    }, 0);
  };

  /**
   * Return a 'port' abstraction to the Authenticator app.
   * @param {function(u2f.WrappedAuthenticatorPort_)} callback
   * @private
   */
  u2f.getAuthenticatorPort_ = function(callback) {
    setTimeout(function() {
      callback(new u2f.WrappedAuthenticatorPort_());
    }, 0);
  };

  /**
   * Return a 'port' abstraction to the iOS client app.
   * @param {function(u2f.WrappedIosPort_)} callback
   * @private
   */
  u2f.getIosPort_ = function(callback) {
    setTimeout(function() {
      callback(new u2f.WrappedIosPort_());
    }, 0);
  };

  /**
   * A wrapper for chrome.runtime.Port that is compatible with MessagePort.
   * @param {Port} port
   * @constructor
   * @private
   */
  u2f.WrappedChromeRuntimePort_ = function(port) {
    this.port_ = port;
  };

  /**
   * Format and return a sign request compliant with the JS API version supported by the extension.
   * @param {Array<u2f.SignRequest>} signRequests
   * @param {number} timeoutSeconds
   * @param {number} reqId
   * @return {Object}
   */
  u2f.formatSignRequest_ =
    function(appId, challenge, registeredKeys, timeoutSeconds, reqId) {
    if (js_api_version === undefined || js_api_version < 1.1) {
      // Adapt request to the 1.0 JS API
      var signRequests = [];
      for (var i = 0; i < registeredKeys.length; i++) {
        signRequests[i] = {
            version: registeredKeys[i].version,
            challenge: challenge,
            keyHandle: registeredKeys[i].keyHandle,
            appId: appId
        };
      }
      return {
        type: u2f.MessageTypes.U2F_SIGN_REQUEST,
        signRequests: signRequests,
        timeoutSeconds: timeoutSeconds,
        requestId: reqId
      };
    }
    // JS 1.1 API
    return {
      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
      appId: appId,
      challenge: challenge,
      registeredKeys: registeredKeys,
      timeoutSeconds: timeoutSeconds,
      requestId: reqId
    };
  };

  /**
   * Format and return a register request compliant with the JS API version supported by the extension..
   * @param {Array<u2f.SignRequest>} signRequests
   * @param {Array<u2f.RegisterRequest>} signRequests
   * @param {number} timeoutSeconds
   * @param {number} reqId
   * @return {Object}
   */
  u2f.formatRegisterRequest_ =
    function(appId, registeredKeys, registerRequests, timeoutSeconds, reqId) {
    if (js_api_version === undefined || js_api_version < 1.1) {
      // Adapt request to the 1.0 JS API
      for (var i = 0; i < registerRequests.length; i++) {
        registerRequests[i].appId = appId;
      }
      var signRequests = [];
      for (var i = 0; i < registeredKeys.length; i++) {
        signRequests[i] = {
            version: registeredKeys[i].version,
            challenge: registerRequests[0],
            keyHandle: registeredKeys[i].keyHandle,
            appId: appId
        };
      }
      return {
        type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
        signRequests: signRequests,
        registerRequests: registerRequests,
        timeoutSeconds: timeoutSeconds,
        requestId: reqId
      };
    }
    // JS 1.1 API
    return {
      type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
      appId: appId,
      registerRequests: registerRequests,
      registeredKeys: registeredKeys,
      timeoutSeconds: timeoutSeconds,
      requestId: reqId
    };
  };


  /**
   * Posts a message on the underlying channel.
   * @param {Object} message
   */
  u2f.WrappedChromeRuntimePort_.prototype.postMessage = function(message) {
    this.port_.postMessage(message);
  };


  /**
   * Emulates the HTML 5 addEventListener interface. Works only for the
   * onmessage event, which is hooked up to the chrome.runtime.Port.onMessage.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */
  u2f.WrappedChromeRuntimePort_.prototype.addEventListener =
      function(eventName, handler) {
    var name = eventName.toLowerCase();
    if (name == 'message' || name == 'onmessage') {
      this.port_.onMessage.addListener(function(message) {
        // Emulate a minimal MessageEvent object
        handler({'data': message});
      });
    } else {
      console.error('WrappedChromeRuntimePort only supports onMessage');
    }
  };

  /**
   * Wrap the Authenticator app with a MessagePort interface.
   * @constructor
   * @private
   */
  u2f.WrappedAuthenticatorPort_ = function() {
    this.requestId_ = -1;
    this.requestObject_ = null;
  }

  /**
   * Launch the Authenticator intent.
   * @param {Object} message
   */
  u2f.WrappedAuthenticatorPort_.prototype.postMessage = function(message) {
    var intentUrl =
      u2f.WrappedAuthenticatorPort_.INTENT_URL_BASE_ +
      ';S.request=' + encodeURIComponent(JSON.stringify(message)) +
      ';end';
    document.location = intentUrl;
  };

  /**
   * Tells what type of port this is.
   * @return {String} port type
   */
  u2f.WrappedAuthenticatorPort_.prototype.getPortType = function() {
    return "WrappedAuthenticatorPort_";
  };


  /**
   * Emulates the HTML 5 addEventListener interface.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */
  u2f.WrappedAuthenticatorPort_.prototype.addEventListener = function(eventName, handler) {
    var name = eventName.toLowerCase();
    if (name == 'message') {
      var self = this;
      /* Register a callback to that executes when
       * chrome injects the response. */
      window.addEventListener(
          'message', self.onRequestUpdate_.bind(self, handler), false);
    } else {
      console.error('WrappedAuthenticatorPort only supports message');
    }
  };

  /**
   * Callback invoked  when a response is received from the Authenticator.
   * @param function({data: Object}) callback
   * @param {Object} message message Object
   */
  u2f.WrappedAuthenticatorPort_.prototype.onRequestUpdate_ =
      function(callback, message) {
    var messageObject = JSON.parse(message.data);
    var intentUrl = messageObject['intentURL'];

    var errorCode = messageObject['errorCode'];
    var responseObject = null;
    if (messageObject.hasOwnProperty('data')) {
      responseObject = /** @type {Object} */ (
          JSON.parse(messageObject['data']));
    }

    callback({'data': responseObject});
  };

  /**
   * Base URL for intents to Authenticator.
   * @const
   * @private
   */
  u2f.WrappedAuthenticatorPort_.INTENT_URL_BASE_ =
    'intent:#Intent;action=com.google.android.apps.authenticator.AUTHENTICATE';

  /**
   * Wrap the iOS client app with a MessagePort interface.
   * @constructor
   * @private
   */
  u2f.WrappedIosPort_ = function() {};

  /**
   * Launch the iOS client app request
   * @param {Object} message
   */
  u2f.WrappedIosPort_.prototype.postMessage = function(message) {
    var str = JSON.stringify(message);
    var url = "u2f://auth?" + encodeURI(str);
    location.replace(url);
  };

  /**
   * Tells what type of port this is.
   * @return {String} port type
   */
  u2f.WrappedIosPort_.prototype.getPortType = function() {
    return "WrappedIosPort_";
  };

  /**
   * Emulates the HTML 5 addEventListener interface.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */
  u2f.WrappedIosPort_.prototype.addEventListener = function(eventName, handler) {
    var name = eventName.toLowerCase();
    if (name !== 'message') {
      console.error('WrappedIosPort only supports message');
    }
  };

  /**
   * Sets up an embedded trampoline iframe, sourced from the extension.
   * @param {function(MessagePort)} callback
   * @private
   */
  u2f.getIframePort_ = function(callback) {
    // Create the iframe
    var iframeOrigin = 'chrome-extension://' + u2f.EXTENSION_ID;
    var iframe = document.createElement('iframe');
    iframe.src = iframeOrigin + '/u2f-comms.html';
    iframe.setAttribute('style', 'display:none');
    document.body.appendChild(iframe);

    var channel = new MessageChannel();
    var ready = function(message) {
      if (message.data == 'ready') {
        channel.port1.removeEventListener('message', ready);
        callback(channel.port1);
      } else {
        console.error('First event on iframe port was not "ready"');
      }
    };
    channel.port1.addEventListener('message', ready);
    channel.port1.start();

    iframe.addEventListener('load', function() {
      // Deliver the port to the iframe and initialize
      iframe.contentWindow.postMessage('init', iframeOrigin, [channel.port2]);
    });
  };


  //High-level JS API

  /**
   * Default extension response timeout in seconds.
   * @const
   */
  u2f.EXTENSION_TIMEOUT_SEC = 30;

  /**
   * A singleton instance for a MessagePort to the extension.
   * @type {MessagePort|u2f.WrappedChromeRuntimePort_}
   * @private
   */
  u2f.port_ = null;

  /**
   * Callbacks waiting for a port
   * @type {Array<function((MessagePort|u2f.WrappedChromeRuntimePort_))>}
   * @private
   */
  u2f.waitingForPort_ = [];

  /**
   * A counter for requestIds.
   * @type {number}
   * @private
   */
  u2f.reqCounter_ = 0;

  /**
   * A map from requestIds to client callbacks
   * @type {Object.<number,(function((u2f.Error|u2f.RegisterResponse))
   *                       |function((u2f.Error|u2f.SignResponse)))>}
   * @private
   */
  u2f.callbackMap_ = {};

  /**
   * Creates or retrieves the MessagePort singleton to use.
   * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
   * @private
   */
  u2f.getPortSingleton_ = function(callback) {
    if (u2f.port_) {
      callback(u2f.port_);
    } else {
      if (u2f.waitingForPort_.length == 0) {
        u2f.getMessagePort(function(port) {
          u2f.port_ = port;
          u2f.port_.addEventListener('message',
              /** @type {function(Event)} */ (u2f.responseHandler_));

          // Careful, here be async callbacks. Maybe.
          while (u2f.waitingForPort_.length)
            u2f.waitingForPort_.shift()(u2f.port_);
        });
      }
      u2f.waitingForPort_.push(callback);
    }
  };

  /**
   * Handles response messages from the extension.
   * @param {MessageEvent.<u2f.Response>} message
   * @private
   */
  u2f.responseHandler_ = function(message) {
    var response = message.data;
    var reqId = response['requestId'];
    if (!reqId || !u2f.callbackMap_[reqId]) {
      console.error('Unknown or missing requestId in response.');
      return;
    }
    var cb = u2f.callbackMap_[reqId];
    delete u2f.callbackMap_[reqId];
    cb(response['responseData']);
  };

  /**
   * Dispatches an array of sign requests to available U2F tokens.
   * If the JS API version supported by the extension is unknown, it first sends a
   * message to the extension to find out the supported API version and then it sends
   * the sign request.
   * @param {string=} appId
   * @param {string=} challenge
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.SignResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.sign = function(appId, challenge, registeredKeys, callback, opt_timeoutSeconds) {
    if (js_api_version === undefined) {
      // Send a message to get the extension to JS API version, then send the actual sign request.
      u2f.getApiVersion(
          function (response) {
            js_api_version = response['js_api_version'] === undefined ? 0 : response['js_api_version'];
            console.log("Extension JS API Version: ", js_api_version);
            u2f.sendSignRequest(appId, challenge, registeredKeys, callback, opt_timeoutSeconds);
          });
    } else {
      // We know the JS API version. Send the actual sign request in the supported API version.
      u2f.sendSignRequest(appId, challenge, registeredKeys, callback, opt_timeoutSeconds);
    }
  };

  /**
   * Dispatches an array of sign requests to available U2F tokens.
   * @param {string=} appId
   * @param {string=} challenge
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.SignResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.sendSignRequest = function(appId, challenge, registeredKeys, callback, opt_timeoutSeconds) {
    u2f.getPortSingleton_(function(port) {
      var reqId = ++u2f.reqCounter_;
      u2f.callbackMap_[reqId] = callback;
      var timeoutSeconds = (typeof opt_timeoutSeconds !== 'undefined' ?
          opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC);
      var req = u2f.formatSignRequest_(appId, challenge, registeredKeys, timeoutSeconds, reqId);
      port.postMessage(req);
    });
  };

  /**
   * Dispatches register requests to available U2F tokens. An array of sign
   * requests identifies already registered tokens.
   * If the JS API version supported by the extension is unknown, it first sends a
   * message to the extension to find out the supported API version and then it sends
   * the register request.
   * @param {string=} appId
   * @param {Array<u2f.RegisterRequest>} registerRequests
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.RegisterResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.register = function(appId, registerRequests, registeredKeys, callback, opt_timeoutSeconds) {
    if (js_api_version === undefined) {
      // Send a message to get the extension to JS API version, then send the actual register request.
      u2f.getApiVersion(
          function (response) {
            js_api_version = response['js_api_version'] === undefined ? 0: response['js_api_version'];
            console.log("Extension JS API Version: ", js_api_version);
            u2f.sendRegisterRequest(appId, registerRequests, registeredKeys,
                callback, opt_timeoutSeconds);
          });
    } else {
      // We know the JS API version. Send the actual register request in the supported API version.
      u2f.sendRegisterRequest(appId, registerRequests, registeredKeys,
          callback, opt_timeoutSeconds);
    }
  };

  /**
   * Dispatches register requests to available U2F tokens. An array of sign
   * requests identifies already registered tokens.
   * @param {string=} appId
   * @param {Array<u2f.RegisterRequest>} registerRequests
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.RegisterResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.sendRegisterRequest = function(appId, registerRequests, registeredKeys, callback, opt_timeoutSeconds) {
    u2f.getPortSingleton_(function(port) {
      var reqId = ++u2f.reqCounter_;
      u2f.callbackMap_[reqId] = callback;
      var timeoutSeconds = (typeof opt_timeoutSeconds !== 'undefined' ?
          opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC);
      var req = u2f.formatRegisterRequest_(
          appId, registeredKeys, registerRequests, timeoutSeconds, reqId);
      port.postMessage(req);
    });
  };


  /**
   * Dispatches a message to the extension to find out the supported
   * JS API version.
   * If the user is on a mobile phone and is thus using Google Authenticator instead
   * of the Chrome extension, don't send the request and simply return 0.
   * @param {function((u2f.Error|u2f.GetJsApiVersionResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.getApiVersion = function(callback, opt_timeoutSeconds) {
   u2f.getPortSingleton_(function(port) {
     // If we are using Android Google Authenticator or iOS client app,
     // do not fire an intent to ask which JS API version to use.
     if (port.getPortType) {
       var apiVersion;
       switch (port.getPortType()) {
         case 'WrappedIosPort_':
         case 'WrappedAuthenticatorPort_':
           apiVersion = 1.1;
           break;

         default:
           apiVersion = 0;
           break;
       }
       callback({ 'js_api_version': apiVersion });
       return;
     }
      var reqId = ++u2f.reqCounter_;
      u2f.callbackMap_[reqId] = callback;
      var req = {
        type: u2f.MessageTypes.U2F_GET_API_VERSION_REQUEST,
        timeoutSeconds: (typeof opt_timeoutSeconds !== 'undefined' ?
            opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC),
        requestId: reqId
      };
      port.postMessage(req);
    });
  };
})();


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(48), __webpack_require__(32)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, RouterUtil, FactorUtil) {
  var _ = Okta._,
      cardinalityTextTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"factor-cardinality\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "cardinalityText") || (depth0 != null ? lookupProperty(depth0, "cardinalityText") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "cardinalityText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 33
          },
          "end": {
            "line": 1,
            "column": 52
          }
        }
      }) : helper)) + "</span>";
    },
    "useData": true
  });

  var FactorRow = Okta.View.extend({
    className: 'enroll-factor-row clearfix',
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorDescription") || (depth0 != null ? lookupProperty(depth0, "factorDescription") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "factorDescription",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 235
            },
            "end": {
              "line": 1,
              "column": 256
            }
          }
        }) : helper)) + "</p>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"enroll-factor-icon-container\"><div class=\"factor-icon enroll-factor-icon " + alias4((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "iconClassName",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 85
            },
            "end": {
              "line": 1,
              "column": 102
            }
          }
        }) : helper)) + "\"></div></div><div class=\"enroll-factor-description\"><h3 class=\"enroll-factor-label\">" + alias4((helper = (helper = lookupProperty(helpers, "factorLabel") || (depth0 != null ? lookupProperty(depth0, "factorLabel") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "factorLabel",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 187
            },
            "end": {
              "line": 1,
              "column": 202
            }
          }
        }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "factorDescription") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 207
            },
            "end": {
              "line": 1,
              "column": 267
            }
          }
        })) != null ? stack1 : "") + "<div class=\"enroll-factor-button\"></div></div>";
      },
      "useData": true
    }),
    attributes: function attributes() {
      return {
        'data-se': this.model.get('factorName')
      };
    },
    children: function children() {
      var children = [],
          enrolled = this.model.get('enrolled'),
          required = this.model.get('required'),
          cardinality = this.model.get('cardinality');

      if (this.options.showInlineSetupButton) {
        return [[Okta.createButton({
          className: 'button',
          title: this.getSetupButtonText(),
          click: function click() {
            this.options.appState.trigger('navigate', RouterUtil.createEnrollFactorUrl(this.model.get('provider'), this.model.get('factorType')));
          }
        }), '.enroll-factor-button']];
      } else if (enrolled) {
        children.push(['<span class="icon success-16-green"></span>', '.enroll-factor-label']);
      } else if (required) {
        children.push(['<span class="icon success-16-gray"></span>', '.enroll-factor-label']);
      }

      var cardinalityText = FactorUtil.getCardinalityText(enrolled, required, cardinality);

      if (cardinalityText) {
        children.push([cardinalityTextTpl({
          cardinalityText: cardinalityText
        }), '.enroll-factor-description']);
      }

      return children;
    },
    minimize: function minimize() {
      this.$el.addClass('enroll-factor-row-min');
    },
    maximize: function maximize() {
      this.$el.removeClass('enroll-factor-row-min');
    },
    getSetupButtonText: function getSetupButtonText() {
      return this.model.get('additionalEnrollment') ? Okta.loc('enroll.choices.setup.another', 'login') : Okta.loc('enroll.choices.setup', 'login');
    }
  });
  return Okta.ListView.extend({
    className: 'enroll-factor-list',
    item: FactorRow,
    itemSelector: '.list-content',
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"list-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "listTitle") || (depth0 != null ? lookupProperty(depth0, "listTitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "listTitle",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 41
            },
            "end": {
              "line": 1,
              "column": 54
            }
          }
        }) : helper)) + "</div>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "listTitle") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 67
            }
          }
        })) != null ? stack1 : "") + "<div class=\"list-content\"></div>";
      },
      "useData": true
    }),
    getTemplateData: function getTemplateData() {
      var json = Okta.ListView.prototype.getTemplateData.call(this);

      _.extend(json, this);

      return json;
    },
    postRender: function postRender() {
      if (this.options.minimize) {
        this.invoke('minimize');
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  var _ = Okta._;
  var TextBox = Okta.internal.views.forms.inputs.TextBox;
  return TextBox.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"okta-form-label-inline o-form-label-inline\">" + alias4((helper = (helper = lookupProperty(helpers, "countryCallingCode") || (depth0 != null ? lookupProperty(depth0, "countryCallingCode") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "countryCallingCode",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 57
            },
            "end": {
              "line": 1,
              "column": 79
            }
          }
        }) : helper)) + "</span><span class=\"okta-form-input-field input-fix o-form-control\"><input type=\"" + alias4((helper = (helper = lookupProperty(helpers, "type") || (depth0 != null ? lookupProperty(depth0, "type") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "type",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 160
            },
            "end": {
              "line": 1,
              "column": 168
            }
          }
        }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "placeholder",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 183
            },
            "end": {
              "line": 1,
              "column": 198
            }
          }
        }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "name",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 206
            },
            "end": {
              "line": 1,
              "column": 214
            }
          }
        }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 220
            },
            "end": {
              "line": 1,
              "column": 231
            }
          }
        }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "value",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 240
            },
            "end": {
              "line": 1,
              "column": 249
            }
          }
        }) : helper)) + "\" autocomplete=\"off\"></span>";
      },
      "useData": true
    }),
    initialize: function initialize() {
      this.listenTo(this.model, 'change:countryCallingCode', function () {
        this.$('.o-form-label-inline').text(this.model.get('countryCallingCode'));
      });
    },
    preRender: function preRender() {
      this.options.countryCallingCode = this.model.get('countryCallingCode');
    },
    postRender: function postRender() {
      // This is a hack - once inputGroups are done, get rid of it!!
      this.$el.removeClass('input-fix o-form-control');

      _.defer((0, _bind.default)(_).call(_, function () {
        this.$el.parent().addClass('o-form-input-group');
      }, this));
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2018-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, Footer) {
  var _ = Okta._;
  var Util = Okta.internal.util.Util;
  return FormController.extend({
    className: 'enroll-custom-factor',
    Model: {
      local: {
        provider: 'string',
        factorType: 'string'
      },
      save: function save() {
        var _this = this;

        return this.manageTransaction(function (transaction, setTransaction) {
          var factor = _.findWhere(transaction.factors, {
            provider: _this.get('provider'),
            factorType: _this.get('factorType')
          });

          return factor.enroll().then(function (trans) {
            setTransaction(trans);

            var url = _this.appState.get('enrollCustomFactorRedirectUrl');

            if (url !== null) {
              Util.redirect(url);
            }
          }).catch(function (err) {
            throw err;
          });
        });
      }
    },
    Form: function Form() {
      var factors = this.options.appState.get('factors');
      var factor = factors.findWhere({
        provider: this.options.provider,
        factorType: this.options.factorType
      });
      var vendorName = factor.get('vendorName');
      var subtitle = Okta.loc('enroll.customFactor.subtitle', 'login', [vendorName]);
      var saveText = Okta.loc('enroll.customFactor.save', 'login');
      return {
        autoSave: true,
        title: vendorName,
        subtitle: subtitle,
        save: saveText
      };
    },
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        return true;
      }
    },
    initialize: function initialize() {
      this.model.set('provider', this.options.provider);
      this.model.set('factorType', this.options.factorType);
    },
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(32), __webpack_require__(8), __webpack_require__(24), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FactorUtil, FormType, Util, TextBox) {
  var _ = Okta._;
  var form = {
    title: function title() {
      var factorName = FactorUtil.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
      return Okta.loc('enroll.totp.title', 'login', [factorName]);
    },
    subtitle: _.partial(Okta.loc, 'enroll.totp.enterCode', 'login'),
    autoSave: true,
    noButtonBar: true,
    attributes: {
      'data-se': 'step-sendcode'
    },
    formChildren: function formChildren() {
      return [FormType.Input({
        label: Okta.loc('mfa.challenge.enterCode.placeholder', 'login'),
        'label-top': true,
        explain: Util.createInputExplain('mfa.challenge.enterCode.tooltip', 'mfa.challenge.enterCode.placeholder', 'login'),
        'explain-top': true,
        name: 'passCode',
        input: TextBox,
        type: 'tel'
      }), FormType.Toolbar({
        noCancelButton: true,
        save: Okta.loc('oform.verify', 'login') // TODO: deprecated by mfa.challenge.verify

      })];
    }
  };
  return form;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums) {
  var Util = Okta.internal.util.Util;
  return Okta.View.extend({
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link help js-skip\" data-se=\"skip-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "password.expiring.later"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 78
            },
            "end": {
              "line": 1,
              "column": 132
            }
          }
        })) + "</a>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "passwordWarn") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 143
            }
          }
        })) != null ? stack1 : "") + "<a href=\"#\" class=\"link help goto js-signout\" data-se=\"signout-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "signout"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 212
            },
            "end": {
              "line": 1,
              "column": 250
            }
          }
        })) + "</a>";
      },
      "useData": true
    }),
    className: 'auth-footer clearfix',
    events: {
      'click .js-signout': function clickJsSignout(e) {
        e.preventDefault();
        var self = this;
        this.model.doTransaction(function (transaction) {
          return transaction.cancel();
        }).then(function () {
          if (self.settings.get('signOutLink')) {
            Util.redirect(self.settings.get('signOutLink'));
          } else {
            self.state.set('navigateDir', Enums.DIRECTION_BACK);
            self.options.appState.trigger('navigate', '');
          }
        });
      },
      'click .js-skip': function clickJsSkip(e) {
        e.preventDefault();
        this.model.doTransaction(function (transaction) {
          return transaction.skip();
        });
      }
    },
    getTemplateData: function getTemplateData() {
      return {
        passwordWarn: this.options.appState.get('isPwdExpiringSoon')
      };
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(32)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FactorUtil) {
  return Okta.View.extend({
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"password-requirements--header\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "password.complexity.requirements.header"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 63
            },
            "end": {
              "line": 1,
              "column": 133
            }
          }
        })) + "</div><ul class=\"password-requirements--list\">" + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "requirements") : depth0, {
          "name": "each",
          "hash": {},
          "fn": container.program(2, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 179
            },
            "end": {
              "line": 1,
              "column": 268
            }
          }
        })) != null ? stack1 : "") + "</ul>";
      },
      "2": function _(container, depth0, helpers, partials, data) {
        return "<li class=\"password-requirements--list-item\">" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "requirements") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 280
            }
          }
        })) != null ? stack1 : "";
      },
      "useData": true
    }),
    attributes: {
      'data-se': 'password-requirements-html'
    },
    allRequirements: [],
    initialize: function initialize(options) {
      var policy = options.policy;

      if (!policy) {
        return;
      }

      this.allRequirements = FactorUtil.getPasswordComplexityDescriptionForHtmlList(policy);
    },
    getTemplateData: function getTemplateData() {
      return {
        requirements: this.allRequirements
      };
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"infobox\"><span class=\"icon info-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "arguments": "helpSupportNumber",
            "bundle": "login",
            "code": "contact.support"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 58
            },
            "end": {
              "line": 1,
              "column": 134
            }
          }
        })) + "</p></div>";
      },
      "useData": true
    }),
    className: 'contact-support',
    getTemplateData: function getTemplateData() {
      return this.settings.pick('helpSupportNumber');
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _find = _interopRequireDefault(__webpack_require__(18));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

/* eslint max-statements: [2, 23],  max-depth: [2, 3], complexity: [2, 13] */

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, TextBox) {
  var _ = Okta._;
  var SchemaFormFactory = Okta.internal.views.forms.helpers.SchemaFormFactory;

  var getParts = function getParts(username) {
    var usernameArr = username.split('');
    var minPartsLength = 3;
    var userNameParts = [];
    var delimiters = [',', '.', '-', '_', '#', '@'];
    var userNamePart = '';

    _.each(usernameArr, function (part) {
      if ((0, _indexOf.default)(delimiters).call(delimiters, part) === -1) {
        userNamePart += part;
      } else {
        if (userNamePart.length >= minPartsLength) {
          userNameParts.push(_.clone(userNamePart));
        }

        userNamePart = '';
      }
    });

    if (userNamePart.length >= minPartsLength) {
      userNameParts.push(_.clone(userNamePart));
    }

    return (0, _filter.default)(userNameParts).call(userNameParts, Boolean);
  };

  var passwordContainsFormField = function passwordContainsFormField(formField, password) {
    if (!formField) {
      return false;
    }

    formField = formField.toLowerCase();
    password = password.toLowerCase();
    var formFieldArr = getParts(formField); //check if each formField part contains password

    for (var i = 0; i < formFieldArr.length; i++) {
      var formFieldPart = formFieldArr[i];

      if ((0, _indexOf.default)(password).call(password, formFieldPart) !== -1) {
        return true;
      }
    }

    return false;
  };

  var checkSubSchema = function checkSubSchema(subSchema, value, model) {
    var minLength = subSchema.get('minLength');
    var maxLength = subSchema.get('maxLength');
    var regex = subSchema.get('format');

    if (_.isNumber(minLength)) {
      if (value.length < minLength) {
        return false;
      }
    }

    if (_.isNumber(maxLength)) {
      if (value.length > maxLength) {
        return false;
      }
    }

    var password = value;

    if (_.isString(regex)) {
      // call passwordContainsFormField if regex is userName, firstName, lastName
      if (regex === '^[#/userName]' || regex === '^[#/firstName]' || regex === '^[#/lastName]') {
        var fieldName = regex.split('^[#/')[1].split(']')[0];
        var fieldValue = model.get(fieldName);

        if (fieldName === 'userName') {
          // with email as login enabled, we only have email populated
          // Therefore we fallback and run validation with email attribute.
          fieldValue = model.has('userName') ? model.get('userName') : model.get('email');
        }

        return !passwordContainsFormField(fieldValue, password);
      } else {
        if (!new RegExp(regex).test(value)) {
          return false;
        }
      }
    }

    return true;
  };

  var checkSubSchemas = function checkSubSchemas(fieldName, model, subSchemas, showError) {
    var value = model.get(fieldName);

    if (!_.isString(value)) {
      return;
    }

    subSchemas.each(function (subSchema, index) {
      var ele = Okta.$('#subschemas-' + fieldName + ' .subschema-' + index); //hide password complexity if no password

      if (value) {
        ele.children('p').removeClass('default-schema');
      } else {
        ele.children('p').addClass('default-schema');
      }

      ele.removeClass('subschema-satisfied subschema-unsatisfied subschema-error');

      if (checkSubSchema(subSchema, value, model)) {
        ele.addClass('subschema-satisfied');
        (0, _find.default)(ele).call(ele, 'p span').removeClass('error error-16-small');
        (0, _find.default)(ele).call(ele, 'p span').addClass('confirm-16');
      } else {
        if (showError) {
          (0, _find.default)(ele).call(ele, 'p span').removeClass('confirm-16');
          (0, _find.default)(ele).call(ele, 'p span').addClass('error error-16-small');
          ele.addClass('subschema-error subschema-unsatisfied');
        }
      }
    });
  };

  var fnCreateInputOptions = function fnCreateInputOptions(schemaProperty) {
    var inputOptions = SchemaFormFactory.createInputOptions(schemaProperty);

    if (inputOptions.type === 'select') {
      inputOptions = _.extend(inputOptions, {
        label: schemaProperty.get('title')
      });
    } else {
      var placeholder = schemaProperty.get('title');

      if (schemaProperty.get('required')) {
        placeholder += ' *';
      }

      inputOptions = _.extend(inputOptions, {
        label: false,
        'label-top': true,
        placeholder: placeholder
      });
    }

    var fieldName = schemaProperty.get('name');

    switch (fieldName) {
      case 'userName':
        inputOptions.input = TextBox;
        inputOptions.params = {
          'icon': 'person-16-gray'
        };
        break;

      case 'password':
        inputOptions.type = 'password';
        inputOptions.input = TextBox;
        inputOptions.params = {
          'icon': 'remote-lock-16'
        };
    }

    var subSchemas = schemaProperty.get('subSchemas');

    if (subSchemas) {
      inputOptions.events = {
        'input': function input() {
          checkSubSchemas(fieldName, this.model, subSchemas, true);
        },
        'focusout': function focusout() {
          checkSubSchemas(fieldName, this.model, subSchemas, true);
        },
        'change:userName': function changeUserName() {
          checkSubSchemas(fieldName, this.model, subSchemas, true);
        },
        'change:firstName': function changeFirstName() {
          checkSubSchemas(fieldName, this.model, subSchemas, true);
        },
        'change:lastName': function changeLastName() {
          checkSubSchemas(fieldName, this.model, subSchemas, true);
        },
        'change:email': function changeEmail() {
          checkSubSchemas(fieldName, this.model, subSchemas, true);
        }
      };
    }

    return inputOptions;
  };

  return {
    createInputOptions: fnCreateInputOptions,
    getUsernameParts: getParts,
    passwordContainsFormField: passwordContainsFormField
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _map = _interopRequireDefault(__webpack_require__(41));

var _okta = __webpack_require__(0);

var _FactorOptions = _interopRequireDefault(__webpack_require__(871));

var _AuthenticatorEnrollOptions = _interopRequireDefault(__webpack_require__(872));

var _AuthenticatorVerifyOptions = _interopRequireDefault(__webpack_require__(365));

var _AuthenticatorUtil = __webpack_require__(185);

var _RemediationConstants = __webpack_require__(57);

var _IDP = _interopRequireDefault(__webpack_require__(318));

var createFactorSelectView = function createFactorSelectView(opt) {
  var _context;

  var optionItems = (0, _map.default)(_context = opt.options || []).call(_context, function (opt) {
    return (0, _assign.default)({}, (0, _AuthenticatorUtil.getAuthenticatorDataForEnroll)(opt), opt);
  });
  return {
    View: _FactorOptions.default,
    options: {
      name: opt.name,
      collection: new _okta.Collection(optionItems)
    }
  };
};

var createAuthenticatorEnrollSelectView = function createAuthenticatorEnrollSelectView(opt) {
  var _context2;

  var optionItems = (0, _map.default)(_context2 = opt.options || []).call(_context2, function (opt) {
    return (0, _assign.default)({}, opt, (0, _AuthenticatorUtil.getAuthenticatorDataForEnroll)(opt));
  });
  return {
    View: _AuthenticatorEnrollOptions.default,
    options: {
      name: opt.name,
      collection: new _okta.Collection(optionItems)
    }
  };
};

var createAuthenticatorVerifySelectView = function createAuthenticatorVerifySelectView(opt) {
  var optionItems = opt.options || []; // If webauthn enrollments > 1 just show one entry with a generic namne (first) so user doesnt have to select which
  // one to pick. eg) If there is yubikey5 and another unknown u2f key, user cannot identify that easily. We need to
  // do this at least  until users can give authenticator enrollments custom names.

  var hasSecurityKey = false;
  optionItems = (0, _filter.default)(optionItems).call(optionItems, function (opt) {
    if (opt.authenticatorType === 'security_key') {
      if (!hasSecurityKey) {
        hasSecurityKey = true;
        return true;
      } else {
        return false;
      }
    }

    return true;
  });
  optionItems = (0, _map.default)(optionItems).call(optionItems, function (opt) {
    return (0, _assign.default)({}, opt, (0, _AuthenticatorUtil.getAuthenticatorDataForVerification)(opt));
  });
  return {
    View: _AuthenticatorVerifyOptions.default,
    options: {
      name: opt.name,
      collection: new _okta.Collection(optionItems)
    }
  };
};

var inputCreationStrategy = {
  factorSelect: createFactorSelectView,
  authenticatorEnrollSelect: createAuthenticatorEnrollSelectView,
  authenticatorVerifySelect: createAuthenticatorVerifySelectView
}; // TODO: move logic to uiSchemaTransformer

var create = function create(uiSchemaObj) {
  var strategyFn = inputCreationStrategy[uiSchemaObj.type] || _okta._.identity;
  return strategyFn(uiSchemaObj);
};
/**
 * Example of `redirect-idp` remediation.
 * {
 *   "name": "redirect-idp",
 *   "type": "MICROSOFT",
 *   "idp": {
 *      "id": "0oa2szc1K1YPgz1pe0g4",
 *      "name": "Microsoft IDP"
 *    },
 *   "href": "http://localhost:3000/sso/idps/0oa2szc1K1YPgz1pe0g4?stateToken=BB...AA",
 *   "method": "GET"
 * }
 *
 */


var createIdpButtons = function createIdpButtons(remediations) {
  var redirectIdpRemediations = (0, _filter.default)(remediations).call(remediations, function (idp) {
    return idp.name === _RemediationConstants.FORMS.REDIRECT_IDP;
  });

  if (!(0, _isArray.default)(redirectIdpRemediations)) {
    return [];
  } //add buttons from idp object


  return (0, _map.default)(redirectIdpRemediations).call(redirectIdpRemediations, function (idpObject) {
    var _idpObject$type;

    var type = (_idpObject$type = idpObject.type) === null || _idpObject$type === void 0 ? void 0 : _idpObject$type.toLowerCase();
    var displayName;

    if (!_okta._.contains(_IDP.default.SUPPORTED_SOCIAL_IDPS, type)) {
      var _idpObject$idp;

      type = 'general-idp';
      displayName = ((_idpObject$idp = idpObject.idp) === null || _idpObject$idp === void 0 ? void 0 : _idpObject$idp.name) || '{ Please provide a text value }';
    } else {
      displayName = (0, _okta.loc)("socialauth.".concat(type, ".label"), 'login');
    }

    var classNames = ['social-auth-button', "social-auth-".concat(type, "-button")];

    if (idpObject.idp.className) {
      classNames.push(idpObject.idp.className);
    }

    var button = {
      attributes: {
        'data-se': "social-auth-".concat(type, "-button")
      },
      className: classNames.join(' '),
      title: displayName,
      href: idpObject.href
    };
    return button;
  });
};

var createCustomButtons = function createCustomButtons(settings) {
  var customButtons = settings.get('customButtons');
  return (0, _map.default)(customButtons).call(customButtons, function (customButton) {
    var button = {
      attributes: {
        'data-se': customButton.dataAttr
      },
      className: customButton.className + ' default-custom-button',
      title: customButton.title,
      click: customButton.click
    };
    return button;
  });
};

module.exports = {
  create: create,
  createIdpButtons: createIdpButtons,
  createCustomButtons: createCustomButtons
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var AuthenticatorRow = _okta.View.extend({
  className: 'authenticator-row clearfix',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      return "authenticator-label--small";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"authenticator-description--text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "description",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 321
          },
          "end": {
            "line": 1,
            "column": 336
          }
        }
      }) : helper)) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"authenticator-icon-container\"><div class=\"factor-icon authenticator-icon " + alias4((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 85
          },
          "end": {
            "line": 1,
            "column": 102
          }
        }
      }) : helper)) + "\"></div></div><div class=\"authenticator-description\"><div><h3 class=\"authenticator-label " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 191
          },
          "end": {
            "line": 1,
            "column": 243
          }
        }
      })) != null ? stack1 : "") + "\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 245
          },
          "end": {
            "line": 1,
            "column": 254
          }
        }
      }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 259
          },
          "end": {
            "line": 1,
            "column": 347
          }
        }
      })) != null ? stack1 : "") + "</div><div class=\"authenticator-button\"></div></div>";
    },
    "useData": true
  }),
  children: function children() {
    return [[(0, _okta.createButton)({
      className: 'button select-factor',
      title: function title() {
        return (0, _okta.loc)('oie.verify.authenticator.button.text', 'login');
      },
      click: function click() {
        this.model.trigger('selectAutheticator', this.model.get('value'));
      }
    }), '.authenticator-button']];
  },
  minimize: function minimize() {
    this.$el.addClass('authenticator-row-min');
  }
});

var _default = _okta.ListView.extend({
  className: 'authenticator-verify-list authenticator-list',
  item: AuthenticatorRow,
  itemSelector: '.list-content',
  initialize: function initialize() {
    this.listenTo(this.collection, 'selectAutheticator', function (data) {
      this.model.set(this.options.name, data);
      this.options.appState.trigger('saveForm', this.model);
    });
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<div class=\"list-content\"></div>";
    },
    "useData": true
  })
});

exports.default = _default;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getV1ClassName = exports.getClassNameMapping = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(141));

var _RemediationConstants = __webpack_require__(57);

var _FORMS$IDENTIFY, _FORMNAME_CLASSNAME_M;

var FORMNAME_CLASSNAME_MAPPINGS = (_FORMNAME_CLASSNAME_M = {}, (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.IDENTIFY, (_FORMS$IDENTIFY = {}, (0, _defineProperty2.default)(_FORMS$IDENTIFY, _RemediationConstants.FORMS.IDENTIFY, 'primary-auth'), (0, _defineProperty2.default)(_FORMS$IDENTIFY, 'password', 'primary-auth'), _FORMS$IDENTIFY)), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.ENROLL_PROFILE, (0, _defineProperty2.default)({}, _RemediationConstants.FORMS.ENROLL_PROFILE, 'registration')), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.CHALLENGE_AUTHENTICATOR, {
  email: 'mfa-verify-passcode',
  password: 'mfa-verify-password',
  sms: 'mfa-verify-passcode',
  voice: 'mfa-verify-passcode',
  'security_question': 'mfa-verify-question',
  'security_key': 'mfa-verify-webauthn',
  app: 'mfa-verify'
}), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.CHALLENGE_POLL, {
  app: 'mfa-verify'
}), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.RESEND_PUSH, {
  app: 'mfa-verify'
}), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.ENROLL_AUTHENTICATOR, {
  email: 'enroll-email',
  password: 'enroll-password',
  sms: 'enroll-sms',
  voice: 'enroll-call',
  'security_question': 'enroll-question',
  'security_key': 'enroll-webauthn'
}), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL, {
  'select-authenticator-enroll': 'enroll-choices'
}), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, {
  'password': 'forgot-password'
}), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.REENROLL_AUTHENTICATOR, {
  'password': 'password-expired'
}), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.RESET_AUTHENTICATOR, {
  'password': 'forgot-password'
}), _FORMNAME_CLASSNAME_M);

var getV1ClassName = function getV1ClassName(formName, authenticatorType, methodType, isPasswordRecoveryFlow) {
  // if password reset flow from identifier page with recoveryAuthenticator add forgot-password class
  if (isPasswordRecoveryFlow && formName === _RemediationConstants.FORMS.IDENTIFY) {
    return 'forgot-password';
  } else {
    var type = formName;

    if (authenticatorType === 'phone') {
      // Both sms and call have same type phone
      // currentAuthenticatorEnrollment is during verify and currentAuthenticator during enroll flows
      type = "".concat(methodType);
    } else if (authenticatorType) {
      type = "".concat(authenticatorType);
    }

    if (FORMNAME_CLASSNAME_MAPPINGS[formName] && FORMNAME_CLASSNAME_MAPPINGS[formName][type]) {
      return FORMNAME_CLASSNAME_MAPPINGS[formName][type];
    } else {
      return null;
    }
  }
};

exports.getV1ClassName = getV1ClassName;

var getClassNameMapping = function getClassNameMapping(formName, authenticatorType, methodType, isPasswordRecoveryFlow) {
  // 1. Generates V2 class name
  // If we have a type which is authenticatorType/methodType use that to generate a V2 className
  // Otherwise just use formName
  var v2ClassName = formName;

  if (authenticatorType) {
    v2ClassName = v2ClassName + '--' + authenticatorType;
  }

  if (methodType && methodType !== authenticatorType) {
    v2ClassName = v2ClassName + '--' + methodType;
  } // 2. do a lookup for any V1 classNames and concat


  var v1ClassName = getV1ClassName(formName, authenticatorType, methodType, isPasswordRecoveryFlow);
  var result = [v2ClassName];

  if (v1ClassName) {
    result.push(v1ClassName);
  }

  return result;
};

exports.getClassNameMapping = getClassNameMapping;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.Body = void 0;

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _okta = __webpack_require__(0);

var Body = _BaseForm.default.extend({
  title: function title() {
    if (this.isPasswordRecoveryFlow()) {
      return (0, _okta.loc)('password.reset.title.generic', 'login');
    }

    return (0, _okta.loc)('oie.select.authenticators.verify.title', 'login');
  },
  subtitle: function subtitle() {
    if (this.isPasswordRecoveryFlow()) {
      return (0, _okta.loc)('oie.password.reset.verification', 'login');
    }

    return (0, _okta.loc)('oie.select.authenticators.verify.subtitle', 'login');
  },
  isPasswordRecoveryFlow: function isPasswordRecoveryFlow() {
    return this.options.appState.get('isPasswordRecovery');
  },
  noButtonBar: true
});

exports.Body = Body;

var _default = _BaseView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(899);
var path = __webpack_require__(15);

var Object = path.Object;

var getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
  return Object.getOwnPropertyDescriptor(it, key);
};

if (Object.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor.sham = true;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ResendView = exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(82));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _okta = __webpack_require__(0);

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var _Constants = __webpack_require__(147);

var ResendView = _okta.View.extend({
  // To be shown after a timeout
  className: 'phone-authenticator-challenge__resend-warning hide',
  events: {
    'click a.resend-link': 'handleResendLink'
  },
  // Override this to change the resend action location from response
  resendActionKey: 'currentAuthenticatorEnrollment-resend',
  initialize: function initialize() {
    var _context;

    var resendText = this.model.get('mode') === 'sms' ? (0, _okta.loc)('oie.phone.verify.sms.resendText', 'login') : (0, _okta.loc)('oie.phone.verify.call.resendText', 'login');
    var linkText = this.model.get('mode') === 'sms' ? (0, _okta.loc)('oie.phone.verify.sms.resendLinkText', 'login') : (0, _okta.loc)('oie.phone.verify.call.resendLinkText', 'login');
    this.add((0, _okta.createCallout)({
      content: (0, _concat.default)(_context = "".concat(resendText, "&nbsp;<a class='resend-link'>")).call(_context, linkText, "</a>"),
      type: 'warning'
    }));
  },
  handleResendLink: function handleResendLink() {
    this.options.appState.trigger('invokeAction', this.resendActionKey); // Hide warning, but start a timeout again..

    if (!this.el.classList.contains('hide')) {
      this.el.classList.add('hide');
    }

    this.showCalloutAfterTimeout();
  },
  postRender: function postRender() {
    this.showCalloutAfterTimeout();
  },
  showCalloutAfterTimeout: function showCalloutAfterTimeout() {
    var _this = this;

    this.showCalloutTimer = (0, _setTimeout2.default)(function () {
      _this.el.classList.remove('hide');
    }, _Constants.SHOW_RESEND_TIMEOUT);
  },
  remove: function remove() {
    _okta.View.prototype.remove.apply(this, arguments);

    clearTimeout(this.showCalloutTimer);
  }
});

exports.ResendView = ResendView;

var Body = _BaseForm.default.extend((0, _assign.default)({
  className: 'phone-authenticator-challenge',
  title: function title() {
    return (0, _okta.loc)('oie.phone.verify.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  },
  initialize: function initialize() {
    var _context2, _context3, _context4;

    _BaseForm.default.prototype.initialize.apply(this, arguments);

    var sendText = this.model.get('mode') === 'sms' ? (0, _okta.loc)('oie.phone.verify.sms.codeSentText', 'login') : (0, _okta.loc)('mfa.calling', 'login');
    var enterCodeText = (0, _okta.loc)('oie.phone.verify.enterCodeText', 'login'); // TODO: Clean-up post M1 when phoneNumber is available in all cases - enrollment & verification.

    var strongClass = this.model.get('phoneNumber') !== (0, _okta.loc)('oie.phone.alternate.title', 'login') ? 'strong' : ''; // Courage doesn't support HTML, hence creating a subtitle here.

    this.add((0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "<div class=\"okta-form-subtitle\" data-se=\"o-form-explain\">\n        ".concat(sendText, "&nbsp;<span class='")).call(_context4, strongClass, "'>")).call(_context3, this.model.escape('phoneNumber'), ".</span>\n        &nbsp;")).call(_context2, enterCodeText, "</div>"), {
      prepend: true,
      selector: '.o-form-fieldset-container'
    });
  },
  postRender: function postRender() {
    _BaseForm.default.prototype.postRender.apply(this, arguments);

    this.add(ResendView, {
      selector: '.o-form-error-container',
      prepend: true
    });
  }
}));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorVerifyFooter.default,
  createModelClass: function createModelClass() {
    var relatesToObject = this.options.currentViewState.relatesTo;

    var _ref = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {},
        methods = _ref.methods,
        profile = _ref.profile;

    var ModelClass = _BaseView.default.prototype.createModelClass.apply(this, arguments);

    var local = (0, _assign.default)({
      mode: {
        'value': methods[0].type,
        'type': 'string'
      },
      phoneNumber: {
        // TODO: Clean-up post M1 when phoneNumber is available in all cases - enrollment & verification.
        'value': (profile === null || profile === void 0 ? void 0 : profile.phoneNumber) ? profile.phoneNumber : (0, _okta.loc)('oie.phone.alternate.title', 'login'),
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local: local
    });
  }
});

exports.default = _default;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(7));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _email = _interopRequireDefault(__webpack_require__(371));

var _polling = _interopRequireDefault(__webpack_require__(127));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _Constants = __webpack_require__(147);

var ResendView = _okta.View.extend({
  className: 'hide resend-email-view',
  events: {
    'click a.resend-link': 'handelResendLink'
  },
  initialize: function initialize() {
    var _context;

    this.add((0, _okta.createCallout)({
      content: (0, _concat.default)(_context = "".concat((0, _okta.loc)('email.code.not.received', 'login'), "\n        <a class='resend-link'>")).call(_context, (0, _okta.loc)('email.button.resend', 'login'), "</a>"),
      type: 'warning'
    }));
  },
  handelResendLink: function handelResendLink() {
    this.options.appState.trigger('invokeAction', this.options.resendEmailAction); // Hide warning, but reinitiate to show warning again after some threshold of polling

    if (!this.$el.hasClass('hide')) {
      this.$el.addClass('hide');
    }

    this.showCalloutWithDelay();
  },
  postRender: function postRender() {
    this.showCalloutWithDelay();
  },
  showCalloutWithDelay: function showCalloutWithDelay() {
    var _this = this;

    this.showMeTimeout = _okta._.delay(function () {
      _this.$el.removeClass('hide');
    }, _Constants.SHOW_RESEND_TIMEOUT);
  },
  remove: function remove() {
    _okta.View.prototype.remove.apply(this, arguments);

    clearTimeout(this.showMeTimeout);
  }
});

var Body = _BaseForm.default.extend((0, _assign.default)({
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  },
  initialize: function initialize() {
    var _context2;

    _BaseForm.default.prototype.initialize.apply(this, arguments);

    this.add(ResendView, {
      selector: '.o-form-error-container',
      options: {
        resendEmailAction: this.resendEmailAction
      }
    });
    this.startPolling(); // polling has been killed when click save to avoid race conditions hence resume if save failed.

    this.listenTo(this.options.model, 'error', (0, _bind.default)(_context2 = this.startPolling).call(_context2, this));
  },
  saveForm: function saveForm() {
    _BaseForm.default.prototype.saveForm.apply(this, arguments);

    this.stopPolling();
  },
  remove: function remove() {
    _BaseForm.default.prototype.remove.apply(this, arguments);

    this.stopPolling();
  }
}, _email.default, _polling.default));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(0);

var _default = {
  title: function title() {
    if (this.options.currentViewState.name === 'enroll-factor') {
      return (0, _okta.loc)('email.enroll.title', 'login');
    } else {
      return (0, _okta.loc)('oie.email.mfa.title', 'login');
    }
  }
};
exports.default = _default;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(18));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _RemediationConstants = __webpack_require__(57);

var _default = _okta.View.extend({
  className: 'switch-channel-text',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"switch-channel-link\">" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.cannotScan"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 63
          },
          "end": {
            "line": 1,
            "column": 136
          }
        }
      })) != null ? stack1 : "") + "</a>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.switch.channel.link.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 148
          },
          "end": {
            "line": 1,
            "column": 228
          }
        }
      })) != null ? stack1 : "";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isQRcodeChannel") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.program(3, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 235
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    return {
      isQRcodeChannel: this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'qrcode'
    };
  },
  postRender: function postRender() {
    var _context,
        _this = this;

    (0, _find.default)(_context = this.$el).call(_context, '.switch-channel-link').on('click', function (event) {
      var appState = _this.options.appState;
      event.preventDefault();
      appState.trigger('switchForm', _RemediationConstants.FORMS.SELECT_ENROLLMENT_CHANNEL);
    });
  }
});

exports.default = _default;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getMessage = exports.default = void 0;

var _filter = _interopRequireDefault(__webpack_require__(37));

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _stringify = _interopRequireDefault(__webpack_require__(83));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

var _okta = __webpack_require__(0);

var _Bundles = _interopRequireDefault(__webpack_require__(125));

var _Logger = _interopRequireDefault(__webpack_require__(64));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
///////////////////////////////////////////////////////////////////////////////
//                                  How this transformer work?               //
//
// ## For Labels inside remediation forms
// 1. Figure out Path for all Labels (for normal field, or options) or Placeholder (for checkbox),e.g.
//   - `identify.identifier`, this is the label for user name at identify page
//   - `select-authenticator-enroll.authenticator.email`,
//      this is for label for email authenticator at `select-authenticator-enroll` page
// 2. Define a mapping between the path and i18n key. see `I18N_OVERRIDE_MAPPINGS`
//   - Not all path needs i18n override. e.g.
//     `challenge-authenticator.security_question.credentials.questionKey`,
//     which is security question during verify step and apparently it does not
//     need overwrite.
//   - This mapping is subject to change when API starts sending i18n key along with label.
//     It probably becomes a mapping between API's i18n key and key in login.properties
//     in order to be backward compatible.
// 3. Now find i18n value using such route: `i18n Path -> i18n key -> login.properties`
//    If found an i18n value, replace label by this i18n value.
//
// ## For top level messages
// 1. Overwrite `message.message` if `message.i18n.key` exists in `login.properties`
//
///////////////////////////////////////////////////////////////////////////////
var SECURITY_QUESTION_PREFIX = 'enroll-authenticator.security_question.credentials.questionKey.';
var I18N_OVERRIDE_MAPPINGS = {
  'identify.identifier': 'primaryauth.username.placeholder',
  'identify.credentials.passcode': 'primaryauth.password.placeholder',
  'identify.rememberMe': 'remember',
  'select-authenticator-enroll.authenticator.email': 'oie.authenticator.email.label',
  'select-authenticator-enroll.authenticator.password': 'oie.authenticator.password.label',
  'select-authenticator-enroll.authenticator.phone': 'oie.authenticator.phone.label',
  'select-authenticator-enroll.authenticator.security_key': 'oie.authenticator.webauthn.label',
  'select-authenticator-enroll.authenticator.security_question': 'oie.authenticator.security.question.label',
  'select-authenticator-enroll.authenticator.app': 'oie.authenticator.okta_verify.label',
  'select-authenticator-authenticate.authenticator.email': 'oie.authenticator.email.label',
  'select-authenticator-authenticate.authenticator.password': 'oie.authenticator.password.label',
  'select-authenticator-authenticate.authenticator.phone': 'oie.authenticator.phone.label',
  'select-authenticator-authenticate.authenticator.security_key': 'oie.authenticator.webauthn.label',
  'select-authenticator-authenticate.authenticator.security_question': 'oie.authenticator.security.question.label',
  'select-authenticator-authenticate.authenticator.app.signed_nonce': 'oie.okta_verify.signed_nonce.title',
  'select-authenticator-authenticate.authenticator.app.push': 'oie.okta_verify.push.title',
  'select-authenticator-authenticate.authenticator.app.totp': 'oie.okta_verify.totp.title',
  'authenticator-verification-data.app.authenticator.methodType.signed_nonce': 'oie.okta_verify.signed_nonce.title',
  'authenticator-verification-data.app.authenticator.methodType.push': 'oie.okta_verify.push.title',
  'authenticator-verification-data.app.authenticator.methodType.totp': 'oie.okta_verify.totp.title',
  'authenticator-enrollment-data.phone.authenticator.phoneNumber': 'mfa.phoneNumber.placeholder',
  'enroll-authenticator.password.credentials.passcode': 'oie.password.passwordLabel',
  'enroll-authenticator.security_question.sub_schema_local_credentials.0': 'oie.security.question.questionKey.label',
  'enroll-authenticator.security_question.sub_schema_local_credentials.1': 'oie.security.question.createQuestion.label',
  'enroll-authenticator.security_question.credentials.answer': 'mfa.challenge.answer.placeholder',
  'enroll-authenticator.security_question.credentials.question': 'oie.security.question.createQuestion.label',
  'enroll-authenticator.security_question.credentials.questionKey': 'oie.security.question.questionKey.label',
  'select-enrollment-channel.authenticator.channel.qrcode': 'oie.enroll.okta_verify.select.channel.qrcode.label',
  'select-enrollment-channel.authenticator.channel.email': 'oie.enroll.okta_verify.select.channel.email.label',
  'select-enrollment-channel.authenticator.channel.sms': 'oie.enroll.okta_verify.select.channel.sms.label',
  'challenge-authenticator.email.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'challenge-authenticator.password.credentials.passcode': 'mfa.challenge.password.placeholder',
  'challenge-authenticator.phone.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'challenge-authenticator.security_question.credentials.answer': 'mfa.challenge.answer.placeholder',
  'challenge-authenticator.app.credentials.totp': 'oie.okta_verify.totp.enterCodeText'
};

var getI18nKey = function getI18nKey(i18nPath) {
  var i18nKey; // we can add mapping to `I18N_OVERRIDE_MAPPINGS` for all
  // security question. It's just a bit tedious hence use following shortcut.

  if ((0, _indexOf.default)(i18nPath).call(i18nPath, SECURITY_QUESTION_PREFIX) === 0) {
    var securityQuestionValue = i18nPath.replace(SECURITY_QUESTION_PREFIX, '');
    i18nKey = "security.".concat(securityQuestionValue);
  }

  if (I18N_OVERRIDE_MAPPINGS[i18nPath]) {
    i18nKey = I18N_OVERRIDE_MAPPINGS[i18nPath];
  }

  if (i18nKey && !_Bundles.default.login[i18nKey]) {
    var _context;

    _Logger.default.warn((0, _concat.default)(_context = "expect i18n key ".concat(i18nKey, " for ")).call(_context, i18nPath, " but not found in 'login' bundle."));

    i18nKey = null;
  }

  return i18nKey;
};
/**
 * Find i18n value using {@code i18nPath} if it exists.
 * Otherwise return {@code defaultValue}.
 *
 * @param {string} i18nPath
 * @param {string} defaultValue
 */


var getI18NValue = function getI18NValue(i18nPath, defaultValue) {
  var i18nKey = getI18nKey(i18nPath);

  if (i18nKey) {
    return (0, _okta.loc)(i18nKey, 'login');
  } else {
    return defaultValue;
  }
};

var updateLabelForUiSchema = function updateLabelForUiSchema(remediation, uiSchema) {
  var _remediation$relatesT, _remediation$relatesT2, _context2, _context3;

  if (uiSchema.mutable === false) {
    return;
  }

  _Logger.default.info('i18n label transformer');

  _Logger.default.info('\t remediationName: ', remediation.name);

  _Logger.default.info('\t uiSchema: ', (0, _stringify.default)(uiSchema));

  var authenticatorType = ((_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.type) ? ".".concat(remediation.relatesTo.value.type) : '';
  var i18nPrefix = (0, _concat.default)(_context2 = "".concat(remediation.name)).call(_context2, authenticatorType, ".");
  var i18nPath = (0, _concat.default)(_context3 = "".concat(i18nPrefix)).call(_context3, uiSchema.name);

  if (uiSchema.type === 'checkbox' && uiSchema.placeholder) {
    _Logger.default.info('\t 1: ', i18nPath);

    uiSchema.placeholder = getI18NValue(i18nPath, uiSchema.placeholder);
  }

  if (uiSchema.label) {
    _Logger.default.info('\t 2: ', i18nPath);

    uiSchema.label = getI18NValue(i18nPath, uiSchema.label);
  }

  if (_okta.$.isPlainObject(uiSchema.options)) {
    uiSchema.options = _okta._.mapObject(uiSchema.options, function (value, key) {
      var _context4;

      var i18nPathOption = (0, _concat.default)(_context4 = "".concat(i18nPath, ".")).call(_context4, key);

      _Logger.default.info('\t 3: ', i18nPathOption);

      return getI18NValue(i18nPathOption, value);
    });
  }

  if ((0, _isArray.default)(uiSchema.options)) {
    var _context5;

    (0, _forEach.default)(_context5 = uiSchema.options).call(_context5, function (o) {
      if (!o.label) {
        return;
      }

      var i18nPathOption;

      if (o.authenticatorType) {
        var _context6, _o$value;

        i18nPathOption = (0, _concat.default)(_context6 = "".concat(i18nPath, ".")).call(_context6, o.authenticatorType);
        var methodType = (_o$value = o.value) === null || _o$value === void 0 ? void 0 : _o$value.methodType;

        if (o.authenticatorType === 'app' && methodType) {
          var _context7;

          i18nPathOption = (0, _concat.default)(_context7 = "".concat(i18nPathOption, ".")).call(_context7, methodType);
        }
      } else if (o.value !== undefined) {
        var _context8;

        // value could be string or number or undefined.
        i18nPathOption = (0, _concat.default)(_context8 = "".concat(i18nPath, ".")).call(_context8, o.value);
      }

      _Logger.default.info('\t 4: ', i18nPathOption);

      o.label = getI18NValue(i18nPathOption, o.label);
    });
  }

  if ((0, _isArray.default)(uiSchema.optionsUiSchemas)) {
    var _context9;

    (0, _forEach.default)(_context9 = uiSchema.optionsUiSchemas).call(_context9, function (optionsUiSchema) {
      (0, _forEach.default)(optionsUiSchema).call(optionsUiSchema, function (uiSchema) {
        return updateLabelForUiSchema(remediation, uiSchema);
      });
    });
  }
};
/**
 * @typedef {Object} Message
 * @property {string} message
 * @property {Object=} i18n
 * @property {string} i18n.key
 * @property {string[]} i18n.params
 */

/**
 * - iff `message.i18n.key` exists and has value in 'login.properties', return the value.
 * - otherwise returns `message.message`
 *
 * @param {Message} message
 */


var getMessage = function getMessage(message) {
  var _message$i18n;

  if ((_message$i18n = message.i18n) === null || _message$i18n === void 0 ? void 0 : _message$i18n.key) {
    var i18nKey = message.i18n.key;

    if (_Bundles.default.login[i18nKey]) {
      _Logger.default.info("Override messages using i18n key ".concat(i18nKey)); // expect user config i18n properly.
      // e.g. the i18n value shall have placeholders like `{0}`, when params is not empty.


      return (0, _okta.loc)(i18nKey, 'login', message.i18n.params || []);
    }
  }

  return message.message;
};

exports.getMessage = getMessage;

var uiSchemaLabelTransformer = function uiSchemaLabelTransformer(transformedResp) {
  var _transformedResp$mess;

  // Try to override label using i18n value
  if ((0, _isArray.default)(transformedResp.remediations)) {
    var _context10, _context11;

    (0, _forEach.default)(_context10 = (0, _filter.default)(_context11 = transformedResp.remediations).call(_context11, function (remediation) {
      return (0, _isArray.default)(remediation.uiSchema) && remediation.uiSchema.length;
    })).call(_context10, function (remediation) {
      var _context12;

      (0, _forEach.default)(_context12 = remediation.uiSchema).call(_context12, function (uiSchema) {
        return updateLabelForUiSchema(remediation, uiSchema);
      });
    });
  } // Try to override `messages` using i18n value.
  // 1. This is only handling top level `messages` object when response status is 200.
  // 2. See `IonResponseHelper.js` where handle `messages` object when none 200 response.
  // 3. Handling `messages` in remediation forms on 200 response is not considered yet.
  //    Is that possible?


  if ((0, _isArray.default)((_transformedResp$mess = transformedResp.messages) === null || _transformedResp$mess === void 0 ? void 0 : _transformedResp$mess.value)) {
    var _context13;

    (0, _forEach.default)(_context13 = transformedResp.messages.value).call(_context13, function (message) {
      message.message = getMessage(message);
    });
  }

  return transformedResp;
};

exports.default = uiSchemaLabelTransformer;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(375);
module.exports = __webpack_require__(560);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(376);

var _global = _interopRequireDefault(__webpack_require__(547));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

if (_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

_global["default"]._babelPolyfill = true;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(377);

__webpack_require__(520);

__webpack_require__(522);

__webpack_require__(525);

__webpack_require__(527);

__webpack_require__(529);

__webpack_require__(531);

__webpack_require__(533);

__webpack_require__(535);

__webpack_require__(537);

__webpack_require__(539);

__webpack_require__(541);

__webpack_require__(543);

__webpack_require__(275);

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(378);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(207);
__webpack_require__(483);
__webpack_require__(264);
__webpack_require__(484);
__webpack_require__(265);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(266);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
module.exports = __webpack_require__(30);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(11);
var has = __webpack_require__(53);
var DESCRIPTORS = __webpack_require__(33);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(49);
var META = __webpack_require__(87).KEY;
var $fails = __webpack_require__(12);
var shared = __webpack_require__(148);
var setToStringTag = __webpack_require__(114);
var uid = __webpack_require__(95);
var wks = __webpack_require__(21);
var wksExt = __webpack_require__(188);
var wksDefine = __webpack_require__(245);
var enumKeys = __webpack_require__(380);
var isArray = __webpack_require__(151);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(14);
var toObject = __webpack_require__(44);
var toIObject = __webpack_require__(55);
var toPrimitive = __webpack_require__(86);
var createDesc = __webpack_require__(94);
var _create = __webpack_require__(99);
var gOPNExt = __webpack_require__(248);
var $GOPD = __webpack_require__(69);
var $GOPS = __webpack_require__(150);
var $DP = __webpack_require__(34);
var $keys = __webpack_require__(97);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(100).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(129).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(96)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(54)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(148)('native-function-to-string', Function.toString);


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(97);
var gOPS = __webpack_require__(150);
var pIE = __webpack_require__(129);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(99) });


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperty: __webpack_require__(34).f });


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperties: __webpack_require__(247) });


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(55);
var $getOwnPropertyDescriptor = __webpack_require__(69).f;

__webpack_require__(70)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(44);
var $getPrototypeOf = __webpack_require__(101);

__webpack_require__(70)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(44);
var $keys = __webpack_require__(97);

__webpack_require__(70)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(70)('getOwnPropertyNames', function () {
  return __webpack_require__(248).f;
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(14);
var meta = __webpack_require__(87).onFreeze;

__webpack_require__(70)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(14);
var meta = __webpack_require__(87).onFreeze;

__webpack_require__(70)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(14);
var meta = __webpack_require__(87).onFreeze;

__webpack_require__(70)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(14);

__webpack_require__(70)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(14);

__webpack_require__(70)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(14);

__webpack_require__(70)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(249) });


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { is: __webpack_require__(250) });


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(192).set });


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(130);
var test = {};
test[__webpack_require__(21)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(49)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(2);

$export($export.P, 'Function', { bind: __webpack_require__(251) });


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(33) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(14);
var getPrototypeOf = __webpack_require__(101);
var HAS_INSTANCE = __webpack_require__(21)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(34).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(253);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(254);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var has = __webpack_require__(53);
var cof = __webpack_require__(76);
var inheritIfRequired = __webpack_require__(194);
var toPrimitive = __webpack_require__(86);
var fails = __webpack_require__(12);
var gOPN = __webpack_require__(100).f;
var gOPD = __webpack_require__(69).f;
var dP = __webpack_require__(34).f;
var $trim = __webpack_require__(115).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(99)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(33) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(49)(global, NUMBER, $Number);
}


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toInteger = __webpack_require__(68);
var aNumberValue = __webpack_require__(255);
var repeat = __webpack_require__(195);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(12)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $fails = __webpack_require__(12);
var aNumberValue = __webpack_require__(255);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(2);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(2);
var _isFinite = __webpack_require__(11).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', { isInteger: __webpack_require__(256) });


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(2);
var isInteger = __webpack_require__(256);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(254);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(253);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(2);
var log1p = __webpack_require__(257);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(2);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(2);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(2);
var sign = __webpack_require__(196);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(2);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(2);
var $expm1 = __webpack_require__(197);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { fround: __webpack_require__(423) });


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(196);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(2);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(2);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(12)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { log1p: __webpack_require__(257) });


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { sign: __webpack_require__(196) });


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(197);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(12)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(197);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(98);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(55);
var toLength = __webpack_require__(25);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(115)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(198)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(199)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $at = __webpack_require__(198)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(25);
var context = __webpack_require__(200);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(202)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(2);
var context = __webpack_require__(200);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(202)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(195)
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(25);
var context = __webpack_require__(200);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(202)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(50)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(50)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(50)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(50)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(50)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(50)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(50)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(50)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(50)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(50)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(50)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(50)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(50)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(2);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(44);
var toPrimitive = __webpack_require__(86);

$export($export.P + $export.F * __webpack_require__(12)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(2);
var toISOString = __webpack_require__(458);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(12);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(49)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(21)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(54)(proto, TO_PRIMITIVE, __webpack_require__(461));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(86);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(2);

$export($export.S, 'Array', { isArray: __webpack_require__(151) });


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(66);
var $export = __webpack_require__(2);
var toObject = __webpack_require__(44);
var call = __webpack_require__(259);
var isArrayIter = __webpack_require__(203);
var toLength = __webpack_require__(25);
var createProperty = __webpack_require__(204);
var getIterFn = __webpack_require__(205);

$export($export.S + $export.F * !__webpack_require__(152)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var createProperty = __webpack_require__(204);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(12)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(2);
var toIObject = __webpack_require__(55);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(128) != Object || !__webpack_require__(58)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var html = __webpack_require__(191);
var cof = __webpack_require__(76);
var toAbsoluteIndex = __webpack_require__(98);
var toLength = __webpack_require__(25);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(12)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var aFunction = __webpack_require__(67);
var toObject = __webpack_require__(44);
var fails = __webpack_require__(12);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(58)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $forEach = __webpack_require__(71)(0);
var STRICT = __webpack_require__(58)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var isArray = __webpack_require__(151);
var SPECIES = __webpack_require__(21)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $map = __webpack_require__(71)(1);

$export($export.P + $export.F * !__webpack_require__(58)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $filter = __webpack_require__(71)(2);

$export($export.P + $export.F * !__webpack_require__(58)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $some = __webpack_require__(71)(3);

$export($export.P + $export.F * !__webpack_require__(58)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $every = __webpack_require__(71)(4);

$export($export.P + $export.F * !__webpack_require__(58)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(261);

$export($export.P + $export.F * !__webpack_require__(58)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(261);

$export($export.P + $export.F * !__webpack_require__(58)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $indexOf = __webpack_require__(149)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(58)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(55);
var toInteger = __webpack_require__(68);
var toLength = __webpack_require__(25);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(58)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { copyWithin: __webpack_require__(262) });

__webpack_require__(102)('copyWithin');


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { fill: __webpack_require__(206) });

__webpack_require__(102)('fill');


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(71)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(102)(KEY);


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(71)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(102)(KEY);


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(117)('Array');


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var inheritIfRequired = __webpack_require__(194);
var dP = __webpack_require__(34).f;
var gOPN = __webpack_require__(100).f;
var isRegExp = __webpack_require__(201);
var $flags = __webpack_require__(153);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(33) && (!CORRECT_NEW || __webpack_require__(12)(function () {
  re2[__webpack_require__(21)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(49)(global, 'RegExp', $RegExp);
}

__webpack_require__(117)('RegExp');


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(265);
var anObject = __webpack_require__(13);
var $flags = __webpack_require__(153);
var DESCRIPTORS = __webpack_require__(33);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(49)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(12)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var toLength = __webpack_require__(25);
var advanceStringIndex = __webpack_require__(209);
var regExpExec = __webpack_require__(154);

// @@match logic
__webpack_require__(155)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var toObject = __webpack_require__(44);
var toLength = __webpack_require__(25);
var toInteger = __webpack_require__(68);
var advanceStringIndex = __webpack_require__(209);
var regExpExec = __webpack_require__(154);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(155)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var sameValue = __webpack_require__(250);
var regExpExec = __webpack_require__(154);

// @@search logic
__webpack_require__(155)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(201);
var anObject = __webpack_require__(13);
var speciesConstructor = __webpack_require__(131);
var advanceStringIndex = __webpack_require__(209);
var toLength = __webpack_require__(25);
var callRegExpExec = __webpack_require__(154);
var regexpExec = __webpack_require__(208);
var fails = __webpack_require__(12);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(155)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var macrotask = __webpack_require__(210).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(76)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(269);
var validate = __webpack_require__(103);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(158)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(269);
var validate = __webpack_require__(103);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(158)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var each = __webpack_require__(71)(0);
var redefine = __webpack_require__(49);
var meta = __webpack_require__(87);
var assign = __webpack_require__(249);
var weak = __webpack_require__(270);
var isObject = __webpack_require__(14);
var validate = __webpack_require__(103);
var NATIVE_WEAK_MAP = __webpack_require__(103);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(158)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(270);
var validate = __webpack_require__(103);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(158)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $typed = __webpack_require__(159);
var buffer = __webpack_require__(211);
var anObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(98);
var toLength = __webpack_require__(25);
var isObject = __webpack_require__(14);
var ArrayBuffer = __webpack_require__(11).ArrayBuffer;
var speciesConstructor = __webpack_require__(131);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(12)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(117)(ARRAY_BUFFER);


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
$export($export.G + $export.W + $export.F * !__webpack_require__(159).ABV, {
  DataView: __webpack_require__(211).DataView
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(67);
var anObject = __webpack_require__(13);
var rApply = (__webpack_require__(11).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(12)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(2);
var create = __webpack_require__(99);
var aFunction = __webpack_require__(67);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(12);
var bind = __webpack_require__(251);
var rConstruct = (__webpack_require__(11).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(34);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(86);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(12)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(2);
var gOPD = __webpack_require__(69).f;
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(13);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(258)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(101);
var has = __webpack_require__(53);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(14);
var anObject = __webpack_require__(13);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(69);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(2);
var getProto = __webpack_require__(101);
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(13);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(272) });


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(13);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(34);
var gOPD = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(101);
var has = __webpack_require__(53);
var $export = __webpack_require__(2);
var createDesc = __webpack_require__(94);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(14);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(2);
var setProto = __webpack_require__(192);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(521);
module.exports = __webpack_require__(30).Array.includes;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(2);
var $includes = __webpack_require__(149)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(102)('includes');


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(523);
module.exports = __webpack_require__(30).Array.flatMap;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(524);
var toObject = __webpack_require__(44);
var toLength = __webpack_require__(25);
var aFunction = __webpack_require__(67);
var arraySpeciesCreate = __webpack_require__(260);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(102)('flatMap');


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(151);
var isObject = __webpack_require__(14);
var toLength = __webpack_require__(25);
var ctx = __webpack_require__(66);
var IS_CONCAT_SPREADABLE = __webpack_require__(21)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(526);
module.exports = __webpack_require__(30).String.padStart;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(273);
var userAgent = __webpack_require__(157);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(528);
module.exports = __webpack_require__(30).String.padEnd;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(273);
var userAgent = __webpack_require__(157);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(530);
module.exports = __webpack_require__(30).String.trimLeft;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(115)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(532);
module.exports = __webpack_require__(30).String.trimRight;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(115)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(534);
module.exports = __webpack_require__(188).f('asyncIterator');


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(245)('asyncIterator');


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(536);
module.exports = __webpack_require__(30).Object.getOwnPropertyDescriptors;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(2);
var ownKeys = __webpack_require__(272);
var toIObject = __webpack_require__(55);
var gOPD = __webpack_require__(69);
var createProperty = __webpack_require__(204);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(538);
module.exports = __webpack_require__(30).Object.values;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $values = __webpack_require__(274)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(540);
module.exports = __webpack_require__(30).Object.entries;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $entries = __webpack_require__(274)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(266);
__webpack_require__(542);
module.exports = __webpack_require__(30).Promise['finally'];


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(2);
var core = __webpack_require__(30);
var global = __webpack_require__(11);
var speciesConstructor = __webpack_require__(131);
var promiseResolve = __webpack_require__(268);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
module.exports = __webpack_require__(30);


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(11);
var $export = __webpack_require__(2);
var userAgent = __webpack_require__(157);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $task = __webpack_require__(210);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(207);
var getKeys = __webpack_require__(97);
var redefine = __webpack_require__(49);
var global = __webpack_require__(11);
var hide = __webpack_require__(54);
var Iterators = __webpack_require__(116);
var wks = __webpack_require__(21);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(548);
module.exports = __webpack_require__(276).global;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(549);

$export($export.G, { global: __webpack_require__(212) });


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(212);
var core = __webpack_require__(276);
var ctx = __webpack_require__(550);
var hide = __webpack_require__(552);
var has = __webpack_require__(559);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(551);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(553);
var createDesc = __webpack_require__(558);
module.exports = __webpack_require__(214) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(554);
var IE8_DOM_DEFINE = __webpack_require__(555);
var toPrimitive = __webpack_require__(557);
var dP = Object.defineProperty;

exports.f = __webpack_require__(214) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(213);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(214) && !__webpack_require__(277)(function () {
  return Object.defineProperty(__webpack_require__(556)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(213);
var document = __webpack_require__(212).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(213);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 559 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*globals module */
var OktaSignIn = function () {
  var _ = __webpack_require__(215);

  var config = __webpack_require__(216);

  var OAuth2Util = __webpack_require__(217);

  var Util = __webpack_require__(24);

  var OktaAuth = __webpack_require__(715);

  var V1Router = __webpack_require__(716);

  var V2Router = __webpack_require__(868);

  var router;

  function getProperties(authClient, Router) {
    var widgetOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    function render(renderOptions, successFn, errorFn) {
      if (router) {
        throw new Error('An instance of the widget has already been rendered. Call remove() first.');
      }
      /**
       * -- Development Mode --
       * When the page loads, provide a helpful message to remind the developer that
       * tokens have not been removed from the hash fragment.
       */


      if (this.hasTokensInUrl()) {
        Util.debugMessage("\n            Looks like there are still tokens in the URL! Don't forget to parse and store them.\n            See: https://github.com/okta/okta-signin-widget/#hastokensinurl\n          ");
      }

      router = new Router(_.extend({}, widgetOptions, renderOptions, {
        authClient: authClient,
        globalSuccessFn: successFn,
        globalErrorFn: errorFn
      }));
      router.start();
    }

    function hide() {
      if (router) {
        router.hide();
      }
    }

    function show() {
      if (router) {
        router.show();
      }
    }

    function remove() {
      if (router) {
        router.remove();
        router = undefined;
      }
    }
    /**
     * Check if tokens or a code have been passed back into the url, which happens in
     * the social auth IDP redirect flow.
     */


    function hasTokensInUrl() {
      var authParams = this.authClient.options;

      if (authParams.pkce || authParams.responseType === 'code' || authParams.responseMode === 'query') {
        // Look for code
        return authParams.responseMode === 'fragment' ? Util.hasCodeInUrl(window.location.hash) : Util.hasCodeInUrl(window.location.search);
      } // Look for tokens (Implicit OIDC flow)


      return Util.hasTokensInHash(window.location.hash);
    }
    /**
     * Renders the Widget with opinionated defaults for the full-page
     * redirect flow.
     * @param options - options for the signin widget
     */


    function showSignInToGetTokens(options) {
      var renderOptions = OAuth2Util.transformShowSignInToGetTokensOptions(options, config);
      return render.call(this, renderOptions);
    } // Properties exposed on OktaSignIn object.


    return {
      renderEl: render,
      authClient: authClient,
      showSignInToGetTokens: showSignInToGetTokens,
      hasTokensInUrl: hasTokensInUrl,
      hide: hide,
      show: show,
      remove: remove
    };
  }

  function createAuthClient(options) {
    var authParams = _.extend({
      transformErrorXHR: Util.transformErrorXHR,
      headers: {
        'X-Okta-User-Agent-Extended': 'okta-signin-widget-' + config.version
      },
      clientId: options.clientId,
      redirectUri: options.redirectUri
    }, options.authParams);

    if (!authParams.issuer) {
      authParams.issuer = options.baseUrl + '/oauth2/default';
    }

    return new OktaAuth(authParams);
  }
  /**
   * Render the sign in widget to an element.
   * @param options - options for the signin widget.
   *        Must have an el or $el property to render the widget to.
   * @param success - success callback function
   * @param error - error callback function
   */


  function OktaSignIn(options) {
    Util.debugMessage("\n        The Okta Sign-In Widget is running in development mode.\n        When you are ready to publish your app, embed the minified version to turn on production mode.\n        See: https://developer.okta.com/code/javascript/okta_sign-in_widget#cdn\n      ");
    var authClient = createAuthClient(options);
    var Router;

    if (options.stateToken && !Util.isV1StateToken(options.stateToken)) {
      Router = V2Router;
    } else {
      Router = V1Router;
    }

    _.extend(this, Router.prototype.Events);

    _.extend(this, getProperties(authClient, Router, options)); // Triggers the event up the chain so it is available to the consumers of the widget.


    this.listenTo(Router.prototype, 'all', this.trigger); // On the first afterRender event (usually when the Widget is ready) - emit a 'ready' event

    this.once('afterRender', function (context) {
      this.trigger('ready', context);
    });
  }

  return OktaSignIn;
}();

module.exports = OktaSignIn;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(562);

module.exports = parent;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(563);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.indexOf) ? indexOf : own;
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(564);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').indexOf;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $indexOf = __webpack_require__(219).indexOf;
var arrayMethodIsStrict = __webpack_require__(108);
var arrayMethodUsesToLength = __webpack_require__(51);

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(566);

module.exports = parent;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var splice = __webpack_require__(567);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.splice;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.splice) ? splice : own;
};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(568);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').splice;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(163);
var toInteger = __webpack_require__(120);
var toLength = __webpack_require__(47);
var toObject = __webpack_require__(52);
var arraySpeciesCreate = __webpack_require__(164);
var createProperty = __webpack_require__(121);
var arrayMethodHasSpeciesSupport = __webpack_require__(133);
var arrayMethodUsesToLength = __webpack_require__(51);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var createNonEnumerableProperty = __webpack_require__(61);

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(571);

module.exports = parent;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var arrayIncludes = __webpack_require__(572);
var stringIncludes = __webpack_require__(574);

var ArrayPrototype = Array.prototype;
var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.includes;
  if (it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.includes)) return arrayIncludes;
  if (typeof it === 'string' || it === StringPrototype || (it instanceof String && own === StringPrototype.includes)) {
    return stringIncludes;
  } return own;
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(573);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').includes;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $includes = __webpack_require__(219).includes;
var addToUnscopables = __webpack_require__(122);
var arrayMethodUsesToLength = __webpack_require__(51);

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(575);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('String').includes;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var notARegExp = __webpack_require__(224);
var requireObjectCoercible = __webpack_require__(107);
var correctIsRegExpLogic = __webpack_require__(225);

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);
var classof = __webpack_require__(106);
var wellKnownSymbol = __webpack_require__(23);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(282);

module.exports = parent;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var isArray = __webpack_require__(110);

// `Array.isArray` method
// https://tc39.github.io/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(580);

module.exports = parent;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var lastIndexOf = __webpack_require__(581);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.lastIndexOf;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.lastIndexOf) ? lastIndexOf : own;
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(582);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').lastIndexOf;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var lastIndexOf = __webpack_require__(583);

// `Array.prototype.lastIndexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(59);
var toInteger = __webpack_require__(120);
var toLength = __webpack_require__(47);
var arrayMethodIsStrict = __webpack_require__(108);
var arrayMethodUsesToLength = __webpack_require__(51);

var min = Math.min;
var nativeLastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!nativeLastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
// For preventing possible almost infinite loop in non-standard implementations, test the forward version of the method
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return nativeLastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : nativeLastIndexOf;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(585);

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(586);

module.exports = parent;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var reverse = __webpack_require__(587);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reverse;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.reverse) ? reverse : own;
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(588);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').reverse;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var isArray = __webpack_require__(110);

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(590);

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(591);

module.exports = parent;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var flat = __webpack_require__(592);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.flat;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.flat) ? flat : own;
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(593);
__webpack_require__(595);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').flat;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var flattenIntoArray = __webpack_require__(594);
var toObject = __webpack_require__(52);
var toLength = __webpack_require__(47);
var toInteger = __webpack_require__(120);
var arraySpeciesCreate = __webpack_require__(164);

// `Array.prototype.flat` method
// https://github.com/tc39/proposal-flatMap
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(110);
var toLength = __webpack_require__(47);
var bind = __webpack_require__(88);

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(122);

addToUnscopables('flat');


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(597);

module.exports = parent;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var flags = __webpack_require__(598);

var RegExpPrototype = RegExp.prototype;

module.exports = function (it) {
  return (it === RegExpPrototype || it instanceof RegExp) && !('flags' in it) ? flags(it) : it.flags;
};


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(599);
var flags = __webpack_require__(600);

module.exports = function (it) {
  return flags.call(it);
};


/***/ }),
/* 599 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(43);

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79);
var forEach = __webpack_require__(605);
var classof = __webpack_require__(81);
var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.forEach;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.forEach)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables.hasOwnProperty(classof(it)) ? forEach : own;
};


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(227);
var classof = __webpack_require__(81);

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),
/* 604 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(606);

module.exports = parent;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(607);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').forEach;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var forEach = __webpack_require__(608);

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(73).forEach;
var arrayMethodIsStrict = __webpack_require__(108);
var arrayMethodUsesToLength = __webpack_require__(51);

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(610);

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(611);

module.exports = parent;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var every = __webpack_require__(612);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.every;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.every) ? every : own;
};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(613);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').every;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $every = __webpack_require__(73).every;
var arrayMethodIsStrict = __webpack_require__(108);
var arrayMethodUsesToLength = __webpack_require__(51);

var STRICT_METHOD = arrayMethodIsStrict('every');
var USES_TO_LENGTH = arrayMethodUsesToLength('every');

// `Array.prototype.every` method
// https://tc39.github.io/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(615);

module.exports = parent;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var some = __webpack_require__(616);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.some;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.some) ? some : own;
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(617);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').some;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $some = __webpack_require__(73).some;
var arrayMethodIsStrict = __webpack_require__(108);
var arrayMethodUsesToLength = __webpack_require__(51);

var STRICT_METHOD = arrayMethodIsStrict('some');
var USES_TO_LENGTH = arrayMethodUsesToLength('some');

// `Array.prototype.some` method
// https://tc39.github.io/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(619);

module.exports = parent;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var findIndex = __webpack_require__(620);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.findIndex;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.findIndex) ? findIndex : own;
};


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(621);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').findIndex;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $findIndex = __webpack_require__(73).findIndex;
var addToUnscopables = __webpack_require__(122);
var arrayMethodUsesToLength = __webpack_require__(51);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(623);

module.exports = parent;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var concat = __webpack_require__(624);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.concat;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.concat) ? concat : own;
};


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(296);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').concat;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(626);

module.exports = parent;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var filter = __webpack_require__(627);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.filter;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.filter) ? filter : own;
};


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(628);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').filter;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $filter = __webpack_require__(73).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(133);
var arrayMethodUsesToLength = __webpack_require__(51);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(630);

module.exports = parent;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var reduce = __webpack_require__(631);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reduce;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.reduce) ? reduce : own;
};


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(632);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').reduce;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $reduce = __webpack_require__(633).left;
var arrayMethodIsStrict = __webpack_require__(108);
var arrayMethodUsesToLength = __webpack_require__(51);

var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(60);
var toObject = __webpack_require__(52);
var IndexedObject = __webpack_require__(161);
var toLength = __webpack_require__(47);

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(635);

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79);
var values = __webpack_require__(636);
var classof = __webpack_require__(81);
var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.values;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.values)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables.hasOwnProperty(classof(it)) ? values : own;
};


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(637);

module.exports = parent;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').values;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(639);

module.exports = parent;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var map = __webpack_require__(640);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.map;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.map) ? map : own;
};


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(641);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').map;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $map = __webpack_require__(73).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(133);
var arrayMethodUsesToLength = __webpack_require__(51);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(297);
var path = __webpack_require__(15);

module.exports = path.setInterval;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(297);
var path = __webpack_require__(15);

module.exports = path.setTimeout;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(645);

module.exports = parent;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var find = __webpack_require__(646);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.find;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.find) ? find : own;
};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(647);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').find;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $find = __webpack_require__(73).find;
var addToUnscopables = __webpack_require__(122);
var arrayMethodUsesToLength = __webpack_require__(51);

var FIND = 'find';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(649);

module.exports = parent;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(650);

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.trim;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.trim) ? trim : own;
};


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(651);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('String').trim;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $trim = __webpack_require__(228).trim;
var forcedStringTrimMethod = __webpack_require__(652);

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(20);
var whitespaces = __webpack_require__(170);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(654);

module.exports = parent;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(655);
var path = __webpack_require__(15);

module.exports = path.parseInt;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var parseIntImplementation = __webpack_require__(656);

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var trim = __webpack_require__(228).trim;
var whitespaces = __webpack_require__(170);

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(658);

module.exports = parent;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(659);
var path = __webpack_require__(15);

module.exports = path.parseFloat;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var parseFloatImplementation = __webpack_require__(660);

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat != parseFloatImplementation }, {
  parseFloat: parseFloatImplementation
});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var trim = __webpack_require__(228).trim;
var whitespaces = __webpack_require__(170);

var $parseFloat = global.parseFloat;
var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
  var trimmedString = trim(String(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79);
var keys = __webpack_require__(662);
var classof = __webpack_require__(81);
var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.keys;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.keys)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables.hasOwnProperty(classof(it)) ? keys : own;
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(663);

module.exports = parent;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').keys;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(665);

module.exports = parent;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(666);
var core = __webpack_require__(15);

if (!core.JSON) core.JSON = { stringify: JSON.stringify };

// eslint-disable-next-line no-unused-vars
module.exports = function stringify(it, replacer, space) {
  return core.JSON.stringify.apply(null, arguments);
};


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var getBuiltIn = __webpack_require__(72);
var fails = __webpack_require__(20);

var $stringify = getBuiltIn('JSON', 'stringify');
var re = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = string.charAt(offset - 1);
  var next = string.charAt(offset + 1);
  if ((low.test(match) && !hi.test(next)) || (hi.test(match) && !low.test(prev))) {
    return '\\u' + match.charCodeAt(0).toString(16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // https://github.com/tc39/proposal-well-formed-stringify
  $({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var result = $stringify.apply(null, arguments);
      return typeof result == 'string' ? result.replace(re, fix) : result;
    }
  });
}


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(299);

module.exports = parent;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(669);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').slice;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var isObject = __webpack_require__(31);
var isArray = __webpack_require__(110);
var toAbsoluteIndex = __webpack_require__(163);
var toLength = __webpack_require__(47);
var toIndexedObject = __webpack_require__(59);
var createProperty = __webpack_require__(121);
var wellKnownSymbol = __webpack_require__(23);
var arrayMethodHasSpeciesSupport = __webpack_require__(133);
var arrayMethodUsesToLength = __webpack_require__(51);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(671);

module.exports = parent;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(672);

var FunctionPrototype = Function.prototype;

module.exports = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (it instanceof Function && own === FunctionPrototype.bind) ? bind : own;
};


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(673);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Function').bind;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var bind = __webpack_require__(674);

// `Function.prototype.bind` method
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true }, {
  bind: bind
});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(60);
var isObject = __webpack_require__(31);

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(301);

module.exports = parent;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(120);
var requireObjectCoercible = __webpack_require__(107);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(304);

module.exports = parent;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),
/* 679 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.hasInstance` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.match` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.matchAll` well-known symbol
defineWellKnownSymbol('matchAll');


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.replace` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.search` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.species` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.split` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.unscopables` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(310);

module.exports = parent;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(39);
var objectDefinePropertyModile = __webpack_require__(62);

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperty: objectDefinePropertyModile.f
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(74);

exports['default'] = function (instance) {
  instance.registerHelper('blockHelperMissing', function (context, options) {
    var inverse = options.inverse,
        fn = options.fn;

    if (context === true) {
      return fn(this);
    } else if (context === false || context == null) {
      return inverse(this);
    } else if (_utils.isArray(context)) {
      if (context.length > 0) {
        if (options.ids) {
          options.ids = [options.name];
        }

        return instance.helpers.each(context, options);
      } else {
        return inverse(this);
      }
    } else {
      if (options.data && options.ids) {
        var data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
        options = { data: data };
      }

      return fn(context, options);
    }
  });
};

module.exports = exports['default'];


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(74);

var _exception = __webpack_require__(112);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('each', function (context, options) {
    if (!options) {
      throw new _exception2['default']('Must pass iterator to #each');
    }

    var fn = options.fn,
        inverse = options.inverse,
        i = 0,
        ret = '',
        data = undefined,
        contextPath = undefined;

    if (options.data && options.ids) {
      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
    }

    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    if (options.data) {
      data = _utils.createFrame(options.data);
    }

    function execIteration(field, index, last) {
      if (data) {
        data.key = field;
        data.index = index;
        data.first = index === 0;
        data.last = !!last;

        if (contextPath) {
          data.contextPath = contextPath + field;
        }
      }

      ret = ret + fn(context[field], {
        data: data,
        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
      });
    }

    if (context && typeof context === 'object') {
      if (_utils.isArray(context)) {
        for (var j = context.length; i < j; i++) {
          if (i in context) {
            execIteration(i, i, i === context.length - 1);
          }
        }
      } else if (global.Symbol && context[global.Symbol.iterator]) {
        var newContext = [];
        var iterator = context[global.Symbol.iterator]();
        for (var it = iterator.next(); !it.done; it = iterator.next()) {
          newContext.push(it.value);
        }
        context = newContext;
        for (var j = context.length; i < j; i++) {
          execIteration(i, i, i === context.length - 1);
        }
      } else {
        (function () {
          var priorKey = undefined;

          Object.keys(context).forEach(function (key) {
            // We're running the iterations one step out of sync so we can detect
            // the last iteration without have to scan the object twice and create
            // an itermediate keys array.
            if (priorKey !== undefined) {
              execIteration(priorKey, i - 1);
            }
            priorKey = key;
            i++;
          });
          if (priorKey !== undefined) {
            execIteration(priorKey, i - 1, true);
          }
        })();
      }
    }

    if (i === 0) {
      ret = inverse(this);
    }

    return ret;
  });
};

module.exports = exports['default'];

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)))

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = __webpack_require__(112);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('helperMissing', function () /* [args, ]options */{
    if (arguments.length === 1) {
      // A missing field in a {{foo}} construct.
      return undefined;
    } else {
      // Someone is actually trying to call something, blow up.
      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    }
  });
};

module.exports = exports['default'];


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(74);

var _exception = __webpack_require__(112);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('if', function (conditional, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#if requires exactly one argument');
    }
    if (_utils.isFunction(conditional)) {
      conditional = conditional.call(this);
    }

    // Default behavior is to render the positive path if the value is truthy and not empty.
    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  instance.registerHelper('unless', function (conditional, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#unless requires exactly one argument');
    }
    return instance.helpers['if'].call(this, conditional, {
      fn: options.inverse,
      inverse: options.fn,
      hash: options.hash
    });
  });
};

module.exports = exports['default'];


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('log', function () /* message, options */{
    var args = [undefined],
        options = arguments[arguments.length - 1];
    for (var i = 0; i < arguments.length - 1; i++) {
      args.push(arguments[i]);
    }

    var level = 1;
    if (options.hash.level != null) {
      level = options.hash.level;
    } else if (options.data && options.data.level != null) {
      level = options.data.level;
    }
    args[0] = level;

    instance.log.apply(instance, args);
  });
};

module.exports = exports['default'];


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('lookup', function (obj, field, options) {
    if (!obj) {
      // Note for 5.0: Change to "obj == null" in 5.0
      return obj;
    }
    return options.lookupProperty(obj, field);
  });
};

module.exports = exports['default'];


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(74);

var _exception = __webpack_require__(112);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('with', function (context, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#with requires exactly one argument');
    }
    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    var fn = options.fn;

    if (!_utils.isEmpty(context)) {
      var data = options.data;
      if (options.data && options.ids) {
        data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
      }

      return fn(context, {
        data: data,
        blockParams: _utils.blockParams([context], [data && data.contextPath])
      });
    } else {
      return options.inverse(this);
    }
  });
};

module.exports = exports['default'];


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultDecorators = registerDefaultDecorators;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _decoratorsInline = __webpack_require__(700);

var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

function registerDefaultDecorators(instance) {
  _decoratorsInline2['default'](instance);
}


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(74);

exports['default'] = function (instance) {
  instance.registerDecorator('inline', function (fn, props, container, options) {
    var ret = fn;
    if (!props.partials) {
      props.partials = {};
      ret = function (context, options) {
        // Create a new partials stack frame prior to exec.
        var original = container.partials;
        container.partials = _utils.extend({}, original, props.partials);
        var ret = fn(context, options);
        container.partials = original;
        return ret;
      };
    }

    props.partials[options.args[0]] = options.fn;

    return ret;
  });
};

module.exports = exports['default'];


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createNewLookupObject = createNewLookupObject;

var _utils = __webpack_require__(74);

/**
 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
 * The resulting object can be used with "object[property]" to check if a property exists
 * @param {...object} sources a varargs parameter of source objects that will be merged
 * @returns {object}
 */

function createNewLookupObject() {
  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  return _utils.extend.apply(undefined, [Object.create(null)].concat(sources));
}


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Build out our basic SafeString type


exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
  return '' + this.string;
};

exports['default'] = SafeString;
module.exports = exports['default'];


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.checkRevision = checkRevision;
exports.template = template;
exports.wrapProgram = wrapProgram;
exports.resolvePartial = resolvePartial;
exports.invokePartial = invokePartial;
exports.noop = noop;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _utils = __webpack_require__(74);

var Utils = _interopRequireWildcard(_utils);

var _exception = __webpack_require__(112);

var _exception2 = _interopRequireDefault(_exception);

var _base = __webpack_require__(311);

var _helpers = __webpack_require__(312);

var _internalWrapHelper = __webpack_require__(704);

var _internalProtoAccess = __webpack_require__(314);

function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
      currentRevision = _base.COMPILER_REVISION;

  if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) {
    return;
  }

  if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
    var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
        compilerVersions = _base.REVISION_CHANGES[compilerRevision];
    throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
  } else {
    // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
  }
}

function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new _exception2['default']('No environment passed to template');
  }
  if (!templateSpec || !templateSpec.main) {
    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
  }

  templateSpec.main.decorator = templateSpec.main_d;

  // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as pseudo-supported APIs.
  env.VM.checkRevision(templateSpec.compiler);

  // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
  var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;

  function invokePartialWrapper(partial, context, options) {
    if (options.hash) {
      context = Utils.extend({}, context, options.hash);
      if (options.ids) {
        options.ids[0] = true;
      }
    }
    partial = env.VM.resolvePartial.call(this, partial, context, options);

    var extendedOptions = Utils.extend({}, options, {
      hooks: this.hooks,
      protoAccessControl: this.protoAccessControl
    });

    var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);

    if (result == null && env.compile) {
      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
      result = options.partials[options.name](context, extendedOptions);
    }
    if (result != null) {
      if (options.indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }

          lines[i] = options.indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
  }

  // Just add water
  var container = {
    strict: function strict(obj, name, loc) {
      if (!obj || !(name in obj)) {
        throw new _exception2['default']('"' + name + '" not defined in ' + obj, {
          loc: loc
        });
      }
      return obj[name];
    },
    lookupProperty: function lookupProperty(parent, propertyName) {
      var result = parent[propertyName];
      if (result == null) {
        return result;
      }
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return result;
      }

      if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) {
        return result;
      }
      return undefined;
    },
    lookup: function lookup(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        var result = depths[i] && container.lookupProperty(depths[i], name);
        if (result != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function lambda(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },

    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,

    fn: function fn(i) {
      var ret = templateSpec[i];
      ret.decorator = templateSpec[i + '_d'];
      return ret;
    },

    programs: [],
    program: function program(i, data, declaredBlockParams, blockParams, depths) {
      var programWrapper = this.programs[i],
          fn = this.fn(i);
      if (data || depths || blockParams || declaredBlockParams) {
        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
      }
      return programWrapper;
    },

    data: function data(value, depth) {
      while (value && depth--) {
        value = value._parent;
      }
      return value;
    },
    mergeIfNeeded: function mergeIfNeeded(param, common) {
      var obj = param || common;

      if (param && common && param !== common) {
        obj = Utils.extend({}, common, param);
      }

      return obj;
    },
    // An empty object to use as replacement for null-contexts
    nullContext: Object.seal({}),

    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };

  function ret(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var data = options.data;

    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths = undefined,
        blockParams = templateSpec.useBlockParams ? [] : undefined;
    if (templateSpec.useDepths) {
      if (options.depths) {
        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
      } else {
        depths = [context];
      }
    }

    function main(context /*, options*/) {
      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
    }

    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
    return main(context, options);
  }

  ret.isTop = true;

  ret._setup = function (options) {
    if (!options.partial) {
      var mergedHelpers = Utils.extend({}, env.helpers, options.helpers);
      wrapHelpersToPassLookupProperty(mergedHelpers, container);
      container.helpers = mergedHelpers;

      if (templateSpec.usePartial) {
        // Use mergeIfNeeded here to prevent compiling global partials multiple times
        container.partials = container.mergeIfNeeded(options.partials, env.partials);
      }
      if (templateSpec.usePartial || templateSpec.useDecorators) {
        container.decorators = Utils.extend({}, env.decorators, options.decorators);
      }

      container.hooks = {};
      container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);

      var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
      _helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
      _helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
    } else {
      container.protoAccessControl = options.protoAccessControl; // internal option
      container.helpers = options.helpers;
      container.partials = options.partials;
      container.decorators = options.decorators;
      container.hooks = options.hooks;
    }
  };

  ret._child = function (i, data, blockParams, depths) {
    if (templateSpec.useBlockParams && !blockParams) {
      throw new _exception2['default']('must pass block params');
    }
    if (templateSpec.useDepths && !depths) {
      throw new _exception2['default']('must pass parent depths');
    }

    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
  };
  return ret;
}

function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
  function prog(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var currentDepths = depths;
    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
      currentDepths = [context].concat(depths);
    }

    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
  }

  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  prog.blockParams = declaredBlockParams || 0;
  return prog;
}

/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */

function resolvePartial(partial, context, options) {
  if (!partial) {
    if (options.name === '@partial-block') {
      partial = options.data['partial-block'];
    } else {
      partial = options.partials[options.name];
    }
  } else if (!partial.call && !options.name) {
    // This is a dynamic partial that returned a string
    options.name = partial;
    partial = options.partials[partial];
  }
  return partial;
}

function invokePartial(partial, context, options) {
  // Use the current closure context to save the partial-block if this partial
  var currentPartialBlock = options.data && options.data['partial-block'];
  options.partial = true;
  if (options.ids) {
    options.data.contextPath = options.ids[0] || options.data.contextPath;
  }

  var partialBlock = undefined;
  if (options.fn && options.fn !== noop) {
    (function () {
      options.data = _base.createFrame(options.data);
      // Wrapper function to get access to currentPartialBlock from the closure
      var fn = options.fn;
      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        // Restore the partial-block from the closure for the execution of the block
        // i.e. the part inside the block of the partial call.
        options.data = _base.createFrame(options.data);
        options.data['partial-block'] = currentPartialBlock;
        return fn(context, options);
      };
      if (fn.partials) {
        options.partials = Utils.extend({}, options.partials, fn.partials);
      }
    })();
  }

  if (partial === undefined && partialBlock) {
    partial = partialBlock;
  }

  if (partial === undefined) {
    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
  } else if (partial instanceof Function) {
    return partial(context, options);
  }
}

function noop() {
  return '';
}

function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? _base.createFrame(data) : {};
    data.root = context;
  }
  return data;
}

function executeDecorators(fn, prog, container, depths, data, blockParams) {
  if (fn.decorator) {
    var props = {};
    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
    Utils.extend(prog, props);
  }
  return prog;
}

function wrapHelpersToPassLookupProperty(mergedHelpers, container) {
  Object.keys(mergedHelpers).forEach(function (helperName) {
    var helper = mergedHelpers[helperName];
    mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
  });
}

function passLookupPropertyOption(helper, container) {
  var lookupProperty = container.lookupProperty;
  return _internalWrapHelper.wrapHelper(helper, function (options) {
    return Utils.extend({ lookupProperty: lookupProperty }, options);
  });
}


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.wrapHelper = wrapHelper;

function wrapHelper(helper, transformOptionsFn) {
  if (typeof helper !== 'function') {
    // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
  }
  var wrapper = function wrapper() /* dynamic arguments */{
    var options = arguments[arguments.length - 1];
    arguments[arguments.length - 1] = transformOptionsFn(options);
    return helper.apply(this, arguments);
  };
  return wrapper;
}


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.__esModule = true;

exports['default'] = function (Handlebars) {
  /* istanbul ignore next */
  var root = typeof global !== 'undefined' ? global : window,
      $Handlebars = root.Handlebars;
  /* istanbul ignore next */
  Handlebars.noConflict = function () {
    if (root.Handlebars === Handlebars) {
      root.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
};

module.exports = exports['default'];

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)))

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Backbone.js 1.2.1

//     (c) 2010-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self == self && self) ||
            (typeof global == 'object' && global.global == global && global);

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(707), __webpack_require__(175), exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'), $;
    try { $ = require('jquery'); } catch(e) {}
    factory(root, exports, _, $);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

}(function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create a local reference to a common array method we'll want to use later.
  var slice = [].slice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.2.1';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Proxy Underscore methods to a Backbone class' prototype using a
  // particular attribute as the data argument
  var addMethod = function(length, method, attribute) {
    switch (length) {
      case 1: return function() {
        return _[method](this[attribute]);
      };
      case 2: return function(value) {
        return _[method](this[attribute], value);
      };
      case 3: return function(iteratee, context) {
        return _[method](this[attribute], iteratee, context);
      };
      case 4: return function(iteratee, defaultVal, context) {
        return _[method](this[attribute], iteratee, defaultVal, context);
      };
      default: return function() {
        var args = slice.call(arguments);
        args.unshift(this[attribute]);
        return _[method].apply(_, args);
      };
    }
  };
  var addUnderscoreMethods = function(Class, methods, attribute) {
    _.each(methods, function(length, method) {
      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
    });
  };

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`), reducing them by manipulating `memo`.
  // Passes a normalized single event name and callback, as well as any
  // optional `opts`.
  var eventsApi = function(iteratee, memo, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = _.keys(name); i < names.length ; i++) {
        memo = iteratee(memo, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space separated event names.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        memo = iteratee(memo, names[i], callback, opts);
      }
    } else {
      memo = iteratee(memo, name, callback, opts);
    }
    return memo;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    return internalOn(this, name, callback, context);
  };

  // An internal use `on` function, used to guard the `listening` argument from
  // the public API.
  var internalOn = function(obj, name, callback, context, listening) {
    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
        context: context,
        ctx: obj,
        listening: listening
    });

    if (listening) {
      var listeners = obj._listeners || (obj._listeners = {});
      listeners[listening.id] = listening;
    }

    return obj;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to.
  Events.listenTo =  function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
    }

    // Bind callbacks on obj, and keep track of them on listening.
    internalOn(obj, name, callback, this, listening);
    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({ callback: callback, context: context, ctx: context || ctx, listening: listening });
    }
    return events;
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off =  function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
        context: context,
        listeners: this._listeners
    });
    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening =  function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : _.keys(listeningTo);

    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
    }
    if (_.isEmpty(listeningTo)) this._listeningTo = void 0;

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    // No events to consider.
    if (!events) return;

    var i = 0, listening;
    var context = options.context, listeners = options.listeners;

    // Delete all events listeners and "drop" events.
    if (!name && !callback && !context) {
      var ids = _.keys(listeners);
      for (; i < ids.length; i++) {
        listening = listeners[ids[i]];
        delete listeners[listening.id];
        delete listening.listeningTo[listening.objId];
      }
      return;
    }

    var names = name ? [name] : _.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Replace events if there are any remaining.  Otherwise, clean up.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          listening = handler.listening;
          if (listening && --listening.count === 0) {
            delete listeners[listening.id];
            delete listening.listeningTo[listening.objId];
          }
        }
      }

      // Update tail event if the list has any events.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }
    if (_.size(events)) return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, it will be removed. When multiple events are
  // passed in using the space-separated syntax, the event will fire once for every
  // event you passed in, not once for a combination of all events
  Events.once =  function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
    return this.on(events, void 0, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce =  function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var once = map[name] = _.once(function() {
        offer(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger =  function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, cb, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId(this.cidPrefix);
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // The prefix is used to create the client id which is used to identify models locally.
    // You may want to override this if you're experiencing name clashes with model ids.
    cidPrefix: 'c',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Special-cased proxy to underscore's `_.matches` method.
    matches: function(attrs) {
      return !!_.iteratee(attrs, this)(this.attributes);
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      var unset      = options.unset;
      var silent     = options.silent;
      var changes    = [];
      var changing   = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }

      var current = this.attributes;
      var changed = this.changed;
      var prev    = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (var attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          changed[attr] = val;
        } else {
          delete changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0; i < changes.length; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      var changed = {};
      for (var attr in diff) {
        var val = diff[attr];
        if (_.isEqual(old[attr], val)) continue;
        changed[attr] = val;
      }
      return _.size(changed) ? changed : false;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server, merging the response with the model's
    // local attributes. Any changed attributes will trigger a "change" event.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (!model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true, parse: true}, options);
      var wait = options.wait;

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      var model = this;
      var success = options.success;
      var attributes = this.attributes;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
        if (serverAttrs && !model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      // Set temporary attributes if `{wait: true}` to properly find new ids.
      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch' && !options.attrs) options.attrs = attrs;
      var xhr = this.sync(method, this, options);

      // Restore attributes.
      this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;
      var wait = options.wait;

      var destroy = function() {
        model.stopListening();
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (wait) destroy();
        if (success) success.call(options.context, model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      var xhr = false;
      if (this.isNew()) {
        _.defer(options.success);
      } else {
        wrapError(this, options);
        xhr = this.sync('delete', this, options);
      }
      if (!wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      var id = this.get(this.idAttribute);
      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.defaults({validate: true}, options));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = { keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
      omit: 0, chain: 1, isEmpty: 1 };

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  addUnderscoreMethods(Model, modelMethods, 'attributes');

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analogous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model) { return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      options = _.extend({}, options);
      var singular = !_.isArray(models);
      models = singular ? [models] : _.clone(models);
      var removed = this._removeModels(models, options);
      if (!options.silent && removed) this.trigger('update', this, options);
      return singular ? removed[0] : removed;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults({}, options, setOptions);
      if (options.parse && !this._isModel(models)) models = this.parse(models, options);
      var singular = !_.isArray(models);
      models = singular ? (models ? [models] : []) : models.slice();
      var id, model, attrs, existing, sort;
      var at = options.at;
      if (at != null) at = +at;
      if (at < 0) at += this.length + 1;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};
      var add = options.add, merge = options.merge, remove = options.remove;
      var order = !sortable && add && remove ? [] : false;
      var orderChanged = false;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (var i = 0; i < models.length; i++) {
        attrs = models[i];

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(attrs)) {
          if (remove) modelMap[existing.cid] = true;
          if (merge && attrs !== existing) {
            attrs = this._isModel(attrs) ? attrs.attributes : attrs;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(attrs, options);
          if (!model) continue;
          toAdd.push(model);
          this._addReference(model, options);
        }

        // Do not add multiple models with the same `id`.
        model = existing || model;
        if (!model) continue;
        id = this.modelId(model.attributes);
        if (order && (model.isNew() || !modelMap[id])) {
          order.push(model);

          // Check to see if this is actually a new model at this index.
          orderChanged = orderChanged || !this.models[i] || model.cid !== this.models[i].cid;
        }

        modelMap[id] = true;
      }

      // Remove nonexistent models if appropriate.
      if (remove) {
        for (var i = 0; i < this.length; i++) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this._removeModels(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length || orderChanged) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          for (var i = 0; i < toAdd.length; i++) {
            this.models.splice(at + i, 0, toAdd[i]);
          }
        } else {
          if (order) this.models.length = 0;
          var orderedModels = order || toAdd;
          for (var i = 0; i < orderedModels.length; i++) {
            this.models.push(orderedModels[i]);
          }
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort events.
      if (!options.silent) {
        var addOpts = at != null ? _.clone(options) : options;
        for (var i = 0; i < toAdd.length; i++) {
          if (at != null) addOpts.index = at + i;
          (model = toAdd[i]).trigger('add', model, this, addOpts);
        }
        if (sort || orderChanged) this.trigger('sort', this, options);
        if (toAdd.length || toRemove.length) this.trigger('update', this, options);
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options = options ? _.clone(options) : {};
      for (var i = 0; i < this.models.length; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      return this.remove(model, options);
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      return this.remove(model, options);
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      var id = this.modelId(this._isModel(obj) ? obj.attributes : obj);
      return this._byId[obj] || this._byId[id] || this._byId[obj.cid];
    },

    // Get the model at the given index.
    at: function(index) {
      if (index < 0) index += this.length;
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      var matches = _.matches(attrs);
      return this[first ? 'find' : 'filter'](function(model) {
        return matches(model.attributes);
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      var wait = options.wait;
      model = this._prepareModel(model, options);
      if (!model) return false;
      if (!wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(model, resp, callbackOpts) {
        if (wait) collection.add(model, callbackOpts);
        if (success) success.call(callbackOpts.context, model, resp, callbackOpts);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models, {
        model: this.model,
        comparator: this.comparator
      });
    },

    // Define how to uniquely identify models in the collection.
    modelId: function (attrs) {
      return attrs[this.model.prototype.idAttribute || 'id'];
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (this._isModel(attrs)) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method called by both remove and set.
    // Returns removed models, or false if nothing is removed.
    _removeModels: function(models, options) {
      var removed = [];
      for (var i = 0; i < models.length; i++) {
        var model = this.get(models[i]);
        if (!model) continue;

        var index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;

        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }

        removed.push(model);
        this._removeReference(model, options);
      }
      return removed.length ? removed : false;
    },

    // Method for checking whether an object should be considered a model for
    // the purposes of adding to the collection.
    _isModel: function (model) {
      return model instanceof Model;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      var id = this.modelId(model.attributes);
      if (id != null) this._byId[id] = model;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      delete this._byId[model.cid];
      var id = this.modelId(model.attributes);
      if (id != null) delete this._byId[id];
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (event === 'change') {
        var prevId = this.modelId(model.previousAttributes());
        var id = this.modelId(model.attributes);
        if (prevId !== id) {
          if (prevId != null) delete this._byId[prevId];
          if (id != null) this._byId[id] = model;
        }
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var collectionMethods = { forEach: 3, each: 3, map: 3, collect: 3, reduce: 4,
      foldl: 4, inject: 4, reduceRight: 4, foldr: 4, find: 3, detect: 3, filter: 3,
      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 2,
      contains: 2, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
      isEmpty: 1, chain: 1, sample: 3, partition: 3 };

  // Mix in each Underscore method as a proxy to `Collection#models`.
  addUnderscoreMethods(Collection, collectionMethods, 'models');

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy', 'indexBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    if (!_[method]) return;
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.$el.remove();
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` and `this.$el` references for this view using the
    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
    // context or an element. Subclasses can override this to utilize an
    // alternative DOM manipulation API and are only required to set the
    // `this.el` property.
    _setElement: function(el) {
      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
      this.el = this.$el[0];
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = _.result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], _.bind(method, this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        this.setElement(this._createElement(_.result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(_.result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      this.$el.attr(attributes);
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // Pass along `textStatus` and `errorThrown` from jQuery.
    var error = options.error;
    options.error = function(xhr, textStatus, errorThrown) {
      options.textStatus = textStatus;
      options.errorThrown = errorThrown;
      if (error) error.call(options.context, xhr, textStatus, errorThrown);
    };

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        if (router.execute(callback, args, name) !== false) {
          router.trigger.apply(router, ['route:' + name].concat(args));
          router.trigger('route', name, args);
          Backbone.history.trigger('route', router, name, args);
        }
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
      return path === this.root && !this.getSearch();
    },

    // Does the pathname match the root?
    matchRoot: function() {
      var path = this.decodeFragment(this.location.pathname);
      var root = path.slice(0, this.root.length - 1) + '/';
      return root === this.root;
    },

    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function(fragment) {
      return decodeURI(fragment.replace(/%25/g, '%2525'));
    },

    // In IE6, the hash fragment and search params are incorrect if the
    // fragment contains `?`.
    getSearch: function() {
      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
      return match ? match[0] : '';
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the pathname and search params, without the root.
    getPath: function() {
      var path = this.decodeFragment(
        this.location.pathname + this.getSearch()
      ).slice(this.root.length - 1);
      return path.charAt(0) === '/' ? path.slice(1) : path;
    },

    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
      if (fragment == null) {
        if (this._usePushState || !this._wantsHashChange) {
          fragment = this.getPath();
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error('Backbone.history has already been started');
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._hasHashChange   = 'onhashchange' in window;
      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.history && this.history.pushState);
      this._usePushState    = this._wantsPushState && this._hasPushState;
      this.fragment         = this.getFragment();

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          var root = this.root.slice(0, -1) || '/';
          this.location.replace(root + '#' + this.getPath());
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot()) {
          this.navigate(this.getHash(), {replace: true});
        }

      }

      // Proxy an iframe to handle location events if the browser doesn't
      // support the `hashchange` event, HTML5 history, or the user wants
      // `hashChange` but not `pushState`.
      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = 'javascript:0';
        this.iframe.style.display = 'none';
        this.iframe.tabIndex = -1;
        var body = document.body;
        // Using `appendChild` will throw on IE < 9 if the document is not ready.
        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
        iWindow.document.open();
        iWindow.document.close();
        iWindow.location.hash = '#' + this.fragment;
      }

      // Add a cross-platform `addEventListener` shim for older browsers.
      var addEventListener = window.addEventListener || function (eventName, listener) {
        return attachEvent('on' + eventName, listener);
      };

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._usePushState) {
        addEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        addEventListener('hashchange', this.checkUrl, false);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      // Add a cross-platform `removeEventListener` shim for older browsers.
      var removeEventListener = window.removeEventListener || function (eventName, listener) {
        return detachEvent('on' + eventName, listener);
      };

      // Remove window listeners.
      if (this._usePushState) {
        removeEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        removeEventListener('hashchange', this.checkUrl, false);
      }

      // Clean up the iframe if necessary.
      if (this.iframe) {
        document.body.removeChild(this.iframe);
        this.iframe = null;
      }

      // Some environments will throw when clearing an undefined interval.
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();

      // If the user pressed the back button, the iframe's hash will have
      // changed and we should use that for comparison.
      if (current === this.fragment && this.iframe) {
        current = this.getHash(this.iframe.contentWindow);
      }

      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      // If the root doesn't match, no routes can match either.
      if (!this.matchRoot()) return false;
      fragment = this.fragment = this.getFragment(fragment);
      return _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      // Normalize the fragment.
      fragment = this.getFragment(fragment || '');

      // Don't include a trailing slash on the root.
      var root = this.root;
      if (fragment === '' || fragment.charAt(0) === '?') {
        root = root.slice(0, -1) || '/';
      }
      var url = root + fragment;

      // Strip the hash and decode for matching.
      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getHash(this.iframe.contentWindow))) {
          var iWindow = this.iframe.contentWindow;

          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            iWindow.document.open();
            iWindow.document.close();
          }

          this._updateHash(iWindow.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent` constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)))

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  }

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132), __webpack_require__(315)(module)))

/***/ }),
/* 708 */
/***/ (function(module, exports) {

var __self__ = (function (root) {
function F() {
this.fetch = false;
this.DOMException = root.DOMException
}
F.prototype = root;
return new F();
})(typeof self !== 'undefined' ? self : this);
(function(self) {

var irrelevant = (function (exports) {
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  return exports;

}({}));
})(__self__);
delete __self__.fetch.polyfill
exports = __self__.fetch // To enable: import fetch from 'cross-fetch'
exports.default = __self__.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = __self__.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = __self__.Headers
exports.Request = __self__.Request
exports.Response = __self__.Response
module.exports = exports


/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = {"signout":"Sign Out","signin":"Sign In","signup":"Sign Up","remember":"Remember me","rememberDevice":"Trust this device","rememberDevice.timebased":"Do not challenge me on this device for the next {0}","rememberDevice.devicebased":"Do not challenge me on this device again","autoPush":"Send push automatically","unlockaccount":"Unlock account?","haveaccount":"Already have an account ?","needhelp":"Need help signing in?","goback":"Back to Sign In","forgotpassword":"Forgot password?","help":"Help","retry":"Retry","iphone":"iPhone","android":"Android","backToSignin":"Back to sign in","closeWindow":"You can close this window","country.label":"Country","phone.extention.label":"Extension","minutes.oneMinute":"minute","minutes":"{0} minutes","hours":"{0} hours","days":"{0} days","error.config":"There was a configuration error","error.required.authParams":"Missing parameters for the configured authentication scheme - \"OAUTH2\"","error.required.baseUrl":"\"baseUrl\" is a required widget parameter","error.required.success":"A success handler is required","error.required.el":"\"el\" is a required widget parameter","error.invalid.colors.brand":"\"colors.brand\" must be in six-digit hex format","error.unsupported.browser":"Unsupported browser","error.unsupported.cors":"Unsupported browser - missing CORS support","error.unsupported.localStorage":"Unsupported browser - missing localStorage support","error.enabled.cors":"There was an error sending the request - have you enabled CORS?","error.expired.session":"Your session has expired. Please try to log in again.","error.auth.lockedOut":"Your account is locked. Please contact your administrator.","error.oauth.idToken":"There was a problem generating the id_token for the user. Please try again.","error.network.connection":"Unable to connect to the server. Please check your network connection.","error.username.required":"Please enter a username","error.password.required":"Please enter a password","errors.E0000004":"Unable to sign in","errors.E0000069":"Your account is locked because of too many authentication attempts.","errors.E0000047":"You exceeded the maximum number of requests. Try again in a while.","errors.E0000079":"The operation is not allowed. Please refresh the page to proceed.","errors.E0000001":"Api validation failed: {0}","errors.E0000002":"The request was not valid: {0}","errors.E0000003":"The request body was not well-formed.","errors.E0000005":"Invalid session","errors.E0000006":"You do not have permission to perform the requested action","errors.E0000007":"Not found: {0}","errors.E0000008":"The requested path was not found","errors.E0000009":"Internal Server Error","errors.E0000010":"Service is in read only mode","errors.E0000011":"Invalid token provided","errors.E0000012":"Unsupported media type","errors.E0000013":"Invalid client app id","errors.E0000015":"You do not have permission to access the feature you are requesting","errors.E0000016":"Activation failed because the user is already active","errors.E0000017":"Password reset failed","errors.E0000018":"Bad request.  Accept and/or Content-Type headers are likely not set.","errors.E0000019":"Bad request.  Accept and/or Content-Type headers likely do not match supported values.","errors.E0000020":"Bad request.","errors.E0000021":"Bad request.  Accept and/or Content-Type headers likely do not match supported values.","errors.E0000022":"The endpoint does not support the provided HTTP method","errors.E0000023":"Operation failed because user profile is mastered under another system","errors.E0000024":"Bad request.  This operation on app metadata is not yet supported.","errors.E0000025":"App version assignment failed.","errors.E0000026":"This endpoint has been deprecated.","errors.E0000027":"Group push bad request : {0}","errors.E0000028":"The request is missing a required parameter.","errors.E0000029":"Invalid paging request.","errors.E0000030":"Bad request. Invalid date. Dates must be of the form yyyy-MM-dd''T''HH:mm:ss.SSSZZ, e.g. 2013-01-01T12:00:00.000-07:00.","errors.E0000031":"Invalid search criteria.","errors.E0000032":"Unlock is not allowed for this user.","errors.E0000033":"Bad request. Can't specify a search query and filter in the same request.","errors.E0000034":"Forgot password not allowed on specified user.","errors.E0000035":"Change password not allowed on specified user.","errors.E0000036":"Change recovery question not allowed on specified user.","errors.E0000037":"Type mismatch exception.","errors.E0000038":"This operation is not allowed in the user''s current status.","errors.E0000039":"Operation on application settings failed.","errors.E0000040":"Application label must not be the same as an existing application label.","errors.E0000041":"Credentials should not be set on this resource based on the scheme.","errors.E0000042":"Setting the error page redirect URL failed.","errors.E0000043":"Self service application assignment is not enabled.","errors.E0000044":"Self service application assignment is not supported.","errors.E0000045":"Field mapping bad request.","errors.E0000046":"Deactivate application for user forbidden.","errors.E0000048":"Entity not found exception.","errors.E0000049":"Invalid SCIM data from SCIM implementation.","errors.E0000050":"Invalid SCIM data from client.","errors.E0000051":"No response from SCIM implementation.","errors.E0000052":"Endpoint not implemented.","errors.E0000053":"Invalid SCIM filter.","errors.E0000054":"Invalid pagination properties.","errors.E0000055":"Duplicate group.","errors.E0000056":"Delete application forbidden.","errors.E0000057":"Access to this application is denied due to a policy.","errors.E0000058":"Access to this application requires MFA: {0}","errors.E0000059":"The connector configuration could not be tested. Make sure that the URL, Authentication Parameters are correct and that there is an implementation available at the URL provided.","errors.E0000060":"Unsupported operation.","errors.E0000061":"Tab error: {0}","errors.E0000062":"The specified user is already assigned to the application.","errors.E0000063":"Invalid combination of parameters specified.","errors.E0000064":"Password is expired and must be changed.","errors.E0000065":"Internal error processing app metadata.","errors.E0000066":"APNS is not configured, contact your admin","errors.E0000067":"Factors Service Error.","errors.E0000070":"Waiting for ACK","errors.E0000071":"Unsupported OS Version: {0}","errors.E0000072":"MIM policy settings have disallowed enrollment for this user","errors.E0000073":"User rejected authentication","errors.E0000074":"Factor Service Error","errors.E0000075":"Cannot modify the {0} attribute because it has a field mapping and profile push is enabled.","errors.E0000076":"Cannot modify the app user because it is mastered by an external app.","errors.E0000077":"Cannot modify the {0} attribute because it is read-only.","errors.E0000078":"Cannot modify the {0} attribute because it is immutable.","errors.E0000081":"Cannot modify the {0} attribute because it is a reserved attribute for this application.","errors.E0000082":"Each code can only be used once. Please wait for a new code and try again.","errors.E0000083":"PassCode is valid but exceeded time window.","errors.E0000084":"App evaluation error.","errors.E0000085":"You do not have permission to access your account at this time.","errors.E0000086":"This policy cannot be activated at this time.","errors.E0000087":"The recovery question answer did not match our records.","errors.E0000090":"The role specified is already assigned to the user.","errors.E0000091":"The provided role type was not the same as required role type.","errors.E0000092":"Access to this application requires re-authentication: {0}","errors.E0000093":"Target count limit exceeded","errors.E0000094":"The provided filter is unsupported.","errors.E0000095":"Recovery not allowed for unknown user.","errors.E0000096":"This certificate has already been uploaded with kid={0}.","errors.E0000097":"There is no verified phone number on file.","errors.E0000098":"This phone number is invalid.","errors.E0000099":"Only numbers located in US and Canada are allowed.  Contact your administrator if this is a problem.","errors.E0000100":"Unable to perform search query.","errors.E0000101":"Upload failed because of a problem with your ipa file, {0}","errors.E0000102":"YubiKey cannot be deleted while assigned to an user. Please deactivate YubiKey using reset MFA and try again","errors.E0000103":"Action on device already in queue or in progress","errors.E0000104":"Device is already locked and cannot be locked again","errors.E0000105":"You have accessed an account recovery link that has expired or been previously used.","errors.E0000106":"Wait for token to change, then enter the new tokencode.","errors.E0000107":"The entity is not in the expected state for the requested transition.","errors.E0000109":"An SMS message was recently sent. Please wait 30 seconds before trying again.","errors.E0000110":"You have accessed a link that has expired or has been previously used.","errors.E0000111":"Cannot modify the {0} object because it is read-only.","errors.E0000112":"Cannot update this user because they are still being activated. Please try again in a few minutes.","errors.E0000113":"{0}.","errors.E0000114":"A user with this login already exists in the current organization.","errors.E0000115":"Upload failed, {0}","errors.E0000116":"{0}","errors.E0000119":"Your account is locked. Please contact your administrator.","errors.E0000124":"Could not create user. To create a user and expire their password immediately, a password must be specified","errors.E0000125":"Could not create user. To create a user and expire their password immediately, \"activate\" must be true","errors.E0000133":"A phone call was recently made. Please wait 30 seconds before trying again.","oform.next":"Next","oform.verify":"Verify","oform.send":"Send","oform.back":"Back","oform.title.authenticate":"Authenticate","oform.save":"Save","oform.cancel":"Cancel","oform.edit":"Edit","oform.previous":"Previous","oform.error.icon.ariaLabel":"Error","oform.errorbanner.title":"We found some errors. Please review the form and make corrections.","oform.errormsg.title":"Please review the form to correct the following errors:","oform.error.unexpected":"There was an unexpected internal error. Please try again.","model.validation.field.blank":"This field cannot be left blank","model.validation.field.wrong.type":"This field is of the wrong type","model.validation.field.invalid":"This field has an invalid value","model.validation.field.value.not.allowed":"This field value is not allowed","model.validation.field.array.minItems":"This array does not have enough items","model.validation.field.array.maxItems":"This array contains too many items","model.validation.field.array.unique":"This array can only have unique values","model.validation.field.string.minLength":"This field cannot be less than the minimum required characters","model.validation.field.string.maxLength":"This field cannot exceed the maximum allowed characters","model.validation.field.invalid.format.email":"This value is not a valid email address","model.validation.field.invalid.format.uri":"This value is not a valid URI","model.validation.field.invalid.format.ipv4":"This value is not a valid IPv4 address","model.validation.field.invalid.format.hostname":"This value is not a valid hostname","model.validation.field.username":"Please check your username","factor.totpSoft.oktaVerify":"Okta Verify","factor.totpSoft.googleAuthenticator":"Google Authenticator","factor.totpSoft.description":"Enter single-use code from the mobile app.","factor.totpHard.rsaSecurId":"RSA SecurID","factor.totpHard.symantecVip":"Symantec VIP","factor.totpHard.description":"Enter a single-use code from a hardware token.","factor.totpHard.yubikey":"YubiKey","factor.totpHard.yubikey.description":"Insert your YubiKey and tap it to get a verification code.","factor.totpHard.yubikey.placeholder":"Click here, then tap your YubiKey","factor.oktaVerifyPush":"Okta Verify","factor.push.description":"Use a push notification sent to the mobile app.","factor.duo":"Duo Security","factor.duo.description":"Use Push Notification, SMS, or Voice call to authenticate.","factor.sms":"SMS Authentication","factor.sms.description":"Enter a single-use code sent to your mobile phone.","factor.sms.time.warning":"Haven't received an SMS? To try again, click <span style=\"font-weight:bold\">Re-send code</span>.","factor.call":"Voice Call Authentication","factor.call.description":"Use a phone to authenticate by following voice instructions.","factor.call.time.warning":"Haven't received a voice call? To try again, click <span style=\"font-weight:bold\">Redial</span>.","factor.securityQuestion":"Security Question","factor.securityQuestion.description":"Use the answer to a security question to authenticate.","factor.windowsHello":"Windows Hello","factor.windowsHello.signin.description":"Sign in to Okta using Windows Hello.","factor.windowsHello.signin.description.generic":"Sign in using Windows Hello.","factor.windowsHello.signin.description.specific":"Sign in to {0} using Windows Hello.","factor.u2f":"Security Key (U2F)","factor.u2f.description":"Use a Universal 2nd Factor (U2F) security key to sign on to Okta.","factor.u2f.description.generic":"Use a Universal 2nd Factor (U2F) security key to sign in.","factor.u2f.description.specific":"Use a Universal 2nd Factor (U2F) security key to sign in to {0}.","factor.email":"Email Authentication","factor.email.description":"Enter a verification code sent to your email.","factor.password":"Password","factor.customFactor.description":"Redirect to a third party MFA provider to sign in to Okta.","factor.customFactor.description.generic":"Redirect to a third party MFA provider to sign in.","factor.customFactor.description.specific":"Redirect to a third party MFA provider to sign in to {0}.","factor.webauthn.biometric":"Security Key or Biometric Authenticator","factor.webauthn.biometric.description":"Use a security key (USB or bluetooth) or a biometric authenticator (Windows Hello, Touch ID, etc.)","factor.hotp.description":"Enter a single-use code from an authenticator.","mfa.challenge.verify":"Verify","mfa.challenge.answer.placeholder":"Answer","mfa.challenge.answer.tooltip":"Answer","mfa.challenge.answer.showAnswer":"Show","mfa.challenge.answer.hideAnswer":"Hide","mfa.challenge.enterCode.placeholder":"Enter Code","mfa.challenge.enterCode.tooltip":"Enter Code","mfa.challenge.password.placeholder":"Password","mfa.backToFactors":"Back to factor list","mfa.phoneNumber.placeholder":"Phone number","mfa.phoneNumber.ext.placeholder":"Extension","mfa.sendCode":"Send code","mfa.sent":"Sent","mfa.resendCode":"Re-send code","mfa.call":"Call","mfa.calling":"Calling","mfa.redial":"Redial","mfa.sendEmail":"Send email","mfa.resendEmail":"Re-send email","mfa.scanBarcode":"Scan barcode","mfa.noAccessToEmail":"Can't access email","password.reset":"Reset Password","password.oldPassword.placeholder":"Old password","password.oldPassword.tooltip":"Old password","password.newPassword.placeholder":"New password","password.newPassword.tooltip":"New password","password.confirmPassword.placeholder":"Repeat password","password.confirmPassword.tooltip":"Repeat password","password.error.match":"New passwords must match","password.enroll.error.match":"Passwords must match","recovery.sms.hint":"SMS can only be used if a mobile phone number has been configured.","recovery.mobile.hint":"{0} can only be used if a mobile phone number has been configured.","recovery.sms":"SMS","recovery.call":"Voice Call","recovery.smsOrCall":"SMS or Voice Call","verify.choices.description":"Verify with one of the following factors.","email.button.send":"Send me the code","email.button.resend":"Send again","email.code.label":"Verification code","email.code.not.received":"Haven't received an email?","email.enroll.title":"Set up Email Authentication","email.enroll.description":"Send a verification code to your registered email.","email.link.terminal.msg":"To finish signing in, return to the screen where you requested the email link.","email.mfa.title":"Verify with Email Authentication","email.mfa.description":"Send a verification code to {0}.","email.mfa.email.sent.description":"A verification code was sent to {0}. Check your email and enter the code below.","email.mfa.email.sent.description.sentText":"A verification code was sent to","email.mfa.email.sent.description.emailCodeText":"Check your email and enter the code below.","enroll.choices.title":"Set up multifactor authentication","enroll.choices.description":"Your company requires multifactor authentication to add an additional layer of security when signing in to your Okta account","enroll.choices.description.generic":"Your company requires multifactor authentication to add an additional layer of security when signing in to your account","enroll.choices.description.specific":"Your company requires multifactor authentication to add an additional layer of security when signing in to your {0} account","enroll.choices.description.gracePeriod.bold":"Your company recommends setting up additional factors for authentication. Set up will be required in: <b>{0} day(s)</b>.","enroll.choices.description.gracePeriod.oneDay.bold":"Your company recommends setting up additional factors for authentication. Set up will be required in: <b>less than 1 day</b>.","enroll.choices.optional":"You can configure any additional optional factor or click finish","enroll.choices.list.setup":"Setup required","enroll.choices.list.enrolled":"Enrolled factors","enroll.choices.list.optional":"Additional optional factors","enroll.choices.setup":"Setup","enroll.choices.setup.another":"Set up another","enroll.choices.submit.finish":"Finish","enroll.choices.submit.configure":"Configure factor","enroll.choices.submit.next":"Configure next factor","enroll.choices.cardinality.setup":"({0} set up)","enroll.choices.cardinality.setup.remaining":"({0} of {1} set up)","enroll.choices.setup.skip":"Skip set up","enroll.securityQuestion.setup":"Setup secret question authentication","security.disliked_food":"What is the food you least liked as a child?","security.name_of_first_plush_toy":"What is the name of your first stuffed animal?","security.first_award":"What did you earn your first medal or award for?","security.favorite_security_question":"What is your favorite security question?","security.favorite_toy":"What is the toy/stuffed animal you liked the most as a kid?","security.first_computer_game":"What was the first computer game you played?","security.favorite_movie_quote":"What is your favorite movie quote?","security.first_sports_team_mascot":"What was the mascot of the first sports team you played on?","security.first_music_purchase":"What music album or song did you first purchase?","security.favorite_art_piece":"What is your favorite piece of art?","security.grandmother_favorite_desert":"What was your grandmother's favorite dessert?","security.first_thing_cooked":"What was the first thing you learned to cook?","security.childhood_dream_job":"What was your dream job as a child?","security.first_kiss_location":"Where did you have your first kiss?","security.place_where_significant_other_was_met":"Where did you meet your spouse/significant other?","security.favorite_vacation_location":"Where did you go for your favorite vacation?","security.new_years_two_thousand":"Where were you on New Year's Eve in the year 2000?","security.favorite_speaker_actor":"Who is your favorite speaker/orator?","security.favorite_book_movie_character":"Who is your favorite book/movie character?","security.favorite_sports_player":"Who is your favorite sports player?","enroll.password.setup":"Select a password","save.password":"Save password","enroll.sms.setup":"Receive a code via SMS to authenticate","enroll.sms.try_again":"The number you entered seems invalid. If the number is correct, please try again.","enroll.call.setup":"Follow phone call instructions to authenticate","enroll.onprem.username.placeholder":"Enter {0} username","enroll.onprem.username.tooltip":"Enter {0} username","enroll.onprem.passcode.placeholder":"Enter {0} passcode","enroll.onprem.passcode.tooltip":"Enter {0} passcode","enroll.symantecVip.subtitle":"Enter Credential ID and two consecutive generated codes","enroll.symantecVip.credentialId.placeholder":"Enter credential ID","enroll.symantecVip.credentialId.tooltip":"Enter credential ID","enroll.symantecVip.passcode1.placeholder":"Security code 1","enroll.symantecVip.passcode1.tooltip":"Security code 1","enroll.symantecVip.passcode2.placeholder":"Security code 2","enroll.symantecVip.passcode2.tooltip":"Security code 2","enroll.yubikey.title":"Setup YubiKey","enroll.yubikey.subtitle":"Insert your YubiKey into a USB port and tap it to generate a verification code","enroll.totp.title":"Setup {0}","enroll.totp.selectDevice":"Select your device type","enroll.totp.downloadApp":"Download <a href=\"{0}\" class=\"inline-link\">{1} from the {2}</a> onto your mobile device.","enroll.hotp.restricted":"Contact your administrator to continue enrollment.","enroll.duo.title":"Setup Duo Security","enroll.windowsHello.title":"Enroll Windows Hello","enroll.windowsHello.subtitle":"Click below to enroll Windows Hello as a second form of authentication","enroll.windowsHello.subtitle.loading":"Please wait while Windows Hello is loading...","enroll.windowsHello.save":"Enroll Windows Hello","enroll.windowsHello.error.notWindows":"Windows Hello can only be used on Windows Edge with Windows 10. Contact your admin for assistance.","enroll.windowsHello.error.notConfiguredHtml":"Windows Hello is not configured. Select the <b>Start</b> button, then select <b>Settings</b> - <b>Accounts</b> - <b>Sign-in</b> to configure Windows Hello.","verify.windowsHello.subtitle":"Verify your identity with Windows Hello","verify.windowsHello.subtitle.loading":"Please wait while Windows Hello is loading...","verify.windowsHello.subtitle.signingIn":"Signing in to Okta...","verify.windowsHello.subtitle.signingIn.generic":"Signing in...","verify.windowsHello.subtitle.signingIn.specific":"Signing in to {0}...","verify.windowsHello.save":"Verify with Windows Hello","verify.windowsHello.error.notFound":"Your Windows Hello enrollment does not match our records. Contact your administrator for assistance.","verify.windowsHello.error.notFound.selectAnother":"Your Windows Hello enrollment does not match our records. Select another factor or contact your administrator for assistance.","enroll.u2f.title":"Setup Security Key (U2F)","enroll.u2f.save":"Register Security Key","enroll.u2f.general2":"Make sure you have a Security Key. If already inserted, remove it now.<br>If you have a Bluetooth Security Key, turn on your computer's Bluetooth.","enroll.u2f.general3":"Click the button below to register","enroll.u2f.instructions":"Insert your Security Key into a USB port on this computer. If it has a button or gold disk, tap it.","enroll.u2f.instructionsBluetooth":"If you are using a Bluetooth Security Key, press the button.","u2f.error.factorNotSupported":"Security Key (U2F) is not supported on this browser. Select another factor or contact your admin for assistance.","u2f.error.factorNotSupported.oneFactor":"Security Key (U2F) is not supported on this browser. Contact your admin for assistance.","u2f.error.other":"An unknown error has occured. Try again or select another factor.","u2f.error.other.oneFactor":"An unknown error has occured. Try again or contact your admin for assistance.","u2f.error.badRequest":"There was an error with the U2F request. Try again or select another factor.","u2f.error.badRequest.oneFactor":"There was an error with the U2F request. Try again or contact your admin for assistance.","u2f.error.unsupported":"The security key is unsupported. Select another factor.","u2f.error.unsupported.oneFactor":"The security key is unsupported. Contact your admin for assistance.","u2f.error.timeout":"You have timed out of the authentication period. Please try again.","verify.u2f.instructions":"Insert your Security Key. If it has a button or gold disk, tap it.","verify.u2f.instructionsBluetooth":"If you are using a Bluetooth Security Key, turn on your computer's Bluetooth and press the button.","verify.u2f.retry":"Retry","enroll.customFactor.subtitle":"Clicking below will redirect to MFA enrollment with {0}","enroll.customFactor.save":"Enroll","verify.customFactor.subtitle":"Clicking below will redirect to verification with {0}","enroll.webauthn.biometric.title":"Set up security key or biometric authenticator","enroll.webauthn.save":"Enroll","enroll.webauthn.biometric.instructions":"Your browser will prompt to register a security key or biometric authenticator (Windows Hello, Touch ID, etc.). Follow the instructions to complete enrollment.","enroll.webauthn.biometric.instructions.edge":"Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select '<b>Cancel</b>' in the prompt before continuing.","verify.webauthn.biometric.instructions":"Your browser or device will prompt you to verify with a security key or biometric authenticator. Follow the instructions to complete authentication.","webauthn.biometric.error.factorNotSupported":"Security key or biometric authenticator is not supported on this browser. Select another factor or contact your admin for assistance.","webauthn.biometric.error.factorNotSupported.oneFactor":"Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.","enroll.webauthn.instructions.noSupportForBiometric":"Note: Some browsers may not support biometric authenticators.","enroll.totp.enterCode":"Enter code displayed from the application","enroll.totp.setupApp":"Launch {0} application on your mobile device and select Add an account.","enroll.totp.setupGoogleAuthApp":"Launch {0}, tap the \"+\" icon, then select \"Scan barcode\".","enroll.totp.cannotScan":"Can't scan?","enroll.totp.refreshBarcode":"Refresh code","enroll.totp.cannotScanBarcode":"Can't scan barcode?","enroll.totp.manualSetupInstructions":"To set up manually enter your Okta Account username and then input the following in the Secret Key Field","enroll.totp.manualSetupInstructions.generic":"To set up manually enter your Account username and then input the following in the Secret Key Field","enroll.totp.manualSetupInstructions.specific":"To set up manually enter your {0} Account username and then input the following in the Secret Key Field","enroll.totp.sharedSecretInstructions":"Enter your Okta Account username and enter the following in the Secret Key Field","enroll.totp.sharedSecretInstructions.generic":"Enter your Account username and enter the following in the Secret Key Field","enroll.totp.sharedSecretInstructions.specific":"Enter your {0} Account username and enter the following in the Secret Key Field","enroll.totp.sendSms":"Send activation link via SMS","enroll.totp.sendEmail":"Send activation link via email","enroll.totp.setupManually":"Setup manually without push notification","enroll.totp.enrollViaEmail.title":"Activation email sent!","enroll.totp.enrollViaEmail.msg":"Open the email from your mobile device.","enroll.totp.enrollViaSms.title":"SMS sent!","enroll.totp.enrollViaSms.msg":"View the SMS on your mobile device.","recoveryChallenge.sms.title":"Enter verification code sent via SMS","recoveryChallenge.call.title":"Enter verification code received via Voice Call","mfa.factors.dropdown.title":"Select an authentication factor","mfa.factors.dropdown.sr.text":"Select Authentication Factor - {0} Factor Selected","mfa.duoSecurity.push":"Push — {0}","mfa.duoSecurity.sms":"SMS — {0}","mfa.duoSecurity.call":"Call — {0}","mfa.switch":"Switch Factor","mfa.challenge.title":"Enter your {0} passcode","mfa.challenge.orEnterCode":"Or enter code","mfa.challenge.totp.subtitle.multiple":"Enter code from any registered {0} device.","mfa.emailVerification.checkEmail":"To finish signing in, click the link in your email.","mfa.emailVerification.title":"Sign in using a link sent to your email.","mfa.emailVerification.subtitle":"Emails will be sent to {0}","mfa.emailVerification.otc.finish":"To finish signing in, enter the code which was emailed to you.","oktaverify.send":"Send Push","oktaverify.resend":"Re-send Push","oktaverify.sent":"Push sent!","oktaverify.rejected":"You have chosen to reject this login.","oktaverify.rejected.upgradeRequired.ios":"Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on the App Store, then try again.","oktaverify.rejected.upgradeRequired.android":"Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on Google Play, then try again.","oktaverify.timeout":"Your push notification has expired.","oktaverify.warning":"Haven't received a push notification yet? Try opening the Okta Verify App on your phone.","oktaverify.numberchallenge.instruction":"On your phone, tap <span class=\"challenge-number\">{0}</span> on Okta Verify prompt to continue.","oktaverify.numberchallenge.explain":"This extra step helps us make sure it's really you signing in.","primaryauth.title":"Sign In","primaryauth.username.placeholder":"Username","primaryauth.username.tooltip":"Username","primaryauth.password.placeholder":"Password","primaryauth.password.tooltip":"Password","primaryauth.submit":"Sign In","primaryauth.newUser.tooltip":"This is the first time you are connecting to {0} from this browser","primaryauth.newUser.tooltip.close":"Close","oktaVerify.button":"Sign in with Okta Verify","idpDiscovery.email.placeholder":"Email","password.forgot.email.or.username.placeholder":"Email or Username","password.forgot.email.or.username.tooltip":"Email or Username","password.forgot.sendText":"Reset via SMS","password.forgot.sendEmail":"Reset via Email","password.forgot.call":"Reset via Voice Call","password.forgot.emailSent.title":"Email sent!","password.forgot.emailSent.desc":"Email has been sent to {0} with instructions on resetting your password.","password.forgot.question.title":"Answer Forgotten Password Challenge","password.forgot.question.submit":"Reset Password","password.forgot.code.notReceived":"Didn't receive a code? Reset via email","password.forgot.noFactorsEnabled":"No password reset options available. Please contact your administrator.","password.reset.title":"Reset your Okta password","password.reset.title.generic":"Reset your password","password.reset.title.specific":"Reset your {0} password","password.complexity.requirements":"Password requirements: {0}.","password.complexity.history":"Your password cannot be any of your last {0} passwords.","password.complexity.minAgeMinutes":"At least {0} minute(s) must have elapsed since you last changed your password.","password.complexity.minAgeHours":"At least {0} hour(s) must have elapsed since you last changed your password.","password.complexity.minAgeDays":"At least {0} day(s) must have elapsed since you last changed your password.","password.reset.verification":"Verify with one of the following factors to reset your password.","password.complexity.length":"at least {0} characters","password.complexity.list.element":", {0}","password.complexity.lowercase":"a lowercase letter","password.complexity.uppercase":"an uppercase letter","password.complexity.number":"a number","password.complexity.symbol":"a symbol","password.complexity.no_username":"no parts of your username","password.complexity.no_first_name":"does not include your first name","password.complexity.no_last_name":"does not include your last name","password.complexity.requirements.header":"Password requirements:","password.complexity.length.description":"At least {0} characters","password.complexity.lowercase.description":"A lowercase letter","password.complexity.uppercase.description":"An uppercase letter","password.complexity.number.description":"A number","password.complexity.symbol.description":"A symbol","password.complexity.no_username.description":"No parts of your username","password.complexity.no_first_name.description":"Does not include your first name","password.complexity.no_last_name.description":"Does not include your last name","password.complexity.history.description":"Your password cannot be any of your last {0} passwords","password.complexity.minAgeMinutes.description":"At least {0} minute(s) must have elapsed since you last changed your password","password.complexity.minAgeHours.description":"At least {0} hour(s) must have elapsed since you last changed your password","password.complexity.minAgeDays.description":"At least {0} day(s) must have elapsed since you last changed your password","password.expired.submit":"Change Password","password.expired.title":"Your Okta password has expired","password.expired.title.generic":"Your password has expired","password.expired.title.specific":"Your {0} password has expired","password.expiring.later":"Remind me later","password.expiring.title":"Your password will expire in {0} days","password.expiring.today":"Your password will expire later today","password.expiring.soon":"Your password is expiring soon","password.expiring.subtitle":"When password expires you may be locked out of Okta Mobile, mobile email, and other services.","password.expiring.subtitle.generic":"When password expires you will be locked out of your account.","password.expiring.subtitle.specific":"When password expires you will be locked out of your {0} account.","password.expired.custom.submit":"Go to {0}","password.expired.custom.subtitle":"This password is set on another website. Click the button below to go there and set a new password.","account.unlock.title":"Unlock account","account.unlock.email.or.username.placeholder":"Email or username","account.unlock.email.or.username.tooltip":"Email or username","account.unlock.sendText":"Send SMS","account.unlock.voiceCall":"Voice Call","account.unlock.sendEmail":"Send Email","account.unlock.emailSent.title":"Email sent!","account.unlock.emailSent.desc":"Email has been sent to {0} with instructions on unlocking your account.","account.unlock.question.title":"Answer Unlock Account Challenge","account.unlock.question.submit":"Unlock Account","account.unlock.unlocked.title":"Account successfully unlocked!","account.unlock.unlocked.desc":"You can log in using your existing username and password.","account.unlock.code.notReceived":"Didn't receive a code? Unlock via email","account.unlock.noFactorsEnabled":"No unlock options available. Please contact your administrator.","contact.support":"If you didn't provide a secondary email address or don't have access to email, please contact your administrator at {0}","socialauth.divider.text":"OR","socialauth.facebook.label":"Sign in with Facebook","socialauth.google.label":"Sign in with Google","socialauth.linkedin.label":"Sign in with LinkedIn","socialauth.microsoft.label":"Sign in with Microsoft","socialauth.apple.label":"Sign in with Apple","socialauth.popup.title":"External Identity Provider User Authentication","authbutton.divider.text":"or","registration.signup.label":"Don't have an account?","registration.signup.text":"Sign up","registration.complete.title":"Verification email sent","registration.complete.confirm.text":"To finish signing in, check your email.","registration.form.title":"Create Account","registration.form.submit":"Register","registration.passwordComplexity.minLength":"At least {0} character(s)","registration.passwordComplexity.minLower":"At least {0} lowercase letter(s)","registration.passwordComplexity.minUpper":"At least {0} uppercase letter(s)","registration.passwordComplexity.minNumber":"At least {0} number(s)","registration.passwordComplexity.minSymbol":"At least {0} symbol(s)","registration.passwordComplexity.excludeUsername":"Does not contain part of username","registration.passwordComplexity.excludeAttribute":"Does not contain '{0}'","registration.required.fields.label":"* indicates required field","registration.default.callbackhook.error":"We could not process your registration at this time. Please try again later.","registration.error.userName.invalidEmail":"Invalid email address","registration.error.password.passwordRequirementsNotMet":"Password requirements were not met","registration.error.userName.notUniqueWithinOrg":"An account with that email already exists","piv.card":"PIV Card","piv.card.insert":"Please insert your PIV card and select the user certificate.","piv.card.error":"Certificate authentication failed. Contact your admin.","piv.card.error.empty":"No certificate selected. Choose a certificate and try again.","piv.card.error.invalid":"Certificate validation failed. Choose another certificate and try again.","piv.cac.card":"Sign in with PIV / CAC card","piv.cac.title":"PIV / CAC card","piv.cac.card.insert":"Please insert your PIV / CAC card and select the user certificate.","piv.cac.error":"There was an error signing in. Click the button below to try again.","unsupported.oneDrive.title":"Your OneDrive version is not supported","unsupported.oneDrive.desc":"Upgrade now by installing the OneDrive for Business Next Generation Sync Client to login to Okta","unsupported.oneDrive.action":"Learn how to upgrade","unsupported.cookies.title":"Cookies are required","unsupported.cookies.desc":"Cookies are disabled on your browser. Please enable Cookies and refresh this page.","unsupported.cookies.action":"Refresh","deviceTrust.sso.text":"Sign in to access company resources","deviceTrust.sso.subtitle.2":"Your company uses Okta Mobile to get you approved to access this app.","deviceTrust.sso.button":"Sign in with Okta Mobile","deviceTrust.sso.expire.title":"Oops let's get you back on track","deviceTrust.sso.redirectText":"You are being redirected","deviceTrust.sso.expire.subtitle":"Unfortunately the steps required to sign in took longer than expected and your attempt timed out.","deviceTrust.sso.expire.button":"Sign in using Okta Mobile","deviceTrust.universalLink.fallback.getOktaMobile.title":"Get Okta Mobile","deviceTrust.universalLink.fallback.getOktaMobile.subtitle":"Go to the {0}AppStore{1}, {0}search{1} for {0}Okta Mobile{1} and tap on {0}GET{1} Okta Mobile. Once installed, sign in to Okta Mobile and follow the instructions to secure your device.","signin.with.fastpass":"Signing in using Okta FastPass","customUri.title":"Verify account access","customUri.subtitle":"Launching Okta Verify...","customUri.content":"<div class=\"skinny-content\"> If nothing prompts from the browser, <a href=\"#\" id=\"launch-ov\" class=\"link\">click here</a> to launch Okta Verify, or make sure Okta Verify is installed.</div>","universalLink.title":"Verify your sign in","universalLink.content":"To continue, you'll need to use the <span class=\"highlight-text\">Okta Verify</span> app to confirm your sign in.","universalLink.userVerification.title":"Extra verification needed","universalLink.userVerification.content.p1":"Your organization needs extra verification to make sure it's you signing in.","universalLink.userVerification.content.p2":"To continue, confirm your screen lock in Okta Verify.","universalLink.userVerification.button":"Confirm screen lock","consent.required.text":"<b>{0}</b> would like to access:","consent.required.description":"By clicking Allow Access, you allow the actions listed above.","consent.required.termsOfService":"Terms of Service","consent.required.privacyPolicy":"Privacy Policy","consent.required.consentButton":"Allow Access","consent.required.cancelButton":"Don't Allow","admin.consent.group.user.group":"User and groups","admin.consent.group.resource.policy":"Resource and policies","admin.consent.group.hook":"Hooks","admin.consent.group.system":"System","polling.title":"There are too many users trying to sign in right now. We will automatically retry in {0} seconds.","cert.authentication.title":"Certificate authentication","oie.password.authenticator.description":"Choose a password for your account","oie.password.challenge.title":"Verify with your password","oie.password.enroll.title":"Set up password","oie.password.passwordLabel":"Enter password","oie.password.confirmPasswordLabel":"Re-enter password","oie.password.reset.verification":"Verify with one of the following authenticators to reset your password.","oie.phone.authenticator.description":"Verify with a code sent to your phone","oie.phone.enroll.title":"Set up phone authentication","oie.phone.enroll.subtitle":"Set up verification with a phone number. You will receive a code sent to your phone","oie.phone.sms.primaryButton":"Send a code via SMS","oie.phone.sms.secondaryButton":"Receive an SMS instead","oie.phone.call.primaryButton":"Send a code via voice call","oie.phone.call.secondaryButton":"Receive a voice call instead","oie.phone.verify.sms.resendText":"Haven't received an SMS?","oie.phone.verify.sms.codeSentText":"A code was sent to","oie.phone.verify.sms.sendText":"Send a code via SMS to","oie.phone.verify.call.sendText":"Send a code via voice call to","oie.phone.verify.call.resendText":"Haven't received a call?","oie.phone.verify.call.resendLinkText":"Call again","oie.phone.verify.sms.resendLinkText":"Send again","oie.phone.verify.enterCodeText":"Enter the code below to verify.","oie.phone.verify.title":"Verify with your phone","oie.phone.alternate.title":"your phone","oie.email.authenticator.description":"Verify with a link or code sent to your email","oie.email.mfa.title":"Verify with your email","oie.email.verify.sentText":"An email was sent to","oie.email.enroll.subtitle":"Please check your email and enter the code below.","oie.authenticator.webauthn.label":"Security Key or Biometric Authenticator","oie.webauthn.description":"Use a security key or a biometric authenticator to sign in","oie.enroll.webauthn.title":"Set up security key or biometric authenticator","oie.enroll.webauthn.instructions":"Your browser will prompt to register a security key or biometric authenticator (Windows Hello, Touch ID, etc.). Follow the instructions to complete enrollment.","oie.enroll.webauthn.uv.required.instructions":"Biometric verification or a PIN is required to setup this authenticator.","oie.enroll.webauthn.instructions.edge":"Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select 'Cancel' in the prompt before continuing.","oie.enroll.webauthn.save":"Set up","oie.webauthn.error.not.supported":"Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.","oie.verify.webauth.title":"Verify with Security Key or Biometric Authenticator","oie.verify.webauthn.instructions":"You will be prompted to use a security key or biometric verification (Windows Hello, Touch ID, etc.). Follow the instructions to complete verification.","oie.verify.webauthn.uv.required.instructions":"Biometric verification or a PIN is required to sign in with this authenticator.","oie.security.question.enroll.title":"Set up security question","oie.security.question.challenge.title":"Verify with your Security Question","oie.security.question.questionKey.label":"Choose a security question","oie.security.question.createQuestion.label":"Create my own security question","oie.security.question.authenticator.description":"Choose a security question and answer that will be used for signing in","oie.okta_verify.authenticator.description":"Okta Verify is an authenticator app, installed on your phone or computer, used to prove your identity","oie.enroll.okta_verify.setup.title":"Set up Okta Verify","oie.enroll.okta_verify.setup.email.title":"Check your email","oie.enroll.okta_verify.setup.sms.title":"Check your text messages","oie.enroll.okta_verify.select.channel.description":"Which option do you want to try?","oie.enroll.okta_verify.select.channel.qrcode.label":"Scan a QR code","oie.enroll.okta_verify.select.channel.email.label":"Email me a setup link","oie.enroll.okta_verify.select.channel.sms.label":"Text me a setup link","oie.enroll.okta_verify.select.channel.title":"More options","oie.enroll.okta_verify.enroll.channel.email.title":"Set up Okta Verify via email link","oie.enroll.okta_verify.enroll.channel.sms.title":"Set up Okta Verify via SMS","oie.enroll.okta_verify.channel.email.description":"Make sure you can access the email on your mobile device.","oie.enroll.okta_verify.channel.sms.description":"Make sure you can access the text on your mobile device.","oie.enroll.okta_verify.qrcode.step1":"On your mobile device, download the Okta Verify app from the App Store (iPhone and iPad) or Google Play (Android devices).","oie.enroll.okta_verify.qrcode.step2":"Open the app and follow the instructions to add your account","oie.enroll.okta_verify.qrcode.step3":"When prompted, tap Scan a QR code, then scan the QR code below:","oie.enroll.okta_verify.qrcode.cannotScan":"Can't scan?","oie.enroll.okta_verify.switch.channel.link.text":"Or <a href=\"#\" class=\"switch-channel-link\">try a different way</a> to set up Okta Verify.","oie.enroll.okta_verify.email.info":"We sent an email to <span class=\"strong\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.","oie.enroll.okta_verify.email.notReceived":"Haven’t received an email? Check your spam folder or <a href=\"#\" class=\"resend-link\">send again</a>","oie.enroll.okta_verify.sms.info":"We sent an SMS to <span class=\"strong\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.","oie.enroll.okta_verify.sms.notReceived":"Haven’t received an SMS? <a href=\"#\" class=\"resend-link\">Send again</a>","oie.enroll.okta_verify.setupLink":"Send me the setup link","oie.okta_verify.totp.title":"Enter a code","oie.okta_verify.totp.enterCodeText":"Enter code from Okta Verify app","oie.okta_verify.push.title":"Get a push notification","oie.okta_verify.push.sent":"Push notification sent","oie.okta_verify.push.send":"Send push notification","oie.okta_verify.signed_nonce.title":"Use Okta FastPass","oie.select.authenticators.enroll.title":"Set up Authenticators","oie.select.authenticators.enroll.subtitle":"Set up authenticators to ensure that only you have access to your account.","oie.select.authenticators.enroll.subtitle.custom":"Set up authenticators for {0} to ensure that only you have access to your account.","oie.setup.required":"Set up required","oie.setup.optional":"Set up optional","oie.optional.authenticator.button.title":"Finish","oie.verify.authenticator.button.text":"Select","oie.enroll.authenticator.button.text":"Set up","oie.select.authenticators.verify.title":"Verify it's you with an authenticator","oie.select.authenticators.verify.subtitle":"Select from the following options","oie.success.redirect":"You are being redirected","oie.go.back":"Go back","oie.enroll.switch.authenticator":"Return to authenticator list","oie.verification.switch.authenticator":"Verify with something else"}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = {"AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia, Plurinational State of","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","VG":"Virgin Islands, British","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CO":"Colombia","KM":"Comoros","CG":"Congo","CK":"Cook Islands","CR":"Costa Rica","CI":"Côte d'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","CD":"Congo, the Democratic Republic of the","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","TL":"Timor-Leste","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KR":"Korea, Republic of","XK":"Kosovo, Republic of","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People's Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, the former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","AN":"Netherlands Antilles","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","KP":"Korea, Democratic People's Republic of","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestine, State of","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Réunion","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","SH":"Saint Helena, Ascension and Tristan da Cunha","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"São Tomé and Príncipe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","VI":"Virgin Islands, U.S.","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VA":"Holy See (Vatican City State)","VE":"Venezuela, Bolivarian Republic of","VN":"Viet Nam","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(712);

module.exports = parent;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var startsWith = __webpack_require__(713);

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.startsWith;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.startsWith) ? startsWith : own;
};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(714);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('String').startsWith;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var getOwnPropertyDescriptor = __webpack_require__(104).f;
var toLength = __webpack_require__(47);
var notARegExp = __webpack_require__(224);
var requireObjectCoercible = __webpack_require__(107);
var correctIsRegExpLogic = __webpack_require__(225);
var IS_PURE = __webpack_require__(63);

var nativeStartsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 * 
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 * 
 */
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.OktaAuth=t():e.OktaAuth=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=11)}([function(e,t){var r=e.exports;r.stringToBase64Url=function(e){var t=btoa(e);return r.base64ToBase64Url(t)},r.base64ToBase64Url=function(e){return e.replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")},r.base64UrlToBase64=function(e){return e.replace(/-/g,"+").replace(/_/g,"/")},r.base64UrlToString=function(e){var t=r.base64UrlToBase64(e);switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Not a valid Base64Url"}var n=atob(t);try{return decodeURIComponent(escape(n))}catch(e){return n}},r.stringToBuffer=function(e){for(var t=new Uint8Array(e.length),r=0;r<e.length;r++)t[r]=e.charCodeAt(r);return t},r.base64UrlDecode=function(e){return atob(r.base64UrlToBase64(e))},r.bind=function(e,t){var r=Array.prototype.slice.call(arguments,2);return function(){var n=Array.prototype.slice.call(arguments);return n=r.concat(n),e.apply(t,n)}},r.isAbsoluteUrl=function(e){return/^(?:[a-z]+:)?\/\//i.test(e)},r.isString=function(e){return"[object String]"===Object.prototype.toString.call(e)},r.isObject=function(e){return"[object Object]"===Object.prototype.toString.call(e)},r.isNumber=function(e){return"[object Number]"===Object.prototype.toString.call(e)},r.isoToUTCString=function(e){var t=e.match(/\d+/g),r=Date.UTC(t[0],t[1]-1,t[2],t[3],t[4],t[5]);return new Date(r).toUTCString()},r.toQueryParams=function(e){var t=[];if(null!==e)for(var r in e)e.hasOwnProperty(r)&&void 0!==e[r]&&null!==e[r]&&t.push(r+"="+encodeURIComponent(e[r]));return t.length?"?"+t.join("&"):""},r.genRandomString=function(e){for(var t="abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",r="",n=0,o=t.length;n<e;++n)r+=t[Math.floor(Math.random()*o)];return r},r.extend=function(){var e=arguments[0];return[].slice.call(arguments,1).forEach(function(t){for(var r in t)t.hasOwnProperty(r)&&void 0!==t[r]&&(e[r]=t[r])}),e},r.removeNils=function(e){var t={};for(var r in e)if(e.hasOwnProperty(r)){var n=e[r];null!==n&&void 0!==n&&(t[r]=n)}return t},r.clone=function(e){if(e){var t=JSON.stringify(e);if(t)return JSON.parse(t)}return e},r.omit=function(e){var t=Array.prototype.slice.call(arguments,1),n={};for(var o in e)e.hasOwnProperty(o)&&-1==t.indexOf(o)&&(n[o]=e[o]);return r.clone(n)},r.find=function(e,t){for(var r=e.length;r--;){var n=e[r],o=!0;for(var i in t)if(t.hasOwnProperty(i)&&n[i]!==t[i]){o=!1;break}if(o)return n}},r.getLink=function(e,t,n){if(e&&e._links){var o=r.clone(e._links[t]);return o&&o.name&&n?o.name===n?o:void 0:o}},r.getNativeConsole=function(){return"undefined"!=typeof window?window.console:"undefined"!=typeof console?console:void 0},r.getConsole=function(){var e=r.getNativeConsole();return e&&e.log?e:{log:function(){}}},r.warn=function(e){r.getConsole().log("[okta-auth-sdk] WARN: "+e)},r.deprecate=function(e){r.getConsole().log("[okta-auth-sdk] DEPRECATION: "+e)},r.deprecateWrap=function(e,t){return function(){return r.deprecate(e),t.apply(null,arguments)}},r.removeTrailingSlash=function(e){if(e){var t=e.replace(/^\s+|\s+$/gm,"");return t=t.replace(/\/+$/,"")}},r.isIE11OrLess=function(){return!!document.documentMode&&document.documentMode<=11},r.isFunction=function(e){return!!e&&"[object Function]"==={}.toString.call(e)},r.delay=function(e){return new Promise(function(t){setTimeout(t,e)})},r.isPromise=function(e){return e&&e.finally&&"function"==typeof e.finally}},function(e,t){function r(e,t){this.name="AuthSdkError",this.message=e,this.errorCode="INTERNAL",this.errorSummary=e,this.errorLink="INTERNAL",this.errorId="INTERNAL",this.errorCauses=[],t&&(this.xhr=t)}r.prototype=new Error,e.exports=r},function(e,t){e.exports={STATE_TOKEN_KEY_NAME:"oktaStateToken",DEFAULT_POLLING_DELAY:500,DEFAULT_MAX_CLOCK_SKEW:300,DEFAULT_CACHE_DURATION:86400,REDIRECT_OAUTH_PARAMS_COOKIE_NAME:"okta-oauth-redirect-params",REDIRECT_STATE_COOKIE_NAME:"okta-oauth-state",REDIRECT_NONCE_COOKIE_NAME:"okta-oauth-nonce",TOKEN_STORAGE_NAME:"okta-token-storage",CACHE_STORAGE_NAME:"okta-cache-storage",PKCE_STORAGE_NAME:"okta-pkce-storage",ACCESS_TOKEN_STORAGE_KEY:"accessToken",ID_TOKEN_STORAGE_KEY:"idToken"}},function(e,t,r){function n(e,t){t=t||{};var r=t.url,n=t.method,o=t.args,i=t.saveAuthnState,c=t.accessToken,l=!1!==t.withCredentials,f=e.options.storageUtil,p=f.storage,h=f.getHttpCache(e.options.cookies);if(t.cacheResponse){var d=h.getStorage(),g=d[r];if(g&&Date.now()/1e3<g.expiresAt)return Promise.resolve(g.response)}var m={Accept:"application/json","Content-Type":"application/json","X-Okta-User-Agent-Extended":e.userAgent};s.extend(m,e.options.headers,t.headers),c&&s.isString(c)&&(m.Authorization="Bearer "+c);var y,v,w={headers:m,data:o||void 0,withCredentials:l};return e.options.httpRequestClient(n,r,w).then(function(n){return v=n.responseText,v&&s.isString(v)&&(v=JSON.parse(v)),i&&(v.stateToken||p.delete(u.STATE_TOKEN_KEY_NAME)),v&&v.stateToken&&v.expiresAt&&p.set(u.STATE_TOKEN_KEY_NAME,v.stateToken,v.expiresAt,e.options.cookies),v&&t.cacheResponse&&h.updateStorage(r,{expiresAt:Math.floor(Date.now()/1e3)+u.DEFAULT_CACHE_DURATION,response:v}),v}).catch(function(t){var r=t.responseText||{};if(s.isString(r))try{r=JSON.parse(r)}catch(e){r={errorSummary:"Unknown error"}}throw t.status>=500&&(r.errorSummary="Unknown error"),e.options.transformErrorXHR&&(t=e.options.transformErrorXHR(s.clone(t))),y=new a(r,t),"E0000011"===y.errorCode&&p.delete(u.STATE_TOKEN_KEY_NAME),y})}function o(e,t,r){t=s.isAbsoluteUrl(t)?t:e.getIssuerOrigin()+t;var o={url:t,method:"GET"};return s.extend(o,r),n(e,o)}function i(e,t,r,o){t=s.isAbsoluteUrl(t)?t:e.getIssuerOrigin()+t;var i={url:t,method:"POST",args:r,saveAuthnState:!0};return s.extend(i,o),n(e,i)}var s=r(0),a=r(19),u=r(2);e.exports={get:o,post:i,httpRequest:n}},function(e,t,r){var n=r(14),o=r(7),i=r(2),s=r(1),a={};a.browserHasLocalStorage=function(){try{var e=a.getLocalStorage();return a.testStorage(e)}catch(e){return!1}},a.browserHasSessionStorage=function(){try{var e=a.getSessionStorage();return a.testStorage(e)}catch(e){return!1}},a.getPKCEStorage=function(e){return e=e||{},!e.preferLocalStorage&&a.browserHasSessionStorage()?o(a.getSessionStorage(),i.PKCE_STORAGE_NAME):a.browserHasLocalStorage()?o(a.getLocalStorage(),i.PKCE_STORAGE_NAME):o(a.getCookieStorage(e),i.PKCE_STORAGE_NAME)},a.getHttpCache=function(e){return a.browserHasLocalStorage()?o(a.getLocalStorage(),i.CACHE_STORAGE_NAME):a.browserHasSessionStorage()?o(a.getSessionStorage(),i.CACHE_STORAGE_NAME):o(a.getCookieStorage(e),i.CACHE_STORAGE_NAME)},a.getLocalStorage=function(){return localStorage},a.getSessionStorage=function(){return sessionStorage},a.getCookieStorage=function(e){var t=e.secure,r=e.sameSite;if(void 0===t||void 0===r)throw new s('getCookieStorage: "secure" and "sameSite" options must be provided');return{getItem:a.storage.get,setItem:function(e,n){a.storage.set(e,n,"2200-01-01T00:00:00.000Z",{secure:t,sameSite:r})}}},a.getInMemoryStorage=function(){var e={};return{getItem:function(t){return e[t]},setItem:function(t,r){e[t]=r}}},a.testStorage=function(e){var t="okta-test-storage";try{return e.setItem(t,t),e.removeItem(t),!0}catch(e){return!1}},a.storage={set:function(e,t,r,o){var i=o.secure,u=o.sameSite;if(void 0===i||void 0===u)throw new s('storage.set: "secure" and "sameSite" options must be provided');var c={path:o.path||"/",secure:i,sameSite:u};return Date.parse(r)&&(c.expires=new Date(r)),n.set(e,t,c),a.storage.get(e)},get:function(e){return n.get(e)},delete:function(e){return n.remove(e,{path:"/"})}},e.exports=a},function(e,t,r){function n(){return w.genRandomString(64)}function o(){return w.genRandomString(64)}function i(e){return!(!e||!e.accessToken&&!e.idToken||!Array.isArray(e.scopes))}function s(e,t,r){e.addEventListener?e.addEventListener(t,r):e.attachEvent("on"+t,r)}function a(e,t,r){e.removeEventListener?e.removeEventListener(t,r):e.detachEvent("on"+t,r)}function u(e){var t=document.createElement("iframe");return t.style.display="none",t.src=e,document.body.appendChild(t)}function c(e,t){var r=t.popupTitle||"External Identity Provider User Authentication",n="toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600";if(w.isIE11OrLess()){var o=window.open("/",r,n);return o.location.href=e,o}return window.open(e,r,n)}function l(e,t){var r=t||e.options.issuer;return v.get(e,r+"/.well-known/openid-configuration",{cacheResponse:!0})}function f(e,t,r){var n=k.getHttpCache(e.options.cookies);return l(e,t).then(function(t){var o=t.jwks_uri,i=n.getStorage(),s=i[o];if(s&&Date.now()/1e3<s.expiresAt){var a=w.find(s.response.keys,{kid:r});if(a)return a}return n.clearStorage(o),v.get(e,o,{cacheResponse:!0}).then(function(e){var t=w.find(e.keys,{kid:r});if(t)return t;throw new T("The key id, "+r+", was not found in the server's keys")})})}function p(e,t,r){var n=r.clientId,o=r.issuer,i=r.nonce;if(!t||!o||!n)throw new T("The jwt, iss, and aud arguments are all required");if(i&&t.nonce!==i)throw new T("OAuth flow response nonce doesn't match request nonce");var s=Math.floor(Date.now()/1e3);if(t.iss!==o)throw new T("The issuer ["+t.iss+"] does not match ["+o+"]");if(t.aud!==n)throw new T("The audience ["+t.aud+"] does not match ["+n+"]");if(t.iat>t.exp)throw new T("The JWT expired before it was issued");if(s-e.options.maxClockSkew>t.exp)throw new T("The JWT expired and is no longer valid");if(t.iat>s+e.options.maxClockSkew)throw new T("The JWT was issued in the future")}function h(e,t){if(arguments.length>2)throw new T('As of version 3.0, "getOAuthUrls" takes only a single set of options');t=t||{};var r=w.removeTrailingSlash(t.authorizeUrl)||e.options.authorizeUrl,n=w.removeTrailingSlash(t.issuer)||e.options.issuer,o=w.removeTrailingSlash(t.userinfoUrl)||e.options.userinfoUrl,i=w.removeTrailingSlash(t.tokenUrl)||e.options.tokenUrl,s=w.removeTrailingSlash(t.logoutUrl)||e.options.logoutUrl,a=w.removeTrailingSlash(t.revokeUrl)||e.options.revokeUrl,u=n.indexOf("/oauth2")>0?n:n+"/oauth2";return r=r||u+"/v1/authorize",o=o||u+"/v1/userinfo",i=i||u+"/v1/token",a=a||u+"/v1/revoke",s=s||u+"/v1/logout",{issuer:n,authorizeUrl:r,userinfoUrl:o,tokenUrl:i,revokeUrl:a,logoutUrl:s}}function d(e){var t=/\+/g,r=/([^&=]+)=?([^&]*)/g,n=e;"#"===n.charAt(0)&&"/"===n.charAt(1)&&(n=n.substring(2)),"#"!==n.charAt(0)&&"?"!==n.charAt(0)||(n=n.substring(1));for(var o,i={};;){if(!(o=r.exec(n)))break;var s=o[1],a=o[2];i[s]="id_token"===s||"access_token"===s||"code"===s?a:decodeURIComponent(a.replace(t," "))}return i}function g(e){return/((id|access)_token=)/i.test(e)}function m(e){return/(code=)/i.test(e)}function y(e){var t=e.options;return t.pkce||"code"===t.responseType||"query"===t.responseMode?m("fragment"===t.responseMode?window.location.hash:window.location.search):g(window.location.hash)}var v=r(3),w=r(0),k=r(4),T=r(1);e.exports={generateState:n,generateNonce:o,getWellKnown:l,getKey:f,validateClaims:p,getOAuthUrls:h,loadFrame:u,loadPopup:c,urlParamsToObject:d,isToken:i,addListener:s,removeListener:a,isLoginRedirect:y}},function(e,t){function r(t){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?e.exports=r=function(e){return typeof e}:e.exports=r=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},r(t)}e.exports=r},function(e,t,r){function n(e,t){function r(){var r=e.getItem(t);r=r||"{}";try{return JSON.parse(r)}catch(e){throw new o("Unable to parse storage string: "+t)}}function n(r){try{var n=JSON.stringify(r);e.setItem(t,n)}catch(e){throw new o("Unable to set storage: "+t)}}function i(e){if(!e)return n({});var t=r();delete t[e],n(t)}function s(e,t){var o=r();o[e]=t,n(o)}if("string"!=typeof t||!t.length)throw new o('"storageName" is required');return{getStorage:r,setStorage:n,clearStorage:i,updateStorage:s}}var o=r(1);e.exports=n},function(e,t,r){e.exports=r(16)},function(e,t){function r(e,t,r,n,o,i,s){try{var a=e[i](s),u=a.value}catch(e){return void r(e)}a.done?t(u):Promise.resolve(u).then(n,o)}function n(e){return function(){var t=this,n=arguments;return new Promise(function(o,i){function s(e){r(u,o,i,s,a,"next",e)}function a(e){r(u,o,i,s,a,"throw",e)}var u=e.apply(t,n);s(void 0)})}}e.exports=n},function(e,t,r){function n(e,t){var r={};return y.extend(r,t),!r.stateToken&&e.stateToken&&(r.stateToken=e.stateToken),r}function o(e){return n(e)}function i(e,t){return t=n(e,t),m.post(e,e.getIssuerOrigin()+"/api/v1/authn",t)}function s(e,t){if(!t||!t.stateToken){var r=e.tx.exists._get(k.STATE_TOKEN_KEY_NAME);if(!r)return Promise.reject(new v("No transaction to resume"));t={stateToken:r}}return e.tx.status(t).then(function(t){return new g(e,t)})}function a(e,t){if(!t||!t.stateToken){var r=e.tx.exists._get(k.STATE_TOKEN_KEY_NAME);if(!r)return Promise.reject(new v("No transaction to evaluate"));t={stateToken:r}}return u(e,t).then(function(t){return new g(e,t)})}function u(e,t){return t=n(e,t),m.post(e,e.getIssuerOrigin()+"/api/v1/authn/introspect",t)}function c(e){return!!e.tx.exists._get(k.STATE_TOKEN_KEY_NAME)}function l(e,t,r,n){return m.post(e,t,r,n).then(function(t){return new g(e,t)})}function f(e,t,r){return function(n){function i(){var r={};if("function"==typeof u)try{r.autoPush=!!u()}catch(e){return Promise.reject(new v("AutoPush resulted in an error."))}else void 0!==u&&null!==u&&(r.autoPush=!!u);if("function"==typeof a)try{r.rememberDevice=!!a()}catch(e){return Promise.reject(new v("RememberDevice resulted in an error."))}else void 0!==a&&null!==a&&(r.rememberDevice=!!a);var n=l.href+y.toQueryParams(r);return m.post(e,n,o(t),{saveAuthnState:!1})}var s,a,u,c;y.isNumber(n)?s=n:y.isObject(n)&&(s=n.delay,a=n.rememberDevice,u=n.autoPush,c=n.transactionCallBack),s||0===s||(s=k.DEFAULT_POLLING_DELAY);var l=y.getLink(t,"next","poll");r.isPolling=!0;var f=0;return function t(){return r.isPolling?i().then(function(n){if(f=0,n.factorResult&&"WAITING"===n.factorResult){if(!r.isPolling)throw new w;return"function"==typeof c&&c(n),y.delay(s).then(t)}return r.isPolling=!1,new g(e,n)}).catch(function(e){if(e.xhr&&(0===e.xhr.status||429===e.xhr.status)&&f<=4){var r=1e3*Math.pow(2,f);return f++,y.delay(r).then(t)}throw e}):Promise.reject(new w)}().catch(function(e){throw r.isPolling=!1,e})}}function p(e,t,r,o,i){if(Array.isArray(o))return function(n,s){if(!n)throw new v("Must provide a link name");var a=y.find(o,{name:n});if(!a)throw new v("No link found for that name");return p(e,t,r,a,i)(s)};if(o.hints&&o.hints.allow&&1===o.hints.allow.length){switch(o.hints.allow[0]){case"GET":return function(){return m.get(e,o.href)};case"POST":return function(s){i&&i.isPolling&&(i.isPolling=!1);var a=n(t,s);"MFA_ENROLL"!==t.status&&"FACTOR_ENROLL"!==t.status||y.extend(a,{factorType:r.factorType,provider:r.provider});var u={},c=a.autoPush;if(void 0!==c){if("function"==typeof c)try{u.autoPush=!!c()}catch(e){return Promise.reject(new v("AutoPush resulted in an error."))}else null!==c&&(u.autoPush=!!c);a=y.omit(a,"autoPush")}var f=a.rememberDevice;if(void 0!==f){if("function"==typeof f)try{u.rememberDevice=!!f()}catch(e){return Promise.reject(new v("RememberDevice resulted in an error."))}else null!==f&&(u.rememberDevice=!!f);a=y.omit(a,"rememberDevice")}else a.profile&&void 0!==a.profile.updatePhone&&(a.profile.updatePhone&&(u.updatePhone=!0),a.profile=y.omit(a.profile,"updatePhone"));var p=o.href+y.toQueryParams(u);return l(e,p,a)}}}}function h(e,t,r,n){var o={};for(var i in r._links)if(r._links.hasOwnProperty(i)){var s=r._links[i];if("next"===i&&(i=s.name),s.type)o[i]=s;else switch(i){case"poll":o.poll=f(e,t,n);break;default:var a=p(e,t,r,s,n);a&&(o[i]=a)}}return o}function d(e,t,r,n){if(r=r||t,r=y.clone(r),Array.isArray(r)){for(var o=[],i=0,s=r.length;i<s;i++)o.push(d(e,t,r[i],n));return o}var a=r._embedded||{};for(var u in a)a.hasOwnProperty(u)&&(y.isObject(a[u])||Array.isArray(a[u]))&&(a[u]=d(e,t,a[u],n));var c=h(e,t,r,n);return y.extend(a,c),r=y.omit(r,"_embedded","_links"),y.extend(r,a),r}function g(e,t){t&&(this.data=t,y.extend(this,d(e,t,t,{})),delete this.stateToken,"RECOVERY_CHALLENGE"!==t.status||t._links||(this.cancel=function(){return Promise.resolve(new g(e))}))}var m=r(3),y=r(0),v=r(1),w=r(20),k=r(2);e.exports={transactionStatus:i,resumeTransaction:s,transactionExists:c,postToTransaction:l,introspect:a}},function(e,t,r){var n=r(12),o=r(4);e.exports=r(15)(o,n)},function(e,t,r){function n(e){return e.headers.get("Content-Type")&&e.headers.get("Content-Type").toLowerCase().indexOf("application/json")>=0?e.json().catch(function(e){return{error:e,errorSummary:"Could not parse server response"}}):e.text()}function o(e,t){var r="object"===s(t),n={responseText:r?JSON.stringify(t):t,status:e};return r&&(n.responseType="json",n.responseJSON=t),n}function i(e,t,r){var i=r.data,s=r.headers||{};return"application/json"===(s["Content-Type"]||s["content-type"]||"")&&i&&"string"!=typeof i&&(i=JSON.stringify(i)),a(t,{method:e,headers:r.headers,body:i,credentials:r.withCredentials?"include":"omit"}).then(function(e){var t=!e.ok,r=e.status;return n(e).then(function(e){return o(r,e)}).then(function(e){if(t)throw e;return e})})}var s=r(6),a=r(13);e.exports=i},function(e,t){var r=function(e){function t(){this.fetch=!1,this.DOMException=e.DOMException}return t.prototype=e,new t}("undefined"!=typeof self?self:this);!function(e){!function(t){function r(e){return e&&DataView.prototype.isPrototypeOf(e)}function n(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e))throw new TypeError("Invalid character in header field name");return e.toLowerCase()}function o(e){return"string"!=typeof e&&(e=String(e)),e}function i(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return k.iterable&&(t[Symbol.iterator]=function(){return t}),t}function s(e){this.map={},e instanceof s?e.forEach(function(e,t){this.append(t,e)},this):Array.isArray(e)?e.forEach(function(e){this.append(e[0],e[1])},this):e&&Object.getOwnPropertyNames(e).forEach(function(t){this.append(t,e[t])},this)}function a(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=!0}function u(e){return new Promise(function(t,r){e.onload=function(){t(e.result)},e.onerror=function(){r(e.error)}})}function c(e){var t=new FileReader,r=u(t);return t.readAsArrayBuffer(e),r}function l(e){var t=new FileReader,r=u(t);return t.readAsText(e),r}function f(e){for(var t=new Uint8Array(e),r=new Array(t.length),n=0;n<t.length;n++)r[n]=String.fromCharCode(t[n]);return r.join("")}function p(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function h(){return this.bodyUsed=!1,this._initBody=function(e){this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:k.blob&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:k.formData&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:k.searchParams&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():k.arrayBuffer&&k.blob&&r(e)?(this._bodyArrayBuffer=p(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):k.arrayBuffer&&(ArrayBuffer.prototype.isPrototypeOf(e)||b(e))?this._bodyArrayBuffer=p(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):k.searchParams&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},k.blob&&(this.blob=function(){var e=a(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?a(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(c)}),this.text=function(){var e=a(this);if(e)return e;if(this._bodyBlob)return l(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(f(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},k.formData&&(this.formData=function(){return this.text().then(m)}),this.json=function(){return this.text().then(JSON.parse)},this}function d(e){var t=e.toUpperCase();return S.indexOf(t)>-1?t:e}function g(e,t){t=t||{};var r=t.body;if(e instanceof g){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new s(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,r||null==e._bodyInit||(r=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new s(t.headers)),this.method=d(t.method||this.method||"GET"),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&r)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(r)}function m(e){var t=new FormData;return e.trim().split("&").forEach(function(e){if(e){var r=e.split("="),n=r.shift().replace(/\+/g," "),o=r.join("=").replace(/\+/g," ");t.append(decodeURIComponent(n),decodeURIComponent(o))}}),t}function y(e){var t=new s;return e.replace(/\r?\n[\t ]+/g," ").split(/\r?\n/).forEach(function(e){var r=e.split(":"),n=r.shift().trim();if(n){var o=r.join(":").trim();t.append(n,o)}}),t}function v(e,t){t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in t?t.statusText:"OK",this.headers=new s(t.headers),this.url=t.url||"",this._initBody(e)}function w(e,r){return new Promise(function(n,o){function i(){a.abort()}var s=new g(e,r);if(s.signal&&s.signal.aborted)return o(new t.DOMException("Aborted","AbortError"));var a=new XMLHttpRequest;a.onload=function(){var e={status:a.status,statusText:a.statusText,headers:y(a.getAllResponseHeaders()||"")};e.url="responseURL"in a?a.responseURL:e.headers.get("X-Request-URL");var t="response"in a?a.response:a.responseText;n(new v(t,e))},a.onerror=function(){o(new TypeError("Network request failed"))},a.ontimeout=function(){o(new TypeError("Network request failed"))},a.onabort=function(){o(new t.DOMException("Aborted","AbortError"))},a.open(s.method,s.url,!0),"include"===s.credentials?a.withCredentials=!0:"omit"===s.credentials&&(a.withCredentials=!1),"responseType"in a&&k.blob&&(a.responseType="blob"),s.headers.forEach(function(e,t){a.setRequestHeader(t,e)}),s.signal&&(s.signal.addEventListener("abort",i),a.onreadystatechange=function(){4===a.readyState&&s.signal.removeEventListener("abort",i)}),a.send(void 0===s._bodyInit?null:s._bodyInit)})}var k={searchParams:"URLSearchParams"in e,iterable:"Symbol"in e&&"iterator"in Symbol,blob:"FileReader"in e&&"Blob"in e&&function(){try{return new Blob,!0}catch(e){return!1}}(),formData:"FormData"in e,arrayBuffer:"ArrayBuffer"in e};if(k.arrayBuffer)var T=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],b=ArrayBuffer.isView||function(e){return e&&T.indexOf(Object.prototype.toString.call(e))>-1};s.prototype.append=function(e,t){e=n(e),t=o(t);var r=this.map[e];this.map[e]=r?r+", "+t:t},s.prototype.delete=function(e){delete this.map[n(e)]},s.prototype.get=function(e){return e=n(e),this.has(e)?this.map[e]:null},s.prototype.has=function(e){return this.map.hasOwnProperty(n(e))},s.prototype.set=function(e,t){this.map[n(e)]=o(t)},s.prototype.forEach=function(e,t){for(var r in this.map)this.map.hasOwnProperty(r)&&e.call(t,this.map[r],r,this)},s.prototype.keys=function(){var e=[];return this.forEach(function(t,r){e.push(r)}),i(e)},s.prototype.values=function(){var e=[];return this.forEach(function(t){e.push(t)}),i(e)},s.prototype.entries=function(){var e=[];return this.forEach(function(t,r){e.push([r,t])}),i(e)},k.iterable&&(s.prototype[Symbol.iterator]=s.prototype.entries);var S=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];g.prototype.clone=function(){return new g(this,{body:this._bodyInit})},h.call(g.prototype),h.call(v.prototype),v.prototype.clone=function(){return new v(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new s(this.headers),url:this.url})},v.error=function(){var e=new v(null,{status:0,statusText:""});return e.type="error",e};var E=[301,302,303,307,308];v.redirect=function(e,t){if(-1===E.indexOf(t))throw new RangeError("Invalid status code");return new v(null,{status:t,headers:{location:e}})},t.DOMException=e.DOMException;try{new t.DOMException}catch(e){t.DOMException=function(e,t){this.message=e,this.name=t;var r=Error(e);this.stack=r.stack},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException}w.polyfill=!0,e.fetch||(e.fetch=w,e.Headers=s,e.Request=g,e.Response=v),t.Headers=s,t.Request=g,t.Response=v,t.fetch=w}({})}(r),delete r.fetch.polyfill,t=r.fetch,t.default=r.fetch,t.fetch=r.fetch,t.Headers=r.Headers,t.Request=r.Request,t.Response=r.Response,e.exports=t},function(e,t,r){var n,o;!function(i){var s=!1;if(n=i,void 0!==(o="function"==typeof n?n.call(t,r,t,e):n)&&(e.exports=o),s=!0,e.exports=i(),s=!0,!s){var a=window.Cookies,u=window.Cookies=i();u.noConflict=function(){return window.Cookies=a,u}}}(function(){function e(){for(var e=0,t={};e<arguments.length;e++){var r=arguments[e];for(var n in r)t[n]=r[n]}return t}function t(r){function n(t,o,i){var s;if("undefined"!=typeof document){if(arguments.length>1){if(i=e({path:"/"},n.defaults,i),"number"==typeof i.expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}i.expires=i.expires?i.expires.toUTCString():"";try{s=JSON.stringify(o),/^[\{\[]/.test(s)&&(o=s)}catch(e){}o=r.write?r.write(o,t):encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),t=encodeURIComponent(String(t)),t=t.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),t=t.replace(/[\(\)]/g,escape);var u="";for(var c in i)i[c]&&(u+="; "+c,!0!==i[c]&&(u+="="+i[c]));return document.cookie=t+"="+o+u}t||(s={});for(var l=document.cookie?document.cookie.split("; "):[],f=/(%[0-9A-Z]{2})+/g,p=0;p<l.length;p++){var h=l[p].split("="),d=h.slice(1).join("=");this.json||'"'!==d.charAt(0)||(d=d.slice(1,-1));try{var g=h[0].replace(f,decodeURIComponent);if(d=r.read?r.read(d,g):r(d,g)||d.replace(f,decodeURIComponent),this.json)try{d=JSON.parse(d)}catch(e){}if(t===g){s=d;break}t||(s[g]=d)}catch(e){}}return s}}return n.set=n,n.get=function(e){return n.call(n,e)},n.getJSON=function(){return n.apply({json:!0},[].slice.call(arguments))},n.defaults={},n.remove=function(t,r){n(t,"",e(r,{expires:-1}))},n.withConverter=t,n}return t(function(){})})},function(e,t,r){function n(e){var t=this;u.assertValidConfig(e);var r=y.extend({secure:!0},e.cookies);t.features.isLocalhost()&&!t.features.isHTTPS()&&(r.secure=!1),void 0===r.sameSite&&(r.sameSite=r.secure?"none":"lax"),r.secure&&!t.features.isHTTPS()&&(console.warn('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'),r.secure=!1),this.options={clientId:e.clientId,issuer:y.removeTrailingSlash(e.issuer),authorizeUrl:y.removeTrailingSlash(e.authorizeUrl),userinfoUrl:y.removeTrailingSlash(e.userinfoUrl),tokenUrl:y.removeTrailingSlash(e.tokenUrl),revokeUrl:y.removeTrailingSlash(e.revokeUrl),logoutUrl:y.removeTrailingSlash(e.logoutUrl),pkce:!1!==e.pkce,redirectUri:e.redirectUri,postLogoutRedirectUri:e.postLogoutRedirectUri,responseMode:e.responseMode,httpRequestClient:e.httpRequestClient,storageUtil:e.storageUtil,transformErrorXHR:e.transformErrorXHR,headers:e.headers,onSessionExpired:e.onSessionExpired,cookies:r},this.userAgent=u.getUserAgent(e,"okta-auth-js/".concat("3.2.3")),e.maxClockSkew||0===e.maxClockSkew?this.options.maxClockSkew=e.maxClockSkew:this.options.maxClockSkew=c.DEFAULT_MAX_CLOCK_SKEW,this.options.ignoreSignature=!!e.ignoreSignature,t.session={close:y.bind(h.closeSession,null,t),exists:y.bind(h.sessionExists,null,t),get:y.bind(h.getSession,null,t),refresh:y.bind(h.refreshSession,null,t),setCookieAndRedirect:y.bind(h.setCookieAndRedirect,null,t)},t.tx={status:y.bind(m.transactionStatus,null,t),resume:y.bind(m.resumeTransaction,null,t),exists:y.bind(m.transactionExists,null,t),introspect:y.bind(m.introspect,null,t)},t.tx.exists._get=function(e){return l.get(e)},t.idToken={authorize:{_getLocationHref:function(){return window.location.href}}},t._tokenQueue=new v,t.token={getWithoutPrompt:y.bind(d.getWithoutPrompt,null,t),getWithPopup:y.bind(d.getWithPopup,null,t),getWithRedirect:y.bind(d.getWithRedirect,null,t),parseFromUrl:y.bind(d.parseFromUrl,null,t),decode:d.decodeToken,revoke:y.bind(d.revokeToken,null,t),renew:y.bind(d.renewToken,null,t),getUserInfo:y.bind(d.getUserInfo,null,t),verify:y.bind(d.verifyToken,null,t),isLoginRedirect:y.bind(p.isLoginRedirect,null,t)};var n=["decode","isLoginRedirect"];Object.keys(t.token).forEach(function(e){if(!(n.indexOf(e)>=0)){var r=t.token[e];t.token[e]=y.bind(v.prototype.push,t._tokenQueue,r,null)}}),t.token.getWithRedirect._setLocation=function(e){window.location=e},t.token.parseFromUrl._getHistory=function(){return window.history},t.token.parseFromUrl._getLocation=function(){return window.location},t.token.parseFromUrl._getDocument=function(){return window.document},t.fingerprint._getUserAgent=function(){return navigator.userAgent};var o=/windows phone|iemobile|wpdesktop/i;t.features.isFingerprintSupported=function(){var e=t.fingerprint._getUserAgent();return e&&!o.test(e)},t.emitter=new s,t.tokenManager=new g(t,e.tokenManager),t.tokenManager.on("error",this._onTokenManagerError,this)}var o=r(8),i=r(9),s=r(17),a=r(1),u=r(18),c=r(2),l=r(4).storage,f=r(3),p=r(5),h=r(21),d=r(22),g=r(26),m=r(10),y=r(0),v=r(28),w=n.prototype;w._onTokenManagerError=function(e){"login_required"===e.errorCode&&e.accessToken&&(this.options.onSessionExpired?this.options.onSessionExpired():console.error("Session has expired or was closed outside the application."))},w.features={},w.features.isPopupPostMessageSupported=function(){var e=document.documentMode&&document.documentMode<10;return!(!window.postMessage||e)},w.features.isTokenVerifySupported=function(){return"undefined"!=typeof crypto&&crypto.subtle&&"undefined"!=typeof Uint8Array},w.features.hasTextEncoder=function(){return"undefined"!=typeof TextEncoder},w.features.isPKCESupported=function(){return w.features.isTokenVerifySupported()&&w.features.hasTextEncoder()},w.features.isHTTPS=function(){return"https:"===window.location.protocol},w.features.isLocalhost=function(){return"localhost"===window.location.hostname},w.signIn=function(e){function t(t){return delete e.sendFingerprint,m.postToTransaction(r,"/api/v1/authn",e,t)}var r=this;return e=y.clone(e||{}),e.sendFingerprint?r.fingerprint().then(function(e){return t({headers:{"X-Device-Fingerprint":e}})}):t()},w.closeSession=function(){var e=this;return e.tokenManager.clear(),e.session.close().catch(function(e){if("AuthApiError"!==e.name||"E0000007"!==e.errorCode)throw e})},w.revokeAccessToken=function(){function e(e){return t.apply(this,arguments)}var t=i(o.mark(function e(t){var r;return o.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(r=this,t){e.next=6;break}return e.next=4,r.tokenManager.get(c.ACCESS_TOKEN_STORAGE_KEY);case 4:t=e.sent,r.tokenManager.remove(c.ACCESS_TOKEN_STORAGE_KEY);case 6:if(t){e.next=8;break}return e.abrupt("return",Promise.resolve());case 8:return e.abrupt("return",r.token.revoke(t));case 9:case"end":return e.stop()}},e,this)}));return e}(),w.signOut=function(){var e=i(o.mark(function e(t){var r,n,i,s,a,u,l,f,h,d,g;return o.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(t=y.extend({},t),r=window.location.origin,n=window.location.href,i=t.postLogoutRedirectUri||this.options.postLogoutRedirectUri||r,s=t.accessToken,a=!1!==t.revokeAccessToken,u=t.idToken,l=this,f=p.getOAuthUrls(l).logoutUrl,void 0!==u){e.next=13;break}return e.next=12,l.tokenManager.get(c.ID_TOKEN_STORAGE_KEY);case 12:u=e.sent;case 13:if(!a||void 0!==s){e.next=17;break}return e.next=16,l.tokenManager.get(c.ACCESS_TOKEN_STORAGE_KEY);case 16:s=e.sent;case 17:if(l.tokenManager.clear(),!a||!s){e.next=21;break}return e.next=21,l.revokeAccessToken(s);case 21:if(u){e.next=23;break}return e.abrupt("return",l.closeSession().then(function(){i===n?window.location.reload():window.location.assign(i)}));case 23:h=t.state,d=u.idToken,g=f+"?id_token_hint="+encodeURIComponent(d)+"&post_logout_redirect_uri="+encodeURIComponent(i),h&&(g+="&state="+encodeURIComponent(h)),window.location.assign(g);case 28:case"end":return e.stop()}},e,this)}));return function(t){return e.apply(this,arguments)}}(),u.addSharedPrototypes(w),w.webfinger=function(e){var t="/.well-known/webfinger"+y.toQueryParams(e),r={headers:{Accept:"application/jrd+json"}};return f.get(this,t,r)},w.fingerprint=function(e){e=e||{};var t=this;if(!t.features.isFingerprintSupported())return Promise.reject(new a("Fingerprinting is not supported on this device"));var r,n,o;return new Promise(function(i,s){n=document.createElement("iframe"),n.style.display="none",o=function(e){if(e&&e.data&&e.origin===t.getIssuerOrigin()){try{var r=JSON.parse(e.data)}catch(e){return}if(r)return"FingerprintAvailable"===r.type?i(r.fingerprint):void("FingerprintServiceReady"===r.type&&e.source.postMessage(JSON.stringify({type:"GetFingerprint"}),e.origin))}},p.addListener(window,"message",o),n.src=t.getIssuerOrigin()+"/auth/services/devicefingerprint",document.body.appendChild(n),r=setTimeout(function(){s(new a("Fingerprinting timed out"))},e.timeout||15e3)}).finally(function(){clearTimeout(r),p.removeListener(window,"message",o),document.body.contains(n)&&n.parentElement.removeChild(n)})},e.exports=u.buildOktaAuth(n)},function(e,t,r){var n=function(e){"use strict";function t(e,t,r,o){var i=t&&t.prototype instanceof n?t:n,s=Object.create(i.prototype),a=new p(o||[]);return s._invoke=u(e,r,a),s}function r(e,t,r){try{return{type:"normal",arg:e.call(t,r)}}catch(e){return{type:"throw",arg:e}}}function n(){}function o(){}function i(){}function s(e){["next","throw","return"].forEach(function(t){e[t]=function(e){return this._invoke(t,e)}})}function a(e){function t(n,o,i,s){var a=r(e[n],e,o);if("throw"!==a.type){var u=a.arg,c=u.value;return c&&"object"==typeof c&&y.call(c,"__await")?Promise.resolve(c.__await).then(function(e){t("next",e,i,s)},function(e){t("throw",e,i,s)}):Promise.resolve(c).then(function(e){u.value=e,i(u)},function(e){return t("throw",e,i,s)})}s(a.arg)}function n(e,r){function n(){return new Promise(function(n,o){t(e,r,n,o)})}return o=o?o.then(n,n):n()}var o;this._invoke=n}function u(e,t,n){var o=b;return function(i,s){if(o===E)throw new Error("Generator is already running");if(o===A){if("throw"===i)throw s;return d()}for(n.method=i,n.arg=s;;){var a=n.delegate;if(a){var u=c(a,n);if(u){if(u===_)continue;return u}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(o===b)throw o=A,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);o=E;var l=r(e,t,n);if("normal"===l.type){if(o=n.done?A:S,l.arg===_)continue;return{value:l.arg,done:n.done}}"throw"===l.type&&(o=A,n.method="throw",n.arg=l.arg)}}}function c(e,t){var n=e.iterator[t.method];if(n===g){if(t.delegate=null,"throw"===t.method){if(e.iterator.return&&(t.method="return",t.arg=g,c(e,t),"throw"===t.method))return _;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method")}return _}var o=r(n,e.iterator,t.arg);if("throw"===o.type)return t.method="throw",t.arg=o.arg,t.delegate=null,_;var i=o.arg;return i?i.done?(t[e.resultName]=i.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=g),t.delegate=null,_):i:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,_)}function l(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function f(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function p(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(l,this),this.reset(!0)}function h(e){if(e){var t=e[w];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var r=-1,n=function t(){for(;++r<e.length;)if(y.call(e,r))return t.value=e[r],t.done=!1,t;return t.value=g,t.done=!0,t};return n.next=n}}return{next:d}}function d(){return{value:g,done:!0}}var g,m=Object.prototype,y=m.hasOwnProperty,v="function"==typeof Symbol?Symbol:{},w=v.iterator||"@@iterator",k=v.asyncIterator||"@@asyncIterator",T=v.toStringTag||"@@toStringTag";e.wrap=t;var b="suspendedStart",S="suspendedYield",E="executing",A="completed",_={},x={};x[w]=function(){return this};var O=Object.getPrototypeOf,U=O&&O(O(h([])));U&&U!==m&&y.call(U,w)&&(x=U);var C=i.prototype=n.prototype=Object.create(x);return o.prototype=C.constructor=i,i.constructor=o,i[T]=o.displayName="GeneratorFunction",e.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===o||"GeneratorFunction"===(t.displayName||t.name))},e.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,i):(e.__proto__=i,T in e||(e[T]="GeneratorFunction")),e.prototype=Object.create(C),e},e.awrap=function(e){return{__await:e}},s(a.prototype),a.prototype[k]=function(){return this},e.AsyncIterator=a,e.async=function(r,n,o,i){var s=new a(t(r,n,o,i));return e.isGeneratorFunction(n)?s:s.next().then(function(e){return e.done?e.value:s.next()})},s(C),C[T]="Generator",C[w]=function(){return this},C.toString=function(){return"[object Generator]"},e.keys=function(e){var t=[];for(var r in e)t.push(r);return t.reverse(),function r(){for(;t.length;){var n=t.pop();if(n in e)return r.value=n,r.done=!1,r}return r.done=!0,r}},e.values=h,p.prototype={constructor:p,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=g,this.done=!1,this.delegate=null,this.method="next",this.arg=g,this.tryEntries.forEach(f),!e)for(var t in this)"t"===t.charAt(0)&&y.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=g)},stop:function(){this.done=!0;var e=this.tryEntries[0],t=e.completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(e){function t(t,n){return i.type="throw",i.arg=e,r.next=t,n&&(r.method="next",r.arg=g),!!n}if(this.done)throw e;for(var r=this,n=this.tryEntries.length-1;n>=0;--n){var o=this.tryEntries[n],i=o.completion;if("root"===o.tryLoc)return t("end");if(o.tryLoc<=this.prev){var s=y.call(o,"catchLoc"),a=y.call(o,"finallyLoc");if(s&&a){if(this.prev<o.catchLoc)return t(o.catchLoc,!0);if(this.prev<o.finallyLoc)return t(o.finallyLoc)}else if(s){if(this.prev<o.catchLoc)return t(o.catchLoc,!0)}else{if(!a)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return t(o.finallyLoc)}}}},abrupt:function(e,t){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&y.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var o=n;break}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=e,i.arg=t,o?(this.method="next",this.next=o.finallyLoc,_):this.complete(i)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),_},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var r=this.tryEntries[t];if(r.finallyLoc===e)return this.complete(r.completion,r.afterLoc),f(r),_}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var r=this.tryEntries[t];if(r.tryLoc===e){var n=r.completion;if("throw"===n.type){var o=n.arg;f(r)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,r){return this.delegate={iterator:h(e),resultName:t,nextLoc:r},"next"===this.method&&(this.arg=g),_}},e}(e.exports);try{regeneratorRuntime=n}catch(e){Function("r","regeneratorRuntime = r")(n)}},function(e,t){function r(){}r.prototype={on:function(e,t,r){var n=this.e||(this.e={});return(n[e]||(n[e]=[])).push({fn:t,ctx:r}),this},once:function(e,t,r){function n(){o.off(e,n),t.apply(r,arguments)}var o=this;return n._=t,this.on(e,n,r)},emit:function(e){var t=[].slice.call(arguments,1),r=((this.e||(this.e={}))[e]||[]).slice(),n=0,o=r.length;for(n;n<o;n++)r[n].fn.apply(r[n].ctx,t);return this},off:function(e,t){var r=this.e||(this.e={}),n=r[e],o=[];if(n&&t)for(var i=0,s=n.length;i<s;i++)n[i].fn!==t&&n[i].fn._!==t&&o.push(n[i]);return o.length?r[e]=o:delete r[e],this}},e.exports=r},function(e,t,r){function n(e){if(!e)throw new a("No arguments passed to constructor. Required usage: new OktaAuth(args)");var t=e.issuer;if(!t)throw new a('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(!new RegExp("^http?s?://.+").test(e.issuer))throw new a('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(-1!==t.indexOf("-admin."))throw new a('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');var r=e.userAgent;if(r&&r.template&&-1===r.template.indexOf("$OKTA_AUTH_JS"))throw new a('UserAgentTemplate must include "$OKTA_AUTH_JS" placeholder. Required usage: new OktaAuth({userAgentTemplate: "xxx $OKTA_AUTH_JS xxx"})')}function o(e){e.getIssuerOrigin=function(){return this.options.issuer.split("/oauth2/")[0]},e.forgotPassword=function(e){return u.postToTransaction(this,"/api/v1/authn/recovery/password",e)},e.unlockAccount=function(e){return u.postToTransaction(this,"/api/v1/authn/recovery/unlock",e)},e.verifyRecoveryToken=function(e){return u.postToTransaction(this,"/api/v1/authn/recovery/token",e)}}function i(e){return function(t,r){function n(o){if(!(this instanceof n))return new n(o);o&&(o.storageUtil=t,o.ajaxRequest?(c.deprecate("ajaxRequest is being deprecated, use httpRequestClient attribute instead."),o.httpRequestClient=o.ajaxRequest):o.httpRequestClient||(o.httpRequestClient=r)),c.bind(e,this)(o)}return n.prototype=e.prototype,n.prototype.constructor=n,n.features=e.prototype.features,n}}function s(e,t){var r=e.userAgent||{};return r.value?r.value:r.template?r.template.replace("$OKTA_AUTH_JS",t):t}var a=r(1),u=r(10),c=r(0);e.exports={addSharedPrototypes:o,buildOktaAuth:i,assertValidConfig:n,getUserAgent:s}},function(e,t){function r(e,t){this.name="AuthApiError",this.message=e.errorSummary,this.errorSummary=e.errorSummary,this.errorCode=e.errorCode,this.errorLink=e.errorLink,this.errorId=e.errorId,this.errorCauses=e.errorCauses,t&&(this.xhr=t)}r.prototype=new Error,e.exports=r},function(e,t){function r(){this.name="AuthPollStopError",this.message="The poll was stopped by the sdk"}r.prototype=new Error,e.exports=r},function(e,t,r){function n(e){return e.session.get().then(function(e){return"ACTIVE"===e.status}).catch(function(){return!1})}function o(e){return c.get(e,"/api/v1/sessions/me").then(function(t){var r=u.omit(t,"_links");return r.refresh=function(){return c.post(e,u.getLink(t,"refresh").href)},r.user=function(){return c.get(e,u.getLink(t,"user").href)},r}).catch(function(){return{status:"INACTIVE"}})}function i(e){return c.httpRequest(e,{url:e.getIssuerOrigin()+"/api/v1/sessions/me",method:"DELETE"})}function s(e){return c.post(e,"/api/v1/sessions/me/lifecycle/refresh")}function a(e,t,r){r=r||window.location.href,window.location=e.getIssuerOrigin()+"/login/sessionCookieRedirect"+u.toQueryParams({checkAccountSetupComplete:!0,token:t,redirectUrl:r})}var u=r(0),c=r(3);e.exports={sessionExists:n,getSession:o,closeSession:i,refreshSession:s,setCookieAndRedirect:a}},function(e,t,r){function n(e,t){return Promise.resolve().then(function(){if(!t||!t.accessToken)throw new C("A valid access token object is required");var r=e.options.clientId;if(!r)throw new C("A clientId must be specified in the OktaAuth constructor to revoke a token");var n=O.getOAuthUrls(e).revokeUrl,o=t.accessToken,i=x.toQueryParams({token_type_hint:"access_token",token:o}).slice(1),s=btoa(r);return _.post(e,n,i,{headers:{"Content-Type":"application/x-www-form-urlencoded",Authorization:"Basic "+s}})})}function o(e){var t,r=e.split(".");try{t={header:JSON.parse(x.base64UrlToString(r[0])),payload:JSON.parse(x.base64UrlToString(r[1])),signature:r[2]}}catch(e){throw new C("Malformed token")}return t}function i(e,t,r){return Promise.resolve().then(function(){if(!t||!t.idToken)throw new C("Only idTokens may be verified");var n=o(t.idToken),i={clientId:e.options.clientId,issuer:e.options.issuer,ignoreSignature:e.options.ignoreSignature};return x.extend(i,r),O.validateClaims(e,n.payload,i),1!=i.ignoreSignature&&e.features.isTokenVerifySupported()?O.getKey(e,t.issuer,n.header.kid).then(function(e){return U.verifyToken(t.idToken,e)}).then(function(e){if(!e)throw new C("The token signature is not valid");if(r&&r.accessToken&&t.claims.at_hash)return U.getOidcHash(r.accessToken).then(function(e){if(e!==t.claims.at_hash)throw new C("Token hash verification failed")})}).then(function(){return t}):t})}function s(e,t,r){var n,o;return new Promise(function(i,s){n=function(t){if(t.data&&t.data.state===r)return t.origin!==e.getIssuerOrigin()?s(new C("The request does not match client configuration")):void i(t.data)},O.addListener(window,"message",n),o=setTimeout(function(){s(new C("OAuth flow timed out"))},t||12e4)}).finally(function(){clearTimeout(o),O.removeListener(window,"message",n)})}function a(e,t,r,n){var o=L.loadMeta(e),i={clientId:t.clientId,authorizationCode:r,codeVerifier:o.codeVerifier,redirectUri:o.redirectUri};return L.getToken(e,i,n).then(function(e){return u(e,i),e}).finally(function(){L.clearMeta(e)})}function u(e,t){if(e.error||e.error_description)throw new P(e.error,e.error_description);if(e.state!==t.state)throw new C("OAuth flow response state doesn't match request state")}function c(e,t,r,n){n=n||{};var o=t.responseType;Array.isArray(o)||(o=[o]);var s=x.clone(t.scopes),c=t.clientId||e.options.clientId,l=!1!==e.options.pkce;return Promise.resolve().then(function(){return u(r,t),r.code&&l?(o=["token"],-1!==s.indexOf("openid")&&o.push("id_token"),a(e,t,r.code,n)):r}).then(function(r){var o={},a=r.expires_in,u=r.token_type,l=r.access_token,f=r.id_token;if(l&&(o.accessToken={value:l,accessToken:l,expiresAt:Number(a)+Math.floor(Date.now()/1e3),tokenType:u,scopes:s,authorizeUrl:n.authorizeUrl,userinfoUrl:n.userinfoUrl}),f){var p=e.token.decode(f),h={value:f,idToken:f,claims:p.payload,expiresAt:p.payload.exp,scopes:s,authorizeUrl:n.authorizeUrl,issuer:n.issuer,clientId:c},d={clientId:c,issuer:n.issuer,nonce:t.nonce,accessToken:l};return void 0!==t.ignoreSignature&&(d.ignoreSignature=t.ignoreSignature),i(e,h,d).then(function(){return o.idToken=h,o})}return o}).then(function(e){if(-1!==o.indexOf("token")&&!e.accessToken)throw new C('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');if(-1!==o.indexOf("id_token")&&!e.idToken)throw new C('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');return{tokens:e,state:r.state,code:r.code}})}function l(e){return{pkce:e.options.pkce,clientId:e.options.clientId,redirectUri:e.options.redirectUri||window.location.href,responseType:["token","id_token"],responseMode:e.options.responseMode,state:O.generateState(),nonce:O.generateNonce(),scopes:["openid","email"],ignoreSignature:e.options.ignoreSignature}}function f(e){if(!e.clientId)throw new C("A clientId must be specified in the OktaAuth constructor to get a token");if(x.isString(e.responseType)&&-1!==e.responseType.indexOf(" "))throw new C("Multiple OAuth responseTypes must be defined as an array");var t=x.removeNils({client_id:e.clientId,code_challenge:e.codeChallenge,code_challenge_method:e.codeChallengeMethod,display:e.display,idp:e.idp,idp_scope:e.idpScope,login_hint:e.loginHint,max_age:e.maxAge,nonce:e.nonce,prompt:e.prompt,redirect_uri:e.redirectUri,response_mode:e.responseMode,response_type:e.responseType,sessionToken:e.sessionToken,state:e.state});if(["idp_scope","response_type"].forEach(function(e){Array.isArray(t[e])&&(t[e]=t[e].join(" "))}),-1!==e.responseType.indexOf("id_token")&&-1===e.scopes.indexOf("openid"))throw new C("openid scope must be specified in the scopes argument when requesting an id_token");return t.scope=e.scopes.join(" "),t}function p(e){var t=f(e);return x.toQueryParams(t)}function h(e,t){return arguments.length>2?Promise.reject(new C('As of version 3.0, "getToken" takes only a single set of options')):(t=t||{},m(e,t).then(function(r){var n={prompt:"none",responseMode:"okta_post_message",display:null},o={display:"popup"};t.sessionToken?x.extend(r,n):t.idp&&x.extend(r,o);var i,a,u;u=O.getOAuthUrls(e,r),a=t.codeVerifier?u.tokenUrl:u.authorizeUrl,i=a+p(r);switch(r.sessionToken||null===r.display?"IFRAME":"popup"===r.display?"POPUP":"IMPLICIT"){case"IFRAME":var l=s(e,t.timeout,r.state),f=O.loadFrame(i);return l.then(function(t){return c(e,r,t,u)}).finally(function(){document.body.contains(f)&&f.parentElement.removeChild(f)});case"POPUP":var h;if("okta_post_message"===r.responseMode){if(!e.features.isPopupPostMessageSupported())throw new C("This browser doesn't have full postMessage support");h=s(e,t.timeout,r.state)}var d={popupTitle:t.popupTitle},g=O.loadPopup(i,d);return new Promise(function(e,t){var r=setInterval(function(){g&&!g.closed||(clearInterval(r),t(new C("Unable to parse OAuth flow response")))},100);h.then(function(t){clearInterval(r),e(t)}).catch(function(e){clearInterval(r),t(e)})}).then(function(t){return c(e,r,t,u)}).finally(function(){g&&!g.closed&&g.close()});default:throw new C("The full page redirect flow is not supported")}}).catch(function(t){throw e.options.pkce&&L.clearMeta(e),t}))}function d(e,t){return arguments.length>2?Promise.reject(new C('As of version 3.0, "getWithoutPrompt" takes only a single set of options')):(t=x.clone(t)||{},x.extend(t,{prompt:"none",responseMode:"okta_post_message",display:null}),h(e,t))}function g(e,t){return arguments.length>2?Promise.reject(new C('As of version 3.0, "getWithPopup" takes only a single set of options')):(t=x.clone(t)||{},x.extend(t,{display:"popup",responseMode:"okta_post_message"}),h(e,t))}function m(e,t){if(O.isLoginRedirect(e))return Promise.reject(new C("The app should not attempt to call getToken on callback. Authorize flow is already in process. Use parseFromUrl() to receive tokens."));t=x.clone(t)||{};var r=l(e);if(x.extend(r,t),!1===r.pkce)return Promise.resolve(r);if(!e.features.isPKCESupported()){var n="PKCE requires a modern browser with encryption support running in a secure context.";return e.features.isHTTPS()||(n+="\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."),e.features.hasTextEncoder()||(n+='\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'),Promise.reject(new C(n))}return r.codeChallengeMethod||(r.codeChallengeMethod=L.DEFAULT_CODE_CHALLENGE_METHOD),r.responseType="code",O.getWellKnown(e,null).then(function(e){if(-1===(e.code_challenge_methods_supported||[]).indexOf(r.codeChallengeMethod))throw new C("Invalid code_challenge_method")}).then(function(){var t=L.generateVerifier(r.codeVerifier),n={codeVerifier:t,redirectUri:r.redirectUri};return L.saveMeta(e,n),L.computeChallenge(t)}).then(function(e){var t=x.clone(r)||{};return x.extend(t,r,{codeChallenge:e}),t})}function y(e,t){return arguments.length>2?Promise.reject(new C('As of version 3.0, "getWithRedirect" takes only a single set of options')):(t=x.clone(t)||{},m(e,t).then(function(r){var n=O.getOAuthUrls(e,t),o=n.authorizeUrl+p(r);I.set(R.REDIRECT_OAUTH_PARAMS_COOKIE_NAME,JSON.stringify({responseType:r.responseType,state:r.state,nonce:r.nonce,scopes:r.scopes,clientId:r.clientId,urls:n,ignoreSignature:r.ignoreSignature}),null,e.options.cookies),I.set(R.REDIRECT_NONCE_COOKIE_NAME,r.nonce,null,e.options.cookies),I.set(R.REDIRECT_STATE_COOKIE_NAME,r.state,null,e.options.cookies),e.token.getWithRedirect._setLocation(o)}))}function v(e,t){if(!O.isToken(t))return Promise.reject(new C("Renew must be passed a token with an array of scopes and an accessToken or idToken"));var r;return r=e.options.pkce?"code":t.accessToken?"token":"id_token",d(e,{responseType:r,scopes:t.scopes,authorizeUrl:t.authorizeUrl,userinfoUrl:t.userinfoUrl,issuer:t.issuer}).then(function(e){var r=e.tokens;return t.idToken?r.idToken:r.accessToken})}function w(e){var t=e.token.parseFromUrl._getHistory(),r=e.token.parseFromUrl._getDocument(),n=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,r.title,n.pathname+n.search):n.hash=""}function k(e){var t=e.token.parseFromUrl._getHistory(),r=e.token.parseFromUrl._getDocument(),n=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,r.title,n.pathname+n.hash):n.search=""}function T(e,t){t=t||{},x.isString(t)&&(t={url:t});var r,n=e.options.pkce?"query":"fragment",o=t.url,i=t.responseMode||e.options.responseMode||n,s=e.token.parseFromUrl._getLocation();if(!(r="query"===i?o?o.substring(o.indexOf("?")):s.search:o?o.substring(o.indexOf("#")):s.hash))return Promise.reject(new C("Unable to parse a token from the url"));var a=I.get(R.REDIRECT_OAUTH_PARAMS_COOKIE_NAME);if(!a)return Promise.reject(new C("Unable to retrieve OAuth redirect params cookie"));try{var u=JSON.parse(a),l=u.urls;delete u.urls,I.delete(R.REDIRECT_OAUTH_PARAMS_COOKIE_NAME)}catch(e){return Promise.reject(new C("Unable to parse the "+R.REDIRECT_OAUTH_PARAMS_COOKIE_NAME+" cookie: "+e.message))}return Promise.resolve(O.urlParamsToObject(r)).then(function(t){return o||("query"===i?k(e):w(e)),c(e,u,t,l)})}function b(e,t,r){return S.apply(this,arguments)}function S(){return S=A(E.mark(function e(t,r,n){return E.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(r){e.next=4;break}return e.next=3,t.tokenManager.get(R.ACCESS_TOKEN_STORAGE_KEY);case 3:r=e.sent;case 4:if(n){e.next=8;break}return e.next=7,t.tokenManager.get(R.ID_TOKEN_STORAGE_KEY);case 7:n=e.sent;case 8:if(r&&(O.isToken(r)||r.accessToken||r.userinfoUrl)){e.next=10;break}return e.abrupt("return",Promise.reject(new C("getUserInfo requires an access token object")));case 10:if(n&&(O.isToken(n)||n.idToken)){e.next=12;break}return e.abrupt("return",Promise.reject(new C("getUserInfo requires an ID token object")));case 12:return e.abrupt("return",_.httpRequest(t,{url:r.userinfoUrl,method:"GET",accessToken:r.accessToken}).then(function(e){return e.sub===n.claims.sub?e:Promise.reject(new C("getUserInfo request was rejected due to token mismatch"))}).catch(function(e){if(e.xhr&&(401===e.xhr.status||403===e.xhr.status)){var t;if(e.xhr.headers&&x.isFunction(e.xhr.headers.get)&&e.xhr.headers.get("WWW-Authenticate")?t=e.xhr.headers.get("WWW-Authenticate"):x.isFunction(e.xhr.getResponseHeader)&&(t=e.xhr.getResponseHeader("WWW-Authenticate")),t){var r=t.match(/error="(.*?)"/)||[],n=t.match(/error_description="(.*?)"/)||[],o=r[1],i=n[1];o&&i&&(e=new P(o,i))}}throw e}));case 13:case"end":return e.stop()}},e)})),S.apply(this,arguments)}var E=r(8),A=r(9),_=r(3),x=r(0),O=r(5),U=r(23),C=r(1),P=r(24),R=r(2),I=r(4).storage,L=r(25);e.exports={revokeToken:n,getToken:h,getWithoutPrompt:d,getWithPopup:g,getWithRedirect:y,parseFromUrl:T,decodeToken:o,renewToken:v,getUserInfo:b,verifyToken:i,handleOAuthResponse:c,prepareOauthParams:m}},function(e,t,r){function n(e){var t=(new TextEncoder).encode(e);return crypto.subtle.digest("SHA-256",t).then(function(e){var t=new Uint8Array(e),r=t.slice(0,16),n=String.fromCharCode.apply(null,r);return i.stringToBase64Url(n)})}function o(e,t){t=i.clone(t);var r={name:"RSASSA-PKCS1-v1_5",hash:{name:"SHA-256"}},n=["verify"];return delete t.use,crypto.subtle.importKey("jwk",t,r,!0,n).then(function(t){var n=e.split("."),o=i.stringToBuffer(n[0]+"."+n[1]),s=i.base64UrlDecode(n[2]),a=i.stringToBuffer(s);return crypto.subtle.verify(r,t,a,o)})}var i=r(0);e.exports={getOidcHash:n,verifyToken:o}},function(e,t){function r(e,t){this.name="OAuthError",this.message=t,this.errorCode=e,this.errorSummary=t}r.prototype=new Error,e.exports=r},function(e,t,r){function n(e){return("0"+e.toString(16)).substr(-2)}function o(e){var t=new Uint8Array(Math.ceil(e/2));return crypto.getRandomValues(t),Array.from(t,n).join("").slice(0,e)}function i(e){var t=e||"";return t.length<y&&(t+=o(y-t.length)),encodeURIComponent(t).slice(0,v)}function s(e,t){return t=m.extend({},e.options.cookies,t),e.options.storageUtil.getPKCEStorage(t)}function a(e,t){var r=s(e,{preferLocalStorage:!0}),n=r.getStorage();n.codeVerifier&&m.warn("saveMeta: PKCE codeVerifier exists in localStorage. This may indicate an auth flow is already in progress."),r=s(e),n=r.getStorage(),n.codeVerifier&&m.warn("saveMeta: PKCE codeVerifier exists in sessionStorage. This may indicate an auth flow is already in progress."),c(e),r.setStorage(t)}function u(e){var t=s(e,{preferLocalStorage:!0}),r=t.getStorage();if(!r.codeVerifier&&(t=s(e,{preferLocalStorage:!1}),r=t.getStorage(),!r.codeVerifier))throw new d("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.",null);return r}function c(e){var t=s(e);t.clearStorage(),t=s(e,{preferLocalStorage:!0}),t.clearStorage()}function l(e){var t=(new TextEncoder).encode(e);return crypto.subtle.digest("SHA-256",t).then(function(e){var t=String.fromCharCode.apply(null,new Uint8Array(e));return m.stringToBase64Url(t)})}function f(e){if(!e.clientId)throw new d("A clientId must be specified in the OktaAuth constructor to get a token");if(!e.redirectUri)throw new d("The redirectUri passed to /authorize must also be passed to /token");if(!e.authorizationCode)throw new d("An authorization code (returned from /authorize) must be passed to /token");if(!e.codeVerifier)throw new d('The "codeVerifier" (generated and saved by your app) must be passed to /token')}function p(e){var t=m.removeNils({client_id:e.clientId,redirect_uri:e.redirectUri,grant_type:"authorization_code",code:e.authorizationCode,code_verifier:e.codeVerifier});return m.toQueryParams(t).slice(1)}function h(e,t,r){f(t);var n=p(t);return g.httpRequest(e,{url:r.tokenUrl,method:"POST",args:n,withCredentials:!1,headers:{"Content-Type":"application/x-www-form-urlencoded"}})}var d=r(1),g=r(3),m=r(0),y=43,v=128;e.exports={DEFAULT_CODE_CHALLENGE_METHOD:"S256",generateVerifier:i,clearMeta:c,saveMeta:a,loadMeta:u,computeChallenge:l,getToken:h}},function(e,t,r){function n(e,t){return t.expiresAt-e.options.expireEarlySeconds}function o(e,t){return n(e,t)<=e.clock.now()}function i(e,t,r){e.emitter.emit("expired",t,r)}function s(e,t){e.emitter.emit("error",t)}function a(e,t){clearTimeout(e.expireTimeouts[t]),delete e.expireTimeouts[t],delete e.renewPromise[t]}function u(e){var t=e.expireTimeouts;for(var r in t)t.hasOwnProperty(r)&&a(e,r)}function c(e,t,r,o){var s=n(t,o),u=1e3*Math.max(s-t.clock.now(),0);a(t,r);var c=setTimeout(function(){i(t,r,o)},u);t.expireTimeouts[r]=c}function l(e,t,r){try{var n=r.getStorage()}catch(e){return void s(t,e)}for(var o in n)if(n.hasOwnProperty(o)){var i=n[o];c(e,t,o,i)}}function f(e,t,r,n,o){var i=r.getStorage();if(!w.isObject(o)||!o.scopes||!o.expiresAt&&0!==o.expiresAt||!o.idToken&&!o.accessToken)throw new k("Token must be an Object with scopes, expiresAt, and an idToken or accessToken properties");i[n]=o,r.setStorage(i),c(e,t,n,o)}function p(e,t){return e.getStorage()[t]}function h(e,t,r,n){return new Promise(function(i,s){if(t.options.autoRenew&&A.isLoginRedirect(e))return s(new k("The app should not attempt to call authorize API on callback. Authorize flow is already in process. Use parseFromUrl() to receive tokens."));var a=p(r,n);return i(a&&o(t,a)?t.options.autoRenew?g(e,t,r,n):d(t,r,n):a)})}function d(e,t,r){a(e,r);var n=t.getStorage();delete n[r],t.setStorage(n)}function g(e,t,r,n){var o=t.renewPromise[n];if(o)return o;try{var i=p(r,n);if(!i)throw new k("The tokenManager has no token for the key: "+n)}catch(e){return Promise.reject(e)}return a(t,n),t.renewPromise[n]=e.token.renew(i).then(function(o){var i=p(r,n);if(i)return f(e,t,r,n,o),t.emitter.emit("renewed",n,o,i),o}).catch(function(e){throw"OAuthError"!==e.name&&"AuthSdkError"!==e.name||(d(t,r,n),e.tokenKey=n,e.accessToken=!!i.accessToken,s(t,e)),e}).finally(function(){delete t.renewPromise[n]}),t.renewPromise[n]}function m(e,t){u(e),t.clearStorage()}function y(e,t){t=w.extend({},_,w.removeNils(t)),"localStorage"!==t.storage||T.browserHasLocalStorage()||(w.warn("This browser doesn't support localStorage. Switching to sessionStorage."),t.storage="sessionStorage"),"sessionStorage"!==t.storage||T.browserHasSessionStorage()||(w.warn("This browser doesn't support sessionStorage. Switching to cookie-based storage."),t.storage="cookie");var r;if("object"===v(t.storage))r=t.storage;else switch(t.storage){case"localStorage":r=localStorage;break;case"sessionStorage":r=sessionStorage;break;case"cookie":r=function(e){var t=T.getCookieStorage(e);return{getItem:function(e){var r=t.getItem(),n={};return Object.keys(r).forEach(function(t){0===t.indexOf(e)&&(n[t.replace("".concat(e,"_"),"")]=JSON.parse(r[t]))}),JSON.stringify(n)},setItem:function(e,r){var n=JSON.parse(this.getItem(e));r=JSON.parse(r),Object.keys(r).forEach(function(o){var i=e+"_"+o,s=JSON.stringify(r[o]);t.setItem(i,s),delete n[o]}),Object.keys(n).forEach(function(t){T.storage.delete(e+"_"+t)})}}}(e.options.cookies);break;case"memory":r=T.getInMemoryStorage();break;default:throw new k("Unrecognized storage option")}var n=t.storageKey||b.TOKEN_STORAGE_NAME,o=S(r,n),i=E.create(e,t),s={clock:i,options:t,emitter:e.emitter,expireTimeouts:{},renewPromise:{}};this.add=w.bind(f,this,e,s,o),this.get=w.bind(h,this,e,s,o),this.remove=w.bind(d,this,s,o),this.clear=w.bind(m,this,s,o),this.renew=w.bind(g,this,e,s,o),this.on=w.bind(s.emitter.on,s.emitter),this.off=w.bind(s.emitter.off,s.emitter),l(e,s,o)}var v=r(6),w=r(0),k=r(1),T=r(4),b=r(2),S=r(7),E=r(27),A=r(5),_={autoRenew:!0,storage:"localStorage",expireEarlySeconds:30};e.exports=y},function(e,t,r){function n(e){this.localOffset=parseInt(e||0)}r(0).extend(n.prototype,{now:function(){return(Date.now()+this.localOffset)/1e3}}),n.create=function(){return new n(0)},e.exports=n},function(e,t,r){function n(){this.queue=[],this.running=!1}var o=r(0);o.extend(n.prototype,{push:function(){var e=this,t=Array.prototype.slice.call(arguments),r=t[0],n=t[1];return t=t.slice(2),new Promise(function(o,i){e.queue.push({method:r,thisObject:n,args:t,resolve:o,reject:i}),e.run()})},run:function(){var e=this;if(!this.running&&0!==this.queue.length){this.running=!0;var t=this.queue.shift(),r=t.method.apply(t.thisObject,t.args);o.isPromise(r)?r.then(t.resolve,t.reject).finally(function(){e.running=!1,e.run()}):(t.resolve(r),this.running=!1,this.run())}}}),e.exports=n}])});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-params: 0 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(717), __webpack_require__(767), __webpack_require__(345), __webpack_require__(777), __webpack_require__(783), __webpack_require__(784), __webpack_require__(795), __webpack_require__(799), __webpack_require__(800), __webpack_require__(801), __webpack_require__(802), __webpack_require__(810), __webpack_require__(811), __webpack_require__(812), __webpack_require__(813), __webpack_require__(814), __webpack_require__(816), __webpack_require__(817), __webpack_require__(818), __webpack_require__(819), __webpack_require__(820), __webpack_require__(821), __webpack_require__(823), __webpack_require__(824), __webpack_require__(358), __webpack_require__(825), __webpack_require__(826), __webpack_require__(827), __webpack_require__(828), __webpack_require__(829), __webpack_require__(830), __webpack_require__(832), __webpack_require__(834), __webpack_require__(835), __webpack_require__(836), __webpack_require__(837), __webpack_require__(838), __webpack_require__(839), __webpack_require__(840), __webpack_require__(841), __webpack_require__(842), __webpack_require__(843), __webpack_require__(844), __webpack_require__(845), __webpack_require__(846), __webpack_require__(847), __webpack_require__(848), __webpack_require__(852), __webpack_require__(853), __webpack_require__(856), __webpack_require__(859), __webpack_require__(320), __webpack_require__(863), __webpack_require__(866), __webpack_require__(867)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (BaseLoginRouter, IDPDiscoveryController, PrimaryAuthController, VerifyDuoController, VerifyPIVController, MfaVerifyController, VerifyWindowsHelloController, VerifyU2FController, VerifyWebauthnController, VerifyCustomFactorController, EnrollChoicesController, EnrollDuoController, EnrollQuestionController, EnrollPasswordController, EnrollWindowsHelloController, EnrollCallAndSmsController, EnrollEmailController, EnrollActivateEmailController, EnrollOnPremController, EnrollSymantecVipController, EnrollYubikeyController, EnrollTotpController, EnrollU2FController, EnrollWebauthnController, EnrollCustomFactorController, EnrollActivateCustomFactorController, EnrollHotpController, BarcodeTotpController, BarcodePushController, ActivateTotpController, ManualSetupTotpController, ManualSetupPushController, EnrollmentLinkSentController, EnterPasscodePushFlowController, PasswordExpiredController, CustomPasswordExpiredController, ForgotPasswordController, RecoveryChallengeController, PwdResetEmailSentController, RecoveryQuestionController, PasswordResetController, RecoveryLoadingController, UnlockAccountController, AccountUnlockedController, UnlockEmailSentController, RefreshAuthStateController, RegistrationController, RegistrationCompleteController, ConsentRequiredController, AdminConsentRequiredController, EnrollUserController, SecurityBeacon, FactorBeacon, PIVBeacon, PollController) {
  return BaseLoginRouter.extend({
    routes: {
      '': 'defaultAuth',
      'signin': 'primaryAuth',
      'signin/verify/duo/web': 'verifyDuo',
      'signin/verify/piv': 'verifyPIV',
      'signin/poll': 'poll',
      'signin/verify/fido/webauthn': 'verifyWebauthn',
      'signin/verify/webauthn': 'verifyWebauthn',
      'signin/verify/fido/u2f': 'verifyU2F',
      'signin/verify/u2f': 'verifyU2F',
      'signin/verify/generic_saml/assertion:saml2': 'verifySAMLFactor',
      'signin/verify/generic_oidc/assertion:oidc': 'verifyOIDCFactor',
      'signin/verify/custom/claims_provider': 'verifyClaimsFactor',
      'signin/verify/:factorType': 'verifyNoProvider',
      'signin/verify/:provider/:factorType(/:factorIndex)': 'verify',
      'signin/enroll': 'enrollChoices',
      'signin/enroll/duo/web': 'enrollDuo',
      'signin/enroll/okta/question': 'enrollQuestion',
      'signin/enroll/okta/password': 'enrollPassword',
      'signin/enroll/okta/sms': 'enrollSms',
      'signin/enroll/okta/call': 'enrollCall',
      'signin/enroll/okta/email': 'enrollEmail',
      'signin/enroll-activate/okta/sms': 'enrollSms',
      'signin/enroll-activate/okta/call': 'enrollCall',
      'signin/enroll/rsa/token': 'enrollRsa',
      'signin/enroll/del_oath/token': 'enrollOnPrem',
      'signin/enroll/symantec/token': 'enrollSymantecVip',
      'signin/enroll/yubico/token:hardware': 'enrollYubikey',
      'signin/enroll/fido/webauthn': 'enrollWebauthn',
      'signin/enroll/fido/u2f': 'enrollU2F',
      'signin/enroll/generic_saml/assertion:saml2': 'enrollSAMLFactor',
      'signin/enroll/generic_oidc/assertion:oidc': 'enrollOIDCFactor',
      'signin/enroll/custom/claims_provider': 'enrollClaimsFactor',
      'signin/enroll/custom/token:hotp': 'enrollHotpFactor',
      'signin/enroll/:provider/:factorType': 'enrollTotpFactor',
      'signin/enroll-activate/okta/email': 'enrollActivateEmail',
      'signin/enroll-activate/okta/push': 'scanBarcodePushFactor',
      'signin/enroll-activate/okta/push/manual': 'manualSetupPushFactor',
      'signin/enroll-activate/okta/push/sent': 'activationLinkSent',
      'signin/enroll-activate/okta/token:software:totp/passcode': 'enterPasscodeInPushEnrollmentFlow',
      'signin/enroll-activate/custom/claims_provider': 'enrollActivateClaimsFactor',
      'signin/enroll-activate/:provider/:factorType': 'scanBarcodeTotpFactor',
      'signin/enroll-activate/:provider/:factorType/activate': 'activateTotpFactor',
      'signin/enroll-activate/:provider/:factorType/manual': 'manualSetupTotpFactor',
      'signin/password-expired': 'passwordExpired',
      'signin/custom-password-expired': 'customPasswordExpired',
      'signin/forgot-password': 'forgotPassword',
      'signin/recovery-challenge': 'recoveryChallenge',
      'signin/recovery-emailed': 'recoveryEmailSent',
      'signin/recovery-question': 'recoveryQuestion',
      'signin/password-reset': 'passwordReset',
      'signin/reset-password/:token': 'recoveryLoading',
      'signin/user-unlock/:token': 'recoveryLoading',
      'signin/recovery/:token': 'recoveryLoading',
      'signin/unlock-emailed': 'unlockEmailSent',
      'signin/unlock': 'unlockAccount',
      'signin/account-unlocked': 'accountUnlocked',
      'signin/refresh-auth-state(/:token)': 'refreshAuthState',
      'signin/register': 'register',
      'signin/register-complete': 'registerComplete',
      'signin/consent': 'consentRequired',
      'signin/admin-consent': 'adminConsentRequired',
      'signin/enroll-user': 'enrollUser',
      '*wildcard': 'defaultAuth'
    },
    // Route handlers that do not require a stateToken. If the page is refreshed,
    // these functions will not require a status call to refresh the stateToken.
    stateLessRouteHandlers: ['defaultAuth', 'idpDiscovery', 'primaryAuth', 'forgotPassword', 'recoveryLoading', 'unlockAccount', 'refreshAuthState', 'register', 'registerComplete', 'verifyPIV'],
    defaultAuth: function defaultAuth() {
      if (this.settings.get('features.idpDiscovery')) {
        this.idpDiscovery();
      } else {
        this.primaryAuth();
      }
    },
    idpDiscovery: function idpDiscovery() {
      this.render(IDPDiscoveryController, {
        Beacon: SecurityBeacon
      });
    },
    primaryAuth: function primaryAuth() {
      this.render(PrimaryAuthController, {
        Beacon: SecurityBeacon
      });
    },
    verifyDuo: function verifyDuo() {
      this.render(VerifyDuoController, {
        provider: 'DUO',
        factorType: 'web',
        Beacon: FactorBeacon
      });
    },
    verifyPIV: function verifyPIV() {
      this.render(VerifyPIVController, {
        Beacon: PIVBeacon
      });
    },
    poll: function poll() {
      this.render(PollController);
    },
    verifyWebauthn: function verifyWebauthn() {
      if (this.settings.get('features.webauthn')) {
        this.render(VerifyWebauthnController, {
          provider: 'FIDO',
          factorType: 'webauthn',
          Beacon: FactorBeacon
        });
      } else {
        this.render(VerifyWindowsHelloController, {
          provider: 'FIDO',
          factorType: 'webauthn',
          Beacon: FactorBeacon
        });
      }
    },
    verifyU2F: function verifyU2F() {
      this.render(VerifyU2FController, {
        provider: 'FIDO',
        factorType: 'u2f',
        Beacon: FactorBeacon
      });
    },
    verifySAMLFactor: function verifySAMLFactor() {
      this.render(VerifyCustomFactorController, {
        provider: 'GENERIC_SAML',
        factorType: 'assertion:saml2',
        Beacon: FactorBeacon
      });
    },
    verifyOIDCFactor: function verifyOIDCFactor() {
      this.render(VerifyCustomFactorController, {
        provider: 'GENERIC_OIDC',
        factorType: 'assertion:oidc',
        Beacon: FactorBeacon
      });
    },
    verifyClaimsFactor: function verifyClaimsFactor() {
      this.render(VerifyCustomFactorController, {
        provider: 'CUSTOM',
        factorType: 'claims_provider',
        Beacon: FactorBeacon
      });
    },
    verify: function verify(provider, factorType, factorIndex) {
      this.render(MfaVerifyController, {
        provider: provider.toUpperCase(),
        factorType: factorType,
        factorIndex: factorIndex,
        Beacon: FactorBeacon
      });
    },
    verifyNoProvider: function verifyNoProvider(factorType) {
      this.render(MfaVerifyController, {
        factorType: factorType,
        Beacon: FactorBeacon
      });
    },
    enrollChoices: function enrollChoices() {
      this.render(EnrollChoicesController, {
        Beacon: SecurityBeacon
      });
    },
    enrollDuo: function enrollDuo() {
      this.render(EnrollDuoController, {
        provider: 'DUO',
        factorType: 'web',
        Beacon: FactorBeacon
      });
    },
    enrollQuestion: function enrollQuestion() {
      this.render(EnrollQuestionController, {
        provider: 'OKTA',
        factorType: 'question',
        Beacon: FactorBeacon
      });
    },
    enrollPassword: function enrollPassword() {
      this.render(EnrollPasswordController, {
        provider: 'OKTA',
        factorType: 'password',
        Beacon: FactorBeacon
      });
    },
    enrollSms: function enrollSms() {
      this.render(EnrollCallAndSmsController, {
        provider: 'OKTA',
        factorType: 'sms',
        Beacon: FactorBeacon
      });
    },
    enrollCall: function enrollCall() {
      this.render(EnrollCallAndSmsController, {
        provider: 'OKTA',
        factorType: 'call',
        Beacon: FactorBeacon
      });
    },
    enrollEmail: function enrollEmail() {
      this.render(EnrollEmailController, {
        provider: 'OKTA',
        factorType: 'email',
        Beacon: FactorBeacon
      });
    },
    enrollActivateEmail: function enrollActivateEmail() {
      this.render(EnrollActivateEmailController, {
        provider: 'OKTA',
        factorType: 'email',
        Beacon: FactorBeacon
      });
    },
    enrollRsa: function enrollRsa() {
      this.render(EnrollOnPremController, {
        provider: 'RSA',
        factorType: 'token',
        Beacon: FactorBeacon
      });
    },
    enrollOnPrem: function enrollOnPrem() {
      this.render(EnrollOnPremController, {
        provider: 'DEL_OATH',
        factorType: 'token',
        Beacon: FactorBeacon
      });
    },
    enrollSymantecVip: function enrollSymantecVip() {
      this.render(EnrollSymantecVipController, {
        provider: 'SYMANTEC',
        factorType: 'token',
        Beacon: FactorBeacon
      });
    },
    enrollYubikey: function enrollYubikey() {
      this.render(EnrollYubikeyController, {
        provider: 'YUBICO',
        factorType: 'token:hardware',
        Beacon: FactorBeacon
      });
    },
    enrollSAMLFactor: function enrollSAMLFactor() {
      this.render(EnrollCustomFactorController, {
        provider: 'GENERIC_SAML',
        factorType: 'assertion:saml2',
        Beacon: FactorBeacon
      });
    },
    enrollOIDCFactor: function enrollOIDCFactor() {
      this.render(EnrollCustomFactorController, {
        provider: 'GENERIC_OIDC',
        factorType: 'assertion:oidc',
        Beacon: FactorBeacon
      });
    },
    enrollClaimsFactor: function enrollClaimsFactor() {
      this.render(EnrollCustomFactorController, {
        provider: 'CUSTOM',
        factorType: 'claims_provider',
        Beacon: FactorBeacon
      });
    },
    enrollActivateClaimsFactor: function enrollActivateClaimsFactor() {
      this.render(EnrollActivateCustomFactorController, {
        provider: 'CUSTOM',
        factorType: 'claims_provider',
        Beacon: FactorBeacon
      });
    },
    enrollTotpFactor: function enrollTotpFactor(provider, factorType) {
      this.render(EnrollTotpController, {
        provider: provider.toUpperCase(),
        factorType: factorType,
        Beacon: FactorBeacon
      });
    },
    enrollHotpFactor: function enrollHotpFactor() {
      this.render(EnrollHotpController, {
        provider: 'CUSTOM',
        factorType: 'token:hotp',
        Beacon: FactorBeacon
      });
    },
    enrollWebauthn: function enrollWebauthn() {
      if (this.settings.get('features.webauthn')) {
        this.render(EnrollWebauthnController, {
          provider: 'FIDO',
          factorType: 'webauthn',
          Beacon: FactorBeacon
        });
      } else {
        this.render(EnrollWindowsHelloController, {
          provider: 'FIDO',
          factorType: 'webauthn',
          Beacon: FactorBeacon
        });
      }
    },
    enrollU2F: function enrollU2F() {
      this.render(EnrollU2FController, {
        provider: 'FIDO',
        factorType: 'u2f',
        Beacon: FactorBeacon
      });
    },
    scanBarcodeTotpFactor: function scanBarcodeTotpFactor(provider, factorType) {
      this.render(BarcodeTotpController, {
        provider: provider.toUpperCase(),
        factorType: factorType,
        Beacon: FactorBeacon
      });
    },
    scanBarcodePushFactor: function scanBarcodePushFactor() {
      this.render(BarcodePushController, {
        provider: 'OKTA',
        factorType: 'push',
        Beacon: FactorBeacon
      });
    },
    activateTotpFactor: function activateTotpFactor(provider, factorType) {
      this.render(ActivateTotpController, {
        provider: provider.toUpperCase(),
        factorType: factorType,
        Beacon: FactorBeacon
      });
    },
    manualSetupTotpFactor: function manualSetupTotpFactor(provider, factorType) {
      this.render(ManualSetupTotpController, {
        provider: provider.toUpperCase(),
        factorType: factorType,
        Beacon: FactorBeacon
      });
    },
    manualSetupPushFactor: function manualSetupPushFactor() {
      this.render(ManualSetupPushController, {
        provider: 'OKTA',
        factorType: 'push',
        Beacon: FactorBeacon
      });
    },
    activationLinkSent: function activationLinkSent() {
      this.render(EnrollmentLinkSentController, {
        provider: 'OKTA',
        factorType: 'push',
        Beacon: FactorBeacon
      });
    },
    enterPasscodeInPushEnrollmentFlow: function enterPasscodeInPushEnrollmentFlow() {
      this.render(EnterPasscodePushFlowController, {
        provider: 'OKTA',
        factorType: 'token:software:totp',
        Beacon: FactorBeacon
      });
    },
    passwordExpired: function passwordExpired() {
      this.render(PasswordExpiredController, {
        Beacon: SecurityBeacon
      });
    },
    customPasswordExpired: function customPasswordExpired() {
      this.render(CustomPasswordExpiredController, {
        Beacon: SecurityBeacon
      });
    },
    forgotPassword: function forgotPassword() {
      this.render(ForgotPasswordController);
    },
    recoveryChallenge: function recoveryChallenge() {
      this.render(RecoveryChallengeController, {
        Beacon: SecurityBeacon
      });
    },
    recoveryEmailSent: function recoveryEmailSent() {
      this.render(PwdResetEmailSentController, {
        Beacon: SecurityBeacon
      });
    },
    unlockEmailSent: function unlockEmailSent() {
      this.render(UnlockEmailSentController, {
        Beacon: SecurityBeacon
      });
    },
    recoveryQuestion: function recoveryQuestion() {
      this.render(RecoveryQuestionController, {
        Beacon: SecurityBeacon
      });
    },
    passwordReset: function passwordReset() {
      this.render(PasswordResetController, {
        Beacon: SecurityBeacon
      });
    },
    recoveryLoading: function recoveryLoading(token) {
      this.render(RecoveryLoadingController, {
        token: token,
        Beacon: SecurityBeacon
      });
    },
    unlockAccount: function unlockAccount() {
      this.render(UnlockAccountController);
    },
    accountUnlocked: function accountUnlocked() {
      this.render(AccountUnlockedController, {
        Beacon: SecurityBeacon
      });
    },
    refreshAuthState: function refreshAuthState(token) {
      this.render(RefreshAuthStateController, {
        token: token,
        Beacon: SecurityBeacon
      });
    },
    register: function register() {
      this.render(RegistrationController);
    },
    registerComplete: function registerComplete() {
      this.render(RegistrationCompleteController);
    },
    consentRequired: function consentRequired() {
      this.render(ConsentRequiredController);
    },
    adminConsentRequired: function adminConsentRequired() {
      this.render(AdminConsentRequiredController);
    },
    enrollUser: function enrollUser() {
      this.render(EnrollUserController);
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(82));

var _find = _interopRequireDefault(__webpack_require__(18));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-params: [2, 16], max-statements: [2, 18] */
// BaseLoginRouter contains the more complicated router logic - rendering/
// transition, etc. Most router changes should happen in LoginRouter (which is
// responsible for adding new routes)
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(75), __webpack_require__(317), __webpack_require__(319), __webpack_require__(320), __webpack_require__(332), __webpack_require__(738), __webpack_require__(344), __webpack_require__(48), __webpack_require__(177), __webpack_require__(56), __webpack_require__(24), __webpack_require__(10), __webpack_require__(125), __webpack_require__(64)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, BrowserFeatures, Settings, Header, SecurityBeacon, AuthContainer, AppState, ColorsUtil, RouterUtil, Animations, Errors, Util, Enums, Bundles, Logger) {
  var _ = Okta._,
      $ = Okta.$,
      Backbone = Okta.Backbone;

  function isStateLessRouteHandler(router, fn) {
    return (0, _find.default)(_).call(_, router.stateLessRouteHandlers, function (routeName) {
      return fn === router[routeName];
    });
  }

  function beaconIsAvailable(Beacon, settings) {
    if (!Beacon) {
      return false;
    }

    if (Beacon === SecurityBeacon) {
      return settings.get('features.securityImage');
    }

    return true;
  }
  /**
   * TODO: deprecated by `util/LanguageUtil.loadLanguage`
   */


  function loadLanguage(appState, i18n, assetBaseUrl, assetRewrite) {
    var timeout = (0, _setTimeout2.default)(function () {
      // Trigger a spinner if we're waiting on a request for a new language.
      appState.trigger('loading', true);
    }, 200);
    return Bundles.loadLanguage(appState.get('languageCode'), i18n, {
      baseUrl: assetBaseUrl,
      rewrite: assetRewrite
    }).then(function () {
      clearTimeout(timeout);
      appState.trigger('loading', false);
    });
  }

  return Okta.Router.extend({
    Events: Backbone.Events,
    initialize: function initialize(options) {
      // Create a default success and/or error handler if
      // one is not provided.
      if (!options.globalSuccessFn) {
        options.globalSuccessFn = function () {};
      }

      if (!options.globalErrorFn) {
        options.globalErrorFn = function (err) {
          Logger.error(err);
        };
      }

      this.settings = new Settings(_.omit(options, 'el', 'authClient'), {
        parse: true
      });
      this.settings.setAuthClient(options.authClient);

      if (!options.el) {
        this.settings.callGlobalError(new Errors.ConfigError(Okta.loc('error.required.el')));
      }

      $('body > div').on('click', function () {// OKTA-69769 Tooltip wont close on iPhone/iPad
        // Registering a click handler on the first div
        // allows a tap that falls outside the tooltip
        // to be registered as a tap by iOS
        // and then the open tooltip will lose focus and close.
      });
      this.appState = new AppState({
        baseUrl: this.settings.get('baseUrl'),
        settings: this.settings
      }, {
        parse: true
      });
      var wrapper = new AuthContainer({
        appState: this.appState
      });
      Okta.$(options.el).append(wrapper.render().$el);
      this.el = "#".concat(Enums.WIDGET_CONTAINER_ID);
      this.header = new Header({
        el: this.el,
        appState: this.appState,
        settings: this.settings
      });
      this.listenTo(this.appState, 'change:transactionError', function (appState, err) {
        RouterUtil.routeAfterAuthStatusChangeError(this, err);
      });
      this.listenTo(this.appState, 'change:transaction', function (appState, trans) {
        RouterUtil.routeAfterAuthStatusChange(this, trans.data);
      });
      this.listenTo(this.appState, 'navigate', function (url) {
        this.navigate(url, {
          trigger: true
        });
      });
    },
    execute: function execute(cb, args) {
      // Recovery flow with a token passed through widget settings
      var recoveryToken = this.settings.get('recoveryToken');

      if (recoveryToken) {
        this.settings.unset('recoveryToken');
        this.navigate(RouterUtil.createRecoveryUrl(recoveryToken), {
          trigger: true
        });
        return;
      } // Refresh flow with a stateToken passed through widget settings


      var stateToken = this.settings.get('stateToken');

      if (stateToken) {
        this.settings.unset('stateToken');
        this.navigate(RouterUtil.createRefreshUrl(stateToken), {
          trigger: true
        });
        return;
      } // Normal flow - we've either navigated to a stateless page, or are
      // in the middle of an auth flow


      var trans = this.appState.get('transaction');

      if (trans && trans.data || isStateLessRouteHandler(this, cb)) {
        cb.apply(this, args);
        return;
      } // StateToken cookie exists on page load, and we are on a stateful url


      if (this.settings.getAuthClient().tx.exists()) {
        this.navigate(RouterUtil.createRefreshUrl(), {
          trigger: true
        });
        return;
      } // We've hit a page that requires state, but have no stateToken - redirect
      // back to primary auth


      this.navigate('', {
        trigger: true
      });
    },
    // Overriding the default navigate method to allow the widget consumer
    // to "turn off" routing - if features.router is false, the browser
    // location bar will not update when the router navigates
    navigate: function navigate(fragment, options) {
      if (this.settings.get('features.router')) {
        return Okta.Router.prototype.navigate.apply(this, arguments);
      }

      if (options && options.trigger) {
        return Backbone.history.loadUrl(fragment);
      }
    },
    render: function render(Controller, options) {
      options || (options = {});
      var Beacon = options.Beacon;

      var controllerOptions = _.extend({
        settings: this.settings,
        appState: this.appState
      }, _.omit(options, 'Beacon')); // Since we have a wrapper view, render our wrapper and use its content
      // element as our new el.
      // Note: Render it here because we know dom is ready at this point


      if (!this.header.rendered()) {
        this.el = this.header.render().getContentEl();
      } // If we need to load a language (or apply custom i18n overrides), do
      // this now and re-run render after it's finished.


      if (!Bundles.isLoaded(this.appState.get('languageCode'))) {
        return loadLanguage(this.appState, this.settings.get('i18n'), this.settings.get('assets.baseUrl'), this.settings.get('assets.rewrite')).then((0, _bind.default)(_).call(_, this.render, this, Controller, options));
      } // Load the custom colors only on the first render


      if (this.settings.get('colors.brand') && !ColorsUtil.isLoaded()) {
        var colors = {
          brand: this.settings.get('colors.brand')
        };
        ColorsUtil.addStyle(colors);
      }

      var oldController = this.controller;
      this.controller = new Controller(controllerOptions); // Bubble up all controller events

      this.listenTo(this.controller, 'all', this.trigger); // First run fetchInitialData, in case the next controller needs data
      // before it's initial render. This will leave the current page in a
      // loading state.

      return this.controller.fetchInitialData().then((0, _bind.default)(_).call(_, function () {
        // Beacon transition occurs in parallel to page swap
        if (!beaconIsAvailable(Beacon, this.settings)) {
          Beacon = null;
        }

        this.header.setBeacon(Beacon, controllerOptions);
        this.controller.render();

        if (!oldController) {
          this.el.append(this.controller.el);
          this.controller.postRenderAnimation();
          return;
        }

        return Animations.swapPages({
          $parent: this.el,
          $oldRoot: oldController.$el,
          $newRoot: this.controller.$el,
          dir: oldController.state.get('navigateDir'),
          ctx: this,
          success: function success() {
            var flashError = this.appState.get('flashError'),
                model = this.controller.model;
            oldController.remove();
            oldController.$el.remove();
            this.controller.postRenderAnimation();

            if (flashError) {
              model.trigger('error', model, {
                responseJSON: {
                  errorSummary: Okta.loc('error.expired.session')
                }
              });
              this.appState.unset('flashError');
              Util.triggerAfterError(this.controller, flashError);
            }
          }
        });
      }, this)).catch(function () {
        // OKTA-69665 - if an error occurs in fetchInitialData, we're left in
        // a state with two active controllers. Therefore, we clean up the
        // old one. Note: This explicitly handles the invalid token case -
        // if we get some other type of error which doesn't force a redirect,
        // we will probably be left in a bad state. I.e. old controller is
        // dropped and new controller is not rendered.
        if (oldController) {
          oldController.remove();
          oldController.$el.remove();
        }
      });
    },
    start: function start() {
      var pushState = false; // Support for browser's back button.

      if (window.addEventListener && this.settings.get('features.router')) {
        window.addEventListener('popstate', (0, _bind.default)(_).call(_, function (e) {
          if (this.controller.back) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.controller.back();
          }
        }, this));
        pushState = BrowserFeatures.supportsPushState();
      }

      Okta.Router.prototype.start.call(this, {
        pushState: pushState
      });
    },
    hide: function hide() {
      this.header.$el.hide();
    },
    show: function show() {
      this.header.$el.show();
    },
    remove: function remove() {
      this.controller.remove();
      this.header.$el.remove();
      Bundles.remove();
      Backbone.history.stop();
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(719);

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(301);

module.exports = parent;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(304);
__webpack_require__(721);
__webpack_require__(722);
__webpack_require__(723);
__webpack_require__(724);
// TODO: Remove from `core-js@4`
__webpack_require__(725);

module.exports = parent;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('asyncDispose');


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('dispose');


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(35);

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('patternMatch');


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: remove from `core-js@4`
var defineWellKnownSymbol = __webpack_require__(35);

defineWellKnownSymbol('replaceAll');


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        return "<div class=\"beacon-blank\"></div><div class=\"bg-helper auth-beacon auth-beacon-security\" data-se=\"loading-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border\"></div></div>";
      },
      "useData": true
    }),
    equals: function equals(Beacon) {
      return Beacon && this instanceof Beacon;
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(728);

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(322);
__webpack_require__(734);
// TODO: Remove from `core-js@4`
__webpack_require__(735);
__webpack_require__(736);
__webpack_require__(737);

module.exports = parent;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var IS_PURE = __webpack_require__(63);
var global = __webpack_require__(22);
var getBuiltIn = __webpack_require__(72);
var NativePromise = __webpack_require__(323);
var redefine = __webpack_require__(124);
var redefineAll = __webpack_require__(178);
var setToStringTag = __webpack_require__(89);
var setSpecies = __webpack_require__(730);
var isObject = __webpack_require__(31);
var aFunction = __webpack_require__(60);
var anInstance = __webpack_require__(179);
var classof = __webpack_require__(106);
var inspectSource = __webpack_require__(286);
var iterate = __webpack_require__(91);
var checkCorrectnessOfIteration = __webpack_require__(326);
var speciesConstructor = __webpack_require__(327);
var task = __webpack_require__(328).set;
var microtask = __webpack_require__(731);
var promiseResolve = __webpack_require__(330);
var hostReportErrors = __webpack_require__(732);
var newPromiseCapabilityModule = __webpack_require__(140);
var perform = __webpack_require__(181);
var InternalStateModule = __webpack_require__(80);
var isForced = __webpack_require__(279);
var wellKnownSymbol = __webpack_require__(23);
var V8_VERSION = __webpack_require__(222);

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof(process) == 'process';
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global, function () {
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(72);
var definePropertyModule = __webpack_require__(62);
var wellKnownSymbol = __webpack_require__(23);
var DESCRIPTORS = __webpack_require__(39);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var getOwnPropertyDescriptor = __webpack_require__(104).f;
var classof = __webpack_require__(106);
var macrotask = __webpack_require__(328).set;
var IS_IOS = __webpack_require__(329);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var IS_NODE = classof(process) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !IS_IOS) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var IS_PURE = __webpack_require__(63);
var NativePromise = __webpack_require__(323);
var fails = __webpack_require__(20);
var getBuiltIn = __webpack_require__(72);
var speciesConstructor = __webpack_require__(327);
var promiseResolve = __webpack_require__(330);
var redefine = __webpack_require__(124);

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// patch native Promise.prototype for native async functions
if (!IS_PURE && typeof NativePromise == 'function' && !NativePromise.prototype['finally']) {
  redefine(NativePromise.prototype, 'finally', getBuiltIn('Promise').prototype['finally']);
}


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(39);
var getPrototypeOf = __webpack_require__(168);
var setPrototypeOf = __webpack_require__(294);
var create = __webpack_require__(135);
var defineProperty = __webpack_require__(62);
var createPropertyDescriptor = __webpack_require__(105);
var iterate = __webpack_require__(91);
var createNonEnumerableProperty = __webpack_require__(61);
var InternalStateModule = __webpack_require__(80);

var setInternalState = InternalStateModule.set;
var getInternalAggregateErrorState = InternalStateModule.getterFor('AggregateError');

var $AggregateError = function AggregateError(errors, message) {
  var that = this;
  if (!(that instanceof $AggregateError)) return new $AggregateError(errors, message);
  if (setPrototypeOf) {
    that = setPrototypeOf(new Error(message), getPrototypeOf(that));
  }
  var errorsArray = [];
  iterate(errors, errorsArray.push, errorsArray);
  if (DESCRIPTORS) setInternalState(that, { errors: errorsArray, type: 'AggregateError' });
  else that.errors = errorsArray;
  if (message !== undefined) createNonEnumerableProperty(that, 'message', String(message));
  return that;
};

$AggregateError.prototype = create(Error.prototype, {
  constructor: createPropertyDescriptor(5, $AggregateError),
  message: createPropertyDescriptor(5, ''),
  name: createPropertyDescriptor(5, 'AggregateError')
});

if (DESCRIPTORS) defineProperty.f($AggregateError.prototype, 'errors', {
  get: function () {
    return getInternalAggregateErrorState(this).errors;
  },
  configurable: true
});

$({ global: true }, {
  AggregateError: $AggregateError
});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__(331);


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var newPromiseCapabilityModule = __webpack_require__(140);
var perform = __webpack_require__(181);

// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$({ target: 'Promise', stat: true }, {
  'try': function (callbackfn) {
    var promiseCapability = newPromiseCapabilityModule.f(this);
    var result = perform(callbackfn);
    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
    return promiseCapability.promise;
  }
});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var aFunction = __webpack_require__(60);
var getBuiltIn = __webpack_require__(72);
var newPromiseCapabilityModule = __webpack_require__(140);
var perform = __webpack_require__(181);
var iterate = __webpack_require__(91);

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://github.com/tc39/proposal-promise-any
$({ target: 'Promise', stat: true }, {
  any: function any(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        errors.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (e) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = e;
          --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _startsWith = _interopRequireDefault(__webpack_require__(316));

var _map = _interopRequireDefault(__webpack_require__(41));

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(36), __webpack_require__(182), __webpack_require__(75), __webpack_require__(56)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Q, Factor, BrowserFeatures, Errors) {
  // Keep track of stateMachine with this special model. Some reasons to not
  // keep it generic:
  // 1. We know exactly what we're using appState for by requiring props
  // 2. Can have some derived functions to help us translate the lastAuthRes
  var _ = Okta._;
  var $ = Okta.$;
  var DEFAULT_APP_LOGO = '/img/logos/default.png';
  var USER_NOT_SEEN_ON_DEVICE = '/img/security/unknown.png';
  var UNDEFINED_USER = '/img/security/default.png';
  var NEW_USER = '/img/security/unknown-device.png';
  var NEW_USER_IMAGE_DESCRIPTION = '';
  var UNDEFINED_USER_IMAGE_DESCRIPTION = '';
  var UNKNOWN_IMAGE_DESCRIPTION = '';

  var securityImageUrlTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return alias4((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "baseUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 11
          }
        }
      }) : helper)) + "/login/getimage?username=" + alias4((helper = (helper = lookupProperty(helpers, "username") || (depth0 != null ? lookupProperty(depth0, "username") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "username",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 36
          },
          "end": {
            "line": 1,
            "column": 48
          }
        }
      }) : helper));
    },
    "useData": true
  });

  function getSecurityImage(baseUrl, username, deviceFingerprint) {
    // When the username is empty, we want to show the default image.
    if (_.isEmpty(username) || _.isUndefined(username)) {
      return Q({
        'securityImage': UNDEFINED_USER,
        'securityImageDescription': UNDEFINED_USER_IMAGE_DESCRIPTION
      });
    } // Reserved characters in the username must be escaped before the query can be safely executed


    username = encodeURIComponent(username);
    var url = securityImageUrlTpl({
      baseUrl: baseUrl,
      username: username
    });
    var data = {
      url: url,
      dataType: 'json'
    };

    if (deviceFingerprint) {
      data['headers'] = {
        'X-Device-Fingerprint': deviceFingerprint
      };
    }

    return Q($.ajax(data)).then(function (res) {
      if (res.pwdImg === USER_NOT_SEEN_ON_DEVICE) {
        // When we get an unknown.png security image from OKTA,
        // we want to show the unknown-device security image.
        // We are mapping the server's img url to a new one because
        // we still need to support the original login page.
        return {
          'securityImage': NEW_USER,
          'securityImageDescription': NEW_USER_IMAGE_DESCRIPTION
        };
      }

      return {
        'securityImage': res.pwdImg,
        'securityImageDescription': res.imageDescription || UNKNOWN_IMAGE_DESCRIPTION
      };
    });
  }

  function getMinutesString(factorLifetimeInMinutes) {
    if (factorLifetimeInMinutes > 60 && factorLifetimeInMinutes <= 1440) {
      var lifetimeInHours = factorLifetimeInMinutes / 60;
      return Okta.loc('hours', 'login', [lifetimeInHours]);
    } else if (factorLifetimeInMinutes > 1440) {
      var lifetimeInDays = factorLifetimeInMinutes / 1440;
      return Okta.loc('days', 'login', [lifetimeInDays]);
    } //Use minutes as the time unit by default


    if (factorLifetimeInMinutes === 1) {
      return Okta.loc('minutes.oneMinute', 'login');
    }

    return Okta.loc('minutes', 'login', [factorLifetimeInMinutes]);
  }

  function getGracePeriodRemainingDays(gracePeriodEndDate) {
    var endDate = new Date(gracePeriodEndDate).getTime();
    var remainingDays = Math.floor((endDate - new Date().getTime()) / (1000 * 3600 * 24));
    return remainingDays;
  }

  function combineFactorsObjects(factorTypes, factors) {
    var addedFactorTypes = [];
    var combinedFactors = [];

    _.each(factors, function (factor) {
      var factorType = factor.factorType;

      if (!_.contains(addedFactorTypes, factorType)) {
        var factorTypeObj = _.findWhere(factorTypes, {
          factorType: factorType
        });

        if (factorTypeObj) {
          addedFactorTypes.push(factorType);
          combinedFactors.push(factorTypeObj);
        } else {
          combinedFactors.push(factor);
        }
      }
    });

    return combinedFactors;
  }

  return Okta.Model.extend({
    initialize: function initialize() {
      // Handle this in initialize (as opposed to a derived property) because
      // the operation is asynchronous
      if (this.settings.get('features.securityImage')) {
        var self = this;
        this.listenTo(this, 'change:username', function (model, username) {
          getSecurityImage(this.get('baseUrl'), username, this.get('deviceFingerprint')).then(function (image) {
            model.set('securityImage', image.securityImage);
            model.set('securityImageDescription', image.securityImageDescription);
            model.unset('deviceFingerprint'); //Fingerprint can only be used once
          }).fail(function (jqXhr) {
            // Only notify the consumer on a CORS error
            if (BrowserFeatures.corsIsNotEnabled(jqXhr)) {
              self.settings.callGlobalError(new Errors.UnsupportedBrowserError(Okta.loc('error.enabled.cors')));
            } else {
              throw jqXhr;
            }
          }).done();
        });
      }
    },
    local: {
      baseUrl: 'string',
      lastAuthResponse: ['object', true, {}],
      transaction: 'object',
      transactionError: 'object',
      introspectSuccess: 'object',
      // only set during introspection
      introspectError: 'object',
      // only set during introspection
      username: 'string',
      factors: 'object',
      policy: 'object',
      securityImage: ['string', true, UNDEFINED_USER],
      securityImageDescription: ['string', true, UNDEFINED_USER_IMAGE_DESCRIPTION],
      userCountryCode: 'string',
      userPhoneNumber: 'string',
      factorActivationType: 'string',
      flashError: 'object',
      beaconType: 'string',
      deviceFingerprint: 'string',
      // valid only once
      typingPattern: 'string',
      // Note: languageCode is special in that it is shared between Settings
      // and AppState. Settings is the *configured* language, and is static.
      // AppState is the dynamic language state - it can be changed via a
      // language picker, etc.
      // Note: this is conceptial feasible but not yet being implemented.
      languageCode: ['string', true],
      disableUsername: ['boolean', false, false],
      trapMfaRequiredResponse: ['boolean', false, false],
      lastFailedChallengeFactorData: ['object', false]
    },
    setAuthResponse: function setAuthResponse(res) {
      var _this = this;

      // Because of MFA_CHALLENGE (i.e. DUO), we need to remember factors
      // across auth responses. Not doing this, for example, results in being
      // unable to switch away from the duo factor dropdown.
      if (res._embedded && res._embedded.policy) {
        this.set('policy', res._embedded.policy);
      }

      if (res._embedded && res._embedded.factors) {
        var factors = res._embedded.factors;

        if (res._embedded.factorTypes) {
          factors = combineFactorsObjects(res._embedded.factorTypes, factors);
        }

        var factorsObject = (0, _map.default)(_).call(_, factors, function (factor) {
          factor.settings = _this.settings;
          factor.appState = _this;
          return factor;
        });
        this.set('factors', new Factor.Collection(factorsObject, {
          parse: true
        }));
      }

      this.set('lastAuthResponse', res);
    },
    clearLastAuthResponse: function clearLastAuthResponse() {
      this.set('lastAuthResponse', {});
    },
    setLastFailedChallengeFactorData: function setLastFailedChallengeFactorData() {
      this.set('lastFailedChallengeFactorData', {
        factor: this.get('factor'),
        errorMessage: this.get('factorResultErrorMessage')
      });
    },
    clearLastFailedChallengeFactorData: function clearLastFailedChallengeFactorData() {
      this.unset('lastFailedChallengeFactorData');
    },
    derived: {
      'isSuccessResponse': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.status === 'SUCCESS';
        }
      },
      'isMfaRequired': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.status === 'MFA_REQUIRED' || res.status === 'FACTOR_REQUIRED';
        }
      },
      'isProfileRequired': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.status === 'PROFILE_REQUIRED';
        }
      },
      'isMfaEnroll': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.status === 'MFA_ENROLL' || res.status === 'FACTOR_ENROLL';
        }
      },
      'isMfaChallenge': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.status === 'MFA_CHALLENGE' || res.status === 'FACTOR_CHALLENGE';
        }
      },
      'isUnauthenticated': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.status === 'UNAUTHENTICATED';
        }
      },
      'isMfaRejected': {
        // MFA failures are usually error responses
        // except in the case of Okta Push, when a
        // user clicks 'deny' on his phone or OV app
        // version is below a required version no.
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.factorResult === 'REJECTED';
        }
      },
      'isMfaTimeout': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.factorResult === 'TIMEOUT';
        }
      },
      'isMfaEnrollActivate': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.status === 'MFA_ENROLL_ACTIVATE' || res.status === 'FACTOR_ENROLL_ACTIVATE';
        }
      },
      'isWaitingForActivation': {
        deps: ['isMfaEnrollActivate', 'lastAuthResponse'],
        fn: function fn(isMfaEnrollActivate, res) {
          return isMfaEnrollActivate && res.factorResult === 'WAITING';
        }
      },
      'isWaitingForNumberChallenge': {
        deps: ['lastAuthResponse', 'isMfaChallenge'],
        fn: function fn(res, isMfaChallenge) {
          if (isMfaChallenge && res && res.factorResult === 'WAITING' && res._embedded && res._embedded.factor && res._embedded.factor._embedded && res._embedded.factor._embedded.challenge) {
            return true;
          }

          return false;
        }
      },
      'hasMultipleFactorsAvailable': {
        deps: ['factors', 'isMfaRequired', 'isMfaChallenge', 'isUnauthenticated'],
        fn: function fn(factors, isMfaRequired, isMfaChallenge, isUnauthenticated) {
          if (!isMfaRequired && !isMfaChallenge && !isUnauthenticated) {
            return false;
          }

          return factors && factors.length > 1;
        }
      },
      'promptForFactorInUnauthenticated': {
        deps: ['lastAuthResponse', 'factors'],
        fn: function fn(res, factors) {
          if (res.status !== 'UNAUTHENTICATED') {
            return false;
          }

          return factors && factors.length > 0;
        }
      },
      'userId': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._embedded || !res._embedded.user) {
            return null;
          }

          return res._embedded.user.id;
        }
      },
      'isIdxStateToken': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          var _context;

          return res && _.isString(res.stateToken) && (0, _startsWith.default)(_context = res.stateToken).call(_context, '01');
        }
      },
      'isPwdExpiringSoon': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.status === 'PASSWORD_WARN';
        }
      },
      'passwordExpireDays': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._embedded || !res._embedded.policy || !res._embedded.policy.expiration) {
            return null;
          }

          return res._embedded.policy.expiration.passwordExpireDays;
        }
      },
      'isPwdManagedByOkta': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._links || !res._links.next || !res._links.next.title) {
            return true;
          }

          return false;
        }
      },
      'passwordExpiredWebsiteName': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._links || !res._links.next || !res._links.next.title) {
            return null;
          }

          return res._links.next.title;
        }
      },
      'passwordExpiredLinkUrl': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._links || !res._links.next || !res._links.next.title || !res._links.next.href) {
            return null;
          }

          return res._links.next.href;
        }
      },
      'recoveryType': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.recoveryType;
        }
      },
      'factorType': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.factorType;
        }
      },
      'factor': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._embedded || !res._embedded.factor) {
            return null;
          }

          return res._embedded.factor;
        }
      },
      'activatedFactorId': {
        deps: ['factor'],
        fn: function fn(factor) {
          return factor ? factor.id : null;
        }
      },
      'activatedFactorType': {
        deps: ['factor'],
        fn: function fn(factor) {
          return factor ? factor.factorType : null;
        }
      },
      'activatedFactorProvider': {
        deps: ['factor'],
        fn: function fn(factor) {
          return factor ? factor.provider : null;
        }
      },
      'qrcode': {
        deps: ['factor'],
        fn: function fn(factor) {
          try {
            return factor._embedded.activation._links.qrcode.href;
          } catch (err) {
            return null;
          }
        }
      },
      'activationSendLinks': {
        deps: ['factor'],
        fn: function fn(factor) {
          var sendLinks;

          try {
            sendLinks = factor._embedded.activation._links.send;
          } catch (err) {
            sendLinks = [];
          }

          return sendLinks;
        }
      },
      'textActivationLinkUrl': {
        deps: ['activationSendLinks'],
        fn: function fn(activationSendLinks) {
          var item = _.findWhere(activationSendLinks, {
            name: 'sms'
          });

          return item ? item.href : null;
        }
      },
      'emailActivationLinkUrl': {
        deps: ['activationSendLinks'],
        fn: function fn(activationSendLinks) {
          var item = _.findWhere(activationSendLinks, {
            name: 'email'
          });

          return item ? item.href : null;
        }
      },
      'sharedSecret': {
        deps: ['factor'],
        fn: function fn(factor) {
          try {
            return factor._embedded.activation.sharedSecret;
          } catch (err) {
            return null;
          }
        }
      },
      'duoEnrollActivation': {
        deps: ['factor'],
        fn: function fn(factor) {
          if (!factor || !factor._embedded || !factor._embedded.activation) {
            return null;
          }

          return factor._embedded.activation;
        }
      },
      'prevLink': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (res._links && res._links.prev) {
            return res._links.prev.href;
          }

          return null;
        }
      },
      'skipLink': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (res._links && res._links.skip) {
            return res._links.skip.href;
          }

          return null;
        }
      },
      'gracePeriodRemainingDays': {
        deps: ['policy'],
        fn: function fn(policy) {
          if (policy && policy.gracePeriod && policy.gracePeriod.endDate) {
            return getGracePeriodRemainingDays(policy.gracePeriod.endDate);
          }

          return null;
        }
      },
      'user': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._embedded || !res._embedded.user) {
            return null;
          }

          return res._embedded.user;
        }
      },
      'recoveryQuestion': {
        deps: ['user'],
        fn: function fn(user) {
          if (!user || !user.recovery_question) {
            return null;
          }

          return user.recovery_question.question;
        }
      },
      'userProfile': {
        deps: ['user'],
        fn: function fn(user) {
          if (!user || !user.profile) {
            return null;
          }

          return user.profile;
        }
      },
      'userConsentName': {
        deps: ['userProfile', 'username'],
        fn: function fn(userProfile, username) {
          if (!userProfile || _.isEmpty(userProfile.firstName)) {
            return username;
          }

          if (_.isEmpty(userProfile.lastName)) {
            return userProfile.firstName;
          }

          return userProfile.firstName + ' ' + userProfile.lastName.charAt(0) + '.';
        }
      },
      'userEmail': {
        deps: ['userProfile'],
        fn: function fn(userProfile) {
          if (!userProfile || !userProfile.login) {
            return null;
          }

          return userProfile.login;
        }
      },
      'userFullName': {
        deps: ['userProfile'],
        fn: function fn(userProfile) {
          if (!userProfile || !userProfile.firstName && !userProfile.lastName) {
            return '';
          }

          return userProfile.firstName + ' ' + userProfile.lastName;
        }
      },
      'defaultAppLogo': {
        deps: ['baseUrl'],
        fn: function fn(baseUrl) {
          return baseUrl + DEFAULT_APP_LOGO;
        }
      },
      'expiresAt': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.expiresAt;
        }
      },
      'target': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._embedded) {
            return null;
          }

          return res._embedded.target;
        }
      },
      'targetLabel': {
        deps: ['target'],
        fn: function fn(target) {
          if (!target) {
            return null;
          }

          return target.label;
        }
      },
      'targetLogo': {
        deps: ['target'],
        fn: function fn(target) {
          if (!target || !target._links) {
            return null;
          }

          return target._links.logo;
        }
      },
      'targetTermsOfService': {
        deps: ['target'],
        fn: function fn(target) {
          if (!target || !target._links) {
            return null;
          }

          return target._links['terms-of-service'];
        }
      },
      'targetPrivacyPolicy': {
        deps: ['target'],
        fn: function fn(target) {
          if (!target || !target._links) {
            return null;
          }

          return target._links['privacy-policy'];
        }
      },
      'targetClientURI': {
        deps: ['target'],
        fn: function fn(target) {
          if (!target || !target._links) {
            return null;
          }

          return target._links['client-uri'];
        }
      },
      'scopes': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._embedded) {
            return null;
          }

          return res._embedded.scopes;
        }
      },
      'issuer': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          var _res$_embedded, _res$_embedded$authen, _res$_embedded$authen2;

          return res === null || res === void 0 ? void 0 : (_res$_embedded = res._embedded) === null || _res$_embedded === void 0 ? void 0 : (_res$_embedded$authen = _res$_embedded.authentication) === null || _res$_embedded$authen === void 0 ? void 0 : (_res$_embedded$authen2 = _res$_embedded$authen.issuer) === null || _res$_embedded$authen2 === void 0 ? void 0 : _res$_embedded$authen2.uri;
        }
      },
      'hasExistingPhones': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._embedded || !res._embedded.factors) {
            return false;
          }

          var factors = res._embedded.factors;

          var factor = _.findWhere(factors, {
            factorType: 'sms',
            provider: 'OKTA'
          });

          if (!factor || !factor._embedded) {
            return false;
          }

          return !!factor._embedded.phones.length;
        }
      },
      'hasExistingPhonesForCall': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._embedded || !res._embedded.factors) {
            return false;
          }

          var factors = res._embedded.factors;

          var factor = _.findWhere(factors, {
            factorType: 'call',
            provider: 'OKTA'
          });

          if (!factor || !factor._embedded) {
            return false;
          }

          return !!factor._embedded.phones.length;
        }
      },
      'isUndefinedUser': {
        deps: ['securityImage'],
        fn: function fn(securityImage) {
          return securityImage === UNDEFINED_USER;
        }
      },
      'isNewUser': {
        deps: ['securityImage'],
        fn: function fn(securityImage) {
          return securityImage === NEW_USER;
        }
      },
      'allowRememberDevice': {
        deps: ['policy'],
        fn: function fn(policy) {
          return policy && policy.allowRememberDevice;
        }
      },
      'rememberDeviceLabel': {
        deps: ['policy'],
        fn: function fn(policy) {
          if (policy && policy.rememberDeviceLifetimeInMinutes > 0) {
            var timeString = getMinutesString(policy.rememberDeviceLifetimeInMinutes);
            return Okta.loc('rememberDevice.timebased', 'login', [timeString]);
          } else if (policy && policy.rememberDeviceLifetimeInMinutes === 0) {
            return Okta.loc('rememberDevice.devicebased', 'login');
          }

          return Okta.loc('rememberDevice', 'login');
        }
      },
      'rememberDeviceByDefault': {
        deps: ['policy'],
        fn: function fn(policy) {
          return policy && policy.rememberDeviceByDefault;
        }
      },
      'factorsPolicyInfo': {
        deps: ['policy'],
        fn: function fn(policy) {
          return policy && policy.factorsPolicyInfo ? policy.factorsPolicyInfo : null;
        }
      },
      'verifyCustomFactorRedirectUrl': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._links || !res._links.next || res._links.next.name !== 'redirect' || !res._links.next.href) {
            return null;
          }

          return res._links.next.href;
        }
      },
      'enrollCustomFactorRedirectUrl': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          if (!res._links || !res._links.next || res._links.next.name !== 'activate' || !res._links.next.href) {
            return null;
          }

          return res._links.next.href;
        }
      },
      'isFactorResultFailed': {
        deps: ['lastAuthResponse'],
        fn: function fn(res) {
          return res.factorResult === 'FAILED';
        }
      },
      'factorResultErrorMessage': {
        deps: ['lastAuthResponse', 'isFactorResultFailed'],
        fn: function fn(res, isFactorResultFailed) {
          if (isFactorResultFailed) {
            return res.factorResultMessage || Okta.loc('oform.error.unexpected', 'login');
          }

          return null;
        }
      }
    },
    parse: function parse(options) {
      this.settings = options.settings;
      return _.extend(_.omit(options, 'settings'), {
        languageCode: this.settings.get('languageCode')
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _reduce = _interopRequireDefault(__webpack_require__(90));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(141));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _keys = _interopRequireDefault(__webpack_require__(334));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(748), __webpack_require__(749)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (parseMs, toMilliseconds) {
  var MOMENT_UNIT = {
    MILLISECOND: 'milliseconds',
    SECOND: 'seconds',
    MINUTE: 'minutes',
    HOUR: 'hours',
    DAY: 'days'
  };
  var MOMENT_UNIT_KEYS = (0, _keys.default)(MOMENT_UNIT);
  /**
   * @method convertMomentUnits
   * Conversion between moment's units and our units internally
   *
   * @param {String} momentUnit The units that val is in
   * @return {String} The key in the MOMENT_UNIT hash
   */

  var convertMomentUnits = function convertMomentUnits(momentUnit) {
    var entry = (0, _filter.default)(MOMENT_UNIT_KEYS).call(MOMENT_UNIT_KEYS, function (k) {
      return MOMENT_UNIT[k] === momentUnit;
    });
    return entry.length === 1 ? entry[0] : momentUnit;
  };

  return {
    /**
     * @method getTimeInHighestRelevantUnit
     * Will return a number in the units of the highest relevant time unit.
     * Only checks milliseconds, seconds, minutes, hours, and days.
     * E.g.
     *   15 MINUTE  -> 15 MINUTE
     *   15 minutes -> 15 MINUTE
     *   60 minutes ->  1 HOUR
     *   90 minutes -> 90 MINUTE
     *   24 HOUR    ->  1 DAY
     *   24 hours   ->  1 DAY
     *   30 DAY     -> 30 DAY
     *
     * @typedef { "MILLISECOND" | "SECOND" | "MINUTE" | "HOUR" | "DAY" } TimeUnit
     *
     * @typedef { "MILLISECOND" | "SECOND" | "MINUTE" | "HOUR" | "DAY" |
     *            "milliseconds" | "seconds" | "minutes" | "hours" | "days"
     *          } FlexibleTimeUnit
     *
     * @typedef TimeAndUnit
     * @property {number} time the consolidated time
     * @property {TimeUnit} unit the unit of the time
     *
     * @param {FlexibleTimeUnit} unit The time unit
     * @return {TimeAndUnit} An object containing the amount of time and the unit
     */
    getTimeInHighestRelevantUnit: function getTimeInHighestRelevantUnit(val, unit) {
      var _context;

      var defaultTimeObj = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
      };
      var normalizedUnit = MOMENT_UNIT[unit] || unit;
      var timeObj;

      try {
        var ms = toMilliseconds((0, _assign.default)(defaultTimeObj, (0, _defineProperty2.default)({}, normalizedUnit, val)));
        timeObj = parseMs(ms);
      } catch (error) {
        timeObj = {};
      }

      var duration = (0, _reduce.default)(_context = (0, _keys.default)(timeObj)).call(_context, function (init, k) {
        if (timeObj[k] !== 0) {
          init[k] = timeObj[k];
        }

        return init;
      }, {});
      var highestUnit;
      var time;

      if ((0, _keys.default)(duration).length === 1) {
        var _context2;

        (0, _forEach.default)(_context2 = (0, _keys.default)(duration)).call(_context2, function (k) {
          time = duration[k];
          highestUnit = k;
        });
      } else {
        time = val;
        highestUnit = normalizedUnit;
      }

      return {
        time: time,
        unit: convertMomentUnits(highestUnit)
      };
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(310);

module.exports = parent;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(742);

module.exports = parent;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(743);
var path = __webpack_require__(15);

module.exports = path.Object.assign;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var assign = __webpack_require__(744);

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(39);
var fails = __webpack_require__(20);
var objectKeys = __webpack_require__(136);
var getOwnPropertySymbolsModule = __webpack_require__(231);
var propertyIsEnumerableModule = __webpack_require__(160);
var toObject = __webpack_require__(52);
var IndexedObject = __webpack_require__(161);

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(746);

module.exports = parent;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(747);
var path = __webpack_require__(15);

module.exports = path.Object.keys;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var toObject = __webpack_require__(52);
var nativeKeys = __webpack_require__(136);
var fails = __webpack_require__(20);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (milliseconds) {
  if (typeof milliseconds !== 'number') {
    throw new TypeError('Expected a number');
  }

  var roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil;
  return {
    days: roundTowardsZero(milliseconds / 86400000),
    hours: roundTowardsZero(milliseconds / 3600000) % 24,
    minutes: roundTowardsZero(milliseconds / 60000) % 60,
    seconds: roundTowardsZero(milliseconds / 1000) % 60,
    milliseconds: roundTowardsZero(milliseconds) % 1000,
    microseconds: roundTowardsZero(milliseconds * 1000) % 1000,
    nanoseconds: roundTowardsZero(milliseconds * 1e6) % 1000
  };
};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(335));

var _entries = _interopRequireDefault(__webpack_require__(343));

var _reduce = _interopRequireDefault(__webpack_require__(90));

var converters = {
  days: function days(value) {
    return value * 864e5;
  },
  hours: function hours(value) {
    return value * 36e5;
  },
  minutes: function minutes(value) {
    return value * 6e4;
  },
  seconds: function seconds(value) {
    return value * 1e3;
  },
  milliseconds: function milliseconds(value) {
    return value;
  },
  microseconds: function microseconds(value) {
    return value / 1e3;
  },
  nanoseconds: function nanoseconds(value) {
    return value / 1e6;
  }
};

var toMilliseconds = function toMilliseconds(object) {
  var _context;

  return (0, _reduce.default)(_context = (0, _entries.default)(object)).call(_context, function (milliseconds, _ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (typeof value !== 'number') {
      var _context2, _context3;

      throw new TypeError((0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "Expected a `number` for key `".concat(key, "`, got `")).call(_context3, value, "` (")).call(_context2, (0, _typeof2.default)(value), ")"));
    }

    if (!converters[key]) {
      throw new Error('Unsupported time key');
    }

    return milliseconds + converters[key](value);
  }, 0);
};

module.exports = toMilliseconds; // TODO: remove this for next major version

module.exports.default = toMilliseconds;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(336);

function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(282);

module.exports = parent;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var _getIterator = __webpack_require__(337);

var _isIterable = __webpack_require__(234);

var _Symbol = __webpack_require__(232);

function _iterableToArrayLimit(arr, i) {
  if (typeof _Symbol === "undefined" || !_isIterable(Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = _getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79);
__webpack_require__(139);
var getIterator = __webpack_require__(338);

module.exports = getIterator;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79);
__webpack_require__(139);
var isIterable = __webpack_require__(755);

module.exports = isIterable;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(81);
var wellKnownSymbol = __webpack_require__(23);
var Iterators = __webpack_require__(111);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(341);

module.exports = parent;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var from = __webpack_require__(758);
var checkCorrectnessOfIteration = __webpack_require__(326);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(88);
var toObject = __webpack_require__(52);
var callWithSafeIterationClosing = __webpack_require__(325);
var isArrayIteratorMethod = __webpack_require__(324);
var toLength = __webpack_require__(47);
var createProperty = __webpack_require__(121);
var getIteratorMethod = __webpack_require__(180);

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(760);

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(299);

module.exports = parent;


/***/ }),
/* 761 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(763);

module.exports = parent;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(764);
var path = __webpack_require__(15);

module.exports = path.Object.entries;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var $entries = __webpack_require__(765).entries;

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(39);
var objectKeys = __webpack_require__(136);
var toIndexedObject = __webpack_require__(59);
var propertyIsEnumerable = __webpack_require__(160).f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(module.exports = {
  INVALID_TOKEN_EXCEPTION: 'E0000011'
});

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(345), __webpack_require__(236), __webpack_require__(775), __webpack_require__(776), __webpack_require__(348), __webpack_require__(126), __webpack_require__(347)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, PrimaryAuthController, PrimaryAuthModel, IDPDiscoveryForm, IDPDiscoveryModel, Footer, BaseLoginController, CustomButtons) {
  return PrimaryAuthController.extend({
    className: 'idp-discovery',
    View: IDPDiscoveryForm,
    constructor: function constructor(options) {
      options.appState.unset('username');
      this.model = new IDPDiscoveryModel({
        requestContext: options.settings.get('idpDiscovery.requestContext'),
        settings: options.settings,
        appState: options.appState
      }, {
        parse: true
      });
      BaseLoginController.apply(this, arguments);
      this.addListeners(); // If social auth is configured, 'socialAuthPositionTop' will determine
      // the order in which the social auth and primary auth are shown on the screen.

      if (options.settings.get('hasConfiguredButtons')) {
        this.add(CustomButtons, {
          prepend: options.settings.get('socialAuthPositionTop'),
          options: {
            // To trigger an afterError event, we require the current controller
            currentController: this
          }
        });
      }

      this.addFooter(options);
      this.setUsername();
    },
    initialize: function initialize() {
      PrimaryAuthController.prototype.initialize.apply(this);
      this.listenTo(this.model, 'goToPrimaryAuth', function () {
        this.settings.set('username', this.model.get('username'));

        if (this.settings.get('features.passwordlessAuth')) {
          var primaryAuthModel = new PrimaryAuthModel({
            username: this.model.get('username'),
            multiOptionalFactorEnroll: this.options.settings.get('features.multiOptionalFactorEnroll'),
            settings: this.options.settings,
            appState: this.options.appState
          }, {
            parse: true
          }); // Events to set the transaction attributes on the app state.

          this.addModelListeners(primaryAuthModel); // Make the primary auth request

          primaryAuthModel.save();
        } else {
          this.options.appState.set('disableUsername', true);
          this.options.appState.trigger('navigate', 'signin');
        }
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(769)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (TypingDNA) {
  var tdna;
  return {
    track: function track(selectorId) {
      try {
        tdna = new TypingDNA();
        tdna.addTarget(selectorId);
        tdna.start();
      } catch (e) {// Issues in typing should not stop Primary auth.
      }
    },
    getTypingPattern: function getTypingPattern() {
      try {
        return tdna.getTypingPattern({
          type: 1
        });
      } catch (e) {
        return null;
      }
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _slice = _interopRequireDefault(__webpack_require__(229));

var _parseInt2 = _interopRequireDefault(__webpack_require__(171));

var _sort = _interopRequireDefault(__webpack_require__(235));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _flags = _interopRequireDefault(__webpack_require__(284));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(335));

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _splice = _interopRequireDefault(__webpack_require__(109));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

var _setInterval2 = _interopRequireDefault(__webpack_require__(169));

/*
 * Checking in as there is no npm module to consume. 
 * Current version is 2.15.
 * Repo - https://github.com/TypingDNA/TypingDnaRecorder-JavaScript
 */

/**
 * TypingDNA - Typing Biometrics JavaScript API
 * https://api.typingdna.com/scripts/typingdna.js
 * https://typingdna.com/scripts/typingdna.js (alternative)
 *
 * @version 2.15
 * @author Raul Popa
 * @copyright SC TypingDNA SRL, http://typingdna.com
 * @license http://www.apache.org/licenses/LICENSE-2.0
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Typical usage:
 * var tdna = new TypingDNA(); // creates a new TypingDNA object and starts recording
 * var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
 * returns a type 1 typing pattern (and continues recording afterwards)
 *
 * Optional:
 * tdna.stop(); // ends recording and clears history stack (returns recording flag: false)
 * tdna.start(); // restarts the recording after a stop (returns recording flag: true)
 * tdna.reset(); // restarts the recording anytime, clears history stack and starts from scratch (returns nothing)
 * var typingPatternQuality = TypingDNA.getQuality(typingPattern); //returns the quality/strength of any typing pattern
 * (there is no need to initialize the class to do pattern quality checking)
 */

/**
 * Creates a single instance (or a reference) of the TypingDNA class
 * @return {Object} Returns the single instance of the TypingDNA class.
 * @example var tdna = new TypingDNA();
 */
module.exports = function TypingDNA() {
  if (TypingDNA.initialized != true) {
    TypingDNA.prototype.start = function () {
      return TypingDNA.start.apply(this, arguments);
    };

    TypingDNA.prototype.stop = function () {
      return TypingDNA.stop.apply(this, arguments);
    };

    TypingDNA.prototype.reset = function () {
      return TypingDNA.reset.apply(this, arguments);
    };

    TypingDNA.prototype.addTarget = function () {
      return TypingDNA.addTarget.apply(this, arguments);
    };

    TypingDNA.prototype.removeTarget = function () {
      return TypingDNA.removeTarget.apply(this, arguments);
    };

    TypingDNA.prototype.getTypingPattern = function () {
      return TypingDNA.getTypingPattern.apply(this, arguments);
    };

    TypingDNA.prototype.get = function () {
      // still works but will be deprecated in favor of getTypignPattern()
      return TypingDNA.get.apply(this, arguments);
    };

    TypingDNA.prototype.startDiagram = function () {// deprecated in favor of start()
      //return TypingDNA.startDiagram.apply(this, arguments);
    };

    TypingDNA.prototype.stopDiagram = function () {// deprecated in favor of stop()
      //return TypingDNA.stopDiagram.apply(this, arguments);
    };

    TypingDNA.prototype.getDiagram = function () {
      // still works but will be deprecated in favor of getTypignPattern()
      return TypingDNA.getDiagram.apply(this, arguments);
    };

    TypingDNA.prototype.getExtendedDiagram = function () {
      // still works but will be deprecated in favor of getTypignPattern()
      return TypingDNA.getExtendedDiagram.apply(this, arguments);
    };

    TypingDNA.prototype.getMouseDiagram = function () {
      return TypingDNA.getMouseDiagram.apply(this, arguments);
    };

    TypingDNA.prototype.startMouse = function () {
      return TypingDNA.startMouse.apply(this, arguments);
    };

    TypingDNA.prototype.stopMouse = function () {
      return TypingDNA.stopMouse.apply(this, arguments);
    };

    TypingDNA.prototype.getQuality = function () {
      return TypingDNA.getQuality.apply(this, arguments);
    };

    TypingDNA.prototype.getLength = function () {
      return TypingDNA.getLength.apply(this, arguments);
    };

    TypingDNA.prototype.isMobile = function () {
      return TypingDNA.isMobile.apply(this, arguments);
    };

    TypingDNA.prototype.getTextId = function () {
      return TypingDNA.getTextId.apply(this, arguments);
    };

    TypingDNA.initialized = true;
    TypingDNA.prototype.maxHistoryLength = TypingDNA.maxHistoryLength;
    TypingDNA.prototype.defaultHistoryLength = TypingDNA.defaultHistoryLength;
    TypingDNA.prototype.maxSeekTime = TypingDNA.maxSeekTime;
    TypingDNA.prototype.maxPressTime = TypingDNA.maxPressTime;
    TypingDNA.version = 2.15;
    TypingDNA.flags = 0;
    TypingDNA.instance = this;
    TypingDNA.document = document;
    TypingDNA.maxHistoryLength = 2000;
    TypingDNA.maxSeekTime = 1500;
    TypingDNA.maxPressTime = 300;
    TypingDNA.defaultHistoryLength = 160;
    TypingDNA.spKeyCodes = [8, 13, 32];
    TypingDNA.spKeyCodesObj = {
      8: 1,
      13: 1,
      32: 1
    };
    TypingDNA.keyCodes = [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 32, 222, 188, 190, 186, 187, 189, 191, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
    TypingDNA.keyCodesObj = {};

    for (var i in TypingDNA.keyCodes) {
      TypingDNA.keyCodesObj[TypingDNA.keyCodes[i]] = 1;
    }

    TypingDNA.pt1 = TypingDNA.ut1 = new Date().getTime();
    TypingDNA.wfk = [];
    TypingDNA.sti = [];
    TypingDNA.skt = [];
    TypingDNA.recording = true;
    TypingDNA.mouseRecording = true;
    TypingDNA.mouseMoveRecording = false;
    TypingDNA.spKeyRecording = true;
    TypingDNA.diagramRecording = true;
    TypingDNA.dwfk = [];
    TypingDNA.dsti = [];
    TypingDNA.dskt = [];
    TypingDNA.drkc = [];
    TypingDNA.dlastDownKey;
    TypingDNA.prevKeyCode = 0;
    TypingDNA.maxMoveDeltaTime = 600;
    TypingDNA.maxScrollDeltaTime = 800;
    TypingDNA.maxStopTime = 1500;
    TypingDNA.maxClickTime = 600;
    TypingDNA.maxMouseHistoryLength = 500;
    TypingDNA.lastMouseMoveTime = TypingDNA.lastMouseDownTime = new Date().getTime();
    TypingDNA.stopTimes = [];
    TypingDNA.clickTimes = [];
    TypingDNA.lastMouseStop = true;
    TypingDNA.zl = 0.0000001;
    TypingDNA.isAndroidChrome = false;
    TypingDNA.ACLastTime = new Date().getTime();
    TypingDNA.ACSeekTime = 0;
    TypingDNA.ACPressTime = 0;
    TypingDNA.ACLastCharCode = 0;
    TypingDNA.ACLastKeyCode = 0;
    TypingDNA.ACInputLengths = {
      inputs: [],
      lastLength: []
    };
    TypingDNA.ACPreviousKeyCode = 0;
    TypingDNA.targetIds = [];
    TypingDNA.lastTarget = "";
    TypingDNA.lastTargetFound = false;
    TypingDNA.replaceMissingKeys = true;
    TypingDNA.replaceMissingKeysPerc = 7;

    TypingDNA.keyDown = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }

      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }

      var keyCode = e.keyCode;

      if (TypingDNA.wfk[keyCode] == 1 || TypingDNA.dwfk[keyCode] == 1) {//return;
      }

      if (keyCode == 229 && TypingDNA.isMobile() && !TypingDNA.isAndroidChrome) {
        TypingDNA.isAndroidChrome = true;
        TypingDNA.ACSeekTime = new Date().getTime() - TypingDNA.ACLastTime;
        TypingDNA.ACLastTime = new Date().getTime();
        TypingDNA.document.removeEventListener("keydown", TypingDNA.keyDown);
        TypingDNA.document.removeEventListener("keyup", TypingDNA.keyUp);
        TypingDNA.document.removeEventListener("keypress", TypingDNA.keyPress); // if android

        TypingDNA.document.addEventListener("keydown", TypingDNA.ACKeyDown);
        TypingDNA.document.addEventListener("keyup", TypingDNA.ACKeyUp);
      } else {
        var t0 = TypingDNA.pt1;
        TypingDNA.pt1 = new Date().getTime();
        var seekTotal = TypingDNA.pt1 - t0;
        var startTime = TypingDNA.pt1;

        if (TypingDNA.recording == true || TypingDNA.spKeyCodesObj[keyCode] && TypingDNA.spKeyRecording == true) {
          if (!e.shiftKey || TypingDNA.isMobile()) {
            TypingDNA.wfk[keyCode] = 1;
            TypingDNA.skt[keyCode] = seekTotal;
            TypingDNA.sti[keyCode] = startTime;
          }
        }

        if (TypingDNA.diagramRecording == true) {
          TypingDNA.dwfk[keyCode] = 1;
          TypingDNA.dskt[keyCode] = seekTotal;
          TypingDNA.dsti[keyCode] = startTime;
          TypingDNA.dlastDownKey = keyCode;
        }
      }
    };

    TypingDNA.keyPress = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }

      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }

      if (TypingDNA.diagramRecording == true) {
        var keyCode = TypingDNA.dlastDownKey;
        TypingDNA.drkc[keyCode] = e.charCode;
      }
    };

    TypingDNA.keyUp = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }

      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }

      var ut = new Date().getTime();
      var keyCode = e.keyCode;

      if (TypingDNA.recording == true || TypingDNA.spKeyCodesObj[keyCode] && TypingDNA.spKeyRecording == true) {
        if (!e.shiftKey || TypingDNA.isMobile()) {
          if (TypingDNA.wfk[keyCode] == 1) {
            var pressTime = ut - TypingDNA.sti[keyCode];
            var seekTime = TypingDNA.skt[keyCode];
            var arr = [keyCode, seekTime, pressTime, TypingDNA.prevKeyCode, ut, e.target.id];
            TypingDNA.history.add(arr);
            TypingDNA.prevKeyCode = keyCode;
          }
        }

        TypingDNA.wfk[keyCode] = 0;
      }

      if (TypingDNA.diagramRecording == true) {
        if (TypingDNA.drkc[keyCode] != undefined && TypingDNA.drkc[keyCode] != 0) {
          if (TypingDNA.dwfk[keyCode] == 1) {
            var pressTime = ut - TypingDNA.dsti[keyCode];
            var seekTime = TypingDNA.dskt[keyCode];
            var realKeyCode = TypingDNA.drkc[keyCode];
            var arrD = [keyCode, seekTime, pressTime, realKeyCode, ut, e.target.id];
            TypingDNA.history.addDiagram(arrD);
          }
        }

        TypingDNA.dwfk[keyCode] = 0;
      }
    };

    TypingDNA.mouseScroll = function (e) {
      if (TypingDNA.mouseRecording == true) {
        if (TypingDNA.mouseMoveRecording == true) {
          if (TypingDNA.mouse.scrollStarted == true) {
            var currentTime = new Date().getTime();
            TypingDNA.mouse.scrollTimes.push(currentTime);
            TypingDNA.mouse.scrollTopArr.push(TypingDNA.document.body.scrollTop);
            clearInterval(TypingDNA.scrollInterval);
            TypingDNA.scrollInterval = (0, _setInterval2.default)(TypingDNA.mouse.checkScroll, TypingDNA.maxScrollDeltaTime);
          } else {
            TypingDNA.mouse.scrollStarted = true;
          }
        }
      }
    };

    TypingDNA.mouseMove = function (e) {
      if (TypingDNA.mouseRecording == true) {
        var currentTime = new Date().getTime();

        if (TypingDNA.mouseMoveRecording == true) {
          if (TypingDNA.mouse.started == true) {
            TypingDNA.mouse.times.push(currentTime);
            TypingDNA.mouse.xPositions.push(e.screenX);
            TypingDNA.mouse.yPositions.push(e.screenY);
            clearInterval(TypingDNA.moveInterval);
            TypingDNA.moveInterval = (0, _setInterval2.default)(TypingDNA.mouse.checkMove, TypingDNA.maxMoveDeltaTime);
          } else {
            TypingDNA.mouse.started = true;
          }
        }

        TypingDNA.lastMouseMoveTime = currentTime;
      }
    };

    TypingDNA.mouseDown = function (e) {
      if (TypingDNA.mouseRecording == true) {
        TypingDNA.mouse.checkMove();
        TypingDNA.mouse.checkScroll();

        if (e.which == 1) {
          TypingDNA.lastMouseDownTime = new Date().getTime();
          var stopTime = TypingDNA.lastMouseDownTime - TypingDNA.lastMouseMoveTime;

          if (stopTime < TypingDNA.maxStopTime && TypingDNA.lastMouseStop == false) {
            TypingDNA.stopTimes.push(stopTime);

            if (TypingDNA.mouseMoveRecording == true) {
              var eventType = 3;
              var arr = [eventType, stopTime];
              TypingDNA.mouse.history.add(arr);
              TypingDNA.lastMouseStop = true;
            }
          }
        }
      }
    };

    TypingDNA.mouseUp = function (e) {
      if (TypingDNA.mouseRecording == true) {
        if (e.which == 1) {
          var clickTime = new Date().getTime() - TypingDNA.lastMouseDownTime;

          if (clickTime < TypingDNA.maxClickTime && TypingDNA.lastMouseDownTime > TypingDNA.lastMouseMoveTime) {
            TypingDNA.clickTimes.push(clickTime);

            if (TypingDNA.mouseMoveRecording == true) {
              var eventType = 4;
              var arr = [eventType, clickTime];
              TypingDNA.mouse.history.add(arr);
            }
          }
        }
      }
    };

    TypingDNA.ACKeyDown = function (e) {
      var _context;

      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }

      TypingDNA.ACSeekTime = new Date().getTime() - TypingDNA.ACLastTime;
      TypingDNA.ACLastTime = new Date().getTime();

      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }

      if ((0, _indexOf.default)(_context = TypingDNA.ACInputLengths.inputs).call(_context, e.target) === -1) {
        TypingDNA.ACInputLengths.inputs.push(e.target);
        TypingDNA.ACInputLengths.lastLength.push(0);
      }
    };

    TypingDNA.ACKeyUp = function (e) {
      var _context2;

      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }

      TypingDNA.ACPressTime = new Date().getTime() - TypingDNA.ACLastTime;
      TypingDNA.ACLastTime = new Date().getTime();

      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }

      var keyCode = e.keyCode;
      var targetIndex = (0, _indexOf.default)(_context2 = TypingDNA.ACInputLengths.inputs).call(_context2, e.target);

      if (targetIndex === -1) {
        var _context3;

        TypingDNA.ACInputLengths.inputs.push(e.target);
        TypingDNA.ACInputLengths.lastLength.push(0);
        targetIndex = (0, _indexOf.default)(_context3 = TypingDNA.ACInputLengths.inputs).call(_context3, e.target);
      }

      if (keyCode == 229 && e.target.value.length >= TypingDNA.ACInputLengths.lastLength[targetIndex]) {
        var char = e.target.value.substr(e.target.selectionStart - 1 || 0, 1);
        keyCode = char.toUpperCase().charCodeAt(0);
        TypingDNA.ACLastCharCode = char.charCodeAt(0);
        TypingDNA.ACLastKeyCode = char.toUpperCase().charCodeAt(0);
      }

      TypingDNA.ACInputLengths.lastLength[targetIndex] = e.target.value.length;
      var arr = [keyCode, TypingDNA.ACSeekTime, TypingDNA.ACPressTime, TypingDNA.ACPreviousKeyCode, TypingDNA.ACLastTime];
      TypingDNA.history.add(arr);
      TypingDNA.ACPreviousKeyCode = keyCode;

      if (TypingDNA.diagramRecording == true) {
        var arrD = [keyCode, TypingDNA.ACSeekTime, TypingDNA.ACPressTime, TypingDNA.ACLastCharCode];
        TypingDNA.history.addDiagram(arrD);
      }
    };

    TypingDNA.isTarget = function (target) {
      if (TypingDNA.lastTarget == target && TypingDNA.lastTargetFound) {
        return true;
      } else {
        var targetLength = TypingDNA.targetIds.length;
        var targetFound = false;

        if (targetLength > 0) {
          for (var i = 0; i < targetLength; i++) {
            if (TypingDNA.targetIds[i] == target) {
              targetFound = true;
              break;
            }
          }

          TypingDNA.lastTarget = target;
          TypingDNA.lastTargetFound = targetFound;
          return targetFound;
        } else {
          TypingDNA.lastTarget = target;
          TypingDNA.lastTargetFound = true;
          return true;
        }
      }
    };

    if (TypingDNA.document.addEventListener) {
      TypingDNA.document.addEventListener("keydown", TypingDNA.keyDown);
      TypingDNA.document.addEventListener("keyup", TypingDNA.keyUp);
      TypingDNA.document.addEventListener("keypress", TypingDNA.keyPress);
      TypingDNA.document.addEventListener("mousemove", TypingDNA.mouseMove);
      TypingDNA.document.addEventListener("mousedown", TypingDNA.mouseDown);
      TypingDNA.document.addEventListener("mouseup", TypingDNA.mouseUp);
      TypingDNA.document.addEventListener("scroll", TypingDNA.mouseScroll);
    } else if (TypingDNA.document.attachEvent) {
      TypingDNA.document.attachEvent("onkeydown", TypingDNA.keyDown);
      TypingDNA.document.attachEvent("onkeyup", TypingDNA.keyUp);
      TypingDNA.document.attachEvent("onkeypress", TypingDNA.keyPress);
      TypingDNA.document.attachEvent("onmousemove", TypingDNA.mouseMove);
      TypingDNA.document.attachEvent("onmousedown", TypingDNA.mouseDown);
      TypingDNA.document.attachEvent("onmouseup", TypingDNA.mouseUp);
      TypingDNA.document.attachEvent("onscroll", TypingDNA.mouseScroll);
    } else {
      console.log("browser not supported");
    }

    TypingDNA.mouse = {};
    TypingDNA.mouse.times = [];
    TypingDNA.mouse.xPositions = [];
    TypingDNA.mouse.yPositions = [];
    TypingDNA.mouse.scrollTimes = [];
    TypingDNA.mouse.scrollTopArr = [];
    TypingDNA.mouse.history = {};
    TypingDNA.mouse.history.stack = [];

    TypingDNA.mouse.getDistance = function (a, b) {
      return Math.sqrt(a * a + b * b);
    };

    TypingDNA.mouse.getTotalDistance = function (xPositions, yPositions) {
      var totalDistance = 0;
      var length = xPositions.length;

      for (i = 1; i < length - 1; i++) {
        var a = xPositions[i] - xPositions[i - 1];
        var b = yPositions[i] - yPositions[i - 1];
        totalDistance += TypingDNA.mouse.getDistance(a, b);
      }

      return totalDistance;
    };

    TypingDNA.mouse.getAngle = function (xPosDelta, yPosDelta) {
      var angle = 0;
      var leftRight = xPosDelta >= 0; // 1 if left, 0 if right

      var downUp = yPosDelta < 0; // 1 if down, 0 if up

      if (leftRight) {
        if (downUp) {
          angle = 180 + Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251); // 0.01745329251 = pi/180
        } else {
          angle = 270 + (90 - Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251));
        }
      } else {
        if (downUp) {
          angle = 90 + (90 - Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251));
        } else {
          angle = Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251);
        }
      }

      return angle;
    };

    TypingDNA.mouse.recordMoveAction = function () {
      var length = TypingDNA.mouse.times.length;

      if (length < 3) {
        return;
      }

      var deltaTime = TypingDNA.mouse.times[length - 1] - TypingDNA.mouse.times[0];
      var xPosDelta = TypingDNA.mouse.xPositions[length - 1] - TypingDNA.mouse.xPositions[0];
      var yPosDelta = TypingDNA.mouse.yPositions[length - 1] - TypingDNA.mouse.yPositions[0];
      var directDistance = Math.round(TypingDNA.mouse.getDistance(xPosDelta, yPosDelta));
      var totalDistance = Math.round(TypingDNA.mouse.getTotalDistance(TypingDNA.mouse.xPositions, TypingDNA.mouse.yPositions));
      var ratioDistance = Math.round(totalDistance * 100 / directDistance);
      var speed = Math.round(directDistance * 100 / deltaTime);
      var angle = TypingDNA.mouse.getAngle(xPosDelta, yPosDelta);
      var eventType = 1;
      var arr = [eventType, deltaTime, directDistance, speed, angle, ratioDistance];

      for (i in arr) {
        if (isNaN(arr[i])) {
          return;
        }
      }

      TypingDNA.mouse.history.add(arr);
      TypingDNA.lastMouseStop = false;
    };

    TypingDNA.mouse.recordScrollAction = function () {
      var length = TypingDNA.mouse.scrollTimes.length;

      if (length < 2) {
        return;
      }

      var deltaTime = TypingDNA.mouse.scrollTimes[length - 1] - TypingDNA.mouse.scrollTimes[0];
      var directDistance = TypingDNA.mouse.scrollTopArr[length - 1] - TypingDNA.mouse.scrollTopArr[0];
      var speed = Math.round(directDistance * 100 / deltaTime);
      var eventType = 2;
      var arr = [eventType, deltaTime, directDistance, speed];

      for (i in arr) {
        if (isNaN(arr[i]) && !isFinite(arr[i])) {
          return;
        }
      }

      TypingDNA.mouse.history.add(arr);
    };

    TypingDNA.mouse.history.add = function (arr) {
      this.stack.push(arr);

      if (this.stack.length > TypingDNA.maxMouseHistoryLength) {
        this.stack.shift();
      }
    };

    TypingDNA.mouse.history.getDiagram = function () {
      var mouseDiagram = this.stack.join("|");
      return [String(TypingDNA.isMobile()) + "," + String(TypingDNA.version), mouseDiagram].join("|");
    };

    TypingDNA.mouse.clearLastMove = function () {
      TypingDNA.mouse.times = [];
      TypingDNA.mouse.xPositions = [];
      TypingDNA.mouse.yPositions = [];
    };

    TypingDNA.mouse.checkMove = function () {
      clearInterval(TypingDNA.moveInterval);

      if (TypingDNA.mouse.started == true) {
        TypingDNA.mouse.started = false;
        TypingDNA.mouse.recordMoveAction();
        TypingDNA.mouse.clearLastMove();
      }
    };

    TypingDNA.mouse.clearLastScroll = function () {
      TypingDNA.mouse.scrollTimes = [];
      TypingDNA.mouse.scrollTopArr = [];
    };

    TypingDNA.mouse.checkScroll = function () {
      clearInterval(TypingDNA.scrollInterval);

      if (TypingDNA.mouse.scrollStarted == true) {
        TypingDNA.mouse.scrollStarted = false;
        TypingDNA.mouse.recordScrollAction();
        TypingDNA.mouse.clearLastScroll();
      }
    };
    /**
     * Adds a target to the targetIds array.
     */


    TypingDNA.addTarget = function (target) {
      var targetLength = TypingDNA.targetIds.length;
      var targetFound = false;

      if (targetLength > 0) {
        for (var i = 0; i < targetLength; i++) {
          if (TypingDNA.targetIds[i] == target) {
            targetFound = true;
            break;
          }
        }

        if (!targetFound) {
          TypingDNA.targetIds.push(target);
        }
      } else {
        TypingDNA.targetIds.push(target);
      }
    };
    /**
     * Adds a target to the targetIds array.
     */


    TypingDNA.removeTarget = function (target) {
      var targetLength = TypingDNA.targetIds.length;

      if (targetLength > 0) {
        for (var i = 0; i < targetLength; i++) {
          if (TypingDNA.targetIds[i] == target) {
            var _context4;

            (0, _splice.default)(_context4 = TypingDNA.targetIds).call(_context4, i, 1);
            break;
          }
        }
      }
    };
    /**
     * Resets the history stack
     */


    TypingDNA.reset = function (all) {
      TypingDNA.history.stack = [];
      TypingDNA.history.stackDiagram = [];
      TypingDNA.clickTimes = [];
      TypingDNA.stopTimes = [];
      TypingDNA.ACInputLengths = {
        inputs: [],
        lastLength: []
      };

      if (all == true) {
        TypingDNA.mouse.history.stack = [];
      }
    };
    /**
     * Automatically called at initilization. It starts the recording of keystrokes.
     */


    TypingDNA.start = function () {
      TypingDNA.diagramRecording = true;
      return TypingDNA.recording = true;
    };
    /**
     * Ends the recording of further keystrokes. To restart recording afterwards you can
     * either call TypingDNA.start() or create a new TypingDNA object again, not recommended.
     */


    TypingDNA.stop = function () {
      TypingDNA.diagramRecording = false;
      return TypingDNA.recording = false;
    };
    /**
     * Starts the recording of mouse activity.
     */


    TypingDNA.startMouse = function () {
      return TypingDNA.mouseRecording = TypingDNA.mouseMoveRecording = true;
    };
    /**
     * Stops the recording of mouse activity.
     */


    TypingDNA.stopMouse = function () {
      return TypingDNA.mouseRecording = TypingDNA.mouseMoveRecording = false;
    };
    /**
     * This is the main function that outputs the typing pattern as a String
     * {type:Number, text:String, textId:Number, length: Number, targetId:String, caseSensitive:Boolean}
     * @param {Object} obj an object with the following properties
     * * * @param {String} type 0 for anytext pattern, 1 for sametext pattern (also called diagram pattern)
     * * * and 2 for extended pattern (most versatile, can replace both anytext and sametext patterns)
     * * * @param {Number} length (Optional) the length of the text in the history for which you want
     * * * the typing pattern. length is ignored when text or targetId is set (or both).
     * * * @param {String} text  (Only for type 1 and type 2) a typed string that you want the typing pattern for
     * * * @param {Number} textId (Optional, only for type 1 and type 2) a personalized id for the typed text
     * * * @param {String} targetId (Optional) specifies if pattern is obtain only from text typed in a certain target
     * * * @param {Boolean} caseSensitive (Optional, default: false) Used if you pass a text for type 1 or type 2
     * * * DEPRECATED * * * in favor of type = 2 * * *
     * * * @param {Boolean} extended (Only for type 1) specifies if full information about what was typed is produced,
     * * * including the actual key pressed, if false, only the order of pressed keys is kept (no actual content)
     * @return {String} A typing pattern in string form
     * @example var typingPattern = tdna.getTypingPattern({type=0, length=180});
     * @example var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
     * @example var typingPattern = tdna.getTypingPattern({type=2, text="example@mail.com"});
     */


    TypingDNA.getTypingPattern = function (obj) {
      if ((0, _typeof2.default)(obj) === 'object') {
        switch (obj.type) {
          case 0:
            return TypingDNA.get(obj.length, obj.targetId);
            break;

          case 1:
            var str = obj.text != undefined ? obj.text : obj.length;
            return TypingDNA.history.getDiagram(obj.extended, str, obj.textId, obj.targetId, obj.caseSensitive);
            break;

          case 2:
            var str = obj.text != undefined ? obj.text : obj.length;
            return TypingDNA.history.getDiagram(true, str, obj.textId, obj.targetId, obj.caseSensitive);
            break;

          default:
            return TypingDNA.get(obj.length);
            break;
        }
      } else {
        return TypingDNA.get();
      }
    };

    TypingDNA.getDiagram = function (str, textId) {
      return TypingDNA.history.getDiagram(false, str, textId, undefined, false);
    };

    TypingDNA.getExtendedDiagram = function (str, textId) {
      return TypingDNA.history.getDiagram(true, str, textId, undefined, false);
    };

    TypingDNA.getMouseDiagram = function () {
      return TypingDNA.mouse.history.getDiagram();
    };

    TypingDNA.get = function (length, targetId) {
      var historyTotalLength = TypingDNA.history.stack.length;

      if (length == undefined || length == 0) {
        length = TypingDNA.defaultHistoryLength;
      }

      if (length > historyTotalLength) {
        length = historyTotalLength;
      }

      var obj = {};

      var _TypingDNA$history$ge = TypingDNA.history.get(length, "", targetId);

      var _TypingDNA$history$ge2 = (0, _slicedToArray2.default)(_TypingDNA$history$ge, 2);

      obj.arr = _TypingDNA$history$ge2[0];
      targetLength = _TypingDNA$history$ge2[1];

      if (targetId != undefined && targetId != "") {
        length = targetLength;
      }

      var zl = TypingDNA.zl;
      var histRev = length;
      var histSktF = TypingDNA.math.fo(TypingDNA.history.get(length, "seek", targetId));
      var histPrtF = TypingDNA.math.fo(TypingDNA.history.get(length, "press", targetId));
      var pressHistMean = Math.round(TypingDNA.math.avg(histPrtF));
      var seekHistMean = Math.round(TypingDNA.math.avg(histSktF));
      var pressHistSD = Math.round(TypingDNA.math.sd(histPrtF));
      var seekHistSD = Math.round(TypingDNA.math.sd(histSktF));
      var charMeanTime = seekHistMean + pressHistMean;
      var pressRatio = TypingDNA.math.rd((pressHistMean + zl) / (charMeanTime + zl), 4);
      var seekToPressRatio = TypingDNA.math.rd((1 - pressRatio) / pressRatio, 4);
      var pressSDToPressRatio = TypingDNA.math.rd((pressHistSD + zl) / (pressHistMean + zl), 4);
      var seekSDToPressRatio = TypingDNA.math.rd((seekHistSD + zl) / (pressHistMean + zl), 4);
      var cpm = Math.round(6E4 / (charMeanTime + zl));

      if (histRev == 0) {
        cpm = 0;
      }

      for (var i in obj.arr) {
        var rev = obj.arr[i][1].length;
        var seekMean = 0;
        var pressMean = 0;
        var postMean = 0;
        var seekSD = 0;
        var pressSD = 0;
        var postSD = 0;

        switch (obj.arr[i][0].length) {
          case 0:
            break;

          case 1:
            var seekMean = TypingDNA.math.rd((obj.arr[i][0][0] + zl) / (seekHistMean + zl), 4);
            break;

          default:
            var arr = TypingDNA.math.fo(obj.arr[i][0]);
            seekMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (seekHistMean + zl), 4);
            seekSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (seekHistSD + zl), 4);
        }

        switch (obj.arr[i][1].length) {
          case 0:
            break;

          case 1:
            var pressMean = TypingDNA.math.rd((obj.arr[i][1][0] + zl) / (pressHistMean + zl), 4);
            break;

          default:
            var arr = TypingDNA.math.fo(obj.arr[i][1]);
            pressMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (pressHistMean + zl), 4);
            pressSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (pressHistSD + zl), 4);
        }

        switch (obj.arr[i][2].length) {
          case 0:
            break;

          case 1:
            var postMean = TypingDNA.math.rd((obj.arr[i][2][0] + zl) / (seekHistMean + zl), 4);
            break;

          default:
            var arr = TypingDNA.math.fo(obj.arr[i][2]);
            postMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (seekHistMean + zl), 4);
            postSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (seekHistSD + zl), 4);
        }

        delete obj.arr[i][2];
        delete obj.arr[i][1];
        delete obj.arr[i][0];
        obj.arr[i][0] = rev;
        obj.arr[i][1] = seekMean;
        obj.arr[i][2] = pressMean;
        obj.arr[i][3] = postMean;
        obj.arr[i][4] = seekSD;
        obj.arr[i][5] = pressSD;
        obj.arr[i][6] = postSD;
      }

      var arr = [];
      TypingDNA.apu(arr, histRev);
      TypingDNA.apu(arr, cpm);
      TypingDNA.apu(arr, charMeanTime);
      TypingDNA.apu(arr, pressRatio);
      TypingDNA.apu(arr, seekToPressRatio);
      TypingDNA.apu(arr, pressSDToPressRatio);
      TypingDNA.apu(arr, seekSDToPressRatio);
      TypingDNA.apu(arr, pressHistMean);
      TypingDNA.apu(arr, seekHistMean);
      TypingDNA.apu(arr, pressHistSD);
      TypingDNA.apu(arr, seekHistSD);

      for (var c = 0; c <= 6; c++) {
        for (var i = 0; i < 44; i++) {
          var keyCode = TypingDNA.keyCodes[i];
          var val = obj.arr[keyCode][c];

          if (val == 0 && c > 0) {
            val = 1;
          }

          TypingDNA.apu(arr, val);
        }
      }

      TypingDNA.apu(arr, TypingDNA.isMobile());
      TypingDNA.apu(arr, TypingDNA.version);
      TypingDNA.apu(arr, (0, _flags.default)(TypingDNA));
      arr.push(TypingDNA.history.getSpecialKeys());
      return arr.join(",");
    };

    TypingDNA.apu = function (arr, val) {
      "NaN" == String(val) && (val = 0);
      arr.push(val);
    };

    TypingDNA.math = {};

    TypingDNA.math.rd = function (val, dec) {
      return Number(val.toFixed(dec));
    };

    TypingDNA.math.avg = function (arr) {
      var len = arr.length;

      if (len > 0) {
        var sum = 0;

        for (var i = 0; i < len; i++) {
          sum += arr[i];
        }

        return this.rd(sum / len, 4);
      } else {
        return 0;
      }
    };

    TypingDNA.math.sd = function (arr) {
      var len = arr.length;

      if (len < 2) {
        return 0;
      } else {
        var sumVS = 0;
        var mean = this.avg(arr);

        for (var i = 0; i < len; i++) {
          sumVS += (arr[i] - mean) * (arr[i] - mean);
        }

        var sd = Math.sqrt(sumVS / len);
        return sd;
      }
    };

    TypingDNA.math.fo = function (arr) {
      if (arr.length > 1) {
        var values = (0, _concat.default)(arr).call(arr);
        var len = arr.length;
        (0, _sort.default)(values).call(values, function (a, b) {
          return a - b;
        });
        var asd = this.sd(values);
        var aMean = values[Math.ceil(arr.length / 2)];
        var multiplier = 2;
        var maxVal = aMean + multiplier * asd;
        var minVal = aMean - multiplier * asd;

        if (len < 20) {
          minVal = 0;
        }

        var fVal = [];

        for (var i = 0; i < len; i++) {
          var tempval = values[i];

          if (tempval < maxVal && tempval > minVal) {
            fVal.push(tempval);
          }
        }

        return fVal;
      } else {
        return arr;
      }
    }; // Calculate a 32 bit FNV-1a hash


    TypingDNA.math.fnv1aHash = function (str) {
      if (str == undefined && typeof str !== 'string') {
        return 0;
      }

      str = str.toLowerCase();
      var i, l;
      var hval = 0x721b5ad4;

      for (i = 0, l = str.length; i < l; i++) {
        hval ^= str.charCodeAt(i);
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
      }

      return hval >>> 0;
    };

    TypingDNA.history = {};
    TypingDNA.history.stack = [];
    TypingDNA.history.stackDiagram = [];

    TypingDNA.history.add = function (arr) {
      this.stack.push(arr);

      if (this.stack.length > TypingDNA.maxHistoryLength) {
        this.stack.shift();
      }
    };

    TypingDNA.history.addDiagram = function (arr) {
      this.stackDiagram.push(arr);
    };

    TypingDNA.history.getDiagram = function (extended, str, textId, targetId, caseSensitive) {
      var caseSensitive = caseSensitive != undefined ? caseSensitive : str == undefined || str == "";
      var returnArr = [];
      var diagramType = extended == true ? 1 : 0;
      var stackDiagram = this.stackDiagram;

      if (targetId != undefined && targetId != "" && stackDiagram.length > 0) {
        stackDiagram = TypingDNA.sliceStackByTargetId(stackDiagram, targetId);

        if (str == undefined || str == "") {
          var element = TypingDNA.document.getElementById(targetId);

          if (element != null) {
            str = element.value;
          }
        }
      } else {
        var targetLength = TypingDNA.targetIds.length;

        if (str == undefined || str == "") {
          if (targetLength > 0) {
            str = "";

            for (var i = 0; i < targetLength; i++) {
              var element = TypingDNA.document.getElementById(TypingDNA.targetIds[i]);

              if (element != null) {
                str += element.value;
              }
            }
          } else {
            if (!extended) {
              console.log("Please use extended pattern OR provide a fixed string param OR use the addTarget method.");
            }
          }
        }
      }

      var missingCount = 0;
      var diagramHistoryLength = stackDiagram.length;
      var strLength = diagramHistoryLength;

      if (typeof str === 'string') {
        strLength = str.length;
      } else if (typeof str === 'number' && str < diagramHistoryLength) {
        strLength = str;
      }

      var returnTextId = 0;

      if (textId != undefined) {
        if (isNaN((0, _parseInt2.default)(textId))) {
          returnTextId = TypingDNA.math.fnv1aHash(textId);
        } else {
          returnTextId = (0, _parseInt2.default)(textId);
        }
      } else {
        if (typeof str === 'string') {
          returnTextId = TypingDNA.math.fnv1aHash(str);
        }
      }

      returnArr.push([TypingDNA.isMobile(), TypingDNA.version, (0, _flags.default)(TypingDNA), diagramType, strLength, returnTextId, TypingDNA.history.getSpecialKeys()]);

      if (str != undefined && str.length > 0 && typeof str === 'string') {
        var strLower = str.toLowerCase();
        var strUpper = str.toUpperCase();
        var lastFoundPos = [];
        var lastPos = 0;
        var strUpperCharCode;
        var currentSensitiveCharCode;

        for (var i = 0; i < str.length; i++) {
          var currentCharCode = str.charCodeAt(i);

          if (!caseSensitive) {
            strUpperCharCode = strUpper.charCodeAt(i);
            currentSensitiveCharCode = strUpperCharCode != currentCharCode ? strUpperCharCode : strLower.charCodeAt(i);
          }

          var startPos = lastPos;
          var finishPos = diagramHistoryLength;
          var found = false;

          while (found == false) {
            for (var j = startPos; j < finishPos; j++) {
              var arr = stackDiagram[j];
              var charCode = arr[3];

              if (charCode == currentCharCode || !caseSensitive && charCode == currentSensitiveCharCode) {
                found = true;

                if (j == lastPos) {
                  lastPos++;
                  lastFoundPos = [];
                } else {
                  lastFoundPos.push(j);
                  var len = lastFoundPos.length;

                  if (len > 1 && lastFoundPos[len - 1] == lastFoundPos[len - 2] + 1) {
                    lastPos = j + 1;
                    lastFoundPos = [];
                  }
                }

                var keyCode = arr[0];
                var seekTime = arr[1];
                var pressTime = arr[2];

                if (extended) {
                  returnArr.push([charCode, seekTime, pressTime, keyCode]);
                } else {
                  returnArr.push([seekTime, pressTime]);
                }

                break;
              }
            }

            if (found == false) {
              if (startPos != 0) {
                startPos = 0;
                finishPos = lastPos;
              } else {
                found = true;

                if (TypingDNA.replaceMissingKeys) {
                  missingCount++;

                  if ((0, _typeof2.default)(TypingDNA.savedMissingAvgValues) !== 'object' || TypingDNA.savedMissingAvgValues.historyLength != diagramHistoryLength) {
                    var histSktF = TypingDNA.math.fo(TypingDNA.history.get(0, "seek"));
                    var histPrtF = TypingDNA.math.fo(TypingDNA.history.get(0, "press"));
                    var seekTime = Math.round(TypingDNA.math.avg(histSktF));
                    var pressTime = Math.round(TypingDNA.math.avg(histPrtF));
                    TypingDNA.savedMissingAvgValues = {
                      seekTime: seekTime,
                      pressTime: pressTime,
                      historyLength: diagramHistoryLength
                    };
                  } else {
                    var seekTime = TypingDNA.savedMissingAvgValues.seekTime;
                    var pressTime = TypingDNA.savedMissingAvgValues.pressTime;
                  }

                  var missing = 1;

                  if (extended) {
                    returnArr.push([currentCharCode, seekTime, pressTime, currentCharCode, missing]);
                  } else {
                    returnArr.push([seekTime, pressTime, missing]);
                  }

                  break;
                }
              }
            }
          }

          if (TypingDNA.replaceMissingKeysPerc < missingCount * 100 / strLength) {
            return null;
          }
        }
      } else {
        var startCount = 0;

        if (typeof str === 'number') {
          startCount = diagramHistoryLength - str;
        }

        if (startCount < 0) {
          startCount = 0;
        }

        for (var i = startCount; i < diagramHistoryLength; i++) {
          var arr = stackDiagram[i];
          var keyCode = arr[0];
          var seekTime = arr[1];
          var pressTime = arr[2];

          if (extended) {
            var charCode = arr[3];
            returnArr.push([charCode, seekTime, pressTime, keyCode]);
          } else {
            returnArr.push([seekTime, pressTime]);
          }
        }
      }

      return returnArr.join("|");
    };

    TypingDNA.sliceStackByTargetId = function (stack, targetId) {
      var length = stack.length;
      var newStack = [];

      for (i = 0; i < length; i++) {
        var arr = stack[i];

        if (arr[5] == targetId) {
          newStack.push(arr);
        }
      }

      return newStack;
    };

    TypingDNA.history.get = function (length, type, targetId) {
      var stack = this.stack;

      if (targetId != undefined && targetId != "" && stack.length > 0) {
        stack = TypingDNA.sliceStackByTargetId(stack, targetId);
      }

      var historyTotalLength = stack.length;

      if (length == 0 || length == undefined) {
        length = TypingDNA.defaultHistoryLength;
      }

      if (length > historyTotalLength) {
        length = historyTotalLength;
      }

      switch (type) {
        case "seek":
          var seekArr = [];

          for (i = 1; i <= length; i++) {
            var seekTime = stack[historyTotalLength - i][1];

            if (seekTime <= TypingDNA.maxSeekTime) {
              seekArr.push(seekTime);
            }
          }

          ;
          return seekArr;
          break;

        case "press":
          var pressArr = [];

          for (i = 1; i <= length; i++) {
            var pressTime = stack[historyTotalLength - i][2];

            if (pressTime <= TypingDNA.maxPressTime) {
              pressArr.push(pressTime);
            }
          }

          ;
          return pressArr;
          break;

        default:
          var historyStackObj = {};

          for (var i in TypingDNA.keyCodes) {
            historyStackObj[TypingDNA.keyCodes[i]] = [[], [], []];
          }

          for (i = 1; i <= length; i++) {
            var arr = stack[historyTotalLength - i];
            var keyCode = arr[0];
            var seekTime = arr[1];
            var pressTime = arr[2];
            var prevKeyCode = arr[3];

            if (TypingDNA.keyCodesObj[keyCode]) {
              if (seekTime <= TypingDNA.maxSeekTime) {
                historyStackObj[keyCode][0].push(seekTime);

                if (prevKeyCode != 0 && TypingDNA.keyCodesObj[prevKeyCode]) {
                  historyStackObj[prevKeyCode][2].push(seekTime);
                }
              }

              if (pressTime <= TypingDNA.maxPressTime) {
                historyStackObj[keyCode][1].push(pressTime);
              }
            }
          }

          ;
          return [historyStackObj, length];
      }
    };

    TypingDNA.history.getSpecialKeys = function () {
      var returnArr = [];
      var length = this.stack.length;
      var historyStackObj = {};

      for (var i in TypingDNA.spKeyCodes) {
        historyStackObj[TypingDNA.spKeyCodes[i]] = [[]];
      }

      for (i = 1; i <= length; i++) {
        var arr = this.stack[length - i];

        if (TypingDNA.spKeyCodesObj[arr[0]]) {
          var keyCode = arr[0];
          var pressTime = arr[2];

          if (pressTime <= TypingDNA.maxPressTime) {
            historyStackObj[keyCode][0].push(pressTime);
          }
        }
      }

      for (var i in TypingDNA.spKeyCodes) {
        var arr = TypingDNA.math.fo(historyStackObj[TypingDNA.spKeyCodes[i]][0]);
        var arrLen = arr.length;
        returnArr.push(arrLen);

        if (arrLen > 1) {
          returnArr.push(Math.round(TypingDNA.math.avg(arr)));
          returnArr.push(Math.round(TypingDNA.math.sd(arr)));
        } else if (arrLen == 1) {
          returnArr.push([arr[0], -1]);
        } else {
          returnArr.push([-1, -1]);
        }
      }

      var clicksArrLen = TypingDNA.clickTimes.length;
      returnArr.push(clicksArrLen);

      if (clicksArrLen > 1) {
        returnArr.push(Math.round(TypingDNA.math.avg(TypingDNA.clickTimes)));
        returnArr.push(Math.round(TypingDNA.math.sd(TypingDNA.clickTimes)));
      } else if (clicksArrLen == 1) {
        returnArr.push(TypingDNA.clickTimes[0], -1);
      } else {
        returnArr.push([-1, -1]);
      }

      var stopArrLen = TypingDNA.stopTimes.length;
      returnArr.push(stopArrLen);

      if (stopArrLen > 1) {
        returnArr.push(Math.round(TypingDNA.math.avg(TypingDNA.stopTimes)));
        returnArr.push(Math.round(TypingDNA.math.sd(TypingDNA.stopTimes)));
      } else if (stopArrLen == 1) {
        returnArr.push(TypingDNA.stopTimes[0], -1);
      } else {
        returnArr.push([-1, -1]);
      }

      return returnArr;
    };
    /**
     * Checks the quality of a typing pattern, how well it is revelated, how useful the
     * information will be for matching applications. It returns a value between 0 and 1.
     * Values over 0.3 are acceptable, however a value over 0.7 shows good pattern strength.
     * @param  {String} typingPattern The typing pattern string returned by the get() function.
     * @return {Number} A real number between 0 and 1. A close to 1 value means a stronger pattern.
     * @example var quality = tdna.getQuality(typingPattern);
     */


    TypingDNA.getQuality = function (typingPattern) {
      var obj = typingPattern.split(",");

      for (i = 0; i < obj.length; i++) {
        obj[i] = Number(obj[i]);
      }

      var totalEvents = obj[0];
      var acc = rec = avgAcc = 0;
      var avg = TypingDNA.math.avg(obj);
      var revs = (0, _slice.default)(obj).call(obj, 11, 55);

      for (var i in revs) {
        rec += Number(revs[i] > 0);
        acc += Number(revs[i] > 4);
        avgAcc += Number(revs[i] > avg);
      }

      var tReturn = Math.sqrt(rec * acc * avgAcc) / 80;
      return tReturn > 1 ? 1 : tReturn;
    };
    /**
     * Checks the validity of a typing pattern if recorded on mobile.
     * @param  {String} typingPattern The typing pattern string returned by the get() function.
     * @return {Number} A real number between 0 and 1. A number larger than 0.7 usually means a valid pattern.
     * @example var quality = tdna.checkMobileValidity(typingPattern);
     */


    TypingDNA.checkMobileValidity = function (typingPattern) {
      var obj = typingPattern.split(",");
      var totalEvents = obj[0];

      if (totalEvents == 0) {
        return 0;
      }

      var rec = 0;
      var revs = (0, _slice.default)(obj).call(obj, 11, 55);

      for (var i in revs) {
        rec += Number(revs[i]);
      }

      return rec / totalEvents;
    };

    TypingDNA.getLength = function (typingPattern) {
      return Number(typingPattern.split(",")[1]);
    };

    TypingDNA.isMobile = function () {
      if (TypingDNA.mobile != undefined) {
        return TypingDNA.mobile;
      } else {
        var check = 0;

        (function (a) {
          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = 1;
          }
        })(navigator.userAgent || navigator.vendor || window.opera);

        TypingDNA.mobile = check;
        return check;
      }
    };

    TypingDNA.getTextId = function (str) {
      return TypingDNA.math.fnv1aHash(str);
    };
  } else {
    // TypingDNA is a static class, currently doesn't support actual multiple instances (Singleton implementation)
    return TypingDNA.instance;
  }
};

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(771);

module.exports = parent;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var sort = __webpack_require__(772);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.sort;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.sort) ? sort : own;
};


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(773);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').sort;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var aFunction = __webpack_require__(60);
var toObject = __webpack_require__(52);
var fails = __webpack_require__(20);
var arrayMethodIsStrict = __webpack_require__(108);

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD;

// `Array.prototype.sort` method
// https://tc39.github.io/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? nativeSort.call(toObject(this))
      : nativeSort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"content-container\"><span class=\"registration-label\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "label",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 64
            },
            "end": {
              "line": 1,
              "column": 73
            }
          }
        }) : helper)) + "</span><a title=\"" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "text",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 90
            },
            "end": {
              "line": 1,
              "column": 98
            }
          }
        }) : helper)) + "\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "text",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 112
            },
            "end": {
              "line": 1,
              "column": 120
            }
          }
        }) : helper)) + "\" class=\"registration-link\" href=\"#\">" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "text",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 157
            },
            "end": {
              "line": 1,
              "column": 165
            }
          }
        }) : helper)) + "</a></div>";
      },
      "useData": true
    }),
    className: 'registration-container',
    events: {
      'click a.registration-link': 'handleClickEvent'
    },
    handleClickEvent: function handleClickEvent(e) {
      e.preventDefault();
      var clickHandler = this.settings.get('registration.click');

      if (clickHandler) {
        clickHandler();
      } else if (this.options.appState.get('isIdxStateToken')) {
        this.options.appState.trigger('navigate', 'signin/enroll-user');
      } else {
        this.options.appState.trigger('navigate', 'signin/register');
      }
    },
    getTemplateData: function getTemplateData() {
      var templateData = {
        label: Okta.loc('registration.signup.label', 'login'),
        text: Okta.loc('registration.signup.text', 'login')
      };
      return templateData;
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(346)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, PrimaryAuthForm) {
  var _ = Okta._;
  return PrimaryAuthForm.extend({
    className: 'idp-discovery-form',
    save: function save() {
      return Okta.loc('oform.next', 'login');
    },
    saveId: 'idp-discovery-submit',
    initialize: function initialize() {
      this.listenTo(this, 'save', (0, _bind.default)(_).call(_, this.model.save, this.model));
      this.stateEnableChange();
    },
    inputs: function inputs() {
      var inputs = [];
      var usernameProps = {
        className: 'margin-btm-30',
        label: Okta.loc('primaryauth.username.placeholder', 'login'),
        inputId: 'idp-discovery-username',
        disabled: false
      };
      inputs.push(_.extend(this.getUsernameField(), usernameProps));

      if (this.settings.get('features.rememberMe')) {
        inputs.push(this.getRemeberMeCheckbox());
      }

      return inputs;
    },
    focus: function focus() {
      if (!this.model.get('username')) {
        this.getInputs().first().focus();
      } else if (this.getInputs().toArray()[1]) {
        this.getInputs().toArray()[1].focus();
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _includes = _interopRequireDefault(__webpack_require__(166));

var _bind = _interopRequireDefault(__webpack_require__(7));

/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(236), __webpack_require__(237), __webpack_require__(10), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, PrimaryAuthModel, CookieUtil, Enums, Util) {
  var _ = Okta._;
  return PrimaryAuthModel.extend({
    props: function props() {
      var cookieUsername = CookieUtil.getCookieUsername(),
          properties = this.getUsernameAndRemember(cookieUsername);
      return {
        username: ['string', true, properties.username],
        lastUsername: ['string', false, cookieUsername],
        context: ['object', false],
        remember: ['boolean', true, properties.remember]
      };
    },
    local: {},
    save: function save() {
      var username = this.settings.transformUsername(this.get('username'), Enums.IDP_DISCOVERY),
          remember = this.get('remember'),
          lastUsername = this.get('lastUsername'),
          resource = 'okta:acct:' + username,
          requestContext = this.get('requestContext');
      this.setUsernameCookie(username, remember, lastUsername); //the 'save' event here is triggered and used in the BaseLoginController
      //to disable the primary button

      this.trigger('save');
      this.appState.trigger('loading', true);
      var webfingerArgs = {
        resource: resource,
        requestContext: requestContext
      };
      var authClient = this.appState.settings.authClient;
      authClient.webfinger(webfingerArgs).then((0, _bind.default)(_).call(_, function (res) {
        if (res && res.links && res.links[0]) {
          if (res.links[0].properties['okta:idp:type'] === 'OKTA') {
            this.trigger('goToPrimaryAuth');
          } else if (res.links[0].href) {
            var _context, _context2;

            //override redirectFn to only use Util.redirectWithFormGet if OKTA_INVALID_SESSION_REPOST is included
            //it will be encoded since it will be included in the encoded fromURI
            var redirectFn = (0, _includes.default)(_context = res.links[0].href).call(_context, 'OKTA_INVALID_SESSION_REPOST%3Dtrue') ? (0, _bind.default)(_context2 = Util.redirectWithFormGet).call(_context2, Util) : this.settings.get('redirectUtilFn');
            redirectFn(res.links[0].href);
          }
        }
      }, this)).catch((0, _bind.default)(_).call(_, function () {
        this.trigger('error'); // Specific event handled by the Header for the case where the security image is not
        // enabled and we want to show a spinner. (Triggered only here and handled only by Header).

        this.appState.trigger('removeLoading');
        CookieUtil.removeUsernameCookie();
      }, this)).finally((0, _bind.default)(_).call(_, function () {
        this.appState.trigger('loading', false);
      }, this));
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint camelcase: 0 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(349), __webpack_require__(36), __webpack_require__(32), __webpack_require__(6), __webpack_require__(10), __webpack_require__(8), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Duo, Q, FactorUtil, FormController, Enums, FormType, FooterSignout) {
  var $ = Okta.$,
      _ = Okta._;
  return FormController.extend({
    className: 'mfa-verify-duo duo-form',
    Model: {
      props: {
        host: 'string',
        signature: 'string',
        postAction: 'string',
        factorId: 'string',
        stateToken: 'string',
        rememberDevice: 'boolean'
      },
      initialize: function initialize() {
        var rememberDevice = FactorUtil.getRememberDeviceValue(this.appState); // set the initial value for remember device (Cannot do this while defining the
        // local property because this.settings would not be initialized there yet).

        this.set('rememberDevice', rememberDevice);
      },
      getInitOptions: function getInitOptions() {
        var rememberDevice = !!this.get('rememberDevice');
        return this.doTransaction(function (transaction) {
          var data = {
            rememberDevice: rememberDevice
          };

          var factor = _.findWhere(transaction.factors, {
            provider: 'DUO',
            factorType: 'web'
          });

          return factor.verify(data).catch(function (err) {
            // Clean up the cookie on failure.
            throw err;
          });
        }, true
        /* rethrow errors */
        );
      },
      verify: function verify(signedResponse) {
        // Note: We should be doing this in OktaAuth! Fix when it's updated.
        var url = this.get('postAction'),
            factorId = this.get('factorId'),
            self = this,
            data = {
          id: factorId,
          stateToken: this.get('stateToken'),
          sig_response: signedResponse
        }; // We don't actually use authClient.post() here (unlike all the other cases in the
        // sign-in widget) since the endpoint is wired to accept serialized form post instead
        // of a JSON post ($.post() is different from authClient.post() in that in $.post(),
        // jquery decides the Content-Type instead of it being a JSON type). Enroll/Verify DUO
        // are the only two places where we actually do this.
        // NOTE - If we ever decide to change this, we should test this very carefully.

        var rememberDevice = this.get('rememberDevice');
        return Q($.post(url, data)).then(function () {
          return self.doTransaction(function (transaction) {
            var data;

            if (rememberDevice) {
              data = {
                rememberDevice: rememberDevice
              };
            }

            return transaction.poll(data);
          });
        }).catch(function (err) {
          self.trigger('error', self, err.xhr);
        });
      }
    },
    Form: {
      autoSave: true,
      noButtonBar: true,
      title: _.partial(Okta.loc, 'factor.duo'),
      attributes: {
        'data-se': 'factor-duo'
      },
      postRender: function postRender() {
        this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>');

        if (this.options.appState.get('allowRememberDevice')) {
          this.addInput({
            label: false,
            'label-top': true,
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            className: 'margin-btm-0',
            name: 'rememberDevice',
            type: 'checkbox'
          });
        }

        Duo.init({
          'host': this.model.get('host'),
          'sig_request': this.model.get('signature'),
          'iframe': this.$('iframe').get(0),
          'post_action': (0, _bind.default)(_).call(_, this.model.verify, this.model)
        });
      }
    },
    Footer: FooterSignout,
    fetchInitialData: function fetchInitialData() {
      var self = this;
      return this.model.getInitOptions().then(function (trans) {
        var res = trans.data;

        if (!res._embedded || !res._embedded.factor || !res._embedded.factor._embedded || !res._embedded.factor._embedded.verification) {
          throw new Error('Response does not have duo verification options');
        }

        var verification = res._embedded.factor._embedded.verification;
        self.model.set({
          host: verification.host,
          signature: verification.signature,
          postAction: verification._links.complete.href,
          factorId: res._embedded.factor.id,
          stateToken: res.stateToken
        });
      });
    },
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaChallenge')) {
        return true;
      }
    },
    back: function back() {// Empty function on verify controllers to prevent users
      // from navigating back during 'verify' using the browser's
      // back button. The URL will still change, but the view will not
      // More details in OKTA-135060.
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(779);

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(780);

module.exports = parent;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var endsWith = __webpack_require__(781);

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.endsWith;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.endsWith) ? endsWith : own;
};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(782);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('String').endsWith;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var getOwnPropertyDescriptor = __webpack_require__(104).f;
var toLength = __webpack_require__(47);
var notARegExp = __webpack_require__(224);
var requireObjectCoercible = __webpack_require__(107);
var correctIsRegExpLogic = __webpack_require__(225);
var IS_PURE = __webpack_require__(63);

var nativeEndsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = String(searchString);
    return nativeEndsWith
      ? nativeEndsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _stringify = _interopRequireDefault(__webpack_require__(83));

var _regenerator = _interopRequireDefault(__webpack_require__(233));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(321));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8), __webpack_require__(350)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType, FooterWithBackLink) {
  var _ = Okta._,
      $ = Okta.$;
  var Util = Okta.internal.util.Util;
  return FormController.extend({
    className: 'piv-cac-card',
    Model: {
      save: function () {
        var _save = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          var self, pivConfig, data, res;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.trigger('request');
                  self = this, pivConfig = this.settings.get('piv'), data = {
                    fromURI: this.settings.get('relayState'),
                    isCustomDomain: pivConfig.isCustomDomain
                  };
                  _context.prev = 2;
                  _context.next = 5;
                  return this.getCert(pivConfig.certAuthUrl);

                case 5:
                  _context.next = 7;
                  return this.postCert(pivConfig.certAuthUrl, data);

                case 7:
                  res = _context.sent;
                  Util.redirect(res.redirectUrl);
                  _context.next = 15;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](2);

                  if (_.isEmpty(_context.t0.responseJSON) && !_context.t0.responseText) {
                    _context.t0.responseJSON = {
                      errorSummary: Okta.loc('piv.cac.error', 'login')
                    };
                  }

                  self.trigger('error', self, _context.t0);

                case 15:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[2, 11]]);
        }));

        function save() {
          return _save.apply(this, arguments);
        }

        return save;
      }(),
      getCert: function getCert(certAuthUrl) {
        return $.get({
          url: certAuthUrl,
          xhrFields: {
            withCredentials: true
          },
          beforeSend: function beforeSend() {// overriding this function to prevent our jquery-wrapper from
            // setting headers. Need to keep this a simple request in order for
            // PIV / CAC to work in IE.
          }
        });
      },
      postCert: function postCert(certAuthUrl, data) {
        return $.post({
          url: certAuthUrl,
          xhrFields: {
            withCredentials: true
          },
          data: (0, _stringify.default)(data),
          contentType: 'text/plain',
          beforeSend: function beforeSend() {// overriding this function to prevent our jquery-wrapper from
            // setting headers. Need to keep this a simple request in order for
            // PIV / CAC to work in IE.
          }
        });
      }
    },
    Form: {
      autoSave: true,
      hasSavingState: false,
      title: _.partial(Okta.loc, 'piv.cac.title', 'login'),
      className: 'piv-cac-card',
      noCancelButton: true,
      save: _.partial(Okta.loc, 'retry', 'login'),
      modelEvents: {
        'request': '_startEnrollment',
        'error': '_stopEnrollment'
      },
      formChildren: [FormType.View({
        View: Okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return "<div class=\"piv-verify-text\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "piv.cac.card.insert"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 32
                  },
                  "end": {
                    "line": 1,
                    "column": 82
                  }
                }
              })) + "</p><div data-se=\"piv-waiting\" class=\"okta-waiting-spinner\"></div></div>";
            },
            "useData": true
          })
        })
      })],
      _startEnrollment: function _startEnrollment() {
        this.$('.okta-waiting-spinner').show();
        this.$('.o-form-button-bar').hide();
      },
      _stopEnrollment: function _stopEnrollment() {
        this.$('.okta-waiting-spinner').hide();
        this.$('.o-form-button-bar').show();
      },
      postRender: function postRender() {
        var _this = this;

        _.defer(function () {
          _this.model.save();
        });
      }
    },
    back: function back() {// Empty function on verify controllers to prevent users
      // from navigating back during 'verify' using the browser's
      // back button. The URL will still change, but the view will not
      // More details in OKTA-135060.
    },
    Footer: FooterWithBackLink
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 21] max-statements: [2, 25] max-params: 0 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(126), __webpack_require__(785), __webpack_require__(786), __webpack_require__(787), __webpack_require__(788), __webpack_require__(789), __webpack_require__(790), __webpack_require__(792), __webpack_require__(793), __webpack_require__(794), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, BaseLoginController, TOTPForm, YubikeyForm, SecurityQuestionForm, PassCodeForm, EmailMagicLinkForm, PushForm, PasswordForm, InlineTOTPForm, SendEmailAndVerifyCodeForm, FooterSignout) {
  var CheckBox = Okta.internal.views.forms.inputs.CheckBox;
  return BaseLoginController.extend({
    className: 'mfa-verify',
    initialize: function initialize(options) {
      var factorType = options.factorType;
      var View;

      switch (factorType) {
        case 'question':
          View = SecurityQuestionForm;
          break;

        case 'email':
          if (this.options.appState.get('isIdxStateToken')) {
            View = EmailMagicLinkForm;
          } else {
            View = SendEmailAndVerifyCodeForm;
          }

          break;

        case 'sms':
        case 'call':
          View = PassCodeForm;
          break;

        case 'token':
        case 'token:software:totp':
        case 'token:hotp':
          View = TOTPForm;
          break;

        case 'token:hardware':
          View = YubikeyForm;
          break;

        case 'push':
          View = PushForm;
          break;

        case 'password':
          View = PasswordForm;
          break;

        default:
          throw new Error('Unrecognized factor type');
      }

      this.model = this.findModel(factorType, options);

      if (!this.model) {
        // TODO: recover from this more gracefully - probably to redirect
        // to default factor
        throw new Error('Unrecognized factor/provider');
      }

      this.addListeners();
      this.add(new View(this.toJSON())); // If Okta Verify Push and Okta Verify totp are both enabled,
      // then we show Push first, and totp is the "backup" factor,
      // which is rendered in an additional InlineTOTPForm

      if (factorType === 'push' && this.model.get('isOktaFactor')) {
        if (this.model.get('backupFactor')) {
          this.inlineTotpForm = this.add(InlineTOTPForm, {
            options: {
              model: this.model.get('backupFactor')
            }
          }).last();
        }

        if (this.settings.get('features.autoPush')) {
          this.autoPushCheckBox = this.add(CheckBox, {
            options: {
              model: this.model,
              name: 'autoPush',
              placeholder: Okta.loc('autoPush', 'login'),
              label: false,
              'label-top': false,
              className: 'margin-btm-0'
            }
          }).last();
        } // Remember Device checkbox resides outside of the Push and TOTP forms.


        if (this.options.appState.get('allowRememberDevice')) {
          this.rememberDeviceCheckbox = this.add(CheckBox, {
            options: {
              model: this.model,
              name: 'rememberDevice',
              placeholder: this.options.appState.get('rememberDeviceLabel'),
              label: false,
              'label-top': true,
              className: 'margin-btm-0'
            }
          }).last();
        } // Set rememberDevice on the backup factor (totp) if available


        if (this.model.get('backupFactor')) {
          this.listenTo(this.model, 'change:rememberDevice', function (model, rememberDevice) {
            model.get('backupFactor').set('rememberDevice', rememberDevice);
          });
        }
      }

      this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function (state, isWaitingForNumberChallenge) {
        if (isWaitingForNumberChallenge || this.options.appState.get('lastAuthResponse').status === 'SUCCESS') {
          this.autoPushCheckBox && this.autoPushCheckBox.$el.hide();
          this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.hide();
          this.inlineTotpForm && this.inlineTotpForm.$el.hide();
        } else {
          this.autoPushCheckBox && this.autoPushCheckBox.$el.show();
          this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.show();
          this.inlineTotpForm && this.inlineTotpForm.$el.show();
        }
      });

      if (!this.settings.get('features.hideSignOutLinkInMFA')) {
        this.add(new FooterSignout(this.toJSON()));
      }
    },
    findModel: function findModel(factorType, options) {
      var factors = options.appState.get('factors');
      var provider = options.provider;
      var factorIndex = options.factorIndex;

      if (!provider) {
        return factors.findWhere({
          factorType: factorType,
          isFactorTypeVerification: true
        });
      } else if (factors.hasMultipleFactorsOfSameType(factorType) && factorIndex) {
        return factors.getFactorByTypeAndIndex(factorType, factorIndex);
      } else {
        return factors.findWhere({
          provider: provider,
          factorType: factorType
        });
      }
    },
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaRequired') && this.options.appState.get('trapMfaRequiredResponse') || this.options.appState.get('isMfaChallenge')) {
        this.options.appState.set('trapMfaRequiredResponse', false);
        return true;
      }

      return false;
    },
    back: function back() {// Empty function on verify controllers to prevent users
      // from navigating back during 'verify' using the browser's
      // back button. The URL will still change, but the view will not
      // More details in OKTA-135060.
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, TextBox) {
  var _ = Okta._;
  return Okta.Form.extend({
    className: 'mfa-verify-totp',
    autoSave: true,
    noCancelButton: true,
    save: _.partial(Okta.loc, 'mfa.challenge.verify', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    attributes: {
      'data-se': 'factor-totp'
    },
    initialize: function initialize() {
      var factorName = this.model.get('factorLabel');
      var maskPasswordField = this.model.get('provider') === 'RSA' || this.model.get('provider') === 'DEL_OATH';
      this.title = factorName;

      if (this.model.get('isFactorTypeVerification')) {
        this.subtitle = Okta.loc('mfa.challenge.totp.subtitle.multiple', 'login', [factorName]);
      } else {
        this.subtitle = Okta.loc('mfa.challenge.title', 'login', [factorName]);
      }

      this.addInput({
        label: Okta.loc('mfa.challenge.enterCode.placeholder', 'login'),
        'label-top': true,
        className: 'o-form-fieldset o-form-label-top auth-passcode',
        name: 'answer',
        input: TextBox,
        type: maskPasswordField ? 'password' : 'tel'
      });

      if (this.options.appState.get('allowRememberDevice')) {
        this.addInput({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        });
      }

      if (this.model.get('provider') === 'RSA' || this.model.get('provider') === 'DEL_OATH') {
        this.listenTo(this.model, 'error', (0, _bind.default)(_).call(_, function (source, error) {
          if (error && error.status === 409) {
            // 409 means we are in change pin, so we should clear out answer input
            this.$('.auth-passcode input').val('');
            this.$('.auth-passcode input').trigger('change');
            this.$('.auth-passcode input').focus();
          }
        }, this));
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, TextBox) {
  var _ = Okta._;
  return Okta.Form.extend({
    className: 'mfa-verify-yubikey',
    autoSave: true,
    noCancelButton: true,
    save: _.partial(Okta.loc, 'mfa.challenge.verify', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    attributes: {
      'data-se': 'factor-yubikey'
    },
    initialize: function initialize() {
      var factorName = this.model.get('factorLabel');
      this.title = factorName;
      this.subtitle = Okta.loc('factor.totpHard.yubikey.description', 'login');
      this.addInput({
        label: Okta.loc('factor.totpHard.yubikey.placeholder', 'login'),
        'label-top': true,
        className: 'o-form-fieldset o-form-label-top auth-passcode',
        name: 'answer',
        input: TextBox,
        inputId: 'mfa-answer',
        type: 'password'
      });

      if (this.options.appState.get('allowRememberDevice')) {
        this.addInput({
          label: false,
          'label-top': true,
          className: 'margin-btm-0',
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          name: 'rememberDevice',
          type: 'checkbox'
        });
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  var _ = Okta._;
  return Okta.Form.extend({
    className: 'mfa-verify-question',
    autoSave: true,
    noCancelButton: true,
    save: _.partial(Okta.loc, 'mfa.challenge.verify', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    attributes: {
      'data-se': 'factor-question'
    },
    initialize: function initialize() {
      this.title = this.model.get('factorLabel');
      this.addInput({
        label: this.model.get('securityQuestion'),
        'label-top': true,
        placeholder: Okta.loc('mfa.challenge.answer.placeholder', 'login'),
        className: 'auth-passcode',
        name: 'answer',
        type: 'password',
        params: {
          showPasswordToggle: true
        }
      });

      if (this.options.appState.get('allowRememberDevice')) {
        this.addInput({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        });
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _runtime = _interopRequireDefault(__webpack_require__(4));

/* eslint complexity: [2, 7] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(36), __webpack_require__(26), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Q, TextBox, Enums) {
  var subtitleTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "(" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "subtitle",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1
          },
          "end": {
            "line": 1,
            "column": 13
          }
        }
      }) : helper)) + ")";
    },
    "useData": true
  });

  var _ = Okta._;
  var warningTemplate = Okta.View.extend({
    className: 'okta-form-infobox-warning infobox infobox-warning login-timeout-warning',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"icon warning-16\"></span><p>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "warning",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 40
            },
            "end": {
              "line": 1,
              "column": 53
            }
          }
        }) : helper)) != null ? stack1 : "") + "</p>";
      },
      "useData": true
    })
  });

  function getFormAndButtonDetails(factorType) {
    switch (factorType) {
      case 'sms':
        return {
          buttonDataSe: 'sms-send-code',
          buttonClassName: 'sms-request-button',
          formSubmit: Okta.loc('mfa.sendCode', 'login'),
          formRetry: Okta.loc('mfa.resendCode', 'login'),
          formSubmitted: Okta.loc('mfa.sent', 'login'),
          subtitle: subtitleTpl({
            subtitle: this.model.get('phoneNumber')
          }),
          warning: Okta.loc('factor.sms.time.warning', 'login')
        };

      case 'call':
        return {
          buttonDataSe: 'make-call',
          buttonClassName: 'call-request-button',
          formSubmit: Okta.loc('mfa.call', 'login'),
          formRetry: Okta.loc('mfa.redial', 'login'),
          formSubmitted: Okta.loc('mfa.calling', 'login'),
          subtitle: subtitleTpl({
            subtitle: this.model.get('phoneNumber')
          }),
          warning: Okta.loc('factor.call.time.warning', 'login')
        };

      case 'email':
        return {
          buttonDataSe: 'email-send-code',
          buttonClassName: 'email-request-button',
          formSubmit: Okta.loc('mfa.sendEmail', 'login'),
          formRetry: Okta.loc('mfa.resendEmail', 'login'),
          formSubmitted: Okta.loc('mfa.sent', 'login'),
          subtitle: subtitleTpl({
            subtitle: this.model.get('email')
          })
        };

      default:
        return {
          buttonDataSe: '',
          buttonClassName: '',
          formSubmit: '',
          formRetry: '',
          formSubmitted: ''
        };
    }
  }

  return Okta.Form.extend({
    className: 'mfa-verify-passcode',
    autoSave: true,
    noCancelButton: true,
    save: _.partial(Okta.loc, 'mfa.challenge.verify', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    disableSubmitButton: function disableSubmitButton() {
      return this.model.appState.get('isMfaChallenge') && this.model.get('answer');
    },
    showWarning: function showWarning(msg) {
      this.clearWarnings();
      this.add(warningTemplate, '.o-form-error-container', {
        options: {
          warning: msg
        }
      });
    },
    clearWarnings: function clearWarnings() {
      this.$('.okta-form-infobox-warning').remove();
    },
    initialize: function initialize() {
      var form = this;
      this.title = this.model.get('factorLabel');
      var factorType = this.model.get('factorType');
      var formAndButtonDetails = getFormAndButtonDetails.call(this, factorType);
      var warningDetails = formAndButtonDetails.warning;
      this.$el.attr('data-se', 'factor-' + factorType);
      this.subtitle = formAndButtonDetails.subtitle;
      this.listenTo(this.model, 'error', function () {
        this.clearErrors();
      });
      this.addInput({
        label: Okta.loc('mfa.challenge.enterCode.placeholder', 'login'),
        'label-top': true,
        className: 'o-form-fieldset o-form-label-top auth-passcode',
        name: 'answer',
        input: TextBox,
        type: 'tel'
      });
      this.add(Okta.createButton({
        attributes: {
          'data-se': formAndButtonDetails.buttonDataSe
        },
        className: 'button ' + formAndButtonDetails.buttonClassName,
        title: formAndButtonDetails.formSubmit,
        click: function click() {
          form.clearErrors();
          this.disable();
          form.clearWarnings();
          this.options.title = formAndButtonDetails.formSubmitted;
          this.render(); // To send an OTP to the device, make the same request but use
          // an empty passCode

          this.model.set('answer', '');
          this.model.save().then(function () {
            // render and focus on the passcode input field.
            form.getInputs().first().render().focus();
            return Q.delay(Enums.API_RATE_LIMIT);
          }).then((0, _bind.default)(_).call(_, function () {
            this.options.title = formAndButtonDetails.formRetry;
            this.enable();

            if (factorType === 'call' || factorType === 'sms') {
              form.showWarning(warningDetails);
            }

            this.render();
          }, this));
        }
      }));

      if (this.options.appState.get('allowRememberDevice')) {
        this.addInput({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        });
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 7] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(36), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Q, Enums) {
  var _ = Okta._;
  return Okta.Form.extend({
    layout: 'o-form-theme',
    className: 'factor-verify-magiclink',
    autoSave: true,
    noCancelButton: true,
    initialize: function initialize() {
      // for FACTOR_REQUIRED with email magic link we dont need to show otp code input field and verify button
      var form = this;
      this.title = this.model.get('factorLabel'); //TODO: OKTA-211618 Temp fix for demo. FACTOR_REQUIRED after sign up is missing the profile object in API response

      var email = this.model.get('email') || this.options.appState.get('lastAuthResponse')._embedded.user.profile.login;

      this.subtitle = '(' + email + ')';
      this.add(Okta.createButton({
        attributes: {
          'data-se': 'email-send-code'
        },
        className: 'button email-request-button',
        title: Okta.loc('mfa.sendEmail', 'login'),
        click: function click() {
          form.clearErrors();
          this.disable();
          this.options.title = Okta.loc('mfa.sent', 'login');
          this.render();
          this.model.save().then((0, _bind.default)(_).call(_, function () {
            return Q.delay(Enums.API_RATE_LIMIT);
          }, this)).then((0, _bind.default)(_).call(_, function () {
            this.options.title = Okta.loc('mfa.resendEmail', 'login');
            this.enable();
            this.render();
          }, this));
        }
      }));
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _find = _interopRequireDefault(__webpack_require__(18));

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(237), __webpack_require__(24), __webpack_require__(791)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, CookieUtil, Util, NumberChallengeView) {
  var _ = Okta._; // deviceName is escaped on BaseForm (see BaseForm's template)

  var titleTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorName") || (depth0 != null ? lookupProperty(depth0, "factorName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "factorName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 14
          }
        }
      }) : helper)) + " (" + ((stack1 = (helper = (helper = lookupProperty(helpers, "deviceName") || (depth0 != null ? lookupProperty(depth0, "deviceName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "deviceName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 16
          },
          "end": {
            "line": 1,
            "column": 32
          }
        }
      }) : helper)) != null ? stack1 : "") + ")";
    },
    "useData": true
  });

  var WARNING_TIMEOUT = 30000; //milliseconds

  var warningTemplate = Okta.View.extend({
    className: 'okta-form-infobox-warning infobox infobox-warning',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"icon warning-16\"></span><p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "warning",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 40
            },
            "end": {
              "line": 1,
              "column": 51
            }
          }
        }) : helper)) + "</p>";
      },
      "useData": true
    })
  });
  return Okta.Form.extend({
    className: 'mfa-verify-push',
    autoSave: true,
    noCancelButton: true,
    save: _.partial(Okta.loc, 'oktaverify.send', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    attributes: {
      'data-se': 'factor-push'
    },
    events: {
      submit: 'submit'
    },
    initialize: function initialize() {
      this.enabled = true;
      this.listenTo(this.options.appState, 'change:isMfaRejected', this.handleRejectStateChange);
      this.numberChallengeView = this.add(NumberChallengeView).last();
      this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function (state, isWaitingForNumberChallenge) {
        if (isWaitingForNumberChallenge || this.options.appState.get('lastAuthResponse').status === 'SUCCESS') {
          var _context;

          this.clearWarnings();
          (0, _find.default)(_context = this.$el).call(_context, '.button').hide();
          this.numberChallengeView.$el.show();
        } else {
          var _context2;

          this.numberChallengeView.$el.hide();
          (0, _find.default)(_context2 = this.$el).call(_context2, '.button').show();
        }
      });
      this.listenTo(this.options.appState, 'change:isMfaTimeout', function (state, isMfaTimeout) {
        this.setSubmitState(isMfaTimeout);

        if (isMfaTimeout) {
          this.showError(Okta.loc('oktaverify.timeout', 'login'));
        }
      });
      this.listenTo(this.options.appState, 'change:isMfaRequired', function (state, isMfaRequired) {
        if (isMfaRequired) {
          this.clearErrors();
          this.clearWarnings();
        }
      });
      this.title = titleTpl({
        factorName: this.model.get('factorLabel'),
        deviceName: this.model.get('deviceName')
      });
    },
    setSubmitState: function setSubmitState(ableToSubmit) {
      var _context3;

      var button = (0, _find.default)(_context3 = this.$el).call(_context3, '.button');
      this.enabled = ableToSubmit;

      if (ableToSubmit) {
        button.removeClass('link-button-disabled');
        button.prop('value', Okta.loc('oktaverify.send', 'login'));
        button.prop('disabled', false);
      } else {
        button.addClass('link-button-disabled');
        button.prop('value', Okta.loc('oktaverify.sent', 'login'));
        button.prop('disabled', true);
      }
    },
    submit: function submit(e) {
      if (e !== undefined) {
        e.preventDefault();
      }

      if (this.enabled) {
        this.setSubmitState(false);
        this.doSave();
      }
    },
    postRender: function postRender() {
      var factorsPolicyInfo = this.options.appState.get('factorsPolicyInfo');
      var id = this.model.get('id');
      var isAutoPushEnabled = this.settings.get('features.autoPush') && factorsPolicyInfo && factorsPolicyInfo[id] ? factorsPolicyInfo[id]['autoPushEnabled'] : false;

      if (isAutoPushEnabled) {
        this.model.set('autoPush', true); // bind after $el has been rendered, and trigger push once DOM is fully loaded

        _.defer((0, _bind.default)(_).call(_, this.submit, this));
      }
    },
    doSave: function doSave() {
      var warningTimeout;
      this.clearErrors();
      this.clearWarnings();

      if (this.model.isValid()) {
        this.listenToOnce(this.model, 'error', function () {
          this.setSubmitState(true);
          this.clearWarnings();
          clearTimeout(warningTimeout);
        });
        this.trigger('save', this.model);
        warningTimeout = Util.callAfterTimeout((0, _bind.default)(_).call(_, function () {
          if (!this.options.appState.get('isWaitingForNumberChallenge')) {
            this.showWarning(Okta.loc('oktaverify.warning', 'login'));
          }
        }, this), WARNING_TIMEOUT);
      }
    },
    showError: function showError(msg) {
      this.clearWarnings();
      this.model.trigger('error', this.model, {
        responseJSON: {
          errorSummary: msg
        }
      });
    },
    showWarning: function showWarning(msg) {
      this.clearWarnings();
      this.add(warningTemplate, '.o-form-error-container', {
        options: {
          warning: msg
        }
      });
    },
    clearWarnings: function clearWarnings() {
      this.$('.okta-form-infobox-warning').remove();
    },
    handleRejectStateChange: function handleRejectStateChange(state, isMfaRejected) {
      if (isMfaRejected) {
        this.setSubmitState(isMfaRejected);
        this.setRejectedErrorMessage();
      }
    },
    setRejectedErrorMessage: function setRejectedErrorMessage() {
      // If rejection is due to outdated app, show error message per platform
      // else show user rejected message.
      if (this.options.appState.get('lastAuthResponse').factorResultMessage === 'OKTA_VERIFY_UPGRADE_REQUIRED') {
        if (this.options.appState.get('factor').profile.platform === 'IOS') {
          this.showError(Okta.loc('oktaverify.rejected.upgradeRequired.ios', 'login'));
        } else {
          this.showError(Okta.loc('oktaverify.rejected.upgradeRequired.android', 'login'));
        }
      } else {
        this.showError(Okta.loc('oktaverify.rejected', 'login'));
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  return Okta.View.extend({
    className: 'number-challenge-view',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<p data-se=\"number-challenge-instruction\">" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "arguments": "number",
            "bundle": "login",
            "code": "oktaverify.numberchallenge.instruction"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 42
            },
            "end": {
              "line": 1,
              "column": 132
            }
          }
        })) != null ? stack1 : "") + "</p><div class=\"phone\"><div class=\"phone--body\"><div class=\"phone--screen\"><span class=\"phone--number\" data-se=\"challenge-number\">" + alias3((helper = (helper = lookupProperty(helpers, "number") || (depth0 != null ? lookupProperty(depth0, "number") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
          "name": "number",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 262
            },
            "end": {
              "line": 1,
              "column": 272
            }
          }
        }) : helper)) + "</span></div><div class=\"phone--home-button\"></div></div></div><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "oktaverify.numberchallenge.explain"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 338
            },
            "end": {
              "line": 1,
              "column": 403
            }
          }
        })) + "</p>";
      },
      "useData": true
    }),
    initialize: function initialize() {
      var _this = this;

      this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function () {
        if (_this.options.appState.get('lastAuthResponse').status !== 'SUCCESS') {
          _this.render();
        }
      });
    },
    getTemplateData: function getTemplateData() {
      var lastAuthResponse = this.options.appState.get('lastAuthResponse');

      if (!this.options.appState.get('isWaitingForNumberChallenge')) {
        return {
          number: null
        };
      }

      return {
        number: lastAuthResponse._embedded.factor._embedded.challenge.correctAnswer
      };
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2016-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  var _ = Okta._;
  return Okta.Form.extend({
    className: 'mfa-verify-password',
    autoSave: true,
    noCancelButton: true,
    save: _.partial(Okta.loc, 'mfa.challenge.verify', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    attributes: {
      'data-se': 'factor-password'
    },
    initialize: function initialize() {
      this.title = this.model.get('factorLabel');
      this.addInput({
        label: Okta.loc('mfa.challenge.password.placeholder', 'login'),
        'label-top': true,
        className: 'auth-passcode',
        name: 'password',
        type: 'password',
        params: {
          showPasswordToggle: true
        }
      });

      if (this.options.appState.get('allowRememberDevice')) {
        this.addInput({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        });
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, TextBox) {
  function addInlineTotp(form) {
    form.addDivider();
    form.addInput({
      label: Okta.loc('mfa.challenge.enterCode.placeholder', 'login'),
      'label-top': true,
      className: 'o-form-fieldset o-form-label-top inline-input auth-passcode',
      name: 'answer',
      input: TextBox,
      type: 'tel'
    });
    form.add(Okta.createButton({
      attributes: {
        'data-se': 'inline-totp-verify'
      },
      className: 'button inline-totp-verify margin-top-30',
      title: Okta.loc('mfa.challenge.verify', 'login'),
      click: function click() {
        form.clearErrors();

        if (!form.isValid()) {
          return;
        }

        form.model.manageTransaction(function (transaction, setTransaction) {
          // This is the case where we enter the TOTP code and verify while there is an
          // active Push request (or polling) running. We need to invoke previous() on authClient
          // and then call model.save(). If not, we would still be in MFA_CHALLENGE state and
          // verify would result in a wrong request (push verify instead of a TOTP verify).
          if (transaction.status === 'MFA_CHALLENGE' && transaction.prev) {
            form.options.appState.set('trapMfaRequiredResponse', true);
            return transaction.prev().then(function (trans) {
              setTransaction(trans);
              form.model.save();
            });
          } else {
            // Push is not active and we enter the code to verify.
            form.model.save();
          }
        });
      }
    }));
    form.at(1).focus();
  }

  return Okta.Form.extend({
    autoSave: true,
    noButtonBar: true,
    scrollOnError: false,
    layout: 'o-form-theme',
    className: 'mfa-verify-totp-inline',
    attributes: {
      'data-se': 'factor-inline-totp'
    },
    initialize: function initialize() {
      var form = this;
      this.listenTo(this.model, 'error', function () {
        this.clearErrors();
      });
      this.add(Okta.createButton({
        className: 'link',
        attributes: {
          'data-se': 'inline-totp-add'
        },
        title: Okta.loc('mfa.challenge.orEnterCode', 'login'),
        click: function click() {
          this.remove();
          addInlineTotp(form);
        }
      }));
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(26), __webpack_require__(351)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, TextBox, ResendEmailView) {
  var _ = Okta._;

  var createEmailMaskElement = function createEmailMaskElement() {
    var email = this.model.get('email');

    var emailTpl = _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"mask-email\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "email",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 25
            },
            "end": {
              "line": 1,
              "column": 34
            }
          }
        }) : helper)) + "</span>";
      },
      "useData": true
    });

    return {
      factorEmail: emailTpl({
        email: email
      })
    };
  };

  var VerifyEmailCodeForm = Okta.Form.extend({
    layout: 'o-form-theme',
    className: 'mfa-verify-email',
    title: _.partial(Okta.loc, 'email.mfa.title', 'login'),
    noButtonBar: false,
    autoSave: true,
    noCancelButton: true,
    attributes: {
      'data-se': 'factor-email'
    },
    save: function save() {
      return this.options.appState.get('isMfaChallenge') ? Okta.loc('mfa.challenge.verify', 'login') : Okta.loc('email.button.send', 'login');
    },
    events: (0, _assign.default)({}, Okta.Form.prototype.events, {
      submit: function submit(e) {
        e.preventDefault();
        this.handleSubmit();
      }
    }),
    handleSubmit: function handleSubmit() {
      this.clearErrors();

      if (this.options.appState.get('isMfaChallenge')) {
        if (this.isValid()) {
          this.model.save();
        }
      } else {
        var _context;

        // Send email and switch to verification view
        this.model.set('answer', '');
        this.model.save().then((0, _bind.default)(_context = this.renderChallengView).call(_context, this));
      }
    },
    initialize: function initialize() {
      Okta.Form.prototype.initialize.apply(this, arguments); //Added thorttle to prevent keyboard enter trigger multipele API calls

      this.handleSubmit = _.throttle(this.handleSubmit, 100, {
        leading: false
      }); // render 'Send Email' page at first place

      this.add(Okta.View.extend({
        attributes: {
          'data-se': 'mfa-send-email-content'
        },
        className: 'mfa-send-email-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var stack1,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "arguments": "factorEmail",
                "bundle": "login",
                "code": "email.mfa.description"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 78
                }
              }
            })) != null ? stack1 : "";
          },
          "useData": true
        }),
        getTemplateData: createEmailMaskElement
      }));
    },
    renderChallengView: function renderChallengView() {
      this.removeChildren();
      this.add(Okta.View.extend({
        className: 'mfa-email-sent-content',
        attributes: {
          'data-se': 'mfa-email-sent-content'
        },
        // Why use `{{{` for the description?
        // - factorEmail is actually an HTML fragment which
        //   is created via another handlebar template and used for bold the email address.
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var stack1,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "arguments": "factorEmail",
                "bundle": "login",
                "code": "email.mfa.email.sent.description"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 89
                }
              }
            })) != null ? stack1 : "";
          },
          "useData": true
        }),
        getTemplateData: createEmailMaskElement
      }));
      this.add(ResendEmailView);
      this.addInput({
        label: Okta.loc('email.code.label', 'login'),
        'label-top': true,
        name: 'answer',
        input: TextBox,
        wide: true,
        type: 'tel'
      });

      if (this.options.appState.get('allowRememberDevice')) {
        this.addInput({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        });
      }

      this.render();
    }
  });
  return VerifyEmailCodeForm;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8), __webpack_require__(113), __webpack_require__(354), __webpack_require__(84), __webpack_require__(85)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType, webauthn, Spinner, FooterSignout, HtmlErrorMessageView) {
  var _ = Okta._;
  return FormController.extend({
    className: 'mfa-verify verify-windows-hello',
    Model: {
      local: {
        __autoTriggered__: 'boolean'
      },
      save: function save() {
        if (!webauthn.isAvailable()) {
          return;
        }

        this.trigger('request');
        var model = this;
        return this.doTransaction(function (transaction) {
          var factor = _.findWhere(transaction.factors, {
            factorType: 'webauthn',
            provider: 'FIDO'
          });

          return factor.verify().then(function (verifyData) {
            var factorData = verifyData.factor;
            return webauthn.getAssertion(factorData.challenge.nonce, [{
              id: factorData.profile.credentialId
            }]).then(function (assertion) {
              return factor.verify({
                authenticatorData: assertion.authenticatorData,
                clientData: assertion.clientData,
                signatureData: assertion.signature
              });
            }).then(function (data) {
              model.trigger('sync');
              model.trigger('signIn');
              return data;
            }).catch(function (error) {
              switch (error.message) {
                case 'AbortError':
                case 'NotFoundError':
                case 'NotSupportedError':
                  model.trigger('abort', error.message);
                  return transaction;
              }

              throw error;
            });
          });
        });
      }
    },
    Form: {
      autoSave: true,
      hasSavingState: false,
      title: _.partial(Okta.loc, 'factor.windowsHello', 'login'),
      subtitle: function subtitle() {
        return webauthn.isAvailable() ? Okta.loc('verify.windowsHello.subtitle', 'login') : '';
      },
      save: _.partial(Okta.loc, 'verify.windowsHello.save', 'login'),
      customSavingState: {
        stop: 'abort'
      },
      modelEvents: function modelEvents() {
        if (!webauthn.isAvailable()) {
          return {};
        }

        return {
          'request': '_startEnrollment',
          'error': '_stopEnrollment',
          'abort': '_stopEnrollment',
          'signIn': '_successEnrollment'
        };
      },
      noButtonBar: function noButtonBar() {
        return !webauthn.isAvailable();
      },
      formChildren: function formChildren() {
        var result = [];

        if (!webauthn.isAvailable()) {
          result.push(FormType.View({
            View: new HtmlErrorMessageView({
              message: Okta.loc('enroll.windowsHello.error.notWindows', 'login')
            })
          }, {
            selector: '.o-form-error-container'
          }));
        }

        result.push(FormType.View({
          View: new Spinner({
            model: this.model,
            visible: false
          })
        }));
        return result;
      },
      postRender: function postRender() {
        if (this.options.appState.get('factors').length === 1 && !this.model.get('__autoTriggered__')) {
          this.model.set('__autoTriggered__', true);
          this.model.save();
        }
      },
      _startEnrollment: function _startEnrollment() {
        this.subtitle = Okta.loc('verify.windowsHello.subtitle.loading', 'login');
        this.model.trigger('spinner:show');

        this._resetErrorMessage();

        this.render();
        this.$('.o-form-button-bar').addClass('hide');
      },
      _stopEnrollment: function _stopEnrollment(errorMessage) {
        this.subtitle = Okta.loc('verify.windowsHello.subtitle', 'login');
        this.model.trigger('spinner:hide');
        this.$('.o-form-button-bar').removeClass('hide');
        var message;

        switch (errorMessage) {
          case 'NotFoundError':
            message = this.options.appState.get('factors').length > 1 ? Okta.loc('verify.windowsHello.error.notFound.selectAnother', 'login') : Okta.loc('verify.windowsHello.error.notFound', 'login');
            break;

          case 'NotSupportedError':
            message = Okta.loc('enroll.windowsHello.error.notConfiguredHtml', 'login');
            break;
        }

        this._resetErrorMessage();

        if (message) {
          var messageView = new HtmlErrorMessageView({
            message: message
          });
          this.$('.o-form-error-container').addClass('o-form-has-errors');
          this.add(messageView, {
            selector: '.o-form-error-container'
          });
          this._errorMessageView = this.last();
        }

        this.render();
      },
      _successEnrollment: function _successEnrollment() {
        this.subtitle = this.settings.get('brandName') ? Okta.loc('verify.windowsHello.subtitle.signingIn.specific', 'login', [this.settings.get('brandName')]) : Okta.loc('verify.windowsHello.subtitle.signingIn.generic', 'login');
        this.render();
        this.$('.o-form-button-bar').addClass('hide');
      },
      _resetErrorMessage: function _resetErrorMessage() {
        this._errorMessageView && this._errorMessageView.remove();
        this._errorMessageView = undefined;
        this.clearErrors();
      }
    },
    back: function back() {// Empty function on verify controllers to prevent users
      // from navigating back during 'verify' using the browser's
      // back button. The URL will still change, but the view will not
      // More details in OKTA-135060.
    },
    Footer: FooterSignout
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(797);

module.exports = parent;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(798);
var path = __webpack_require__(15);

module.exports = path.Object.freeze;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var FREEZING = __webpack_require__(353);
var fails = __webpack_require__(20);
var isObject = __webpack_require__(31);
var onFreeze = __webpack_require__(184).onFreeze;

var nativeFreeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { nativeFreeze(1); });

// `Object.freeze` method
// https://tc39.github.io/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return nativeFreeze && isObject(it) ? nativeFreeze(onFreeze(it)) : it;
  }
});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(56), __webpack_require__(6), __webpack_require__(8), __webpack_require__(84), __webpack_require__(36), __webpack_require__(32), __webpack_require__(238), __webpack_require__(85), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Errors, FormController, FormType, FooterSignout, Q, FactorUtil, FidoUtil, HtmlErrorMessageView) {
  var _ = Okta._;

  function getRegisteredKeysSequence(factors) {
    var keys = [];

    _.each(factors, function (factor) {
      keys.push({
        version: factor.profile.version,
        keyHandle: factor.profile.credentialId
      });
    });

    return keys;
  }

  return FormController.extend({
    className: 'mfa-verify verify-u2f',
    Model: {
      props: {
        rememberDevice: 'boolean'
      },
      initialize: function initialize() {
        var rememberDevice = FactorUtil.getRememberDeviceValue(this.appState); // set the initial value for remember device (Cannot do this while defining the
        // local property because this.settings would not be initialized there yet).

        this.set('rememberDevice', rememberDevice);
      },
      save: function save() {
        this.trigger('request');
        return this.doTransaction(function (transaction) {
          var factor;

          if (transaction.factorTypes) {
            factor = _.findWhere(transaction.factorTypes, {
              factorType: 'u2f'
            });
          } else {
            factor = _.findWhere(transaction.factors, {
              factorType: 'u2f',
              provider: 'FIDO'
            });
          }

          var self = this;
          return factor.verify().then(function (transaction) {
            var registeredKeys, appId, nonce;

            if (transaction.factors) {
              var factors = transaction.factors;
              appId = factors[0]['profile']['appId'];
              nonce = transaction.challenge.nonce;
              registeredKeys = getRegisteredKeysSequence(factors);
            } else {
              var factorData = transaction.factor;
              appId = factorData.profile.appId;
              nonce = factorData.challenge.nonce;
              registeredKeys = [{
                version: FidoUtil.getU2fVersion(),
                keyHandle: factorData.profile.credentialId
              }];
            }

            self.trigger('request');
            var deferred = Q.defer();
            u2f.sign(appId, nonce, registeredKeys, function (data) {
              self.trigger('errors:clear');

              if (data.errorCode && data.errorCode !== 0) {
                var isOneFactor = self.options.appState.get('factors').length === 1;
                deferred.reject(new Errors.U2FError({
                  xhr: {
                    responseJSON: {
                      errorSummary: FidoUtil.getU2fVerifyErrorMessageByCode(data.errorCode, isOneFactor)
                    }
                  }
                }));
              } else {
                var rememberDevice = !!self.get('rememberDevice');
                return factor.verify({
                  clientData: data.clientData,
                  signatureData: data.signatureData,
                  rememberDevice: rememberDevice
                }).then(deferred.resolve);
              }
            });
            return deferred.promise;
          });
        });
      }
    },
    Form: {
      autoSave: true,
      hasSavingState: false,
      title: _.partial(Okta.loc, 'factor.u2f', 'login'),
      className: 'verify-u2f-form',
      noCancelButton: true,
      save: _.partial(Okta.loc, 'verify.u2f.retry', 'login'),
      noButtonBar: function noButtonBar() {
        return !FidoUtil.isU2fAvailable();
      },
      modelEvents: {
        'request': '_startEnrollment',
        'error': '_stopEnrollment'
      },
      formChildren: function formChildren() {
        var result = [];

        if (!FidoUtil.isU2fAvailable()) {
          var errorMessageKey = 'u2f.error.factorNotSupported';

          if (this.options.appState.get('factors').length === 1) {
            errorMessageKey = 'u2f.error.factorNotSupported.oneFactor';
          }

          result.push(FormType.View({
            View: new HtmlErrorMessageView({
              message: Okta.loc(errorMessageKey, 'login')
            })
          }, {
            selector: '.o-form-error-container'
          }));
        } else {
          result.push(FormType.View({
            View: Okta.View.extend({
              template: _runtime.default.template({
                "compiler": [8, ">= 4.3.0"],
                "main": function main(container, depth0, helpers, partials, data) {
                  var alias1 = depth0 != null ? depth0 : container.nullContext || {},
                      alias2 = container.hooks.helperMissing,
                      alias3 = container.escapeExpression,
                      lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }

                    return undefined;
                  };

                  return "<div class=\"u2f-verify-text\"><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                    "name": "i18n",
                    "hash": {
                      "bundle": "login",
                      "code": "verify.u2f.instructions"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 32
                      },
                      "end": {
                        "line": 1,
                        "column": 86
                      }
                    }
                  })) + "</p><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                    "name": "i18n",
                    "hash": {
                      "bundle": "login",
                      "code": "verify.u2f.instructionsBluetooth"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 93
                      },
                      "end": {
                        "line": 1,
                        "column": 156
                      }
                    }
                  })) + "</p><div data-se=\"u2f-waiting\" class=\"okta-waiting-spinner\"></div></div>";
                },
                "useData": true
              })
            })
          }));
        }

        if (this.options.appState.get('allowRememberDevice')) {
          result.push(FormType.Input({
            label: false,
            'label-top': true,
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            className: 'margin-btm-0',
            name: 'rememberDevice',
            type: 'checkbox'
          }));
        }

        return result;
      },
      postRender: function postRender() {
        _.defer((0, _bind.default)(_).call(_, function () {
          if (FidoUtil.isU2fAvailable()) {
            this.model.save();
          } else {
            this.$('[data-se="u2f-waiting"]').addClass('hide');
          }
        }, this));
      },
      _startEnrollment: function _startEnrollment() {
        this.$('.okta-waiting-spinner').removeClass('hide');
        this.$('.o-form-button-bar').hide();
      },
      _stopEnrollment: function _stopEnrollment() {
        this.$('.okta-waiting-spinner').addClass('hide');
        this.$('.o-form-button-bar').show();
      }
    },
    back: function back() {// Empty function on verify controllers to prevent users
      // from navigating back during 'verify' using the browser's
      // back button. The URL will still change, but the view will not
      // More details in OKTA-135060.
    },
    Footer: FooterSignout
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(56), __webpack_require__(6), __webpack_require__(8), __webpack_require__(143), __webpack_require__(113), __webpack_require__(84), __webpack_require__(36), __webpack_require__(32), __webpack_require__(85)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Errors, FormController, FormType, CryptoUtil, webauthn, FooterSignout, Q, FactorUtil, HtmlErrorMessageView) {
  var _ = Okta._;

  function getAllowCredentials(factors) {
    var allowCredentials = [];

    _.each(factors, function (factor) {
      allowCredentials.push({
        type: 'public-key',
        id: CryptoUtil.strToBin(factor.profile.credentialId)
      });
    });

    return allowCredentials;
  }

  return FormController.extend({
    className: 'mfa-verify verify-webauthn',
    Model: {
      props: {
        rememberDevice: 'boolean'
      },
      initialize: function initialize() {
        var _this = this;

        var rememberDevice = FactorUtil.getRememberDeviceValue(this.appState); // set the initial value for remember device (Cannot do this while defining the
        // local property because this.settings would not be initialized there yet).

        this.set('rememberDevice', rememberDevice);
        this.appState.on('factorSwitched signOut', function () {
          if (_this.webauthnAbortController) {
            _this.webauthnAbortController.abort();

            _this.webauthnAbortController = null;
          }
        });
      },
      save: function save() {
        this.trigger('request');
        return this.doTransaction(function (transaction) {
          var factor;

          if (transaction.factorTypes) {
            factor = _.findWhere(transaction.factorTypes, {
              factorType: 'webauthn'
            });
          } else {
            factor = _.findWhere(transaction.factors, {
              factorType: 'webauthn',
              provider: 'FIDO'
            });
          }

          var self = this;
          return factor.verify().then(function (transaction) {
            var allowCredentials, challenge;

            if (transaction.factors) {
              var factors = transaction.factors;
              challenge = transaction.challenge;
              allowCredentials = getAllowCredentials(factors);
            } else {
              var factorData = transaction.factor;
              challenge = factorData.challenge;
              allowCredentials = getAllowCredentials([factorData]);
            }

            self.trigger('request'); // verify via browser webauthn js

            var options = _.extend({}, challenge, {
              allowCredentials: allowCredentials,
              challenge: CryptoUtil.strToBin(challenge.challenge)
            });

            self.webauthnAbortController = new AbortController();
            return new Q(navigator.credentials.get({
              publicKey: options,
              signal: self.webauthnAbortController.signal
            })).then(function (assertion) {
              var rememberDevice = !!self.get('rememberDevice');
              return factor.verify({
                clientData: CryptoUtil.binToStr(assertion.response.clientDataJSON),
                authenticatorData: CryptoUtil.binToStr(assertion.response.authenticatorData),
                signatureData: CryptoUtil.binToStr(assertion.response.signature),
                rememberDevice: rememberDevice
              });
            }).catch(function (error) {
              self.trigger('errors:clear'); // Do not display if it is abort error triggered by code when switching.
              // self.webauthnAbortController would be null if abort was triggered by code.

              if (!self.webauthnAbortController) {
                throw new Errors.WebauthnAbortError();
              } else {
                throw new Errors.WebAuthnError({
                  xhr: {
                    responseJSON: {
                      errorSummary: error.message
                    }
                  }
                });
              }
            }).finally(function () {
              // unset webauthnAbortController on successful authentication or error
              self.webauthnAbortController = null;
            });
          });
        });
      }
    },
    Form: {
      autoSave: true,
      hasSavingState: false,
      title: _.partial(Okta.loc, 'factor.webauthn.biometric', 'login'),
      className: 'verify-webauthn-form',
      noCancelButton: true,
      save: _.partial(Okta.loc, 'verify.u2f.retry', 'login'),
      noButtonBar: function noButtonBar() {
        return !webauthn.isNewApiAvailable();
      },
      modelEvents: {
        'request': '_startEnrollment',
        'error': '_stopEnrollment'
      },
      formChildren: function formChildren() {
        var children = [];

        if (webauthn.isNewApiAvailable()) {
          children.push(FormType.View({
            View: Okta.View.extend({
              template: _runtime.default.template({
                "compiler": [8, ">= 4.3.0"],
                "main": function main(container, depth0, helpers, partials, data) {
                  var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }

                    return undefined;
                  };

                  return "<div class=\"webauthn-verify-text\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "i18n",
                    "hash": {
                      "bundle": "login",
                      "code": "verify.webauthn.biometric.instructions"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 37
                      },
                      "end": {
                        "line": 1,
                        "column": 106
                      }
                    }
                  })) + "</p><div data-se=\"webauthn-waiting\" class=\"okta-waiting-spinner\"></div></div>";
                },
                "useData": true
              })
            })
          }));
        } else {
          var errorMessageKey = 'webauthn.biometric.error.factorNotSupported';

          if (this.options.appState.get('factors').length === 1) {
            errorMessageKey = 'webauthn.biometric.error.factorNotSupported.oneFactor';
          }

          children.push(FormType.View({
            View: new HtmlErrorMessageView({
              message: Okta.loc(errorMessageKey, 'login')
            })
          }, {
            selector: '.o-form-error-container'
          }));
        }

        if (this.options.appState.get('allowRememberDevice')) {
          children.push(FormType.Input({
            label: false,
            'label-top': true,
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            className: 'margin-btm-0',
            name: 'rememberDevice',
            type: 'checkbox'
          }));
        }

        return children;
      },
      postRender: function postRender() {
        _.defer((0, _bind.default)(_).call(_, function () {
          if (webauthn.isNewApiAvailable()) {
            this.model.save();
          } else {
            this.$('[data-se="webauthn-waiting"]').hide();
          }
        }, this));
      },
      _startEnrollment: function _startEnrollment() {
        this.$('.okta-waiting-spinner').show();
        this.$('.o-form-button-bar').hide();
      },
      _stopEnrollment: function _stopEnrollment() {
        this.$('.okta-waiting-spinner').hide();
        this.$('.o-form-button-bar').show();
      }
    },
    back: function back() {// Empty function on verify controllers to prevent users
      // from navigating back during 'verify' using the browser's
      // back button. The URL will still change, but the view will not
      // More details in OKTA-135060.
    },
    Footer: FooterSignout
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2018-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8), __webpack_require__(84), __webpack_require__(32), __webpack_require__(85)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType, FooterSignout, FactorUtil, HtmlErrorMessageView) {
  var _ = Okta._;
  var Util = Okta.internal.util.Util;
  return FormController.extend({
    className: 'verify-custom-factor custom-factor-form',
    Model: {
      props: {
        rememberDevice: 'boolean'
      },
      initialize: function initialize() {
        var rememberDevice = FactorUtil.getRememberDeviceValue(this.appState); // set the initial value for remember device (Cannot do this while defining the
        // local property because this.settings would not be initialized there yet).

        this.set('rememberDevice', rememberDevice);
      },
      save: function save() {
        var _this = this;

        var rememberDevice = !!this.get('rememberDevice');
        return this.manageTransaction(function (transaction, setTransaction) {
          var data = {
            rememberDevice: rememberDevice
          };

          var factor = _.findWhere(transaction.factors, {
            provider: _this.get('provider'),
            factorType: _this.get('factorType')
          });

          return factor.verify(data).then(function (trans) {
            setTransaction(trans);

            var url = _this.appState.get('verifyCustomFactorRedirectUrl');

            if (url !== null) {
              Util.redirect(url);
            }
          }).catch(function (err) {
            throw err;
          });
        });
      }
    },
    Form: function Form() {
      var factors = this.options.appState.get('factors');
      var factor = factors.findWhere({
        provider: this.options.provider,
        factorType: this.options.factorType
      });
      var vendorName = factor.get('vendorName');
      var saveText = Okta.loc('mfa.challenge.verify', 'login');
      var subtitle = Okta.loc('verify.customFactor.subtitle', 'login', [vendorName]);
      return {
        autoSave: true,
        title: vendorName,
        save: saveText,
        subtitle: subtitle,
        attributes: {
          'data-se': 'factor-custom'
        },
        initialize: function initialize() {
          if (this.options.appState.get('allowRememberDevice')) {
            this.addInput({
              label: false,
              'label-top': true,
              placeholder: this.options.appState.get('rememberDeviceLabel'),
              className: 'margin-btm-0',
              name: 'rememberDevice',
              type: 'checkbox'
            });
          }
        },
        formChildren: function formChildren() {
          var result = [],
              lastFailedChallengeFactorData = this.options.appState.get('lastFailedChallengeFactorData');

          if (lastFailedChallengeFactorData) {
            result.push(FormType.View({
              View: new HtmlErrorMessageView({
                message: lastFailedChallengeFactorData.errorMessage
              })
            }, {
              selector: '.o-form-error-container'
            }));
          }

          return result;
        }
      };
    },
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaChallenge')) {
        return true;
      }
    },
    back: function back() {// Empty function on verify controllers to prevent users
      // from navigating back during 'verify' using the browser's
      // back button. The URL will still change, but the view will not
      // More details in OKTA-135060.
    },
    initialize: function initialize() {
      this.model.set('provider', this.options.provider);
      this.model.set('factorType', this.options.factorType);

      if (!this.settings.get('features.hideSignOutLinkInMFA')) {
        this.addFooter(FooterSignout);
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _filter = _interopRequireDefault(__webpack_require__(37));

var _isInteger = _interopRequireDefault(__webpack_require__(803));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(10), __webpack_require__(48), __webpack_require__(356), __webpack_require__(808), __webpack_require__(809)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, Enums, RouterUtil, FactorList, RequiredFactorList, Footer) {
  var _ = Okta._,
      $ = Okta.$,
      subtitleTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "subtitle",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 6
          },
          "end": {
            "line": 1,
            "column": 20
          }
        }
      }) : helper)) != null ? stack1 : "") + "</span>";
    },
    "useData": true
  });

  return FormController.extend({
    className: 'enroll-choices',
    state: {
      pageType: null
    },
    Model: {},
    Form: {
      noCancelButton: true,
      title: _.partial(Okta.loc, 'enroll.choices.title', 'login'),
      noButtonBar: function noButtonBar() {
        return this.state.get('pageType') === Enums.ALL_OPTIONAL_NONE_ENROLLED;
      },
      subtitle: ' ',
      getSubtitle: function getSubtitle() {
        switch (this.state.get('pageType')) {
          case Enums.ALL_OPTIONAL_SOME_ENROLLED:
          case Enums.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
            return Okta.loc('enroll.choices.optional', 'login');

          case Enums.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
            var remainingDays = this.options.appState.get('gracePeriodRemainingDays');
            return (0, _isInteger.default)(remainingDays) && remainingDays >= 0 ? this.getGracePeriodSubtitle(remainingDays) : this.getDefaultSubtitle();

          default:
            return this.getDefaultSubtitle();
        }
      },
      getDefaultSubtitle: function getDefaultSubtitle() {
        return this.settings.get('brandName') ? Okta.loc('enroll.choices.description.specific', 'login', [this.settings.get('brandName')]) : Okta.loc('enroll.choices.description.generic', 'login');
      },
      getGracePeriodSubtitle: function getGracePeriodSubtitle(remainingDays) {
        return remainingDays >= 1 ? Okta.loc('enroll.choices.description.gracePeriod.bold', 'login', [remainingDays]) : Okta.loc('enroll.choices.description.gracePeriod.oneDay.bold', 'login');
      },
      save: function save() {
        switch (this.state.get('pageType')) {
          case Enums.ALL_OPTIONAL_SOME_ENROLLED:
          case Enums.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
            return Okta.loc('enroll.choices.submit.finish', 'login');

          case Enums.HAS_REQUIRED_NONE_ENROLLED:
            return Okta.loc('enroll.choices.submit.configure', 'login');

          case Enums.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
            return Okta.loc('enroll.choices.submit.next', 'login');

          default:
            return '';
        }
      },
      initialize: function initialize(options) {
        this.listenTo(this, 'save', function () {
          var current;

          switch (this.state.get('pageType')) {
            case Enums.HAS_REQUIRED_NONE_ENROLLED:
            case Enums.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
              current = options.appState.get('factors').getFirstUnenrolledRequiredFactor();
              options.appState.trigger('navigate', RouterUtil.createEnrollFactorUrl(current.get('provider'), current.get('factorType')));
              break;

            default:
              return this.model.doTransaction(function (transaction) {
                return transaction.skip();
              });
          }
        });
      },
      preRender: function preRender() {
        // form subtitle does not support unescaped strings, and we need some html elements
        // in the subtitle for this form. So instead of a regular subtitle, we add a <span>
        // with the text we need
        this.add(subtitleTpl({
          subtitle: this.getSubtitle()
        }), $('p.okta-form-subtitle'));
        var factors = this.options.appState.get('factors');

        switch (this.state.get('pageType')) {
          case Enums.HAS_REQUIRED_NONE_ENROLLED:
          case Enums.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
            this.add(new RequiredFactorList({
              minimize: true,
              collection: new Okta.Collection(factors.where({
                required: true
              })),
              appState: this.options.appState
            }));
            break;

          case Enums.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
          case Enums.ALL_OPTIONAL_SOME_ENROLLED:
          case Enums.ALL_OPTIONAL_NONE_ENROLLED:
            var enrolled = factors.where({
              enrolled: true
            }),
                notEnrolled = (0, _filter.default)(factors).call(factors, function (factor) {
              // pick factors that are not enrolled or have additional enrollments
              return !factor.get('enrolled') || factor.get('additionalEnrollment');
            }),
                notEnrolledListTitle;

            if (enrolled.length > 0) {
              notEnrolledListTitle = Okta.loc('enroll.choices.list.optional', 'login');
              this.add(new FactorList({
                listTitle: Okta.loc('enroll.choices.list.enrolled', 'login'),
                minimize: true,
                collection: new Okta.Collection(enrolled),
                appState: this.options.appState
              }));
            }

            this.add(new FactorList({
              listTitle: notEnrolledListTitle,
              collection: new Okta.Collection(notEnrolled),
              appState: this.options.appState,
              showInlineSetupButton: true
            }));
            break;
        }
      }
    },
    initialize: function initialize(options) {
      var numRequiredEnrolled = 0,
          numRequiredNotEnrolled = 0,
          numOptionalEnrolled = 0,
          numOptionalNotEnrolled = 0,
          hasRequired,
          pageType;
      options.appState.get('factors').each(function (factor) {
        var required = factor.get('required'),
            enrolled = factor.get('enrolled'),
            additionalEnrollment = factor.get('additionalEnrollment');

        if (required && enrolled) {
          numRequiredEnrolled++;
        } else if (required && !enrolled) {
          numRequiredNotEnrolled++;
        } else if (!required && enrolled) {
          numOptionalEnrolled++;
        } else if (!required && !enrolled) {
          numOptionalNotEnrolled++;
        } // If a factor has multiple instances and
        // additional optional enrollments


        if (enrolled && additionalEnrollment) {
          numOptionalNotEnrolled++;
        }
      });
      hasRequired = numRequiredEnrolled > 0 || numRequiredNotEnrolled > 0; // There are 5 possible states this screen can be in:
      // 1. Has required, but none have been enrolled. Wizard start page.

      if (hasRequired && numRequiredEnrolled === 0) {
        pageType = Enums.HAS_REQUIRED_NONE_ENROLLED;
      } // 2. Has required, and have enrolled at least one. The page layout
      //    to configure the remaining required factors.
      else if (hasRequired && numRequiredNotEnrolled > 0) {
          pageType = Enums.HAS_REQUIRED_SOME_REQUIRED_ENROLLED;
        } // 3. Has required, and finished enrolling all required factors. The
        //    page layout you see to configure any optional factors or skip.
        else if (hasRequired && numOptionalNotEnrolled > 0) {
            pageType = Enums.HAS_REQUIRED_ALL_REQUIRED_ENROLLED;
          } // 4. Factors are all optional, no factors enrolled.
          else if (numOptionalEnrolled === 0 && numOptionalNotEnrolled > 0) {
              pageType = Enums.ALL_OPTIONAL_NONE_ENROLLED;
            } // 5. Factors are all optional, some factors have already been
            //    enrolled (can either enroll more or skip).
            else if (numOptionalNotEnrolled > 0) {
                pageType = Enums.ALL_OPTIONAL_SOME_ENROLLED;
              } // 6. Factors are all optional, all factors have already been
              //    enrolled, among them there is OktaVerify with Push enrolled as totp
              //    (API return OktaVerify push factor as unenrolled in this case and as we always merge
              //    push and totp in UI so we redirect to skip link here).
              else {
                  this.model.doTransaction(function (transaction) {
                    return transaction.skip();
                  });
                }

      this.state.set('pageType', pageType);

      if (this.options.appState.get('skipLink') && pageType === Enums.HAS_REQUIRED_SOME_REQUIRED_ENROLLED) {
        this.add(new Footer(this.toJSON()));
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(804);

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(805);

module.exports = parent;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(806);
var path = __webpack_require__(15);

module.exports = path.Number.isInteger;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var isInteger = __webpack_require__(807);

// `Number.isInteger` method
// https://tc39.github.io/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.github.io/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _find = _interopRequireDefault(__webpack_require__(18));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(356)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FactorList) {
  var _ = Okta._;
  return FactorList.extend({
    listTitle: _.partial(Okta.loc, 'enroll.choices.list.setup', 'login'),
    className: function className() {
      return FactorList.prototype.className + ' enroll-required-factor-list';
    },
    postRender: function postRender() {
      var _context;

      var currentModel, currentRow;
      FactorList.prototype.postRender.apply(this, arguments);
      currentModel = this.options.appState.get('factors').getFirstUnenrolledRequiredFactor();
      currentRow = (0, _find.default)(_context = this).call(_context, function (view) {
        return view.model === currentModel;
      });
      currentRow.maximize();
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link goto js-skip\" data-se=\"skip-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "enroll.choices.setup.skip"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 58
            },
            "end": {
              "line": 1,
              "column": 114
            }
          }
        })) + "</a>";
      },
      "useData": true
    }),
    className: 'auth-footer clearfix',
    events: {
      'click .js-skip': function clickJsSkip(e) {
        e.preventDefault();
        this.model.doTransaction(function (transaction) {
          return transaction.skip();
        });
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint camelcase: 0*/
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(349), __webpack_require__(36), __webpack_require__(6), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Duo, Q, FormController, Footer) {
  var $ = Okta.$,
      _ = Okta._;
  return FormController.extend({
    className: 'enroll-duo duo-form',
    Model: {
      props: {
        host: 'string',
        signature: 'string',
        postAction: 'string',
        factorId: 'string',
        stateToken: 'string'
      },
      getInitOptions: function getInitOptions() {
        return this.doTransaction(function (transaction) {
          var factor = _.findWhere(transaction.factors, {
            factorType: 'web',
            provider: 'DUO'
          });

          return factor.enroll();
        });
      },
      activate: function activate(signedResponse) {
        // Note: We should be doing this in OktaAuth! Fix when it's updated.
        var url = this.get('postAction'),
            factorId = this.get('factorId'),
            self = this,
            data = {
          id: factorId,
          stateToken: this.get('stateToken'),
          sig_response: signedResponse
        }; // We don't actually use authClient.post() here (unlike all the other cases in the
        // sign-in widget) since the endpoint is wired to accept serialized form post instead
        // of a JSON post ($.post() is different from authClient.post() in that in $.post(),
        // jquery decides the Content-Type instead of it being a JSON type). Enroll/Verify DUO
        // are the only two places where we actually do this.
        // NOTE - If we ever decide to change this, we should test this very carefully.

        return Q($.post(url, data)).then(function () {
          return self.doTransaction(function (transaction) {
            return transaction.poll();
          });
        }).catch(function (err) {
          self.trigger('error', self, err.xhr);
        });
      }
    },
    Form: {
      autoSave: true,
      noButtonBar: true,
      title: _.partial(Okta.loc, 'enroll.duo.title', 'login'),
      postRender: function postRender() {
        this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>');
        Duo.init({
          'host': this.model.get('host'),
          'sig_request': this.model.get('signature'),
          'iframe': this.$('iframe').get(0),
          'post_action': (0, _bind.default)(_).call(_, this.model.activate, this.model)
        });
      }
    },
    Footer: Footer,
    fetchInitialData: function fetchInitialData() {
      var self = this;
      return this.model.getInitOptions(this.options.appState).then(function (trans) {
        var res = trans.data;

        if (!res || !res._embedded || !res._embedded.factor || !res._embedded.factor._embedded || !res._embedded.factor._embedded.activation) {
          throw new Error('Response does not have duo activation options');
        }

        var factor = res._embedded.factor;
        var activation = factor._embedded.activation;
        self.model.set({
          host: activation.host,
          signature: activation.signature,
          postAction: activation._links.complete.href,
          factorId: factor.id,
          stateToken: res.stateToken
        });
      });
    },
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        return true;
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(32), __webpack_require__(24), __webpack_require__(38), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FactorUtil, Util, Footer, TextBox) {
  var _ = Okta._;
  return FormController.extend({
    className: 'enroll-question',
    Model: {
      props: {
        question: 'string',
        answer: ['string', true]
      },
      local: {
        securityQuestions: 'object'
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          var factor = _.findWhere(transaction.factors, {
            factorType: 'question',
            provider: 'OKTA'
          });

          return factor.enroll({
            profile: {
              question: this.get('question'),
              answer: this.get('answer')
            }
          });
        });
      }
    },
    Form: {
      autoSave: true,
      title: _.partial(Okta.loc, 'enroll.securityQuestion.setup', 'login'),
      inputs: function inputs() {
        return [{
          label: false,
          'label-top': true,
          name: 'question',
          type: 'select',
          wide: true,
          options: function options() {
            return this.model.get('securityQuestions');
          },
          params: {
            searchThreshold: 25
          }
        }, {
          label: Okta.loc('mfa.challenge.answer.placeholder', 'login'),
          'label-top': true,
          explain: Util.createInputExplain('mfa.challenge.answer.tooltip', 'mfa.challenge.answer.placeholder', 'login'),
          'explain-top': true,
          className: 'o-form-fieldset o-form-label-top auth-passcode',
          name: 'answer',
          input: TextBox,
          type: 'text'
        }];
      }
    },
    Footer: Footer,
    fetchInitialData: function fetchInitialData() {
      var self = this;
      return this.model.manageTransaction(function (transaction) {
        var factor = _.findWhere(transaction.factors, {
          factorType: 'question',
          provider: 'OKTA'
        });

        return factor.questions();
      }).then(function (questionsRes) {
        var questions = {};

        _.each(questionsRes, function (question) {
          questions[question.question] = FactorUtil.getSecurityQuestionLabel(question);
        });

        self.model.set('securityQuestions', questions);
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(144), __webpack_require__(38), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, ValidationUtil, Footer, TextBox) {
  var _ = Okta._;
  return FormController.extend({
    className: 'enroll-password',
    Model: {
      props: {
        password: ['string', true],
        confirmPassword: ['string', true]
      },
      validate: function validate() {
        return ValidationUtil.validateFieldsMatch(this, 'password', 'confirmPassword', Okta.loc('password.enroll.error.match', 'login'));
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          var factor = _.findWhere(transaction.factors, {
            factorType: 'password',
            provider: 'OKTA'
          });

          return factor.enroll({
            profile: {
              password: this.get('password')
            }
          });
        });
      }
    },
    Form: {
      autoSave: true,
      title: _.partial(Okta.loc, 'enroll.password.setup', 'login'),
      inputs: function inputs() {
        return [{
          label: Okta.loc('mfa.challenge.password.placeholder', 'login'),
          'label-top': true,
          className: 'o-form-fieldset o-form-label-top auth-passcode',
          name: 'password',
          input: TextBox,
          type: 'password'
        }, {
          label: Okta.loc('password.confirmPassword.placeholder', 'login'),
          'label-top': true,
          className: 'o-form-fieldset o-form-label-top auth-passcode',
          name: 'confirmPassword',
          input: TextBox,
          type: 'password'
        }];
      }
    },
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8), __webpack_require__(113), __webpack_require__(354), __webpack_require__(38), __webpack_require__(85)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType, webauthn, Spinner, Footer, HtmlErrorMessageView) {
  var _ = Okta._;
  return FormController.extend({
    className: 'enroll-windows-hello',
    Model: {
      local: {
        __isEnrolled__: 'boolean'
      },
      save: function save() {
        if (!webauthn.isAvailable()) {
          return;
        }

        this.trigger('request');

        if (this.get('__isEnrolled__')) {
          return this.activate();
        }

        return this.doTransaction(function (transaction) {
          return this._enroll(transaction);
        });
      },
      _enroll: function _enroll(transaction) {
        var factor = _.findWhere(transaction.factors, {
          factorType: 'webauthn',
          provider: 'FIDO'
        });

        return factor.enroll();
      },
      activate: function activate() {
        this.set('__isEnrolled__', true);
        return this.doTransaction(function (transaction) {
          var activation = transaction.factor.activation;
          var user = transaction.user;
          var model = this;
          var accountInfo = {
            rpDisplayName: activation.rpDisplayName,
            userDisplayName: user.profile.displayName,
            accountName: user.profile.login,
            userId: user.id
          };
          var cryptoParams = [{
            algorithm: activation.algorithm
          }];
          var challenge = activation.nonce;
          return webauthn.makeCredential(accountInfo, cryptoParams, challenge).then(function (creds) {
            return transaction.activate({
              credentialId: creds.credential.id,
              publicKey: creds.publicKey,
              attestation: null
            });
          }).catch(function (error) {
            switch (error.message) {
              case 'AbortError':
              case 'NotFoundError':
              case 'NotSupportedError':
                model.trigger('abort', error.message);
                return transaction;
            }

            throw error;
          });
        });
      }
    },
    Form: {
      autoSave: true,
      hasSavingState: false,
      title: _.partial(Okta.loc, 'enroll.windowsHello.title', 'login'),
      subtitle: function subtitle() {
        return webauthn.isAvailable() ? Okta.loc('enroll.windowsHello.subtitle', 'login') : '';
      },
      save: _.partial(Okta.loc, 'enroll.windowsHello.save', 'login'),
      customSavingState: {
        stop: 'abort'
      },
      modelEvents: function modelEvents() {
        if (!webauthn.isAvailable()) {
          return {};
        }

        return {
          'request': '_startEnrollment',
          'error': '_stopEnrollment',
          'abort': '_stopEnrollment'
        };
      },
      noButtonBar: function noButtonBar() {
        return !webauthn.isAvailable();
      },
      formChildren: function formChildren() {
        var result = [];

        if (!webauthn.isAvailable()) {
          result.push(FormType.View({
            View: new HtmlErrorMessageView({
              message: Okta.loc('enroll.windowsHello.error.notWindows', 'login')
            })
          }, {
            selector: '.o-form-error-container'
          }));
        }

        result.push(FormType.View({
          View: new Spinner({
            model: this.model,
            visible: false
          })
        }));
        return result;
      },
      _startEnrollment: function _startEnrollment() {
        this.subtitle = Okta.loc('enroll.windowsHello.subtitle.loading', 'login');
        this.model.trigger('spinner:show');

        this._resetErrorMessage();

        this.render();
        this.$('.o-form-button-bar').addClass('hide');
      },
      _stopEnrollment: function _stopEnrollment(errorMessage) {
        this.subtitle = Okta.loc('enroll.windowsHello.subtitle', 'login');
        this.model.trigger('spinner:hide');
        var message;

        switch (errorMessage) {
          case 'NotSupportedError':
            message = Okta.loc('enroll.windowsHello.error.notConfiguredHtml', 'login');
            break;
        }

        this._resetErrorMessage();

        if (message) {
          var messageView = new HtmlErrorMessageView({
            message: message
          });
          this.$('.o-form-error-container').addClass('o-form-has-errors');
          this.add(messageView, {
            selector: '.o-form-error-container'
          });
          this._errorMessageView = this.last();
        }

        this.render();
        this.$('.o-form-button-bar').removeClass('hide');
      },
      _resetErrorMessage: function _resetErrorMessage() {
        this._errorMessageView && this._errorMessageView.remove();
        this._errorMessageView = undefined;
        this.clearErrors();
      }
    },
    Footer: Footer,
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        this.model.activate();
        return true;
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _runtime = _interopRequireDefault(__webpack_require__(4));

/* eslint complexity: [2, 8] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(38), __webpack_require__(357), __webpack_require__(26), __webpack_require__(145), __webpack_require__(8), __webpack_require__(24), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, Footer, PhoneTextBox, TextBox, CountryUtil, FormType, Util, Enums) {
  var _ = Okta._;
  var Keys = Okta.internal.util.Keys;
  var warningTemplate = Okta.View.extend({
    className: 'okta-form-infobox-warning infobox infobox-warning login-timeout-warning',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"icon warning-16\"></span><p>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "warning",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 40
            },
            "end": {
              "line": 1,
              "column": 53
            }
          }
        }) : helper)) != null ? stack1 : "") + "</p>";
      },
      "useData": true
    })
  });
  var factorIdIsDefined = {
    factorId: function factorId(val) {
      return !_.isUndefined(val);
    }
  };

  function isCallFactor(factorType) {
    return factorType === 'call';
  }

  function getClassName(factorType) {
    return isCallFactor(factorType) ? 'enroll-call' : 'enroll-sms';
  }

  function sendCode(e) {
    if (Keys.isEnter(e)) {
      e.stopPropagation();
      e.preventDefault();

      if (e.type === 'keyup' && e.data && e.data.model) {
        e.data.model.sendCode();
      }
    }
  }

  return FormController.extend({
    className: function className() {
      return getClassName(this.options.factorType);
    },
    Model: {
      props: {
        countryCode: ['string', true, 'US'],
        phoneNumber: ['string', true],
        phoneExtension: ['string', false],
        lastEnrolledPhoneNumber: 'string',
        passCode: ['string', true],
        factorId: 'string'
      },
      local: {
        hasExistingPhones: 'boolean',
        trapEnrollment: 'boolean',
        ableToResend: 'boolean',
        factorType: 'string',
        skipPhoneValidation: 'boolean'
      },
      derived: {
        countryCallingCode: {
          deps: ['countryCode'],
          fn: function fn(countryCode) {
            return '+' + CountryUtil.getCallingCodeForCountry(countryCode);
          }
        },
        fullPhoneNumber: {
          deps: ['countryCallingCode', 'phoneNumber'],
          fn: function fn(countryCallingCode, phoneNumber) {
            return phoneNumber ? countryCallingCode + phoneNumber : '';
          }
        },
        enrolled: {
          deps: ['lastEnrolledPhoneNumber', 'fullPhoneNumber'],
          fn: function fn(lastEnrolled, current) {
            return lastEnrolled === current;
          }
        }
      },
      limitResending: function limitResending() {
        this.set({
          ableToResend: false
        });

        _.delay((0, _bind.default)(_).call(_, this.set, this), Enums.API_RATE_LIMIT, {
          ableToResend: true
        });
      },
      sendCode: function sendCode() {
        var self = this;
        var phoneNumber = this.get('fullPhoneNumber');
        var phoneExtension = this.get('phoneExtension');
        self.trigger('errors:clear');

        if (!phoneNumber.length) {
          self.trigger('invalid', self, {
            'phoneNumber': 'model.validation.field.blank'
          });
          return;
        }

        return this.doTransaction(function (transaction) {
          var isMfaEnroll = transaction.status === 'MFA_ENROLL' || transaction.status === 'FACTOR_ENROLL';
          var profileData = {
            phoneNumber: phoneNumber,
            updatePhone: isMfaEnroll ? self.get('hasExistingPhones') : true
          };

          if (isCallFactor(self.get('factorType'))) {
            profileData['phoneExtension'] = phoneExtension;
          }

          if (self.get('skipPhoneValidation')) {
            profileData['validatePhone'] = false;
          }

          var doEnroll = function doEnroll(trans) {
            var factor = _.findWhere(trans.factors, {
              factorType: self.get('factorType'),
              provider: 'OKTA'
            });

            return factor.enroll({
              profile: profileData
            }).catch(function (error) {
              if (error.errorCode === 'E0000098') {
                // E0000098: "This phone number is invalid."
                self.set('skipPhoneValidation', true);
                error.xhr.responseJSON.errorSummary = Okta.loc('enroll.sms.try_again', 'login');
              }

              throw error;
            });
          };

          if (isMfaEnroll) {
            return doEnroll(transaction);
          } else {
            // We must transition to MfaEnroll before updating the phone number
            self.set('trapEnrollment', true);
            return transaction.prev().then(doEnroll).then(function (trans) {
              self.set('trapEnrollment', false);
              return trans;
            });
          } // Rethrow errors so we can change state
          // AFTER setting the new transaction

        }, true).then(function () {
          self.set('lastEnrolledPhoneNumber', phoneNumber);
          self.limitResending();
        }).catch(function () {
          self.set('ableToResend', true);
          self.set('trapEnrollment', false);
        });
      },
      resendCode: function resendCode() {
        this.trigger('errors:clear');
        this.limitResending();
        return this.doTransaction(function (transaction) {
          return transaction.resend(this.get('factorType'));
        });
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          return transaction.activate({
            passCode: this.get('passCode')
          });
        });
      }
    },
    Form: function Form() {
      var factorType = this.options.factorType;
      var isCall = isCallFactor(factorType);
      var formTitle = Okta.loc(isCall ? 'enroll.call.setup' : 'enroll.sms.setup', 'login');
      var formSubmit = Okta.loc(isCall ? 'mfa.call' : 'mfa.sendCode', 'login');
      var formRetry = Okta.loc(isCall ? 'mfa.redial' : 'mfa.resendCode', 'login');
      var formSubmitted = Okta.loc(isCall ? 'mfa.calling' : 'mfa.sent', 'login');
      var numberFieldClassName = isCall ? 'enroll-call-phone' : 'enroll-sms-phone';
      var buttonClassName = isCall ? 'call-request-button' : 'sms-request-button';
      var formChildren = [FormType.Input({
        name: 'countryCode',
        type: 'select',
        wide: true,
        options: CountryUtil.getCountries()
      }), FormType.Input({
        label: Okta.loc('mfa.phoneNumber.placeholder', 'login'),
        'label-top': true,
        className: numberFieldClassName,
        name: 'phoneNumber',
        input: PhoneTextBox,
        type: 'text',
        render: function render() {
          this.$('input[name="phoneNumber"]').off('keydown keyup', sendCode).keydown(sendCode).keyup({
            model: this.model
          }, sendCode);
        }
      })];

      if (isCall) {
        formChildren.push(FormType.Input({
          label: Okta.loc('mfa.phoneNumber.ext.placeholder', 'login'),
          'label-top': true,
          className: 'enroll-call-extension',
          name: 'phoneExtension',
          input: TextBox,
          type: 'text'
        }));
      }

      formChildren.push(FormType.Button({
        title: formSubmit,
        attributes: {
          'data-se': buttonClassName
        },
        className: 'button button-primary js-enroll-phone margin-top-30 ' + buttonClassName,
        click: function click() {
          this.model.sendCode();
        }
      }), FormType.Button({
        title: formRetry,
        attributes: {
          'data-se': buttonClassName
        },
        className: 'button js-enroll-phone margin-top-30 ' + buttonClassName,
        click: function click() {
          this.model.resendCode();
        },
        initialize: function initialize() {
          this.$el.css({
            display: 'none'
          });
          this.listenTo(this.model, 'change:ableToResend', function (model, ableToResend) {
            if (ableToResend) {
              this.options.title = formRetry;
              this.enable();
            } else {
              this.options.title = formSubmitted;
              this.disable();
            }

            this.render();
          });
        }
      }), FormType.Divider({
        showWhen: factorIdIsDefined
      }), FormType.Input({
        label: Okta.loc('mfa.challenge.enterCode.placeholder', 'login'),
        'label-top': true,
        explain: Util.createInputExplain('mfa.challenge.enterCode.tooltip', 'mfa.challenge.enterCode.placeholder', 'login'),
        'explain-top': true,
        name: 'passCode',
        input: TextBox,
        type: 'tel',
        showWhen: factorIdIsDefined
      }), FormType.Toolbar({
        noCancelButton: true,
        save: Okta.loc('mfa.challenge.verify', 'login'),
        showWhen: factorIdIsDefined
      }));
      return {
        title: formTitle,
        noButtonBar: true,
        autoSave: true,
        className: getClassName(factorType),
        showWarning: function showWarning(msg) {
          this.clearWarnings();
          this.add(warningTemplate, '.o-form-error-container', {
            options: {
              warning: msg
            }
          });
        },
        clearWarnings: function clearWarnings() {
          this.$('.okta-form-infobox-warning').remove();
        },
        initialize: function initialize() {
          this.listenTo(this.model, 'change:ableToResend', function (model, ableToResend) {
            if (ableToResend) {
              this.showWarning(Okta.loc(isCall ? 'factor.call.time.warning' : 'factor.sms.time.warning', 'login'));
            } else {
              this.clearWarnings();
            }
          });
          this.listenTo(this.model, 'error errors:clear', function () {
            this.clearWarnings();
            this.clearErrors();
          });
          this.listenTo(this.model, 'change:enrolled', function () {
            this.$('.js-enroll-phone').toggle();
          });
        },
        formChildren: formChildren
      };
    },
    Footer: Footer,
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        this.model.set('factorId', this.options.appState.get('activatedFactorId'));
        return true;
      }

      if (this.options.appState.get('isMfaEnroll') && this.model.get('trapEnrollment')) {
        return true;
      }
    },
    initialize: function initialize() {
      if (isCallFactor(this.options.factorType)) {
        this.model.set('hasExistingPhones', this.options.appState.get('hasExistingPhonesForCall'));
      } else {
        this.model.set('hasExistingPhones', this.options.appState.get('hasExistingPhones'));
      }

      this.model.set('factorType', this.options.factorType);
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-len:0 */
!(module.exports = {
  'US': '1',
  'AG': '1',
  'AI': '1',
  'AS': '1',
  'BB': '1',
  'BM': '1',
  'BS': '1',
  'CA': '1',
  'DM': '1',
  'DO': '1',
  'GD': '1',
  'GU': '1',
  'JM': '1',
  'KN': '1',
  'KY': '1',
  'LC': '1',
  'MP': '1',
  'MS': '1',
  'PR': '1',
  'SX': '1',
  'TC': '1',
  'TT': '1',
  'VC': '1',
  'VG': '1',
  'VI': '1',
  'RU': '7',
  'KZ': '7',
  'EG': '20',
  'ZA': '27',
  'GR': '30',
  'NL': '31',
  'BE': '32',
  'FR': '33',
  'ES': '34',
  'HU': '36',
  'IT': '39',
  'VA': '39',
  'RO': '40',
  'CH': '41',
  'AT': '43',
  'GB': '44',
  'GG': '44',
  'IM': '44',
  'JE': '44',
  'DK': '45',
  'SE': '46',
  'NO': '47',
  'SJ': '47',
  'PL': '48',
  'DE': '49',
  'PE': '51',
  'MX': '52',
  'CU': '53',
  'AR': '54',
  'BR': '55',
  'CL': '56',
  'CO': '57',
  'VE': '58',
  'MY': '60',
  'AU': '61',
  'CC': '61',
  'CX': '61',
  'ID': '62',
  'PH': '63',
  'NZ': '64',
  'SG': '65',
  'TH': '66',
  'JP': '81',
  'KR': '82',
  'VN': '84',
  'CN': '86',
  'TR': '90',
  'IN': '91',
  'PK': '92',
  'AF': '93',
  'LK': '94',
  'MM': '95',
  'IR': '98',
  'SS': '211',
  'MA': '212',
  'EH': '212',
  'DZ': '213',
  'TN': '216',
  'LY': '218',
  'GM': '220',
  'SN': '221',
  'MR': '222',
  'ML': '223',
  'GN': '224',
  'CI': '225',
  'BF': '226',
  'NE': '227',
  'TG': '228',
  'BJ': '229',
  'MU': '230',
  'LR': '231',
  'SL': '232',
  'GH': '233',
  'NG': '234',
  'TD': '235',
  'CF': '236',
  'CM': '237',
  'CV': '238',
  'ST': '239',
  'GQ': '240',
  'GA': '241',
  'CG': '242',
  'CD': '243',
  'AO': '244',
  'GW': '245',
  'IO': '246',
  'AC': '247',
  'SC': '248',
  'SD': '249',
  'RW': '250',
  'ET': '251',
  'SO': '252',
  'DJ': '253',
  'KE': '254',
  'TZ': '255',
  'UG': '256',
  'BI': '257',
  'MZ': '258',
  'ZM': '260',
  'MG': '261',
  'RE': '262',
  'YT': '262',
  'ZW': '263',
  'NA': '264',
  'MW': '265',
  'LS': '266',
  'BW': '267',
  'SZ': '268',
  'KM': '269',
  'SH': '290',
  'TA': '290',
  'ER': '291',
  'AW': '297',
  'FO': '298',
  'GL': '299',
  'GI': '350',
  'PT': '351',
  'LU': '352',
  'IE': '353',
  'IS': '354',
  'AL': '355',
  'MT': '356',
  'CY': '357',
  'FI': '358',
  'AX': '358',
  'BG': '359',
  'LT': '370',
  'LV': '371',
  'EE': '372',
  'MD': '373',
  'AM': '374',
  'BY': '375',
  'AD': '376',
  'MC': '377',
  'SM': '378',
  'UA': '380',
  'RS': '381',
  'ME': '382',
  'XK': '383',
  'HR': '385',
  'SI': '386',
  'BA': '387',
  'MK': '389',
  'CZ': '420',
  'SK': '421',
  'LI': '423',
  'FK': '500',
  'BZ': '501',
  'GT': '502',
  'SV': '503',
  'HN': '504',
  'NI': '505',
  'CR': '506',
  'PA': '507',
  'PM': '508',
  'HT': '509',
  'GP': '590',
  'BL': '590',
  'MF': '590',
  'BO': '591',
  'GY': '592',
  'EC': '593',
  'GF': '594',
  'PY': '595',
  'MQ': '596',
  'SR': '597',
  'UY': '598',
  'CW': '599',
  'BQ': '599',
  'TL': '670',
  'NF': '672',
  'BN': '673',
  'NR': '674',
  'PG': '675',
  'TO': '676',
  'SB': '677',
  'VU': '678',
  'FJ': '679',
  'PW': '680',
  'WF': '681',
  'CK': '682',
  'NU': '683',
  'WS': '685',
  'KI': '686',
  'NC': '687',
  'TV': '688',
  'PF': '689',
  'TK': '690',
  'FM': '691',
  'MH': '692',
  '001': '979',
  'KP': '850',
  'HK': '852',
  'MO': '853',
  'KH': '855',
  'LA': '856',
  'BD': '880',
  'TW': '886',
  'MV': '960',
  'LB': '961',
  'JO': '962',
  'SY': '963',
  'IQ': '964',
  'KW': '965',
  'SA': '966',
  'YE': '967',
  'OM': '968',
  'PS': '970',
  'AE': '971',
  'IL': '972',
  'BH': '973',
  'QA': '974',
  'BT': '975',
  'MN': '976',
  'NP': '977',
  'TJ': '992',
  'TM': '993',
  'AZ': '994',
  'GE': '995',
  'KG': '996',
  'UZ': '998',
  'GS': '500',
  'PN': '64',
  'AQ': '672',
  'UM': '1',
  'AN': '599'
});

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(38), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, Footer, FormType) {
  var _ = Okta._;
  var Model = {
    local: {
      factorType: 'string',
      provider: 'string'
    },
    save: function save() {
      this.trigger('save');
      var factorOpt = this.pick('factorType', 'provider');
      return this.doTransaction(function (transaction) {
        var factor = _.findWhere(transaction.factors, factorOpt);

        return factor.enroll();
      });
    }
  };

  var Form = function Form() {
    return {
      title: _.partial(Okta.loc, 'email.enroll.title', 'login'),
      noButtonBar: false,
      autoSave: true,
      save: _.partial(Okta.loc, 'email.button.send', 'login'),
      formChildren: [FormType.View({
        View: Okta.View.extend({
          attributes: {
            'data-se': 'enroll-email-content'
          },
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "email.enroll.description"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 55
                  }
                }
              }));
            },
            "useData": true
          })
        })
      })]
    };
  };

  return FormController.extend({
    className: 'enroll-email',
    Model: Model,
    Form: Form,
    Footer: Footer,
    initialize: function initialize() {
      this.model.set(_.pick(this.options, 'factorType', 'provider'));
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(38), __webpack_require__(351), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, Footer, ResendEmailView, FormType) {
  var _ = Okta._;
  var Model = {
    props: {
      passCode: 'string'
    },
    resend: function resend() {
      this.trigger('form:clear-errors');
      return this.doTransaction(function (transaction) {
        // authn support multiple `resend` hence has to specify name.
        return transaction.resend('email');
      });
    },
    save: function save() {
      this.trigger('save');
      var formData = this.toJSON();
      return this.doTransaction(function (transaction) {
        return transaction.activate(formData);
      });
    }
  };

  var Form = function Form() {
    return {
      title: _.partial(Okta.loc, 'email.enroll.title', 'login'),
      noButtonBar: false,
      autoSave: true,
      save: _.partial(Okta.loc, 'oform.verify', 'login'),
      // TODO: deprecated by mfa.challenge.verify
      formChildren: [// message
      FormType.View({
        View: Okta.View.extend({
          className: 'enroll-activate-email-content',
          attributes: {
            'data-se': 'enroll-activate-email-content'
          },
          // Why use `{{{` for the description?
          // - factorEmail is actually an HTML fragment which
          //   is created via another handlebar template and used for bold the email address.
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var stack1,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "arguments": "factorEmail",
                  "bundle": "login",
                  "code": "email.mfa.email.sent.description"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 89
                  }
                }
              })) != null ? stack1 : "";
            },
            "useData": true
          }),
          getTemplateData: function getTemplateData() {
            var factor = this.options.appState.get('factor');
            var factorEmailVal = factor && factor.profile ? factor.profile.email : '';

            var factorEmail = _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var helper,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<span class=\"mask-email\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "email",
                  "hash": {},
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 25
                    },
                    "end": {
                      "line": 1,
                      "column": 34
                    }
                  }
                }) : helper)) + "</span>";
              },
              "useData": true
            })({
              email: factorEmailVal
            });

            return {
              factorEmail: factorEmail
            };
          }
        })
      }), // send again callout message and link button
      FormType.View({
        View: ResendEmailView
      }), // passcode input
      FormType.Input({
        label: Okta.loc('email.code.label', 'login'),
        'label-top': true,
        name: 'passCode',
        type: 'text',
        wide: true
      })]
    };
  };

  return FormController.extend({
    className: 'enroll-activate-email',
    Model: Model,
    Form: Form,
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(8), __webpack_require__(6), __webpack_require__(24), __webpack_require__(38), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormType, FormController, Util, Footer, TextBox) {
  var _ = Okta._;

  function isRSA(provider) {
    return provider === 'RSA';
  }

  function getClassName(provider) {
    return isRSA(provider) ? 'enroll-rsa' : 'enroll-onprem';
  }

  return FormController.extend({
    className: function className() {
      return getClassName(this.options.provider);
    },
    Model: function Model() {
      var provider = this.options.provider;
      var factors = this.options.appState.get('factors');
      var factor = factors.findWhere(_.pick(this.options, 'provider', 'factorType'));
      var profile = factor.get('profile');
      var credentialId = profile && profile.credentialId ? profile.credentialId : '';
      return {
        props: {
          credentialId: ['string', true, credentialId],
          passCode: ['string', true],
          factorId: 'string'
        },
        save: function save() {
          return this.doTransaction(function (transaction) {
            var factor = _.findWhere(transaction.factors, {
              factorType: 'token',
              provider: provider
            });

            return factor.enroll({
              passCode: this.get('passCode'),
              profile: {
                credentialId: this.get('credentialId')
              }
            });
          });
        }
      };
    },
    Form: function Form() {
      var provider = this.options.provider;
      var factors = this.options.appState.get('factors');
      var factor = factors.findWhere(_.pick(this.options, 'provider', 'factorType'));
      var vendorName = factor.get('vendorName');
      var title = isRSA(provider) ? Okta.loc('factor.totpHard.rsaSecurId', 'login') : vendorName;
      return {
        title: title,
        noButtonBar: true,
        autoSave: true,
        className: getClassName(provider),
        initialize: function initialize() {
          this.listenTo(this.model, 'error', (0, _bind.default)(_).call(_, function (source, error) {
            if (error && error.status === 409) {
              // 409 means we are in change pin, so we should clear out answer input
              this.$('.o-form-input-name-passCode input').val('');
              this.$('.o-form-input-name-passCode input').trigger('change');
              this.$('.o-form-input-name-passCode input').focus();
            }
          }, this));
        },
        formChildren: [FormType.Input({
          label: Okta.loc('enroll.onprem.username.placeholder', 'login', [vendorName]),
          'label-top': true,
          explain: Util.createInputExplain('enroll.onprem.username.tooltip', 'enroll.onprem.username.placeholder', 'login', [vendorName], [vendorName]),
          'explain-top': true,
          name: 'credentialId',
          input: TextBox,
          type: 'text'
        }), FormType.Input({
          label: Okta.loc('enroll.onprem.passcode.placeholder', 'login', [vendorName]),
          'label-top': true,
          explain: Util.createInputExplain('enroll.onprem.passcode.tooltip', 'enroll.onprem.passcode.placeholder', 'login', [vendorName], [vendorName]),
          'explain-top': true,
          name: 'passCode',
          input: TextBox,
          type: 'password'
        }), FormType.Toolbar({
          noCancelButton: true,
          save: Okta.loc('mfa.challenge.verify', 'login')
        })]
      };
    },
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(8), __webpack_require__(6), __webpack_require__(24), __webpack_require__(38), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormType, FormController, Util, Footer, TextBox) {
  var _ = Okta._;
  return FormController.extend({
    className: 'enroll-symantec',
    Model: {
      props: {
        credentialId: ['string', true],
        passCode: ['string', true],
        nextPassCode: ['string', true],
        factorId: 'string'
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          var factor = _.findWhere(transaction.factors, {
            factorType: 'token',
            provider: 'SYMANTEC'
          });

          return factor.enroll({
            passCode: this.get('passCode'),
            nextPassCode: this.get('nextPassCode'),
            profile: {
              credentialId: this.get('credentialId')
            }
          });
        });
      }
    },
    Form: {
      title: _.partial(Okta.loc, 'factor.totpHard.symantecVip', 'login'),
      subtitle: _.partial(Okta.loc, 'enroll.symantecVip.subtitle', 'login'),
      noButtonBar: true,
      autoSave: true,
      className: 'enroll-symantec',
      formChildren: function formChildren() {
        return [FormType.Input({
          label: Okta.loc('enroll.symantecVip.credentialId.placeholder', 'login'),
          'label-top': true,
          explain: Util.createInputExplain('enroll.symantecVip.credentialId.tooltip', 'enroll.symantecVip.credentialId.placeholder', 'login'),
          'explain-top': true,
          name: 'credentialId',
          input: TextBox,
          type: 'text'
        }), FormType.Input({
          label: Okta.loc('enroll.symantecVip.passcode1.placeholder', 'login'),
          'label-top': true,
          explain: Util.createInputExplain('enroll.symantecVip.passcode1.tooltip', 'enroll.symantecVip.passcode1.placeholder', 'login'),
          'explain-top': true,
          name: 'passCode',
          input: TextBox,
          type: 'text'
        }), FormType.Input({
          label: Okta.loc('enroll.symantecVip.passcode2.placeholder', 'login'),
          'label-top': true,
          explain: Util.createInputExplain('enroll.symantecVip.passcode2.tooltip', 'enroll.symantecVip.passcode2.placeholder', 'login'),
          'explain-top': true,
          name: 'nextPassCode',
          input: TextBox,
          type: 'text'
        }), FormType.Toolbar({
          noCancelButton: true,
          save: Okta.loc('mfa.challenge.verify', 'login')
        })];
      }
    },
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(8), __webpack_require__(6), __webpack_require__(38), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormType, FormController, Footer, TextBox) {
  var _ = Okta._;
  return FormController.extend({
    className: 'enroll-yubikey',
    Model: {
      props: {
        passCode: ['string', true],
        factorId: 'string'
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          var factor = _.findWhere(transaction.factors, {
            factorType: 'token:hardware',
            provider: 'YUBICO'
          });

          return factor.enroll({
            passCode: this.get('passCode')
          });
        });
      }
    },
    Form: {
      title: _.partial(Okta.loc, 'enroll.yubikey.title', 'login'),
      subtitle: _.partial(Okta.loc, 'enroll.yubikey.subtitle', 'login'),
      noCancelButton: true,
      save: _.partial(Okta.loc, 'mfa.challenge.verify', 'login'),
      autoSave: true,
      className: 'enroll-yubikey',
      formChildren: [FormType.View({
        View: '<div class="yubikey-demo" data-type="yubikey-example"></div>'
      }), FormType.Input({
        name: 'passCode',
        input: TextBox,
        type: 'password'
      })]
    },
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(32), __webpack_require__(6), __webpack_require__(8), __webpack_require__(48), __webpack_require__(822), __webpack_require__(239), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FactorUtil, FormController, FormType, RouterUtil, StoreLinks, BarcodeView, Footer) {
  var _ = Okta._;
  var showWhenDeviceTypeSelected = {
    '__deviceType__': function __deviceType__(val) {
      return val !== undefined;
    }
  };
  var AppDownloadInstructionsView = Okta.View.extend({
    attributes: {
      'data-se': 'app-download-instructions'
    },
    className: 'app-download-instructions',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"app-logo " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "appIcon") || (depth0 != null ? lookupProperty(depth0, "appIcon") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "appIcon",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 22
            },
            "end": {
              "line": 1,
              "column": 33
            }
          }
        }) : helper)) + "\"></span><p class=\"instructions\">" + ((stack1 = (helper = (helper = lookupProperty(helpers, "appStoreLinkText") || (depth0 != null ? lookupProperty(depth0, "appStoreLinkText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
          "name": "appStoreLinkText",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 66
            },
            "end": {
              "line": 1,
              "column": 88
            }
          }
        }) : helper)) != null ? stack1 : "") + "</p>";
      },
      "useData": true
    }),
    initialize: function initialize() {
      this.listenTo(this.model, 'change:__deviceType__', this.render);
    },
    getTemplateData: function getTemplateData() {
      var appStoreLink, appIcon, appStoreName;
      var factorName = FactorUtil.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
      appStoreName = StoreLinks.STORE[this.model.get('__deviceType__')];

      if (this.model.get('__provider__') === 'GOOGLE') {
        appStoreLink = StoreLinks.GOOGLE[this.model.get('__deviceType__')];
        appIcon = 'google-auth-38';
      } else {
        appStoreLink = StoreLinks.OKTA[this.model.get('__deviceType__')];
        appIcon = 'okta-verify-38';
      }

      return {
        appStoreLinkText: Okta.loc('enroll.totp.downloadApp', 'login', [appStoreLink, factorName, appStoreName]),
        appIcon: appIcon
      };
    }
  });
  var EnrollTotpController = FormController.extend({
    className: 'enroll-totp',
    Model: function Model() {
      return {
        local: {
          '__deviceType__': 'string',
          '__factorType__': ['string', false, this.options.factorType],
          '__provider__': ['string', false, this.options.provider]
        },
        save: function save() {
          return this.doTransaction(function (transaction) {
            var factor = _.findWhere(transaction.factors, {
              factorType: this.get('__factorType__'),
              provider: this.get('__provider__')
            });

            return factor.enroll();
          });
        }
      };
    },
    Form: {
      title: function title() {
        var factorName = FactorUtil.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
        return Okta.loc('enroll.totp.title', 'login', [factorName]);
      },
      subtitle: _.partial(Okta.loc, 'enroll.totp.selectDevice', 'login'),
      autoSave: true,
      noButtonBar: true,
      attributes: {
        'data-se': 'step-device-type'
      },
      formChildren: function formChildren() {
        var inputOptions = {
          APPLE: Okta.loc('iphone', 'login'),
          ANDROID: Okta.loc('android', 'login')
        };
        var children = [FormType.Input({
          name: '__deviceType__',
          type: 'radio',
          options: inputOptions
        }), FormType.Divider({
          showWhen: showWhenDeviceTypeSelected
        }), FormType.View({
          View: AppDownloadInstructionsView,
          showWhen: showWhenDeviceTypeSelected
        }), FormType.Toolbar({
          noCancelButton: true,
          save: Okta.loc('oform.next', 'login'),
          showWhen: showWhenDeviceTypeSelected
        })];
        return children;
      }
    },
    Footer: Footer
  });
  return EnrollTotpController;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(module.exports = {
  OKTA: {
    APPLE: 'https://itunes.apple.com/us/app/okta-verify/id490179405',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.okta.android.auth'
  },
  GOOGLE: {
    APPLE: 'https://itunes.apple.com/us/app/google-authenticator/id388497605',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
  },
  STORE: {
    APPLE: 'App Store',
    ANDROID: 'Google Play Store'
  }
});

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(56), __webpack_require__(8), __webpack_require__(6), __webpack_require__(238), __webpack_require__(38), __webpack_require__(36), __webpack_require__(85), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Errors, FormType, FormController, FidoUtil, Footer, Q, HtmlErrorMessageView) {
  var _ = Okta._;
  return FormController.extend({
    className: 'enroll-u2f',
    Model: {
      local: {
        '__enrolled__': 'boolean'
      },
      save: function save() {
        this.trigger('request');

        if (this.get('__enrolled__')) {
          return this.activate();
        }

        return this.doTransaction(function (transaction) {
          var factor = _.findWhere(transaction.factors, {
            factorType: 'u2f',
            provider: 'FIDO'
          });

          return factor.enroll();
        });
      },
      activate: function activate() {
        this.set('__enrolled__', true);
        this.trigger('errors:clear');
        return this.doTransaction(function (transaction) {
          var activation = transaction.factor.activation;
          var appId = activation.appId;
          var registerRequests = [{
            version: FidoUtil.getU2fVersion(),
            challenge: activation.nonce
          }];
          var self = this;
          var deferred = Q.defer();
          u2f.register(appId, registerRequests, [], function (data) {
            self.trigger('errors:clear');

            if (data.errorCode && data.errorCode !== 0) {
              deferred.reject(new Errors.U2FError({
                xhr: {
                  responseJSON: {
                    errorSummary: FidoUtil.getU2fEnrollErrorMessageByCode(data.errorCode)
                  }
                }
              }));
            } else {
              deferred.resolve(transaction.activate({
                registrationData: data.registrationData,
                version: data.version,
                challenge: data.challenge,
                clientData: data.clientData
              }));
            }
          });
          return deferred.promise;
        });
      }
    },
    Form: {
      title: _.partial(Okta.loc, 'enroll.u2f.title', 'login'),
      save: _.partial(Okta.loc, 'enroll.u2f.save', 'login'),
      noCancelButton: true,
      hasSavingState: false,
      autoSave: true,
      className: 'enroll-u2f-form',
      noButtonBar: function noButtonBar() {
        return !FidoUtil.isU2fAvailable();
      },
      modelEvents: {
        'request': '_startEnrollment',
        'error': '_stopEnrollment'
      },
      formChildren: function formChildren() {
        var result = [];

        if (!FidoUtil.isU2fAvailable()) {
          var errorMessageKey = 'u2f.error.factorNotSupported';

          if (this.options.appState.get('factors').length === 1) {
            errorMessageKey = 'u2f.error.factorNotSupported.oneFactor';
          }

          result.push(FormType.View({
            View: new HtmlErrorMessageView({
              message: Okta.loc(errorMessageKey, 'login')
            })
          }, {
            selector: '.o-form-error-container'
          }));
        } else {
          //There is html in enroll.u2f.general2 in our properties file, reason why is unescaped
          result.push(FormType.View({
            View: Okta.View.extend({
              template: _runtime.default.template({
                "compiler": [8, ">= 4.3.0"],
                "main": function main(container, depth0, helpers, partials, data) {
                  var stack1,
                      alias1 = depth0 != null ? depth0 : container.nullContext || {},
                      alias2 = container.hooks.helperMissing,
                      lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }

                    return undefined;
                  };

                  return "<div class=\"u2f-instructions\"><ol><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                    "name": "i18n",
                    "hash": {
                      "bundle": "login",
                      "code": "enroll.u2f.general2"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 38
                      },
                      "end": {
                        "line": 1,
                        "column": 90
                      }
                    }
                  })) != null ? stack1 : "") + "</li><li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                    "name": "i18n",
                    "hash": {
                      "bundle": "login",
                      "code": "enroll.u2f.general3"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 99
                      },
                      "end": {
                        "line": 1,
                        "column": 149
                      }
                    }
                  })) + "</li></ol></div>";
                },
                "useData": true
              })
            })
          }));
          result.push(FormType.View({
            View: Okta.View.extend({
              template: _runtime.default.template({
                "compiler": [8, ">= 4.3.0"],
                "main": function main(container, depth0, helpers, partials, data) {
                  var alias1 = depth0 != null ? depth0 : container.nullContext || {},
                      alias2 = container.hooks.helperMissing,
                      alias3 = container.escapeExpression,
                      lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }

                    return undefined;
                  };

                  return "<div class=\"u2f-enroll-text hide\"><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                    "name": "i18n",
                    "hash": {
                      "bundle": "login",
                      "code": "enroll.u2f.instructions"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 37
                      },
                      "end": {
                        "line": 1,
                        "column": 91
                      }
                    }
                  })) + "</p><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                    "name": "i18n",
                    "hash": {
                      "bundle": "login",
                      "code": "enroll.u2f.instructionsBluetooth"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 98
                      },
                      "end": {
                        "line": 1,
                        "column": 161
                      }
                    }
                  })) + "</p><div data-se=\"u2f-devices\" class=\"u2f-devices-images\"><div class=\"u2f-usb\"></div><div class=\"u2f-bluetooth\"></div></div><div data-se=\"u2f-waiting\" class=\"okta-waiting-spinner\"></div></div>";
                },
                "useData": true
              })
            })
          }));
        }

        return result;
      },
      _startEnrollment: function _startEnrollment() {
        this.$('.u2f-instructions').addClass('hide');
        this.$('.u2f-enroll-text').removeClass('hide');
        this.$('.o-form-button-bar').hide();
      },
      _stopEnrollment: function _stopEnrollment() {
        this.$('.u2f-instructions').removeClass('hide');
        this.$('.u2f-enroll-text').addClass('hide');
        this.$('.o-form-button-bar').show();
      }
    },
    Footer: Footer,
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        this.model.activate();
        return true;
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(56), __webpack_require__(8), __webpack_require__(6), __webpack_require__(143), __webpack_require__(113), __webpack_require__(38), __webpack_require__(36), __webpack_require__(85), __webpack_require__(75)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Errors, FormType, FormController, CryptoUtil, webauthn, Footer, Q, HtmlErrorMessageView, BrowserFeatures) {
  var _ = Okta._;

  function getExcludeCredentials(credentials) {
    var excludeCredentials = [];

    _.each(credentials, function (credential) {
      excludeCredentials.push({
        type: 'public-key',
        id: CryptoUtil.strToBin(credential.id)
      });
    });

    return excludeCredentials;
  }

  return FormController.extend({
    className: 'enroll-webauthn',
    Model: {
      local: {
        '__enrolled__': 'boolean'
      },
      save: function save() {
        this.trigger('request');

        if (this.get('__enrolled__')) {
          return this.activate();
        }

        return this.doTransaction(function (transaction) {
          var factor = _.findWhere(transaction.factors, {
            factorType: 'webauthn',
            provider: 'FIDO'
          });

          return factor.enroll();
        });
      },
      activate: function activate() {
        var _this = this;

        this.set('__enrolled__', true);
        this.trigger('errors:clear');
        this.appState.on('backToFactors', function () {
          if (_this.webauthnAbortController) {
            _this.webauthnAbortController.abort();

            _this.webauthnAbortController = null;
          }
        });
        return this.doTransaction(function (transaction) {
          // enroll via browser webauthn js
          var activation = transaction.factor.activation;
          var self = this;

          if (webauthn.isNewApiAvailable()) {
            var options = _.extend({}, activation, {
              challenge: CryptoUtil.strToBin(activation.challenge),
              user: {
                id: CryptoUtil.strToBin(activation.user.id),
                name: activation.user.name,
                displayName: activation.user.displayName
              },
              excludeCredentials: getExcludeCredentials(activation.excludeCredentials)
            });

            self.webauthnAbortController = new AbortController();
            return new Q(navigator.credentials.create({
              publicKey: options,
              signal: self.webauthnAbortController.signal
            })).then(function (newCredential) {
              return transaction.activate({
                attestation: CryptoUtil.binToStr(newCredential.response.attestationObject),
                clientData: CryptoUtil.binToStr(newCredential.response.clientDataJSON)
              });
            }).catch(function (error) {
              self.trigger('errors:clear'); // Do not display if it is abort error triggered by code when switching.
              // self.webauthnAbortController would be null if abort was triggered by code. 

              if (!self.webauthnAbortController) {
                throw new Errors.WebauthnAbortError();
              } else {
                throw new Errors.WebAuthnError({
                  xhr: {
                    responseJSON: {
                      errorSummary: error.message
                    }
                  }
                });
              }
            }).finally(function () {
              // unset webauthnAbortController on successful authentication or error
              self.webauthnAbortController = null;
            });
          }
        });
      }
    },
    Form: {
      title: _.partial(Okta.loc, 'enroll.webauthn.biometric.title', 'login'),
      save: _.partial(Okta.loc, 'enroll.webauthn.save', 'login'),
      noCancelButton: true,
      hasSavingState: false,
      autoSave: true,
      className: 'enroll-webauthn-form',
      noButtonBar: function noButtonBar() {
        return !webauthn.isNewApiAvailable();
      },
      modelEvents: {
        'request': '_startEnrollment',
        'error': '_stopEnrollment'
      },
      formChildren: function formChildren() {
        var children = [];

        if (webauthn.isNewApiAvailable()) {
          //enroll.webauthn.biometric.instructions.edge is unescaped because it contains html
          children.push(FormType.View({
            View: Okta.View.extend({
              className: 'webauthn-enroll-text',
              template: _runtime.default.template({
                "1": function _(container, depth0, helpers, partials, data) {
                  var stack1,
                      lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }

                    return undefined;
                  };

                  return "<div class=\"webauthn-edge-text\"><p>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "i18n",
                    "hash": {
                      "bundle": "login",
                      "code": "enroll.webauthn.biometric.instructions.edge"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 173
                      },
                      "end": {
                        "line": 1,
                        "column": 249
                      }
                    }
                  })) != null ? stack1 : "") + "</p></div>";
                },
                "3": function _(container, depth0, helpers, partials, data) {
                  var stack1,
                      lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }

                    return undefined;
                  };

                  return "<div class=\"webauthn-restrictions-text\"><p>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "i18n",
                    "hash": {
                      "bundle": "login",
                      "code": "enroll.webauthn.instructions.noSupportForBiometric"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 340
                      },
                      "end": {
                        "line": 1,
                        "column": 423
                      }
                    }
                  })) != null ? stack1 : "") + "</p></div>";
                },
                "compiler": [8, ">= 4.3.0"],
                "main": function main(container, depth0, helpers, partials, data) {
                  var stack1,
                      alias1 = depth0 != null ? depth0 : container.nullContext || {},
                      lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }

                    return undefined;
                  };

                  return "<div class=\"webauthn-enroll-instructions\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                    "name": "i18n",
                    "hash": {
                      "bundle": "login",
                      "code": "enroll.webauthn.biometric.instructions"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 45
                      },
                      "end": {
                        "line": 1,
                        "column": 114
                      }
                    }
                  })) + "</p></div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isEdge") : depth0, {
                    "name": "if",
                    "hash": {},
                    "fn": container.program(1, data, 0),
                    "inverse": container.noop,
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 124
                      },
                      "end": {
                        "line": 1,
                        "column": 266
                      }
                    }
                  })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "onlySupportsSecurityKey") : depth0, {
                    "name": "if",
                    "hash": {},
                    "fn": container.program(3, data, 0),
                    "inverse": container.noop,
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 266
                      },
                      "end": {
                        "line": 1,
                        "column": 440
                      }
                    }
                  })) != null ? stack1 : "") + "<div data-se=\"webauthn-waiting\" class=\"okta-waiting-spinner hide\"></div>";
                },
                "useData": true
              }),
              getTemplateData: function getTemplateData() {
                return {
                  isEdge: BrowserFeatures.isEdge(),
                  onlySupportsSecurityKey: (BrowserFeatures.isFirefox() || BrowserFeatures.isSafari()) && BrowserFeatures.isMac()
                };
              }
            })
          }));
        } else {
          var errorMessageKey = 'webauthn.biometric.error.factorNotSupported';

          if (this.options.appState.get('factors').length === 1) {
            errorMessageKey = 'webauthn.biometric.error.factorNotSupported.oneFactor';
          }

          children.push(FormType.View({
            View: new HtmlErrorMessageView({
              message: Okta.loc(errorMessageKey, 'login')
            })
          }, {
            selector: '.o-form-error-container'
          }));
        }

        return children;
      },
      _startEnrollment: function _startEnrollment() {
        this.$('.okta-waiting-spinner').show();
        this.$('.o-form-button-bar').hide();
      },
      _stopEnrollment: function _stopEnrollment() {
        this.$('.okta-waiting-spinner').hide();
        this.$('.o-form-button-bar').show();
      }
    },
    Footer: Footer,
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        this.model.activate();
        return true;
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2019-2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(182), __webpack_require__(8), __webpack_require__(358), __webpack_require__(85)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Factor, FormType, EnrollCustomFactorController, HtmlErrorMessageView) {
  var Util = Okta.internal.util.Util;
  return EnrollCustomFactorController.extend({
    Model: {
      local: {
        provider: 'string',
        factorType: 'string'
      },
      save: function save() {
        var _this = this;

        return this.manageTransaction(function () {
          var url = _this.appState.get('enrollCustomFactorRedirectUrl');

          if (url !== null) {
            Util.redirect(url);
          }
        });
      }
    },
    Form: function Form() {
      var factor = new Factor.Model(this.options.appState.get('factor'), this.toJSON());
      var vendorName = factor.get('vendorName');
      var subtitle = Okta.loc('enroll.customFactor.subtitle', 'login', [vendorName]);
      var saveText = Okta.loc('enroll.customFactor.save', 'login');
      return {
        autoSave: true,
        title: vendorName,
        subtitle: subtitle,
        save: saveText,
        formChildren: function formChildren() {
          var result = [];

          if (this.options.appState.get('isFactorResultFailed')) {
            result.push(FormType.View({
              View: new HtmlErrorMessageView({
                message: this.options.appState.get('factorResultErrorMessage')
              })
            }, {
              selector: '.o-form-error-container'
            }));
          }

          return result;
        }
      };
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8), __webpack_require__(38), __webpack_require__(85)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType, Footer, HtmlErrorMessageView) {
  return FormController.extend({
    className: 'enroll-hotp',
    Model: function Model() {
      return {
        local: {
          '__factorType__': ['string', false, this.options.factorType],
          '__provider__': ['string', false, this.options.provider]
        }
      };
    },
    Form: {
      title: function title() {
        var factors = this.options.appState.get('factors');
        var hotpFactor = factors.findWhere({
          provider: this.model.get('__provider__'),
          factorType: this.model.get('__factorType__')
        });
        return Okta.loc('enroll.totp.title', 'login', [hotpFactor.get('factorLabel')]);
      },
      noButtonBar: true,
      attributes: {
        'data-se': 'restrict-enroll'
      },
      formChildren: function formChildren() {
        var children = [FormType.View({
          View: new HtmlErrorMessageView({
            message: Okta.loc('enroll.hotp.restricted', 'login')
          })
        })];
        return children;
      }
    },
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(32), __webpack_require__(6), __webpack_require__(8), __webpack_require__(48), __webpack_require__(239), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FactorUtil, FormController, FormType, RouterUtil, BarcodeView, Footer) {
  var _ = Okta._;
  return FormController.extend({
    className: 'barcode-totp',
    Model: function Model() {
      return {
        local: {
          '__factorType__': ['string', false, this.options.factorType],
          '__provider__': ['string', false, this.options.provider]
        }
      };
    },
    Form: {
      title: function title() {
        var factorName = FactorUtil.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
        return Okta.loc('enroll.totp.title', 'login', [factorName]);
      },
      subtitle: _.partial(Okta.loc, 'mfa.scanBarcode', 'login'),
      save: _.partial(Okta.loc, 'oform.next', 'login'),
      noCancelButton: true,
      attributes: {
        'data-se': 'step-scan'
      },
      className: 'barcode-scan',
      formChildren: [FormType.View({
        View: BarcodeView
      })]
    },
    Footer: Footer,
    initialize: function initialize() {
      this.listenTo(this.form, 'save', function () {
        var url = RouterUtil.createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'activate');
        this.options.appState.trigger('navigate', url);
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(32), __webpack_require__(6), __webpack_require__(8), __webpack_require__(48), __webpack_require__(239), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FactorUtil, FormController, FormType, RouterUtil, BarcodeView, Footer) {
  var _ = Okta._; // Note: Keep-alive is set to 5 seconds - using 5 seconds here will result
  // in network connection lost errors in Safari and IE.

  var PUSH_INTERVAL = 6000;
  return FormController.extend({
    className: 'barcode-push',
    Model: function Model() {
      return {
        local: {
          '__factorType__': ['string', false, this.options.factorType],
          '__provider__': ['string', false, this.options.provider]
        }
      };
    },
    Form: {
      title: function title() {
        var factorName = FactorUtil.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
        return Okta.loc('enroll.totp.title', 'login', [factorName]);
      },
      subtitle: _.partial(Okta.loc, 'mfa.scanBarcode', 'login'),
      noButtonBar: true,
      attributes: {
        'data-se': 'step-scan'
      },
      className: 'barcode-scan',
      initialize: function initialize() {
        this.listenTo(this.model, 'error errors:clear', function () {
          this.clearErrors();
        });
      },
      formChildren: [FormType.View({
        View: BarcodeView
      })]
    },
    Footer: Footer,
    initialize: function initialize() {
      this.pollForEnrollment();
    },
    pollForEnrollment: function pollForEnrollment() {
      return this.model.doTransaction(function (transaction) {
        return transaction.poll(PUSH_INTERVAL);
      });
    },
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        return true;
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(359), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, EnterPasscodeForm, Footer) {
  return FormController.extend({
    className: 'activate-totp',
    Model: function Model() {
      return {
        props: {
          factorId: ['string', true, this.options.appState.get('activatedFactorId')],
          passCode: ['string', true]
        },
        local: {
          '__factorType__': ['string', false, this.options.factorType],
          '__provider__': ['string', false, this.options.provider]
        },
        save: function save() {
          return this.doTransaction(function (transaction) {
            return transaction.activate({
              passCode: this.get('passCode')
            });
          });
        }
      };
    },
    Form: EnterPasscodeForm,
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(32), __webpack_require__(6), __webpack_require__(8), __webpack_require__(48), __webpack_require__(831), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FactorUtil, FormController, FormType, RouterUtil, ManualSetupFooter, TextBox) {
  var _ = Okta._;
  return FormController.extend({
    className: 'enroll-manual-totp',
    Model: function Model() {
      return {
        local: {
          'sharedSecret': ['string', false, this.options.appState.get('sharedSecret')],
          '__factorType__': ['string', false, this.options.factorType],
          '__provider__': ['string', false, this.options.provider]
        }
      };
    },
    Form: {
      title: function title() {
        var factorName = FactorUtil.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
        return Okta.loc('enroll.totp.title', 'login', [factorName]);
      },
      subtitle: _.partial(Okta.loc, 'enroll.totp.cannotScanBarcode', 'login'),
      noButtonBar: true,
      attributes: {
        'data-se': 'step-manual-setup'
      },
      formChildren: function formChildren() {
        var instructions = this.settings.get('brandName') ? Okta.loc('enroll.totp.manualSetupInstructions.specific', 'login', [this.settings.get('brandName')]) : Okta.loc('enroll.totp.manualSetupInstructions.generic', 'login');
        return [FormType.View({
          View: Okta.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var helper,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<p class=\"okta-form-subtitle o-form-explain text-align-c\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "instructions",
                  "hash": {},
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 58
                    },
                    "end": {
                      "line": 1,
                      "column": 74
                    }
                  }
                }) : helper)) + "</p>";
              },
              "useData": true
            }),
            getTemplateData: function getTemplateData() {
              return {
                instructions: instructions
              };
            }
          })
        }), FormType.Input({
          name: 'sharedSecret',
          input: TextBox,
          type: 'text',
          disabled: true
        }), FormType.Toolbar({
          noCancelButton: true,
          save: Okta.loc('oform.next', 'login')
        })];
      }
    },
    Footer: ManualSetupFooter,
    initialize: function initialize() {
      this.listenTo(this.form, 'save', function () {
        var url = RouterUtil.createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'activate');
        this.options.appState.trigger('navigate', url);
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(48), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, RouterUtil, Enums) {
  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "mfa.backToFactors"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 58
            },
            "end": {
              "line": 1,
              "column": 106
            }
          }
        })) + "</a><a href=\"#\" class=\"link help goto js-goto\" data-se=\"goto-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "mfa.scanBarcode"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 173
            },
            "end": {
              "line": 1,
              "column": 219
            }
          }
        })) + "</a>";
      },
      "useData": true
    }),
    className: 'auth-footer',
    events: {
      'click .js-back': function clickJsBack(e) {
        e.preventDefault();
        this.back();
      },
      'click .js-goto': function clickJsGoto(e) {
        e.preventDefault(); // go to a different screen with current auth status:
        // refresh the latest response

        this.model.startTransaction(function (authClient) {
          return authClient.tx.resume();
        });
      }
    },
    back: function back() {
      this.state.set('navigateDir', Enums.DIRECTION_BACK);

      if (this.options.appState.get('prevLink')) {
        // Once we are in the MFA_ENROLL_ACTIVATE, we need to reset to the
        // correct state. Fortunately, this means that the router will
        // handle navigation once the request is finished.
        this.model.doTransaction(function (transaction) {
          return transaction.prev();
        });
      } else {
        this.options.appState.trigger('navigate', 'signin/enroll');
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(145), __webpack_require__(32), __webpack_require__(6), __webpack_require__(8), __webpack_require__(48), __webpack_require__(833), __webpack_require__(357), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, CountryUtil, FactorUtil, FormController, FormType, RouterUtil, Footer, PhoneTextBox, TextBox) {
  var _ = Okta._;

  function goToFactorActivation(view, step) {
    var url = RouterUtil.createActivateFactorUrl(view.options.appState.get('activatedFactorProvider'), view.options.appState.get('activatedFactorType'), step);
    view.options.appState.trigger('navigate', url);
  }

  function setStateValues(view) {
    var userPhoneNumber, userCountryCode;

    if (view.model.get('activationType') === 'SMS') {
      userCountryCode = view.model.get('countryCode');
      userPhoneNumber = view.model.get('phoneNumber');
    }

    view.options.appState.set({
      factorActivationType: view.model.get('activationType'),
      userCountryCode: userCountryCode,
      userPhoneNumber: userPhoneNumber
    });
  }

  function enrollFactor(view, factorType) {
    return view.model.doTransaction(function (transaction) {
      return transaction.prev().then(function (trans) {
        var factor = _.findWhere(trans.factors, {
          factorType: factorType,
          provider: 'OKTA'
        });

        return factor.enroll();
      }).then(function (trans) {
        var textActivationLinkUrl,
            emailActivationLinkUrl,
            sharedSecret,
            res = trans.data;

        if (res && res._embedded && res._embedded.factor && res._embedded.factor._embedded && res._embedded.factor._embedded.activation) {
          var factor = res._embedded.factor; // Shared secret

          sharedSecret = factor._embedded.activation.sharedSecret;

          if (factor._embedded.activation._links && factor._embedded.activation._links.send) {
            var activationSendLinks = factor._embedded.activation._links.send; // SMS activation url

            var smsItem = _.findWhere(activationSendLinks, {
              name: 'sms'
            });

            textActivationLinkUrl = smsItem ? smsItem.href : null; // Email activation url

            var emailItem = _.findWhere(activationSendLinks, {
              name: 'email'
            });

            emailActivationLinkUrl = emailItem ? emailItem.href : null;
          }
        }

        view.model.set({
          'SMS': textActivationLinkUrl,
          'EMAIL': emailActivationLinkUrl,
          'sharedSecret': sharedSecret
        });
        return trans;
      });
    });
  }

  return FormController.extend({
    className: 'enroll-manual-push',
    Model: function Model() {
      return {
        local: {
          activationType: ['string', true, this.options.appState.get('factorActivationType') || 'SMS'],
          countryCode: ['string', false, 'US'],
          phoneNumber: 'string',
          'SMS': ['string', false, this.options.appState.get('textActivationLinkUrl')],
          'EMAIL': ['string', false, this.options.appState.get('emailActivationLinkUrl')],
          'sharedSecret': ['string', false, this.options.appState.get('sharedSecret')],
          '__factorType__': ['string', false, this.options.factorType],
          '__provider__': ['string', false, this.options.provider]
        },
        derived: {
          countryCallingCode: {
            deps: ['countryCode'],
            fn: function fn(countryCode) {
              return '+' + CountryUtil.getCallingCodeForCountry(countryCode);
            }
          },
          fullPhoneNumber: {
            deps: ['countryCallingCode', 'phoneNumber'],
            fn: function fn(countryCallingCode, phoneNumber) {
              return countryCallingCode + phoneNumber;
            }
          }
        }
      };
    },
    Form: {
      title: function title() {
        var factorName = FactorUtil.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
        return Okta.loc('enroll.totp.title', 'login', [factorName]);
      },
      subtitle: _.partial(Okta.loc, 'enroll.totp.cannotScanBarcode', 'login'),
      noButtonBar: true,
      attributes: {
        'data-se': 'step-manual-setup'
      },
      formChildren: function formChildren() {
        var instructions = this.settings.get('brandName') ? Okta.loc('enroll.totp.sharedSecretInstructions.specific', 'login', [this.settings.get('brandName')]) : Okta.loc('enroll.totp.sharedSecretInstructions.generic', 'login');
        var children = [FormType.Input({
          name: 'activationType',
          type: 'select',
          wide: true,
          options: {
            SMS: Okta.loc('enroll.totp.sendSms', 'login'),
            EMAIL: Okta.loc('enroll.totp.sendEmail', 'login'),
            MANUAL: Okta.loc('enroll.totp.setupManually', 'login')
          }
        }), FormType.Input({
          name: 'countryCode',
          type: 'select',
          wide: true,
          options: CountryUtil.getCountries(),
          showWhen: {
            activationType: 'SMS'
          }
        }), FormType.Input({
          label: Okta.loc('mfa.phoneNumber.placeholder', 'login'),
          'label-top': true,
          className: 'enroll-sms-phone',
          name: 'phoneNumber',
          input: PhoneTextBox,
          type: 'text',
          showWhen: {
            activationType: 'SMS'
          }
        }), FormType.View({
          View: Okta.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var helper,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<p class=\"okta-form-subtitle o-form-explain text-align-c\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "instructions",
                  "hash": {},
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 58
                    },
                    "end": {
                      "line": 1,
                      "column": 74
                    }
                  }
                }) : helper)) + "</p>";
              },
              "useData": true
            }),
            getTemplateData: function getTemplateData() {
              return {
                instructions: instructions
              };
            }
          }),
          showWhen: {
            activationType: 'MANUAL'
          }
        }), FormType.Input({
          name: 'sharedSecret',
          input: TextBox,
          type: 'text',
          disabled: true,
          showWhen: {
            activationType: 'MANUAL'
          },
          initialize: function initialize() {
            this.listenTo(this.model, 'change:sharedSecret', this.render);
          }
        }), FormType.View({
          View: Okta.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                return "<div data-type=\"next-button-wrap\"></div>";
              },
              "useData": true
            })
          }),
          showWhen: {
            activationType: 'MANUAL'
          }
        }), FormType.Button({
          title: Okta.loc('oform.next', 'login'),
          className: 'button button-primary button-wide button-next',
          attributes: {
            'data-se': 'next-button'
          },
          click: (0, _bind.default)(_).call(_, function () {
            setStateValues(this);
            goToFactorActivation(this, 'passcode');
          }, this)
        }, '[data-type="next-button-wrap"]'), FormType.Toolbar({
          noCancelButton: true,
          save: Okta.loc('oform.send', 'login'),
          showWhen: {
            activationType: function activationType(val) {
              return val === 'SMS' || val === 'EMAIL';
            }
          }
        })];
        return children;
      }
    },
    Footer: Footer,
    initialize: function initialize() {
      this.setInitialModel(); // Move this logic to a model when AuthClient supports sending email and sms

      this.listenTo(this.form, 'save', function () {
        var self = this;
        this.model.doTransaction(function (transaction) {
          var activationType = this.get('activationType').toLowerCase(),
              opts = {};

          if (activationType === 'sms') {
            opts.profile = {
              phoneNumber: this.get('fullPhoneNumber')
            };
          }

          return transaction.factor.activation.send(activationType, opts).then(function (trans) {
            setStateValues(self); // Note: Need to defer because OktaAuth calls our router success
            // handler on the next tick - if we immediately called, appState would
            // still be populated with the last response

            _.defer(function () {
              goToFactorActivation(self, 'sent');
            });

            return trans;
          });
        });
      });
      this.listenTo(this.model, 'change:activationType', function (model, value) {
        this.form.clearErrors();

        if (value === 'MANUAL' && this.options.appState.get('activatedFactorType') !== 'token:software:totp') {
          enrollFactor(this, 'token:software:totp');
        } else if (this.options.appState.get('activatedFactorType') !== 'push') {
          enrollFactor(this, 'push');
        }
      });
    },
    setInitialModel: function setInitialModel() {
      if (this.options.appState.get('factorActivationType') === 'SMS') {
        this.model.set({
          countryCode: this.options.appState.get('userCountryCode') || 'US',
          phoneNumber: this.options.appState.get('userPhoneNumber')
        });
      }
    },
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isMfaEnrollActivate') || this.options.appState.get('isMfaEnroll')) {
        return true;
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(48)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, RouterUtil) {
  var _ = Okta._;

  function goToFactorActivation(appState) {
    var url = RouterUtil.createActivateFactorUrl(appState.get('activatedFactorProvider'), appState.get('activatedFactorType'));
    appState.trigger('navigate', url);
  }

  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "mfa.backToFactors"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 58
            },
            "end": {
              "line": 1,
              "column": 106
            }
          }
        })) + "</a><a href=\"#\" class=\"link help goto js-goto\" data-se=\"goto-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "mfa.scanBarcode"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 173
            },
            "end": {
              "line": 1,
              "column": 219
            }
          }
        })) + "</a>";
      },
      "useData": true
    }),
    className: 'auth-footer',
    events: {
      'click .js-back': function clickJsBack(e) {
        e.preventDefault();
        this.back();
      },
      'click .js-goto': function clickJsGoto(e) {
        e.preventDefault();

        var goToFactor = _.partial(goToFactorActivation, this.options.appState);

        this.options.appState.unset('factorActivationType');
        this.model.doTransaction(function (transaction) {
          return transaction.prev().then(function (trans) {
            var factor = _.findWhere(trans.factors, {
              factorType: 'push',
              provider: 'OKTA'
            });

            return factor.enroll();
          });
        }).then(goToFactor);
      }
    },
    back: function back() {
      var self = this;
      self.options.appState.unset('factorActivationType');

      if (self.options.appState.get('prevLink')) {
        this.model.doTransaction(function (transaction) {
          return transaction.prev();
        }).then(function () {
          // we trap 'MFA_ENROLL' response that's why we need to trigger navigation from here
          self.options.appState.trigger('navigate', 'signin/enroll');
        });
      } else {
        self.options.appState.trigger('navigate', 'signin/enroll');
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(145), __webpack_require__(6), __webpack_require__(8), __webpack_require__(48)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, CountryUtil, FormController, FormType, RouterUtil) {
  var _ = Okta._; // Note: Keep-alive is set to 5 seconds - using 5 seconds here will result
  // in network connection lost errors in Safari and IE.

  var PUSH_INTERVAL = 6000;
  var Footer = Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "oform.back"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 58
            },
            "end": {
              "line": 1,
              "column": 99
            }
          }
        })) + "</a>";
      },
      "useData": true
    }),
    className: 'auth-footer',
    events: {
      'click .js-back': function clickJsBack(e) {
        e.preventDefault();
        this.back();
      }
    },
    back: function back() {
      var url = RouterUtil.createActivateFactorUrl(this.options.appState.get('activatedFactorProvider'), this.options.appState.get('activatedFactorType'), 'manual');
      this.options.appState.trigger('navigate', url);
    }
  });
  var emailSentForm = {
    title: _.partial(Okta.loc, 'enroll.totp.enrollViaEmail.title', 'login'),
    noButtonBar: true,
    attributes: {
      'data-se': 'sent-email-activation-link'
    },
    formChildren: [FormType.View({
      View: Okta.View.extend({
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var helper,
                alias1 = depth0 != null ? depth0 : container.nullContext || {},
                alias2 = container.hooks.helperMissing,
                alias3 = container.escapeExpression,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "enroll.totp.enrollViaEmail.msg"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 3
                },
                "end": {
                  "line": 1,
                  "column": 64
                }
              }
            })) + "</p><p class=\"email-address\">" + alias3((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
              "name": "email",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 93
                },
                "end": {
                  "line": 1,
                  "column": 102
                }
              }
            }) : helper)) + "</p>";
          },
          "useData": true
        }),
        getTemplateData: function getTemplateData() {
          return {
            email: this.options.appState.get('userEmail')
          };
        }
      })
    })]
  };
  var smsSentForm = {
    title: _.partial(Okta.loc, 'enroll.totp.enrollViaSms.title', 'login'),
    noButtonBar: true,
    attributes: {
      'data-se': 'sent-sms-activation-link'
    },
    formChildren: [FormType.View({
      View: Okta.View.extend({
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var helper,
                alias1 = depth0 != null ? depth0 : container.nullContext || {},
                alias2 = container.hooks.helperMissing,
                alias3 = container.escapeExpression,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "enroll.totp.enrollViaSms.msg"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 3
                },
                "end": {
                  "line": 1,
                  "column": 62
                }
              }
            })) + "</p><p class=\"phone-number\">" + alias3((helper = (helper = lookupProperty(helpers, "phoneNumber") || (depth0 != null ? lookupProperty(depth0, "phoneNumber") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
              "name": "phoneNumber",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 90
                },
                "end": {
                  "line": 1,
                  "column": 105
                }
              }
            }) : helper)) + "</p>";
          },
          "useData": true
        }),
        getTemplateData: function getTemplateData() {
          return {
            phoneNumber: this.model.get('fullPhoneNumber')
          };
        }
      })
    })]
  };
  return FormController.extend({
    className: 'enroll-activation-link-sent',
    Model: function Model() {
      return {
        local: {
          countryCode: ['string', false, this.options.appState.get('userCountryCode')],
          phoneNumber: ['string', false, this.options.appState.get('userPhoneNumber')],
          '__factorType__': ['string', false, this.options.factorType],
          '__provider__': ['string', false, this.options.provider]
        },
        derived: {
          countryCallingCode: {
            deps: ['countryCode'],
            fn: function fn(countryCode) {
              return '+' + CountryUtil.getCallingCodeForCountry(countryCode);
            }
          },
          fullPhoneNumber: {
            deps: ['countryCallingCode', 'phoneNumber'],
            fn: function fn(countryCallingCode, phoneNumber) {
              return countryCallingCode + phoneNumber;
            }
          }
        }
      };
    },
    Form: function Form() {
      var activationType = this.options.appState.get('factorActivationType');

      switch (activationType) {
        case 'SMS':
          return smsSentForm;

        case 'EMAIL':
          return emailSentForm;

        default:
          throw new Error('Unknown activation option: ' + activationType);
      }
    },
    Footer: Footer,
    initialize: function initialize() {
      this.pollForEnrollment();
    },
    remove: function remove() {
      return FormController.prototype.remove.apply(this, arguments);
    },
    pollForEnrollment: function pollForEnrollment() {
      return this.model.doTransaction(function (transaction) {
        return transaction.poll(PUSH_INTERVAL);
      });
    },
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isWaitingForActivation')) {
        this.pollForEnrollment();
        return true;
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(48), __webpack_require__(359)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, RouterUtil, EnterPasscodeForm) {
  var Footer = Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "oform.back"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 58
            },
            "end": {
              "line": 1,
              "column": 99
            }
          }
        })) + "</a>";
      },
      "useData": true
    }),
    className: 'auth-footer',
    events: {
      'click .js-back': function clickJsBack(e) {
        e.preventDefault();
        this.back();
      }
    },
    back: function back() {
      var url = RouterUtil.createActivateFactorUrl(this.options.appState.get('activatedFactorProvider'), 'push', 'manual');
      this.options.appState.trigger('navigate', url);
    }
  });
  return FormController.extend({
    className: 'activate-push',
    Model: function Model() {
      return {
        props: {
          factorId: ['string', true, this.options.appState.get('activatedFactorId')],
          passCode: ['string', true]
        },
        local: {
          '__factorType__': ['string', false, this.options.factorType],
          '__provider__': ['string', false, this.options.provider]
        },
        save: function save() {
          return this.doTransaction(function (transaction) {
            return transaction.activate({
              passCode: this.get('passCode')
            });
          });
        }
      };
    },
    Form: EnterPasscodeForm,
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _concat = _interopRequireDefault(__webpack_require__(16));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(10), __webpack_require__(8), __webpack_require__(144), __webpack_require__(32), __webpack_require__(24), __webpack_require__(360), __webpack_require__(26), __webpack_require__(361)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, Enums, FormType, ValidationUtil, FactorUtil, Util, Footer, TextBox, PasswordRequirements) {
  var _ = Okta._;
  return FormController.extend({
    className: 'password-expired',
    Model: {
      props: {
        oldPassword: ['string', true],
        newPassword: ['string', true],
        confirmPassword: ['string', true]
      },
      validate: function validate() {
        return ValidationUtil.validatePasswordMatch(this);
      },
      save: function save() {
        this.trigger('save');
        return this.doTransaction(function (transaction) {
          return transaction.changePassword({
            oldPassword: this.get('oldPassword'),
            newPassword: this.get('newPassword')
          });
        });
      }
    },
    Form: {
      save: _.partial(Okta.loc, 'password.expired.submit', 'login'),
      title: function title() {
        var expiringSoon = this.options.appState.get('isPwdExpiringSoon'),
            numDays = this.options.appState.get('passwordExpireDays');

        if (expiringSoon && numDays > 0) {
          return Okta.loc('password.expiring.title', 'login', [numDays]);
        } else if (expiringSoon && numDays === 0) {
          return Okta.loc('password.expiring.today', 'login');
        } else if (expiringSoon) {
          return Okta.loc('password.expiring.soon', 'login');
        } else {
          return this.settings.get('brandName') ? Okta.loc('password.expired.title.specific', 'login', [this.settings.get('brandName')]) : Okta.loc('password.expired.title.generic', 'login');
        }
      },
      subtitle: function subtitle() {
        if (this.options.appState.get('isPwdExpiringSoon')) {
          return this.settings.get('brandName') ? Okta.loc('password.expiring.subtitle.specific', 'login', [this.settings.get('brandName')]) : Okta.loc('password.expiring.subtitle.generic', 'login');
        }

        var policy = this.options.appState.get('policy');

        if (!policy || this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
          return;
        }

        return FactorUtil.getPasswordComplexityDescription(policy);
      },
      parseErrorMessage: function parseErrorMessage(responseJSON) {
        var policy = this.options.appState.get('policy');

        if (!!policy && this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
          /*
            - This is a specific case where don't want to repeat the requirements again in the error message, since this
              is already shown in the description. The description as bullet-points itself should give an indication
              of the requirements.
            - We cannot check for error code this in this case, as the error code is shared between
              requirements not met message, common password message, etc. So error summary is the only differentiating
              factor. Replace the password requirements string with empty string in this case.
          */
          responseJSON = FactorUtil.removeRequirementsFromError(responseJSON, policy);
        }

        return responseJSON;
      },
      formChildren: function formChildren() {
        var children = [];

        if (this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
          children.push(FormType.View({
            View: new PasswordRequirements({
              policy: this.options.appState.get('policy')
            })
          }));
        }

        children = (0, _concat.default)(children).call(children, [FormType.Input({
          'label-top': true,
          label: Okta.loc('password.oldPassword.placeholder', 'login'),
          explain: Util.createInputExplain('password.oldPassword.tooltip', 'password.oldPassword.placeholder', 'login'),
          'explain-top': true,
          name: 'oldPassword',
          input: TextBox,
          type: 'password'
        }), FormType.Divider(), FormType.Input({
          className: 'margin-btm-5',
          'label-top': true,
          label: Okta.loc('password.newPassword.placeholder', 'login'),
          explain: Util.createInputExplain('password.newPassword.tooltip', 'password.newPassword.placeholder', 'login'),
          'explain-top': true,
          name: 'newPassword',
          input: TextBox,
          type: 'password'
        }), FormType.Input({
          'label-top': true,
          label: Okta.loc('password.confirmPassword.placeholder', 'login'),
          explain: Util.createInputExplain('password.confirmPassword.tooltip', 'password.confirmPassword.placeholder', 'login'),
          'explain-top': true,
          name: 'confirmPassword',
          input: TextBox,
          type: 'password'
        })]);
        return children;
      }
    },
    Footer: Footer,
    initialize: function initialize() {
      this.listenTo(this.form, 'save', function () {
        var creds = {
          username: this.options.appState.get('userEmail'),
          password: this.model.get('newPassword')
        };
        this.settings.processCreds(creds).then((0, _bind.default)(_).call(_, this.model.save, this.model));
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8), __webpack_require__(360)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType, Footer) {
  var _ = Okta._;
  var Util = Okta.internal.util.Util;
  return FormController.extend({
    className: 'custom-password-expired',
    Model: {},
    Form: {
      noButtonBar: true,
      title: function title() {
        var expiringSoon = this.options.appState.get('isPwdExpiringSoon'),
            numDays = this.options.appState.get('passwordExpireDays');

        if (expiringSoon && numDays > 0) {
          return Okta.loc('password.expiring.title', 'login', [numDays]);
        } else if (expiringSoon && numDays === 0) {
          return Okta.loc('password.expiring.today', 'login');
        } else if (expiringSoon) {
          return Okta.loc('password.expiring.soon', 'login');
        } else {
          return this.settings.get('brandName') ? Okta.loc('password.expired.title.specific', 'login', [this.settings.get('brandName')]) : Okta.loc('password.expired.title.generic', 'login');
        }
      },
      subtitle: function subtitle() {
        if (this.options.appState.get('isPwdExpiringSoon')) {
          var subtitle = this.settings.get('brandName') ? Okta.loc('password.expiring.subtitle.specific', 'login', [this.settings.get('brandName')]) : Okta.loc('password.expiring.subtitle.generic', 'login');
          return subtitle + ' ' + Okta.loc('password.expired.custom.subtitle', 'login');
        }

        return Okta.loc('password.expired.custom.subtitle', 'login');
      },
      formChildren: function formChildren() {
        return [FormType.Button({
          title: _.partial(Okta.loc, 'password.expired.custom.submit', 'login', [this.options.appState.get('passwordExpiredWebsiteName')]),
          className: 'button button-primary button-wide',
          attributes: {
            'data-se': 'custom-button'
          },
          click: function click() {
            Util.redirect(this.options.appState.get('passwordExpiredLinkUrl'));
          }
        })];
      }
    },
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(10), __webpack_require__(8), __webpack_require__(144), __webpack_require__(24), __webpack_require__(362), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, Enums, FormType, ValidationUtil, Util, ContactSupport, TextBox) {
  var _ = Okta._;
  var noFactorsError = Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "password.forgot.noFactorsEnabled"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 110
            },
            "end": {
              "line": 1,
              "column": 173
            }
          }
        })) + "</p></div>";
      },
      "useData": true
    })
  });
  var Footer = Okta.View.extend({
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "goback"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 94
            },
            "end": {
              "line": 1,
              "column": 131
            }
          }
        })) + "</a>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link goto js-contact-support\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "mfa.noAccessToEmail"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 220
            },
            "end": {
              "line": 1,
              "column": 270
            }
          }
        })) + "</a>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "hideBackToSignInForReset") : depth0, {
          "name": "unless",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 146
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "helpSupportNumber") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 146
            },
            "end": {
              "line": 1,
              "column": 281
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),
    className: 'auth-footer',
    events: {
      'click .js-back': function clickJsBack(e) {
        e.preventDefault();
        this.back();
      },
      'click .js-contact-support': function clickJsContactSupport(e) {
        e.preventDefault();
        this.state.trigger('contactSupport');
        this.$('.js-contact-support').hide();
      }
    },
    getTemplateData: function getTemplateData() {
      return {
        hideBackToSignInForReset: this.settings.get('features.hideBackToSignInForReset'),
        helpSupportNumber: this.settings.get('helpSupportNumber')
      };
    },
    back: function back() {
      this.state.set('navigateDir', Enums.DIRECTION_BACK);
      this.options.appState.trigger('navigate', '');
    }
  });
  return FormController.extend({
    className: 'forgot-password',
    Model: {
      props: {
        username: ['string', true],
        factorType: ['string', true]
      },
      validate: function validate() {
        return ValidationUtil.validateUsername(this);
      },
      save: function save() {
        var self = this;
        var relayState = this.settings.get('relayState');
        this.startTransaction(function (authClient) {
          return authClient.forgotPassword({
            username: self.settings.transformUsername(self.get('username'), Enums.FORGOT_PASSWORD),
            factorType: self.get('factorType'),
            relayState: relayState
          });
        }).catch(function () {//need empty fail handler on model to display errors on form
        });
      }
    },
    Form: {
      noButtonBar: true,
      title: _.partial(Okta.loc, 'password.reset', 'login'),
      formChildren: function formChildren() {
        /*eslint complexity: [2, 9] max-statements: [2, 23] */
        var smsEnabled = this.settings.get('features.smsRecovery');
        var callEnabled = this.settings.get('features.callRecovery');
        var emailEnabled = this.settings.get('features.emailRecovery');
        var noFactorsEnabled = !(smsEnabled || callEnabled || emailEnabled);
        var formChildren = [];

        if (noFactorsEnabled) {
          this.add(noFactorsError, '.o-form-error-container');
        } else {
          formChildren.push(FormType.Input({
            label: Okta.loc('password.forgot.email.or.username.placeholder', 'login'),
            'label-top': true,
            explain: Util.createInputExplain('password.forgot.email.or.username.tooltip', 'password.forgot.email.or.username.placeholder', 'login'),
            'explain-top': true,
            name: 'username',
            input: TextBox,
            inputId: 'account-recovery-username',
            type: 'text',
            inlineValidation: false
          }));

          if (smsEnabled || callEnabled) {
            formChildren.push(FormType.View({
              View: Okta.View.extend({
                template: _runtime.default.template({
                  "compiler": [8, ">= 4.3.0"],
                  "main": function main(container, depth0, helpers, partials, data) {
                    var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                      }

                      return undefined;
                    };

                    return "<p class=\"mobile-recovery-hint\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                      "name": "i18n",
                      "hash": {
                        "arguments": "mobileFactors",
                        "bundle": "login",
                        "code": "recovery.mobile.hint"
                      },
                      "data": data,
                      "loc": {
                        "start": {
                          "line": 1,
                          "column": 32
                        },
                        "end": {
                          "line": 1,
                          "column": 109
                        }
                      }
                    })) + "</p>";
                  },
                  "useData": true
                }),
                getTemplateData: function getTemplateData() {
                  var mobileFactors;

                  if (smsEnabled && callEnabled) {
                    mobileFactors = Okta.loc('recovery.smsOrCall');
                  } else if (callEnabled) {
                    mobileFactors = Okta.loc('recovery.call');
                  } else {
                    mobileFactors = Okta.loc('recovery.sms');
                  }

                  return {
                    mobileFactors: mobileFactors
                  };
                }
              })
            }));
          }

          if (smsEnabled) {
            this.$el.addClass('forgot-password-sms-enabled');
            formChildren.push(this.createRecoveryFactorButton('sms-button', 'password.forgot.sendText', Enums.RECOVERY_FACTOR_TYPE_SMS, this));
            this.setDefaultFactorType(Enums.RECOVERY_FACTOR_TYPE_SMS);
          }

          if (callEnabled) {
            this.$el.addClass('forgot-password-call-enabled');
            formChildren.push(this.createRecoveryFactorButton('call-button', 'password.forgot.call', Enums.RECOVERY_FACTOR_TYPE_CALL, this));
            this.setDefaultFactorType(Enums.RECOVERY_FACTOR_TYPE_CALL);
          }

          if (emailEnabled) {
            this.$el.addClass('forgot-password-email-enabled');
            formChildren.push(this.createRecoveryFactorButton('email-button', 'password.forgot.sendEmail', Enums.RECOVERY_FACTOR_TYPE_EMAIL, this));
            this.setDefaultFactorType(Enums.RECOVERY_FACTOR_TYPE_EMAIL);
          }
        }

        return formChildren;
      },
      initialize: function initialize() {
        this.listenTo(this.state, 'contactSupport', function () {
          this.add(ContactSupport, '.o-form-error-container');
        });
        this.listenTo(this, 'save', function () {
          this.options.appState.set('username', this.model.get('username'));
          this.model.save();
        });
      },
      setDefaultFactorType: function setDefaultFactorType(factorType) {
        if (_.isEmpty(this.model.get('factorType'))) {
          this.model.set('factorType', factorType);
        }
      },
      createRecoveryFactorButton: function createRecoveryFactorButton(className, labelCode, factorType, form) {
        return FormType.Button({
          attributes: {
            'data-se': className
          },
          className: 'button button-primary button-wide ' + className,
          title: Okta.loc(labelCode, 'login'),
          click: function click() {
            form.clearErrors();

            if (this.model.isValid()) {
              this.model.set('factorType', factorType);
              form.trigger('save', this.model);
            }
          }
        });
      }
    },
    Footer: Footer,
    initialize: function initialize() {
      this.options.appState.unset('username');
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8), __webpack_require__(10), __webpack_require__(84), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType, Enums, FooterSignout, TextBox) {
  var _ = Okta._;
  return FormController.extend({
    className: 'recovery-challenge',
    Model: {
      props: {
        passCode: ['string', true]
      },
      local: {
        ableToResend: 'boolean'
      },
      resendCode: function resendCode() {
        // Note: This does not require a trapAuthResponse because Backbone's
        // router will not navigate if the url path is the same
        this.limitResending();
        return this.doTransaction(function (transaction) {
          return transaction.resend();
        });
      },
      limitResending: function limitResending() {
        this.set({
          ableToResend: false
        });

        _.delay((0, _bind.default)(_).call(_, this.set, this), Enums.API_RATE_LIMIT, {
          ableToResend: true
        });
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          return transaction.verify({
            passCode: this.get('passCode')
          });
        });
      }
    },
    Form: {
      autoSave: true,
      save: _.partial(Okta.loc, 'mfa.challenge.verify', 'login'),
      title: function title() {
        if (this.options.appState.get('factorType') === Enums.RECOVERY_FACTOR_TYPE_CALL) {
          return Okta.loc('recoveryChallenge.call.title', 'login');
        } else {
          return Okta.loc('recoveryChallenge.sms.title', 'login');
        }
      },
      className: 'recovery-challenge',
      initialize: function initialize() {
        this.listenTo(this.model, 'error', function () {
          this.clearErrors();
        });
      },
      formChildren: function formChildren() {
        return [FormType.Button({
          title: Okta.loc('mfa.resendCode', 'login'),
          attributes: {
            'data-se': 'resend-button'
          },
          className: 'button sms-request-button margin-top-30',
          click: function click() {
            this.model.resendCode();
          },
          initialize: function initialize() {
            this.listenTo(this.model, 'change:ableToResend', function (model, ableToResend) {
              if (ableToResend) {
                this.options.title = Okta.loc('mfa.resendCode', 'login');
                this.enable();
                this.render();
              } else {
                this.options.title = Okta.loc('mfa.sent', 'login');
                this.disable();
                this.render();
              }
            });
          }
        }), FormType.Input({
          label: Okta.loc('mfa.challenge.enterCode.placeholder', 'login'),
          'label-top': true,
          className: 'enroll-sms-phone',
          name: 'passCode',
          input: TextBox,
          type: 'text'
        })];
      }
    },
    events: {
      'click .send-email-link': function clickSendEmailLink(e) {
        e.preventDefault();
        var settings = this.model.settings,
            username = this.options.appState.get('username'),
            recoveryType = this.options.appState.get('recoveryType');
        this.model.startTransaction(function (authClient) {
          // The user could have landed here via the Forgot Password/Unlock Account flow
          switch (recoveryType) {
            case Enums.RECOVERY_TYPE_PASSWORD:
              return authClient.forgotPassword({
                username: settings.transformUsername(username, Enums.FORGOT_PASSWORD),
                factorType: Enums.RECOVERY_FACTOR_TYPE_EMAIL
              });

            case Enums.RECOVERY_TYPE_UNLOCK:
              return authClient.unlockAccount({
                username: settings.transformUsername(username, Enums.UNLOCK_ACCOUNT),
                factorType: Enums.RECOVERY_FACTOR_TYPE_EMAIL
              });

            default:
              return;
          }
        });
      }
    },
    initialize: function initialize() {
      var recoveryType = this.options.appState.get('recoveryType'),
          sendEmailLink;

      switch (recoveryType) {
        case Enums.RECOVERY_TYPE_PASSWORD:
          sendEmailLink = _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "password.forgot.code.notReceived"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 63
                  }
                }
              }));
            },
            "useData": true
          });
          break;

        case Enums.RECOVERY_TYPE_UNLOCK:
          sendEmailLink = _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "account.unlock.code.notReceived"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 62
                  }
                }
              }));
            },
            "useData": true
          });
          break;

        default:
          break;
      }

      if (sendEmailLink && this.settings.get('features.emailRecovery')) {
        this.add(Okta.View.extend({
          className: 'link send-email-link',
          tagName: 'a',
          attributes: {
            href: '#',
            'data-se': 'send-email-link'
          },
          template: sendEmailLink
        }));
      }

      if (!this.settings.get('features.hideBackToSignInForReset')) {
        this.add(new FooterSignout(_.extend(this.toJSON(), {
          linkText: Okta.loc('goback', 'login'),
          linkClassName: ''
        })));
      }
    },
    postRender: function postRender() {
      this.model.limitResending();
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10), __webpack_require__(6), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums, FormController, FormType) {
  var _ = Okta._;
  return FormController.extend({
    className: 'password-reset-email-sent',
    Model: function Model() {
      return {
        local: {
          userFullName: ['string', false, this.options.appState.get('userFullName')]
        }
      };
    },
    Form: {
      title: _.partial(Okta.loc, 'password.forgot.emailSent.title', 'login'),
      subtitle: function subtitle() {
        var username = this.options.appState.get('username');
        return Okta.loc('password.forgot.emailSent.desc', 'login', [username]);
      },
      noButtonBar: true,
      attributes: {
        'data-se': 'pwd-reset-email-sent'
      },
      formChildren: function formChildren() {
        var children = [FormType.View({
          View: Okta.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var helper,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<span class=\"accessibility-text\" role=\"status\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "alert") || (depth0 != null ? lookupProperty(depth0, "alert") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "alert",
                  "hash": {},
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 47
                    },
                    "end": {
                      "line": 1,
                      "column": 56
                    }
                  }
                }) : helper)) + "</span>";
              },
              "useData": true
            }),
            getTemplateData: function getTemplateData() {
              return {
                'alert': Okta.loc('password.forgot.emailSent.title', 'login')
              };
            }
          })
        })];

        if (!this.settings.get('features.hideBackToSignInForReset')) {
          children.push(FormType.Button({
            title: Okta.loc('goback', 'login'),
            className: 'button button-primary button-wide',
            attributes: {
              'data-se': 'back-button'
            },
            click: function click() {
              var self = this;
              return this.model.doTransaction(function (transaction) {
                return transaction.cancel();
              }).then(function () {
                self.state.set('navigateDir', Enums.DIRECTION_BACK);
                self.options.appState.trigger('navigate', '');
              });
            }
          }));
        }

        return children;
      }
    },
    initialize: function initialize(options) {
      this.settings.callGlobalSuccess(Enums.FORGOT_PASSWORD_EMAIL_SENT, {
        username: options.appState.get('username')
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8), __webpack_require__(84), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType, FooterSignout, TextBox) {
  return FormController.extend({
    className: 'recovery-question',
    Model: {
      props: {
        answer: ['string', true],
        showAnswer: 'boolean'
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          return transaction.answer({
            answer: this.get('answer')
          });
        });
      }
    },
    Form: {
      autoSave: true,
      save: function save() {
        switch (this.options.appState.get('recoveryType')) {
          case 'PASSWORD':
            return Okta.loc('password.forgot.question.submit', 'login');

          case 'UNLOCK':
            return Okta.loc('account.unlock.question.submit', 'login');

          default:
            return Okta.loc('mfa.challenge.verify', 'login');
        }
      },
      title: function title() {
        switch (this.options.appState.get('recoveryType')) {
          case 'PASSWORD':
            return Okta.loc('password.forgot.question.title', 'login');

          case 'UNLOCK':
            return Okta.loc('account.unlock.question.title', 'login');

          default:
            return '';
        }
      },
      formChildren: function formChildren() {
        return [FormType.Input({
          label: this.options.appState.get('recoveryQuestion'),
          placeholder: Okta.loc('mfa.challenge.answer.placeholder', 'login'),
          name: 'answer',
          input: TextBox,
          type: 'password',
          initialize: function initialize() {
            this.listenTo(this.model, 'change:showAnswer', function () {
              var type = this.model.get('showAnswer') ? 'text' : 'password';
              this.getInputs()[0].changeType(type);
            });
          }
        }), FormType.Input({
          label: false,
          'label-top': true,
          placeholder: Okta.loc('mfa.challenge.answer.showAnswer', 'login'),
          className: 'recovery-question-show margin-btm-0',
          name: 'showAnswer',
          type: 'checkbox'
        })];
      }
    },
    initialize: function initialize() {
      if (!this.settings.get('features.hideBackToSignInForReset')) {
        this.addFooter(FooterSignout, {
          linkText: Okta.loc('goback', 'login'),
          linkClassName: ''
        });
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _concat = _interopRequireDefault(__webpack_require__(16));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8), __webpack_require__(144), __webpack_require__(32), __webpack_require__(24), __webpack_require__(84), __webpack_require__(26), __webpack_require__(361)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType, ValidationUtil, FactorUtil, Util, FooterSignout, TextBox, PasswordRequirements) {
  var _ = Okta._;
  return FormController.extend({
    className: 'password-reset',
    Model: {
      props: {
        newPassword: ['string', true],
        confirmPassword: ['string', true]
      },
      validate: function validate() {
        return ValidationUtil.validatePasswordMatch(this);
      },
      save: function save() {
        this.trigger('save');
        var self = this;
        return this.doTransaction(function (transaction) {
          return transaction.resetPassword({
            newPassword: self.get('newPassword')
          });
        });
      }
    },
    Form: {
      save: _.partial(Okta.loc, 'password.reset', 'login'),
      title: function title() {
        return this.settings.get('brandName') ? Okta.loc('password.reset.title.specific', 'login', [this.settings.get('brandName')]) : Okta.loc('password.reset.title.generic', 'login');
      },
      subtitle: function subtitle() {
        var policy = this.options.appState.get('policy');

        if (!policy || this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
          return;
        }

        return FactorUtil.getPasswordComplexityDescription(policy);
      },
      parseErrorMessage: function parseErrorMessage(responseJSON) {
        var policy = this.options.appState.get('policy');

        if (!!policy && this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
          /*
            - This is a specific case where don't want to repeat the requirements again in the error message, since this
              is already shown in the description. The description as bullet-points itself should give an indication
              of the requirements.
            - We cannot check for error code this in this case, as the error code is shared between
              requirements not met message, common password message, etc. So error summary is the only differentiating
              factor. Replace the password requirements string with empty string in this case.
          */
          responseJSON = FactorUtil.removeRequirementsFromError(responseJSON, policy);
        }

        return responseJSON;
      },
      formChildren: function formChildren() {
        var children = [];

        if (this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
          children.push(FormType.View({
            View: new PasswordRequirements({
              policy: this.options.appState.get('policy')
            })
          }));
        }

        children = (0, _concat.default)(children).call(children, [FormType.Input({
          className: 'margin-btm-5',
          label: Okta.loc('password.newPassword.placeholder', 'login'),
          'label-top': true,
          explain: Util.createInputExplain('password.newPassword.tooltip', 'password.newPassword.placeholder', 'login'),
          'explain-top': true,
          name: 'newPassword',
          input: TextBox,
          type: 'password'
        }), FormType.Input({
          label: Okta.loc('password.confirmPassword.placeholder', 'login'),
          'label-top': true,
          explain: Util.createInputExplain('password.confirmPassword.tooltip', 'password.confirmPassword.placeholder', 'login'),
          'explain-top': true,
          name: 'confirmPassword',
          input: TextBox,
          type: 'password'
        })]);
        return children;
      }
    },
    initialize: function initialize() {
      this.listenTo(this.form, 'save', function () {
        var creds = {
          username: this.options.appState.get('userEmail'),
          password: this.model.get('newPassword')
        };
        this.settings.processCreds(creds).then((0, _bind.default)(_).call(_, this.model.save, this.model));
      });

      if (!this.settings.get('features.hideBackToSignInForReset')) {
        this.addFooter(FooterSignout);
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController) {
  return FormController.extend({
    className: 'recovery-loading',
    Model: {},
    Form: {
      noButtonBar: true
    },
    initialize: function initialize(options) {
      var self = this;
      return this.model.startTransaction(function (authClient) {
        return authClient.verifyRecoveryToken({
          recoveryToken: options.token
        });
      }).catch(function () {
        self.options.appState.trigger('loading', false);
        self.options.appState.trigger('removeLoading');
      });
    },
    preRender: function preRender() {
      this.options.appState.trigger('loading', true);
    },
    trapAuthResponse: function trapAuthResponse() {
      this.options.appState.trigger('loading', false);
      return false;
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(10), __webpack_require__(8), __webpack_require__(24), __webpack_require__(144), __webpack_require__(362), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, Enums, FormType, Util, ValidationUtil, ContactSupport, TextBox) {
  var _ = Okta._;
  var noFactorsError = Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "account.unlock.noFactorsEnabled"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 110
            },
            "end": {
              "line": 1,
              "column": 172
            }
          }
        })) + "</p></div>";
      },
      "useData": true
    })
  });
  var Footer = Okta.View.extend({
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link goto js-contact-support\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "mfa.noAccessToEmail"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 173
            },
            "end": {
              "line": 1,
              "column": 223
            }
          }
        })) + "</a>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "goback"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 58
            },
            "end": {
              "line": 1,
              "column": 95
            }
          }
        })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "helpSupportNumber") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 99
            },
            "end": {
              "line": 1,
              "column": 234
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),
    className: 'auth-footer',
    events: {
      'click .js-back': function clickJsBack(e) {
        e.preventDefault();
        this.back();
      },
      'click .js-contact-support': function clickJsContactSupport(e) {
        e.preventDefault();
        this.state.trigger('contactSupport');
        this.$('.js-contact-support').hide();
      }
    },
    getTemplateData: function getTemplateData() {
      return this.settings.pick('helpSupportNumber');
    },
    back: function back() {
      this.state.set('navigateDir', Enums.DIRECTION_BACK);
      this.options.appState.trigger('navigate', '');
    }
  });
  return FormController.extend({
    className: 'account-unlock',
    Model: {
      props: {
        username: ['string', true],
        factorType: ['string', true]
      },
      validate: function validate() {
        return ValidationUtil.validateUsername(this);
      },
      save: function save() {
        var self = this;
        return this.startTransaction(function (authClient) {
          return authClient.unlockAccount({
            username: self.settings.transformUsername(self.get('username'), Enums.UNLOCK_ACCOUNT),
            factorType: self.get('factorType')
          });
        }).catch(function () {//need empty fail handler on model to display errors on form
        });
      }
    },
    Form: {
      noButtonBar: true,
      title: _.partial(Okta.loc, 'account.unlock.title', 'login'),
      formChildren: function formChildren() {
        /*eslint complexity: [2, 9] max-statements: [2, 24] */
        var smsEnabled = this.settings.get('features.smsRecovery');
        var callEnabled = this.settings.get('features.callRecovery');
        var emailEnabled = this.settings.get('features.emailRecovery');
        var noFactorsEnabled = !(smsEnabled || callEnabled || emailEnabled);
        var formChildren = [];
        var form = this;

        if (noFactorsEnabled) {
          this.add(noFactorsError, '.o-form-error-container');
        } else {
          formChildren.push(FormType.Input({
            label: Okta.loc('account.unlock.email.or.username.placeholder', 'login'),
            'label-top': true,
            explain: Util.createInputExplain('account.unlock.email.or.username.tooltip', 'account.unlock.email.or.username.placeholder', 'login'),
            'explain-top': true,
            name: 'username',
            input: TextBox,
            inputId: 'account-recovery-username',
            type: 'text',
            inlineValidation: false
          }));

          if (smsEnabled || callEnabled) {
            formChildren.push(FormType.View({
              View: Okta.View.extend({
                template: _runtime.default.template({
                  "compiler": [8, ">= 4.3.0"],
                  "main": function main(container, depth0, helpers, partials, data) {
                    var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                      }

                      return undefined;
                    };

                    return "<p class=\"mobile-recovery-hint\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                      "name": "i18n",
                      "hash": {
                        "arguments": "mobileFactors",
                        "bundle": "login",
                        "code": "recovery.mobile.hint"
                      },
                      "data": data,
                      "loc": {
                        "start": {
                          "line": 1,
                          "column": 32
                        },
                        "end": {
                          "line": 1,
                          "column": 109
                        }
                      }
                    })) + "</p>";
                  },
                  "useData": true
                }),
                getTemplateData: function getTemplateData() {
                  var mobileFactors;

                  if (smsEnabled && callEnabled) {
                    mobileFactors = Okta.loc('recovery.smsOrCall');
                  } else if (callEnabled) {
                    mobileFactors = Okta.loc('recovery.call');
                  } else {
                    mobileFactors = Okta.loc('recovery.sms');
                  }

                  return {
                    mobileFactors: mobileFactors
                  };
                }
              })
            }));
          }

          if (smsEnabled) {
            this.$el.addClass('forgot-password-sms-enabled');
            formChildren.push(this.createRecoveryFactorButton('sms-button', 'account.unlock.sendText', Enums.RECOVERY_FACTOR_TYPE_SMS, form));
            this.setDefaultFactorType(Enums.RECOVERY_FACTOR_TYPE_SMS);
          }

          if (callEnabled) {
            this.$el.addClass('forgot-password-call-enabled');
            formChildren.push(this.createRecoveryFactorButton('call-button', 'account.unlock.voiceCall', Enums.RECOVERY_FACTOR_TYPE_CALL, form));
            this.setDefaultFactorType(Enums.RECOVERY_FACTOR_TYPE_CALL);
          }

          if (emailEnabled) {
            this.$el.addClass('forgot-password-email-enabled');
            formChildren.push(this.createRecoveryFactorButton('email-button', 'account.unlock.sendEmail', Enums.RECOVERY_FACTOR_TYPE_EMAIL, form));
            this.setDefaultFactorType(Enums.RECOVERY_FACTOR_TYPE_EMAIL);
          }
        }

        return formChildren;
      },
      initialize: function initialize() {
        this.listenTo(this, 'save', function () {
          this.options.appState.set('username', this.model.get('username'));
          this.model.save();
        });
        this.listenTo(this.state, 'contactSupport', function () {
          this.add(ContactSupport, '.o-form-error-container');
        });
      },
      setDefaultFactorType: function setDefaultFactorType(factorType) {
        if (_.isEmpty(this.model.get('factorType'))) {
          this.model.set('factorType', factorType);
        }
      },
      createRecoveryFactorButton: function createRecoveryFactorButton(className, labelCode, factorType, form) {
        return FormType.Button({
          attributes: {
            'data-se': className
          },
          className: 'button button-primary button-wide ' + className,
          title: Okta.loc(labelCode, 'login'),
          click: function click() {
            form.clearErrors();

            if (this.model.isValid()) {
              this.model.set('factorType', factorType);
              form.trigger('save', this.model);
            }
          }
        });
      }
    },
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10), __webpack_require__(6), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums, FormController, FormType) {
  var _ = Okta._;
  return FormController.extend({
    className: 'account-unlocked',
    Model: function Model() {
      return {
        local: {
          userFullName: ['string', false, this.options.appState.get('userFullName')]
        }
      };
    },
    Form: {
      title: _.partial(Okta.loc, 'account.unlock.unlocked.title', 'login'),
      subtitle: _.partial(Okta.loc, 'account.unlock.unlocked.desc', 'login'),
      noButtonBar: true,
      attributes: {
        'data-se': 'account-unlocked'
      },
      formChildren: function formChildren() {
        return [FormType.Button({
          title: Okta.loc('goback', 'login'),
          className: 'button button-primary button-wide',
          attributes: {
            'data-se': 'back-button'
          },
          click: function click() {
            this.state.set('navigateDir', Enums.DIRECTION_BACK);
            this.options.appState.trigger('navigate', '');
          }
        })];
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10), __webpack_require__(6), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums, FormController, FormType) {
  var _ = Okta._;
  return FormController.extend({
    className: 'account-unlock-email-sent',
    Model: function Model() {
      return {
        local: {
          userFullName: ['string', false, this.options.appState.get('userFullName')]
        }
      };
    },
    Form: {
      title: _.partial(Okta.loc, 'account.unlock.emailSent.title', 'login'),
      subtitle: function subtitle() {
        var username = this.options.appState.get('username');
        return Okta.loc('account.unlock.emailSent.desc', 'login', [username]);
      },
      noButtonBar: true,
      attributes: {
        'data-se': 'unlock-email-sent'
      },
      formChildren: function formChildren() {
        return [FormType.Button({
          title: Okta.loc('goback', 'login'),
          className: 'button button-primary button-wide',
          attributes: {
            'data-se': 'back-button'
          },
          click: function click() {
            this.state.set('navigateDir', Enums.DIRECTION_BACK);
            this.options.appState.trigger('navigate', '');
          }
        })];
      }
    },
    initialize: function initialize(options) {
      this.settings.callGlobalSuccess(Enums.UNLOCK_ACCOUNT_EMAIL_SENT, {
        username: options.appState.get('username')
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable max-depth */

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (FormController) {
  return FormController.extend({
    className: 'refresh-auth-state',
    Model: {},
    Form: {
      noButtonBar: true
    },
    preRender: function preRender() {
      var appState = this.options.appState;
      var token = this.options.token;
      this.model.startTransaction(function (authClient) {
        appState.trigger('loading', true);

        if (token) {
          return authClient.tx.introspect({
            stateToken: token
          });
        } // get stateToken from cookie
        // currently only applies to old pipeline


        if (authClient.tx.exists()) {
          return authClient.tx.resume();
        }

        appState.trigger('navigate', '');
      });
    },
    remove: function remove() {
      this.options.appState.trigger('loading', false);
      return FormController.prototype.remove.apply(this, arguments);
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _find = _interopRequireDefault(__webpack_require__(18));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(36), __webpack_require__(849), __webpack_require__(850), __webpack_require__(126), __webpack_require__(10), __webpack_require__(363), __webpack_require__(851), __webpack_require__(56), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Q, RegistrationSchema, LoginModel, BaseLoginController, Enums, RegistrationFormFactory, SubSchema, Errors, Util) {
  var _ = Okta._,
      Backbone = Okta.Backbone;
  var Footer = Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link help\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "goback"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 50
            },
            "end": {
              "line": 1,
              "column": 87
            }
          }
        })) + "</a>";
      },
      "useData": true
    }),
    className: 'auth-footer',
    events: {
      'click .help': function clickHelp(e) {
        e.preventDefault();
        this.back();
      }
    },
    back: function back() {
      this.state.set('navigateDir', Enums.DIRECTION_BACK);
      this.options.appState.trigger('navigate', '');
    }
  });
  return BaseLoginController.extend({
    className: 'registration',
    initialize: function initialize() {
      // setup schema
      var Schema = RegistrationSchema.extend({
        settings: this.options.settings,
        url: this.options.settings.get('baseUrl') + '/api/v1/registration/form'
      });
      var schema = new Schema();
      this.state.set('schema', schema);
    },
    getRegistrationApiUrl: function getRegistrationApiUrl() {
      // default policyId
      var defaultPolicyId = this.settings.get('defaultPolicyId'); // org policyId

      var orgPolicyId = this.options.settings.get('policyId');
      var apiUrl = defaultPolicyId ? this.getRegistrationPolicyApi(defaultPolicyId) : this.getRegistrationPolicyApi(orgPolicyId);
      return apiUrl;
    },
    getRegistrationPolicyApi: function getRegistrationPolicyApi(policyId) {
      return this.options.settings.get('baseUrl') + '/api/v1/registration/' + policyId;
    },
    doPostSubmit: function doPostSubmit() {
      if (this.model.get('activationToken')) {
        // register via activation token
        var self = this;
        self.settings.callGlobalSuccess(Enums.REGISTRATION_COMPLETE, {
          activationToken: this.model.get('activationToken')
        });
        var loginModel = new LoginModel({
          settings: self.model.appState.settings
        });
        loginModel.loginWithActivationToken(this.model.get('activationToken')).then(function (transaction) {
          self.model.trigger('setTransaction', transaction);
        });
      } else {
        // register via activation email
        this.model.appState.set('username', this.model.get('email'));
        this.model.appState.trigger('navigate', 'signin/register-complete');
      }
    },
    registerUser: function registerUser(postData) {
      var self = this;
      this.model.attributes = postData; // Model.save returns a jqXHR

      Backbone.Model.prototype.save.call(this.model).then(function () {
        var activationToken = self.model.get('activationToken');
        var postSubmitData = activationToken ? activationToken : self.model.get('email');
        self.settings.postSubmit(postSubmitData, function () {
          self.doPostSubmit();
        }, function (errors) {
          self.showErrors(errors);
        });
      }).fail(function (err) {
        var responseJSON = err.responseJSON;

        if (responseJSON && responseJSON.errorCauses.length) {
          var errMsg = responseJSON.errorCauses[0].errorSummary;
          Util.triggerAfterError(self, new Errors.RegistrationError(errMsg));
        }
      });
    },
    createRegistrationModel: function createRegistrationModel(modelProperties) {
      var self = this;
      var Model = Okta.Model.extend({
        url: self.getRegistrationApiUrl() + '/register',
        settings: this.settings,
        appState: this.options.appState,
        props: modelProperties,
        local: {
          activationToken: 'string'
        },
        toJSON: function toJSON() {
          var data = Okta.Model.prototype.toJSON.apply(this, arguments);
          return {
            userProfile: data,
            relayState: this.settings.get('relayState')
          };
        },
        parse: function parse(resp) {
          this.set('activationToken', resp.activationToken);
          delete resp.activationToken;
          return resp;
        },
        save: function save() {
          this.settings.preSubmit(this.attributes, function (postData) {
            self.registerUser(postData);
          }, function (errors) {
            self.showErrors(errors);
          });
        }
      });
      return new Model();
    },
    showErrors: function showErrors(error, hideRegisterButton) {
      //for parseSchema error hide form and show error at form level
      if (error.callback === 'parseSchema' && error.errorCauses) {
        error.errorSummary = _.clone(error.errorCauses[0].errorSummary);
        delete error.errorCauses;
      } //show error on form


      this.model.trigger('error', this.model, {
        responseJSON: error
      }); //throw registration error

      var errMsg = error.callback ? error.callback + ':' + error.errorSummary : error.errorSummary;
      Util.triggerAfterError(this, new Errors.RegistrationError(errMsg));

      if (hideRegisterButton) {
        var _context;

        (0, _find.default)(_context = this.$el).call(_context, '.button-primary').hide();
      }
    },
    fetchInitialData: function fetchInitialData() {
      var self = this; // register parse complete event listener

      self.state.get('schema').on('parseComplete', function (updatedSchema) {
        var modelProperties = updatedSchema.properties.createModelProperties();
        self.settings.set('defaultPolicyId', updatedSchema.properties.defaultPolicyId); // create model

        self.model = self.createRegistrationModel(modelProperties); // create form

        var Form = Okta.Form.extend({
          layout: 'o-form-theme',
          autoSave: true,
          noCancelButton: true,
          title: Okta.loc('registration.form.title', 'login'),
          save: Okta.loc('registration.form.submit', 'login')
        });
        var form = new Form(self.toJSON()); // add form

        self.add(form); // add footer

        self.footer = new self.Footer(self.toJSON());
        self.add(self.footer);
        self.addListeners();

        if (updatedSchema.error) {
          self.showErrors(updatedSchema.error, true);
        } else {
          // add fields
          updatedSchema.properties.each(function (schemaProperty) {
            var inputOptions = RegistrationFormFactory.createInputOptions(schemaProperty);
            var subSchemas = schemaProperty.get('subSchemas');
            var name = schemaProperty.get('name');
            form.addInput(inputOptions);

            if (name === 'password' && subSchemas) {
              form.add(SubSchema.extend({
                id: 'subschemas-' + name,
                subSchemas: subSchemas
              }));
            }
          });

          var requiredFieldsLabel = _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var helper,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return "<span class=\"required-fields-label\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "label",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 36
                  },
                  "end": {
                    "line": 1,
                    "column": 45
                  }
                }
              }) : helper)) + "</span>";
            },
            "useData": true
          })({
            label: Okta.loc('registration.required.fields.label', 'login')
          });

          form.add(requiredFieldsLabel);
        }
      }); // fetch schema from API, returns a jqXHR. Wrap it in a Q

      return Q(this.state.get('schema').fetch());
    },
    Footer: Footer
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _sort = _interopRequireDefault(__webpack_require__(235));

var _bind = _interopRequireDefault(__webpack_require__(7));

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  var _ = Okta._;
  var _Okta$internal$models = Okta.internal.models,
      BaseSchema = _Okta$internal$models.BaseSchema,
      SchemaProperty = _Okta$internal$models.SchemaProperty;
  var RegistrationSchemaPropertyCollection = SchemaProperty.Collection.extend({
    createModelProperties: function createModelProperties() {
      var modelProperties = SchemaProperty.Collection.prototype.createModelProperties.apply(this);

      _.each(modelProperties, function (modelProperty, name) {
        modelProperty.required = !!this.get(name).get('required');
      }, this);

      return modelProperties;
    }
  });
  return BaseSchema.Model.extend({
    expand: ['schema'],
    constructor: function constructor() {
      this.properties = new RegistrationSchemaPropertyCollection();
      Okta.BaseModel.apply(this, arguments);
    },
    parse: function parse(resp) {
      var parseResponseData = (0, _bind.default)(_).call(_, function (resp) {
        var requireFields = resp.schema.required;

        if (_.isArray(requireFields)) {
          _.each(requireFields, function (requireField) {
            var field = this.properties.get(requireField);

            if (field) {
              field.set('required', true);
            }
          }, this);
        }

        var fieldOrderIds = resp.schema.fieldOrder;

        if (_.isArray(fieldOrderIds)) {
          var _context;

          _.each(fieldOrderIds, function (fieldOrderId, sortOrder) {
            var field = this.properties.get(fieldOrderId);

            if (field) {
              field.set('sortOrder', sortOrder);
            }
          }, this);

          this.properties.comparator = 'sortOrder';
          (0, _sort.default)(_context = this.properties).call(_context);
        }

        this.properties.defaultPolicyId = resp.policyId;
        return resp;
      }, this);
      var self = this;
      this.settings.parseSchema(resp, function (resp) {
        if (resp.profileSchema) {
          resp.schema = resp.profileSchema;
          BaseSchema.Model.prototype.parse.apply(self, [resp]);
          resp = parseResponseData(resp);
        }

        self.trigger('parseComplete', {
          properties: self.properties
        });
      }, function (error) {
        self.trigger('parseComplete', {
          properties: self.properties,
          error: error
        });
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(142)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, BaseLoginModel) {
  return BaseLoginModel.extend({
    constructor: function constructor(options) {
      this.settings = options && options.settings;
      Okta.Model.apply(this, arguments);
    },
    loginWithActivationToken: function loginWithActivationToken(activationToken) {
      return this.startTransaction(function (authClient) {
        return authClient.signIn({
          token: activationToken
        });
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _map = _interopRequireDefault(__webpack_require__(41));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  var SubSchema = Okta.View.extend({
    index: '',
    message: '',
    class: function _class() {
      return;
    },
    className: function className() {
      return 'subschema-unsatisfied subschema-' + this.index;
    },
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<p class=\"default-schema\"><span class=\"icon icon-16\"></span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "message",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 60
            },
            "end": {
              "line": 1,
              "column": 71
            }
          }
        }) : helper)) + "</p>";
      },
      "useData": true
    }),
    getTemplateData: function getTemplateData() {
      return {
        message: this.message
      };
    }
  });
  return Okta.View.extend({
    className: 'subschema',
    children: function children() {
      var _context;

      return (0, _map.default)(_context = this.subSchemas).call(_context, function (subSchema, index) {
        var description = subSchema.get('description'); // TODO API should send translated strings instead of i18n code inside description
        // or send param with i18n code

        var message = description;
        return SubSchema.extend({
          index: index,
          message: message
        });
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(10), __webpack_require__(6), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Enums, FormController, FormType) {
  return FormController.extend({
    events: {
      'click .back-btn': function clickBackBtn(e) {
        e.preventDefault();
        this.back();
      }
    },
    back: function back() {
      this.state.set('navigateDir', Enums.DIRECTION_BACK);
      this.options.appState.trigger('navigate', '');
    },
    className: 'registration-complete',
    Model: function Model() {},
    initialize: function initialize() {
      this.settings.callGlobalSuccess(Enums.ACTIVATION_EMAIL_SENT, {
        username: this.options.appState.get('username')
      });
    },
    Form: {
      noButtonBar: true,
      formChildren: function formChildren() {
        return [FormType.View({
          View: Okta.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var helper,
                    alias1 = depth0 != null ? depth0 : container.nullContext || {},
                    alias2 = container.hooks.helperMissing,
                    alias3 = "function",
                    alias4 = container.escapeExpression,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<div class=\"container\"><span class=\"title-icon icon icon-16 confirm-16-green\"></span><h2 class=\"title\">" + alias4((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
                  "name": "title",
                  "hash": {},
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 103
                    },
                    "end": {
                      "line": 1,
                      "column": 112
                    }
                  }
                }) : helper)) + "</h2><div class=\"desc\">" + alias4((helper = (helper = lookupProperty(helpers, "desc") || (depth0 != null ? lookupProperty(depth0, "desc") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
                  "name": "desc",
                  "hash": {},
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 135
                    },
                    "end": {
                      "line": 1,
                      "column": 143
                    }
                  }
                }) : helper)) + "</div></div><a href=\"#\" class=\"back-btn\" data-se=\"back-link\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "goback"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 204
                    },
                    "end": {
                      "line": 1,
                      "column": 241
                    }
                  }
                })) + "</a>";
              },
              "useData": true
            }),
            getTemplateData: function getTemplateData() {
              return {
                'desc': Okta.loc('registration.complete.confirm.text', 'login'),
                'title': Okta.loc('registration.complete.title', 'login')
              };
            }
          })
        })];
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _bind = _interopRequireDefault(__webpack_require__(7));

var _runtime = _interopRequireDefault(__webpack_require__(4));

/* eslint max-len: [2, 160] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8), __webpack_require__(854)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType, ScopeList) {
  var _ = Okta._;
  return FormController.extend({
    className: 'consent-required',
    initialize: function initialize() {
      this.model.set('expiresAt', this.options.appState.get('expiresAt'));
      this.model.set('scopes', this.options.appState.get('scopes'));
      this.listenTo(this.form, 'cancel', (0, _bind.default)(_).call(_, this.model.cancel, this.model));
    },
    postRender: function postRender() {
      FormController.prototype.postRender.apply(this, arguments); // Update the "don't allow" and "allow access" buttons to be neutral by changing "allow button" to be gray.

      this.$('.o-form-button-bar .button-primary').removeClass('button-primary');
    },
    Model: {
      props: {
        expiresAt: ['string', true],
        scopes: ['array', true]
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          return transaction.consent({
            consent: {
              expiresAt: this.get('expiresAt'),
              scopes: _.pluck(this.get('scopes'), 'name')
            }
          });
        });
      },
      cancel: function cancel() {
        var self = this;
        return this.doTransaction(function (transaction) {
          return transaction.cancel();
        }).then(function () {
          var consentCancelFn = self.settings.get('consent.cancel');

          if (_.isFunction(consentCancelFn)) {
            consentCancelFn();
          }
        });
      }
    },
    Form: {
      noCancelButton: false,
      autoSave: true,
      save: _.partial(Okta.loc, 'consent.required.consentButton', 'login'),
      cancel: _.partial(Okta.loc, 'consent.required.cancelButton', 'login'),
      formChildren: function formChildren() {
        return [FormType.View({
          View: Okta.View.extend({
            className: 'consent-title detail-row',
            template: _runtime.default.template({
              "1": function _(container, depth0, helpers, partials, data) {
                var helper,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<a href=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "clientURI",
                  "hash": {},
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 26
                    },
                    "end": {
                      "line": 1,
                      "column": 39
                    }
                  }
                }) : helper)) + "\" class=\"client-logo-link\" target=\"_blank\">";
              },
              "3": function _(container, depth0, helpers, partials, data) {
                var helper,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<img class=\"client-logo custom-logo\" src=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "customLogo",
                  "hash": {},
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 149
                    },
                    "end": {
                      "line": 1,
                      "column": 163
                    }
                  }
                }) : helper)) + "\" />";
              },
              "5": function _(container, depth0, helpers, partials, data) {
                var helper,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<img class=\"client-logo default-logo\" src=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "defaultLogo",
                  "hash": {},
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 218
                    },
                    "end": {
                      "line": 1,
                      "column": 233
                    }
                  }
                }) : helper)) + "\" />";
              },
              "7": function _(container, depth0, helpers, partials, data) {
                return "</a>";
              },
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var stack1,
                    alias1 = depth0 != null ? depth0 : container.nullContext || {},
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
                  "name": "if",
                  "hash": {},
                  "fn": container.program(1, data, 0),
                  "inverse": container.noop,
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 89
                    }
                  }
                })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
                  "name": "if",
                  "hash": {},
                  "fn": container.program(3, data, 0),
                  "inverse": container.program(5, data, 0),
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 89
                    },
                    "end": {
                      "line": 1,
                      "column": 244
                    }
                  }
                })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
                  "name": "if",
                  "hash": {},
                  "fn": container.program(7, data, 0),
                  "inverse": container.noop,
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 244
                    },
                    "end": {
                      "line": 1,
                      "column": 272
                    }
                  }
                })) != null ? stack1 : "") + "<span>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "arguments": "appName",
                    "bundle": "login",
                    "code": "consent.required.text"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 278
                    },
                    "end": {
                      "line": 1,
                      "column": 352
                    }
                  }
                })) != null ? stack1 : "") + "</span>";
              },
              "useData": true
            }),
            getTemplateData: function getTemplateData() {
              var appState = this.options.appState;
              return {
                appName: appState.escape('targetLabel'),
                customLogo: appState.get('targetLogo') && appState.get('targetLogo').href,
                defaultLogo: appState.get('defaultAppLogo'),
                clientURI: appState.get('targetClientURI') && appState.get('targetClientURI').href
              };
            }
          })
        }), FormType.View({
          View: new ScopeList({
            model: this.model
          })
        }), FormType.View({
          View: Okta.View.extend({
            className: 'consent-description detail-row',
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "consent.required.description"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 3
                    },
                    "end": {
                      "line": 1,
                      "column": 62
                    }
                  }
                })) + "</p>";
              },
              "useData": true
            })
          })
        })];
      }
    },
    Footer: Okta.View.extend({
      className: 'consent-footer',
      template: _runtime.default.template({
        "1": function _(container, depth0, helpers, partials, data) {
          var stack1,
              helper,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              alias2 = container.hooks.helperMissing,
              alias3 = container.escapeExpression,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return "<a class=\"terms-of-service\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "termsOfService") || (depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "termsOfService",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 56
              },
              "end": {
                "line": 1,
                "column": 74
              }
            }
          }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "consent.required.termsOfService"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 92
              },
              "end": {
                "line": 1,
                "column": 154
              }
            }
          })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(2, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 158
              },
              "end": {
                "line": 1,
                "column": 194
              }
            }
          })) != null ? stack1 : "");
        },
        "2": function _(container, depth0, helpers, partials, data) {
          return " &#8226 ";
        },
        "4": function _(container, depth0, helpers, partials, data) {
          var helper,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              alias2 = container.hooks.helperMissing,
              alias3 = container.escapeExpression,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return "<a class=\"privacy-policy\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "privacyPolicy") || (depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "privacyPolicy",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 254
              },
              "end": {
                "line": 1,
                "column": 271
              }
            }
          }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "consent.required.privacyPolicy"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 289
              },
              "end": {
                "line": 1,
                "column": 350
              }
            }
          })) + "</a>";
        },
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var stack1,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 201
              }
            }
          })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(4, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 201
              },
              "end": {
                "line": 1,
                "column": 361
              }
            }
          })) != null ? stack1 : "");
        },
        "useData": true
      }),
      getTemplateData: function getTemplateData() {
        var appState = this.options.appState;
        return {
          termsOfService: appState.get('targetTermsOfService') && appState.get('targetTermsOfService').href,
          privacyPolicy: appState.get('targetPrivacyPolicy') && appState.get('targetPrivacyPolicy').href
        };
      }
    })
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _forEach = _interopRequireDefault(__webpack_require__(28));

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(855)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, ScopeItem) {
  return Okta.View.extend({
    className: 'scope-list detail-row',
    postRender: function postRender() {
      var _context,
          _this = this;

      (0, _forEach.default)(_context = this.model.get('scopes')).call(_context, function (scope) {
        _this.add(ScopeItem, {
          options: {
            name: scope.displayName || scope.name,
            description: scope.description
          }
        });
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(176)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  return Okta.View.extend({
    className: 'scope-item',
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        return "<span class=\"scope-item-tooltip icon form-help-16\"></span>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"scope-item-text\"><p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
          "name": "name",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 32
            },
            "end": {
              "line": 1,
              "column": 40
            }
          }
        }) : helper)) + "</p></div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 50
            },
            "end": {
              "line": 1,
              "column": 134
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),
    postRender: function postRender() {
      this.$('.scope-item-tooltip').qtip({
        content: {
          text: this.options.description
        },
        style: {
          classes: 'okta-tooltip qtip-custom qtip-shadow'
        },
        position: {
          my: 'bottom right',
          target: 'mouse'
        }
      });
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _FormController = _interopRequireDefault(__webpack_require__(6));

var _FormType = _interopRequireDefault(__webpack_require__(8));

var _ScopeList = _interopRequireDefault(__webpack_require__(857));

var ConsentModel = {
  props: {
    scopes: ['array', true]
  },
  save: function save() {
    return this.doTransaction(function (transaction) {
      return transaction.consent({
        consent: {
          scopes: _okta._.pluck(this.get('scopes'), 'name')
        }
      });
    });
  },
  cancel: function cancel() {
    var self = this;
    return this.doTransaction(function (transaction) {
      return transaction.cancel();
    }).then(function () {
      var consentCancelFn = self.settings.get('consent.cancel');

      if (_okta._.isFunction(consentCancelFn)) {
        consentCancelFn();
      }
    });
  }
};

var ConsentHeader = _okta.View.extend({
  className: 'consent-title detail-row',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "clientURI",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 26
          },
          "end": {
            "line": 1,
            "column": 39
          }
        }
      }) : helper)) + "\" class=\"client-logo-link\" target=\"_blank\">";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<img class=\"client-logo custom-logo\" src=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "customLogo",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 149
          },
          "end": {
            "line": 1,
            "column": 163
          }
        }
      }) : helper)) + "\" />";
    },
    "5": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<img class=\"client-logo default-logo\" src=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "defaultLogo",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 218
          },
          "end": {
            "line": 1,
            "column": 233
          }
        }
      }) : helper)) + "\" />";
    },
    "7": function _(container, depth0, helpers, partials, data) {
      return "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 89
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.program(5, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 89
          },
          "end": {
            "line": 1,
            "column": 244
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 244
          },
          "end": {
            "line": 1,
            "column": 272
          }
        }
      })) != null ? stack1 : "") + "<span class=\"title-text\">" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "arguments": "appName",
          "bundle": "login",
          "code": "consent.required.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 297
          },
          "end": {
            "line": 1,
            "column": 371
          }
        }
      })) != null ? stack1 : "") + "</span><div class=\"issuer\"><span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "issuer") || (depth0 != null ? lookupProperty(depth0, "issuer") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "issuer",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 404
          },
          "end": {
            "line": 1,
            "column": 414
          }
        }
      }) : helper)) + "</span></div>";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var appState = this.options.appState;
    return {
      appName: appState.escape('targetLabel'),
      customLogo: appState.get('targetLogo') && appState.get('targetLogo').href,
      defaultLogo: appState.get('defaultAppLogo'),
      clientURI: appState.get('targetClientURI') && appState.get('targetClientURI').href,
      issuer: appState.get('issuer')
    };
  }
});

var ConsentForm = {
  noCancelButton: false,
  autoSave: true,
  save: _okta._.partial(_okta.loc, 'consent.required.consentButton', 'login'),
  cancel: _okta._.partial(_okta.loc, 'consent.required.cancelButton', 'login'),
  formChildren: [_FormType.default.View({
    View: ConsentHeader
  }), _FormType.default.View({
    View: _ScopeList.default
  })]
};

var AdminConsentRequiredController = _FormController.default.extend({
  Model: ConsentModel,
  Form: ConsentForm,
  className: 'admin-consent-required',
  initialize: function initialize() {
    var _this = this;

    this.model.set('scopes', this.options.appState.get('scopes'));
    this.listenTo(this.form, 'cancel', function () {
      _this.model.cancel();
    });
  }
});

module.exports = AdminConsentRequiredController;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _ScopeItem = _interopRequireDefault(__webpack_require__(858));

var SCOPE_N_GROUP_CONFIG = {
  groups: 'user',
  myAccount: 'user',
  users: 'user',
  apps: 'resource',
  authenticators: 'resource',
  authorizationServers: 'resource',
  clients: 'resource',
  factors: 'resource',
  idps: 'resource',
  linkedObjects: 'resource',
  policies: 'resource',
  templates: 'resource',
  eventHooks: 'hook',
  inlineHooks: 'hook',
  events: 'system',
  logs: 'system',
  orgs: 'system',
  roles: 'system',
  schemas: 'system',
  sessions: 'system',
  trustedOrigins: 'system'
};
var DEFAULT_GROUP = 'system';

var findScopeGroupKey = function findScopeGroupKey(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name;
  var xs = name.split('.');
  var groupType = xs[1];
  return SCOPE_N_GROUP_CONFIG[groupType] || DEFAULT_GROUP;
};

var ScopeGroupHeaderView = _okta.View.extend({
  className: 'scope-group',
  events: {
    'click': 'expandScopes'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"scope-group--header\"><h3>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "groupName") || (depth0 != null ? lookupProperty(depth0, "groupName") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "groupName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 37
          },
          "end": {
            "line": 1,
            "column": 50
          }
        }
      }) : helper)) + "</h3><span class=\"scope-group--toggle\"><svg class=\"caret\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"path\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.99967 4.66663L10.2663 8.66663L11.333 7.66663L5.99967 2.66663L0.666342 7.73636L1.73301 8.66663L5.99967 4.66663Z\" fill=\"#A0A7AC\"></path></svg></span></div>";
    },
    "useData": true
  }),
  expandScopes: function expandScopes() {
    this.$el.toggleClass('scope-group--is-expanded');
    this.$('.caret').toggleClass('caret--is-rotated');
  },
  preRender: function preRender() {
    var _this = this;

    _okta._.chain(this.options.scopes).sortBy(function (_ref2) {
      var name = _ref2.name;
      return name;
    }).each(function (_ref3) {
      var name = _ref3.name,
          displayName = _ref3.displayName,
          description = _ref3.description;

      _this.add(_ScopeItem.default, {
        options: {
          name: displayName || name,
          description: description
        }
      });
    });
  }
});

var _default = _okta.View.extend({
  className: 'scope-list detail-row',
  postRender: function postRender() {
    var _this2 = this;

    var allScopes = this.model.get('scopes');

    var scopesWithGroup = _okta._.groupBy(allScopes, findScopeGroupKey);

    var SCOPE_GROUP_NAMES_CONFIG = {
      'user': (0, _okta.loc)('admin.consent.group.user.group', 'login'),
      'resource': (0, _okta.loc)('admin.consent.group.resource.policy', 'login'),
      'hook': (0, _okta.loc)('admin.consent.group.hook', 'login'),
      'system': (0, _okta.loc)('admin.consent.group.system', 'login')
    }; // loop through SCOPE_GROUP_NAMES_CONFIG to keep group order consistent in UI.

    _okta._.each(SCOPE_GROUP_NAMES_CONFIG, function (groupName, groupKey) {
      var scopes = scopesWithGroup[groupKey];

      if (!(0, _isArray.default)(scopes)) {
        return;
      } // add scope group header and scopes


      _this2.add(ScopeGroupHeaderView, {
        options: {
          groupName: groupName,
          scopes: scopes
        }
      });
    });
  }
});

exports.default = _default;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

__webpack_require__(176);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  className: 'scope-item',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      return "<span class=\"scope-item-tooltip icon form-help-16\" />";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"scope-item-text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 27
          },
          "end": {
            "line": 1,
            "column": 35
          }
        }
      }) : helper)) + "</p>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 39
          },
          "end": {
            "line": 1,
            "column": 118
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  postRender: function postRender() {
    this.$('.scope-item-tooltip').qtip({
      content: {
        text: this.options.description
      },
      style: {
        classes: 'okta-tooltip qtip-custom qtip-shadow'
      },
      position: {
        my: 'bottom left',
        target: 'mouse'
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(860), __webpack_require__(126), __webpack_require__(861), __webpack_require__(350)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, EnrollUser, BaseLoginController, EnrollUserForm, FooterWithBackLink) {
  return BaseLoginController.extend({
    className: 'enroll-user',
    initialize: function initialize(options) {
      this.options = options || {}; // create model

      this.model = new EnrollUser(this.options);
    },
    fetchInitialData: function fetchInitialData() {
      // If user is unauthenticated and starts enroll flow make a post call to transition state to PROFILE_REQUIRED
      if (this.options.appState.get('isUnauthenticated')) {
        return this.model.getEnrollFormData();
      } else {
        return BaseLoginController.prototype.fetchInitialData.call();
      }
    },
    trapAuthResponse: function trapAuthResponse() {
      if (this.options.appState.get('isProfileRequired')) {
        return true;
      }
    },
    postRender: function postRender() {
      var form = new EnrollUserForm(this.toJSON());
      this.add(form);
      this.add(new FooterWithBackLink(this.toJSON()));
      this.addListeners();
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the 'License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(142)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, BaseLoginModel) {
  var _ = Okta._;
  return BaseLoginModel.extend({
    initialize: function initialize(options) {
      this.options = options || {};
      this.appState = this.options.appState;
    },
    constructPostData: function constructPostData(profileAttributes) {
      var postData = {
        'registration': {
          'profile': profileAttributes
        }
      }; // send createNewAccount flag for new user creation

      if (this.appState.get('policy').registration.createNewAccount) {
        postData.registration['createNewAccount'] = true;
      }

      return postData;
    },
    getEnrollFormData: function getEnrollFormData() {
      return this.manageTransaction(function (transaction, setTransaction) {
        return transaction.enroll().then(function (trans) {
          setTransaction(trans);
        });
      });
    },
    save: function save() {
      var data = BaseLoginModel.prototype.toJSON.apply(this, arguments);
      data = _.omit(data, ['appState', 'settings', 'createNewAccount']);

      if (_.isEmpty(data)) {
        var error = {
          'errorSummary': Okta.loc('oform.errorbanner.title', 'login')
        };
        this.trigger('error', this, {
          responseJSON: error
        });
      } else {
        return this.manageTransaction(function (transaction, setTransaction) {
          transaction.enroll(this.constructPostData(data)).then(function (trans) {
            setTransaction(trans);
          });
        });
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

/* eslint max-len: [2, 130] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(363), __webpack_require__(862)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, RegistrationFormFactory, ProfileSchema) {
  return Okta.Form.extend({
    layout: 'o-form-theme',
    autoSave: true,
    noCancelButton: true,
    title: Okta.loc('registration.form.title', 'login'),
    save: Okta.loc('registration.form.submit', 'login'),
    initialize: function initialize(options) {
      var _this = this;

      this.options = options || {};
      this.schema = new ProfileSchema({
        profileSchemaAttributes: this.options.appState.get('policy').registration.profile
      });
      this.schema.properties.each(function (schemaProperty) {
        var inputOptions = RegistrationFormFactory.createInputOptions(schemaProperty);

        _this.addInput(inputOptions);
      });

      var requiredFieldsLabel = _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var helper,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return "<span class=\"required-fields-label\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "label",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 36
              },
              "end": {
                "line": 1,
                "column": 45
              }
            }
          }) : helper)) + "</span>";
        },
        "useData": true
      })({
        label: Okta.loc('registration.required.fields.label', 'login')
      });

      this.add(requiredFieldsLabel);
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  var _ = Okta._;
  var BaseSchema = Okta.internal.models.BaseSchema;
  return BaseSchema.Model.extend({
    expand: ['schema'],
    setFieldPlaceholder: function setFieldPlaceholder(formFields) {
      _.each(formFields, function (formField) {
        formField.title = formField.label;
      });

      return formFields;
    },
    initialize: function initialize(options) {
      var profileAttributes = options.profileSchemaAttributes;
      profileAttributes = this.setFieldPlaceholder(profileAttributes);

      if (profileAttributes) {
        var userProfileSchema = {
          'properties': {}
        };

        for (var i = 0; i < profileAttributes.length; i++) {
          var profileAttributeObject = profileAttributes[i];
          userProfileSchema.properties[profileAttributeObject.name] = profileAttributeObject;
        }

        this.parse.apply(this, [{
          'schema': userProfileSchema
        }]);
      }
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _find = _interopRequireDefault(__webpack_require__(18));

var _runtime = _interopRequireDefault(__webpack_require__(4));

/* eslint complexity: [2, 8] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(36), __webpack_require__(32), __webpack_require__(864), __webpack_require__(182)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, Q, FactorUtil, FactorsDropDown, Factor) {
  return Okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div><div class=\"bg-helper auth-beacon auth-beacon-factor " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "className",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 171
            },
            "end": {
              "line": 1,
              "column": 184
            }
          }
        }) : helper)) + "\" data-se=\"factor-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div><div data-type=\"factor-types-dropdown\" class=\"factors-dropdown-wrap\"></div>";
      },
      "useData": true
    }),
    events: {
      'click .auth-beacon-factor': function clickAuthBeaconFactor(e) {
        e.preventDefault();
        e.stopPropagation();
        var expanded = this.$('.dropdown .options').toggle().is(':visible');
        this.$('a.option-selected').attr('aria-expanded', expanded);

        if (expanded) {
          var _context;

          (0, _find.default)(_context = this.$('#okta-dropdown-options')).call(_context, 'li.factor-option:first a').focus();
        }
      }
    },
    initialize: function initialize() {
      this.options.appState.set('beaconType', 'factor');
    },
    getTemplateData: function getTemplateData() {
      var factors = this.options.appState.get('factors'),
          factor,
          className;

      if (factors) {
        factor = FactorUtil.findFactorInFactorsArray(factors, this.options.provider, this.options.factorType);
      } else {
        factor = new Factor.Model(this.options.appState.get('factor'));
      }

      className = factor.get('iconClassName');
      return {
        className: className || ''
      };
    },
    postRender: function postRender() {
      if (this.options.animate) {
        this.$('.auth-beacon-factor').fadeIn(200);
      }

      var appState = this.options.appState;

      if (appState.get('hasMultipleFactorsAvailable')) {
        this.add(FactorsDropDown, '[data-type="factor-types-dropdown"]');
      }
    },
    fadeOut: function fadeOut() {
      var deferred = Q.defer();
      this.$('.auth-beacon-factor').fadeOut(200, function () {
        deferred.resolve();
      });
      return deferred.promise;
    },
    equals: function equals(Beacon, options) {
      return Beacon && this instanceof Beacon && options.provider === this.options.provider && (options.factorType === this.options.factorType || FactorUtil.isOktaVerify(options.provider, options.factorType) && FactorUtil.isOktaVerify(this.options.provider, this.options.factorType));
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _find = _interopRequireDefault(__webpack_require__(18));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(32), __webpack_require__(182), __webpack_require__(865)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FactorUtil, Factor, FactorsDropDownOptions) {
  var _ = Okta._,
      $ = Okta.$;
  var BaseDropDown = Okta.internal.views.components.BaseDropDown;
  $(document).click(function (e) {
    var $target = $(e.target);
    var isDropdown = $target.closest('.option-selected').length > 0 && $target.closest('.dropdown').length > 0;

    if (!isDropdown) {
      $('.dropdown .options').hide();
      $('.dropdown a.option-selected').attr('aria-expanded', false);
    }
  });
  return BaseDropDown.extend({
    className: 'bg-helper icon-button',
    screenReaderText: function screenReaderText() {
      var factors = this.options.appState.get('factors'),
          factor,
          factorLabel;

      if (factors) {
        factor = FactorUtil.findFactorInFactorsArray(factors, this.options.provider, this.options.factorType);
      } else {
        factor = new Factor.Model(this.options.appState.get('factor'), this.toJSON());
      }

      factorLabel = factor.get('factorLabel');
      return Okta.loc('mfa.factors.dropdown.sr.text', 'login', [factorLabel]);
    },
    events: {
      'click a.option-selected': function clickAOptionSelected(e) {
        e.preventDefault();

        if (_.result(this, 'disabled')) {
          e.stopPropagation();
        } else {
          var expanded = this.$('.options').toggle().is(':visible');
          this.$('a.option-selected').attr('aria-expanded', expanded);

          if (expanded) {
            var _context;

            (0, _find.default)(_context = this.$('#okta-dropdown-options')).call(_context, 'li.factor-option:first a').focus();
          }
        }
      },
      'click .dropdown-disabled': function clickDropdownDisabled(e) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    initialize: function initialize() {
      this.addOption(FactorsDropDownOptions.getDropdownOption('TITLE'));
      var factorsList = this.options.appState.get('factors');
      var multiplePushFactors = factorsList.hasMultipleFactorsOfSameType('push');
      factorsList.each(function (factor) {
        // Do not add okta totp if there are multiple okta push (each push will have an inline totp)
        if (!(factor.get('factorType') === 'token:software:totp' && multiplePushFactors)) {
          this.addOption(FactorsDropDownOptions.getDropdownOption(factor.get('factorName')), {
            model: factor
          });
          this.listenTo(this.last(), 'options:toggle', function () {
            this.$('.options').hide();
            this.$('a.option-selected').attr('aria-expanded', false);
          });
        }
      }, this);
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

/* eslint max-statements: [2, 16], complexity: [2, 10] */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(48)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, RouterUtil) {
  var _ = Okta._; // deviceName is escaped on BaseForm (see BaseForm's template)

  var pushTitleTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorName") || (depth0 != null ? lookupProperty(depth0, "factorName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "factorName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 14
          }
        }
      }) : helper)) + " (" + ((stack1 = (helper = (helper = lookupProperty(helpers, "deviceName") || (depth0 != null ? lookupProperty(depth0, "deviceName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "deviceName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 16
          },
          "end": {
            "line": 1,
            "column": 32
          }
        }
      }) : helper)) != null ? stack1 : "") + ")";
    },
    "useData": true
  });

  var _action = function action(model) {
    var factorIndex;
    var factorType = model.get('factorType');
    var factorsList = this.options.appState.get('factors');

    if (factorsList.hasMultipleFactorsOfSameType(factorType)) {
      factorIndex = factorsList.getFactorIndex(factorType, model.get('id'));
    }

    var url = RouterUtil.createVerifyUrl(model.get('provider'), factorType, factorIndex);
    var self = this;
    this.options.appState.trigger('factorSwitched');
    this.model.manageTransaction(function (transaction, setTransaction) {
      // FACTOR_CHALLENGE does not have a prev link
      if (transaction.status === 'FACTOR_CHALLENGE') {
        this.options.appState.set('trapMfaRequiredResponse', true);
      }

      if (transaction.status === 'MFA_CHALLENGE' && transaction.prev) {
        this.options.appState.set('trapMfaRequiredResponse', true);
        return transaction.prev().then(function (trans) {
          self.trigger('options:toggle');
          setTransaction(trans);
          self.options.appState.trigger('navigate', url);
        });
      } else {
        self.trigger('options:toggle');
        self.options.appState.trigger('navigate', url);
      }
    });
  };

  var dropdownOptions = {
    'TITLE': {
      title: _.partial(Okta.loc, 'mfa.factors.dropdown.title', 'login'),
      className: 'dropdown-list-title',
      disabled: true
    },
    'OKTA_VERIFY': {
      icon: 'factor-icon mfa-okta-verify-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'OKTA_VERIFY_PUSH': {
      icon: 'factor-icon mfa-okta-verify-30',
      className: 'factor-option',
      title: function title() {
        return pushTitleTpl({
          factorName: this.model.get('factorLabel'),
          deviceName: this.model.get('deviceName')
        });
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'GOOGLE_AUTH': {
      icon: 'factor-icon mfa-google-auth-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'CUSTOM_HOTP': {
      icon: 'factor-icon mfa-hotp-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'SYMANTEC_VIP': {
      icon: 'factor-icon mfa-symantec-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'RSA_SECURID': {
      icon: 'factor-icon mfa-rsa-30',
      className: 'factor-option',
      title: _.partial(Okta.loc, 'factor.totpHard.rsaSecurId', 'login'),
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'ON_PREM': {
      icon: 'factor-icon mfa-onprem-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'DUO': {
      icon: 'factor-icon mfa-duo-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'DUO_PUSH': {
      icon: 'duo-push-16',
      className: 'suboption factor-option',
      // TODO: add phone number here
      title: _.partial(Okta.loc, 'mfa.duoSecurity.push', 'login', ['XXX-XXX-7890'])
    },
    'DUO_SMS': {
      icon: 'duo-sms-16',
      className: 'suboption factor-option',
      // TODO: add phone number here
      title: _.partial(Okta.loc, 'mfa.duoSecurity.sms', 'login', ['XXX-XXX-7890'])
    },
    'DUO_CALL': {
      icon: 'duo-call-16',
      className: 'suboption factor-option',
      // TODO: add phone number here
      title: _.partial(Okta.loc, 'mfa.duoSecurity.call', 'login', ['XXX-XXX-7890'])
    },
    'YUBIKEY': {
      icon: 'factor-icon mfa-yubikey-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'SMS': {
      icon: 'factor-icon mfa-sms-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'CALL': {
      icon: 'factor-icon mfa-call-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'QUESTION': {
      icon: 'factor-icon mfa-question-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'PASSWORD': {
      icon: 'factor-icon mfa-password-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'WINDOWS_HELLO': {
      icon: 'factor-icon mfa-windows-hello-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'U2F': {
      icon: 'factor-icon mfa-u2f-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'WEBAUTHN': {
      icon: 'factor-icon mfa-webauthn-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'EMAIL': {
      icon: 'factor-icon mfa-email-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'GENERIC_SAML': {
      icon: 'factor-icon mfa-custom-factor-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'GENERIC_OIDC': {
      icon: 'factor-icon mfa-custom-factor-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    },
    'CUSTOM_CLAIMS': {
      icon: 'factor-icon mfa-custom-factor-30',
      className: 'factor-option',
      title: function title() {
        return this.model.get('factorLabel');
      },
      action: function action() {
        _action.call(this, this.model);
      }
    }
  };
  return {
    getDropdownOption: function getDropdownOption(factorName) {
      return dropdownOptions[factorName];
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta) {
  return Okta.View.extend({
    className: 'piv-beacon',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        return "<div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div><div class=\"bg-helper auth-beacon smartcard\" data-se=\"piv-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div>";
      },
      "useData": true
    }),
    equals: function equals(Beacon) {
      return Beacon && this instanceof Beacon;
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _find = _interopRequireDefault(__webpack_require__(18));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(82));

var _setInterval2 = _interopRequireDefault(__webpack_require__(169));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(6), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Okta, FormController, FormType) {
  return FormController.extend({
    className: 'poll',
    Model: {
      save: function save() {
        var _this = this;

        this.trigger('cancelRequest');
        return this.appState.get('transaction').cancel().then(function () {
          _this.options.appState.trigger('navigate', '');
        }).catch(function () {
          _this._stopCountDown();
        });
      }
    },
    Form: {
      autoSave: true,
      hasSavingState: false,
      title: function title() {
        return this.title;
      },
      className: 'poll-controller',
      noCancelButton: true,
      save: Okta.loc('oform.cancel', 'login'),
      modelEvents: {
        'cancelRequest': '_stopCountDown'
      },
      formChildren: [FormType.View({
        View: '<div >\
               <div data-se="poll-waiting" class="hide okta-waiting-spinner"></div>\
             </div>'
      })],
      _checkStatus: function _checkStatus() {
        var _this2 = this;

        // start polling request 
        this.transactionObject.poll().then(function (resp) {
          if (resp.data && resp.status !== 'POLL') {
            _this2.options.appState.set('transaction', resp);

            return;
          }

          _this2.$('.okta-waiting-spinner').hide();

          var factorPollingIntervalSeconds = Math.ceil(resp.transaction.profile.refresh / 1000);

          _this2._startCountDown(factorPollingIntervalSeconds);
        }).catch(function () {
          _this2._stopCountDown();
        });
      },
      _startCountDown: function _startCountDown(factorPollingIntervalSeconds) {
        var _this3 = this;

        // start one second countdown for next poll request
        this.countDown = (0, _setInterval2.default)(function () {
          // update title after every second and check if countdown == 1 to poll again
          _this3._updateTitle(factorPollingIntervalSeconds);

          if (factorPollingIntervalSeconds === 0) {
            /* when countdown hits 0
                         - stop current poll
                         - show spinner
                         - check status
                        */
            _this3._stopCountDown();

            _this3.$('.okta-waiting-spinner').show(); // start after a small delay so that the spinner does not get hidden too soon


            _this3.checkStatusTimeout = (0, _setTimeout2.default)(function () {
              _this3._checkStatus();
            }, 200);
          } else {
            // reduce countdown after every second
            factorPollingIntervalSeconds = factorPollingIntervalSeconds - 1;
          }
        }, 1000);
      },
      _updateTitle: function _updateTitle(factorPollingIntervalSeconds) {
        var _context;

        this.title = Okta.loc('polling.title', 'login', [factorPollingIntervalSeconds]);
        (0, _find.default)(_context = this.$el).call(_context, '.okta-form-title').text(this.title);
      },
      _stopCountDown: function _stopCountDown() {
        // clear countdown setInterval
        if (this.countDown) {
          clearInterval(this.countDown);
        } // clear checkstatus setTimeout


        if (this.checkStatusTimeout) {
          clearInterval(this.checkStatusTimeout);
        }
      },
      initialize: function initialize(options) {
        this.transactionObject = options.appState.get('transaction');
        this.factorPollingIntervalSeconds = Math.ceil(this.transactionObject.transaction.profile.refresh / 1000);

        this._updateTitle(this.factorPollingIntervalSeconds);

        this._startCountDown(this.factorPollingIntervalSeconds);
      }
    },
    back: function back() {// Empty function on verify controllers to prevent users
      // from navigating back during 'verify' using the browser's
      // back button. The URL will still change, but the view will not
      // More details in OKTA-135060.
    },
    remove: function remove() {
      this.form._stopCountDown();
    }
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _FormController = _interopRequireDefault(__webpack_require__(869));

var _BaseLoginRouter = _interopRequireDefault(__webpack_require__(941));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
module.exports = _BaseLoginRouter.default.extend({
  routes: {
    '': 'defaultAuth',
    '*wildcard': 'defaultAuth'
  },
  defaultAuth: function defaultAuth() {
    this.render(_FormController.default);
  }
});

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(7));

var _find = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(0);

var _ViewFactory = _interopRequireDefault(__webpack_require__(870));

var _IonResponseHelper = _interopRequireDefault(__webpack_require__(940));

var _ViewClassNamesFactory = __webpack_require__(366);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.Controller.extend({
  className: 'form-controller',
  appStateEvents: {
    'change:currentFormName': 'handleFormNameChange',
    'afterError': 'handleAfterError',
    'invokeAction': 'handleInvokeAction',
    'saveForm': 'handleSaveForm',
    'switchForm': 'handleSwitchForm'
  },
  preRender: function preRender() {
    this.removeChildren();
  },
  postRender: function postRender() {
    var currentViewState = this.options.appState.getCurrentViewState();

    if (!currentViewState) {
      return;
    }

    var TheView = _ViewFactory.default.create(currentViewState.name, this.options.appState.get('authenticatorType'));

    try {
      this.formView = this.add(TheView, {
        options: {
          currentViewState: currentViewState
        }
      }).last();
    } catch (error) {
      // This is the place where runtime error (NPE) happens at most of time.
      // It has been swallowed by Q.js hence add try/catch to surface up errors.
      this.options.settings.callGlobalError(error);
      return;
    }

    this.triggerAfterRenderEvent();
  },
  triggerAfterRenderEvent: function triggerAfterRenderEvent() {
    var contextData = this.createAfterEventContext();
    this.trigger('afterRender', contextData);
  },
  handleFormNameChange: function handleFormNameChange() {
    this.render();
  },
  handleAfterError: function handleAfterError() {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var contextData = this.createAfterEventContext();
    var errorContextData = {
      xhr: error,
      errorSummary: error.responseJSON && error.responseJSON.errorSummary
    }; // TODO: need some enhancement after https://github.com/okta/okta-idx-js/pull/27
    // OKTA-318062

    this.trigger('afterError', contextData, errorContextData);
  },
  createAfterEventContext: function createAfterEventContext() {
    var formName = this.options.appState.get('currentFormName');
    var authenticatorType = this.options.appState.get('authenticatorType');
    var methodType = this.options.appState.get('authenticatorMethodType');
    var isPasswordRecoveryFlow = this.options.appState.get('isPasswordRecoveryFlow');
    var v1ControllerClassName = (0, _ViewClassNamesFactory.getV1ClassName)(formName, authenticatorType, methodType, isPasswordRecoveryFlow);
    var eventData = {
      controller: v1ControllerClassName,
      formName: formName
    };

    if (authenticatorType) {
      eventData.authenticatorType = authenticatorType;
    }

    if (methodType && authenticatorType !== methodType) {
      eventData.methodType = methodType;
    }

    return eventData;
  },
  handleSwitchForm: function handleSwitchForm(formName) {
    // trigger formname change to change view
    this.options.appState.set('currentFormName', formName);
  },
  handleInvokeAction: function handleInvokeAction() {
    var _context,
        _this = this;

    var actionPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var idx = this.options.appState.get('idx');

    if ((0, _find.default)(_context = idx['neededToProceed']).call(_context, function (item) {
      return item.name === actionPath;
    })) {
      var _context2;

      idx.proceed(actionPath, {}).then((0, _bind.default)(_context2 = this.handleIdxSuccess).call(_context2, this)).catch(function (error) {
        _this.showFormErrors(_this.formView.model, error);
      });
      return;
    }

    var actionFn = idx['actions'][actionPath];

    if (_okta._.isFunction(actionFn)) {
      var _context3;

      // TODO: OKTA-243167
      // 1. what's the approach to show spinner indicating API in fligh?
      actionFn().then((0, _bind.default)(_context3 = this.handleIdxSuccess).call(_context3, this)).catch(function (error) {
        _this.showFormErrors(_this.formView.model, error);
      });
    } else {
      this.options.settings.callGlobalError("Invalid action selected: ".concat(actionPath));
      this.showFormErrors(this.formView.model, 'Invalid action selected.');
    }
  },
  handleSaveForm: function handleSaveForm(model) {
    var _context4,
        _context5,
        _this2 = this;

    var formName = model.get('formName');
    var idx = this.options.appState.get('idx');

    if (!(0, _find.default)(_context4 = idx['neededToProceed']).call(_context4, function (item) {
      return item.name === formName;
    })) {
      this.options.settings.callGlobalError("Cannot find http action for \"".concat(formName, "\"."));
      this.showFormErrors(this.formView.model, 'Cannot find action to proceed.');
      return;
    }

    this.toggleFormButtonState(true);
    model.trigger('request');
    idx.proceed(formName, model.toJSON()).then((0, _bind.default)(_context5 = this.handleIdxSuccess).call(_context5, this)).catch(function (error) {
      if (error.proceed && error.rawIdxState) {
        // Okta server responds 401 status code with WWW-Authenticate header and new remediation
        // so that the iOS/MacOS credential SSO extension (Okta Verify) can intercept
        // the response reaches here when Okta Verify is not installed
        // we need to return an idx object so that
        // the SIW can proceed to the next step without showing error
        _this2.handleIdxSuccess(error);
      } else {
        _this2.showFormErrors(model, error);
      }
    }).finally(function () {
      _this2.toggleFormButtonState(false);
    });
  },
  showFormErrors: function showFormErrors(model, error) {
    model.trigger('clearFormError');

    if (!error) {
      error = 'FormController - unknown error found';
      this.options.settings.callGlobalError(error);
    }

    if (_IonResponseHelper.default.isIonErrorResponse(error)) {
      var convertedErrors = _IonResponseHelper.default.convertFormErrors(error);

      var showBanner = convertedErrors.responseJSON.errorCauses.length ? false : true;
      model.trigger('error', model, convertedErrors, showBanner);
    } else if (error.errorSummary) {
      model.trigger('error', model, {
        responseJSON: error
      }, true);
    } else {
      model.trigger('error', model, {
        responseJSON: {
          errorSummary: String(error)
        }
      }, true);
    }
  },
  handleIdxSuccess: function handleIdxSuccess(idxResp) {
    this.options.appState.trigger('remediationSuccess', idxResp);
  },

  /**
   * SignIn widget has its own (hacky) way to customize the button disabled state:
   * adding `link-button-disabled` despite the name was intend only to disable
   * `link-button`.
   * Instead of doing decent refactor, we want to follow the convention for now.
   *
   * @param {boolean} disabled whether add extra disable CSS class.
   */
  toggleFormButtonState: function toggleFormButtonState(disabled) {
    var _context6;

    var button = (0, _find.default)(_context6 = this.$el).call(_context6, '.o-form-button-bar .button');
    button.toggleClass('link-button-disabled', disabled);
  }
});

exports.default = _default;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _concat = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(141));

var _Logger = _interopRequireDefault(__webpack_require__(64));

var _RemediationConstants = __webpack_require__(57);

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _IdentifierView = _interopRequireDefault(__webpack_require__(876));

var _TerminalView = _interopRequireDefault(__webpack_require__(880));

var _SuccessView = _interopRequireDefault(__webpack_require__(881));

var _DeviceChallengePollView = _interopRequireDefault(__webpack_require__(882));

var _SSOExtensionView = _interopRequireDefault(__webpack_require__(884));

var _EnrollProfileView = _interopRequireDefault(__webpack_require__(885));

var _SelectFactorEnrollView = _interopRequireDefault(__webpack_require__(886));

var _SelectFactorAuthenticateView = _interopRequireDefault(__webpack_require__(887));

var _SelectAuthenticatorEnrollView = _interopRequireDefault(__webpack_require__(888));

var _SelectAuthenticatorVerifyView = _interopRequireDefault(__webpack_require__(367));

var _EnrollFactorPasswordView = _interopRequireDefault(__webpack_require__(889));

var _RequiredFactorPasswordView = _interopRequireDefault(__webpack_require__(890));

var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(186));

var _ChallengeAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(891));

var _ReEnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(892));

var _ReEnrollAuthenticatorWarningPasswordView = _interopRequireDefault(__webpack_require__(893));

var _ResetAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(894));

var _EnrollAuthenticatorPhoneView = _interopRequireDefault(__webpack_require__(895));

var _EnrollAuthenticatorDataPhoneView = _interopRequireDefault(__webpack_require__(914));

var _ChallengeAuthenticatorPhoneView = _interopRequireDefault(__webpack_require__(369));

var _ChallengeAuthenticatorDataPhoneView = _interopRequireDefault(__webpack_require__(915));

var _EnrollAuthenticatorSecurityQuestionView = _interopRequireDefault(__webpack_require__(916));

var _ChallengeAuthenticatorSecurityQuestion = _interopRequireDefault(__webpack_require__(917));

var _RequiredFactorWebauthnView = _interopRequireDefault(__webpack_require__(918));

var _EnrollWebauthnView = _interopRequireDefault(__webpack_require__(919));

var _ChallengeWebauthnView = _interopRequireDefault(__webpack_require__(921));

var _EnrollAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(923));

var _RequiredFactorEmailView = _interopRequireDefault(__webpack_require__(924));

var _ChallengeAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(925));

var _EnrollPollOktaVerifyView = _interopRequireDefault(__webpack_require__(926));

var _SelectEnrollmentChannelOktaVerifyView = _interopRequireDefault(__webpack_require__(929));

var _EnrollementChannelDataOktaVerifyView = _interopRequireDefault(__webpack_require__(933));

var _ChallengeOktaVerifyView = _interopRequireDefault(__webpack_require__(934));

var _ChallengeOktaVerifyTotpView = _interopRequireDefault(__webpack_require__(937));

var _ChallengeOktaVerifyResendPushView = _interopRequireDefault(__webpack_require__(938));

var _ChallengeAuthenticatorDataOktaVerifyView = _interopRequireDefault(__webpack_require__(939));

var _VIEWS_MAPPING;

var DEFAULT = '_';
var VIEWS_MAPPING = (_VIEWS_MAPPING = {}, (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.IDENTIFY, (0, _defineProperty2.default)({}, DEFAULT, _IdentifierView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.DEVICE_CHALLENGE_POLL, (0, _defineProperty2.default)({}, DEFAULT, _DeviceChallengePollView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.DEVICE_APPLE_SSO_EXTENSION, (0, _defineProperty2.default)({}, DEFAULT, _SSOExtensionView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.CANCEL_TRANSACTION, (0, _defineProperty2.default)({}, DEFAULT, _SSOExtensionView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, 'select-factor-authenticate', (0, _defineProperty2.default)({}, DEFAULT, _SelectFactorAuthenticateView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, 'select-factor-enroll', (0, _defineProperty2.default)({}, DEFAULT, _SelectFactorEnrollView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.ENROLL_PROFILE, (0, _defineProperty2.default)({}, DEFAULT, _EnrollProfileView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, 'enroll-factor', {
  email: _RequiredFactorEmailView.default,
  // TODO EnrollFactorEmailView is unimplemented
  password: _EnrollFactorPasswordView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, 'challenge-factor', {
  email: _RequiredFactorEmailView.default,
  password: _RequiredFactorPasswordView.default,
  webauthn: _RequiredFactorWebauthnView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL, (0, _defineProperty2.default)({}, DEFAULT, _SelectAuthenticatorEnrollView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.AUTHENTICATOR_ENROLLMENT_DATA, {
  phone: _EnrollAuthenticatorDataPhoneView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.ENROLL_AUTHENTICATOR, {
  password: _EnrollAuthenticatorPasswordView.default,
  'security_key': _EnrollWebauthnView.default,
  phone: _EnrollAuthenticatorPhoneView.default,
  'security_question': _EnrollAuthenticatorSecurityQuestionView.default,
  email: _EnrollAuthenticatorEmailView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.ENROLL_POLL, {
  app: _EnrollPollOktaVerifyView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.SELECT_ENROLLMENT_CHANNEL, {
  app: _SelectEnrollmentChannelOktaVerifyView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.ENROLLMENT_CHANNEL_DATA, {
  app: _EnrollementChannelDataOktaVerifyView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.REENROLL_AUTHENTICATOR, {
  // Password expired scenario..
  password: _ReEnrollAuthenticatorPasswordView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.REENROLL_AUTHENTICATOR_WARNING, {
  // Password will expire soon scenario..
  password: _ReEnrollAuthenticatorWarningPasswordView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.RESET_AUTHENTICATOR, {
  // Admin driven password reset..
  password: _ResetAuthenticatorPasswordView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, (0, _defineProperty2.default)({}, DEFAULT, _SelectAuthenticatorVerifyView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.CHALLENGE_AUTHENTICATOR, {
  email: _ChallengeAuthenticatorEmailView.default,
  password: _ChallengeAuthenticatorPasswordView.default,
  webauthn: _RequiredFactorWebauthnView.default,
  'security_key': _ChallengeWebauthnView.default,
  'security_question': _ChallengeAuthenticatorSecurityQuestion.default,
  phone: _ChallengeAuthenticatorPhoneView.default,
  app: _ChallengeOktaVerifyTotpView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.CHALLENGE_POLL, {
  app: _ChallengeOktaVerifyView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.RESEND, {
  app: _ChallengeOktaVerifyResendPushView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.AUTHENTICATOR_VERIFICATION_DATA, {
  phone: _ChallengeAuthenticatorDataPhoneView.default,
  app: _ChallengeAuthenticatorDataOktaVerifyView.default
}), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.SUCCESS_REDIRECT, (0, _defineProperty2.default)({}, DEFAULT, _SuccessView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.REDIRECT_IDP, (0, _defineProperty2.default)({}, DEFAULT, _IdentifierView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.TERMINAL, (0, _defineProperty2.default)({}, DEFAULT, _TerminalView.default)), _VIEWS_MAPPING);
module.exports = {
  create: function create(formName) {
    var authenticatorType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT;
    var config = VIEWS_MAPPING[formName];

    if (!config) {
      _Logger.default.warn("Cannot find customized View for ".concat(formName, "."));

      return _BaseView.default;
    }

    var View = config[authenticatorType] || config[DEFAULT];

    if (!View) {
      var _context;

      _Logger.default.warn((0, _concat.default)(_context = "Cannot find customized View for ".concat(formName, " + ")).call(_context, authenticatorType, "."));

      return _BaseView.default;
    }

    return View;
  }
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var FactorRow = _okta.View.extend({
  className: 'enroll-factor-row clearfix',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"factor-description\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "description",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 250
          },
          "end": {
            "line": 1,
            "column": 265
          }
        }
      }) : helper)) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"enroll-factor-icon-container\"><div class=\"factor-icon enroll-factor-icon " + alias4((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 85
          },
          "end": {
            "line": 1,
            "column": 102
          }
        }
      }) : helper)) + "\"></div></div><div class=\"enroll-factor-description\"><h3 class=\"enroll-factor-label\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 187
          },
          "end": {
            "line": 1,
            "column": 196
          }
        }
      }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 201
          },
          "end": {
            "line": 1,
            "column": 276
          }
        }
      })) != null ? stack1 : "") + "<div class=\"enroll-factor-button\"></div></div>";
    },
    "useData": true
  }),
  children: function children() {
    return [[(0, _okta.createButton)({
      className: 'button select-factor',
      title: function title() {
        return 'Select';
      },
      click: function click() {
        this.model.trigger('selectFactor', this.model.get('value'));
      }
    }), '.enroll-factor-button']];
  },
  minimize: function minimize() {
    this.$el.addClass('enroll-factor-row-min');
  }
});

var _default = _okta.ListView.extend({
  className: 'enroll-factor-list',
  item: FactorRow,
  itemSelector: '.list-content',
  initialize: function initialize() {
    this.listenTo(this.collection, 'selectFactor', function (data) {
      this.model.set(this.options.name, data);
      this.options.appState.trigger('saveForm', this.model);
    });
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<div class=\"list-content\"></div>";
    },
    "useData": true
  })
});

exports.default = _default;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _RemediationConstants = __webpack_require__(57);

var _SkipOptionalEnrollmentButton = _interopRequireDefault(__webpack_require__(873));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var AuthenticatorRow = _okta.View.extend({
  className: 'authenticator-row clearfix',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"authenticator-description--text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "description",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 263
          },
          "end": {
            "line": 1,
            "column": 278
          }
        }
      }) : helper)) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"authenticator-icon-container\"><div class=\"factor-icon authenticator-icon " + alias4((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 85
          },
          "end": {
            "line": 1,
            "column": 102
          }
        }
      }) : helper)) + "\"></div></div><div class=\"authenticator-description\"><h3 class=\"authenticator-label\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 187
          },
          "end": {
            "line": 1,
            "column": 196
          }
        }
      }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 201
          },
          "end": {
            "line": 1,
            "column": 289
          }
        }
      })) != null ? stack1 : "") + "<div class=\"authenticator-button\"></div></div>";
    },
    "useData": true
  }),
  children: function children() {
    return [[(0, _okta.createButton)({
      className: 'button select-factor',
      title: function title() {
        return (0, _okta.loc)('oie.enroll.authenticator.button.text', 'login');
      },
      click: function click() {
        this.model.trigger('selectAutheticator', this.model.get('value'));
      }
    }), '.authenticator-button']];
  },
  minimize: function minimize() {
    this.$el.addClass('authenticator-row-min');
  }
});

var _default = _okta.ListView.extend({
  className: 'authenticator-enroll-list authenticator-list',
  item: AuthenticatorRow,
  itemSelector: '.list-content',
  initialize: function initialize() {
    this.listenTo(this.collection, 'selectAutheticator', function (data) {
      this.model.set(this.options.name, data);
      this.options.appState.trigger('saveForm', this.model);
    });
    this.hasOptionalFactors = this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.SKIP);

    if (this.hasOptionalFactors) {
      this.add(_SkipOptionalEnrollmentButton.default);
    }
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"list-content\"><div class=\"authenticator-list-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 64
          },
          "end": {
            "line": 1,
            "column": 73
          }
        }
      }) : helper)) + "</div></div>";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    // presence of the skip remediation form tells us that the authenticators are all optional
    var title = this.hasOptionalFactors ? (0, _okta.loc)('oie.setup.optional', 'login') : (0, _okta.loc)('oie.setup.required', 'login');
    return {
      title: title
    };
  }
});

exports.default = _default;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(0);

var _RemediationConstants = __webpack_require__(57);

var skipAll = (0, _okta.createButton)({
  className: 'button-primary button skip-all',
  title: function title() {
    return (0, _okta.loc)('oie.optional.authenticator.button.title', 'login');
  },
  click: function click() {
    this.options.appState.trigger('invokeAction', _RemediationConstants.FORMS.SKIP);
  }
});
var _default = skipAll;
exports.default = _default;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(141));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(0);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var convertUiSchemaFieldToProp = function convertUiSchemaFieldToProp(uiSchemaField) {
  var config = (0, _assign.default)({}, _okta._.chain(uiSchemaField).pick('minLength', 'maxLength', 'required', 'value').defaults({
    type: 'string',
    required: true
  }).value());

  if (uiSchemaField.modelType) {
    config.type = uiSchemaField.modelType;
  }

  return (0, _defineProperty2.default)({}, uiSchemaField.name, config);
};

var createPropsAndLocals = function createPropsAndLocals() {
  var remediation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var optionUiSchemaConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var local = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var uiSchemas = remediation.uiSchema || [];
  (0, _forEach.default)(uiSchemas).call(uiSchemas, function (schema) {
    if ((0, _isArray.default)(schema.optionsUiSchemas)) {
      var optionUiSchemaIndex;
      var optionUiSchemaValue = {};

      if (Number(schema.value) >= 0) {
        optionUiSchemaIndex = schema.value;
      }

      if (optionUiSchemaConfig[schema.name]) {
        optionUiSchemaValue = {
          value: optionUiSchemaConfig[schema.name]
        };
        optionUiSchemaIndex = Number(optionUiSchemaValue.value);
      }

      (0, _assign.default)(local, convertUiSchemaFieldToProp((0, _assign.default)({}, schema, optionUiSchemaValue)));

      if (optionUiSchemaIndex) {
        createPropsAndLocals({
          uiSchema: schema.optionsUiSchemas[optionUiSchemaIndex]
        }, optionUiSchemaConfig, props, local);
      }
    } else {
      (0, _assign.default)(props, convertUiSchemaFieldToProp(schema));
    }
  });
};

var create = function create() {
  var remediation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var optionUiSchemaConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var props = {};
  var local = {
    formName: 'string'
  };
  createPropsAndLocals(remediation, optionUiSchemaConfig, props, local);

  var BaseModel = _okta.Model.extend({
    props: props,
    local: local
  });

  return BaseModel;
};

module.exports = {
  create: create
};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Link = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 9
          }
        }
      }) : helper));
    },
    "useData": true
  }),
  tagName: 'a',
  attributes: function attributes() {
    var href = this.options.href || '#';
    return {
      'data-se': this.options.name,
      href: href
    };
  },
  className: function className() {
    var names = ['link'];

    if (this.options.name) {
      var nameToClass = this.options.name.replace(/[ ]/g, '-');
      names.push("js-".concat(nameToClass));
    }

    return names.join(' ');
  },
  postRender: function postRender() {
    var _this = this;

    // TODO OKTA-245224
    if (!this.options.href) {
      this.$el.click(function (event) {
        var appState = _this.options.appState;
        event.preventDefault();
        _this.options.formName ? appState.trigger('switchForm', _this.options.formName) : appState.trigger('invokeAction', _this.options.actionPath);
      });
    }
  }
});

module.exports = Link;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(16));

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _find = _interopRequireDefault(__webpack_require__(18));

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _okta = __webpack_require__(0);

var _RemediationConstants = __webpack_require__(57);

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseFooter = _interopRequireDefault(__webpack_require__(92));

var _SignInWithIdps = _interopRequireDefault(__webpack_require__(877));

var _CustomButtons = _interopRequireDefault(__webpack_require__(878));

var _SignInWithDeviceOption = _interopRequireDefault(__webpack_require__(879));

var _FormInputFactory = __webpack_require__(364);

var _LinksUtil = __webpack_require__(146);

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('primaryauth.title', 'login');
  },
  save: (0, _okta.loc)('oform.next', 'login'),
  render: function render() {
    _BaseForm.default.prototype.render.apply(this, arguments); // Launch Device Authenticator


    if (this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.LAUNCH_AUTHENTICATOR)) {
      this.add(_SignInWithDeviceOption.default, '.o-form-fieldset-container', false, true);
    } // This IdentifierView has been reused for the case when there is no `identify` remediation form
    // but only `redirect-idp` forms. At that case, no UI Schema.


    var hasUISchemas = this.getUISchema().length > 0; // add external idps buttons

    var idpButtons = (0, _FormInputFactory.createIdpButtons)(this.options.appState.get('remediations'));

    if ((0, _isArray.default)(idpButtons) && idpButtons.length) {
      this.add(_SignInWithIdps.default, {
        selector: '.o-form-button-bar',
        options: {
          idpButtons: idpButtons,
          addSeparateLine: hasUISchemas
        }
      });
    }

    var customButtons = (0, _FormInputFactory.createCustomButtons)(this.options.settings);

    if ((0, _isArray.default)(customButtons) && customButtons.length) {
      this.add(_CustomButtons.default, {
        selector: '.o-form-button-bar',
        options: {
          customButtons: customButtons,
          addSeparateLine: true
        }
      });
    }

    if (!hasUISchemas) {
      var _context;

      (0, _find.default)(_context = this.$el).call(_context, '.button-primary').hide();
    }
  },
  showMessages: function showMessages() {
    /**
     * Renders a warning callout for unknown user flow
     * Note: Anytime we get back `messages` object along with identify view
     * we would render it as a warning callout
     * */
    var messagesObj = this.options.appState.get('messages');

    if ((messagesObj === null || messagesObj === void 0 ? void 0 : messagesObj.value.length) && this.options.appState.get('currentFormName') === 'identify') {
      var content = messagesObj.value[0].message;
      var messageCallout = (0, _okta.createCallout)({
        content: content,
        type: 'warning'
      });
      this.add(messageCallout, '.o-form-error-container');
    }
  }
});

var Footer = _BaseFooter.default.extend({
  links: function links() {
    var _context3, _context4;

    var helpLinkHref;

    if (this.options.settings.get('helpLinks.help')) {
      helpLinkHref = this.options.settings.get('helpLinks.help');
    } else {
      var baseUrl = this.options.settings.get('baseUrl');
      helpLinkHref = baseUrl + '/help/login';
    }

    var helpLink = [{
      'name': 'help',
      'label': (0, _okta.loc)('help', 'login'),
      'href': helpLinkHref
    }];
    var signupLink = [];

    if (this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_ENROLL_PROFILE)) {
      signupLink.push({
        'type': 'link',
        'label': (0, _okta.loc)('signup', 'login'),
        'name': 'enroll',
        'actionPath': _RemediationConstants.FORMS.SELECT_ENROLL_PROFILE
      });
    }

    var forgotPasswordLink = (0, _LinksUtil.getForgotPasswordLink)(this.options.appState, this.options.settings);
    var customHelpLinks = [];

    if (this.options.settings.get('helpLinks.custom')) {
      var _context2;

      //add custom helpLinks
      (0, _forEach.default)(_context2 = this.options.settings.get('helpLinks.custom')).call(_context2, function (customHelpLink) {
        customHelpLink.name = 'custom';
        customHelpLink.label = customHelpLink.text;
        customHelpLinks.push(customHelpLink);
      });
    }

    return (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = (0, _concat.default)(forgotPasswordLink).call(forgotPasswordLink, signupLink)).call(_context4, helpLink)).call(_context3, customHelpLinks);
  }
});

var _default = _BaseView.default.extend({
  Body: Body,
  Footer: Footer,
  postRender: function postRender() {
    var _context5;

    _BaseView.default.prototype.postRender.apply(this, arguments); // If user enterted identifier is not found, API sends back a message with a link to sign up
    // This is the click handler for that link


    var appState = this.options.appState;
    (0, _find.default)(_context5 = this.$el).call(_context5, '.js-sign-up').click(function () {
      appState.trigger('invokeAction', _RemediationConstants.FORMS.SELECT_ENROLL_PROFILE);
      return false;
    });
  }
});

exports.default = _default;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _default = _okta.View.extend({
  className: 'sign-in-with-idp',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      return "<div class=\"separation-line\"><span>OR</span></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "addSeparateLine") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 80
          }
        }
      })) != null ? stack1 : "") + "<div class=\"okta-idps-container\"></div>";
    },
    "useData": true
  }),
  initialize: function initialize() {
    var _context,
        _this = this;

    (0, _forEach.default)(_context = this.options.idpButtons).call(_context, function (idpButton) {
      _this.add((0, _okta.createButton)(idpButton), '.okta-idps-container');
    });
  },
  getTemplateData: function getTemplateData() {
    var jsonData = _okta.View.prototype.getTemplateData.apply(this, arguments);

    return (0, _assign.default)(jsonData, {
      addSeparateLine: this.options.addSeparateLine
    });
  }
});

exports.default = _default;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _default = _okta.View.extend({
  className: 'custom-buttons',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      return "<div class=\"separation-line\"><span>OR</span></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "addSeparateLine") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 80
          }
        }
      })) != null ? stack1 : "") + "<div class=\"okta-custom-buttons-container primary-auth-container\"></div>";
    },
    "useData": true
  }),
  initialize: function initialize(options) {
    var _context,
        _this = this;

    (0, _forEach.default)(_context = options.customButtons).call(_context, function (idpButton) {
      _this.add((0, _okta.createButton)(idpButton), '.okta-custom-buttons-container');
    });
  },
  getTemplateData: function getTemplateData() {
    var jsonData = _okta.View.prototype.getTemplateData.apply(this, arguments);

    return (0, _assign.default)(jsonData, {
      addSeparateLine: this.options.addSeparateLine
    });
  }
});

exports.default = _default;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _default = _okta.View.extend({
  className: 'sign-in-with-device-option',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<div class=\"okta-verify-container\"></div><div class=\"separation-line\"><span>OR</span></div>";
    },
    "useData": true
  }),
  initialize: function initialize() {
    var appState = this.options.appState;
    this.add((0, _okta.createButton)({
      className: 'button',
      title: (0, _okta.loc)('oktaVerify.button', 'login'),
      click: function click() {
        appState.trigger('invokeAction', 'launch-authenticator');
      }
    }), '.okta-verify-container');
  }
});

exports.default = _default;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _okta = __webpack_require__(0);

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var Body = _BaseForm.default.extend({
  noButtonBar: true,
  postRender: function postRender() {
    _BaseForm.default.prototype.postRender.apply(this, arguments);

    this.$el.addClass('terminal-state');
  },
  showMessages: function showMessages() {
    var _this = this;

    var messagesObjs = this.options.appState.get('messages');

    if (messagesObjs && (0, _isArray.default)(messagesObjs.value)) {
      var _context;

      this.add('<div class="ion-messages-container"></div>', '.o-form-error-container');
      (0, _forEach.default)(_context = messagesObjs.value).call(_context, function (messagesObj) {
        var msg = messagesObj.message;

        if (messagesObj.class === 'ERROR') {
          _this.add((0, _okta.createCallout)({
            content: msg,
            type: 'error'
          }), '.o-form-error-container');
        } else {
          _this.add("<p>".concat(msg, "</p>"), '.ion-messages-container');
        }
      });
    }
  }
});

var _default = _BaseView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _Util = _interopRequireDefault(__webpack_require__(24));

var _okta = __webpack_require__(0);

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('oie.success.redirect', 'login');
  },
  noButtonBar: true,
  initialize: function initialize() {
    _BaseForm.default.prototype.initialize.apply(this, arguments); // TODO OKTA-250473
    // Form post for success redirect


    var url = this.options.currentViewState.href;

    _Util.default.redirectWithFormGet(url);
  },
  render: function render() {
    _BaseForm.default.prototype.render.apply(this, arguments);

    this.add('<div class="okta-waiting-spinner"></div>');
  }
});

var _default = _BaseView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _promise = _interopRequireDefault(__webpack_require__(242));

var _stringify = _interopRequireDefault(__webpack_require__(83));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseHeader = _interopRequireDefault(__webpack_require__(240));

var _HeaderBeacon = _interopRequireDefault(__webpack_require__(241));

var _BaseFooter = _interopRequireDefault(__webpack_require__(92));

var _Logger = _interopRequireDefault(__webpack_require__(64));

var _DeviceFingerprint = _interopRequireDefault(__webpack_require__(183));

var _polling = _interopRequireDefault(__webpack_require__(127));

var _Util = _interopRequireDefault(__webpack_require__(24));

/* global Promise */
var request = function request(opts) {
  var ajaxOptions = (0, _assign.default)({
    method: 'GET',
    contentType: 'application/json'
  }, opts);
  return _okta.$.ajax(ajaxOptions);
};

var Body = _BaseForm.default.extend((0, _assign.default)({
  noButtonBar: true,
  className: 'ion-form device-challenge-poll',
  events: {
    'click #launch-ov': function clickLaunchOv(e) {
      e.preventDefault();
      this.doCustomURI();
    }
  },
  initialize: function initialize() {
    _BaseForm.default.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'error', this.onPollingFail);
    this.deviceChallengePollRemediation = this.options.currentViewState;
    this.doChallenge();
    this.startPolling();
  },
  onPollingFail: function onPollingFail() {
    this.$('.spinner').hide();
    this.stopPolling();
  },
  remove: function remove() {
    _BaseForm.default.prototype.remove.apply(this, arguments);

    this.stopPolling();
  },
  doChallenge: function doChallenge() {
    var deviceChallenge = this.deviceChallengePollRemediation.relatesTo.value;

    switch (deviceChallenge.challengeMethod) {
      case 'LOOPBACK':
        this.title = (0, _okta.loc)('signin.with.fastpass', 'login');
        this.add(_okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              return "<div class=\"spinner\"></div>";
            },
            "useData": true
          })
        }));
        this.doLoopback(deviceChallenge.domain, deviceChallenge.ports, deviceChallenge.challengeRequest);
        break;

      case 'CUSTOM_URI':
        this.title = (0, _okta.loc)('customUri.title', 'login');
        this.subtitle = (0, _okta.loc)('customUri.subtitle', 'login');
        this.add(_okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var stack1,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "customUri.content"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 50
                  }
                }
              })) != null ? stack1 : "";
            },
            "useData": true
          })
        }));
        this.customURI = deviceChallenge.href;
        this.doCustomURI();
        break;

      case 'UNIVERSAL_LINK':
        this.title = (0, _okta.loc)('universalLink.title', 'login');
        this.add(_okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var stack1,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "universalLink.content"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 54
                  }
                }
              })) != null ? stack1 : "";
            },
            "useData": true
          })
        }));
        this.add((0, _okta.createButton)({
          className: 'ul-button button button-wide button-primary',
          title: (0, _okta.loc)('oktaVerify.button', 'login'),
          click: function click() {
            // only window.location.href can open universal link in iOS/MacOS
            // other methods won't do, ex, AJAX get or form get (Util.redirectWithFormGet)
            _Util.default.redirect(deviceChallenge.href);
          }
        }));
    }
  },
  doLoopback: function doLoopback() {
    var _this = this;

    var authenticatorDomainUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var ports = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var challengeRequest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var currentPort;
    var foundPort = false;
    var countFailedPorts = 0;

    var getAuthenticatorUrl = function getAuthenticatorUrl(path) {
      var _context, _context2;

      return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(authenticatorDomainUrl, ":")).call(_context2, currentPort, "/")).call(_context, path);
    };

    var checkPort = function checkPort() {
      return request({
        url: getAuthenticatorUrl('probe'),
        // in loopback server, SSL handshake sometimes takes more than 100ms and thus needs additional timeout
        // however, increasing timeout is a temporary solution since user will need to wait much longer in worst case
        // TODO: OKTA-278573 Android timeout is temporarily set to 3000ms and needs optimization post-Beta
        timeout: _DeviceFingerprint.default.isAndroid() ? 3000 : 100
      });
    };

    var onPortFound = function onPortFound() {
      foundPort = true;
      return request({
        url: getAuthenticatorUrl('challenge'),
        method: 'POST',
        data: (0, _stringify.default)({
          challengeRequest: challengeRequest
        }),
        timeout: 3000 // authenticator should respond within 3000ms for challenge request

      });
    };

    var onFailure = function onFailure() {
      _Logger.default.error("Something unexpected happened while we were checking port ".concat(currentPort, "."));
    };

    var doProbing = function doProbing() {
      return checkPort() // TODO: can we use standard ES6 promise methods, then/catch?
      .done(onPortFound).fail(onFailure);
    };

    var probeChain = _promise.default.resolve();

    (0, _forEach.default)(ports).call(ports, function (port) {
      probeChain = probeChain.then(function () {
        if (!foundPort) {
          currentPort = port;
          return doProbing();
        }
      }).catch(function () {
        countFailedPorts++;

        _Logger.default.error("Authenticator is not listening on port ".concat(currentPort, "."));

        if (countFailedPorts === ports.length) {
          _Logger.default.error('No available ports. Loopback server failed and polling is cancelled.');

          _this.options.appState.trigger('invokeAction', 'authenticatorChallenge-cancel');
        }
      });
    });
  },
  doCustomURI: function doCustomURI() {
    this.ulDom && this.ulDom.remove();
    this.ulDom = this.add("\n        <iframe src=\"".concat(this.customURI, "\" id=\"custom-uri-container\" style=\"display:none;\"></iframe>\n      ")).last();
  }
}, _polling.default));

var Footer = _BaseFooter.default.extend({
  links: function links() {
    var links = [];
    var deviceChallenge = this.options.currentViewState.relatesTo.value;

    if (deviceChallenge.challengeMethod === 'CUSTOM_URI') {
      links = [{
        name: 'sign-in-options',
        type: 'link',
        label: (0, _okta.loc)('goback', 'login'),
        href: this.settings.get('baseUrl')
      }];
    }

    return links;
  }
});

var _default = _BaseView.default.extend({
  Header: _BaseHeader.default.extend({
    HeaderBeacon: _HeaderBeacon.default.extend({
      getBeaconClassName: function getBeaconClassName() {
        return 'mfa-okta-verify';
      }
    })
  }),
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(322);

module.exports = parent;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _filter = _interopRequireDefault(__webpack_require__(37));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _Util = _interopRequireDefault(__webpack_require__(24));

var _okta = __webpack_require__(0);

// for BETA,
// redirect is needed for Apple SSO Extension to intercept the request, because
// - XHR request is not interceptable
// - form post is interceptable, but some app (Outlook) closes the app after
// We may have a different approach/UX for EA
var Body = _BaseForm.default.extend({
  noButtonBar: true,
  title: function title() {
    return (0, _okta.loc)('deviceTrust.sso.redirectText', 'login');
  },
  initialize: function initialize() {
    var _context,
        _this = this;

    _BaseForm.default.prototype.initialize.apply(this, arguments); // TODO: OKTA-286547
    // this should be handle by the foundation, not on the view level


    var method = (0, _filter.default)(_context = this.options.appState.get('remediations')).call(_context, function (v) {
      return v.name === _this.options.appState.get('currentFormName');
    })[0].method || '';

    if (method.toLowerCase() === 'get') {
      _Util.default.redirectWithFormGet(this.options.currentViewState.href);
    } else {
      this.add('<div class="spinner"></div>');
      this.options.appState.trigger('saveForm', this.model);
    }
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(0);

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseFooter = _interopRequireDefault(__webpack_require__(92));

var _RemediationConstants = __webpack_require__(57);

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('registration.form.title', 'login');
  },
  save: (0, _okta.loc)('registration.form.submit', 'login')
});

var Footer = _BaseFooter.default.extend({
  links: function links() {
    var links = [];

    if (this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_IDENTIFY)) {
      links.push({
        'type': 'link',
        'label': (0, _okta.loc)('haveaccount', 'login'),
        'name': 'back',
        'actionPath': _RemediationConstants.FORMS.SELECT_IDENTIFY
      });
    }

    return links;
  }
});

var _default = _BaseView.default.extend({
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _okta = __webpack_require__(0);

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('enroll.choices.setup', 'login');
  },
  subtitle: (0, _okta.loc)('enroll.choices.description', 'login'),
  noButtonBar: true
});

var _default = _BaseView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _okta = __webpack_require__(0);

var Body = _BaseForm.default.extend({
  title: function title() {
    if (this.isPasswordRecoveryFlow()) {
      return (0, _okta.loc)('password.reset.title.generic', 'login');
    }

    return (0, _okta.loc)('mfa.factors.dropdown.title', 'login');
  },
  subtitle: function subtitle() {
    if (this.isPasswordRecoveryFlow()) {
      return (0, _okta.loc)('password.reset.verification', 'login');
    }

    return (0, _okta.loc)('verify.choices.description', 'login');
  },
  isPasswordRecoveryFlow: function isPasswordRecoveryFlow() {
    var recoveryFactor = this.options.appState.get('recoveryFactor');
    return (recoveryFactor === null || recoveryFactor === void 0 ? void 0 : recoveryFactor.factorType) === 'password';
  },
  noButtonBar: true
});

var _default = _BaseView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _okta = __webpack_require__(0);

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('oie.select.authenticators.enroll.title', 'login');
  },
  subtitle: function subtitle() {
    var subtitle = this.options.settings.get('brandName') ? (0, _okta.loc)('oie.select.authenticators.enroll.subtitle.custom', 'login', [this.options.settings.get('brandName')]) : (0, _okta.loc)('oie.select.authenticators.enroll.subtitle', 'login');
    return subtitle;
  },
  noButtonBar: true
});

var _default = _BaseView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _okta = __webpack_require__(0);

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('enroll.password.setup', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('save.password', 'login');
  },
  getUISchema: function getUISchema() {
    var uiSchemas = _BaseForm.default.prototype.getUISchema.apply(this, arguments);

    return (0, _concat.default)(uiSchemas).call(uiSchemas, [{
      name: 'confirmPassword',
      label: (0, _okta.loc)('password.confirmPassword.placeholder', 'login'),
      type: 'password',
      'label-top': true,
      params: {
        showPasswordToggle: true
      }
    }]);
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  createModelClass: function createModelClass() {
    var ModelClass = _BaseView.default.prototype.createModelClass.apply(this, arguments);

    var local = (0, _assign.default)({
      confirmPassword: {
        type: 'string',
        required: true
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local: local,
      validate: function validate() {
        if (this.get('credentials.passcode') !== this.get('confirmPassword') && this.get('credential.value') !== this.get('confirmPassword')) {
          var ret = {};
          ret['confirmPassword'] = (0, _okta.loc)('password.error.match', 'login');
          return ret;
        }
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(16));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var recoveryLinkAction = 'factor-recover';

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('factor.password', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  }
});

var Footer = _AuthenticatorVerifyFooter.default.extend({
  links: function links() {
    var links = _AuthenticatorVerifyFooter.default.prototype.links.apply(this, arguments);

    if (this.options.appState.getActionByPath(recoveryLinkAction)) {
      var _context;

      links = (0, _concat.default)(_context = [{
        'type': 'link',
        'label': (0, _okta.loc)('forgotpassword', 'login'),
        'name': 'forgot-password',
        'actionPath': recoveryLinkAction
      }]).call(_context, links);
    }

    return links;
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(16));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _LinksUtil = __webpack_require__(146);

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('oie.password.challenge.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  }
});

var Footer = _AuthenticatorVerifyFooter.default.extend({
  links: function links() {
    var _context;

    var links = _AuthenticatorVerifyFooter.default.prototype.links.apply(this, arguments);

    links = (0, _concat.default)(_context = (0, _LinksUtil.getForgotPasswordLink)(this.options.appState, this.options.settings)).call(_context, links);
    return links;
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(0);

var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(186));

var Body = _EnrollAuthenticatorPasswordView.default.prototype.Body.extend({
  className: 'password-authenticator',
  title: function title() {
    var title = this.options.settings.get('brandName') ? (0, _okta.loc)('password.expired.title.specific', 'login', [this.options.settings.get('brandName')]) : (0, _okta.loc)('password.expired.title.generic', 'login');
    return title;
  },
  save: function save() {
    return (0, _okta.loc)('password.expired.submit', 'login');
  },
  getPasswordPolicySettings: function getPasswordPolicySettings() {
    return this.options.appState.get('recoveryAuthenticator').settings;
  }
});

var _default = _EnrollAuthenticatorPasswordView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(0);

var _BaseFooter = _interopRequireDefault(__webpack_require__(92));

var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(186));

var Body = _EnrollAuthenticatorPasswordView.default.prototype.Body.extend({
  className: 'password-authenticator',
  subtitle: function subtitle() {
    if (this.options.settings.get('brandName')) {
      return (0, _okta.loc)('password.expiring.subtitle.specific', 'login', [this.options.settings.get('brandName')]);
    }
  },
  title: function title() {
    var passwordPolicy = this.getPasswordPolicySettings() || {};
    var daysToExpiry = passwordPolicy.daysToExpiry;

    if (daysToExpiry > 0) {
      return (0, _okta.loc)('password.expiring.title', 'login', [daysToExpiry]);
    } else if (daysToExpiry === 0) {
      return (0, _okta.loc)('password.expiring.today', 'login');
    } else {
      return (0, _okta.loc)('password.expiring.soon', 'login');
    }
  },
  save: function save() {
    return (0, _okta.loc)('password.expired.submit', 'login');
  },
  showMessages: function showMessages() {
    // if brandName is configured and messages is present, render as subtitle with brandName in context
    if (this.options.settings.get('brandName')) {
      return null;
    } // else if brandName is not set, render messages object sent from server as text


    _EnrollAuthenticatorPasswordView.default.prototype.Body.prototype.showMessages.apply(this, arguments);
  }
});

var Footer = _BaseFooter.default.extend({
  links: function links() {
    var links = [];

    if (this.options.appState.hasRemediationObject('skip')) {
      links.push({
        'type': 'link',
        'label': (0, _okta.loc)('password.expiring.later', 'login'),
        'name': 'skip',
        'actionPath': 'skip'
      });
    }

    return links;
  }
});

var _default = _EnrollAuthenticatorPasswordView.default.extend({
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(0);

var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(186));

var Body = _EnrollAuthenticatorPasswordView.default.prototype.Body.extend({
  className: 'password-authenticator',
  title: function title() {
    var title = this.options.settings.get('brandName') ? (0, _okta.loc)('password.reset.title.specific', 'login', [this.options.settings.get('brandName')]) : (0, _okta.loc)('password.reset.title.generic', 'login');
    return title;
  },
  save: function save() {
    return (0, _okta.loc)('password.reset', 'login');
  }
});

var _default = _EnrollAuthenticatorPasswordView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(896);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(0);

var _ChallengeAuthenticatorPhoneView = _interopRequireWildcard(__webpack_require__(369));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var EnrollResendView = _ChallengeAuthenticatorPhoneView.ResendView.extend({
  // To be shown after a timeout
  className: 'phone-authenticator-enroll--warning hide',
  resendActionKey: 'currentAuthenticator-resend'
});

var Body = _ChallengeAuthenticatorPhoneView.default.prototype.Body.extend({
  className: 'phone-authenticator-enroll',
  title: function title() {
    return (0, _okta.loc)('oie.phone.enroll.title', 'login');
  },
  postRender: function postRender() {
    _BaseForm.default.prototype.postRender.apply(this, arguments);

    this.add(EnrollResendView, {
      selector: '.o-form-error-container',
      prepend: true
    });
  }
});

var _default = _ChallengeAuthenticatorPhoneView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$getOwnPropertyDescriptor = __webpack_require__(897);

var _Object$defineProperty = __webpack_require__(333);

var _typeof = __webpack_require__(29);

var _WeakMap = __webpack_require__(900);

function _getRequireWildcardCache() {
  if (typeof _WeakMap !== "function") return null;
  var cache = new _WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        _Object$defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(898);

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(368);

module.exports = parent;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var fails = __webpack_require__(20);
var toIndexedObject = __webpack_require__(59);
var nativeGetOwnPropertyDescriptor = __webpack_require__(104).f;
var DESCRIPTORS = __webpack_require__(39);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(901);

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(902);
__webpack_require__(906);
__webpack_require__(908);
__webpack_require__(910);
__webpack_require__(912);

module.exports = parent;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(174);
__webpack_require__(903);
__webpack_require__(79);
var path = __webpack_require__(15);

module.exports = path.WeakMap;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(22);
var redefineAll = __webpack_require__(178);
var InternalMetadataModule = __webpack_require__(184);
var collection = __webpack_require__(904);
var collectionWeak = __webpack_require__(905);
var isObject = __webpack_require__(31);
var enforceIternalState = __webpack_require__(80).enforce;
var NATIVE_WEAK_MAP = __webpack_require__(285);

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.github.io/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.REQUIRED = true;
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var global = __webpack_require__(22);
var InternalMetadataModule = __webpack_require__(184);
var fails = __webpack_require__(20);
var createNonEnumerableProperty = __webpack_require__(61);
var iterate = __webpack_require__(91);
var anInstance = __webpack_require__(179);
var isObject = __webpack_require__(31);
var setToStringTag = __webpack_require__(89);
var defineProperty = __webpack_require__(62).f;
var forEach = __webpack_require__(73).forEach;
var DESCRIPTORS = __webpack_require__(39);
var InternalStateModule = __webpack_require__(80);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var exported = {};
  var Constructor;

  if (!DESCRIPTORS || typeof NativeConstructor != 'function'
    || !(IS_WEAK || NativePrototype.forEach && !fails(function () { new NativeConstructor().entries().next(); }))
  ) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else {
    Constructor = wrapper(function (target, iterable) {
      setInternalState(anInstance(target, Constructor, CONSTRUCTOR_NAME), {
        type: CONSTRUCTOR_NAME,
        collection: new NativeConstructor()
      });
      if (iterable != undefined) iterate(iterable, target[ADDER], target, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    forEach(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in NativePrototype && !(IS_WEAK && KEY == 'clear')) {
        createNonEnumerableProperty(Constructor.prototype, KEY, function (a, b) {
          var collection = getInternalState(this).collection;
          if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
          var result = collection[KEY](a === 0 ? 0 : a, b);
          return IS_ADDER ? this : result;
        });
      }
    });

    IS_WEAK || defineProperty(Constructor.prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).collection.size;
      }
    });
  }

  setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: true }, exported);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(178);
var getWeakData = __webpack_require__(184).getWeakData;
var anObject = __webpack_require__(43);
var isObject = __webpack_require__(31);
var anInstance = __webpack_require__(179);
var iterate = __webpack_require__(91);
var ArrayIterationModule = __webpack_require__(73);
var $has = __webpack_require__(46);
var InternalStateModule = __webpack_require__(80);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.3.3.3 WeakMap.prototype.get(key)
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // 23.3.3.5 WeakMap.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // 23.4.3.1 WeakSet.prototype.add(value)
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var from = __webpack_require__(907);

// `WeakMap.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
$({ target: 'WeakMap', stat: true }, {
  from: from
});


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var aFunction = __webpack_require__(60);
var bind = __webpack_require__(88);
var iterate = __webpack_require__(91);

module.exports = function from(source /* , mapFn, thisArg */) {
  var length = arguments.length;
  var mapFn = length > 1 ? arguments[1] : undefined;
  var mapping, A, n, boundFunction;
  aFunction(this);
  mapping = mapFn !== undefined;
  if (mapping) aFunction(mapFn);
  if (source == undefined) return new this();
  A = [];
  if (mapping) {
    n = 0;
    boundFunction = bind(mapFn, length > 2 ? arguments[2] : undefined, 2);
    iterate(source, function (nextItem) {
      A.push(boundFunction(nextItem, n++));
    });
  } else {
    iterate(source, A.push, A);
  }
  return new this(A);
};


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var of = __webpack_require__(909);

// `WeakMap.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
$({ target: 'WeakMap', stat: true }, {
  of: of
});


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
module.exports = function of() {
  var length = arguments.length;
  var A = new Array(length);
  while (length--) A[length] = arguments[length];
  return new this(A);
};


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var IS_PURE = __webpack_require__(63);
var collectionDeleteAll = __webpack_require__(911);

// `WeakMap.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'WeakMap', proto: true, real: true, forced: IS_PURE }, {
  deleteAll: function deleteAll(/* ...elements */) {
    return collectionDeleteAll.apply(this, arguments);
  }
});


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(43);
var aFunction = __webpack_require__(60);

// https://github.com/tc39/collection-methods
module.exports = function (/* ...elements */) {
  var collection = anObject(this);
  var remover = aFunction(collection['delete']);
  var allDeleted = true;
  var wasDeleted;
  for (var k = 0, len = arguments.length; k < len; k++) {
    wasDeleted = remover.call(collection, arguments[k]);
    allDeleted = allDeleted && wasDeleted;
  }
  return !!allDeleted;
};


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var IS_PURE = __webpack_require__(63);
var $upsert = __webpack_require__(913);

// `WeakMap.prototype.upsert` method
// https://github.com/thumbsupep/proposal-upsert
$({ target: 'WeakMap', proto: true, real: true, forced: IS_PURE }, {
  upsert: $upsert
});


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(43);

// `Map.prototype.upsert` method
// https://github.com/thumbsupep/proposal-upsert
module.exports = function upsert(key, updateFn /* , insertFn */) {
  var map = anObject(this);
  var insertFn = arguments.length > 2 ? arguments[2] : undefined;
  var value;
  if (typeof updateFn != 'function' && typeof insertFn != 'function') {
    throw TypeError('At least one callback required');
  }
  if (map.has(key)) {
    value = map.get(key);
    if (typeof updateFn == 'function') {
      value = updateFn(value);
      map.set(key, value);
    }
  } else if (typeof insertFn == 'function') {
    value = insertFn();
    map.set(key, value);
  } return value;
};


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _trim = _interopRequireDefault(__webpack_require__(138));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _bind = _interopRequireDefault(__webpack_require__(7));

var _splice = _interopRequireDefault(__webpack_require__(109));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _findIndex = _interopRequireDefault(__webpack_require__(137));

var _find = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(0);

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _CountryUtil = _interopRequireDefault(__webpack_require__(145));

var _AuthenticatorEnrollFooter = _interopRequireDefault(__webpack_require__(93));

var Body = _BaseForm.default.extend({
  className: 'phone-authenticator-enroll',
  title: function title() {
    return (0, _okta.loc)('oie.phone.enroll.title', 'login');
  },
  subtitle: function subtitle() {
    return (0, _okta.loc)('oie.phone.enroll.subtitle', 'login');
  },
  render: function render() {
    _BaseForm.default.prototype.render.apply(this, arguments);

    var selectedMethod = this.model.get('authenticator.methodType');
    var phoneField = this.el.querySelector('.phone-authenticator-enroll__phone');
    var extensionField = this.el.querySelector('.phone-authenticator-enroll__phone-ext');

    if (selectedMethod === 'voice') {
      if (!phoneField.classList.contains('phone-authenticator-enroll__phone--small')) {
        phoneField.classList.add('phone-authenticator-enroll__phone--small');
      }

      extensionField.classList.remove('hide');
    }

    if (selectedMethod === 'sms') {
      phoneField.classList.remove('phone-authenticator-enroll__phone--small');

      if (!extensionField.classList.contains('hide')) {
        extensionField.classList.add('hide');
      }
    }

    this.el.querySelector('.phone-authenticator-enroll__phone-code').innerText = "+".concat(this.model.get('phoneCode'));
  },
  handlePhoneCodeChange: function handlePhoneCodeChange() {
    var countryCodeField = this.el.querySelector('.phone-authenticator-enroll__phone-code');
    countryCodeField.innerText = "+".concat(this.model.get('phoneCode'));
  },
  save: function save() {
    return this.model.get('authenticator.methodType') === 'voice' ? (0, _okta.loc)('oie.phone.call.primaryButton', 'login') : (0, _okta.loc)('oie.phone.sms.primaryButton', 'login');
  },
  getUISchema: function getUISchema() {
    var uiSchemas = _BaseForm.default.prototype.getUISchema.apply(this, arguments); // TODO: Using underscore to support IE, replace with Array.prototype methods (find, findIndex) when IE
    // support is removed


    var phoneNumberUISchema = (0, _find.default)(_okta._).call(_okta._, uiSchemas, function (_ref) {
      var name = _ref.name;
      return name === 'authenticator.phoneNumber';
    });
    var phoneNumberUISchemaIndex = (0, _findIndex.default)(_okta._).call(_okta._, uiSchemas, function (_ref2) {
      var name = _ref2.name;
      return name === 'authenticator.phoneNumber';
    });
    var countryUISchema = {
      'label-top': true,
      label: (0, _okta.loc)('country.label', 'login'),
      type: 'select',
      options: _CountryUtil.default.getCountries(),
      name: 'country',
      wide: true
    }; // Create an input group - serves as a display wrapper

    var phoneNumberWithCodeUISchema = {
      label: (0, _okta.loc)('mfa.phoneNumber.placeholder', 'login'),
      type: 'group',
      modelType: 'string',
      'label-top': true,
      name: 'phoneCode',
      className: 'phone-authenticator-enroll__phone',
      input: [{
        type: 'label',
        label: "+".concat(this.model.get('phoneCode')),
        className: 'phone-authenticator-enroll__phone-code'
      }, (0, _assign.default)({}, phoneNumberUISchema)]
    };
    var extensionUISchema = {
      label: (0, _okta.loc)('phone.extention.label', 'login'),
      type: 'text',
      // Need to manually hide and show
      // - toggleWhen puts display: block on the element when it unhides hence can't be used.
      //   Because in this case, the element needs to be rendered as an inline-block.
      // - showWhen has an animation on the element when unhiding
      //   The animation makes the element look weird because of the way it is positioned,
      //   hence can't be used
      className: 'phone-authenticator-enroll__phone-ext hide',
      'label-top': true,
      name: 'extension'
    };

    if (phoneNumberUISchemaIndex !== -1) {
      // Replace phoneNumberUISchema..
      (0, _splice.default)(uiSchemas).call(uiSchemas, phoneNumberUISchemaIndex, 1, phoneNumberWithCodeUISchema); // Add countryUISchema before & extensionUISchema after phone..

      (0, _splice.default)(uiSchemas).call(uiSchemas, phoneNumberUISchemaIndex, 0, countryUISchema);
      (0, _splice.default)(uiSchemas).call(uiSchemas, phoneNumberUISchemaIndex + 2, 0, extensionUISchema);
    }

    return uiSchemas;
  },
  initialize: function initialize() {
    var _context, _context2;

    _BaseForm.default.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'change:authenticator.methodType', (0, _bind.default)(_context = this.render).call(_context, this));
    this.listenTo(this.model, 'change:phoneCode', (0, _bind.default)(_context2 = this.handlePhoneCodeChange).call(_context2, this));
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorEnrollFooter.default,
  createModelClass: function createModelClass() {
    var ModelClass = _BaseView.default.prototype.createModelClass.apply(this, arguments);

    var local = (0, _assign.default)({
      country: {
        // Set default country to "US"
        'value': 'US',
        'type': 'string'
      },
      extension: {
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    var derived = (0, _assign.default)({
      phoneCode: {
        deps: ['country'],
        fn: function fn(country) {
          return _CountryUtil.default.getCallingCodeForCountry(country);
        }
      }
    }, ModelClass.prototype.derived);
    return ModelClass.extend({
      local: local,
      derived: derived,
      toJSON: function toJSON() {
        var _context3;

        var modelJSON = _okta.Model.prototype.toJSON.call(this, arguments);

        var extension = this.get('extension');
        var phoneCode = this.get('phoneCode'); // Add country code..

        var formattedPhoneNumber = (0, _concat.default)(_context3 = "+".concat(phoneCode)).call(_context3, modelJSON.authenticator.phoneNumber); // Add extension if present..

        if (modelJSON.authenticator.methodType === 'voice' && (extension === null || extension === void 0 ? void 0 : (0, _trim.default)(extension).call(extension).length)) {
          var _context4;

          formattedPhoneNumber = (0, _concat.default)(_context4 = "".concat(formattedPhoneNumber, "x")).call(_context4, extension);
        } // Override phone with formatted number..


        modelJSON.authenticator.phoneNumber = formattedPhoneNumber;
        return modelJSON;
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _find = _interopRequireDefault(__webpack_require__(18));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _okta = __webpack_require__(0);

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var Body = _BaseForm.default.extend({
  className: 'phone-authenticator-challenge',
  events: {
    'click a.phone-authenticator-challenge__link': 'handleSecondaryLinkClick'
  },
  title: function title() {
    return (0, _okta.loc)('oie.phone.verify.title', 'login');
  },
  save: function save() {
    return this.model.get('primaryMode') === 'sms' ? (0, _okta.loc)('oie.phone.sms.primaryButton', 'login') : (0, _okta.loc)('oie.phone.call.primaryButton', 'login');
  },
  handleSecondaryLinkClick: function handleSecondaryLinkClick() {
    // Call the API to send a code via secondary mode
    var secondaryMode = this.model.get('secondaryMode');
    this.model.set('authenticator.methodType', secondaryMode);
    this.saveForm(this.model);
  },
  initialize: function initialize() {
    var _context;

    _BaseForm.default.prototype.initialize.apply(this, arguments);

    var sendText = this.model.get('primaryMode') === 'sms' ? (0, _okta.loc)('oie.phone.verify.sms.sendText', 'login') : (0, _okta.loc)('oie.phone.verify.call.sendText', 'login'); // Courage doesn't support HTML, hence creating a subtitle here.

    this.add((0, _concat.default)(_context = "<div class=\"okta-form-subtitle\" data-se=\"o-form-explain\">".concat(sendText, "\n        <div><span class=\"strong\">")).call(_context, this.model.escape('phoneNumber'), "</span></div>\n        </div>"));
  },
  getUISchema: function getUISchema() {
    // Change the UI schema to not display radios here.
    var uiSchemas = _BaseForm.default.prototype.getUISchema.apply(this, arguments);

    return (0, _filter.default)(uiSchemas).call(uiSchemas, function (schema) {
      return schema.name !== 'authenticator.methodType';
    });
  },
  render: function render() {
    _BaseForm.default.prototype.render.apply(this, arguments);

    var secondaryMode = this.model.get('secondaryMode');

    if (secondaryMode) {
      var secondaryButtonTitle = secondaryMode === 'sms' ? (0, _okta.loc)('oie.phone.sms.secondaryButton', 'login') : (0, _okta.loc)('oie.phone.call.secondaryButton', 'login');
      this.add("<a href=\"#\"\n            class=\"link phone-authenticator-challenge__link\"\n            data-se=\"phone-authenticator-challenge__link\">".concat(secondaryButtonTitle, "</a>"), '.o-form-button-bar');
    }
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorVerifyFooter.default,
  createModelClass: function createModelClass(_ref) {
    var uiSchema = _ref.uiSchema;

    // It is important to get methods from here to maintain single source of truth.
    var _$find = (0, _find.default)(_okta._).call(_okta._, uiSchema, function (schema) {
      return schema.name === 'authenticator.methodType';
    }),
        methods = _$find.options;

    var relatesToObject = this.options.currentViewState.relatesTo;

    var _ref2 = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {},
        profile = _ref2.profile;

    var ModelClass = _BaseView.default.prototype.createModelClass.apply(this, arguments);

    var local = (0, _assign.default)({
      primaryMode: {
        'value': methods[0].value,
        'type': 'string'
      },
      secondaryMode: {
        'value': methods[1] && methods[1].value,
        'type': 'string'
      },
      phoneNumber: {
        'value': profile.phoneNumber,
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local: local
    });
  }
});

exports.default = _default;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorEnrollFooter = _interopRequireDefault(__webpack_require__(93));

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('oie.security.question.enroll.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorEnrollFooter.default
});

exports.default = _default;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _indexOf = _interopRequireDefault(__webpack_require__(45));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('oie.security.question.challenge.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  },
  getUISchema: function getUISchema() {
    var uiSchemas = _BaseForm.default.prototype.getUISchema.apply(this, arguments);

    var questionKey = (0, _filter.default)(uiSchemas).call(uiSchemas, function (s) {
      var _context;

      return (0, _indexOf.default)(_context = s.name).call(_context, 'questionKey') >= 0;
    });
    var answer = (0, _filter.default)(uiSchemas).call(uiSchemas, function (s) {
      var _context2;

      return (0, _indexOf.default)(_context2 = s.name).call(_context2, 'answer') >= 0;
    });
    /**
     * At verify SQ case,
     * 'questionKey' is read-only hence it won't show up in UI anyway.
     * 'answer' has label 'answer' but apparently UI want to display the
     * actual question (label of `questionKey`) as better user experience.
     */

    if (questionKey.length === 1 && answer.length === 1) {
      answer[0].label = questionKey[0].label;
    }

    return uiSchemas;
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorVerifyFooter.default
});

exports.default = _default;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseFooter = _interopRequireDefault(__webpack_require__(92));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _CryptoUtil = _interopRequireDefault(__webpack_require__(143));

var _webauthn = _interopRequireDefault(__webpack_require__(113));

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('factor.webauthn.biometric', 'login');
  },
  getUISchema: function getUISchema() {
    var _this = this;

    var schema = []; // Returning custom array so no input fields are displayed for webauthn

    if (_webauthn.default.isNewApiAvailable()) {
      var retryButton = (0, _okta.createButton)({
        className: 'retry-webauthn button-primary default-custom-button',
        title: (0, _okta.loc)('retry', 'login'),
        click: function click() {
          _this.getCredentialsAndSave();
        }
      });
      schema.push({
        View: _okta.View.extend({
          className: 'webauthn-verify-text idx-webauthn-verify-text',
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "verify.webauthn.biometric.instructions"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 3
                  },
                  "end": {
                    "line": 1,
                    "column": 72
                  }
                }
              })) + "</p><div data-se=\"webauthn-waiting\" class=\"okta-waiting-spinner\"></div>";
            },
            "useData": true
          })
        })
      }, {
        View: retryButton
      });
    }

    return schema;
  },
  remove: function remove() {
    _BaseForm.default.prototype.remove.apply(this, arguments);

    if (this.webauthnAbortController) {
      this.webauthnAbortController.abort();
      this.webauthnAbortController = null;
    }
  },
  noButtonBar: true,
  modelEvents: {
    'error': '_stopVerification'
  },
  getCredentialsAndSave: function getCredentialsAndSave() {
    var _this2 = this;

    this.clearErrors();

    this._startVerification();

    this.webauthnAbortController = new AbortController();
    var factor = this.options.appState.get('factor');
    var allowCredentials = [{
      type: 'public-key',
      id: _CryptoUtil.default.strToBin(factor.contextualData.profile.credentialId)
    }];
    var options = {
      allowCredentials: allowCredentials,
      challenge: _CryptoUtil.default.strToBin(factor.contextualData.challengeData.challenge)
    };
    navigator.credentials.get({
      publicKey: options,
      signal: this.webauthnAbortController.signal
    }).then(function (assertion) {
      _this2.model.set({
        credentials: {
          clientData: _CryptoUtil.default.binToStr(assertion.response.clientDataJSON),
          authenticatorData: _CryptoUtil.default.binToStr(assertion.response.authenticatorData),
          signatureData: _CryptoUtil.default.binToStr(assertion.response.signature)
        }
      });

      _this2.saveForm(_this2.model);
    }, function (error) {
      // Do not display if it is abort error triggered by code when switching.
      // this.webauthnAbortController would be null if abort was triggered by code.
      if (_this2.webauthnAbortController) {
        _this2.model.trigger('error', _this2.model, {
          responseJSON: {
            errorSummary: error.message
          }
        });
      }
    }).finally(function () {
      // unset webauthnAbortController on successful authentication or error
      _this2.webauthnAbortController = null;
    });
  },
  postRender: function postRender() {
    var _this3 = this;

    _okta._.defer(function () {
      if (_webauthn.default.isNewApiAvailable()) {
        _this3.getCredentialsAndSave();
      } else {
        _this3.model.trigger('error', _this3.model, {
          responseJSON: {
            errorSummary: (0, _okta.loc)('webauthn.biometric.error.factorNotSupported', 'login')
          }
        });

        _this3.$('[data-se="webauthn-waiting"]').hide();
      }
    });
  },
  _startVerification: function _startVerification() {
    this.$('.okta-waiting-spinner').show();
    this.$('.retry-webauthn').hide();
  },
  _stopVerification: function _stopVerification() {
    this.$('.okta-waiting-spinner').hide();
    this.$('.retry-webauthn').show();
  }
});

var Footer = _BaseFooter.default.extend({
  links: function links() {
    // recovery link
    var links = []; // check if we have a select-factor form in remediation, if so add a link

    if (this.options.appState.hasRemediationObject('select-factor')) {
      links.push({
        'type': 'link',
        'label': (0, _okta.loc)('mfa.switch', 'login'),
        'name': 'switchFactor',
        'formName': 'select-factor'
      });
    }

    return links;
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(18));

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _webauthn = _interopRequireDefault(__webpack_require__(113));

var _CryptoUtil = _interopRequireDefault(__webpack_require__(143));

var _EnrollWebauthnInfoView = _interopRequireDefault(__webpack_require__(920));

var _AuthenticatorEnrollFooter = _interopRequireDefault(__webpack_require__(93));

function getExcludeCredentials() {
  var authenticatorEnrollments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var credentials = [];
  (0, _forEach.default)(authenticatorEnrollments).call(authenticatorEnrollments, function (enrollement) {
    if (enrollement.type === 'security_key') {
      credentials.push({
        type: 'public-key',
        id: _CryptoUtil.default.strToBin(enrollement.credentialId)
      });
    }
  });
  return credentials;
}

var Body = _BaseForm.default.extend({
  title: (0, _okta.loc)('oie.enroll.webauthn.title', 'login'),
  className: 'oie-enroll-webauthn',
  modelEvents: {
    'error': '_stopEnrollment'
  },
  getUISchema: function getUISchema() {
    var _this = this;

    var schema = []; // Returning custom array so no input fields are displayed for webauthn

    if (_webauthn.default.isNewApiAvailable()) {
      schema.push({
        View: _EnrollWebauthnInfoView.default
      });
      schema.push({
        View: (0, _okta.createButton)({
          className: 'webauthn-setup button button-primary button-wide',
          title: (0, _okta.loc)('oie.enroll.webauthn.save', 'login'),
          click: function click() {
            _this.triggerWebauthnPrompt();
          }
        })
      });
    } else {
      schema.push({
        View: (0, _okta.createCallout)({
          className: 'webauthn-not-supported',
          type: 'error',
          subtitle: (0, _okta.loc)('oie.webauthn.error.not.supported', 'login')
        })
      });
    }

    return schema;
  },
  triggerWebauthnPrompt: function triggerWebauthnPrompt() {
    var _context,
        _this2 = this;

    (0, _find.default)(_context = this.$el).call(_context, '.o-form-error-container').empty();

    this._startEnrollment();

    var relatesToObject = this.options.currentViewState.relatesTo;
    var activationData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.activationData;

    if (_webauthn.default.isNewApiAvailable()) {
      var options = _okta._.extend({}, activationData, {
        challenge: _CryptoUtil.default.strToBin(activationData.challenge),
        user: {
          id: _CryptoUtil.default.strToBin(activationData.user.id),
          name: activationData.user.name,
          displayName: activationData.user.displayName
        },
        excludeCredentials: getExcludeCredentials(this.options.appState.get('authenticatorEnrollments').value)
      });

      this.webauthnAbortController = new AbortController();
      navigator.credentials.create({
        publicKey: options,
        signal: this.webauthnAbortController.signal
      }).then(function (newCredential) {
        _this2.model.set({
          credentials: {
            clientData: _CryptoUtil.default.binToStr(newCredential.response.clientDataJSON),
            attestation: _CryptoUtil.default.binToStr(newCredential.response.attestationObject)
          }
        });

        _this2.saveForm(_this2.model);
      }).catch(function (error) {
        _this2.model.trigger('error', _this2.model, {
          responseJSON: {
            errorSummary: error.message
          }
        });
      }).finally(function () {
        _this2.webauthnAbortController = null;
      });
    }
  },
  _startEnrollment: function _startEnrollment() {
    this.$('.okta-waiting-spinner').show();
    this.$('.webauthn-setup').hide();
  },
  _stopEnrollment: function _stopEnrollment() {
    this.$('.okta-waiting-spinner').hide();
    this.$('.webauthn-setup').show();
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorEnrollFooter.default,
  postRender: function postRender() {
    var _context2;

    _BaseAuthenticatorView.default.prototype.postRender.apply(this, arguments);

    (0, _find.default)(_context2 = this.$el).call(_context2, '.o-form-button-bar [type="submit"]').remove();
  }
});

exports.default = _default;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(75));

var _default = _okta.View.extend({
  // eslint-disable-next-line max-len
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"idx-webauthn-enroll-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.webauthn.instructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 36
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      })) + "</p>";
    },
    "useData": true
  }),
  initialize: function initialize() {
    var relatesToObject = this.options.currentViewState.relatesTo;
    var activationData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.activationData;

    if (_BrowserFeatures.default.isEdge()) {
      this.add(_okta.View.extend({
        tagName: 'p',
        className: 'idx-webauthn-enroll-text-edge',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "oie.enroll.webauthn.instructions.edge"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 68
                }
              }
            }));
          },
          "useData": true
        })
      }));
    }

    if (activationData.authenticatorSelection.userVerification === 'required') {
      this.add((0, _okta.createCallout)({
        className: 'uv-required-callout',
        size: 'slim',
        type: 'warning',
        subtitle: (0, _okta.loc)('oie.enroll.webauthn.uv.required.instructions', 'login')
      }));
    }

    this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
  }
});

exports.default = _default;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _CryptoUtil = _interopRequireDefault(__webpack_require__(143));

var _webauthn = _interopRequireDefault(__webpack_require__(113));

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var _ChallengeWebauthnInfoView = _interopRequireDefault(__webpack_require__(922));

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('oie.verify.webauth.title', 'login');
  },
  className: 'oie-verify-webauthn',
  getUISchema: function getUISchema() {
    var _this = this;

    var schema = []; // Returning custom array so no input fields are displayed for webauthn

    if (_webauthn.default.isNewApiAvailable()) {
      var retryButton = (0, _okta.createButton)({
        className: 'retry-webauthn button-primary default-custom-button',
        title: (0, _okta.loc)('retry', 'login'),
        click: function click() {
          _this.getCredentialsAndSave();
        }
      });
      schema.push({
        View: _ChallengeWebauthnInfoView.default
      }, {
        View: retryButton
      });
    } else {
      schema.push({
        View: (0, _okta.createCallout)({
          className: 'webauthn-not-supported',
          type: 'error',
          subtitle: (0, _okta.loc)('oie.webauthn.error.not.supported', 'login')
        })
      });
    }

    return schema;
  },
  remove: function remove() {
    _BaseForm.default.prototype.remove.apply(this, arguments);

    if (this.webauthnAbortController) {
      this.webauthnAbortController.abort();
      this.webauthnAbortController = null;
    }
  },
  noButtonBar: true,
  modelEvents: {
    'error': '_stopVerification'
  },
  getCredentialsAndSave: function getCredentialsAndSave() {
    var _this2 = this;

    this.clearErrors();

    this._startVerification();

    this.webauthnAbortController = new AbortController();
    var relatesToObject = this.options.currentViewState.relatesTo;
    var authenticatorData = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {};
    var allowCredentials = [];
    var authenticatorEnrollments = this.options.appState.get('authenticatorEnrollments').value || [];
    (0, _forEach.default)(authenticatorEnrollments).call(authenticatorEnrollments, function (enrollement) {
      if (enrollement.type === 'security_key') {
        allowCredentials.push({
          type: 'public-key',
          id: _CryptoUtil.default.strToBin(enrollement.credentialId)
        });
      }
    });
    var options = {
      allowCredentials: allowCredentials,
      userVerification: authenticatorData.contextualData.challengeData.userVerification,
      challenge: _CryptoUtil.default.strToBin(authenticatorData.contextualData.challengeData.challenge)
    };
    navigator.credentials.get({
      publicKey: options,
      signal: this.webauthnAbortController.signal
    }).then(function (assertion) {
      _this2.model.set({
        credentials: {
          clientData: _CryptoUtil.default.binToStr(assertion.response.clientDataJSON),
          authenticatorData: _CryptoUtil.default.binToStr(assertion.response.authenticatorData),
          signatureData: _CryptoUtil.default.binToStr(assertion.response.signature)
        }
      });

      _this2.saveForm(_this2.model);
    }, function (error) {
      // Do not display if it is abort error triggered by code when switching.
      // this.webauthnAbortController would be null if abort was triggered by code.
      if (_this2.webauthnAbortController) {
        _this2.model.trigger('error', _this2.model, {
          responseJSON: {
            errorSummary: error.message
          }
        });
      }
    }).finally(function () {
      // unset webauthnAbortController on successful authentication or error
      _this2.webauthnAbortController = null;
    });
  },
  _startVerification: function _startVerification() {
    this.$('.okta-waiting-spinner').show();
    this.$('.retry-webauthn').hide();
  },
  _stopVerification: function _stopVerification() {
    this.$('.okta-waiting-spinner').hide();
    this.$('.retry-webauthn').show();
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorVerifyFooter.default,
  postRender: function postRender() {
    _BaseAuthenticatorView.default.prototype.postRender.apply(this, arguments);

    if (_webauthn.default.isNewApiAvailable()) {
      this.form.getCredentialsAndSave();
    }
  }
});

exports.default = _default;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _default = _okta.View.extend({
  // eslint-disable-next-line max-len
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"idx-webauthn-verify-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.instructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 36
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      })) + "</p>";
    },
    "useData": true
  }),
  initialize: function initialize() {
    var relatesToObject = this.options.currentViewState.relatesTo;
    var challengeData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.challengeData;

    if (challengeData.userVerification === 'required') {
      this.add((0, _okta.createCallout)({
        className: 'uv-required-callout',
        size: 'slim',
        type: 'warning',
        subtitle: (0, _okta.loc)('oie.verify.webauthn.uv.required.instructions', 'login')
      }));
    }

    this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
  }
});

exports.default = _default;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(0);

var _AuthenticatorEnrollFooter = _interopRequireDefault(__webpack_require__(93));

var _BaseAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(370));

var BaseAuthenticatorEmailForm = _BaseAuthenticatorEmailView.default.prototype.Body;
var Body = BaseAuthenticatorEmailForm.extend((0, _assign.default)({
  resendEmailAction: 'currentAuthenticator-resend',
  subtitle: function subtitle() {
    return (0, _okta.loc)('oie.email.enroll.subtitle', 'login');
  }
}));

var _default = _BaseAuthenticatorEmailView.default.extend({
  Body: Body,
  Footer: _AuthenticatorEnrollFooter.default
});

exports.default = _default;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(18));

var _bind = _interopRequireDefault(__webpack_require__(7));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _email = _interopRequireDefault(__webpack_require__(371));

var _polling = _interopRequireDefault(__webpack_require__(127));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var _Constants = __webpack_require__(147);

var ResendView = _okta.View.extend({
  //only show after certain threshold of polling
  className: 'hide resend-email-view',
  events: {
    'click a.resend-link': 'handelResendLink'
  },
  initialize: function initialize() {
    var _context;

    this.add((0, _okta.createCallout)({
      content: (0, _concat.default)(_context = "".concat((0, _okta.loc)('email.code.not.received', 'login'), "\n        <a class='resend-link'>")).call(_context, (0, _okta.loc)('email.button.resend', 'login'), "</a>"),
      type: 'warning'
    }));
  },
  handelResendLink: function handelResendLink() {
    this.options.appState.trigger('invokeAction', 'factor-resend'); //hide warning, but reinitiate to show warning again after some threshold of polling

    this.$el.addClass('hide');
    this.showCalloutWithDelay();
  },
  postRender: function postRender() {
    this.showCalloutWithDelay();
  },
  showCalloutWithDelay: function showCalloutWithDelay() {
    var _this = this;

    this.showMeTimeout = _okta._.delay(function () {
      _this.$el.removeClass('hide');
    }, _Constants.SHOW_RESEND_TIMEOUT);
  },
  remove: function remove() {
    _okta.View.prototype.remove.apply(this, arguments);

    clearTimeout(this.showMeTimeout);
  }
});

var Body = _BaseForm.default.extend((0, _assign.default)({
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  },
  subtitle: 'A verification code was sent to your email.',
  initialize: function initialize() {
    var _context2;

    _BaseForm.default.prototype.initialize.apply(this, arguments); // polling has been killed when click save to avoid race conditions hence resume if save failed.


    this.listenTo(this.options.model, 'error', (0, _bind.default)(_context2 = this.startPolling).call(_context2, this));
  },
  saveForm: function saveForm() {
    _BaseForm.default.prototype.saveForm.apply(this, arguments);

    this.stopPolling(); // TODO: abort ongoing request. (https://oktainc.atlassian.net/browse/OKTA-244134)
  },
  postRender: function postRender() {
    var _context3, _context4, _context5;

    //Override message in form subtitle so that we can add html content to it. Courage form subtitle doesn't
    //support html tags.
    (0, _find.default)(_context3 = this.$el).call(_context3, '.okta-form-subtitle').empty();
    this.add((0, _concat.default)(_context4 = (0, _concat.default)(_context5 = "<div>".concat((0, _okta.loc)('email.mfa.email.sent.description.sentText', 'login'), "<span class='strong'>\n        ")).call(_context5, this.options.appState.get('authenticatorProfile').email, "</span>.\n        ")).call(_context4, (0, _okta.loc)('email.mfa.email.sent.description.emailCodeText', 'login'), "</div>"), '.okta-form-subtitle');
    this.add(ResendView, {
      selector: '.o-form-error-container',
      prepend: true
    });
    this.startPolling();
  },
  remove: function remove() {
    _BaseForm.default.prototype.remove.apply(this, arguments);

    this.stopPolling();
  }
}, _email.default, _polling.default));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorVerifyFooter.default
});

exports.default = _default;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var _BaseAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(370));

var BaseAuthenticatorEmailForm = _BaseAuthenticatorEmailView.default.prototype.Body; // Courage doesn't support HTML, hence creating a subtitle here.

var CheckYourEmailTitle = _okta.View.extend({
  className: 'okta-form-subtitle',
  attributes: {
    'data-se': 'o-form-explain'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.email.verify.sentText"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 56
          }
        }
      })) + "&nbsp;<span class=\"strong\">" + alias3((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "email",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 83
          },
          "end": {
            "line": 1,
            "column": 92
          }
        }
      }) : helper)) + ".</span>&nbsp;" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "email.mfa.email.sent.description.emailCodeText"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 106
          },
          "end": {
            "line": 1,
            "column": 183
          }
        }
      }));
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var email = this.options.email;
    return {
      email: email
    };
  }
});

var Body = BaseAuthenticatorEmailForm.extend((0, _assign.default)({
  resendEmailAction: 'currentAuthenticatorEnrollment-resend',
  initialize: function initialize() {
    var _this$options$current2, _this$options$current3;

    BaseAuthenticatorEmailForm.prototype.initialize.apply(this, arguments);

    var _this$options$current = (_this$options$current2 = this.options.currentViewState.relatesTo) === null || _this$options$current2 === void 0 ? void 0 : (_this$options$current3 = _this$options$current2.value) === null || _this$options$current3 === void 0 ? void 0 : _this$options$current3.profile,
        email = _this$options$current.email;

    this.add(CheckYourEmailTitle, {
      prepend: true,
      selector: '.o-form-error-container',
      options: {
        email: email
      }
    });
  }
}));

var _default = _BaseAuthenticatorEmailView.default.extend({
  Body: Body,
  Footer: _AuthenticatorVerifyFooter.default
});

exports.default = _default;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _includes = _interopRequireDefault(__webpack_require__(166));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BrowserFeatures = __webpack_require__(75);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorEnrollFooter = _interopRequireDefault(__webpack_require__(93));

var _polling = _interopRequireDefault(__webpack_require__(127));

var _RemediationConstants = __webpack_require__(57);

var _ResendView = _interopRequireDefault(__webpack_require__(927));

var _SwitchEnrollChannelLinkView = _interopRequireDefault(__webpack_require__(372));

var _EnrollChannelPollDescriptionView = _interopRequireDefault(__webpack_require__(928));

var Body = _BaseForm.default.extend((0, _assign.default)({
  title: function title() {
    var selectedChannel = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
    var title;

    switch (selectedChannel) {
      case 'email':
        title = (0, _okta.loc)('oie.enroll.okta_verify.setup.email.title', 'login');
        break;

      case 'sms':
        title = (0, _okta.loc)('oie.enroll.okta_verify.setup.sms.title', 'login');
        break;

      default:
        title = (0, _okta.loc)('oie.enroll.okta_verify.setup.title', 'login');
    }

    return title;
  },
  className: 'oie-enroll-ov-poll',
  noButtonBar: true,
  initialize: function initialize() {
    _BaseForm.default.prototype.initialize.apply(this, arguments);

    if (((0, _BrowserFeatures.isAndroid)() || (0, _BrowserFeatures.isIOS)()) & this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'qrcode') {
      this.options.appState.trigger('switchForm', _RemediationConstants.FORMS.SELECT_ENROLLMENT_CHANNEL);
    }

    this.listenTo(this.model, 'error', this.stopPolling);
    this.startPolling();
  },
  getUISchema: function getUISchema() {
    var _context;

    var schema = [];
    var contextualData = this.options.appState.get('currentAuthenticator').contextualData;
    var selectedChannel = contextualData.selectedChannel;
    schema.push({
      View: _EnrollChannelPollDescriptionView.default
    });
    schema.push({
      View: _SwitchEnrollChannelLinkView.default,
      options: {
        selectedChannel: selectedChannel
      },
      selector: selectedChannel === 'qrcode' ? '.qrcode-container' : '.switch-channel-content'
    });

    if ((0, _includes.default)(_context = ['email', 'sms']).call(_context, selectedChannel)) {
      schema.push({
        View: _ResendView.default,
        selector: '.o-form-error-container'
      });
    }

    return schema;
  },
  remove: function remove() {
    _BaseForm.default.prototype.remove.apply(this, arguments);

    this.stopPolling();
  }
}, _polling.default));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorEnrollFooter.default
});

exports.default = _default;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _Constants = __webpack_require__(147);

var _default = _okta.View.extend({
  //only show after certain threshold of polling
  className: 'hide resend-ov-link-view',
  events: {
    'click a.resend-link': 'handelResendLink'
  },
  initialize: function initialize() {
    var selectedChannel = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
    this.add((0, _okta.createCallout)({
      content: selectedChannel === 'email' ? _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var stack1,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "oie.enroll.okta_verify.email.notReceived"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 73
              }
            }
          })) != null ? stack1 : "";
        },
        "useData": true
      }) : _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var stack1,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "oie.enroll.okta_verify.sms.notReceived"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 71
              }
            }
          })) != null ? stack1 : "";
        },
        "useData": true
      }),
      type: 'warning'
    }));
  },
  handelResendLink: function handelResendLink() {
    this.options.appState.trigger('invokeAction', 'currentAuthenticator-resend'); //hide warning, but reinitiate to show warning again after some threshold of polling

    this.$el.addClass('hide');
    this.showCalloutWithDelay();
  },
  postRender: function postRender() {
    this.showCalloutWithDelay();
  },
  showCalloutWithDelay: function showCalloutWithDelay() {
    var _this = this;

    this.showMeTimeout = _okta._.delay(function () {
      _this.$el.removeClass('hide');
    }, _Constants.SHOW_RESEND_TIMEOUT);
  },
  remove: function remove() {
    _okta.View.prototype.remove.apply(this, arguments);

    clearTimeout(this.showMeTimeout);
  }
});

exports.default = _default;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _default = _okta.View.extend({
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<ol class=\"qrcode-info ov-info\"><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 48
          },
          "end": {
            "line": 1,
            "column": 114
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 123
          },
          "end": {
            "line": 1,
            "column": 189
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step3"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 198
          },
          "end": {
            "line": 1,
            "column": 264
          }
        }
      })) + "</li></ol><div class=\"qrcode-container\"><img class=\"qrcode\" src=" + alias3((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "href",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 328
          },
          "end": {
            "line": 1,
            "column": 336
          }
        }
      }) : helper)) + " alt=\"qr code\"></img></div>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<ul class=\"email-info ov-info\"><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "arguments": "email",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.email.info"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 418
          },
          "end": {
            "line": 1,
            "column": 502
          }
        }
      })) != null ? stack1 : "") + "</li><li class=\"switch-channel-content\"></li></ul>";
    },
    "5": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<ul class=\"sms-info ov-info\"><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "arguments": "phoneNumber",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.sms.info"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 611
          },
          "end": {
            "line": 1,
            "column": 699
          }
        }
      })) != null ? stack1 : "") + "</li><li class=\"switch-channel-content\"></li></ul>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "href") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 370
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "email") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 370
          },
          "end": {
            "line": 1,
            "column": 559
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "phoneNumber") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 559
          },
          "end": {
            "line": 1,
            "column": 756
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var _contextualData$qrcod;

    var contextualData = this.options.appState.get('currentAuthenticator').contextualData;
    return {
      href: (_contextualData$qrcod = contextualData.qrcode) === null || _contextualData$qrcod === void 0 ? void 0 : _contextualData$qrcod.href,
      email: _okta._.escape(contextualData === null || contextualData === void 0 ? void 0 : contextualData.email),
      phoneNumber: _okta._.escape(contextualData === null || contextualData === void 0 ? void 0 : contextualData.phoneNumber)
    };
  }
});

exports.default = _default;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(16));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(243));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _find = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorEnrollFooter = _interopRequireDefault(__webpack_require__(93));

var _BrowserFeatures = __webpack_require__(75);

var Body = _BaseForm.default.extend({
  title: function title() {
    return (0, _BrowserFeatures.isAndroid)() || (0, _BrowserFeatures.isIOS)() ? (0, _okta.loc)('oie.enroll.okta_verify.setup.title', 'login') : (0, _okta.loc)('oie.enroll.okta_verify.select.channel.title', 'login');
  },
  getUISchema: function getUISchema() {
    var _this = this,
        _channelField$options,
        _context;

    var schemas = _BaseForm.default.prototype.getUISchema.apply(this, arguments); // filter selected channel


    var channelField = (0, _find.default)(_okta._).call(_okta._, schemas, function (schema) {
      return schema.name === 'authenticator.channel';
    });
    channelField.options = (0, _filter.default)(_okta._).call(_okta._, channelField === null || channelField === void 0 ? void 0 : channelField.options, function (option) {
      var _this$options$appStat, _this$options$appStat2;

      return option.value !== ((_this$options$appStat = _this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.contextualData) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.selectedChannel);
    });
    channelField.value = (_channelField$options = channelField.options[0]) === null || _channelField$options === void 0 ? void 0 : _channelField$options.value;
    var description = {
      View: (0, _okta.loc)('oie.enroll.okta_verify.select.channel.description', 'login'),
      selector: '.o-form-fieldset-container'
    };
    return (0, _concat.default)(_context = [description]).call(_context, (0, _toConsumableArray2.default)(schemas));
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorEnrollFooter.default
});

exports.default = _default;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(336);

var arrayLikeToArray = __webpack_require__(342);

function _arrayWithoutHoles(arr) {
  if (_Array$isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$from = __webpack_require__(340);

var _isIterable = __webpack_require__(234);

var _Symbol = __webpack_require__(232);

function _iterableToArray(iter) {
  if (typeof _Symbol !== "undefined" && _isIterable(Object(iter))) return _Array$from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 932 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(16));

var _bind = _interopRequireDefault(__webpack_require__(7));

var _splice = _interopRequireDefault(__webpack_require__(109));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _findIndex = _interopRequireDefault(__webpack_require__(137));

var _find = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseView = _interopRequireDefault(__webpack_require__(42));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorEnrollFooter = _interopRequireDefault(__webpack_require__(93));

var _CountryUtil = _interopRequireDefault(__webpack_require__(145));

var _SwitchEnrollChannelLinkView = _interopRequireDefault(__webpack_require__(372));

var Body = _BaseForm.default.extend({
  className: 'oie-enroll-ov-data',
  title: function title() {
    return this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'email' ? (0, _okta.loc)('oie.enroll.okta_verify.enroll.channel.email.title', 'login') : (0, _okta.loc)('oie.enroll.okta_verify.enroll.channel.sms.title', 'login');
  },
  save: (0, _okta.loc)('oie.enroll.okta_verify.setupLink', 'login'),
  getUISchema: function getUISchema() {
    var uiSchemas = _BaseForm.default.prototype.getUISchema.apply(this, arguments);

    var phoneNumberUISchema = (0, _find.default)(_okta._).call(_okta._, uiSchemas, function (_ref) {
      var name = _ref.name;
      return name === 'phoneNumber';
    });
    var phoneNumberUISchemaIndex = (0, _findIndex.default)(_okta._).call(_okta._, uiSchemas, function (_ref2) {
      var name = _ref2.name;
      return name === 'phoneNumber';
    });
    var countryUISchema = {
      'label-top': true,
      label: (0, _okta.loc)('country.label', 'login'),
      type: 'select',
      options: _CountryUtil.default.getCountries(),
      name: 'country',
      wide: true
    }; // Create an input group - serves as a display wrapper

    var phoneNumberWithCodeUISchema = {
      label: (0, _okta.loc)('mfa.phoneNumber.placeholder', 'login'),
      type: 'group',
      modelType: 'string',
      'label-top': true,
      name: 'phoneCode',
      input: [{
        type: 'label',
        label: "+".concat(this.model.get('phoneCode')),
        className: 'country-code-label'
      }, (0, _assign.default)({}, phoneNumberUISchema)]
    };

    if (phoneNumberUISchemaIndex !== -1) {
      // Replace phoneNumberUISchema and add countryUISchema before phone.
      (0, _splice.default)(uiSchemas).call(uiSchemas, phoneNumberUISchemaIndex, 1, countryUISchema, phoneNumberWithCodeUISchema);
    }

    var description = {
      View: this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'email' ? (0, _okta.loc)('oie.enroll.okta_verify.channel.email.description', 'login') : (0, _okta.loc)('oie.enroll.okta_verify.channel.sms.description', 'login'),
      selector: '.o-form-fieldset-container'
    };
    uiSchemas.push(description);
    return uiSchemas;
  },
  handlePhoneCodeChange: function handlePhoneCodeChange() {
    var countryCodeField = this.el.querySelector('.country-code-label');
    countryCodeField.innerText = "+".concat(this.model.get('phoneCode'));
  },
  initialize: function initialize() {
    _BaseForm.default.prototype.initialize.apply(this, arguments);

    if (this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'sms') {
      var _context;

      this.listenTo(this.model, 'change:phoneCode', (0, _bind.default)(_context = this.handlePhoneCodeChange).call(_context, this));
    }
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorEnrollFooter.default,
  createModelClass: function createModelClass() {
    var ModelClass = _BaseView.default.prototype.createModelClass.apply(this, arguments);

    if (this.options.appState.get('currentAuthenticator').contextualData.selectedChannel !== 'sms') {
      return ModelClass;
    }

    var local = (0, _assign.default)({
      country: {
        // Set default country to "US"
        'value': 'US',
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    var derived = (0, _assign.default)({
      phoneCode: {
        deps: ['country'],
        fn: function fn(country) {
          return _CountryUtil.default.getCallingCodeForCountry(country);
        }
      }
    }, ModelClass.prototype.derived);
    return ModelClass.extend({
      local: local,
      derived: derived,
      toJSON: function toJSON() {
        var _context2;

        var modelJSON = _okta.Model.prototype.toJSON.call(this, arguments);

        var phoneCode = this.get('phoneCode'); // Add country code..

        var formattedPhoneNumber = (0, _concat.default)(_context2 = "+".concat(phoneCode)).call(_context2, modelJSON.phoneNumber); // Override phone with formatted number..

        modelJSON.phoneNumber = formattedPhoneNumber;
        return modelJSON;
      }
    });
  },
  postRender: function postRender() {
    this.add(_SwitchEnrollChannelLinkView.default, 'form');
  }
});

exports.default = _default;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var _ChallengeOktaVerifyPushView = _interopRequireDefault(__webpack_require__(935));

var _ChallengeOktaVerifyFastPassView = _interopRequireDefault(__webpack_require__(936));

var _default = _BaseAuthenticatorView.default.extend({
  initialize: function initialize() {
    var _this$options, _this$options$appStat;

    _BaseAuthenticatorView.default.prototype.initialize.apply(this, arguments);

    var currentAuthenticator = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$appStat = _this$options.appState) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.get('currentAuthenticator');
    var selectedMethod = currentAuthenticator === null || currentAuthenticator === void 0 ? void 0 : currentAuthenticator.methods[0];

    if ((selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.type) === 'push') {
      this.Body = _ChallengeOktaVerifyPushView.default;
      this.Footer = _AuthenticatorVerifyFooter.default;
    } else {
      this.Body = _ChallengeOktaVerifyFastPassView.default;
    }
  }
});

exports.default = _default;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(7));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(82));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _polling = _interopRequireDefault(__webpack_require__(127));

var _Constants = __webpack_require__(147);

var warningTemplate = _okta.View.extend({
  className: 'okta-form-infobox-warning infobox infobox-warning',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"icon warning-16\"></span><p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "warning",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 51
          }
        }
      }) : helper)) + "</p>";
    },
    "useData": true
  })
});

var Body = _BaseForm.default.extend((0, _assign.default)({
  noButtonBar: true,
  className: 'okta-verify-push-challenge',
  title: function title() {
    return (0, _okta.loc)('oie.okta_verify.push.title', 'login');
  },
  initialize: function initialize() {
    _BaseForm.default.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'error', this.stopPoll);
    this.addView();
  },
  addView: function addView() {
    this.add((0, _okta.createButton)({
      className: 'button button-wide button-primary send-push link-button-disabled',
      title: (0, _okta.loc)('oie.okta_verify.push.sent', 'login'),
      click: function click(e) {
        e.preventDefault();
      }
    }));
  },
  postRender: function postRender() {
    this.startPoll();
  },
  startPoll: function startPoll() {
    this.startPolling();
    this.warningTimeout = (0, _setTimeout2.default)((0, _bind.default)(_okta._).call(_okta._, function () {
      this.showWarning((0, _okta.loc)('oktaverify.warning', 'login'));
    }, this), _Constants.WARNING_TIMEOUT);
  },
  stopPoll: function stopPoll() {
    this.stopPolling();
    this.clearWarning();
  },
  showWarning: function showWarning(msg) {
    this.clearWarning();
    this.add(warningTemplate, '.o-form-error-container', {
      options: {
        warning: msg
      }
    });
  },
  clearWarning: function clearWarning() {
    if (this.$('.o-form-error-container div').hasClass('okta-form-infobox-warning')) {
      this.$('.okta-form-infobox-warning').remove();
    }

    clearTimeout(this.warningTimeout);
  },
  remove: function remove() {
    _BaseForm.default.prototype.remove.apply(this, arguments);

    this.stopPolling();
  }
}, _polling.default));

var _default = Body;
exports.default = _default;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _promise = _interopRequireDefault(__webpack_require__(242));

var _stringify = _interopRequireDefault(__webpack_require__(83));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _Logger = _interopRequireDefault(__webpack_require__(64));

var _DeviceFingerprint = _interopRequireDefault(__webpack_require__(183));

var _polling = _interopRequireDefault(__webpack_require__(127));

var _Util = _interopRequireDefault(__webpack_require__(24));

/* global Promise */
var request = function request(opts) {
  var ajaxOptions = (0, _assign.default)({
    method: 'GET',
    contentType: 'application/json'
  }, opts);
  return _okta.$.ajax(ajaxOptions);
};

var Body = _BaseForm.default.extend((0, _assign.default)({
  noButtonBar: true,
  className: 'ion-form device-challenge-poll',
  events: {
    'click #launch-ov': function clickLaunchOv(e) {
      e.preventDefault();
      this.doCustomURI();
    }
  },
  initialize: function initialize() {
    _BaseForm.default.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'error', this.onPollingFail);
    this.deviceChallengePollRemediation = this.options.currentViewState;
    this.doChallenge();
    this.startPolling();
  },
  onPollingFail: function onPollingFail() {
    this.$('.spinner').hide();
    this.stopPolling();
  },
  remove: function remove() {
    _BaseForm.default.prototype.remove.apply(this, arguments);

    this.stopPolling();
  },
  doChallenge: function doChallenge() {
    var deviceChallenge = this.deviceChallengePollRemediation.relatesTo.value.contextualData.challenge.value;

    switch (deviceChallenge.challengeMethod) {
      case 'LOOPBACK':
        this.title = (0, _okta.loc)('signin.with.fastpass', 'login');
        this.add(_okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              return "<div class=\"spinner\"></div>";
            },
            "useData": true
          })
        }));
        this.doLoopback(deviceChallenge.domain, deviceChallenge.ports, deviceChallenge.challengeRequest);
        break;

      case 'CUSTOM_URI':
        this.title = (0, _okta.loc)('customUri.title', 'login');
        this.subtitle = (0, _okta.loc)('customUri.subtitle', 'login');
        this.add(_okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var stack1,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "customUri.content"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 50
                  }
                }
              })) != null ? stack1 : "";
            },
            "useData": true
          })
        }));
        this.customURI = deviceChallenge.href;
        this.doCustomURI();
        break;

      case 'UNIVERSAL_LINK':
        this.title = (0, _okta.loc)('universalLink.userVerification.title', 'login');
        this.add(_okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "universalLink.userVerification.content.p1"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 72
                  }
                }
              }));
            },
            "useData": true
          })
        }));
        this.add(_okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "universalLink.userVerification.content.p2"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 72
                  }
                }
              }));
            },
            "useData": true
          })
        }));
        this.add((0, _okta.createButton)({
          className: 'ul-button button button-wide button-primary',
          title: (0, _okta.loc)('universalLink.userVerification.button', 'login'),
          click: function click() {
            // only window.location.href can open universal link in iOS/MacOS
            // other methods won't do, ex, AJAX get or form get (Util.redirectWithFormGet)
            _Util.default.redirect(deviceChallenge.href);
          }
        }));
    }
  },
  doLoopback: function doLoopback() {
    var _this = this;

    var authenticatorDomainUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var ports = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var challengeRequest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var currentPort;
    var foundPort = false;
    var countFailedPorts = 0;

    var getAuthenticatorUrl = function getAuthenticatorUrl(path) {
      var _context, _context2;

      return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(authenticatorDomainUrl, ":")).call(_context2, currentPort, "/")).call(_context, path);
    };

    var checkPort = function checkPort() {
      return request({
        url: getAuthenticatorUrl('probe'),
        // in loopback server, SSL handshake sometimes takes more than 1000 ms and thus needs additional timeout
        // however, increasing timeout is a temporary solution since user will need to wait much longer in worst case
        // TODO: OKTA-278573 Android timeout is temporarily set to 3000ms and needs optimization post-Beta
        timeout: _DeviceFingerprint.default.isAndroid() ? 3000 : 1000
      });
    };

    var onPortFound = function onPortFound() {
      foundPort = true;
      return request({
        url: getAuthenticatorUrl('challenge'),
        method: 'POST',
        data: (0, _stringify.default)({
          challengeRequest: challengeRequest
        }),
        timeout: 3000 // authenticator should respond within 3000ms for challenge request

      });
    };

    var onFailure = function onFailure() {
      _Logger.default.error("Something unexpected happened while we were checking port ".concat(currentPort, "."));
    };

    var doProbing = function doProbing() {
      return checkPort() // TODO: can we use standard ES6 promise methods, then/catch?
      .done(onPortFound).fail(onFailure);
    };

    var probeChain = _promise.default.resolve();

    (0, _forEach.default)(ports).call(ports, function (port) {
      probeChain = probeChain.then(function () {
        if (!foundPort) {
          currentPort = port;
          return doProbing();
        }
      }).catch(function () {
        countFailedPorts++;

        _Logger.default.error("Authenticator is not listening on port ".concat(currentPort, "."));

        if (countFailedPorts === ports.length) {
          _Logger.default.error('No available ports. Loopback server failed and polling is cancelled.');

          _this.options.appState.trigger('invokeAction', 'currentAuthenticatorEnrollment-cancel');
        }
      });
    });
  },
  doCustomURI: function doCustomURI() {
    this.ulDom && this.ulDom.remove();
    this.ulDom = this.add("\n        <iframe src=\"".concat(this.customURI, "\" id=\"custom-uri-container\" style=\"display:none;\"></iframe>\n      ")).last();
  }
}, _polling.default));

var _default = Body;
exports.default = _default;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var Body = _BaseForm.default.extend((0, _assign.default)({
  className: 'okta-verify-totp-challenge',
  title: function title() {
    return (0, _okta.loc)('oie.okta_verify.totp.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  }
}));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorVerifyFooter.default
});

exports.default = _default;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorVerifyFooter = _interopRequireDefault(__webpack_require__(65));

var Body = _BaseForm.default.extend((0, _assign.default)({
  className: 'okta-verify-resend-push',
  title: function title() {
    return (0, _okta.loc)('oie.okta_verify.push.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oie.okta_verify.push.send', 'login');
  },
  showMessages: function showMessages() {
    var _this = this;

    // override showMessages to display error in cases like reject push
    // or timeout. Borrowed this logic from TerminalView.
    var messagesObjs = this.options.appState.get('messages');

    if (messagesObjs && (0, _isArray.default)(messagesObjs.value)) {
      var _context;

      this.add('<div class="ion-messages-container"></div>', '.o-form-error-container');
      (0, _forEach.default)(_context = messagesObjs.value).call(_context, function (messagesObj) {
        var msg = messagesObj.message;

        if ((messagesObj === null || messagesObj === void 0 ? void 0 : messagesObj.class) === 'ERROR') {
          _this.add((0, _okta.createCallout)({
            content: msg,
            type: 'error'
          }), '.o-form-error-container');
        } else {
          _this.add("<p>".concat(msg, "</p>"), '.ion-messages-container');
        }
      });
    }
  }
}));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _AuthenticatorVerifyFooter.default
});

exports.default = _default;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _map = _interopRequireDefault(__webpack_require__(41));

var _find = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(0);

var _BaseForm = _interopRequireDefault(__webpack_require__(9));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(27));

var _AuthenticatorVerifyOptions = _interopRequireDefault(__webpack_require__(365));

var _AuthenticatorUtil = __webpack_require__(185);

var _SelectAuthenticatorVerifyView = __webpack_require__(367);

var Body = _SelectAuthenticatorVerifyView.Body.extend({
  getUISchema: function getUISchema() {
    var _context;

    // Change the UI schema to not display radios here.
    var uiSchemas = _BaseForm.default.prototype.getUISchema.apply(this, arguments);

    var methodsSchema = (0, _find.default)(uiSchemas).call(uiSchemas, function (schema) {
      return schema.name === 'authenticator.methodType';
    });
    var methodOptions = (0, _map.default)(_context = methodsSchema.options).call(_context, function (option) {
      return (0, _assign.default)({}, option, (0, _AuthenticatorUtil.getAuthenticatorDataForVerification)({
        authenticatorType: 'app'
      }));
    });
    return [{
      View: _AuthenticatorVerifyOptions.default,
      options: {
        name: methodsSchema.name,
        collection: new _okta.Collection(methodOptions)
      }
    }];
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(16));

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _map = _interopRequireDefault(__webpack_require__(41));

var _okta = __webpack_require__(0);

var _i18nTransformer = __webpack_require__(373);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var convertErrorMessageToErrorSummary = function convertErrorMessageToErrorSummary(formName) {
  var _context, _context2;

  var remediationValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (0, _map.default)(_context = (0, _filter.default)(_context2 = _okta._.chain(remediationValues)).call(_context2, function (field) {
    var _field$messages;

    return (0, _isArray.default)((_field$messages = field.messages) === null || _field$messages === void 0 ? void 0 : _field$messages.value) && field.messages.value.length;
  })).call(_context, function (field) {
    var _context3, _context4;

    return {
      property: formName ? (0, _concat.default)(_context3 = "".concat(formName, ".")).call(_context3, field.name) : field.name,
      errorSummary: (0, _map.default)(_context4 = field.messages.value).call(_context4, _i18nTransformer.getMessage)
    };
  }).value();
};
/**
 * Although time complexity is O(n^2),
 * the `array` is actually very small (size < 5),
 * hence performance doesn't matter.
 */


var uniqWith = function uniqWith(array, comparator) {
  if (!(0, _isArray.default)(array)) {
    return [];
  }

  if (!_okta._.isFunction(comparator) || array.length === 1) {
    return array;
  }

  var result = [];

  for (var i = 0; i < array.length; i++) {
    var seen = false;

    for (var j = i + 1; j < array.length; j++) {
      /* eslint max-depth: [2, 3] */
      if (comparator(array[i], array[j])) {
        seen = true;
        break;
      }
    }

    if (!seen) {
      result.push(array[i]);
    }
  }

  return result;
};
/**
 * returns errors
 * @example
 * errors = [
 *   {property : fieldName1, errorSummary: [errorMessage1]},
 *   {property : fieldName2, errorSummary: [errorMessage2]}
 *   {property : fieldName3, errorSummary: [errorMessage31, errorMessage32]}
 * ]
 */


var getRemediationErrors = function getRemediationErrors(res) {
  var errors = [];

  if (!res.remediation || !(0, _isArray.default)(res.remediation.value) || res.remediation.value.length === 0) {
    return errors;
  }

  var remediationFormFields = res.remediation.value[0].value;

  if (!(0, _isArray.default)(remediationFormFields)) {
    return errors;
  } // error at field


  errors.push(convertErrorMessageToErrorSummary(null, remediationFormFields));

  _okta._.each(remediationFormFields, function (remediationForm) {
    var _remediationForm$form;

    var formName = remediationForm.name; // error at form.value

    if ((0, _isArray.default)((_remediationForm$form = remediationForm.form) === null || _remediationForm$form === void 0 ? void 0 : _remediationForm$form.value)) {
      errors.push(convertErrorMessageToErrorSummary(formName, remediationForm.form.value));
    } // error at option.value.form.value


    if ((0, _isArray.default)(remediationForm.options)) {
      _okta._.each(remediationForm.options, function (option) {
        var _option$value, _option$value$form;

        if ((0, _isArray.default)((_option$value = option.value) === null || _option$value === void 0 ? void 0 : (_option$value$form = _option$value.form) === null || _option$value$form === void 0 ? void 0 : _option$value$form.value)) {
          errors.push(convertErrorMessageToErrorSummary(formName, option.value.form.value));
        }
      });
    }
  }); // API may return identical error on same field
  // thus run through `uniqWith`.
  // Check unit test for details.


  return uniqWith(_okta._.flatten(errors), _okta._.isEqual);
};
/**
 * return global error summary combined into one string
 * allErrors = 'error string1. error string2'
 */


var getGlobalErrors = function getGlobalErrors(res) {
  var _res$messages;

  var allErrors = [];

  if ((0, _isArray.default)((_res$messages = res.messages) === null || _res$messages === void 0 ? void 0 : _res$messages.value)) {
    var _context5;

    allErrors = (0, _map.default)(_context5 = res.messages.value).call(_context5, _i18nTransformer.getMessage);
  }

  return allErrors.join('. ');
};

var convertFormErrors = function convertFormErrors(response) {
  var errors = {
    errorCauses: getRemediationErrors(response),
    errorSummary: getGlobalErrors(response)
  };
  return {
    responseJSON: errors
  };
};

var isIonErrorResponse = function isIonErrorResponse() {
  var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // check if error format is an ION response by looking for version attribute.
  // a little sloppy.
  return response.version;
};

var _default = {
  convertFormErrors: convertFormErrors,
  isIonErrorResponse: isIonErrorResponse
};
exports.default = _default;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(7));

var _okta = __webpack_require__(0);

var _Settings = _interopRequireDefault(__webpack_require__(317));

var _Bundles = _interopRequireDefault(__webpack_require__(125));

var _ColorsUtil = _interopRequireDefault(__webpack_require__(344));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Errors = _interopRequireDefault(__webpack_require__(56));

var _Logger = _interopRequireDefault(__webpack_require__(64));

var _LanguageUtil = _interopRequireDefault(__webpack_require__(942));

var _AuthContainer = _interopRequireDefault(__webpack_require__(332));

var _Header = _interopRequireDefault(__webpack_require__(319));

var _responseTransformer = _interopRequireDefault(__webpack_require__(943));

var _uiSchemaTransformer = _interopRequireDefault(__webpack_require__(944));

var _i18nTransformer = _interopRequireDefault(__webpack_require__(373));

var _AppState = _interopRequireDefault(__webpack_require__(948));

var _idx = _interopRequireDefault(__webpack_require__(949));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
// BaseLoginRouter contains the more complicated router logic - rendering/
// transition, etc. Most router changes should happen in LoginRouter (which is
// responsible for adding new routes)
var introspectStateToken = function introspectStateToken(settings) {
  var domain = settings.get('baseUrl');
  var stateHandle = settings.get('stateToken');
  var version = settings.get('apiVersion');
  return _idx.default.start({
    domain: domain,
    stateHandle: stateHandle,
    version: version
  });
};

var _default = _okta.Router.extend({
  Events: _okta.Backbone.Events,
  initialize: function initialize(options) {
    // Create a default success and/or error handler if
    // one is not provided.
    if (!options.globalSuccessFn) {
      options.globalSuccessFn = function () {};
    }

    if (!options.globalErrorFn) {
      options.globalErrorFn = function (err) {
        _Logger.default.error(err);
      };
    }

    this.settings = new _Settings.default(_okta._.omit(options, 'el', 'authClient'), {
      parse: true
    });
    this.settings.setAuthClient(options.authClient);

    if (!options.el) {
      this.settings.callGlobalError(new _Errors.default.ConfigError((0, _okta.loc)('error.required.el')));
    }

    (0, _okta.$)('body > div').on('click', function () {// OKTA-69769 Tooltip wont close on iPhone/iPad
      // Registering a click handler on the first div
      // allows a tap that falls outside the tooltip
      // to be registered as a tap by iOS
      // and then the open tooltip will lose focus and close.
    });
    this.appState = new _AppState.default();
    var wrapper = new _AuthContainer.default({
      appState: this.appState
    });
    (0, _okta.$)(options.el).append(wrapper.render().$el);
    this.el = "#".concat(_Enums.default.WIDGET_CONTAINER_ID);
    this.header = new _Header.default({
      el: this.el,
      appState: this.appState,
      settings: this.settings
    });
    this.listenTo(this.appState, 'remediationSuccess', this.handleIdxResponseSuccess);
    this.listenTo(this.appState, 'remediationError', this.handleIdxResponseFailure);
  },
  handleIdxResponseSuccess: function handleIdxResponseSuccess(idxResponse) {
    // transform response
    var ionResponse = _okta._.compose(_i18nTransformer.default, _uiSchemaTransformer.default, (0, _bind.default)(_responseTransformer.default).call(_responseTransformer.default, {}, this.settings))(idxResponse);

    this.appState.setIonResponse(ionResponse);
  },
  handleIdxResponseFailure: function handleIdxResponseFailure() {
    var _error$details;

    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (error === null || error === void 0 ? void 0 : (_error$details = error.details) === null || _error$details === void 0 ? void 0 : _error$details.stateHandle) {
      // 1. loosely check whether is IDX error response
      // see idx for details: https://github.com/okta/okta-idx-js/blob/master/src/index.js
      // Need to mimic IdxRespones as idx returns raw response at error case
      this.handleIdxResponseSuccess({
        rawIdxState: error.details,
        context: _okta._.pick(error.details, 'messages'),
        neededToProceed: []
      });
    } else {
      // 2. otherwise, assume it's config error
      this.settings.callGlobalError(new _Errors.default.ConfigError(error)); // -- TODO: OKTA-244631 How to suface up the CORS error in IDX?
      // -- The `err` object from idx.js doesn't have XHR object
      // Global error handling for CORS enabled errors
      // if (err.xhr && BrowserFeatures.corsIsNotEnabled(err.xhr)) {
      //   this.settings.callGlobalError(new Errors.UnsupportedBrowserError(loc('error.enabled.cors')));
      //   return;
      // }
    }
  },
  render: function render(Controller) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Since we have a wrapper view, render our wrapper and use its content
    // element as our new el.
    // Note: Render it here because we know dom is ready at this point
    if (!this.header.rendered()) {
      this.el = this.header.render().getContentEl();
    } // If we need to load a language (or apply custom i18n overrides), do
    // this now and re-run render after it's finished.


    if (!_Bundles.default.isLoaded(this.settings.get('languageCode'))) {
      return _LanguageUtil.default.loadLanguage(this.appState, this.settings).done(function () {
        _this.render(Controller, options);
      });
    } // introspect stateToken when widget is bootstrap with state token
    // and remove it from `settings` afterwards as IDX response always has
    // state token (which will be set into AppState)


    if (this.settings.get('stateToken')) {
      return introspectStateToken(this.settings).then(function (idxResp) {
        _this.settings.unset('stateToken');

        _this.appState.trigger('remediationSuccess', idxResp);

        _this.render(Controller, options);
      }).catch(function (errorResp) {
        _this.settings.unset('stateToken');

        _this.appState.trigger('remediationError', errorResp.error);

        _this.render(Controller, options);
      });
    } // Load the custom colors only on the first render


    if (this.settings.get('colors.brand') && !_ColorsUtil.default.isLoaded()) {
      var colors = {
        brand: this.settings.get('colors.brand')
      };

      _ColorsUtil.default.addStyle(colors);
    } // render Controller


    this.unload();

    var controllerOptions = _okta._.extend({
      el: this.el,
      settings: this.settings,
      appState: this.appState
    }, options);

    this.controller = new Controller(controllerOptions); // Bubble up all controller events

    this.listenTo(this.controller, 'all', this.trigger);
    this.controller.render();
  },
  hide: function hide() {
    this.header.$el.hide();
  },
  show: function show() {
    this.header.$el.show();
  },
  remove: function remove() {
    this.unload();
    this.header.$el.remove();
    this.stopListening(this.appState);
    this.stopListening(this.settings);

    _Bundles.default.remove();

    _okta.Backbone.history.stop();
  }
});

exports.default = _default;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _setTimeout2 = _interopRequireDefault(__webpack_require__(82));

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(125)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Bundles) {
  function loadLanguage(appState, settings) {
    var languageCode = settings.get('languageCode');
    var i18n = settings.get('i18n');
    var assetBaseUrl = settings.get('assets.baseUrl');
    var assetRewrite = settings.get('assets.rewrite');
    var timeout = (0, _setTimeout2.default)(function () {
      // Trigger a spinner if we're waiting on a request for a new language.
      appState.trigger('loading', true);
    }, 200);
    return Bundles.loadLanguage(languageCode, i18n, {
      baseUrl: assetBaseUrl,
      rewrite: assetRewrite
    }).then(function () {
      clearTimeout(timeout);
      appState.trigger('loading', false);
    }); // TODO: what if load language error?
  }

  return {
    loadLanguage: loadLanguage
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _map = _interopRequireDefault(__webpack_require__(41));

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(243));

var _okta = __webpack_require__(0);

var _RemediationConstants = __webpack_require__(57);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Transform the ion spec response into canonical format.
 */

/**
 * Authn V2 response
 * @typedef {Object} AuthnResponse
 */

/**
 * @typedef {Object} AuthnResult
 * @property {Object=} user
 * @property {Object=} factor
 */
var isObject = function isObject(x) {
  return _okta._.isObject(x);
};
/**
 * Flatten first level objects from response
 */


var getFirstLevelObjects = function getFirstLevelObjects(resp) {
  var result = {};

  _okta._.each(resp, function (val, key) {
    // if key is remediation we dont do any transformation
    if (key === 'remediation') {
      return;
    } // for arrays we just want it as a top level object
    // Example factors array in select-factor form


    if (val.type === 'array') {
      result[key] = {
        value: val.value
      };
    } // for handling attributes with type object


    if (val.type === 'object') {
      result[key] = val.value;
    }
  });

  return result;
};

var getRemediationValues = function getRemediationValues(idx) {
  var _context;

  var remediationValues = [];

  if (_okta._.isEmpty(idx.neededToProceed)) {
    // no remediation but only success
    if (idx.context.success) {
      remediationValues.push({
        name: idx.context.success.name,
        href: idx.context.success.href,
        value: []
      });
    } else if (idx.context.messages) {
      // no remediation but only messages
      remediationValues.push({
        name: _RemediationConstants.FORMS.TERMINAL,
        // Using `value` is unnecessary as `messages` will be display via `TerminalView.showMessages`,
        // even though might sound a littre counterintuitive.
        // The reason being is there is `BaseForm.showMessages` that is intended to handle
        // messages generically.
        value: []
      });
    }
  }

  return {
    remediations: (0, _concat.default)(_context = []).call(_context, remediationValues, (0, _toConsumableArray2.default)(idx.neededToProceed))
  };
};
/**
 * To support `idps` configuration in OIE.
 * https://github.com/okta/okta-signin-widget#openid-connect
 */


var injectIdPConfigButtonToRemediation = function injectIdPConfigButtonToRemediation(settings, idxResp) {
  var widgetRemedations = idxResp.remediations;
  var hasIdentifyRemedation = (0, _filter.default)(widgetRemedations).call(widgetRemedations, function (r) {
    return r.name === 'identify';
  });

  if (hasIdentifyRemedation.length === 0) {
    return idxResp;
  }

  var idpsConfig = settings.get('idps');

  if ((0, _isArray.default)(idpsConfig)) {
    var _context2;

    var existsRedirectIdpIds = {};
    (0, _forEach.default)(widgetRemedations).call(widgetRemedations, function (r) {
      if (r.name === _RemediationConstants.FORMS.REDIRECT_IDP && r.idp) {
        existsRedirectIdpIds[r.idp.id] = true;
      }
    });
    var baseUrl = settings.get('baseUrl');
    var stateHandle = idxResp.idx.context.stateHandle;
    var redirectIdpRemedations = (0, _map.default)(_context2 = (0, _filter.default)(idpsConfig).call(idpsConfig, function (c) {
      return !existsRedirectIdpIds[c.id];
    }) // omit idps that are already in remediation.
    ).call(_context2, function (idpConfig) {
      var _context3, _context4;

      var idp = {
        id: idpConfig.id,
        name: idpConfig.text
      };
      var redirectUri = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(baseUrl, "/sso/idps/")).call(_context4, idpConfig.id, "?stateToken=")).call(_context3, stateHandle);

      if (idpConfig.className) {
        idp.className = idpConfig.className;
      }

      return {
        name: _RemediationConstants.FORMS.REDIRECT_IDP,
        type: idpConfig.type,
        idp: idp,
        href: redirectUri
      };
    });
    idxResp.remediations = (0, _concat.default)(widgetRemedations).call(widgetRemedations, redirectIdpRemedations);
  }

  return idxResp;
};
/**
 * IFF there is one `redirect-idp` remediation form, widget will automatically redirect to `redirect-idp.href`.
 *
 * The idea now is to reuse `success-redirect` thus converts `redirect-idp` to `success-redirect` form.
 */


var convertRedirectIdPToSuccessRedirectIffOneIdp = function convertRedirectIdPToSuccessRedirectIffOneIdp(result) {
  if ((0, _isArray.default)(result.remediations)) {
    var _context5;

    var redirectIdpRemediations = (0, _filter.default)(_context5 = result.remediations).call(_context5, function (idp) {
      return idp.name === _RemediationConstants.FORMS.REDIRECT_IDP;
    });

    if (redirectIdpRemediations.length === 1 && result.remediations.length === 1) {
      var successRedirect = {
        name: _RemediationConstants.FORMS.SUCCESS_REDIRECT,
        href: redirectIdpRemediations[0].href,
        value: []
      };
      result.remediations = [successRedirect];
    }
  }
};
/**
 * @param {Models.Settings} user configuration
 * @param {idx} idx object
 * @returns {} transformed object with flattened firstlevel objects, idx and remediations array
 * Example: {
 *  idx: {
 *    proceed: ƒ(),
 *    neededToProceed: [],
 *    actions: {cancel: ƒ()},
 *    context: {},
 *  },
 *  remediations: [],
 *  factors: {},
 *  factor: {},
 *  messages: {},
 * }
 */


var convert = function convert(settings) {
  var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!isObject(idx.rawIdxState)) {
    return null;
  }

  var firstLevelObjects = getFirstLevelObjects(idx.rawIdxState);
  var remediationValues = getRemediationValues(idx);
  var result = (0, _assign.default)({}, firstLevelObjects, remediationValues, {
    idx: idx
  });
  injectIdPConfigButtonToRemediation(settings, result);
  convertRedirectIdPToSuccessRedirectIffOneIdp(result);
  return result;
};

var _default = convert;
exports.default = _default;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(17));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _map = _interopRequireDefault(__webpack_require__(41));

var _okta = __webpack_require__(0);

var _ionBooleanHandler = _interopRequireDefault(__webpack_require__(945));

var _ionObjectHandler = _interopRequireDefault(__webpack_require__(946));

var _ionStringHandler = _interopRequireDefault(__webpack_require__(947));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Create UI Schema into remedation object base on remediation values
 */
var UISchemaHandlers = {
  string: _ionStringHandler.default,
  boolean: _ionBooleanHandler.default,
  object: _ionObjectHandler.default
};
/**
 *
 * @param {AuthResult} transformedResp
 * @param {IONForm} remeditationForm
 */

var createUISchema = function createUISchema(transformedResp, remediationForm) {
  var _context, _context2;

  // For cases where field itself is a form, it has a formname and we are appending the formname to each field.
  // Sort of flat the structure in order to align Courage flatten Model. The flatten structure will be converted
  // back to object hierarchy through `Model.toJSON`.
  // For simplicity we are assuming that when field itself is a form its only one level deep.
  var remediationValue = (0, _map.default)(_context = (0, _filter.default)(_context2 = _okta._.chain(remediationForm.value || [])).call(_context2, function (v) {
    return v.visible !== false;
  })).call(_context, function (v) {
    var _v$value;

    var nestedForm;

    if (v.form) {
      nestedForm = v.form;
    } else if ((_v$value = v.value) === null || _v$value === void 0 ? void 0 : _v$value.form) {
      nestedForm = v.value.form;
    }

    if (nestedForm) {
      var _context3;

      var inputGroupName = v.name;
      return (0, _map.default)(_context3 = nestedForm.value).call(_context3, function (input) {
        return (0, _assign.default)({}, input, {
          name: inputGroupName + '.' + input.name
        });
      });
    } else {
      return v;
    }
  }).flatten().value();
  return (0, _map.default)(remediationValue).call(remediationValue, function (ionFormField) {
    var uiSchemaDefaultConfig = {
      'label-top': true
    };
    var fieldType = ionFormField.type || 'string';
    var uiSchemaHandler = UISchemaHandlers[fieldType];
    var uiSchemaResult = uiSchemaHandler(ionFormField, remediationForm, transformedResp, createUISchema);
    return (0, _assign.default)({}, ionFormField, uiSchemaDefaultConfig, uiSchemaResult);
  });
};
/**
 *
 * @param {AuthResult} transformedResp
 */


var insertUISchema = function insertUISchema(transformedResp) {
  if (transformedResp) {
    var _context4;

    transformedResp.remediations = (0, _map.default)(_context4 = transformedResp.remediations).call(_context4, function (obj) {
      obj.uiSchema = createUISchema(transformedResp, obj);
      return obj;
    });
  }

  return transformedResp;
};

var _default = insertUISchema;
/**
 * @typedef {Object} FactorOption
 * @property {string} label Factor label
 * @property {string} value Factor ID
 */

/**
 * @typedef {Object} Factor
 * @property {string} factorType
 * @property {string} factorId
 */

/**
 * @typedef {Object} Authenticator
 * @property {string} label
 * @property {AuthenticatorValue} value
 */

/**
 * @typedef {Object} AuthenticatorValue
 * @property {string} type Authenticator Type
 * @property {string} id Authenticator Org Authenticator ID
 * @property {AuthenticatorMethod[]} methods
 */

/**
 * @typedef {Object} AuthenticatorEnrollment
 * @property {string} label
 * @property {AuthenticatorEnrollmentValue} value
 */

/**
 * @typedef {Object} AuthenticatorEnrollmentValue
 * @property {string} authenticatorId Org Authenticator ID
 * @property {string} type Authenticator Type
 * @property {string} id Authenticator Enrollment ID
 * @property {AuthenticatorMethod[]} methods
 */

/**
 * @typedef {Object} AuthenticatorMethod
 * @property {string} type Authenticator method type
 */

/**
 * @typedef {Object} AuthenticatorOption
 * @property {string} label
 * @property {Object} form
 * @property {AuthenticatorOption[]} form.value
 */

/**
 * @typedef {Object} AuthenticatorOptionValue
 * @property {string} name
 * @property {boolean} required
 * @property {string} value
 * @property {boolean} mutable
 */

/**
 * @typedef {Object} IONForm
 * @property {string} name
 * @property {string[]} rel
 * @property {string} method
 * @property {string} href
 * @property {string} accepts
 * @property {IONFormField[]} value
 */

/**
 * @typedef {Object} IONFormField
 * @property {string} name
 * @property {string=} type
 * @property {string=} required
 * @property {string=} secret
 * @property {string=} label
 * @property {Object[]} options
 * @property {Object=} form
 * @property {IONFormField[]} form.value
 */

exports.default = _default;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var getCheckboxUiSchema = function getCheckboxUiSchema(_ref) {
  var label = _ref.label,
      type = _ref.type,
      required = _ref.required;
  return {
    // For Remember Me checkbox, we need the label only on the right side of it.
    placeholder: label,
    label: false,
    // Separating prop type for Backbone.Model
    // from html input type
    modelType: type,
    // uiSchema type is the html input type desired.
    type: 'checkbox',
    required: required || false
  };
};

var createUiSchemaForBoolean = function createUiSchemaForBoolean(ionFormField) {
  return getCheckboxUiSchema(ionFormField);
};

var _default = createUiSchemaForBoolean;
exports.default = _default;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(141));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _reduce = _interopRequireDefault(__webpack_require__(90));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _splice = _interopRequireDefault(__webpack_require__(109));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _findIndex = _interopRequireDefault(__webpack_require__(137));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(243));

var _map = _interopRequireDefault(__webpack_require__(41));

var _find = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(0);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Example of the option like
 * @param {AuthenticatorOption[]} options
 * @param {( AuthenticatorEnrollment[] || Authenticator[] )} authenticators
 */
var createOVOptions = function createOVOptions() {
  var _ovItem$value, _ovItem$value$form, _ovItem$value$form$va;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Split OV into individual entries for verification (one for each method).
  var ovItem = (0, _find.default)(options).call(options, function (option) {
    return option.relatesTo.type === 'app';
  });
  var methodTypeObj = ovItem === null || ovItem === void 0 ? void 0 : (_ovItem$value = ovItem.value) === null || _ovItem$value === void 0 ? void 0 : (_ovItem$value$form = _ovItem$value.form) === null || _ovItem$value$form === void 0 ? void 0 : (_ovItem$value$form$va = _ovItem$value$form.value) === null || _ovItem$value$form$va === void 0 ? void 0 : (0, _find.default)(_ovItem$value$form$va).call(_ovItem$value$form$va, function (v) {
    return v.name === 'methodType';
  });
  var methodOptions = methodTypeObj === null || methodTypeObj === void 0 ? void 0 : methodTypeObj.options;

  if (methodOptions) {
    var _spliceInstanceProper, _context2;

    var ovOptions = (0, _map.default)(methodOptions).call(methodOptions, function (method) {
      var _context;

      // get value object from the ov item
      var value = (0, _toConsumableArray2.default)(ovItem.value.form.value); // get index of the methodType object within the value object

      var methodTypeIndex = (0, _findIndex.default)(_context = ovItem.value.form.value).call(_context, function (v) {
        return v.name === 'methodType';
      }); // create a new methodType object that removes the options array and
      // has a value of the current method

      var newMethodTypeObj = (0, _assign.default)(_okta._.omit(methodTypeObj, 'options'), method); // set the methodType field to be required and immutable in our UI,
      // so it is always sent to the backend.

      newMethodTypeObj.required = true;
      newMethodTypeObj.mutable = false; // replace old methodType object with the new one

      (0, _splice.default)(value).call(value, methodTypeIndex, 1, newMethodTypeObj); // return a new ov item for a specific method

      return (0, _assign.default)({}, ovItem, {
        label: method.label,
        value: {
          form: {
            value: value
          }
        }
      });
    });
    var ovIndex = (0, _findIndex.default)(options).call(options, function (option) {
      return option.relatesTo.type === 'app';
    });

    (_spliceInstanceProper = (0, _splice.default)(options)).call.apply(_spliceInstanceProper, (0, _concat.default)(_context2 = [options, ovIndex, 1]).call(_context2, (0, _toConsumableArray2.default)(ovOptions)));
  }
};

var createAuthenticatorOptions = function createAuthenticatorOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  createOVOptions(options);
  return (0, _map.default)(options).call(options, function (option) {
    var _option$value, _option$value$form, _context3, _option$relatesTo;

    var value = ((_option$value = option.value) === null || _option$value === void 0 ? void 0 : (_option$value$form = _option$value.form) === null || _option$value$form === void 0 ? void 0 : _option$value$form.value) || []; // Each authenticator option has list of ION field.
    // Currently we only support merely selecting one of options
    // rather than pop up another page to collect extra data
    // (in order to fill value for `mutable: true; value: null` fields).
    // The only reason of such design is to simplify widget implementation
    // but could subject to change in later releases.
    // Thus only surface up fields that are `required: true; mutable: false`
    // which implies it already has `value`.

    var valueObject = (0, _reduce.default)(_context3 = (0, _filter.default)(value).call(value, function (v) {
      return v.required === true && v.mutable === false;
    })).call(_context3, function (init, v) {
      return (0, _assign.default)(init, (0, _defineProperty2.default)({}, v.name, v.value));
    }, {});
    return {
      label: option.label,
      value: valueObject,
      relatesTo: option.relatesTo,
      authenticatorType: (_option$relatesTo = option.relatesTo) === null || _option$relatesTo === void 0 ? void 0 : _option$relatesTo.type
    };
  });
};

var getAuthenticatorsEnrollUiSchema = function getAuthenticatorsEnrollUiSchema(_ref) {
  var options = _ref.options;
  return {
    type: 'authenticatorEnrollSelect',
    options: createAuthenticatorOptions(options)
  };
};

var getAuthenticatorsVerifyUiSchema = function getAuthenticatorsVerifyUiSchema(_ref2) {
  var options = _ref2.options;
  return {
    type: 'authenticatorVerifySelect',
    options: createAuthenticatorOptions(options)
  };
};
/**
  * Create ui schema for ION field that has type 'object'.
  */


var createUiSchemaForObject = function createUiSchemaForObject(ionFormField, remediationForm, transformedResp, createUISchema) {
  var uiSchema = {};

  if (ionFormField.name === 'authenticator' && remediationForm.name === 'select-authenticator-authenticate') {
    // 1. when `select-authenticator-authenticator`,
    // create customize type so that display authenticator list as selectable list
    (0, _assign.default)(uiSchema, getAuthenticatorsVerifyUiSchema(ionFormField));
  } else if (ionFormField.name === 'authenticator' && remediationForm.name === 'select-authenticator-enroll') {
    // 2. when `select-authenticator-enroll`,
    // create customize type so that display authenticator list as selectable list
    (0, _assign.default)(uiSchema, getAuthenticatorsEnrollUiSchema(ionFormField));
  } else if ((0, _isArray.default)(ionFormField.options)) {
    var _context4, _context5;

    // 3. For other cases, create ui schema for each `option` in order to render
    // different view for each option.
    //
    // e.g. { "name": "credentials", "type": "object", options: [ {value: {form: value:[]} ]
    uiSchema.optionsUiSchemas = (0, _map.default)(_context4 = ionFormField.options).call(_context4, function (opt) {
      return createUISchema(transformedResp, {
        value: [{
          name: ionFormField.name,
          value: opt.value
        }]
      });
    });
    uiSchema.options = (0, _map.default)(_context5 = ionFormField.options).call(_context5, function (opt, index) {
      return {
        label: opt.label,
        value: index
      };
    }); // assume (default to) use radio buttons to switch sub-schema.

    uiSchema.type = 'radio';
    uiSchema.value = '0';
    uiSchema.name = "sub_schema_local_".concat(ionFormField.name);
  }

  return uiSchema;
};

var _default = createUiSchemaForObject;
exports.default = _default;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _assign = _interopRequireDefault(__webpack_require__(17));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

var _find = _interopRequireDefault(__webpack_require__(18));

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _okta = __webpack_require__(0);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-depth: [2, 3] */
var ionOptionsToUiOptions = function ionOptionsToUiOptions(options) {
  var result = {};
  (0, _forEach.default)(options).call(options, function (_ref) {
    var value = _ref.value,
        label = _ref.label;
    result[value] = label;
  });
  return result;
};
/**
 * Adds `factorType` metadata to each select-factor option item using factors array
 * @param {FactorOption[]} options
 * @param {Factor[]} factors
 * @returns {Object} option
 * @returns {string} option.label
 * @returns {string} option.value
 * @returns {string} option.factorType
 */


var createFactorTypeOptions = function createFactorTypeOptions(options, factors) {
  _okta._.each(options, function (optionItem) {
    var factorValue = optionItem.value;
    var factor = (0, _find.default)(factors).call(factors, function (item) {
      return item.factorProfileId === factorValue || item.factorId === factorValue;
    }) || {};
    optionItem.factorType = factor.factorType;
  });

  return options;
};

var getFactorsUiSchema = function getFactorsUiSchema(_ref2, factors) {
  var options = _ref2.options;
  return {
    type: 'factorSelect',
    options: createFactorTypeOptions(options, factors)
  };
};

var getPasswordUiSchema = function getPasswordUiSchema() {
  return {
    type: 'password',
    params: {
      showPasswordToggle: true
    }
  };
};

var shouldRenderAsRadio = function shouldRenderAsRadio(name) {
  return (0, _indexOf.default)(name).call(name, 'methodType') >= 0 || (0, _indexOf.default)(name).call(name, 'channel') >= 0;
};

var createUiSchemaForString = function createUiSchemaForString(ionFormField, remediationForm, transformedResp) {
  var uiSchema = {
    type: 'text'
  }; // e.g. { name: 'password', secret: true }

  if (ionFormField.secret === true) {
    (0, _assign.default)(uiSchema, getPasswordUiSchema());
  }

  if ((0, _isArray.default)(ionFormField.options)) {
    if (ionFormField.name === 'factorId' || ionFormField.name === 'factorProfileId') {
      var _transformedResp$fact;

      // select factor form for multiple factor enroll and multiple factor verify
      // when factor has not been enrolled we get back factorProfileId, and once its enrolled
      // we get back factorId
      // e.g. { name: 'factorId' | 'factorProfileId', type: 'string', options: [ {label: 'xxx', value: 'yyy'} ]}
      var factors = ((_transformedResp$fact = transformedResp.factors) === null || _transformedResp$fact === void 0 ? void 0 : _transformedResp$fact.value) || [];
      (0, _assign.default)(uiSchema, getFactorsUiSchema(ionFormField, factors));
    } else if (shouldRenderAsRadio(ionFormField.name)) {
      // e.g. { name: 'methodType', options: [ {label: 'sms'} ], type: 'string' | null }
      uiSchema.type = 'radio'; // set the default value to the first value..

      if (ionFormField.options[0] && ionFormField.options[0].value) {
        ionFormField.value = ionFormField.options[0].value;
      }
    } else {
      // default to select (dropdown). no particular reason (certainly can default to radio.)
      // e.g. { name: 'questionKey', options: [], type: 'string' | null }
      uiSchema.type = 'select';
      uiSchema.wide = true;
      uiSchema.options = ionOptionsToUiOptions(ionFormField.options);
    }
  }

  return uiSchema;
};

var _default = createUiSchemaForString;
exports.default = _default;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(3);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _stringify = _interopRequireDefault(__webpack_require__(83));

var _includes = _interopRequireDefault(__webpack_require__(166));

var _map = _interopRequireDefault(__webpack_require__(41));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _find = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(0);

var _Logger = _interopRequireDefault(__webpack_require__(64));

var _RemediationConstants = __webpack_require__(57);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Keep track of stateMachine with this special model. Similar to `src/models/AppState.js`
 */
var _default = _okta.Model.extend({
  local: {
    introspectSuccess: 'object',
    // only set during introspection
    introspectError: 'object',
    // only set during introspection
    factor: 'object',
    // optional
    user: 'object',
    // optional
    currentFormName: 'string',
    idx: 'object',
    remediations: 'array'
  },
  derived: {
    authenticatorProfile: {
      // While we're moving toward `authenticator` platform, but still
      // need to support `factor` for certain period.
      // Could remove `factor` after it's deprecated completely.
      deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment', 'factor'],
      fn: function fn() {
        var currentAuthenticator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var currentAuthenticatorEnrollment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var factor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return currentAuthenticator.profile || currentAuthenticatorEnrollment.profile || factor.profile || {};
      }
    },
    authenticatorType: {
      deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment', 'factor'],
      fn: function fn() {
        var currentAuthenticator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var currentAuthenticatorEnrollment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var factor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return currentAuthenticator.type || currentAuthenticatorEnrollment.type || factor.factorType || '';
      }
    },
    authenticatorMethodType: {
      deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment'],
      fn: function fn() {
        var currentAuthenticator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var currentAuthenticatorEnrollment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return currentAuthenticator.methods && currentAuthenticator.methods[0].type || currentAuthenticatorEnrollment.methods && currentAuthenticatorEnrollment.methods[0].type || '';
      }
    },
    isPasswordRecovery: {
      deps: ['recoveryAuthenticator'],
      fn: function fn() {
        var recoveryAuthenticator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return (recoveryAuthenticator === null || recoveryAuthenticator === void 0 ? void 0 : recoveryAuthenticator.type) === 'password';
      }
    }
  },
  hasRemediationObject: function hasRemediationObject(formName) {
    var _context;

    return (0, _find.default)(_context = this.get('idx').neededToProceed).call(_context, function (remediation) {
      return remediation.name === formName;
    });
  },
  getActionByPath: function getActionByPath(actionPath) {
    var paths = actionPath.split('.');
    var targetObject;

    if (paths.length === 1) {
      targetObject = this.get('idx').actions;
    } else {
      targetObject = this.get(paths.shift());
    } // Limitation
    // At the time of writting, action only lives in first level of state objects.


    var actionName = paths.shift();

    if (targetObject && _okta._.isFunction(targetObject[actionName])) {
      return targetObject[actionName];
    } else {
      return null;
    }
  },
  getCurrentViewState: function getCurrentViewState() {
    var _context2;

    var currentFormName = this.get('currentFormName');

    if (!currentFormName) {
      return;
    } // didn't expect `remediations` is empty. See `setIonResponse`.


    var currentViewState = (0, _filter.default)(_context2 = this.get('remediations')).call(_context2, function (r) {
      return r.name === currentFormName;
    })[0];

    if (!currentViewState) {
      var _context3;

      _Logger.default.error('Panic!!');

      _Logger.default.error("\tCannot find view state for form ".concat(currentFormName, "."));

      var allFormNames = (0, _map.default)(_context3 = this.get('remediations')).call(_context3, function (r) {
        return r.name;
      });

      _Logger.default.error("\tAll available form names: ".concat(allFormNames));
    }

    return currentViewState;
  },
  shouldReRenderView: function shouldReRenderView(transformedResponse) {
    var previousRawState = this.has('idx') ? this.get('idx').rawIdxState : null;

    var identicalResponse = _okta._.isEqual(_okta._.omit(transformedResponse.idx.rawIdxState, 'expiresAt'), _okta._.omit(previousRawState, 'expiresAt'));

    var reRender = true;

    if (identicalResponse) {
      /**
       * returns false: When new response is same as last.
       * usually happens during polling when pipeline doesn't proceed to next step.
       * expiresAt will be different for each response, hence compare objects without that property
       */
      reRender = false;
    }

    if (identicalResponse && (0, _includes.default)(_RemediationConstants.FORMS_WITH_STATIC_BACK_LINK).call(_RemediationConstants.FORMS_WITH_STATIC_BACK_LINK, this.get('currentFormName'))) {
      /**
       * returns true: We want to force reRender if you go back to selection screen from challenge or enroll screen
       * and re-select the same authenticator for challenge. In this case also new response will be identical
       * to the old response.
       */
      reRender = true;
    }

    return reRender;
  },
  // Sign Out link will be displayed in the footer of a form, unless
  // - widget config hideSignOutLinkInMFA=true and form is for identity verification (FORMS_FOR_VERIFICATION)
  // - cancel remediation form is not present in the response
  // - form is part of our list FORMS_WITHOUT_SIGNOUT
  shouldShowSignOutLinkInCurrentForm: function shouldShowSignOutLinkInCurrentForm(hideSignOutLinkInMFA) {
    var idxActions = this.get('idx') && this.get('idx').actions;
    var currentFormName = this.get('currentFormName');
    var hideSignOutConfigOverride = hideSignOutLinkInMFA && (0, _includes.default)(_RemediationConstants.FORMS_FOR_VERIFICATION).call(_RemediationConstants.FORMS_FOR_VERIFICATION, currentFormName);
    return !hideSignOutConfigOverride && _okta._.isFunction(idxActions === null || idxActions === void 0 ? void 0 : idxActions.cancel) && !(0, _includes.default)(_RemediationConstants.FORMS_WITHOUT_SIGNOUT).call(_RemediationConstants.FORMS_WITHOUT_SIGNOUT, currentFormName);
  },
  setIonResponse: function setIonResponse(transformedResponse) {
    if (!this.shouldReRenderView(transformedResponse)) {
      return;
    } // `currentFormName` is default to first form of remediations or nothing.


    var currentFormName = null;

    if (!_okta._.isEmpty(transformedResponse.remediations)) {
      currentFormName = transformedResponse.remediations[0].name;
    } else {
      _Logger.default.error('Panic!!');

      _Logger.default.error('\tNo remediation found.');

      _Logger.default.error('\tHere is the entire response');

      _Logger.default.error((0, _stringify.default)(transformedResponse, null, 2));
    } // clear appState before setting new values


    this.clear({
      silent: true
    }); // clear cache for derived props.

    this.trigger('cache:clear'); // set new app state properties

    this.set(transformedResponse); // make sure change `currentFormName` is last step.
    // change `currentFormName` will re-render FormController,
    // which may depend on other derived properties hence
    // those derived properties must be re-computed before
    // re-rendering controller.

    this.set({
      currentFormName: currentFormName
    });
  }
});

exports.default = _default;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _find = _interopRequireDefault(__webpack_require__(18));

var _from = _interopRequireDefault(__webpack_require__(950));

var _entries = _interopRequireDefault(__webpack_require__(343));

var _fromEntries = _interopRequireDefault(__webpack_require__(952));

var _isIterable2 = _interopRequireDefault(__webpack_require__(234));

var _defineProperties = _interopRequireDefault(__webpack_require__(956));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(960));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(965));

var _getIterator2 = _interopRequireDefault(__webpack_require__(337));

var _regenerator = _interopRequireDefault(__webpack_require__(233));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(82));

var _splice = _interopRequireDefault(__webpack_require__(109));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(968));

var _reduce = _interopRequireDefault(__webpack_require__(90));

var _fill = _interopRequireDefault(__webpack_require__(970));

var _isFinite = _interopRequireDefault(__webpack_require__(976));

var _stringify = _interopRequireDefault(__webpack_require__(83));

var _sort = _interopRequireDefault(__webpack_require__(235));

var _keys = _interopRequireDefault(__webpack_require__(334));

var _filter = _interopRequireDefault(__webpack_require__(37));

var _keys2 = _interopRequireDefault(__webpack_require__(172));

var _getPrototypeOf = _interopRequireDefault(__webpack_require__(981));

var _concat = _interopRequireDefault(__webpack_require__(16));

var _freeze = _interopRequireDefault(__webpack_require__(352));

var _parseFloat2 = _interopRequireDefault(__webpack_require__(298));

var _parseInt2 = _interopRequireDefault(__webpack_require__(171));

var _trim = _interopRequireDefault(__webpack_require__(138));

var _entries2 = _interopRequireDefault(__webpack_require__(985));

var _map = _interopRequireDefault(__webpack_require__(41));

var _urlSearchParams = _interopRequireDefault(__webpack_require__(989));

var _slice = _interopRequireDefault(__webpack_require__(229));

var _promise = _interopRequireDefault(__webpack_require__(242));

var _getOwnPropertyNames = _interopRequireDefault(__webpack_require__(994));

var _isArray = _interopRequireDefault(__webpack_require__(40));

var _forEach = _interopRequireDefault(__webpack_require__(28));

var _iterator = _interopRequireDefault(__webpack_require__(300));

var _indexOf = _interopRequireDefault(__webpack_require__(45));

var _bind = _interopRequireDefault(__webpack_require__(7));

var _create = _interopRequireDefault(__webpack_require__(998));

var _toStringTag = _interopRequireDefault(__webpack_require__(1002));

var _symbol = _interopRequireDefault(__webpack_require__(303));

var _defineProperty = _interopRequireDefault(__webpack_require__(3));

var _typeof2 = _interopRequireDefault(__webpack_require__(29));

!function (e, t) {
  "object" == ( false ? "undefined" : (0, _typeof2.default)(exports)) && "object" == ( false ? "undefined" : (0, _typeof2.default)(module)) ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof2.default)(exports)) ? exports.idx = t() : e.idx = t();
}(window, function () {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var i = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || (0, _defineProperty.default)(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof _symbol.default && _toStringTag.default && (0, _defineProperty.default)(e, _toStringTag.default, {
        value: "Module"
      }), (0, _defineProperty.default)(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == (0, _typeof2.default)(e) && e && e.__esModule) return e;
      var n = (0, _create.default)(null);
      if (r.r(n), (0, _defineProperty.default)(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        var _context;

        r.d(n, i, (0, _bind.default)(_context = function _context(t) {
          return e[t];
        }).call(_context, null, i));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 3);
  }([function (e, t) {
    var r = function (e) {
      function t() {
        this.fetch = !1, this.DOMException = e.DOMException;
      }

      return t.prototype = e, new t();
    }("undefined" != typeof self ? self : this);

    !function (e) {
      !function (t) {
        var r = ("URLSearchParams" in e),
            n = "Symbol" in e && "iterator" in _symbol.default,
            i = "FileReader" in e && "Blob" in e && function () {
          try {
            return new Blob(), !0;
          } catch (e) {
            return !1;
          }
        }(),
            o = ("FormData" in e),
            a = ("ArrayBuffer" in e);

        if (a) var s = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
            c = ArrayBuffer.isView || function (e) {
          return e && (0, _indexOf.default)(s).call(s, Object.prototype.toString.call(e)) > -1;
        };

        function u(e) {
          if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
          return e.toLowerCase();
        }

        function l(e) {
          return "string" != typeof e && (e = String(e)), e;
        }

        function p(e) {
          var t = {
            next: function next() {
              var t = e.shift();
              return {
                done: void 0 === t,
                value: t
              };
            }
          };
          return n && (t[_iterator.default] = function () {
            return t;
          }), t;
        }

        function f(e) {
          var _context2;

          this.map = {}, e instanceof f ? (0, _forEach.default)(e).call(e, function (e, t) {
            this.append(t, e);
          }, this) : (0, _isArray.default)(e) ? (0, _forEach.default)(e).call(e, function (e) {
            this.append(e[0], e[1]);
          }, this) : e && (0, _forEach.default)(_context2 = (0, _getOwnPropertyNames.default)(e)).call(_context2, function (t) {
            this.append(t, e[t]);
          }, this);
        }

        function h(e) {
          if (e.bodyUsed) return _promise.default.reject(new TypeError("Already read"));
          e.bodyUsed = !0;
        }

        function d(e) {
          return new _promise.default(function (t, r) {
            e.onload = function () {
              t(e.result);
            }, e.onerror = function () {
              r(e.error);
            };
          });
        }

        function y(e) {
          var t = new FileReader(),
              r = d(t);
          return t.readAsArrayBuffer(e), r;
        }

        function m(e) {
          if ((0, _slice.default)(e)) return (0, _slice.default)(e).call(e, 0);
          var t = new Uint8Array(e.byteLength);
          return t.set(new Uint8Array(e)), t.buffer;
        }

        function v() {
          return this.bodyUsed = !1, this._initBody = function (e) {
            var t;
            this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : i && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : o && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : r && _urlSearchParams.default.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : a && i && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = m(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a && (ArrayBuffer.prototype.isPrototypeOf(e) || c(e)) ? this._bodyArrayBuffer = m(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r && _urlSearchParams.default.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, i && (this.blob = function () {
            var e = h(this);
            if (e) return e;
            if (this._bodyBlob) return _promise.default.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return _promise.default.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return _promise.default.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function () {
            return this._bodyArrayBuffer ? h(this) || _promise.default.resolve(this._bodyArrayBuffer) : this.blob().then(y);
          }), this.text = function () {
            var e,
                t,
                r,
                n = h(this);
            if (n) return n;
            if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader(), r = d(t), t.readAsText(e), r;
            if (this._bodyArrayBuffer) return _promise.default.resolve(function (e) {
              for (var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++) {
                r[n] = String.fromCharCode(t[n]);
              }

              return r.join("");
            }(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return _promise.default.resolve(this._bodyText);
          }, o && (this.formData = function () {
            return this.text().then(S);
          }), this.json = function () {
            return this.text().then(JSON.parse);
          }, this;
        }

        f.prototype.append = function (e, t) {
          e = u(e), t = l(t);
          var r = (0, _map.default)(this)[e];
          (0, _map.default)(this)[e] = r ? r + ", " + t : t;
        }, f.prototype.delete = function (e) {
          delete (0, _map.default)(this)[u(e)];
        }, f.prototype.get = function (e) {
          return e = u(e), this.has(e) ? (0, _map.default)(this)[e] : null;
        }, f.prototype.has = function (e) {
          return (0, _map.default)(this).hasOwnProperty(u(e));
        }, f.prototype.set = function (e, t) {
          (0, _map.default)(this)[u(e)] = l(t);
        }, f.prototype.forEach = function (e, t) {
          for (var r in (0, _map.default)(this)) {
            (0, _map.default)(this).hasOwnProperty(r) && e.call(t, (0, _map.default)(this)[r], r, this);
          }
        }, f.prototype.keys = function () {
          var _context3;

          var e = [];
          return (0, _forEach.default)(_context3 = this).call(_context3, function (t, r) {
            e.push(r);
          }), p(e);
        }, f.prototype.values = function () {
          var _context4;

          var e = [];
          return (0, _forEach.default)(_context4 = this).call(_context4, function (t) {
            e.push(t);
          }), p(e);
        }, f.prototype.entries = function () {
          var _context5;

          var e = [];
          return (0, _forEach.default)(_context5 = this).call(_context5, function (t, r) {
            e.push([r, t]);
          }), p(e);
        }, n && (f.prototype[_iterator.default] = (0, _entries2.default)(f.prototype));
        var g = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

        function b(e, t) {
          var r,
              n,
              i = (t = t || {}).body;

          if (e instanceof b) {
            if (e.bodyUsed) throw new TypeError("Already read");
            this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new f(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, i || null == e._bodyInit || (i = e._bodyInit, e.bodyUsed = !0);
          } else this.url = String(e);

          if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new f(t.headers)), this.method = (r = t.method || this.method || "GET", n = r.toUpperCase(), (0, _indexOf.default)(g).call(g, n) > -1 ? n : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");

          this._initBody(i);
        }

        function S(e) {
          var _context6;

          var t = new FormData();
          return (0, _forEach.default)(_context6 = (0, _trim.default)(e).call(e).split("&")).call(_context6, function (e) {
            if (e) {
              var r = e.split("="),
                  n = r.shift().replace(/\+/g, " "),
                  i = r.join("=").replace(/\+/g, " ");
              t.append(decodeURIComponent(n), decodeURIComponent(i));
            }
          }), t;
        }

        function E(e, t) {
          t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new f(t.headers), this.url = t.url || "", this._initBody(e);
        }

        b.prototype.clone = function () {
          return new b(this, {
            body: this._bodyInit
          });
        }, v.call(b.prototype), v.call(E.prototype), E.prototype.clone = function () {
          return new E(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new f(this.headers),
            url: this.url
          });
        }, E.error = function () {
          var e = new E(null, {
            status: 0,
            statusText: ""
          });
          return e.type = "error", e;
        };
        var x = [301, 302, 303, 307, 308];
        E.redirect = function (e, t) {
          if (-1 === (0, _indexOf.default)(x).call(x, t)) throw new RangeError("Invalid status code");
          return new E(null, {
            status: t,
            headers: {
              location: e
            }
          });
        }, t.DOMException = e.DOMException;

        try {
          new t.DOMException();
        } catch (e) {
          t.DOMException = function (e, t) {
            this.message = e, this.name = t;
            var r = Error(e);
            this.stack = r.stack;
          }, t.DOMException.prototype = (0, _create.default)(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
        }

        function w(e, r) {
          return new _promise.default(function (n, o) {
            var _context10;

            var a = new b(e, r);
            if (a.signal && a.signal.aborted) return o(new t.DOMException("Aborted", "AbortError"));
            var s = new XMLHttpRequest();

            function c() {
              s.abort();
            }

            s.onload = function () {
              var _context7;

              var e,
                  t,
                  r = {
                status: s.status,
                statusText: s.statusText,
                headers: (e = s.getAllResponseHeaders() || "", t = new f(), (0, _forEach.default)(_context7 = e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/)).call(_context7, function (e) {
                  var _context8;

                  var r = e.split(":"),
                      n = (0, _trim.default)(_context8 = r.shift()).call(_context8);

                  if (n) {
                    var _context9;

                    var i = (0, _trim.default)(_context9 = r.join(":")).call(_context9);
                    t.append(n, i);
                  }
                }), t)
              };
              r.url = "responseURL" in s ? s.responseURL : r.headers.get("X-Request-URL");
              var i = "response" in s ? s.response : s.responseText;
              n(new E(i, r));
            }, s.onerror = function () {
              o(new TypeError("Network request failed"));
            }, s.ontimeout = function () {
              o(new TypeError("Network request failed"));
            }, s.onabort = function () {
              o(new t.DOMException("Aborted", "AbortError"));
            }, s.open(a.method, a.url, !0), "include" === a.credentials ? s.withCredentials = !0 : "omit" === a.credentials && (s.withCredentials = !1), "responseType" in s && i && (s.responseType = "blob"), (0, _forEach.default)(_context10 = a.headers).call(_context10, function (e, t) {
              s.setRequestHeader(t, e);
            }), a.signal && (a.signal.addEventListener("abort", c), s.onreadystatechange = function () {
              4 === s.readyState && a.signal.removeEventListener("abort", c);
            }), s.send(void 0 === a._bodyInit ? null : a._bodyInit);
          });
        }

        w.polyfill = !0, e.fetch || (e.fetch = w, e.Headers = f, e.Request = b, e.Response = E), t.Headers = f, t.Request = b, t.Response = E, t.fetch = w;
      }({});
    }(r), delete r.fetch.polyfill, (t = r.fetch).default = r.fetch, t.fetch = r.fetch, t.Headers = r.Headers, t.Request = r.Request, t.Response = r.Response, e.exports = t;
  }, function (e, t, r) {
    (function (t) {
      e.exports = function e(t, r, n) {
        function i(a, s) {
          if (!r[a]) {
            if (!t[a]) {
              if (o) return o(a, !0);
              var c = new Error("Cannot find module '" + a + "'");
              throw c.code = "MODULE_NOT_FOUND", c;
            }

            var u = r[a] = {
              exports: {}
            };
            t[a][0].call(u.exports, function (e) {
              var r = t[a][1][e];
              return i(r || e);
            }, u, u.exports, e, t, r, n);
          }

          return r[a].exports;
        }

        for (var o = !1, a = 0; a < n.length; a++) {
          i(n[a]);
        }

        return i;
      }({
        "./aesprim": [function (e, t, r) {
          !function (e, t) {
            "use strict";

            t(void 0 !== r ? r : e.esprima = {});
          }(this, function (e) {
            "use strict";

            var t, r, n, i, o, a, s, c, u, l, p, f, h, d, y, m, v, g;

            function b(e, t) {
              if (!e) throw new Error("ASSERT: " + t);
            }

            function S(e) {
              return e >= 48 && e <= 57;
            }

            function E(e) {
              var _context11;

              return (0, _indexOf.default)(_context11 = "0123456789abcdefABCDEF").call(_context11, e) >= 0;
            }

            function x(e) {
              var _context12;

              return (0, _indexOf.default)(_context12 = "01234567").call(_context12, e) >= 0;
            }

            function w(e) {
              var _context13;

              return 32 === e || 9 === e || 11 === e || 12 === e || 160 === e || e >= 5760 && (0, _indexOf.default)(_context13 = [5760, 6158, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279]).call(_context13, e) >= 0;
            }

            function k(e) {
              return 10 === e || 13 === e || 8232 === e || 8233 === e;
            }

            function O(e) {
              return 64 == e || 36 === e || 95 === e || e >= 65 && e <= 90 || e >= 97 && e <= 122 || 92 === e || e >= 128 && s.NonAsciiIdentifierStart.test(String.fromCharCode(e));
            }

            function _(e) {
              return 36 === e || 95 === e || e >= 65 && e <= 90 || e >= 97 && e <= 122 || e >= 48 && e <= 57 || 92 === e || e >= 128 && s.NonAsciiIdentifierPart.test(String.fromCharCode(e));
            }

            function I(e) {
              switch (e) {
                case "implements":
                case "interface":
                case "package":
                case "private":
                case "protected":
                case "public":
                case "static":
                case "yield":
                case "let":
                  return !0;

                default:
                  return !1;
              }
            }

            function P(e) {
              return "eval" === e || "arguments" === e;
            }

            function A(e, t, r, n, i) {
              var o;
              b("number" == typeof r, "Comment must have valid position"), v.lastCommentStart >= r || (v.lastCommentStart = r, o = {
                type: e,
                value: t
              }, g.range && (o.range = [r, n]), g.loc && (o.loc = i), g.comments.push(o), g.attachComment && (g.leadingComments.push(o), g.trailingComments.push(o)));
            }

            function T(e) {
              var t, r, n, i;

              for (t = p - e, r = {
                start: {
                  line: f,
                  column: p - h - e
                }
              }; p < d;) {
                if (n = u.charCodeAt(p), ++p, k(n)) return g.comments && (i = (0, _slice.default)(u).call(u, t + e, p - 1), r.end = {
                  line: f,
                  column: p - h - 1
                }, A("Line", i, t, p - 1, r)), 13 === n && 10 === u.charCodeAt(p) && ++p, ++f, void (h = p);
              }

              g.comments && (i = (0, _slice.default)(u).call(u, t + e, p), r.end = {
                line: f,
                column: p - h
              }, A("Line", i, t, p, r));
            }

            function C() {
              var e, t, r, n;

              for (g.comments && (e = p - 2, t = {
                start: {
                  line: f,
                  column: p - h - 2
                }
              }); p < d;) {
                if (k(r = u.charCodeAt(p))) 13 === r && 10 === u.charCodeAt(p + 1) && ++p, ++f, ++p, h = p, p >= d && W({}, a.UnexpectedToken, "ILLEGAL");else if (42 === r) {
                  if (47 === u.charCodeAt(p + 1)) return ++p, ++p, void (g.comments && (n = (0, _slice.default)(u).call(u, e + 2, p - 2), t.end = {
                    line: f,
                    column: p - h
                  }, A("Block", n, e, p, t)));
                  ++p;
                } else ++p;
              }

              W({}, a.UnexpectedToken, "ILLEGAL");
            }

            function N() {
              var e, t;

              for (t = 0 === p; p < d;) {
                if (w(e = u.charCodeAt(p))) ++p;else if (k(e)) ++p, 13 === e && 10 === u.charCodeAt(p) && ++p, ++f, h = p, t = !0;else if (47 === e) {
                  if (47 === (e = u.charCodeAt(p + 1))) ++p, ++p, T(2), t = !0;else {
                    if (42 !== e) break;
                    ++p, ++p, C();
                  }
                } else if (t && 45 === e) {
                  if (45 !== u.charCodeAt(p + 1) || 62 !== u.charCodeAt(p + 2)) break;
                  p += 3, T(3);
                } else {
                  if (60 !== e) break;
                  if ("!--" !== (0, _slice.default)(u).call(u, p + 1, p + 4)) break;
                  ++p, ++p, ++p, ++p, T(4);
                }
              }
            }

            function R(e) {
              var t,
                  r,
                  n,
                  i = 0;

              for (r = "u" === e ? 4 : 2, t = 0; t < r; ++t) {
                var _context14;

                if (!(p < d && E(u[p]))) return "";
                n = u[p++], i = 16 * i + (0, _indexOf.default)(_context14 = "0123456789abcdef").call(_context14, n.toLowerCase());
              }

              return String.fromCharCode(i);
            }

            function L() {
              var e, t;

              for (e = u.charCodeAt(p++), t = String.fromCharCode(e), 92 === e && (117 !== u.charCodeAt(p) && W({}, a.UnexpectedToken, "ILLEGAL"), ++p, (e = R("u")) && "\\" !== e && O(e.charCodeAt(0)) || W({}, a.UnexpectedToken, "ILLEGAL"), t = e); p < d && _(e = u.charCodeAt(p));) {
                ++p, t += String.fromCharCode(e), 92 === e && (t = t.substr(0, t.length - 1), 117 !== u.charCodeAt(p) && W({}, a.UnexpectedToken, "ILLEGAL"), ++p, (e = R("u")) && "\\" !== e && _(e.charCodeAt(0)) || W({}, a.UnexpectedToken, "ILLEGAL"), t += e);
              }

              return t;
            }

            function j() {
              var e, r;
              return e = p, {
                type: 1 === (r = 92 === u.charCodeAt(p) ? L() : function () {
                  var e, t;

                  for (e = p++; p < d;) {
                    if (92 === (t = u.charCodeAt(p))) return p = e, L();
                    if (!_(t)) break;
                    ++p;
                  }

                  return (0, _slice.default)(u).call(u, e, p);
                }()).length ? t.Identifier : function (e) {
                  if (l && I(e)) return !0;

                  switch (e.length) {
                    case 2:
                      return "if" === e || "in" === e || "do" === e;

                    case 3:
                      return "var" === e || "for" === e || "new" === e || "try" === e || "let" === e;

                    case 4:
                      return "this" === e || "else" === e || "case" === e || "void" === e || "with" === e || "enum" === e;

                    case 5:
                      return "while" === e || "break" === e || "catch" === e || "throw" === e || "const" === e || "yield" === e || "class" === e || "super" === e;

                    case 6:
                      return "return" === e || "typeof" === e || "delete" === e || "switch" === e || "export" === e || "import" === e;

                    case 7:
                      return "default" === e || "finally" === e || "extends" === e;

                    case 8:
                      return "function" === e || "continue" === e || "debugger" === e;

                    case 10:
                      return "instanceof" === e;

                    default:
                      return !1;
                  }
                }(r) ? t.Keyword : "null" === r ? t.NullLiteral : "true" === r || "false" === r ? t.BooleanLiteral : t.Identifier,
                value: r,
                lineNumber: f,
                lineStart: h,
                start: e,
                end: p
              };
            }

            function D() {
              var _context15, _context16;

              var e,
                  r,
                  n,
                  i,
                  o = p,
                  s = u.charCodeAt(p),
                  c = u[p];

              switch (s) {
                case 46:
                case 40:
                case 41:
                case 59:
                case 44:
                case 123:
                case 125:
                case 91:
                case 93:
                case 58:
                case 63:
                case 126:
                  return ++p, g.tokenize && (40 === s ? g.openParenToken = g.tokens.length : 123 === s && (g.openCurlyToken = g.tokens.length)), {
                    type: t.Punctuator,
                    value: String.fromCharCode(s),
                    lineNumber: f,
                    lineStart: h,
                    start: o,
                    end: p
                  };

                default:
                  if (61 === (e = u.charCodeAt(p + 1))) switch (s) {
                    case 43:
                    case 45:
                    case 47:
                    case 60:
                    case 62:
                    case 94:
                    case 124:
                    case 37:
                    case 38:
                    case 42:
                      return p += 2, {
                        type: t.Punctuator,
                        value: String.fromCharCode(s) + String.fromCharCode(e),
                        lineNumber: f,
                        lineStart: h,
                        start: o,
                        end: p
                      };

                    case 33:
                    case 61:
                      return p += 2, 61 === u.charCodeAt(p) && ++p, {
                        type: t.Punctuator,
                        value: (0, _slice.default)(u).call(u, o, p),
                        lineNumber: f,
                        lineStart: h,
                        start: o,
                        end: p
                      };
                  }
              }

              return ">>>=" === (i = u.substr(p, 4)) ? {
                type: t.Punctuator,
                value: i,
                lineNumber: f,
                lineStart: h,
                start: o,
                end: p += 4
              } : ">>>" === (n = i.substr(0, 3)) || "<<=" === n || ">>=" === n ? {
                type: t.Punctuator,
                value: n,
                lineNumber: f,
                lineStart: h,
                start: o,
                end: p += 3
              } : c === (r = n.substr(0, 2))[1] && (0, _indexOf.default)(_context15 = "+-<>&|").call(_context15, c) >= 0 || "=>" === r ? {
                type: t.Punctuator,
                value: r,
                lineNumber: f,
                lineStart: h,
                start: o,
                end: p += 2
              } : (0, _indexOf.default)(_context16 = "<>=!+-*%&|^/").call(_context16, c) >= 0 ? (++p, {
                type: t.Punctuator,
                value: c,
                lineNumber: f,
                lineStart: h,
                start: o,
                end: p
              }) : void W({}, a.UnexpectedToken, "ILLEGAL");
            }

            function B() {
              var e, r, n;

              if (b(S((n = u[p]).charCodeAt(0)) || "." === n, "Numeric literal must start with a decimal digit or a decimal point"), r = p, e = "", "." !== n) {
                if (e = u[p++], n = u[p], "0" === e) {
                  if ("x" === n || "X" === n) return ++p, function (e) {
                    for (var r = ""; p < d && E(u[p]);) {
                      r += u[p++];
                    }

                    return 0 === r.length && W({}, a.UnexpectedToken, "ILLEGAL"), O(u.charCodeAt(p)) && W({}, a.UnexpectedToken, "ILLEGAL"), {
                      type: t.NumericLiteral,
                      value: (0, _parseInt2.default)("0x" + r, 16),
                      lineNumber: f,
                      lineStart: h,
                      start: e,
                      end: p
                    };
                  }(r);
                  if (x(n)) return function (e) {
                    for (var r = "0" + u[p++]; p < d && x(u[p]);) {
                      r += u[p++];
                    }

                    return (O(u.charCodeAt(p)) || S(u.charCodeAt(p))) && W({}, a.UnexpectedToken, "ILLEGAL"), {
                      type: t.NumericLiteral,
                      value: (0, _parseInt2.default)(r, 8),
                      octal: !0,
                      lineNumber: f,
                      lineStart: h,
                      start: e,
                      end: p
                    };
                  }(r);
                  n && S(n.charCodeAt(0)) && W({}, a.UnexpectedToken, "ILLEGAL");
                }

                for (; S(u.charCodeAt(p));) {
                  e += u[p++];
                }

                n = u[p];
              }

              if ("." === n) {
                for (e += u[p++]; S(u.charCodeAt(p));) {
                  e += u[p++];
                }

                n = u[p];
              }

              if ("e" === n || "E" === n) if (e += u[p++], "+" !== (n = u[p]) && "-" !== n || (e += u[p++]), S(u.charCodeAt(p))) for (; S(u.charCodeAt(p));) {
                e += u[p++];
              } else W({}, a.UnexpectedToken, "ILLEGAL");
              return O(u.charCodeAt(p)) && W({}, a.UnexpectedToken, "ILLEGAL"), {
                type: t.NumericLiteral,
                value: (0, _parseFloat2.default)(e),
                lineNumber: f,
                lineStart: h,
                start: r,
                end: p
              };
            }

            function U() {
              var e, r, n, i;
              return m = null, N(), e = p, r = function () {
                var e, t, r, n;

                for (b("/" === (e = u[p]), "Regular expression literal must start with a slash"), t = u[p++], r = !1, n = !1; p < d;) {
                  if (t += e = u[p++], "\\" === e) k((e = u[p++]).charCodeAt(0)) && W({}, a.UnterminatedRegExp), t += e;else if (k(e.charCodeAt(0))) W({}, a.UnterminatedRegExp);else if (r) "]" === e && (r = !1);else {
                    if ("/" === e) {
                      n = !0;
                      break;
                    }

                    "[" === e && (r = !0);
                  }
                }

                return n || W({}, a.UnterminatedRegExp), {
                  value: t.substr(1, t.length - 2),
                  literal: t
                };
              }(), n = function () {
                var e, t, r, n;

                for (t = "", r = ""; p < d && _((e = u[p]).charCodeAt(0));) {
                  if (++p, "\\" === e && p < d) {
                    if ("u" === (e = u[p])) {
                      if (n = ++p, e = R("u")) for (r += e, t += "\\u"; n < p; ++n) {
                        t += u[n];
                      } else p = n, r += "u", t += "\\u";
                      V({}, a.UnexpectedToken, "ILLEGAL");
                    } else t += "\\", V({}, a.UnexpectedToken, "ILLEGAL");
                  } else r += e, t += e;
                }

                return {
                  value: r,
                  literal: t
                };
              }(), i = function (e, t) {
                var r;

                try {
                  r = new RegExp(e, t);
                } catch (e) {
                  W({}, a.InvalidRegExp);
                }

                return r;
              }(r.value, n.value), g.tokenize ? {
                type: t.RegularExpression,
                value: i,
                lineNumber: f,
                lineStart: h,
                start: e,
                end: p
              } : {
                literal: r.literal + n.literal,
                value: i,
                start: e,
                end: p
              };
            }

            function F() {
              var e, t, r, n;
              return N(), e = p, t = {
                start: {
                  line: f,
                  column: p - h
                }
              }, r = U(), t.end = {
                line: f,
                column: p - h
              }, g.tokenize || (g.tokens.length > 0 && (n = g.tokens[g.tokens.length - 1]).range[0] === e && "Punctuator" === n.type && ("/" !== n.value && "/=" !== n.value || g.tokens.pop()), g.tokens.push({
                type: "RegularExpression",
                value: r.literal,
                range: [e, p],
                loc: t
              })), r;
            }

            function M() {
              var e;
              return N(), p >= d ? {
                type: t.EOF,
                lineNumber: f,
                lineStart: h,
                start: p,
                end: p
              } : O(e = u.charCodeAt(p)) ? j() : 40 === e || 41 === e || 59 === e ? D() : 39 === e || 34 === e ? function () {
                var _context17, _context18, _context19, _context20;

                var e,
                    r,
                    n,
                    i,
                    o,
                    s,
                    c,
                    l,
                    y = "",
                    m = !1;

                for (c = f, l = h, b("'" === (e = u[p]) || '"' === e, "String literal must starts with a quote"), r = p, ++p; p < d;) {
                  if ((n = u[p++]) === e) {
                    e = "";
                    break;
                  }

                  if ("\\" === n) {
                    if ((n = u[p++]) && k(n.charCodeAt(0))) ++f, "\r" === n && "\n" === u[p] && ++p, h = p;else switch (n) {
                      case "u":
                      case "x":
                        s = p, (o = R(n)) ? y += o : (p = s, y += n);
                        break;

                      case "n":
                        y += "\n";
                        break;

                      case "r":
                        y += "\r";
                        break;

                      case "t":
                        y += "\t";
                        break;

                      case "b":
                        y += "\b";
                        break;

                      case "f":
                        y += "\f";
                        break;

                      case "v":
                        y += "\v";
                        break;

                      default:
                        x(n) ? (0 !== (i = (0, _indexOf.default)(_context17 = "01234567").call(_context17, n)) && (m = !0), p < d && x(u[p]) && (m = !0, i = 8 * i + (0, _indexOf.default)(_context18 = "01234567").call(_context18, u[p++]), (0, _indexOf.default)(_context19 = "0123").call(_context19, n) >= 0 && p < d && x(u[p]) && (i = 8 * i + (0, _indexOf.default)(_context20 = "01234567").call(_context20, u[p++]))), y += String.fromCharCode(i)) : y += n;
                    }
                  } else {
                    if (k(n.charCodeAt(0))) break;
                    y += n;
                  }
                }

                return "" !== e && W({}, a.UnexpectedToken, "ILLEGAL"), {
                  type: t.StringLiteral,
                  value: y,
                  octal: m,
                  startLineNumber: c,
                  startLineStart: l,
                  lineNumber: f,
                  lineStart: h,
                  start: r,
                  end: p
                };
              }() : 46 === e ? S(u.charCodeAt(p + 1)) ? B() : D() : S(e) ? B() : g.tokenize && 47 === e ? function () {
                var e, t;
                if (!(e = g.tokens[g.tokens.length - 1])) return F();

                if ("Punctuator" === e.type) {
                  if ("]" === e.value) return D();
                  if (")" === e.value) return !(t = g.tokens[g.openParenToken - 1]) || "Keyword" !== t.type || "if" !== t.value && "while" !== t.value && "for" !== t.value && "with" !== t.value ? D() : F();

                  if ("}" === e.value) {
                    if (g.tokens[g.openCurlyToken - 3] && "Keyword" === g.tokens[g.openCurlyToken - 3].type) {
                      if (!(t = g.tokens[g.openCurlyToken - 4])) return D();
                    } else {
                      if (!g.tokens[g.openCurlyToken - 4] || "Keyword" !== g.tokens[g.openCurlyToken - 4].type) return D();
                      if (!(t = g.tokens[g.openCurlyToken - 5])) return F();
                    }

                    return (0, _indexOf.default)(n).call(n, t.value) >= 0 ? D() : F();
                  }

                  return F();
                }

                return "Keyword" === e.type ? F() : D();
              }() : D();
            }

            function $() {
              var e, n, i;
              return N(), e = {
                start: {
                  line: f,
                  column: p - h
                }
              }, n = M(), e.end = {
                line: f,
                column: p - h
              }, n.type !== t.EOF && (i = (0, _slice.default)(u).call(u, n.start, n.end), g.tokens.push({
                type: r[n.type],
                value: i,
                range: [n.start, n.end],
                loc: e
              })), n;
            }

            function q() {
              var e;
              return p = (e = m).end, f = e.lineNumber, h = e.lineStart, m = void 0 !== g.tokens ? $() : M(), p = e.end, f = e.lineNumber, h = e.lineStart, e;
            }

            function H() {
              var e, t, r;
              e = p, t = f, r = h, m = void 0 !== g.tokens ? $() : M(), p = e, f = t, h = r;
            }

            function z(e, t) {
              this.line = e, this.column = t;
            }

            function G(e, t, r, n) {
              this.start = new z(e, t), this.end = new z(r, n);
            }

            function X() {
              var e, t, r, n;
              return e = p, t = f, r = h, N(), n = f !== t, p = e, f = t, h = r, n;
            }

            function W(e, t) {
              var r,
                  n = (0, _slice.default)(Array.prototype).call(arguments, 2),
                  i = t.replace(/%(\d)/g, function (e, t) {
                return b(t < n.length, "Message reference must be in range"), n[t];
              });
              throw "number" == typeof e.lineNumber ? ((r = new Error("Line " + e.lineNumber + ": " + i)).index = e.start, r.lineNumber = e.lineNumber, r.column = e.start - h + 1) : ((r = new Error("Line " + f + ": " + i)).index = p, r.lineNumber = f, r.column = p - h + 1), r.description = i, r;
            }

            function V() {
              try {
                W.apply(null, arguments);
              } catch (e) {
                if (!g.errors) throw e;
                g.errors.push(e);
              }
            }

            function K(e) {
              if (e.type === t.EOF && W(e, a.UnexpectedEOS), e.type === t.NumericLiteral && W(e, a.UnexpectedNumber), e.type === t.StringLiteral && W(e, a.UnexpectedString), e.type === t.Identifier && W(e, a.UnexpectedIdentifier), e.type === t.Keyword) {
                if (function (e) {
                  switch (e) {
                    case "class":
                    case "enum":
                    case "export":
                    case "extends":
                    case "import":
                    case "super":
                      return !0;

                    default:
                      return !1;
                  }
                }(e.value)) W(e, a.UnexpectedReserved);else if (l && I(e.value)) return void V(e, a.StrictReservedWord);
                W(e, a.UnexpectedToken, e.value);
              }

              W(e, a.UnexpectedToken, e.value);
            }

            function J(e) {
              var r = q();
              r.type === t.Punctuator && r.value === e || K(r);
            }

            function Q(e) {
              var r = q();
              r.type === t.Keyword && r.value === e || K(r);
            }

            function Z(e) {
              return m.type === t.Punctuator && m.value === e;
            }

            function Y(e) {
              return m.type === t.Keyword && m.value === e;
            }

            function ee() {
              var e;
              59 === u.charCodeAt(p) || Z(";") ? q() : (e = f, N(), f === e && (m.type === t.EOF || Z("}") || K(m)));
            }

            function te(e) {
              return e.type === i.Identifier || e.type === i.MemberExpression;
            }

            function re(e, t) {
              var r, n, i;
              return r = l, i = m, n = Oe(), t && l && P(e[0].name) && V(t, a.StrictParamName), l = r, y.markEnd(y.createFunctionExpression(null, e, [], n), i);
            }

            function ne() {
              var e, r;
              return r = m, (e = q()).type === t.StringLiteral || e.type === t.NumericLiteral ? (l && e.octal && V(e, a.StrictOctalLiteral), y.markEnd(y.createLiteral(e), r)) : y.markEnd(y.createIdentifier(e.value), r);
            }

            function ie() {
              var e, r, n, i, o, s;
              return s = m, (e = m).type === t.Identifier ? (n = ne(), "get" !== e.value || Z(":") ? "set" !== e.value || Z(":") ? (J(":"), i = ye(), y.markEnd(y.createProperty("init", n, i), s)) : (r = ne(), J("("), (e = m).type !== t.Identifier ? (J(")"), V(e, a.UnexpectedToken, e.value), i = re([])) : (o = [ge()], J(")"), i = re(o, e)), y.markEnd(y.createProperty("set", r, i), s)) : (r = ne(), J("("), J(")"), i = re([]), y.markEnd(y.createProperty("get", r, i), s))) : e.type !== t.EOF && e.type !== t.Punctuator ? (r = ne(), J(":"), i = ye(), y.markEnd(y.createProperty("init", r, i), s)) : void K(e);
            }

            function oe() {
              var e, r, n, s;
              if (Z("(")) return function () {
                var e;
                return J("("), e = me(), J(")"), e;
              }();
              if (Z("[")) return function () {
                var e,
                    t = [];

                for (e = m, J("["); !Z("]");) {
                  Z(",") ? (q(), t.push(null)) : (t.push(ye()), Z("]") || J(","));
                }

                return q(), y.markEnd(y.createArrayExpression(t), e);
              }();
              if (Z("{")) return function () {
                var e,
                    t,
                    r,
                    n,
                    s,
                    c = [],
                    u = {},
                    p = String;

                for (s = m, J("{"); !Z("}");) {
                  t = (e = ie()).key.type === i.Identifier ? e.key.name : p(e.key.value), n = "init" === e.kind ? o.Data : "get" === e.kind ? o.Get : o.Set, r = "$" + t, Object.prototype.hasOwnProperty.call(u, r) ? (u[r] === o.Data ? l && n === o.Data ? V({}, a.StrictDuplicateProperty) : n !== o.Data && V({}, a.AccessorDataProperty) : n === o.Data ? V({}, a.AccessorDataProperty) : u[r] & n && V({}, a.AccessorGetSet), u[r] |= n) : u[r] = n, c.push(e), Z("}") || J(",");
                }

                return J("}"), y.markEnd(y.createObjectExpression(c), s);
              }();
              if (e = m.type, s = m, e === t.Identifier) n = y.createIdentifier(q().value);else if (e === t.StringLiteral || e === t.NumericLiteral) l && m.octal && V(m, a.StrictOctalLiteral), n = y.createLiteral(q());else if (e === t.Keyword) {
                if (Y("function")) return function () {
                  var e,
                      t,
                      r,
                      n,
                      i,
                      o,
                      s,
                      c,
                      u,
                      p = null;
                  return u = m, Q("function"), Z("(") || (e = m, p = ge(), l ? P(e.value) && V(e, a.StrictFunctionName) : P(e.value) ? (r = e, n = a.StrictFunctionName) : I(e.value) && (r = e, n = a.StrictReservedWord)), i = _e(r), o = i.params, t = i.stricted, r = i.firstRestricted, i.message && (n = i.message), c = l, s = Oe(), l && r && W(r, n), l && t && V(t, n), l = c, y.markEnd(y.createFunctionExpression(p, o, [], s), u);
                }();
                Y("this") ? (q(), n = y.createThisExpression()) : K(q());
              } else e === t.BooleanLiteral ? ((r = q()).value = "true" === r.value, n = y.createLiteral(r)) : e === t.NullLiteral ? ((r = q()).value = null, n = y.createLiteral(r)) : Z("/") || Z("/=") ? (n = void 0 !== g.tokens ? y.createLiteral(F()) : y.createLiteral(U()), H()) : K(q());
              return y.markEnd(n, s);
            }

            function ae() {
              var e = [];
              if (J("("), !Z(")")) for (; p < d && (e.push(ye()), !Z(")"));) {
                J(",");
              }
              return J(")"), e;
            }

            function se() {
              var e, r;
              return r = m, function (e) {
                return e.type === t.Identifier || e.type === t.Keyword || e.type === t.BooleanLiteral || e.type === t.NullLiteral;
              }(e = q()) || K(e), y.markEnd(y.createIdentifier(e.value), r);
            }

            function ce() {
              return J("."), se();
            }

            function ue() {
              var e;
              return J("["), e = me(), J("]"), e;
            }

            function le() {
              var e, t, r;
              return r = m, Q("new"), e = function () {
                var e, t, r, n;

                for (n = m, e = v.allowIn, t = Y("new") ? le() : oe(), v.allowIn = e; Z(".") || Z("[");) {
                  Z("[") ? (r = ue(), t = y.createMemberExpression("[", t, r)) : (r = ce(), t = y.createMemberExpression(".", t, r)), y.markEnd(t, n);
                }

                return t;
              }(), t = Z("(") ? ae() : [], y.markEnd(y.createNewExpression(e, t), r);
            }

            function pe() {
              var e,
                  r,
                  n = m;
              return e = function () {
                var e, t, r, n, i;

                for (i = m, e = v.allowIn, v.allowIn = !0, t = Y("new") ? le() : oe(), v.allowIn = e;;) {
                  if (Z(".")) n = ce(), t = y.createMemberExpression(".", t, n);else if (Z("(")) r = ae(), t = y.createCallExpression(t, r);else {
                    if (!Z("[")) break;
                    n = ue(), t = y.createMemberExpression("[", t, n);
                  }
                  y.markEnd(t, i);
                }

                return t;
              }(), m.type === t.Punctuator && (!Z("++") && !Z("--") || X() || (l && e.type === i.Identifier && P(e.name) && V({}, a.StrictLHSPostfix), te(e) || V({}, a.InvalidLHSInAssignment), r = q(), e = y.markEnd(y.createPostfixExpression(r.value, e), n))), e;
            }

            function fe() {
              var e, r, n;
              return m.type !== t.Punctuator && m.type !== t.Keyword ? r = pe() : Z("++") || Z("--") ? (n = m, e = q(), r = fe(), l && r.type === i.Identifier && P(r.name) && V({}, a.StrictLHSPrefix), te(r) || V({}, a.InvalidLHSInAssignment), r = y.createUnaryExpression(e.value, r), r = y.markEnd(r, n)) : Z("+") || Z("-") || Z("~") || Z("!") ? (n = m, e = q(), r = fe(), r = y.createUnaryExpression(e.value, r), r = y.markEnd(r, n)) : Y("delete") || Y("void") || Y("typeof") ? (n = m, e = q(), r = fe(), r = y.createUnaryExpression(e.value, r), r = y.markEnd(r, n), l && "delete" === r.operator && r.argument.type === i.Identifier && V({}, a.StrictDelete)) : r = pe(), r;
            }

            function he(e, r) {
              var n = 0;
              if (e.type !== t.Punctuator && e.type !== t.Keyword) return 0;

              switch (e.value) {
                case "||":
                  n = 1;
                  break;

                case "&&":
                  n = 2;
                  break;

                case "|":
                  n = 3;
                  break;

                case "^":
                  n = 4;
                  break;

                case "&":
                  n = 5;
                  break;

                case "==":
                case "!=":
                case "===":
                case "!==":
                  n = 6;
                  break;

                case "<":
                case ">":
                case "<=":
                case ">=":
                case "instanceof":
                  n = 7;
                  break;

                case "in":
                  n = r ? 7 : 0;
                  break;

                case "<<":
                case ">>":
                case ">>>":
                  n = 8;
                  break;

                case "+":
                case "-":
                  n = 9;
                  break;

                case "*":
                case "/":
                case "%":
                  n = 11;
              }

              return n;
            }

            function de() {
              var e, t, r, n, i;
              return i = m, e = function () {
                var e, t, r, n, i, o, a, s, c, u;
                if (e = m, c = fe(), 0 === (i = he(n = m, v.allowIn))) return c;

                for (n.prec = i, q(), t = [e, m], o = [c, n, a = fe()]; (i = he(m, v.allowIn)) > 0;) {
                  for (; o.length > 2 && i <= o[o.length - 2].prec;) {
                    a = o.pop(), s = o.pop().value, c = o.pop(), r = y.createBinaryExpression(s, c, a), t.pop(), e = t[t.length - 1], y.markEnd(r, e), o.push(r);
                  }

                  (n = q()).prec = i, o.push(n), t.push(m), r = fe(), o.push(r);
                }

                for (r = o[u = o.length - 1], t.pop(); u > 1;) {
                  r = y.createBinaryExpression(o[u - 1].value, o[u - 2], r), u -= 2, e = t.pop(), y.markEnd(r, e);
                }

                return r;
              }(), Z("?") && (q(), t = v.allowIn, v.allowIn = !0, r = ye(), v.allowIn = t, J(":"), n = ye(), e = y.createConditionalExpression(e, r, n), y.markEnd(e, i)), e;
            }

            function ye() {
              var e, r, n, o, s, c;
              return e = m, s = m, o = r = de(), m.type !== t.Punctuator || "=" !== (c = m.value) && "*=" !== c && "/=" !== c && "%=" !== c && "+=" !== c && "-=" !== c && "<<=" !== c && ">>=" !== c && ">>>=" !== c && "&=" !== c && "^=" !== c && "|=" !== c || (te(r) || V({}, a.InvalidLHSInAssignment), l && r.type === i.Identifier && P(r.name) && V(e, a.StrictLHSAssignment), e = q(), n = ye(), o = y.markEnd(y.createAssignmentExpression(e.value, r, n), s)), o;
            }

            function me() {
              var e,
                  t = m;

              if (e = ye(), Z(",")) {
                for (e = y.createSequenceExpression([e]); p < d && Z(",");) {
                  q(), e.expressions.push(ye());
                }

                y.markEnd(e, t);
              }

              return e;
            }

            function ve() {
              var e, t;
              return t = m, J("{"), e = function () {
                for (var e, t = []; p < d && !Z("}") && void 0 !== (e = Pe());) {
                  t.push(e);
                }

                return t;
              }(), J("}"), y.markEnd(y.createBlockStatement(e), t);
            }

            function ge() {
              var e, r;
              return r = m, (e = q()).type !== t.Identifier && K(e), y.markEnd(y.createIdentifier(e.value), r);
            }

            function be(e) {
              var t,
                  r,
                  n = null;
              return r = m, t = ge(), l && P(t.name) && V({}, a.StrictVarName), "const" === e ? (J("="), n = ye()) : Z("=") && (q(), n = ye()), y.markEnd(y.createVariableDeclarator(t, n), r);
            }

            function Se(e) {
              var t = [];

              do {
                if (t.push(be(e)), !Z(",")) break;
                q();
              } while (p < d);

              return t;
            }

            function Ee() {
              var e, t, r, n, i, o, s, c, u, l;
              return e = t = r = null, Q("for"), J("("), Z(";") ? q() : (Y("var") || Y("let") ? (v.allowIn = !1, l = m, c = q(), u = Se(), e = y.markEnd(y.createVariableDeclaration(u, c.value), l), v.allowIn = !0, 1 === e.declarations.length && Y("in") && (q(), n = e, i = me(), e = null)) : (v.allowIn = !1, e = me(), v.allowIn = !0, Y("in") && (te(e) || V({}, a.InvalidLHSInForIn), q(), n = e, i = me(), e = null)), void 0 === n && J(";")), void 0 === n && (Z(";") || (t = me()), J(";"), Z(")") || (r = me())), J(")"), s = v.inIteration, v.inIteration = !0, o = ke(), v.inIteration = s, void 0 === n ? y.createForStatement(e, t, r, o) : y.createForInStatement(n, i, o);
            }

            function xe() {
              var e,
                  t,
                  r,
                  n = [];

              for (r = m, Y("default") ? (q(), e = null) : (Q("case"), e = me()), J(":"); p < d && !(Z("}") || Y("default") || Y("case"));) {
                t = ke(), n.push(t);
              }

              return y.markEnd(y.createSwitchCase(e, n), r);
            }

            function we() {
              var e,
                  t,
                  r,
                  n,
                  i = [],
                  o = null;
              return Q("try"), e = ve(), Y("catch") && i.push((n = m, Q("catch"), J("("), Z(")") && K(m), t = ge(), l && P(t.name) && V({}, a.StrictCatchVariable), J(")"), r = ve(), y.markEnd(y.createCatchClause(t, r), n))), Y("finally") && (q(), o = ve()), 0 !== i.length || o || W({}, a.NoCatchOrFinally), y.createTryStatement(e, [], i, o);
            }

            function ke() {
              var e,
                  r,
                  n,
                  o,
                  s,
                  c,
                  f,
                  h,
                  g,
                  b = m.type;
              if (b === t.EOF && K(m), b === t.Punctuator && "{" === m.value) return ve();
              if (o = m, b === t.Punctuator) switch (m.value) {
                case ";":
                  return y.markEnd((J(";"), y.createEmptyStatement()), o);

                case "(":
                  return y.markEnd(function () {
                    var e = me();
                    return ee(), y.createExpressionStatement(e);
                  }(), o);
              }
              if (b === t.Keyword) switch (m.value) {
                case "break":
                  return y.markEnd(function () {
                    var e,
                        r = null;
                    return Q("break"), 59 === u.charCodeAt(p) ? (q(), v.inIteration || v.inSwitch || W({}, a.IllegalBreak), y.createBreakStatement(null)) : X() ? (v.inIteration || v.inSwitch || W({}, a.IllegalBreak), y.createBreakStatement(null)) : (m.type === t.Identifier && (e = "$" + (r = ge()).name, Object.prototype.hasOwnProperty.call(v.labelSet, e) || W({}, a.UnknownLabel, r.name)), ee(), null !== r || v.inIteration || v.inSwitch || W({}, a.IllegalBreak), y.createBreakStatement(r));
                  }(), o);

                case "continue":
                  return y.markEnd(function () {
                    var e,
                        r = null;
                    return Q("continue"), 59 === u.charCodeAt(p) ? (q(), v.inIteration || W({}, a.IllegalContinue), y.createContinueStatement(null)) : X() ? (v.inIteration || W({}, a.IllegalContinue), y.createContinueStatement(null)) : (m.type === t.Identifier && (e = "$" + (r = ge()).name, Object.prototype.hasOwnProperty.call(v.labelSet, e) || W({}, a.UnknownLabel, r.name)), ee(), null !== r || v.inIteration || W({}, a.IllegalContinue), y.createContinueStatement(r));
                  }(), o);

                case "debugger":
                  return y.markEnd((Q("debugger"), ee(), y.createDebuggerStatement()), o);

                case "do":
                  return y.markEnd((Q("do"), g = v.inIteration, v.inIteration = !0, f = ke(), v.inIteration = g, Q("while"), J("("), h = me(), J(")"), Z(";") && q(), y.createDoWhileStatement(f, h)), o);

                case "for":
                  return y.markEnd(Ee(), o);

                case "function":
                  return y.markEnd(Ie(), o);

                case "if":
                  return y.markEnd(function () {
                    var e, t, r;
                    return Q("if"), J("("), e = me(), J(")"), t = ke(), Y("else") ? (q(), r = ke()) : r = null, y.createIfStatement(e, t, r);
                  }(), o);

                case "return":
                  return y.markEnd((c = null, Q("return"), v.inFunctionBody || V({}, a.IllegalReturn), 32 === u.charCodeAt(p) && O(u.charCodeAt(p + 1)) ? (c = me(), ee(), y.createReturnStatement(c)) : X() ? y.createReturnStatement(null) : (Z(";") || Z("}") || m.type === t.EOF || (c = me()), ee(), y.createReturnStatement(c))), o);

                case "switch":
                  return y.markEnd(function () {
                    var e, t, r, n, i;
                    if (Q("switch"), J("("), e = me(), J(")"), J("{"), t = [], Z("}")) return q(), y.createSwitchStatement(e, t);

                    for (n = v.inSwitch, v.inSwitch = !0, i = !1; p < d && !Z("}");) {
                      null === (r = xe()).test && (i && W({}, a.MultipleDefaultsInSwitch), i = !0), t.push(r);
                    }

                    return v.inSwitch = n, J("}"), y.createSwitchStatement(e, t);
                  }(), o);

                case "throw":
                  return y.markEnd(function () {
                    var e;
                    return Q("throw"), X() && W({}, a.NewlineAfterThrow), e = me(), ee(), y.createThrowStatement(e);
                  }(), o);

                case "try":
                  return y.markEnd(we(), o);

                case "var":
                  return y.markEnd((Q("var"), s = Se(), ee(), y.createVariableDeclaration(s, "var")), o);

                case "while":
                  return y.markEnd(function () {
                    var e, t, r;
                    return Q("while"), J("("), e = me(), J(")"), r = v.inIteration, v.inIteration = !0, t = ke(), v.inIteration = r, y.createWhileStatement(e, t);
                  }(), o);

                case "with":
                  return y.markEnd(function () {
                    var e, t;
                    return l && (N(), V({}, a.StrictModeWith)), Q("with"), J("("), e = me(), J(")"), t = ke(), y.createWithStatement(e, t);
                  }(), o);
              }
              return (e = me()).type === i.Identifier && Z(":") ? (q(), n = "$" + e.name, Object.prototype.hasOwnProperty.call(v.labelSet, n) && W({}, a.Redeclaration, "Label", e.name), v.labelSet[n] = !0, r = ke(), delete v.labelSet[n], y.markEnd(y.createLabeledStatement(e, r), o)) : (ee(), y.markEnd(y.createExpressionStatement(e), o));
            }

            function Oe() {
              var e,
                  r,
                  n,
                  o,
                  s,
                  c,
                  f,
                  h,
                  g = [];

              for (h = m, J("{"); p < d && m.type === t.StringLiteral && (r = m, e = Pe(), g.push(e), e.expression.type === i.Literal);) {
                "use strict" === (0, _slice.default)(u).call(u, r.start + 1, r.end - 1) ? (l = !0, n && V(n, a.StrictOctalLiteral)) : !n && r.octal && (n = r);
              }

              for (o = v.labelSet, s = v.inIteration, c = v.inSwitch, f = v.inFunctionBody, v.labelSet = {}, v.inIteration = !1, v.inSwitch = !1, v.inFunctionBody = !0; p < d && !Z("}") && void 0 !== (e = Pe());) {
                g.push(e);
              }

              return J("}"), v.labelSet = o, v.inIteration = s, v.inSwitch = c, v.inFunctionBody = f, y.markEnd(y.createBlockStatement(g), h);
            }

            function _e(e) {
              var t,
                  r,
                  n,
                  i,
                  o,
                  s,
                  c = [];
              if (J("("), !Z(")")) for (i = {}; p < d && (r = m, t = ge(), o = "$" + r.value, l ? (P(r.value) && (n = r, s = a.StrictParamName), Object.prototype.hasOwnProperty.call(i, o) && (n = r, s = a.StrictParamDupe)) : e || (P(r.value) ? (e = r, s = a.StrictParamName) : I(r.value) ? (e = r, s = a.StrictReservedWord) : Object.prototype.hasOwnProperty.call(i, o) && (e = r, s = a.StrictParamDupe)), c.push(t), i[o] = !0, !Z(")"));) {
                J(",");
              }
              return J(")"), {
                params: c,
                stricted: n,
                firstRestricted: e,
                message: s
              };
            }

            function Ie() {
              var e, t, r, n, i, o, s, c, u, p;
              return p = m, Q("function"), n = m, e = ge(), l ? P(n.value) && V(n, a.StrictFunctionName) : P(n.value) ? (s = n, c = a.StrictFunctionName) : I(n.value) && (s = n, c = a.StrictReservedWord), t = (o = _e(s)).params, i = o.stricted, s = o.firstRestricted, o.message && (c = o.message), u = l, r = Oe(), l && s && W(s, c), l && i && V(i, c), l = u, y.markEnd(y.createFunctionDeclaration(e, t, [], r), p);
            }

            function Pe() {
              if (m.type === t.Keyword) switch (m.value) {
                case "const":
                case "let":
                  return e = m.value, n = m, Q(e), r = Se(e), ee(), y.markEnd(y.createVariableDeclaration(r, e), n);

                case "function":
                  return Ie();

                default:
                  return ke();
              }
              var e, r, n;
              if (m.type !== t.EOF) return ke();
            }

            function Ae() {
              var e, r;
              return N(), H(), r = m, l = !1, e = function () {
                for (var e, r, n, o = []; p < d && (r = m).type === t.StringLiteral && (e = Pe(), o.push(e), e.expression.type === i.Literal);) {
                  "use strict" === (0, _slice.default)(u).call(u, r.start + 1, r.end - 1) ? (l = !0, n && V(n, a.StrictOctalLiteral)) : !n && r.octal && (n = r);
                }

                for (; p < d && void 0 !== (e = Pe());) {
                  o.push(e);
                }

                return o;
              }(), y.markEnd(y.createProgram(e), r);
            }

            function Te() {
              var e,
                  t,
                  r,
                  n = [];

              for (e = 0; e < g.tokens.length; ++e) {
                r = {
                  type: (t = g.tokens[e]).type,
                  value: t.value
                }, g.range && (r.range = t.range), g.loc && (r.loc = t.loc), n.push(r);
              }

              g.tokens = n;
            }

            (r = {})[(t = {
              BooleanLiteral: 1,
              EOF: 2,
              Identifier: 3,
              Keyword: 4,
              NullLiteral: 5,
              NumericLiteral: 6,
              Punctuator: 7,
              StringLiteral: 8,
              RegularExpression: 9
            }).BooleanLiteral] = "Boolean", r[t.EOF] = "<end>", r[t.Identifier] = "Identifier", r[t.Keyword] = "Keyword", r[t.NullLiteral] = "Null", r[t.NumericLiteral] = "Numeric", r[t.Punctuator] = "Punctuator", r[t.StringLiteral] = "String", r[t.RegularExpression] = "RegularExpression", n = ["(", "{", "[", "in", "typeof", "instanceof", "new", "return", "case", "delete", "throw", "void", "=", "+=", "-=", "*=", "/=", "%=", "<<=", ">>=", ">>>=", "&=", "|=", "^=", ",", "+", "-", "*", "/", "%", "++", "--", "<<", ">>", ">>>", "&", "|", "^", "!", "~", "&&", "||", "?", ":", "===", "==", ">=", "<=", "<", ">", "!=", "!=="], i = {
              AssignmentExpression: "AssignmentExpression",
              ArrayExpression: "ArrayExpression",
              BlockStatement: "BlockStatement",
              BinaryExpression: "BinaryExpression",
              BreakStatement: "BreakStatement",
              CallExpression: "CallExpression",
              CatchClause: "CatchClause",
              ConditionalExpression: "ConditionalExpression",
              ContinueStatement: "ContinueStatement",
              DoWhileStatement: "DoWhileStatement",
              DebuggerStatement: "DebuggerStatement",
              EmptyStatement: "EmptyStatement",
              ExpressionStatement: "ExpressionStatement",
              ForStatement: "ForStatement",
              ForInStatement: "ForInStatement",
              FunctionDeclaration: "FunctionDeclaration",
              FunctionExpression: "FunctionExpression",
              Identifier: "Identifier",
              IfStatement: "IfStatement",
              Literal: "Literal",
              LabeledStatement: "LabeledStatement",
              LogicalExpression: "LogicalExpression",
              MemberExpression: "MemberExpression",
              NewExpression: "NewExpression",
              ObjectExpression: "ObjectExpression",
              Program: "Program",
              Property: "Property",
              ReturnStatement: "ReturnStatement",
              SequenceExpression: "SequenceExpression",
              SwitchStatement: "SwitchStatement",
              SwitchCase: "SwitchCase",
              ThisExpression: "ThisExpression",
              ThrowStatement: "ThrowStatement",
              TryStatement: "TryStatement",
              UnaryExpression: "UnaryExpression",
              UpdateExpression: "UpdateExpression",
              VariableDeclaration: "VariableDeclaration",
              VariableDeclarator: "VariableDeclarator",
              WhileStatement: "WhileStatement",
              WithStatement: "WithStatement"
            }, o = {
              Data: 1,
              Get: 2,
              Set: 4
            }, a = {
              UnexpectedToken: "Unexpected token %0",
              UnexpectedNumber: "Unexpected number",
              UnexpectedString: "Unexpected string",
              UnexpectedIdentifier: "Unexpected identifier",
              UnexpectedReserved: "Unexpected reserved word",
              UnexpectedEOS: "Unexpected end of input",
              NewlineAfterThrow: "Illegal newline after throw",
              InvalidRegExp: "Invalid regular expression",
              UnterminatedRegExp: "Invalid regular expression: missing /",
              InvalidLHSInAssignment: "Invalid left-hand side in assignment",
              InvalidLHSInForIn: "Invalid left-hand side in for-in",
              MultipleDefaultsInSwitch: "More than one default clause in switch statement",
              NoCatchOrFinally: "Missing catch or finally after try",
              UnknownLabel: "Undefined label '%0'",
              Redeclaration: "%0 '%1' has already been declared",
              IllegalContinue: "Illegal continue statement",
              IllegalBreak: "Illegal break statement",
              IllegalReturn: "Illegal return statement",
              StrictModeWith: "Strict mode code may not include a with statement",
              StrictCatchVariable: "Catch variable may not be eval or arguments in strict mode",
              StrictVarName: "Variable name may not be eval or arguments in strict mode",
              StrictParamName: "Parameter name eval or arguments is not allowed in strict mode",
              StrictParamDupe: "Strict mode function may not have duplicate parameter names",
              StrictFunctionName: "Function name may not be eval or arguments in strict mode",
              StrictOctalLiteral: "Octal literals are not allowed in strict mode.",
              StrictDelete: "Delete of an unqualified identifier in strict mode.",
              StrictDuplicateProperty: "Duplicate data property in object literal not allowed in strict mode",
              AccessorDataProperty: "Object literal may not have data and accessor property with the same name",
              AccessorGetSet: "Object literal may not have multiple get/set accessors with the same name",
              StrictLHSAssignment: "Assignment to eval or arguments is not allowed in strict mode",
              StrictLHSPostfix: "Postfix increment/decrement may not have eval or arguments operand in strict mode",
              StrictLHSPrefix: "Prefix increment/decrement may not have eval or arguments operand in strict mode",
              StrictReservedWord: "Use of future reserved word in strict mode"
            }, s = {
              NonAsciiIdentifierStart: new RegExp("[ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ]"),
              NonAsciiIdentifierPart: new RegExp("[ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮ̀-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁ҃-҇Ҋ-ԧԱ-Ֆՙա-և֑-ׇֽֿׁׂׅׄא-תװ-ײؐ-ؚؠ-٩ٮ-ۓە-ۜ۟-۪ۨ-ۼۿܐ-݊ݍ-ޱ߀-ߵߺࠀ-࠭ࡀ-࡛ࢠࢢ-ࢬࣤ-ࣾऀ-ॣ०-९ॱ-ॷॹ-ॿঁ-ঃঅ-ঌএঐও-নপ-রলশ-হ়-ৄেৈো-ৎৗড়ঢ়য়-ৣ০-ৱਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹ਼ਾ-ੂੇੈੋ-੍ੑਖ਼-ੜਫ਼੦-ੵઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હ઼-ૅે-ૉો-્ૐૠ-ૣ૦-૯ଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହ଼-ୄେୈୋ-୍ୖୗଡ଼ଢ଼ୟ-ୣ୦-୯ୱஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-்ௐௗ௦-௯ఁ-ఃఅ-ఌఎ-ఐఒ-నప-ళవ-హఽ-ౄె-ైొ-్ౕౖౘౙౠ-ౣ౦-౯ಂಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹ಼-ೄೆ-ೈೊ-್ೕೖೞೠ-ೣ೦-೯ೱೲംഃഅ-ഌഎ-ഐഒ-ഺഽ-ൄെ-ൈൊ-ൎൗൠ-ൣ൦-൯ൺ-ൿංඃඅ-ඖක-නඳ-රලව-ෆ්ා-ුූෘ-ෟෲෳก-ฺเ-๎๐-๙ກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ູົ-ຽເ-ໄໆ່-ໍ໐-໙ໜ-ໟༀ༘༙༠-༩༹༵༷༾-ཇཉ-ཬཱ-྄྆-ྗྙ-ྼ࿆က-၉ၐ-ႝႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፝-፟ᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-᜔ᜠ-᜴ᝀ-ᝓᝠ-ᝬᝮ-ᝰᝲᝳក-៓ៗៜ៝០-៩᠋-᠍᠐-᠙ᠠ-ᡷᢀ-ᢪᢰ-ᣵᤀ-ᤜᤠ-ᤫᤰ-᤻᥆-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉ᧐-᧙ᨀ-ᨛᨠ-ᩞ᩠-᩿᩼-᪉᪐-᪙ᪧᬀ-ᭋ᭐-᭙᭫-᭳ᮀ-᯳ᰀ-᰷᱀-᱉ᱍ-ᱽ᳐-᳔᳒-ᳶᴀ-ᷦ᷼-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼ‌‍‿⁀⁔ⁱⁿₐ-ₜ⃐-⃥⃜⃡-⃰ℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯ⵿-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⷠ-ⷿⸯ々-〇〡-〯〱-〵〸-〼ぁ-ゖ゙゚ゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘫꙀ-꙯ꙴ-꙽ꙿ-ꚗꚟ-꛱ꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠧꡀ-ꡳꢀ-꣄꣐-꣙꣠-ꣷꣻ꤀-꤭ꤰ-꥓ꥠ-ꥼꦀ-꧀ꧏ-꧙ꨀ-ꨶꩀ-ꩍ꩐-꩙ꩠ-ꩶꩺꩻꪀ-ꫂꫛ-ꫝꫠ-ꫯꫲ-꫶ꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯪ꯬꯭꯰-꯹가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻ︀-️︠-︦︳︴﹍-﹏ﹰ-ﹴﹶ-ﻼ０-９Ａ-Ｚ＿ａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ]")
            }, c = {
              name: "SyntaxTree",
              processComment: function processComment(e) {
                var t, r;

                if (!(e.type === i.Program && e.body.length > 0)) {
                  for (g.trailingComments.length > 0 ? g.trailingComments[0].range[0] >= e.range[1] ? (r = g.trailingComments, g.trailingComments = []) : g.trailingComments.length = 0 : g.bottomRightStack.length > 0 && g.bottomRightStack[g.bottomRightStack.length - 1].trailingComments && g.bottomRightStack[g.bottomRightStack.length - 1].trailingComments[0].range[0] >= e.range[1] && (r = g.bottomRightStack[g.bottomRightStack.length - 1].trailingComments, delete g.bottomRightStack[g.bottomRightStack.length - 1].trailingComments); g.bottomRightStack.length > 0 && g.bottomRightStack[g.bottomRightStack.length - 1].range[0] >= e.range[0];) {
                    t = g.bottomRightStack.pop();
                  }

                  t ? t.leadingComments && t.leadingComments[t.leadingComments.length - 1].range[1] <= e.range[0] && (e.leadingComments = t.leadingComments, delete t.leadingComments) : g.leadingComments.length > 0 && g.leadingComments[g.leadingComments.length - 1].range[1] <= e.range[0] && (e.leadingComments = g.leadingComments, g.leadingComments = []), r && (e.trailingComments = r), g.bottomRightStack.push(e);
                }
              },
              markEnd: function markEnd(e, t) {
                return g.range && (e.range = [t.start, p]), g.loc && (e.loc = new G(void 0 === t.startLineNumber ? t.lineNumber : t.startLineNumber, t.start - (void 0 === t.startLineStart ? t.lineStart : t.startLineStart), f, p - h), this.postProcess(e)), g.attachComment && this.processComment(e), e;
              },
              postProcess: function postProcess(e) {
                return g.source && (e.loc.source = g.source), e;
              },
              createArrayExpression: function createArrayExpression(e) {
                return {
                  type: i.ArrayExpression,
                  elements: e
                };
              },
              createAssignmentExpression: function createAssignmentExpression(e, t, r) {
                return {
                  type: i.AssignmentExpression,
                  operator: e,
                  left: t,
                  right: r
                };
              },
              createBinaryExpression: function createBinaryExpression(e, t, r) {
                return {
                  type: "||" === e || "&&" === e ? i.LogicalExpression : i.BinaryExpression,
                  operator: e,
                  left: t,
                  right: r
                };
              },
              createBlockStatement: function createBlockStatement(e) {
                return {
                  type: i.BlockStatement,
                  body: e
                };
              },
              createBreakStatement: function createBreakStatement(e) {
                return {
                  type: i.BreakStatement,
                  label: e
                };
              },
              createCallExpression: function createCallExpression(e, t) {
                return {
                  type: i.CallExpression,
                  callee: e,
                  arguments: t
                };
              },
              createCatchClause: function createCatchClause(e, t) {
                return {
                  type: i.CatchClause,
                  param: e,
                  body: t
                };
              },
              createConditionalExpression: function createConditionalExpression(e, t, r) {
                return {
                  type: i.ConditionalExpression,
                  test: e,
                  consequent: t,
                  alternate: r
                };
              },
              createContinueStatement: function createContinueStatement(e) {
                return {
                  type: i.ContinueStatement,
                  label: e
                };
              },
              createDebuggerStatement: function createDebuggerStatement() {
                return {
                  type: i.DebuggerStatement
                };
              },
              createDoWhileStatement: function createDoWhileStatement(e, t) {
                return {
                  type: i.DoWhileStatement,
                  body: e,
                  test: t
                };
              },
              createEmptyStatement: function createEmptyStatement() {
                return {
                  type: i.EmptyStatement
                };
              },
              createExpressionStatement: function createExpressionStatement(e) {
                return {
                  type: i.ExpressionStatement,
                  expression: e
                };
              },
              createForStatement: function createForStatement(e, t, r, n) {
                return {
                  type: i.ForStatement,
                  init: e,
                  test: t,
                  update: r,
                  body: n
                };
              },
              createForInStatement: function createForInStatement(e, t, r) {
                return {
                  type: i.ForInStatement,
                  left: e,
                  right: t,
                  body: r,
                  each: !1
                };
              },
              createFunctionDeclaration: function createFunctionDeclaration(e, t, r, n) {
                return {
                  type: i.FunctionDeclaration,
                  id: e,
                  params: t,
                  defaults: r,
                  body: n,
                  rest: null,
                  generator: !1,
                  expression: !1
                };
              },
              createFunctionExpression: function createFunctionExpression(e, t, r, n) {
                return {
                  type: i.FunctionExpression,
                  id: e,
                  params: t,
                  defaults: r,
                  body: n,
                  rest: null,
                  generator: !1,
                  expression: !1
                };
              },
              createIdentifier: function createIdentifier(e) {
                return {
                  type: i.Identifier,
                  name: e
                };
              },
              createIfStatement: function createIfStatement(e, t, r) {
                return {
                  type: i.IfStatement,
                  test: e,
                  consequent: t,
                  alternate: r
                };
              },
              createLabeledStatement: function createLabeledStatement(e, t) {
                return {
                  type: i.LabeledStatement,
                  label: e,
                  body: t
                };
              },
              createLiteral: function createLiteral(e) {
                return {
                  type: i.Literal,
                  value: e.value,
                  raw: (0, _slice.default)(u).call(u, e.start, e.end)
                };
              },
              createMemberExpression: function createMemberExpression(e, t, r) {
                return {
                  type: i.MemberExpression,
                  computed: "[" === e,
                  object: t,
                  property: r
                };
              },
              createNewExpression: function createNewExpression(e, t) {
                return {
                  type: i.NewExpression,
                  callee: e,
                  arguments: t
                };
              },
              createObjectExpression: function createObjectExpression(e) {
                return {
                  type: i.ObjectExpression,
                  properties: e
                };
              },
              createPostfixExpression: function createPostfixExpression(e, t) {
                return {
                  type: i.UpdateExpression,
                  operator: e,
                  argument: t,
                  prefix: !1
                };
              },
              createProgram: function createProgram(e) {
                return {
                  type: i.Program,
                  body: e
                };
              },
              createProperty: function createProperty(e, t, r) {
                return {
                  type: i.Property,
                  key: t,
                  value: r,
                  kind: e
                };
              },
              createReturnStatement: function createReturnStatement(e) {
                return {
                  type: i.ReturnStatement,
                  argument: e
                };
              },
              createSequenceExpression: function createSequenceExpression(e) {
                return {
                  type: i.SequenceExpression,
                  expressions: e
                };
              },
              createSwitchCase: function createSwitchCase(e, t) {
                return {
                  type: i.SwitchCase,
                  test: e,
                  consequent: t
                };
              },
              createSwitchStatement: function createSwitchStatement(e, t) {
                return {
                  type: i.SwitchStatement,
                  discriminant: e,
                  cases: t
                };
              },
              createThisExpression: function createThisExpression() {
                return {
                  type: i.ThisExpression
                };
              },
              createThrowStatement: function createThrowStatement(e) {
                return {
                  type: i.ThrowStatement,
                  argument: e
                };
              },
              createTryStatement: function createTryStatement(e, t, r, n) {
                return {
                  type: i.TryStatement,
                  block: e,
                  guardedHandlers: t,
                  handlers: r,
                  finalizer: n
                };
              },
              createUnaryExpression: function createUnaryExpression(e, t) {
                return "++" === e || "--" === e ? {
                  type: i.UpdateExpression,
                  operator: e,
                  argument: t,
                  prefix: !0
                } : {
                  type: i.UnaryExpression,
                  operator: e,
                  argument: t,
                  prefix: !0
                };
              },
              createVariableDeclaration: function createVariableDeclaration(e, t) {
                return {
                  type: i.VariableDeclaration,
                  declarations: e,
                  kind: t
                };
              },
              createVariableDeclarator: function createVariableDeclarator(e, t) {
                return {
                  type: i.VariableDeclarator,
                  id: e,
                  init: t
                };
              },
              createWhileStatement: function createWhileStatement(e, t) {
                return {
                  type: i.WhileStatement,
                  test: e,
                  body: t
                };
              },
              createWithStatement: function createWithStatement(e, t) {
                return {
                  type: i.WithStatement,
                  object: e,
                  body: t
                };
              }
            }, e.version = "1.2.2", e.tokenize = function (e, r) {
              var n;
              "string" == typeof e || e instanceof String || (e = String(e)), y = c, p = 0, f = (u = e).length > 0 ? 1 : 0, h = 0, d = u.length, m = null, v = {
                allowIn: !0,
                labelSet: {},
                inFunctionBody: !1,
                inIteration: !1,
                inSwitch: !1,
                lastCommentStart: -1
              }, g = {}, (r = r || {}).tokens = !0, g.tokens = [], g.tokenize = !0, g.openParenToken = -1, g.openCurlyToken = -1, g.range = "boolean" == typeof r.range && r.range, g.loc = "boolean" == typeof r.loc && r.loc, "boolean" == typeof r.comment && r.comment && (g.comments = []), "boolean" == typeof r.tolerant && r.tolerant && (g.errors = []);

              try {
                if (H(), m.type === t.EOF) return g.tokens;

                for (q(); m.type !== t.EOF;) {
                  try {
                    q();
                  } catch (e) {
                    if (g.errors) {
                      g.errors.push(e);
                      break;
                    }

                    throw e;
                  }
                }

                Te(), n = g.tokens, void 0 !== g.comments && (n.comments = g.comments), void 0 !== g.errors && (n.errors = g.errors);
              } catch (e) {
                throw e;
              } finally {
                g = {};
              }

              return n;
            }, e.parse = function (e, t) {
              var r, n;
              n = String, "string" == typeof e || e instanceof String || (e = n(e)), y = c, p = 0, f = (u = e).length > 0 ? 1 : 0, h = 0, d = u.length, m = null, v = {
                allowIn: !0,
                labelSet: {},
                inFunctionBody: !1,
                inIteration: !1,
                inSwitch: !1,
                lastCommentStart: -1
              }, g = {}, void 0 !== t && (g.range = "boolean" == typeof t.range && t.range, g.loc = "boolean" == typeof t.loc && t.loc, g.attachComment = "boolean" == typeof t.attachComment && t.attachComment, g.loc && null !== t.source && void 0 !== t.source && (g.source = n(t.source)), "boolean" == typeof t.tokens && t.tokens && (g.tokens = []), "boolean" == typeof t.comment && t.comment && (g.comments = []), "boolean" == typeof t.tolerant && t.tolerant && (g.errors = []), g.attachComment && (g.range = !0, g.comments = [], g.bottomRightStack = [], g.trailingComments = [], g.leadingComments = []));

              try {
                r = Ae(), void 0 !== g.comments && (r.comments = g.comments), void 0 !== g.tokens && (Te(), r.tokens = g.tokens), void 0 !== g.errors && (r.errors = g.errors);
              } catch (e) {
                throw e;
              } finally {
                g = {};
              }

              return r;
            }, e.Syntax = function () {
              var e,
                  t = {};

              for (e in "function" == typeof _create.default && (t = (0, _create.default)(null)), i) {
                i.hasOwnProperty(e) && (t[e] = i[e]);
              }

              return "function" == typeof _freeze.default && (0, _freeze.default)(t), t;
            }();
          });
        }, {}],
        1: [function (e, t, r) {
          (function (n) {
            var _context28;

            var i = function () {
              var e = {
                trace: function trace() {},
                yy: {},
                symbols_: {
                  error: 2,
                  JSON_PATH: 3,
                  DOLLAR: 4,
                  PATH_COMPONENTS: 5,
                  LEADING_CHILD_MEMBER_EXPRESSION: 6,
                  PATH_COMPONENT: 7,
                  MEMBER_COMPONENT: 8,
                  SUBSCRIPT_COMPONENT: 9,
                  CHILD_MEMBER_COMPONENT: 10,
                  DESCENDANT_MEMBER_COMPONENT: 11,
                  DOT: 12,
                  MEMBER_EXPRESSION: 13,
                  DOT_DOT: 14,
                  STAR: 15,
                  IDENTIFIER: 16,
                  SCRIPT_EXPRESSION: 17,
                  INTEGER: 18,
                  END: 19,
                  CHILD_SUBSCRIPT_COMPONENT: 20,
                  DESCENDANT_SUBSCRIPT_COMPONENT: 21,
                  "[": 22,
                  SUBSCRIPT: 23,
                  "]": 24,
                  SUBSCRIPT_EXPRESSION: 25,
                  SUBSCRIPT_EXPRESSION_LIST: 26,
                  SUBSCRIPT_EXPRESSION_LISTABLE: 27,
                  ",": 28,
                  STRING_LITERAL: 29,
                  ARRAY_SLICE: 30,
                  FILTER_EXPRESSION: 31,
                  QQ_STRING: 32,
                  Q_STRING: 33,
                  $accept: 0,
                  $end: 1
                },
                terminals_: {
                  2: "error",
                  4: "DOLLAR",
                  12: "DOT",
                  14: "DOT_DOT",
                  15: "STAR",
                  16: "IDENTIFIER",
                  17: "SCRIPT_EXPRESSION",
                  18: "INTEGER",
                  19: "END",
                  22: "[",
                  24: "]",
                  28: ",",
                  30: "ARRAY_SLICE",
                  31: "FILTER_EXPRESSION",
                  32: "QQ_STRING",
                  33: "Q_STRING"
                },
                productions_: [0, [3, 1], [3, 2], [3, 1], [3, 2], [5, 1], [5, 2], [7, 1], [7, 1], [8, 1], [8, 1], [10, 2], [6, 1], [11, 2], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [9, 1], [9, 1], [20, 3], [21, 4], [23, 1], [23, 1], [26, 1], [26, 3], [27, 1], [27, 1], [27, 1], [25, 1], [25, 1], [25, 1], [29, 1], [29, 1]],
                performAction: function performAction(e, r, n, i, o, a, s) {
                  var _context21;

                  i.ast || (i.ast = t, t.initialize());
                  var c = a.length - 1;

                  switch (o) {
                    case 1:
                      return i.ast.set({
                        expression: {
                          type: "root",
                          value: a[c]
                        }
                      }), i.ast.unshift(), i.ast.yield();

                    case 2:
                      return i.ast.set({
                        expression: {
                          type: "root",
                          value: a[c - 1]
                        }
                      }), i.ast.unshift(), i.ast.yield();

                    case 3:
                      return i.ast.unshift(), i.ast.yield();

                    case 4:
                      return i.ast.set({
                        operation: "member",
                        scope: "child",
                        expression: {
                          type: "identifier",
                          value: a[c - 1]
                        }
                      }), i.ast.unshift(), i.ast.yield();

                    case 5:
                    case 6:
                      break;

                    case 7:
                      i.ast.set({
                        operation: "member"
                      }), i.ast.push();
                      break;

                    case 8:
                      i.ast.set({
                        operation: "subscript"
                      }), i.ast.push();
                      break;

                    case 9:
                      i.ast.set({
                        scope: "child"
                      });
                      break;

                    case 10:
                      i.ast.set({
                        scope: "descendant"
                      });
                      break;

                    case 11:
                      break;

                    case 12:
                      i.ast.set({
                        scope: "child",
                        operation: "member"
                      });
                      break;

                    case 13:
                      break;

                    case 14:
                      i.ast.set({
                        expression: {
                          type: "wildcard",
                          value: a[c]
                        }
                      });
                      break;

                    case 15:
                      i.ast.set({
                        expression: {
                          type: "identifier",
                          value: a[c]
                        }
                      });
                      break;

                    case 16:
                      i.ast.set({
                        expression: {
                          type: "script_expression",
                          value: a[c]
                        }
                      });
                      break;

                    case 17:
                      i.ast.set({
                        expression: {
                          type: "numeric_literal",
                          value: (0, _parseInt2.default)(a[c])
                        }
                      });
                      break;

                    case 18:
                      break;

                    case 19:
                      i.ast.set({
                        scope: "child"
                      });
                      break;

                    case 20:
                      i.ast.set({
                        scope: "descendant"
                      });
                      break;

                    case 21:
                    case 22:
                    case 23:
                      break;

                    case 24:
                      a[c].length > 1 ? i.ast.set({
                        expression: {
                          type: "union",
                          value: a[c]
                        }
                      }) : this.$ = a[c];
                      break;

                    case 25:
                      this.$ = [a[c]];
                      break;

                    case 26:
                      this.$ = (0, _concat.default)(_context21 = a[c - 2]).call(_context21, a[c]);
                      break;

                    case 27:
                      this.$ = {
                        expression: {
                          type: "numeric_literal",
                          value: (0, _parseInt2.default)(a[c])
                        }
                      }, i.ast.set(this.$);
                      break;

                    case 28:
                      this.$ = {
                        expression: {
                          type: "string_literal",
                          value: a[c]
                        }
                      }, i.ast.set(this.$);
                      break;

                    case 29:
                      this.$ = {
                        expression: {
                          type: "slice",
                          value: a[c]
                        }
                      }, i.ast.set(this.$);
                      break;

                    case 30:
                      this.$ = {
                        expression: {
                          type: "wildcard",
                          value: a[c]
                        }
                      }, i.ast.set(this.$);
                      break;

                    case 31:
                      this.$ = {
                        expression: {
                          type: "script_expression",
                          value: a[c]
                        }
                      }, i.ast.set(this.$);
                      break;

                    case 32:
                      this.$ = {
                        expression: {
                          type: "filter_expression",
                          value: a[c]
                        }
                      }, i.ast.set(this.$);
                      break;

                    case 33:
                    case 34:
                      this.$ = a[c];
                  }
                },
                table: [{
                  3: 1,
                  4: [1, 2],
                  6: 3,
                  13: 4,
                  15: [1, 5],
                  16: [1, 6],
                  17: [1, 7],
                  18: [1, 8],
                  19: [1, 9]
                }, {
                  1: [3]
                }, {
                  1: [2, 1],
                  5: 10,
                  7: 11,
                  8: 12,
                  9: 13,
                  10: 14,
                  11: 15,
                  12: [1, 18],
                  14: [1, 19],
                  20: 16,
                  21: 17,
                  22: [1, 20]
                }, {
                  1: [2, 3],
                  5: 21,
                  7: 11,
                  8: 12,
                  9: 13,
                  10: 14,
                  11: 15,
                  12: [1, 18],
                  14: [1, 19],
                  20: 16,
                  21: 17,
                  22: [1, 20]
                }, {
                  1: [2, 12],
                  12: [2, 12],
                  14: [2, 12],
                  22: [2, 12]
                }, {
                  1: [2, 14],
                  12: [2, 14],
                  14: [2, 14],
                  22: [2, 14]
                }, {
                  1: [2, 15],
                  12: [2, 15],
                  14: [2, 15],
                  22: [2, 15]
                }, {
                  1: [2, 16],
                  12: [2, 16],
                  14: [2, 16],
                  22: [2, 16]
                }, {
                  1: [2, 17],
                  12: [2, 17],
                  14: [2, 17],
                  22: [2, 17]
                }, {
                  1: [2, 18],
                  12: [2, 18],
                  14: [2, 18],
                  22: [2, 18]
                }, {
                  1: [2, 2],
                  7: 22,
                  8: 12,
                  9: 13,
                  10: 14,
                  11: 15,
                  12: [1, 18],
                  14: [1, 19],
                  20: 16,
                  21: 17,
                  22: [1, 20]
                }, {
                  1: [2, 5],
                  12: [2, 5],
                  14: [2, 5],
                  22: [2, 5]
                }, {
                  1: [2, 7],
                  12: [2, 7],
                  14: [2, 7],
                  22: [2, 7]
                }, {
                  1: [2, 8],
                  12: [2, 8],
                  14: [2, 8],
                  22: [2, 8]
                }, {
                  1: [2, 9],
                  12: [2, 9],
                  14: [2, 9],
                  22: [2, 9]
                }, {
                  1: [2, 10],
                  12: [2, 10],
                  14: [2, 10],
                  22: [2, 10]
                }, {
                  1: [2, 19],
                  12: [2, 19],
                  14: [2, 19],
                  22: [2, 19]
                }, {
                  1: [2, 20],
                  12: [2, 20],
                  14: [2, 20],
                  22: [2, 20]
                }, {
                  13: 23,
                  15: [1, 5],
                  16: [1, 6],
                  17: [1, 7],
                  18: [1, 8],
                  19: [1, 9]
                }, {
                  13: 24,
                  15: [1, 5],
                  16: [1, 6],
                  17: [1, 7],
                  18: [1, 8],
                  19: [1, 9],
                  22: [1, 25]
                }, {
                  15: [1, 29],
                  17: [1, 30],
                  18: [1, 33],
                  23: 26,
                  25: 27,
                  26: 28,
                  27: 32,
                  29: 34,
                  30: [1, 35],
                  31: [1, 31],
                  32: [1, 36],
                  33: [1, 37]
                }, {
                  1: [2, 4],
                  7: 22,
                  8: 12,
                  9: 13,
                  10: 14,
                  11: 15,
                  12: [1, 18],
                  14: [1, 19],
                  20: 16,
                  21: 17,
                  22: [1, 20]
                }, {
                  1: [2, 6],
                  12: [2, 6],
                  14: [2, 6],
                  22: [2, 6]
                }, {
                  1: [2, 11],
                  12: [2, 11],
                  14: [2, 11],
                  22: [2, 11]
                }, {
                  1: [2, 13],
                  12: [2, 13],
                  14: [2, 13],
                  22: [2, 13]
                }, {
                  15: [1, 29],
                  17: [1, 30],
                  18: [1, 33],
                  23: 38,
                  25: 27,
                  26: 28,
                  27: 32,
                  29: 34,
                  30: [1, 35],
                  31: [1, 31],
                  32: [1, 36],
                  33: [1, 37]
                }, {
                  24: [1, 39]
                }, {
                  24: [2, 23]
                }, {
                  24: [2, 24],
                  28: [1, 40]
                }, {
                  24: [2, 30]
                }, {
                  24: [2, 31]
                }, {
                  24: [2, 32]
                }, {
                  24: [2, 25],
                  28: [2, 25]
                }, {
                  24: [2, 27],
                  28: [2, 27]
                }, {
                  24: [2, 28],
                  28: [2, 28]
                }, {
                  24: [2, 29],
                  28: [2, 29]
                }, {
                  24: [2, 33],
                  28: [2, 33]
                }, {
                  24: [2, 34],
                  28: [2, 34]
                }, {
                  24: [1, 41]
                }, {
                  1: [2, 21],
                  12: [2, 21],
                  14: [2, 21],
                  22: [2, 21]
                }, {
                  18: [1, 33],
                  27: 42,
                  29: 34,
                  30: [1, 35],
                  32: [1, 36],
                  33: [1, 37]
                }, {
                  1: [2, 22],
                  12: [2, 22],
                  14: [2, 22],
                  22: [2, 22]
                }, {
                  24: [2, 26],
                  28: [2, 26]
                }],
                defaultActions: {
                  27: [2, 23],
                  29: [2, 30],
                  30: [2, 31],
                  31: [2, 32]
                },
                parseError: function parseError(e, t) {
                  if (!t.recoverable) throw new Error(e);
                  this.trace(e);
                },
                parse: function parse(e) {
                  var _context22;

                  var t = this,
                      r = [0],
                      n = [null],
                      i = [],
                      o = this.table,
                      a = "",
                      s = 0,
                      c = 0,
                      u = 0,
                      l = 2,
                      p = 1,
                      f = (0, _slice.default)(i).call(arguments, 1);
                  this.lexer.setInput(e), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, void 0 === this.lexer.yylloc && (this.lexer.yylloc = {});
                  var h = this.lexer.yylloc;
                  i.push(h);
                  var d = this.lexer.options && this.lexer.options.ranges;

                  function y() {
                    var e;
                    return "number" != typeof (e = t.lexer.lex() || p) && (e = t.symbols_[e] || e), e;
                  }

                  "function" == typeof this.yy.parseError ? this.parseError = this.yy.parseError : this.parseError = (0, _getPrototypeOf.default)(this).parseError;

                  for (var m, v, g, b, S, E, x, w, k, O = {};;) {
                    if (g = r[r.length - 1], this.defaultActions[g] ? b = this.defaultActions[g] : (null == m && (m = y()), b = o[g] && o[g][m]), void 0 === b || !b.length || !b[0]) {
                      var _ = "";

                      for (E in k = [], o[g]) {
                        this.terminals_[E] && E > l && k.push("'" + this.terminals_[E] + "'");
                      }

                      _ = this.lexer.showPosition ? "Parse error on line " + (s + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + k.join(", ") + ", got '" + (this.terminals_[m] || m) + "'" : "Parse error on line " + (s + 1) + ": Unexpected " + (m == p ? "end of input" : "'" + (this.terminals_[m] || m) + "'"), this.parseError(_, {
                        text: this.lexer.match,
                        token: this.terminals_[m] || m,
                        line: this.lexer.yylineno,
                        loc: h,
                        expected: k
                      });
                    }

                    if (b[0] instanceof Array && b.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + g + ", token: " + m);

                    switch (b[0]) {
                      case 1:
                        r.push(m), n.push(this.lexer.yytext), i.push(this.lexer.yylloc), r.push(b[1]), m = null, v ? (m = v, v = null) : (c = this.lexer.yyleng, a = this.lexer.yytext, s = this.lexer.yylineno, h = this.lexer.yylloc, u > 0 && u--);
                        break;

                      case 2:
                        if (x = this.productions_[b[1]][1], O.$ = n[n.length - x], O._$ = {
                          first_line: i[i.length - (x || 1)].first_line,
                          last_line: i[i.length - 1].last_line,
                          first_column: i[i.length - (x || 1)].first_column,
                          last_column: i[i.length - 1].last_column
                        }, d && (O._$.range = [i[i.length - (x || 1)].range[0], i[i.length - 1].range[1]]), void 0 !== (S = this.performAction.apply(O, (0, _concat.default)(_context22 = [a, c, s, this.yy, b[1], n, i]).call(_context22, f)))) return S;
                        x && (r = (0, _slice.default)(r).call(r, 0, -1 * x * 2), n = (0, _slice.default)(n).call(n, 0, -1 * x), i = (0, _slice.default)(i).call(i, 0, -1 * x)), r.push(this.productions_[b[1]][0]), n.push(O.$), i.push(O._$), w = o[r[r.length - 2]][r[r.length - 1]], r.push(w);
                        break;

                      case 3:
                        return !0;
                    }
                  }

                  return !0;
                }
              },
                  t = {
                initialize: function initialize() {
                  this._nodes = [], this._node = {}, this._stash = [];
                },
                set: function set(e) {
                  for (var t in e) {
                    this._node[t] = e[t];
                  }

                  return this._node;
                },
                node: function node(e) {
                  return arguments.length && (this._node = e), this._node;
                },
                push: function push() {
                  this._nodes.push(this._node), this._node = {};
                },
                unshift: function unshift() {
                  this._nodes.unshift(this._node), this._node = {};
                },
                yield: function _yield() {
                  var e = this._nodes;
                  return this.initialize(), e;
                }
              },
                  r = {
                EOF: 1,
                parseError: function parseError(e, t) {
                  if (!this.yy.parser) throw new Error(e);
                  this.yy.parser.parseError(e, t);
                },
                setInput: function setInput(e) {
                  return this._input = e, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                  }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
                },
                input: function input() {
                  var _context23;

                  var e = this._input[0];
                  return this.yytext += e, this.yyleng++, this.offset++, this.match += e, this.matched += e, e.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = (0, _slice.default)(_context23 = this._input).call(_context23, 1), e;
                },
                unput: function unput(e) {
                  var t = e.length,
                      r = e.split(/(?:\r\n?|\n)/g);
                  this._input = e + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - t - 1), this.offset -= t;
                  var n = this.match.split(/(?:\r\n?|\n)/g);
                  this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), r.length - 1 && (this.yylineno -= r.length - 1);
                  var i = this.yylloc.range;
                  return this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: r ? (r.length === n.length ? this.yylloc.first_column : 0) + n[n.length - r.length].length - r[0].length : this.yylloc.first_column - t
                  }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - t]), this.yyleng = this.yytext.length, this;
                },
                more: function more() {
                  return this._more = !0, this;
                },
                reject: function reject() {
                  return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                  });
                },
                less: function less(e) {
                  var _context24;

                  this.unput((0, _slice.default)(_context24 = this.match).call(_context24, e));
                },
                pastInput: function pastInput() {
                  var e = this.matched.substr(0, this.matched.length - this.match.length);
                  return (e.length > 20 ? "..." : "") + e.substr(-20).replace(/\n/g, "");
                },
                upcomingInput: function upcomingInput() {
                  var e = this.match;
                  return e.length < 20 && (e += this._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(/\n/g, "");
                },
                showPosition: function showPosition() {
                  var e = this.pastInput(),
                      t = new Array(e.length + 1).join("-");
                  return e + this.upcomingInput() + "\n" + t + "^";
                },
                test_match: function test_match(e, t) {
                  var _context25, _context26, _context27;

                  var r, n, i;
                  if (this.options.backtrack_lexer && (i = {
                    yylineno: this.yylineno,
                    yylloc: {
                      first_line: this.yylloc.first_line,
                      last_line: this.last_line,
                      first_column: this.yylloc.first_column,
                      last_column: this.yylloc.last_column
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    yy: this.yy,
                    conditionStack: (0, _slice.default)(_context25 = this.conditionStack).call(_context25, 0),
                    done: this.done
                  }, this.options.ranges && (i.yylloc.range = (0, _slice.default)(_context26 = this.yylloc.range).call(_context26, 0))), (n = e[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += n.length), this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: n ? n[n.length - 1].length - n[n.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + e[0].length
                  }, this.yytext += e[0], this.match += e[0], this.matches = e, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = (0, _slice.default)(_context27 = this._input).call(_context27, e[0].length), this.matched += e[0], r = this.performAction.call(this, this.yy, this, t, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), r) return r;

                  if (this._backtrack) {
                    for (var o in i) {
                      this[o] = i[o];
                    }

                    return !1;
                  }

                  return !1;
                },
                next: function next() {
                  if (this.done) return this.EOF;
                  var e, t, r, n;
                  this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

                  for (var i = this._currentRules(), o = 0; o < i.length; o++) {
                    if ((r = this._input.match(this.rules[i[o]])) && (!t || r[0].length > t[0].length)) {
                      if (t = r, n = o, this.options.backtrack_lexer) {
                        if (!1 !== (e = this.test_match(r, i[o]))) return e;

                        if (this._backtrack) {
                          t = !1;
                          continue;
                        }

                        return !1;
                      }

                      if (!this.options.flex) break;
                    }
                  }

                  return t ? !1 !== (e = this.test_match(t, i[n])) && e : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                  });
                },
                lex: function lex() {
                  var e = this.next();
                  return e || this.lex();
                },
                begin: function begin(e) {
                  this.conditionStack.push(e);
                },
                popState: function popState() {
                  return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
                },
                _currentRules: function _currentRules() {
                  return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
                },
                topState: function topState(e) {
                  return (e = this.conditionStack.length - 1 - Math.abs(e || 0)) >= 0 ? this.conditionStack[e] : "INITIAL";
                },
                pushState: function pushState(e) {
                  this.begin(e);
                },
                stateStackSize: function stateStackSize() {
                  return this.conditionStack.length;
                },
                options: {},
                performAction: function performAction(e, t, r, n) {
                  switch (r) {
                    case 0:
                      return 4;

                    case 1:
                      return 14;

                    case 2:
                      return 12;

                    case 3:
                      return 15;

                    case 4:
                      return 16;

                    case 5:
                      return 22;

                    case 6:
                      return 24;

                    case 7:
                      return 28;

                    case 8:
                      return 30;

                    case 9:
                      return 18;

                    case 10:
                      return t.yytext = t.yytext.substr(1, t.yyleng - 2), 32;

                    case 11:
                      return t.yytext = t.yytext.substr(1, t.yyleng - 2), 33;

                    case 12:
                      return 17;

                    case 13:
                      return 31;
                  }
                },
                rules: [/^(?:\$)/, /^(?:\.\.)/, /^(?:\.)/, /^(?:\*)/, /^(?:[a-zA-Z_]+[a-zA-Z0-9_]*)/, /^(?:\[)/, /^(?:\])/, /^(?:,)/, /^(?:((-?(?:0|[1-9][0-9]*)))?\:((-?(?:0|[1-9][0-9]*)))?(\:((-?(?:0|[1-9][0-9]*)))?)?)/, /^(?:(-?(?:0|[1-9][0-9]*)))/, /^(?:"(?:\\["bfnrt/\\]|\\u[a-fA-F0-9]{4}|[^"\\])*")/, /^(?:'(?:\\['bfnrt/\\]|\\u[a-fA-F0-9]{4}|[^'\\])*')/, /^(?:\(.+?\)(?=\]))/, /^(?:\?\(.+?\)(?=\]))/],
                conditions: {
                  INITIAL: {
                    rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
                    inclusive: !0
                  }
                }
              };

              function n() {
                this.yy = {};
              }

              return e.lexer = r, n.prototype = e, e.Parser = n, new n();
            }();

            void 0 !== e && void 0 !== r && (r.parser = i, r.Parser = i.Parser, r.parse = function () {
              return i.parse.apply(i, arguments);
            }, r.main = function (t) {
              t[1] || (console.log("Usage: " + t[0] + " FILE"), n.exit(1));
              var i = e("fs").readFileSync(e("path").normalize(t[1]), "utf8");
              return r.parser.parse(i);
            }, void 0 !== t && e.main === t && r.main((0, _slice.default)(_context28 = n.argv).call(_context28, 1)));
          }).call(this, e("_process"));
        }, {
          _process: 14,
          fs: 12,
          path: 13
        }],
        2: [function (e, t, r) {
          t.exports = {
            identifier: "[a-zA-Z_]+[a-zA-Z0-9_]*",
            integer: "-?(?:0|[1-9][0-9]*)",
            qq_string: "\"(?:\\\\[\"bfnrt/\\\\]|\\\\u[a-fA-F0-9]{4}|[^\"\\\\])*\"",
            q_string: "'(?:\\\\['bfnrt/\\\\]|\\\\u[a-fA-F0-9]{4}|[^'\\\\])*'"
          };
        }, {}],
        3: [function (e, t, r) {
          var n = e("./dict"),
              i = e("fs"),
              o = {
            lex: {
              macros: {
                esc: "\\\\",
                int: n.integer
              },
              rules: [["\\$", "return 'DOLLAR'"], ["\\.\\.", "return 'DOT_DOT'"], ["\\.", "return 'DOT'"], ["\\*", "return 'STAR'"], [n.identifier, "return 'IDENTIFIER'"], ["\\[", "return '['"], ["\\]", "return ']'"], [",", "return ','"], ["({int})?\\:({int})?(\\:({int})?)?", "return 'ARRAY_SLICE'"], ["{int}", "return 'INTEGER'"], [n.qq_string, "yytext = yytext.substr(1,yyleng-2); return 'QQ_STRING';"], [n.q_string, "yytext = yytext.substr(1,yyleng-2); return 'Q_STRING';"], ["\\(.+?\\)(?=\\])", "return 'SCRIPT_EXPRESSION'"], ["\\?\\(.+?\\)(?=\\])", "return 'FILTER_EXPRESSION'"]]
            },
            start: "JSON_PATH",
            bnf: {
              JSON_PATH: [["DOLLAR", 'yy.ast.set({ expression: { type: "root", value: $1 } }); yy.ast.unshift(); return yy.ast.yield()'], ["DOLLAR PATH_COMPONENTS", 'yy.ast.set({ expression: { type: "root", value: $1 } }); yy.ast.unshift(); return yy.ast.yield()'], ["LEADING_CHILD_MEMBER_EXPRESSION", "yy.ast.unshift(); return yy.ast.yield()"], ["LEADING_CHILD_MEMBER_EXPRESSION PATH_COMPONENTS", 'yy.ast.set({ operation: "member", scope: "child", expression: { type: "identifier", value: $1 }}); yy.ast.unshift(); return yy.ast.yield()']],
              PATH_COMPONENTS: [["PATH_COMPONENT", ""], ["PATH_COMPONENTS PATH_COMPONENT", ""]],
              PATH_COMPONENT: [["MEMBER_COMPONENT", 'yy.ast.set({ operation: "member" }); yy.ast.push()'], ["SUBSCRIPT_COMPONENT", 'yy.ast.set({ operation: "subscript" }); yy.ast.push() ']],
              MEMBER_COMPONENT: [["CHILD_MEMBER_COMPONENT", 'yy.ast.set({ scope: "child" })'], ["DESCENDANT_MEMBER_COMPONENT", 'yy.ast.set({ scope: "descendant" })']],
              CHILD_MEMBER_COMPONENT: [["DOT MEMBER_EXPRESSION", ""]],
              LEADING_CHILD_MEMBER_EXPRESSION: [["MEMBER_EXPRESSION", 'yy.ast.set({ scope: "child", operation: "member" })']],
              DESCENDANT_MEMBER_COMPONENT: [["DOT_DOT MEMBER_EXPRESSION", ""]],
              MEMBER_EXPRESSION: [["STAR", 'yy.ast.set({ expression: { type: "wildcard", value: $1 } })'], ["IDENTIFIER", 'yy.ast.set({ expression: { type: "identifier", value: $1 } })'], ["SCRIPT_EXPRESSION", 'yy.ast.set({ expression: { type: "script_expression", value: $1 } })'], ["INTEGER", 'yy.ast.set({ expression: { type: "numeric_literal", value: parseInt($1) } })'], ["END", ""]],
              SUBSCRIPT_COMPONENT: [["CHILD_SUBSCRIPT_COMPONENT", 'yy.ast.set({ scope: "child" })'], ["DESCENDANT_SUBSCRIPT_COMPONENT", 'yy.ast.set({ scope: "descendant" })']],
              CHILD_SUBSCRIPT_COMPONENT: [["[ SUBSCRIPT ]", ""]],
              DESCENDANT_SUBSCRIPT_COMPONENT: [["DOT_DOT [ SUBSCRIPT ]", ""]],
              SUBSCRIPT: [["SUBSCRIPT_EXPRESSION", ""], ["SUBSCRIPT_EXPRESSION_LIST", '$1.length > 1? yy.ast.set({ expression: { type: "union", value: $1 } }) : $$ = $1']],
              SUBSCRIPT_EXPRESSION_LIST: [["SUBSCRIPT_EXPRESSION_LISTABLE", "$$ = [$1]"], ["SUBSCRIPT_EXPRESSION_LIST , SUBSCRIPT_EXPRESSION_LISTABLE", "$$ = $1.concat($3)"]],
              SUBSCRIPT_EXPRESSION_LISTABLE: [["INTEGER", '$$ = { expression: { type: "numeric_literal", value: parseInt($1) } }; yy.ast.set($$)'], ["STRING_LITERAL", '$$ = { expression: { type: "string_literal", value: $1 } }; yy.ast.set($$)'], ["ARRAY_SLICE", '$$ = { expression: { type: "slice", value: $1 } }; yy.ast.set($$)']],
              SUBSCRIPT_EXPRESSION: [["STAR", '$$ = { expression: { type: "wildcard", value: $1 } }; yy.ast.set($$)'], ["SCRIPT_EXPRESSION", '$$ = { expression: { type: "script_expression", value: $1 } }; yy.ast.set($$)'], ["FILTER_EXPRESSION", '$$ = { expression: { type: "filter_expression", value: $1 } }; yy.ast.set($$)']],
              STRING_LITERAL: [["QQ_STRING", "$$ = $1"], ["Q_STRING", "$$ = $1"]]
            }
          };
          i.readFileSync && (o.moduleInclude = i.readFileSync(e.resolve("../include/module.js")), o.actionInclude = i.readFileSync(e.resolve("../include/action.js"))), t.exports = o;
        }, {
          "./dict": 2,
          fs: 12
        }],
        4: [function (e, t, r) {
          var n = e("./aesprim"),
              i = e("./slice"),
              o = e("static-eval"),
              a = e("underscore").uniq,
              s = function s() {
            return this.initialize.apply(this, arguments);
          };

          function c(t, r, i) {
            var o = e("./index"),
                a = h(n.parse(r).body[0].expression, {
              "@": t.value
            }),
                s = i.replace(/\{\{\s*value\s*\}\}/g, a),
                c = o.nodes(t.value, s);
            return (0, _forEach.default)(c).call(c, function (e) {
              var _context29, _context30;

              e.path = (0, _concat.default)(_context29 = t.path).call(_context29, (0, _slice.default)(_context30 = e.path).call(_context30, 1));
            }), c;
          }

          function u(e) {
            return (0, _isArray.default)(e);
          }

          function l(e) {
            return function (t, r, n, i) {
              var _context31;

              var o = t.value,
                  a = t.path,
                  s = [],
                  c = (0, _bind.default)(_context31 = function _context31(t, o) {
                var _context32, _context33, _context34, _context35;

                var a;
                u(t) ? ((0, _forEach.default)(t).call(t, function (e, t) {
                  s.length >= i || n(t, e, r) && s.push({
                    path: (0, _concat.default)(o).call(o, t),
                    value: e
                  });
                }), (0, _forEach.default)(t).call(t, function (t, r) {
                  s.length >= i || e && c(t, (0, _concat.default)(o).call(o, r));
                })) : (a = t) && !(a instanceof Array) && a instanceof Object && ((0, _forEach.default)(_context32 = (0, _keys2.default)(_context33 = this).call(_context33, t)).call(_context32, function (e) {
                  s.length >= i || n(e, t[e], r) && s.push({
                    path: (0, _concat.default)(o).call(o, e),
                    value: t[e]
                  });
                }), (0, _forEach.default)(_context34 = (0, _keys2.default)(_context35 = this).call(_context35, t)).call(_context34, function (r) {
                  s.length >= i || e && c(t[r], (0, _concat.default)(o).call(o, r));
                }));
              }).call(_context31, this);
              return c(o, a), s;
            };
          }

          function p(e) {
            return function (t, r, n) {
              return this.descend(r, t.expression.value, e, n);
            };
          }

          function f(e) {
            return function (t, r, n) {
              return this.traverse(r, t.expression.value, e, n);
            };
          }

          function h() {
            try {
              return o.apply(this, arguments);
            } catch (e) {}
          }

          function d(e) {
            return e = (0, _filter.default)(e).call(e, function (e) {
              return e;
            }), a(e, function (e) {
              var _context36;

              return (0, _map.default)(_context36 = e.path).call(_context36, function (e) {
                return String(e).replace("-", "--");
              }).join("-");
            });
          }

          function y(e) {
            var t = String(e);
            return t.match(/^-?[0-9]+$/) ? (0, _parseInt2.default)(t) : null;
          }

          s.prototype.initialize = function () {
            this.traverse = l(!0), this.descend = l();
          }, s.prototype.keys = _keys.default, s.prototype.resolve = function (e) {
            var t = [e.operation, e.scope, e.expression.type].join("-"),
                r = this._fns[t];
            if (!r) throw new Error("couldn't resolve key: " + t);
            return (0, _bind.default)(r).call(r, this);
          }, s.prototype.register = function (e, t) {
            if (!t instanceof Function) throw new Error("handler must be a function");
            this._fns[e] = t;
          }, s.prototype._fns = {
            "member-child-identifier": function memberChildIdentifier(e, t) {
              var _context37;

              var r = e.expression.value,
                  n = t.value;
              if (n instanceof Object && r in n) return [{
                value: n[r],
                path: (0, _concat.default)(_context37 = t.path).call(_context37, r)
              }];
            },
            "member-descendant-identifier": f(function (e, t, r) {
              return e == r;
            }),
            "subscript-child-numeric_literal": p(function (e, t, r) {
              return e === r;
            }),
            "member-child-numeric_literal": p(function (e, t, r) {
              return String(e) === String(r);
            }),
            "subscript-descendant-numeric_literal": f(function (e, t, r) {
              return e === r;
            }),
            "member-child-wildcard": p(function () {
              return !0;
            }),
            "member-descendant-wildcard": f(function () {
              return !0;
            }),
            "subscript-descendant-wildcard": f(function () {
              return !0;
            }),
            "subscript-child-wildcard": p(function () {
              return !0;
            }),
            "subscript-child-slice": function subscriptChildSlice(e, t) {
              if (u(t.value)) {
                var _context38, _context39, _context41;

                var r = (0, _map.default)(_context38 = e.expression.value.split(":")).call(_context38, y),
                    n = (0, _map.default)(_context39 = t.value).call(_context39, function (e, r) {
                  var _context40;

                  return {
                    value: e,
                    path: (0, _concat.default)(_context40 = t.path).call(_context40, r)
                  };
                });
                return i.apply(null, (0, _concat.default)(_context41 = [n]).call(_context41, r));
              }
            },
            "subscript-child-union": function subscriptChildUnion(e, t) {
              var _context42;

              var r = [];
              return (0, _forEach.default)(_context42 = e.expression.value).call(_context42, function (e) {
                var n = {
                  operation: "subscript",
                  scope: "child",
                  expression: e.expression
                },
                    i = this.resolve(n)(n, t);
                i && (r = (0, _concat.default)(r).call(r, i));
              }, this), d(r);
            },
            "subscript-descendant-union": function subscriptDescendantUnion(t, r, n) {
              var _context43, _context44;

              var i = e(".."),
                  o = this,
                  a = [];
              return (0, _forEach.default)(_context43 = (0, _slice.default)(_context44 = i.nodes(r, "$..*")).call(_context44, 1)).call(_context43, function (e) {
                var _context45;

                a.length >= n || (0, _forEach.default)(_context45 = t.expression.value).call(_context45, function (t) {
                  var r = {
                    operation: "subscript",
                    scope: "child",
                    expression: t.expression
                  },
                      n = o.resolve(r)(r, e);
                  a = (0, _concat.default)(a).call(a, n);
                });
              }), d(a);
            },
            "subscript-child-filter_expression": function subscriptChildFilter_expression(e, t, r) {
              var _context46;

              var i = (0, _slice.default)(_context46 = e.expression.value).call(_context46, 2, -1),
                  o = n.parse(i).body[0].expression;
              return this.descend(t, null, function (e, t) {
                return h(o, {
                  "@": t
                });
              }, r);
            },
            "subscript-descendant-filter_expression": function subscriptDescendantFilter_expression(e, t, r) {
              var _context47;

              var i = (0, _slice.default)(_context47 = e.expression.value).call(_context47, 2, -1),
                  o = n.parse(i).body[0].expression;
              return this.traverse(t, null, function (e, t) {
                return h(o, {
                  "@": t
                });
              }, r);
            },
            "subscript-child-script_expression": function subscriptChildScript_expression(e, t) {
              var _context48;

              return c(t, (0, _slice.default)(_context48 = e.expression.value).call(_context48, 1, -1), "$[{{value}}]");
            },
            "member-child-script_expression": function memberChildScript_expression(e, t) {
              var _context49;

              return c(t, (0, _slice.default)(_context49 = e.expression.value).call(_context49, 1, -1), "$.{{value}}");
            },
            "member-descendant-script_expression": function memberDescendantScript_expression(e, t) {
              var _context50;

              return c(t, (0, _slice.default)(_context50 = e.expression.value).call(_context50, 1, -1), "$..value");
            }
          }, s.prototype._fns["subscript-child-string_literal"] = s.prototype._fns["member-child-identifier"], s.prototype._fns["member-descendant-numeric_literal"] = s.prototype._fns["subscript-descendant-string_literal"] = s.prototype._fns["member-descendant-identifier"], t.exports = s;
        }, {
          "..": "jsonpath",
          "./aesprim": "./aesprim",
          "./index": 5,
          "./slice": 7,
          "static-eval": 15,
          underscore: 12
        }],
        5: [function (e, t, r) {
          var n = e("assert"),
              i = e("./dict"),
              o = e("./parser"),
              a = e("./handlers"),
              s = function s() {
            this.initialize.apply(this, arguments);
          };

          function c(e) {
            return "[object String]" == Object.prototype.toString.call(e);
          }

          s.prototype.initialize = function () {
            this.parser = new o(), this.handlers = new a();
          }, s.prototype.parse = function (e) {
            return n.ok(c(e), "we need a path"), this.parser.parse(e);
          }, s.prototype.parent = function (e, t) {
            n.ok(e instanceof Object, "obj needs to be an object"), n.ok(t, "we need a path");
            var r = this.nodes(e, t)[0];
            return r.path.pop(), this.value(e, r.path);
          }, s.prototype.apply = function (e, t, r) {
            var _context51;

            n.ok(e instanceof Object, "obj needs to be an object"), n.ok(t, "we need a path"), n.equal((0, _typeof2.default)(r), "function", "fn needs to be function");
            var i = (0, _sort.default)(_context51 = this.nodes(e, t)).call(_context51, function (e, t) {
              return t.path.length - e.path.length;
            });
            return (0, _forEach.default)(i).call(i, function (t) {
              var n = t.path.pop(),
                  i = this.value(e, this.stringify(t.path)),
                  o = t.value = r.call(e, i[n]);
              i[n] = o;
            }, this), i;
          }, s.prototype.value = function (e, t, r) {
            if (n.ok(e instanceof Object, "obj needs to be an object"), n.ok(t, "we need a path"), arguments.length >= 3) {
              var _context52;

              var i = this.nodes(e, t).shift();
              if (!i) return this._vivify(e, t, r);
              var o = (0, _slice.default)(_context52 = i.path).call(_context52, -1).shift(),
                  a = this.parent(e, this.stringify(i.path));
              a[o] = r;
            }

            return this.query(e, this.stringify(t), 1).shift();
          }, s.prototype._vivify = function (e, t, r) {
            var _context53;

            var i = this;
            n.ok(e instanceof Object, "obj needs to be an object"), n.ok(t, "we need a path");

            var o = (0, _map.default)(_context53 = this.parser.parse(t)).call(_context53, function (e) {
              return e.expression.value;
            }),
                a = function a(t, r) {
              var n = t.pop(),
                  o = i.value(e, t);
              o || (a((0, _concat.default)(t).call(t), "string" == typeof n ? {} : []), o = i.value(e, t)), o[n] = r;
            };

            return a(o, r), this.query(e, t)[0];
          }, s.prototype.query = function (e, t, r) {
            var _context54;

            return n.ok(e instanceof Object, "obj needs to be an object"), n.ok(c(t), "we need a path"), (0, _map.default)(_context54 = this.nodes(e, t, r)).call(_context54, function (e) {
              return e.value;
            });
          }, s.prototype.paths = function (e, t, r) {
            var _context55;

            return n.ok(e instanceof Object, "obj needs to be an object"), n.ok(t, "we need a path"), (0, _map.default)(_context55 = this.nodes(e, t, r)).call(_context55, function (e) {
              return e.path;
            });
          }, s.prototype.nodes = function (e, t, r) {
            if (n.ok(e instanceof Object, "obj needs to be an object"), n.ok(t, "we need a path"), 0 === r) return [];
            var i = this.parser.parse(t),
                o = this.handlers,
                a = [{
              path: ["$"],
              value: e
            }],
                s = [];
            return i.length && "root" == i[0].expression.type && i.shift(), i.length ? ((0, _forEach.default)(i).call(i, function (e, t) {
              if (!(s.length >= r)) {
                var n = o.resolve(e),
                    c = [];
                (0, _forEach.default)(a).call(a, function (o) {
                  if (!(s.length >= r)) {
                    var a = n(e, o, r);
                    t == i.length - 1 ? s = (0, _concat.default)(s).call(s, a || []) : c = (0, _concat.default)(c).call(c, a || []);
                  }
                }), a = c;
              }
            }), r ? (0, _slice.default)(s).call(s, 0, r) : s) : a;
          }, s.prototype.stringify = function (e) {
            var _context56;

            n.ok(e, "we need a path");
            var t = "$",
                r = {
              "descendant-member": "..{{value}}",
              "child-member": ".{{value}}",
              "descendant-subscript": "..[{{value}}]",
              "child-subscript": "[{{value}}]"
            };
            return (0, _forEach.default)(_context56 = e = this._normalize(e)).call(_context56, function (e) {
              if ("root" != e.expression.type) {
                var n,
                    i = [e.scope, e.operation].join("-"),
                    o = r[i];
                if (n = "string_literal" == e.expression.type ? (0, _stringify.default)(e.expression.value) : e.expression.value, !o) throw new Error("couldn't find template " + i);
                t += o.replace(/{{value}}/, n);
              }
            }), t;
          }, s.prototype._normalize = function (e) {
            if (n.ok(e, "we need a path"), "string" == typeof e) return this.parser.parse(e);

            if ((0, _isArray.default)(e) && "string" == typeof e[0]) {
              var t = [{
                expression: {
                  type: "root",
                  value: "$"
                }
              }];
              return (0, _forEach.default)(e).call(e, function (e, r) {
                if ("$" != e || 0 !== r) if ("string" == typeof e && e.match("^" + i.identifier + "$")) t.push({
                  operation: "member",
                  scope: "child",
                  expression: {
                    value: e,
                    type: "identifier"
                  }
                });else {
                  var n = "number" == typeof e ? "numeric_literal" : "string_literal";
                  t.push({
                    operation: "subscript",
                    scope: "child",
                    expression: {
                      value: e,
                      type: n
                    }
                  });
                }
              }), t;
            }

            if ((0, _isArray.default)(e) && "object" == (0, _typeof2.default)(e[0])) return e;
            throw new Error("couldn't understand path " + e);
          }, s.Handlers = a, s.Parser = o;
          var u = new s();
          u.JSONPath = s, t.exports = u;
        }, {
          "./dict": 2,
          "./handlers": 4,
          "./parser": 6,
          assert: 8
        }],
        6: [function (e, t, r) {
          var n = e("./grammar"),
              i = e("../generated/parser"),
              o = function o() {
            var e = new i.Parser(),
                t = e.parseError;
            return e.yy.parseError = function () {
              e.yy.ast && e.yy.ast.initialize(), t.apply(e, arguments);
            }, e;
          };

          o.grammar = n, t.exports = o;
        }, {
          "../generated/parser": 1,
          "./grammar": 3
        }],
        7: [function (e, t, r) {
          function n(e) {
            return String(e).match(/^[0-9]+$/) ? (0, _parseInt2.default)(e) : (0, _isFinite.default)(e) ? (0, _parseInt2.default)(e, 10) : 0;
          }

          t.exports = function (e, t, r, i) {
            if ("string" == typeof t) throw new Error("start cannot be a string");
            if ("string" == typeof r) throw new Error("end cannot be a string");
            if ("string" == typeof i) throw new Error("step cannot be a string");
            var o = e.length;
            if (0 === i) throw new Error("step cannot be zero");
            if (i = i ? n(i) : 1, r = r < 0 ? o + r : r, t = n(0 === (t = t < 0 ? o + t : t) ? 0 : t || (i > 0 ? 0 : o - 1)), r = n(0 === r ? 0 : r || (i > 0 ? o : -1)), t = i > 0 ? Math.max(0, t) : Math.min(o, t), r = i > 0 ? Math.min(r, o) : Math.max(-1, r), i > 0 && r <= t) return [];
            if (i < 0 && t <= r) return [];

            for (var a = [], s = t; s != r && !(i < 0 && s <= r || i > 0 && s >= r); s += i) {
              a.push(e[s]);
            }

            return a;
          };
        }, {}],
        8: [function (e, t, r) {
          var n = e("util/"),
              i = (0, _slice.default)(Array.prototype),
              o = Object.prototype.hasOwnProperty,
              a = t.exports = l;

          function s(e, t) {
            return n.isUndefined(t) ? "" + t : n.isNumber(t) && !isFinite(t) ? t.toString() : n.isFunction(t) || n.isRegExp(t) ? t.toString() : t;
          }

          function c(e, t) {
            return n.isString(e) ? e.length < t ? e : (0, _slice.default)(e).call(e, 0, t) : e;
          }

          function u(e, t, r, n, i) {
            throw new a.AssertionError({
              message: r,
              actual: e,
              expected: t,
              operator: n,
              stackStartFunction: i
            });
          }

          function l(e, t) {
            e || u(e, !0, t, "==", a.ok);
          }

          function p(e, t) {
            if (e === t) return !0;

            if (n.isBuffer(e) && n.isBuffer(t)) {
              if (e.length != t.length) return !1;

              for (var r = 0; r < e.length; r++) {
                if (e[r] !== t[r]) return !1;
              }

              return !0;
            }

            return n.isDate(e) && n.isDate(t) ? e.getTime() === t.getTime() : n.isRegExp(e) && n.isRegExp(t) ? e.source === t.source && e.global === t.global && e.multiline === t.multiline && e.lastIndex === t.lastIndex && e.ignoreCase === t.ignoreCase : n.isObject(e) || n.isObject(t) ? function (e, t) {
              if (n.isNullOrUndefined(e) || n.isNullOrUndefined(t)) return !1;
              if (e.prototype !== t.prototype) return !1;
              if (n.isPrimitive(e) || n.isPrimitive(t)) return e === t;
              var r = f(e),
                  o = f(t);
              if (r && !o || !r && o) return !1;
              if (r) return e = i.call(e), t = i.call(t), p(e, t);
              var a,
                  s,
                  c = y(e),
                  u = y(t);
              if (c.length != u.length) return !1;

              for ((0, _sort.default)(c).call(c), (0, _sort.default)(u).call(u), s = c.length - 1; s >= 0; s--) {
                if (c[s] != u[s]) return !1;
              }

              for (s = c.length - 1; s >= 0; s--) {
                if (a = c[s], !p(e[a], t[a])) return !1;
              }

              return !0;
            }(e, t) : e == t;
          }

          function f(e) {
            return "[object Arguments]" == Object.prototype.toString.call(e);
          }

          function h(e, t) {
            return !(!e || !t) && ("[object RegExp]" == Object.prototype.toString.call(t) ? t.test(e) : e instanceof t || !0 === t.call({}, e));
          }

          function d(e, t, r, i) {
            var o;
            n.isString(r) && (i = r, r = null);

            try {
              t();
            } catch (e) {
              o = e;
            }

            if (i = (r && r.name ? " (" + r.name + ")." : ".") + (i ? " " + i : "."), e && !o && u(o, r, "Missing expected exception" + i), !e && h(o, r) && u(o, r, "Got unwanted exception" + i), e && o && r && !h(o, r) || !e && o) throw o;
          }

          a.AssertionError = function (e) {
            this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = function (e) {
              return c((0, _stringify.default)(e.actual, s), 128) + " " + e.operator + " " + c((0, _stringify.default)(e.expected, s), 128);
            }(this), this.generatedMessage = !0);
            var t = e.stackStartFunction || u;
            if (Error.captureStackTrace) Error.captureStackTrace(this, t);else {
              var r = new Error();

              if (r.stack) {
                var n = r.stack,
                    i = t.name,
                    o = (0, _indexOf.default)(n).call(n, "\n" + i);

                if (o >= 0) {
                  var a = (0, _indexOf.default)(n).call(n, "\n", o + 1);
                  n = n.substring(a + 1);
                }

                this.stack = n;
              }
            }
          }, n.inherits(a.AssertionError, Error), a.fail = u, a.ok = l, a.equal = function (e, t, r) {
            e != t && u(e, t, r, "==", a.equal);
          }, a.notEqual = function (e, t, r) {
            e == t && u(e, t, r, "!=", a.notEqual);
          }, a.deepEqual = function (e, t, r) {
            p(e, t) || u(e, t, r, "deepEqual", a.deepEqual);
          }, a.notDeepEqual = function (e, t, r) {
            p(e, t) && u(e, t, r, "notDeepEqual", a.notDeepEqual);
          }, a.strictEqual = function (e, t, r) {
            e !== t && u(e, t, r, "===", a.strictEqual);
          }, a.notStrictEqual = function (e, t, r) {
            e === t && u(e, t, r, "!==", a.notStrictEqual);
          }, a.throws = function (e, t, r) {
            var _context57;

            d.apply(this, (0, _concat.default)(_context57 = [!0]).call(_context57, i.call(arguments)));
          }, a.doesNotThrow = function (e, t) {
            var _context58;

            d.apply(this, (0, _concat.default)(_context58 = [!1]).call(_context58, i.call(arguments)));
          }, a.ifError = function (e) {
            if (e) throw e;
          };

          var y = _keys.default || function (e) {
            var t = [];

            for (var r in e) {
              o.call(e, r) && t.push(r);
            }

            return t;
          };
        }, {
          "util/": 11
        }],
        9: [function (e, t, r) {
          "function" == typeof _create.default ? t.exports = function (e, t) {
            e.super_ = t, e.prototype = (0, _create.default)(t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            });
          } : t.exports = function (e, t) {
            e.super_ = t;

            var r = function r() {};

            r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
          };
        }, {}],
        10: [function (e, t, r) {
          t.exports = function (e) {
            return e && "object" == (0, _typeof2.default)(e) && "function" == typeof e.copy && "function" == typeof (0, _fill.default)(e) && "function" == typeof e.readUInt8;
          };
        }, {}],
        11: [function (e, r, n) {
          (function (t, r) {
            var i = /%[sdj%]/g;
            n.format = function (e) {
              if (!v(e)) {
                for (var t = [], r = 0; r < arguments.length; r++) {
                  t.push(s(arguments[r]));
                }

                return t.join(" ");
              }

              r = 1;

              for (var n = arguments, o = n.length, a = String(e).replace(i, function (e) {
                if ("%%" === e) return "%";
                if (r >= o) return e;

                switch (e) {
                  case "%s":
                    return String(n[r++]);

                  case "%d":
                    return Number(n[r++]);

                  case "%j":
                    try {
                      return (0, _stringify.default)(n[r++]);
                    } catch (e) {
                      return "[Circular]";
                    }

                  default:
                    return e;
                }
              }), c = n[r]; r < o; c = n[++r]) {
                y(c) || !S(c) ? a += " " + c : a += " " + s(c);
              }

              return a;
            }, n.deprecate = function (e, i) {
              if (g(r.process)) return function () {
                return n.deprecate(e, i).apply(this, arguments);
              };
              if (!0 === t.noDeprecation) return e;
              var o = !1;
              return function () {
                if (!o) {
                  if (t.throwDeprecation) throw new Error(i);
                  t.traceDeprecation ? console.trace(i) : console.error(i), o = !0;
                }

                return e.apply(this, arguments);
              };
            };
            var o,
                a = {};

            function s(e, t) {
              var r = {
                seen: [],
                stylize: u
              };
              return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), d(t) ? r.showHidden = t : t && n._extend(r, t), g(r.showHidden) && (r.showHidden = !1), g(r.depth) && (r.depth = 2), g(r.colors) && (r.colors = !1), g(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = c), l(r, e, r.depth);
            }

            function c(e, t) {
              var r = s.styles[t];
              return r ? "[" + s.colors[r][0] + "m" + e + "[" + s.colors[r][1] + "m" : e;
            }

            function u(e, t) {
              return e;
            }

            function l(e, t, r) {
              if (e.customInspect && t && w(t.inspect) && t.inspect !== n.inspect && (!t.constructor || t.constructor.prototype !== t)) {
                var i = t.inspect(r, e);
                return v(i) || (i = l(e, i, r)), i;
              }

              var o = function (e, t) {
                if (g(t)) return e.stylize("undefined", "undefined");

                if (v(t)) {
                  var r = "'" + (0, _stringify.default)(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                  return e.stylize(r, "string");
                }

                return m(t) ? e.stylize("" + t, "number") : d(t) ? e.stylize("" + t, "boolean") : y(t) ? e.stylize("null", "null") : void 0;
              }(e, t);

              if (o) return o;

              var a = (0, _keys.default)(t),
                  s = function (e) {
                var t = {};
                return (0, _forEach.default)(e).call(e, function (e, r) {
                  t[e] = !0;
                }), t;
              }(a);

              if (e.showHidden && (a = (0, _getOwnPropertyNames.default)(t)), x(t) && ((0, _indexOf.default)(a).call(a, "message") >= 0 || (0, _indexOf.default)(a).call(a, "description") >= 0)) return p(t);

              if (0 === a.length) {
                if (w(t)) {
                  var c = t.name ? ": " + t.name : "";
                  return e.stylize("[Function" + c + "]", "special");
                }

                if (b(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                if (E(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                if (x(t)) return p(t);
              }

              var u,
                  S = "",
                  k = !1,
                  O = ["{", "}"];
              return h(t) && (k = !0, O = ["[", "]"]), w(t) && (S = " [Function" + (t.name ? ": " + t.name : "") + "]"), b(t) && (S = " " + RegExp.prototype.toString.call(t)), E(t) && (S = " " + Date.prototype.toUTCString.call(t)), x(t) && (S = " " + p(t)), 0 !== a.length || k && 0 != t.length ? r < 0 ? b(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), u = k ? function (e, t, r, n, i) {
                for (var o = [], a = 0, s = t.length; a < s; ++a) {
                  P(t, String(a)) ? o.push(f(e, t, r, n, String(a), !0)) : o.push("");
                }

                return (0, _forEach.default)(i).call(i, function (i) {
                  i.match(/^\d+$/) || o.push(f(e, t, r, n, i, !0));
                }), o;
              }(e, t, r, s, a) : (0, _map.default)(a).call(a, function (n) {
                return f(e, t, r, s, n, k);
              }), e.seen.pop(), function (e, t, r) {
                return (0, _reduce.default)(e).call(e, function (e, t) {
                  return (0, _indexOf.default)(t).call(t, "\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                }, 0) > 60 ? r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
              }(u, S, O)) : O[0] + S + O[1];
            }

            function p(e) {
              return "[" + Error.prototype.toString.call(e) + "]";
            }

            function f(e, t, r, n, i, o) {
              var _context59, _context60, _context61, _context62;

              var a, s, c;

              if ((c = (0, _getOwnPropertyDescriptor.default)(t, i) || {
                value: t[i]
              }).get ? s = c.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : c.set && (s = e.stylize("[Setter]", "special")), P(n, i) || (a = "[" + i + "]"), s || ((0, _indexOf.default)(_context59 = e.seen).call(_context59, c.value) < 0 ? (0, _indexOf.default)(_context60 = s = y(r) ? l(e, c.value, null) : l(e, c.value, r - 1)).call(_context60, "\n") > -1 && (s = o ? (0, _map.default)(_context61 = s.split("\n")).call(_context61, function (e) {
                return "  " + e;
              }).join("\n").substr(2) : "\n" + (0, _map.default)(_context62 = s.split("\n")).call(_context62, function (e) {
                return "   " + e;
              }).join("\n")) : s = e.stylize("[Circular]", "special")), g(a)) {
                if (o && i.match(/^\d+$/)) return s;
                (a = (0, _stringify.default)("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
              }

              return a + ": " + s;
            }

            function h(e) {
              return (0, _isArray.default)(e);
            }

            function d(e) {
              return "boolean" == typeof e;
            }

            function y(e) {
              return null === e;
            }

            function m(e) {
              return "number" == typeof e;
            }

            function v(e) {
              return "string" == typeof e;
            }

            function g(e) {
              return void 0 === e;
            }

            function b(e) {
              return S(e) && "[object RegExp]" === k(e);
            }

            function S(e) {
              return "object" == (0, _typeof2.default)(e) && null !== e;
            }

            function E(e) {
              return S(e) && "[object Date]" === k(e);
            }

            function x(e) {
              return S(e) && ("[object Error]" === k(e) || e instanceof Error);
            }

            function w(e) {
              return "function" == typeof e;
            }

            function k(e) {
              return Object.prototype.toString.call(e);
            }

            function O(e) {
              return e < 10 ? "0" + e.toString(10) : e.toString(10);
            }

            n.debuglog = function (e) {
              if (g(o) && (o = t.env.NODE_DEBUG || ""), e = e.toUpperCase(), !a[e]) if (new RegExp("\\b" + e + "\\b", "i").test(o)) {
                var r = t.pid;

                a[e] = function () {
                  var t = n.format.apply(n, arguments);
                  console.error("%s %d: %s", e, r, t);
                };
              } else a[e] = function () {};
              return a[e];
            }, n.inspect = s, s.colors = {
              bold: [1, 22],
              italic: [3, 23],
              underline: [4, 24],
              inverse: [7, 27],
              white: [37, 39],
              grey: [90, 39],
              black: [30, 39],
              blue: [34, 39],
              cyan: [36, 39],
              green: [32, 39],
              magenta: [35, 39],
              red: [31, 39],
              yellow: [33, 39]
            }, s.styles = {
              special: "cyan",
              number: "yellow",
              boolean: "yellow",
              undefined: "grey",
              null: "bold",
              string: "green",
              date: "magenta",
              regexp: "red"
            }, n.isArray = h, n.isBoolean = d, n.isNull = y, n.isNullOrUndefined = function (e) {
              return null == e;
            }, n.isNumber = m, n.isString = v, n.isSymbol = function (e) {
              return "symbol" == (0, _typeof2.default)(e);
            }, n.isUndefined = g, n.isRegExp = b, n.isObject = S, n.isDate = E, n.isError = x, n.isFunction = w, n.isPrimitive = function (e) {
              return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == (0, _typeof2.default)(e) || void 0 === e;
            }, n.isBuffer = e("./support/isBuffer");
            var _ = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

            function I() {
              var e = new Date(),
                  t = [O(e.getHours()), O(e.getMinutes()), O(e.getSeconds())].join(":");
              return [e.getDate(), _[e.getMonth()], t].join(" ");
            }

            function P(e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }

            n.log = function () {
              console.log("%s - %s", I(), n.format.apply(n, arguments));
            }, n.inherits = e("inherits"), n._extend = function (e, t) {
              if (!t || !S(t)) return e;

              for (var r = (0, _keys.default)(t), n = r.length; n--;) {
                e[r[n]] = t[r[n]];
              }

              return e;
            };
          }).call(this, e("_process"), void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {
          "./support/isBuffer": 10,
          _process: 14,
          inherits: 9
        }],
        12: [function (e, t, r) {}, {}],
        13: [function (e, t, r) {
          (function (e) {
            function t(e, t) {
              for (var r = 0, n = e.length - 1; n >= 0; n--) {
                var i = e[n];
                "." === i ? (0, _splice.default)(e).call(e, n, 1) : ".." === i ? ((0, _splice.default)(e).call(e, n, 1), r++) : r && ((0, _splice.default)(e).call(e, n, 1), r--);
              }

              if (t) for (; r--; r) {
                e.unshift("..");
              }
              return e;
            }

            function n(e, t) {
              if ((0, _filter.default)(e)) return (0, _filter.default)(e).call(e, t);

              for (var r = [], n = 0; n < e.length; n++) {
                t(e[n], n, e) && r.push(e[n]);
              }

              return r;
            }

            r.resolve = function () {
              for (var r = "", i = !1, o = arguments.length - 1; o >= -1 && !i; o--) {
                var a = o >= 0 ? arguments[o] : e.cwd();
                if ("string" != typeof a) throw new TypeError("Arguments to path.resolve must be strings");
                a && (r = a + "/" + r, i = "/" === a.charAt(0));
              }

              return (i ? "/" : "") + (r = t(n(r.split("/"), function (e) {
                return !!e;
              }), !i).join("/")) || ".";
            }, r.normalize = function (e) {
              var o = r.isAbsolute(e),
                  a = "/" === i(e, -1);
              return (e = t(n(e.split("/"), function (e) {
                return !!e;
              }), !o).join("/")) || o || (e = "."), e && a && (e += "/"), (o ? "/" : "") + e;
            }, r.isAbsolute = function (e) {
              return "/" === e.charAt(0);
            }, r.join = function () {
              var e = (0, _slice.default)(Array.prototype).call(arguments, 0);
              return r.normalize(n(e, function (e, t) {
                if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
                return e;
              }).join("/"));
            }, r.relative = function (e, t) {
              function n(e) {
                for (var t = 0; t < e.length && "" === e[t]; t++) {
                  ;
                }

                for (var r = e.length - 1; r >= 0 && "" === e[r]; r--) {
                  ;
                }

                return t > r ? [] : (0, _slice.default)(e).call(e, t, r - t + 1);
              }

              e = r.resolve(e).substr(1), t = r.resolve(t).substr(1);

              for (var i = n(e.split("/")), o = n(t.split("/")), a = Math.min(i.length, o.length), s = a, c = 0; c < a; c++) {
                if (i[c] !== o[c]) {
                  s = c;
                  break;
                }
              }

              var u = [];

              for (c = s; c < i.length; c++) {
                u.push("..");
              }

              return (u = (0, _concat.default)(u).call(u, (0, _slice.default)(o).call(o, s))).join("/");
            }, r.sep = "/", r.delimiter = ":", r.dirname = function (e) {
              if ("string" != typeof e && (e += ""), 0 === e.length) return ".";

              for (var t = e.charCodeAt(0), r = 47 === t, n = -1, i = !0, o = e.length - 1; o >= 1; --o) {
                if (47 === (t = e.charCodeAt(o))) {
                  if (!i) {
                    n = o;
                    break;
                  }
                } else i = !1;
              }

              return -1 === n ? r ? "/" : "." : r && 1 === n ? "/" : (0, _slice.default)(e).call(e, 0, n);
            }, r.basename = function (e, t) {
              var r = function (e) {
                "string" != typeof e && (e += "");
                var t,
                    r = 0,
                    n = -1,
                    i = !0;

                for (t = e.length - 1; t >= 0; --t) {
                  if (47 === e.charCodeAt(t)) {
                    if (!i) {
                      r = t + 1;
                      break;
                    }
                  } else -1 === n && (i = !1, n = t + 1);
                }

                return -1 === n ? "" : (0, _slice.default)(e).call(e, r, n);
              }(e);

              return t && r.substr(-1 * t.length) === t && (r = r.substr(0, r.length - t.length)), r;
            }, r.extname = function (e) {
              "string" != typeof e && (e += "");

              for (var t = -1, r = 0, n = -1, i = !0, o = 0, a = e.length - 1; a >= 0; --a) {
                var s = e.charCodeAt(a);
                if (47 !== s) -1 === n && (i = !1, n = a + 1), 46 === s ? -1 === t ? t = a : 1 !== o && (o = 1) : -1 !== t && (o = -1);else if (!i) {
                  r = a + 1;
                  break;
                }
              }

              return -1 === t || -1 === n || 0 === o || 1 === o && t === n - 1 && t === r + 1 ? "" : (0, _slice.default)(e).call(e, t, n);
            };
            var i = "b" === "ab".substr(-1) ? function (e, t, r) {
              return e.substr(t, r);
            } : function (e, t, r) {
              return t < 0 && (t = e.length + t), e.substr(t, r);
            };
          }).call(this, e("_process"));
        }, {
          _process: 14
        }],
        14: [function (e, t, r) {
          var n,
              i,
              o = t.exports = {};

          function a() {
            throw new Error("setTimeout has not been defined");
          }

          function s() {
            throw new Error("clearTimeout has not been defined");
          }

          function c(e) {
            if (n === _setTimeout2.default) return (0, _setTimeout2.default)(e, 0);
            if ((n === a || !n) && _setTimeout2.default) return n = _setTimeout2.default, (0, _setTimeout2.default)(e, 0);

            try {
              return n(e, 0);
            } catch (t) {
              try {
                return n.call(null, e, 0);
              } catch (t) {
                return n.call(this, e, 0);
              }
            }
          }

          !function () {
            try {
              n = "function" == typeof _setTimeout2.default ? _setTimeout2.default : a;
            } catch (e) {
              n = a;
            }

            try {
              i = "function" == typeof clearTimeout ? clearTimeout : s;
            } catch (e) {
              i = s;
            }
          }();
          var u,
              l = [],
              p = !1,
              f = -1;

          function h() {
            p && u && (p = !1, u.length ? l = (0, _concat.default)(u).call(u, l) : f = -1, l.length && d());
          }

          function d() {
            if (!p) {
              var e = c(h);
              p = !0;

              for (var t = l.length; t;) {
                for (u = l, l = []; ++f < t;) {
                  u && u[f].run();
                }

                f = -1, t = l.length;
              }

              u = null, p = !1, function (e) {
                if (i === clearTimeout) return clearTimeout(e);
                if ((i === s || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);

                try {
                  i(e);
                } catch (t) {
                  try {
                    return i.call(null, e);
                  } catch (t) {
                    return i.call(this, e);
                  }
                }
              }(e);
            }
          }

          function y(e, t) {
            this.fun = e, this.array = t;
          }

          function m() {}

          o.nextTick = function (e) {
            var t = new Array(arguments.length - 1);
            if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
              t[r - 1] = arguments[r];
            }
            l.push(new y(e, t)), 1 !== l.length || p || c(d);
          }, y.prototype.run = function () {
            this.fun.apply(null, this.array);
          }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = m, o.addListener = m, o.once = m, o.off = m, o.removeListener = m, o.removeAllListeners = m, o.emit = m, o.prependListener = m, o.prependOnceListener = m, o.listeners = function (e) {
            return [];
          }, o.binding = function (e) {
            throw new Error("process.binding is not supported");
          }, o.cwd = function () {
            return "/";
          }, o.chdir = function (e) {
            throw new Error("process.chdir is not supported");
          }, o.umask = function () {
            return 0;
          };
        }, {}],
        15: [function (e, t, r) {
          var n = e("escodegen").generate;

          t.exports = function (e, t) {
            t || (t = {});

            var r = {},
                i = function e(i, o) {
              if ("Literal" === i.type) return i.value;

              if ("UnaryExpression" === i.type) {
                var a = e(i.argument);
                return "+" === i.operator ? +a : "-" === i.operator ? -a : "~" === i.operator ? ~a : "!" === i.operator ? !a : r;
              }

              if ("ArrayExpression" === i.type) {
                for (var s = [], c = 0, u = i.elements.length; c < u; c++) {
                  if ((v = e(i.elements[c])) === r) return r;
                  s.push(v);
                }

                return s;
              }

              if ("ObjectExpression" === i.type) {
                var l = {};

                for (c = 0; c < i.properties.length; c++) {
                  var p = null === (g = i.properties[c]).value ? g.value : e(g.value);
                  if (p === r) return r;
                  l[g.key.value || g.key.name] = p;
                }

                return l;
              }

              if ("BinaryExpression" === i.type || "LogicalExpression" === i.type) {
                if ((u = e(i.left)) === r) return r;
                var f = e(i.right);
                if (f === r) return r;
                var h = i.operator;
                return "==" === h ? u == f : "===" === h ? u === f : "!=" === h ? u != f : "!==" === h ? u !== f : "+" === h ? u + f : "-" === h ? u - f : "*" === h ? u * f : "/" === h ? u / f : "%" === h ? u % f : "<" === h ? u < f : "<=" === h ? u <= f : ">" === h ? u > f : ">=" === h ? u >= f : "|" === h ? u | f : "&" === h ? u & f : "^" === h ? u ^ f : "&&" === h ? u && f : "||" === h ? u || f : r;
              }

              if ("Identifier" === i.type) return {}.hasOwnProperty.call(t, i.name) ? t[i.name] : r;
              if ("ThisExpression" === i.type) return {}.hasOwnProperty.call(t, "this") ? t.this : r;

              if ("CallExpression" === i.type) {
                var d = e(i.callee);
                if (d === r) return r;
                if ("function" != typeof d) return r;
                var y = i.callee.object ? e(i.callee.object) : r;
                y === r && (y = null);
                var m = [];

                for (c = 0, u = i.arguments.length; c < u; c++) {
                  var v;
                  if ((v = e(i.arguments[c])) === r) return r;
                  m.push(v);
                }

                return d.apply(y, m);
              }

              var g;
              if ("MemberExpression" === i.type) return (l = e(i.object)) === r || "function" == typeof l ? r : "Identifier" === i.property.type ? l[i.property.name] : (g = e(i.property)) === r ? r : l[g];
              if ("ConditionalExpression" === i.type) return (a = e(i.test)) === r ? r : e(a ? i.consequent : i.alternate);
              if ("ExpressionStatement" === i.type) return (a = e(i.expression)) === r ? r : a;
              if ("ReturnStatement" === i.type) return e(i.argument);

              if ("FunctionExpression" === i.type) {
                var b = i.body.body,
                    S = {};

                for ((0, _forEach.default)(_context63 = (0, _keys.default)(t)).call(_context63, function (e) {
                  S[e] = t[e];
                }), c = 0; c < i.params.length; c++) {
                  var _context63;

                  var E = i.params[c];
                  if ("Identifier" != E.type) return r;
                  t[E.name] = null;
                }

                for (var c in b) {
                  if (e(b[c]) === r) return r;
                }

                t = S;
                var x = (0, _keys.default)(t),
                    w = (0, _map.default)(x).call(x, function (e) {
                  return t[e];
                });
                return Function(x.join(", "), "return " + n(i)).apply(null, w);
              }

              if ("TemplateLiteral" === i.type) {
                var k = "";

                for (c = 0; c < i.expressions.length; c++) {
                  k += e(i.quasis[c]), k += e(i.expressions[c]);
                }

                return k += e(i.quasis[c]);
              }

              if ("TaggedTemplateExpression" === i.type) {
                var _context64, _context65, _context66;

                var O = e(i.tag),
                    _ = i.quasi,
                    I = (0, _map.default)(_context64 = _.quasis).call(_context64, e),
                    P = (0, _map.default)(_context65 = _.expressions).call(_context65, e);
                return O.apply(null, (0, _concat.default)(_context66 = [I]).call(_context66, P));
              }

              return "TemplateElement" === i.type ? i.value.cooked : r;
            }(e);

            return i === r ? void 0 : i;
          };
        }, {
          escodegen: 12
        }],
        jsonpath: [function (e, t, r) {
          t.exports = e("./lib/index");
        }, {
          "./lib/index": 5
        }]
      }, {}, ["jsonpath"])("jsonpath");
    }).call(this, r(2));
  }, function (e, t) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (e) {
      "object" == (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) && (r = window);
    }

    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    var _context71;

    r.r(t);
    var n = r(0),
        i = r.n(n);

    function o(e, t, r, n, i, o, a) {
      try {
        var s = e[o](a),
            c = s.value;
      } catch (e) {
        return void r(e);
      }

      s.done ? t(c) : _promise.default.resolve(c).then(n, i);
    }

    var a = function () {
      var e,
          t = (e = _regenerator.default.mark(function e(t) {
        var r, n, o, a;
        return _regenerator.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r = t.domain, n = t.stateHandle, (null != (o = t.version) ? o : "").replace(/[^0-9a-zA-Z._-]/, "") === o && o) {
                  e.next = 4;
                  break;
                }

                throw new Error("invalid version supplied - version is required and uses semver syntax");

              case 4:
                return a = "".concat(r, "/idp/idx/introspect"), e.abrupt("return", i()(a, {
                  method: "POST",
                  headers: {
                    "content-type": "application/ion+json; okta-version=".concat(o),
                    accept: "application/ion+json; okta-version=".concat(o)
                  },
                  body: (0, _stringify.default)({
                    stateToken: n
                  })
                }).then(function (e) {
                  return e.ok ? e.json() : e.json().then(function (e) {
                    return _promise.default.reject(e);
                  });
                }));

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }), function () {
        var t = this,
            r = arguments;
        return new _promise.default(function (n, i) {
          var a = e.apply(t, r);

          function s(e) {
            o(a, n, i, s, c, "next", e);
          }

          function c(e) {
            o(a, n, i, s, c, "throw", e);
          }

          s(void 0);
        });
      });
      return function (e) {
        return t.apply(this, arguments);
      };
    }(),
        s = function s(e) {
      return !1 !== e.mutable;
    },
        c = function c(e) {
      var t = {},
          r = [],
          n = {};
      if (!e.value) return r.push(e), {
        defaultParamsForAction: t,
        neededParamsForAction: r,
        immutableParamsForAction: n
      };
      var i = !0,
          o = !1,
          a = void 0;

      try {
        for (var c, u = (0, _getIterator2.default)(e.value); !(i = (c = u.next()).done); i = !0) {
          var l,
              p,
              f = c.value;
          if (s(f)) r.push(f), null !== (l = f.value) && void 0 !== l && l && (t[f.name] = f.value);else n[f.name] = null !== (p = f.value) && void 0 !== p ? p : "";
        }
      } catch (e) {
        o = !0, a = e;
      } finally {
        try {
          i || null == u.return || u.return();
        } finally {
          if (o) throw a;
        }
      }

      return {
        defaultParamsForAction: t,
        neededParamsForAction: r,
        immutableParamsForAction: n
      };
    };

    function u(e, t) {
      var r = (0, _keys.default)(e);

      if (_getOwnPropertySymbols.default) {
        var n = (0, _getOwnPropertySymbols.default)(e);
        t && (n = (0, _filter.default)(n).call(n, function (t) {
          return (0, _getOwnPropertyDescriptor.default)(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function l(e) {
      for (var t = 1; t < arguments.length; t++) {
        var _context67, _context68;

        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? (0, _forEach.default)(_context67 = u(Object(r), !0)).call(_context67, function (t) {
          p(e, t, r[t]);
        }) : _getOwnPropertyDescriptors.default ? (0, _defineProperties.default)(e, (0, _getOwnPropertyDescriptors.default)(r)) : (0, _forEach.default)(_context68 = u(Object(r))).call(_context68, function (t) {
          (0, _defineProperty.default)(e, t, (0, _getOwnPropertyDescriptor.default)(r, t));
        });
      }

      return e;
    }

    function p(e, t, r) {
      return t in e ? (0, _defineProperty.default)(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function f(e, t, r, n, i, o, a) {
      try {
        var s = e[o](a),
            c = s.value;
      } catch (e) {
        return void r(e);
      }

      s.done ? t(c) : _promise.default.resolve(c).then(n, i);
    }

    var h = function h(e) {
      var t = e.actionDefinition,
          r = e.defaultParamsForAction,
          n = void 0 === r ? {} : r,
          o = e.immutableParamsForAction,
          a = void 0 === o ? {} : o,
          s = t.href;
      return function () {
        var e,
            r = (e = _regenerator.default.mark(function e(r) {
          return _regenerator.default.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", i()(s, {
                    method: t.method,
                    headers: {
                      "content-type": "application/json",
                      accepts: t.accepts || "application/ion+json"
                    },
                    body: (0, _stringify.default)(l({}, n, {}, r, {}, a))
                  }).then(function (e) {
                    var t = e.json();
                    return e.ok ? t : 401 === e.status && 'Oktadevicejwt realm="Okta Device"' === e.headers.get("WWW-Authenticate") ? t.then(function (e) {
                      return _promise.default.reject(P(e));
                    }) : t.then(function (e) {
                      return _promise.default.reject(e);
                    });
                  }).then(function (e) {
                    return P(e);
                  }));

                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }), function () {
          var t = this,
              r = arguments;
          return new _promise.default(function (n, i) {
            var o = e.apply(t, r);

            function a(e) {
              f(o, n, i, a, s, "next", e);
            }

            function s(e) {
              f(o, n, i, a, s, "throw", e);
            }

            a(void 0);
          });
        });
        return function (e) {
          return r.apply(this, arguments);
        };
      }();
    },
        d = function d(e) {
      var t = h,
          r = function (e) {
        e = (0, _isArray.default)(e) ? e : [e];
        var t = [],
            r = {},
            n = {},
            i = !0,
            o = !1,
            a = void 0;

        try {
          for (var s, u = (0, _getIterator2.default)(e); !(i = (s = u.next()).done); i = !0) {
            var l = s.value,
                p = c(l),
                f = p.defaultParamsForAction,
                h = p.neededParamsForAction,
                d = p.immutableParamsForAction;
            t.push(h), r[l.name] = f, n[l.name] = d;
          }
        } catch (e) {
          o = !0, a = e;
        } finally {
          try {
            i || null == u.return || u.return();
          } finally {
            if (o) throw a;
          }
        }

        return {
          defaultParams: r,
          neededParams: t,
          immutableParams: n
        };
      }(e),
          n = r.defaultParams,
          i = r.neededParams,
          o = r.immutableParams,
          a = t({
        actionDefinition: e,
        defaultParamsForAction: n[e.name],
        immutableParamsForAction: o[e.name]
      });

      return a.neededParams = i, a;
    },
        y = r(1),
        m = r.n(y);

    function v(e, t) {
      return function (e) {
        if ((0, _isArray.default)(e)) return e;
      }(e) || function (e, t) {
        if (!((0, _isIterable2.default)(Object(e)) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
        var r = [],
            n = !0,
            i = !1,
            o = void 0;

        try {
          for (var a, s = (0, _getIterator2.default)(e); !(n = (a = s.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          i = !0, o = e;
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }

        return r;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function g(e, t) {
      var r = (0, _keys.default)(e);

      if (_getOwnPropertySymbols.default) {
        var n = (0, _getOwnPropertySymbols.default)(e);
        t && (n = (0, _filter.default)(n).call(n, function (t) {
          return (0, _getOwnPropertyDescriptor.default)(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function b(e) {
      for (var t = 1; t < arguments.length; t++) {
        var _context69, _context70;

        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? (0, _forEach.default)(_context69 = g(Object(r), !0)).call(_context69, function (t) {
          S(e, t, r[t]);
        }) : _getOwnPropertyDescriptors.default ? (0, _defineProperties.default)(e, (0, _getOwnPropertyDescriptors.default)(r)) : (0, _forEach.default)(_context70 = g(Object(r))).call(_context70, function (t) {
          (0, _defineProperty.default)(e, t, (0, _getOwnPropertyDescriptor.default)(r, t));
        });
      }

      return e;
    }

    function S(e, t, r) {
      return t in e ? (0, _defineProperty.default)(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function E(e, t) {
      if (null == e) return {};

      var r,
          n,
          i = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            i = {},
            o = (0, _keys.default)(e);

        for (n = 0; n < o.length; n++) {
          r = o[n], (0, _indexOf.default)(t).call(t, r) >= 0 || (i[r] = e[r]);
        }

        return i;
      }(e, t);

      if (_getOwnPropertySymbols.default) {
        var o = (0, _getOwnPropertySymbols.default)(e);

        for (n = 0; n < o.length; n++) {
          r = o[n], (0, _indexOf.default)(t).call(t, r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
        }
      }

      return i;
    }

    function x(e) {
      return (x = "function" == typeof _symbol.default && "symbol" == (0, _typeof2.default)(_iterator.default) ? function (e) {
        return (0, _typeof2.default)(e);
      } : function (e) {
        return e && "function" == typeof _symbol.default && e.constructor === _symbol.default && e !== _symbol.default.prototype ? "symbol" : (0, _typeof2.default)(e);
      })(e);
    }

    var w = (0, _fromEntries.default)((0, _map.default)(_context71 = ["remediation", "context"]).call(_context71, function (e) {
      return [e, !0];
    })),
        k = function k(e) {
      var t;
      return b({}, e, {
        action: (t = [e], (0, _fromEntries.default)((0, _map.default)(t).call(t, function (e) {
          return [e.name, d(e)];
        })))[e.name]
      });
    },
        O = function O(e) {
      var t,
          r = (null === (t = e.remediation) || void 0 === t ? void 0 : t.value) || [];
      (0, _forEach.default)(r).call(r, function (t) {
        return function e(t, r) {
          var _context72;

          (0, _forEach.default)(_context72 = (0, _keys.default)(r)).call(_context72, function (n) {
            var _context73;

            if ("relatesTo" === n) {
              var i = (0, _isArray.default)(r[n]) ? r[n][0] : r[n];

              if ("string" == typeof i) {
                var o = m.a.query(t, i)[0];
                if (o) return void (r[n] = o);
              }
            }

            (0, _isArray.default)(r[n]) && (0, _forEach.default)(_context73 = r[n]).call(_context73, function (r) {
              return e(t, r);
            });
          });
        }(e, t);
      });

      var n = (0, _map.default)(r).call(r, k),
          i = function (e) {
        var _context74, _context75;

        var t = {},
            r = {};
        return (0, _forEach.default)(_context74 = (0, _filter.default)(_context75 = (0, _keys.default)(e)).call(_context75, function (e) {
          return !w[e];
        })).call(_context74, function (n) {
          if ("object" === x(e[n]) && !!e[n]) {
            if (e[n].rel) t[e[n].name] = d(e[n]);else {
              var _context76;

              var i = e[n],
                  o = i.value,
                  a = i.type,
                  s = E(i, ["value", "type"]);
              r[n] = b({
                type: a
              }, s), "object" === a ? (r[n].value = {}, (0, _forEach.default)(_context76 = (0, _entries.default)(o)).call(_context76, function (e) {
                var _context77;

                var i = v(e, 2),
                    o = i[0],
                    a = i[1];
                a.rel ? t[(0, _concat.default)(_context77 = "".concat(n, "-")).call(_context77, o.name || o)] = d(a) : r[n].value[o] = a;
              })) : r[n].value = o;
            }
          } else r[n] = e[n];
        }), {
          context: r,
          actions: t
        };
      }(e);

      return {
        remediations: n,
        context: i.context,
        actions: i.actions
      };
    };

    function _(e, t, r, n, i, o, a) {
      try {
        var s = e[o](a),
            c = s.value;
      } catch (e) {
        return void r(e);
      }

      s.done ? t(c) : _promise.default.resolve(c).then(n, i);
    }

    function I(e) {
      return function (e) {
        if ((0, _isArray.default)(e)) {
          for (var t = 0, r = new Array(e.length); t < e.length; t++) {
            r[t] = e[t];
          }

          return r;
        }
      }(e) || function (e) {
        if ((0, _isIterable2.default)(Object(e)) || "[object Arguments]" === Object.prototype.toString.call(e)) return (0, _from.default)(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    var P = function P(e) {
      var t = e,
          r = O(e),
          n = r.remediations,
          i = r.context,
          o = r.actions,
          a = I(n);
      return {
        proceed: function () {
          var e,
              t = (e = _regenerator.default.mark(function e(t) {
            var r,
                i,
                o = arguments;
            return _regenerator.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (r = o.length > 1 && void 0 !== o[1] ? o[1] : {}, i = (0, _find.default)(n).call(n, function (e) {
                      return e.name === t;
                    })) {
                      e.next = 4;
                      break;
                    }

                    return e.abrupt("return", _promise.default.reject("Unknown remediation choice: [".concat(t, "]")));

                  case 4:
                    return e.abrupt("return", i.action(r));

                  case 5:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }), function () {
            var t = this,
                r = arguments;
            return new _promise.default(function (n, i) {
              var o = e.apply(t, r);

              function a(e) {
                _(o, n, i, a, s, "next", e);
              }

              function s(e) {
                _(o, n, i, a, s, "throw", e);
              }

              a(void 0);
            });
          });
          return function (e) {
            return t.apply(this, arguments);
          };
        }(),
        neededToProceed: a,
        actions: o,
        context: i,
        rawIdxState: t
      };
    },
        A = {
      makeIdxState: P
    },
        T = function T(e) {
      switch (e) {
        case "1.0.0":
          return A;

        case void 0:
        case null:
          throw new Error("Api version is required");

        default:
          throw new Error("Unknown api version: ".concat(e, ".  Use an exact semver version."));
      }
    };

    function C(e, t, r, n, i, o, a) {
      try {
        var s = e[o](a),
            c = s.value;
      } catch (e) {
        return void r(e);
      }

      s.done ? t(c) : _promise.default.resolve(c).then(n, i);
    }

    var N = function () {
      var e,
          t = (e = _regenerator.default.mark(function e(t) {
        var r, n, i, o, s, c, u;
        return _regenerator.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r = t.domain, n = t.stateHandle, i = t.version, n) {
                  e.next = 3;
                  break;
                }

                return e.abrupt("return", _promise.default.reject({
                  error: "stateHandle is required"
                }));

              case 3:
                if (r) {
                  e.next = 5;
                  break;
                }

                return e.abrupt("return", _promise.default.reject({
                  error: "domain is required"
                }));

              case 5:
                if (i) {
                  e.next = 7;
                  break;
                }

                return e.abrupt("return", _promise.default.reject({
                  error: "version is required"
                }));

              case 7:
                return e.prev = 7, o = T(i), s = o.makeIdxState, e.next = 11, a({
                  domain: r,
                  stateHandle: n,
                  version: i
                }).catch(function (e) {
                  return _promise.default.reject({
                    error: "introspect call failed",
                    details: e
                  });
                });

              case 11:
                return c = e.sent, u = s(c), e.abrupt("return", u);

              case 16:
                return e.prev = 16, e.t0 = e.catch(7), e.abrupt("return", _promise.default.reject({
                  error: e.t0
                }));

              case 19:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[7, 16]]);
      }), function () {
        var t = this,
            r = arguments;
        return new _promise.default(function (n, i) {
          var o = e.apply(t, r);

          function a(e) {
            C(o, n, i, a, s, "next", e);
          }

          function s(e) {
            C(o, n, i, a, s, "throw", e);
          }

          a(void 0);
        });
      });
      return function (e) {
        return t.apply(this, arguments);
      };
    }();

    t.default = {
      start: N,
      LATEST_SUPPORTED_IDX_API_VERSION: "1.0.0"
    };
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(315)(module)))

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(951);

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(341);

module.exports = parent;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(953);

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(954);

module.exports = parent;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
__webpack_require__(955);
var path = __webpack_require__(15);

module.exports = path.Object.fromEntries;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var iterate = __webpack_require__(91);
var createProperty = __webpack_require__(121);

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, undefined, true);
    return obj;
  }
});


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(957);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(958);

module.exports = parent;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(959);
var path = __webpack_require__(15);

var Object = path.Object;

var defineProperties = module.exports = function defineProperties(T, D) {
  return Object.defineProperties(T, D);
};

if (Object.defineProperties.sham) defineProperties.sham = true;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(39);
var defineProperties = __webpack_require__(291);

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(961);

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(962);

module.exports = parent;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(963);
var path = __webpack_require__(15);

module.exports = path.Object.getOwnPropertyDescriptors;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(39);
var ownKeys = __webpack_require__(964);
var toIndexedObject = __webpack_require__(59);
var getOwnPropertyDescriptorModule = __webpack_require__(104);
var createProperty = __webpack_require__(121);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(72);
var getOwnPropertyNamesModule = __webpack_require__(230);
var getOwnPropertySymbolsModule = __webpack_require__(231);
var anObject = __webpack_require__(43);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(966);

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(967);

module.exports = parent;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(305);
var path = __webpack_require__(15);

module.exports = path.Object.getOwnPropertySymbols;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(969);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(368);

module.exports = parent;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(971);

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(972);

module.exports = parent;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var fill = __webpack_require__(973);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.fill;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.fill) ? fill : own;
};


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(974);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').fill;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var fill = __webpack_require__(975);
var addToUnscopables = __webpack_require__(122);

// `Array.prototype.fill` method
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(52);
var toAbsoluteIndex = __webpack_require__(163);
var toLength = __webpack_require__(47);

// `Array.prototype.fill` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(977);

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(978);

module.exports = parent;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(979);
var path = __webpack_require__(15);

module.exports = path.Number.isFinite;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var numberIsFinite = __webpack_require__(980);

// `Number.isFinite` method
// https://tc39.github.io/ecma262/#sec-number.isfinite
$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);

var globalIsFinite = global.isFinite;

// `Number.isFinite` method
// https://tc39.github.io/ecma262/#sec-number.isfinite
module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(982);

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(983);

module.exports = parent;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(984);
var path = __webpack_require__(15);

module.exports = path.Object.getPrototypeOf;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var fails = __webpack_require__(20);
var toObject = __webpack_require__(52);
var nativeGetPrototypeOf = __webpack_require__(168);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(290);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(986);

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79);
var entries = __webpack_require__(987);
var classof = __webpack_require__(81);
var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.entries;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.entries)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables.hasOwnProperty(classof(it)) ? entries : own;
};


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(988);

module.exports = parent;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
var entryVirtual = __webpack_require__(19);

module.exports = entryVirtual('Array').entries;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(990);

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(991);

module.exports = parent;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(992);
var path = __webpack_require__(15);

module.exports = path.URLSearchParams;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(123);
var $ = __webpack_require__(5);
var getBuiltIn = __webpack_require__(72);
var USE_NATIVE_URL = __webpack_require__(993);
var redefine = __webpack_require__(124);
var redefineAll = __webpack_require__(178);
var setToStringTag = __webpack_require__(89);
var createIteratorConstructor = __webpack_require__(288);
var InternalStateModule = __webpack_require__(80);
var anInstance = __webpack_require__(179);
var hasOwn = __webpack_require__(46);
var bind = __webpack_require__(88);
var classof = __webpack_require__(81);
var anObject = __webpack_require__(43);
var isObject = __webpack_require__(31);
var create = __webpack_require__(135);
var createPropertyDescriptor = __webpack_require__(105);
var getIterator = __webpack_require__(338);
var getIteratorMethod = __webpack_require__(180);
var wellKnownSymbol = __webpack_require__(23);

var $fetch = getBuiltIn('fetch');
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.appent` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!USE_NATIVE_URL && typeof $fetch == 'function' && typeof Headers == 'function') {
  $({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject(init)) {
          body = init.body;
          if (classof(body) === URL_SEARCH_PARAMS) {
            headers = init.headers ? new Headers(init.headers) : new Headers();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = create(init, {
              body: createPropertyDescriptor(0, String(body)),
              headers: createPropertyDescriptor(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch.apply(this, args);
    }
  });
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(20);
var wellKnownSymbol = __webpack_require__(23);
var IS_PURE = __webpack_require__(63);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(995);

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(996);

module.exports = parent;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(997);
var path = __webpack_require__(15);

var Object = path.Object;

module.exports = function getOwnPropertyNames(it) {
  return Object.getOwnPropertyNames(it);
};


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var fails = __webpack_require__(20);
var nativeGetOwnPropertyNames = __webpack_require__(306).f;

var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: nativeGetOwnPropertyNames
});


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(999);

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1000);

module.exports = parent;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1001);
var path = __webpack_require__(15);

var Object = path.Object;

module.exports = function create(P, D) {
  return Object.create(P, D);
};


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(39);
var create = __webpack_require__(135);

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1003);

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1004);

module.exports = parent;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(307);
__webpack_require__(174);
__webpack_require__(308);
__webpack_require__(309);
var WrappedWellKnownSymbolModule = __webpack_require__(173);

module.exports = WrappedWellKnownSymbolModule.f('toStringTag');


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// okta-sign-in.min.js